export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>
}
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never }
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  Any: { input: any; output: any }
  DateTime: { input: any; output: any }
  UUID: { input: any; output: any }
}

export type AdynamicTitleAndContant = IAdynamicTitleAndContant & {
  __typename?: "AdynamicTitleAndContant"
  /** תוכן */
  content?: Maybe<BasicRichText>
  /** כותרת */
  title?: Maybe<BasicPropertyValue>
}

export type AnchorMenu = IAnchorMenu & {
  __typename?: "AnchorMenu"
  /** רשימת קישורים לעוגן */
  anchorMenuItems?: Maybe<BasicBlockListModel>
}

export type AnchorMenuItems = IAnchorMenuItems & {
  __typename?: "AnchorMenuItems"
  /** ID לעוגן */
  anchorId?: Maybe<BasicPropertyValue>
  /** שם הקישור */
  itemText?: Maybe<BasicPropertyValue>
}

/** תבנית להקמת עמוד חדשות */
export type Article = IArticle &
  IPageInfoBlock & {
    __typename?: "Article"
    /** כותב הכתבה */
    articleAuthor?: Maybe<BasicPropertyValue>
    /** תוכן המאמר */
    articleContent?: Maybe<BasicBlockListModel>
    /** תאריך המאמר */
    articleDate?: Maybe<BasicDateTimePicker>
    /** תאור קשר של הכתבה */
    articleShortDescription?: Maybe<BasicPropertyValue>
    /** כותרת הכתבה */
    articleTitle?: Maybe<BasicPropertyValue>
    /** יש להגדיר כתובת מלאה כולל דומיין */
    canonicalUrl?: Maybe<BasicPropertyValue>
    jsonPdSchema?: Maybe<BasicPropertyValue>
    /** תגית מטא עבור תיאור העמוד (SEO) */
    metaDescription?: Maybe<BasicPropertyValue>
    /** תגית מטא עבור כותרת העמוד (SEO) */
    metaTitle?: Maybe<BasicPropertyValue>
    /** תמונה שתופיע בשיתוף העמוד */
    ogImageSHARE?: Maybe<MintMediaPicker>
    /** לצורך מיפוי כתובות אתר ישנות לעמוד זה. נא לציין כתובת יחסית ללא דומיין כותת סלאש ראשון בהתחלה */
    oldUrls?: Maybe<BasicMultiUrlPicker>
    robotsTxt?: Maybe<BasicPropertyValue>
    /**
     * תמונה מוקטנת - JPG/PNG
     * 320X144
     */
    thumbnailImage?: Maybe<MintMediaPicker>
    /** שם העמוד גם עבור Breadcrumbs */
    titleBreadcrumbs?: Maybe<BasicPropertyValue>
  }

export type ArticlesCategory = IArticlesCategory & {
  __typename?: "ArticlesCategory"
  /** שם הקטגוריה */
  articlesCategoryName?: Maybe<BasicPropertyValue>
}

/** לובי כתבות */
export type ArticlesLobby = IArticlesLobby &
  IPageInfoBlock & {
    __typename?: "ArticlesLobby"
    /** יש להגדיר כתובת מלאה כולל דומיין */
    canonicalUrl?: Maybe<BasicPropertyValue>
    jsonPdSchema?: Maybe<BasicPropertyValue>
    /** תגית מטא עבור תיאור העמוד (SEO) */
    metaDescription?: Maybe<BasicPropertyValue>
    /** תגית מטא עבור כותרת העמוד (SEO) */
    metaTitle?: Maybe<BasicPropertyValue>
    /** תמונה שתופיע בשיתוף העמוד */
    ogImageSHARE?: Maybe<MintMediaPicker>
    /** לצורך מיפוי כתובות אתר ישנות לעמוד זה. נא לציין כתובת יחסית ללא דומיין כותת סלאש ראשון בהתחלה */
    oldUrls?: Maybe<BasicMultiUrlPicker>
    /** כותרת ראשית */
    pageMainTitle?: Maybe<BasicPropertyValue>
    robotsTxt?: Maybe<BasicPropertyValue>
    /** שם העמוד גם עבור Breadcrumbs */
    titleBreadcrumbs?: Maybe<BasicPropertyValue>
  }

export type BannerModule = IBannerModule & {
  __typename?: "BannerModule"
  /** צבע רקע - לבן */
  background?: Maybe<BasicPropertyValue>
  /** כפתור */
  button?: Maybe<BasicMultiUrlPicker>
  /**
   * תמונה לדסקטופ PNG\JPG
   * with:700; height:375
   */
  desktopImage?: Maybe<MintMediaPicker>
  /** הסתר את הבאנר */
  hideBanner?: Maybe<BasicPropertyValue>
  /** רשימת שירותים */
  itemsList?: Maybe<BasicBlockListModel>
  /**
   * תמונה למובייל PNG\JPG
   * with:360px;
   * height:179px;
   */
  mobileImage?: Maybe<MintMediaPicker>
  /** תת כותרת */
  subtitle?: Maybe<BasicRichText>
  /** כותרת */
  title?: Maybe<BasicRichText>
}

export type BasicBannerModule = IBasicBannerModule & {
  __typename?: "BasicBannerModule"
  /** צבע רקע - לבן */
  background?: Maybe<BasicPropertyValue>
  /** כפתור */
  button?: Maybe<BasicMultiUrlPicker>
  /**
   * תמונה לדסקטופ PNG\JPG
   * with:700; height:375
   */
  desktopImage?: Maybe<MintMediaPicker>
  /**
   * תמונה למובייל PNG\JPG
   * with:360px;
   * height:179px;
   */
  mobileImage?: Maybe<MintMediaPicker>
  /** תת כותרת */
  subtitle?: Maybe<BasicRichText>
  /** כותרת */
  title?: Maybe<BasicRichText>
}

/** Represents a block grid area. */
export type BasicBlockGridArea = {
  __typename?: "BasicBlockGridArea"
  /** Gets the alias block grid area. */
  alias?: Maybe<Scalars["String"]["output"]>
  /** Gets the blocks of the block grid area. */
  blocks?: Maybe<Array<BasicBlockGridItem>>
  /** Gets the column dimensions of the block. */
  columnSpan: Scalars["Int"]["output"]
  /** Gets the row dimensions of the block. */
  rowSpan: Scalars["Int"]["output"]
}

/** Represents a block grid item. */
export type BasicBlockGridItem = {
  __typename?: "BasicBlockGridItem"
  /** Gets the areas of the block grid item. */
  areas: Array<Maybe<BasicBlockGridArea>>
  /** Gets the column dimensions of the block. */
  columnSpan: Scalars["Int"]["output"]
  /** Gets the alias of the content block grid item. */
  contentAlias?: Maybe<Scalars["String"]["output"]>
  /** Gets the content properties of the block grid item. */
  contentProperties: Array<Maybe<BasicProperty>>
  /** Gets the row dimensions of the block. */
  rowSpan: Scalars["Int"]["output"]
  /** Gets the alias of the settings block grid item. */
  settingsAlias?: Maybe<Scalars["String"]["output"]>
  /** Gets the setting properties of the block grid item. */
  settingsProperties: Array<Maybe<BasicProperty>>
}

/** Represents a block list model. */
export type BasicBlockGridModel = PropertyValue & {
  __typename?: "BasicBlockGridModel"
  /** Gets the blocks of a block grid model. */
  blocks?: Maybe<Array<BasicBlockGridItem>>
  /** Gets the number of columns defined for the grid. */
  gridColumns?: Maybe<Scalars["Int"]["output"]>
  model: Scalars["String"]["output"]
}

/** Represents a block list item. */
export type BasicBlockListItem = {
  __typename?: "BasicBlockListItem"
  /** Gets the alias of the content block list item. */
  contentAlias?: Maybe<Scalars["String"]["output"]>
  /** Gets the content properties of the block list item. */
  contentProperties: Array<Maybe<BasicProperty>>
  /** Gets the alias of the settings block list item. */
  settingsAlias?: Maybe<Scalars["String"]["output"]>
  /** Gets the setting properties of the block list item. */
  settingsProperties: Array<Maybe<BasicProperty>>
}

/** Represents a block list model. */
export type BasicBlockListModel = PropertyValue & {
  __typename?: "BasicBlockListModel"
  /** Gets the blocks of a block list model. */
  blocks?: Maybe<Array<BasicBlockListItem>>
  model: Scalars["String"]["output"]
}

/** Represents a content item. */
export type BasicContent = {
  __typename?: "BasicContent"
  /** Gets the absolute url of the content item. */
  absoluteUrl?: Maybe<Scalars["String"]["output"]>
  /** Gets the children of the content item that are available for the current culture. */
  children?: Maybe<Array<Maybe<BasicContent>>>
  /** Gets all the children of the content item, regardless of whether they are available for the current culture. */
  childrenForAllCultures?: Maybe<Array<Maybe<BasicContent>>>
  /** Gets the content type. */
  contentType?: Maybe<BasicContentType>
  /** Gets the date that the content was created. */
  createDate?: Maybe<Scalars["DateTime"]["output"]>
  /** Gets the identifier of the user who created the content item. */
  creatorId?: Maybe<Scalars["Int"]["output"]>
  /** Gets available culture infos. */
  cultures?: Maybe<Array<KeyValuePairOfStringAndPublishedCultureInfo>>
  /** Gets the unique identifier of the content item. */
  id?: Maybe<Scalars["Int"]["output"]>
  /** Gets the type of the content item (document, media...). */
  itemType?: Maybe<PublishedItemType>
  /** Gets the unique key of the element. */
  key?: Maybe<Scalars["UUID"]["output"]>
  /** Gets the tree level of the content item. */
  level?: Maybe<Scalars["Int"]["output"]>
  /** Gets the name of the content item for the current culture. */
  name?: Maybe<Scalars["String"]["output"]>
  /** Gets the named properties of the element using the content types in Umbraco. */
  namedProperties: INamedContentProperties
  /** Gets the parent of the content item. */
  parent?: Maybe<BasicContent>
  /** Gets the tree path of the content item. */
  path?: Maybe<Scalars["String"]["output"]>
  /** Gets the properties of the element. */
  properties?: Maybe<Array<Maybe<BasicProperty>>>
  /** Gets the redirect information. */
  redirect?: Maybe<BasicContentRedirect>
  /** Gets the sort order of the content item. */
  sortOrder?: Maybe<Scalars["Int"]["output"]>
  /** Gets the identifier of the template to use to render the content item. */
  templateId?: Maybe<Scalars["Int"]["output"]>
  /** Gets the date the content item was last updated. */
  updateDate?: Maybe<Scalars["DateTime"]["output"]>
  /** Gets the url of the content item. */
  url?: Maybe<Scalars["String"]["output"]>
  /** Gets the URL segment of the content item for the current culture. */
  urlSegment?: Maybe<Scalars["String"]["output"]>
  /** Gets the identifier of the user who last updated the content item. */
  writerId?: Maybe<Scalars["Int"]["output"]>
}

/** Represents a content item. */
export type BasicContentChildrenArgs = {
  order?: InputMaybe<Array<BasicContentSortInput>>
  where?: InputMaybe<BasicContentFilterInput>
}

/** Represents a content item. */
export type BasicContentChildrenForAllCulturesArgs = {
  order?: InputMaybe<Array<BasicContentSortInput>>
  where?: InputMaybe<BasicContentFilterInput>
}

/** Represents a content item. */
export type BasicContentPropertiesArgs = {
  where?: InputMaybe<BasicPropertyFilterInput>
}

/** Represents a content item. */
export type BasicContentFilterInput = {
  /** Gets the absolute url of the content item. */
  absoluteUrl?: InputMaybe<StringOperationFilterInput>
  and?: InputMaybe<Array<BasicContentFilterInput>>
  /** Gets the children of the content item that are available for the current culture. */
  children?: InputMaybe<ListFilterInputTypeOfBasicContentFilterInput>
  /** Gets all the children of the content item, regardless of whether they are available for the current culture. */
  childrenForAllCultures?: InputMaybe<ListFilterInputTypeOfBasicContentFilterInput>
  /** Gets the content type. */
  contentType?: InputMaybe<BasicContentTypeFilterInput>
  /** Gets the date that the content was created. */
  createDate?: InputMaybe<DateTimeOperationFilterInput>
  /** Gets the identifier of the user who created the content item. */
  creatorId?: InputMaybe<IntOperationFilterInput>
  /** Gets available culture infos. */
  cultures?: InputMaybe<ListFilterInputTypeOfKeyValuePairOfStringAndPublishedCultureInfoFilterInput>
  /** Gets the unique identifier of the content item. */
  id?: InputMaybe<IntOperationFilterInput>
  /** Gets the type of the content item (document, media...). */
  itemType?: InputMaybe<NullableOfPublishedItemTypeOperationFilterInput>
  /** Gets the unique key of the element. */
  key?: InputMaybe<UuidOperationFilterInput>
  /** Gets the tree level of the content item. */
  level?: InputMaybe<IntOperationFilterInput>
  /** Gets the name of the content item for the current culture. */
  name?: InputMaybe<StringOperationFilterInput>
  or?: InputMaybe<Array<BasicContentFilterInput>>
  /** Gets the parent of the content item. */
  parent?: InputMaybe<BasicContentFilterInput>
  /** Gets the tree path of the content item. */
  path?: InputMaybe<StringOperationFilterInput>
  /** Gets the properties of the element. */
  properties?: InputMaybe<ListFilterInputTypeOfBasicPropertyFilterInput>
  /** Gets the redirect information. */
  redirect?: InputMaybe<BasicContentRedirectFilterInput>
  /** Gets the sort order of the content item. */
  sortOrder?: InputMaybe<IntOperationFilterInput>
  /** Gets the identifier of the template to use to render the content item. */
  templateId?: InputMaybe<IntOperationFilterInput>
  /** Gets the date the content item was last updated. */
  updateDate?: InputMaybe<DateTimeOperationFilterInput>
  /** Gets the url of the content item. */
  url?: InputMaybe<StringOperationFilterInput>
  /** Gets the URL segment of the content item for the current culture. */
  urlSegment?: InputMaybe<StringOperationFilterInput>
  /** Gets the identifier of the user who last updated the content item. */
  writerId?: InputMaybe<IntOperationFilterInput>
}

/** Represents a content picker value. */
export type BasicContentPicker = PropertyValue & {
  __typename?: "BasicContentPicker"
  /** Gets the list of content. */
  contentList: Array<BasicContentPickerItem>
  model: Scalars["String"]["output"]
}

/** Represents a content picker item. */
export type BasicContentPickerItem = {
  __typename?: "BasicContentPickerItem"
  /** Gets the absolute url of a content item. */
  absoluteUrl: Scalars["String"]["output"]
  /** Gets the id of a content item. */
  id: Scalars["Int"]["output"]
  /** Gets the key of a content item. */
  key: Scalars["UUID"]["output"]
  /** Gets the name of a content item. */
  name?: Maybe<Scalars["String"]["output"]>
  /** Gets the url of a content item. */
  url: Scalars["String"]["output"]
  /** Gets the url segment of the content item. */
  urlSegment?: Maybe<Scalars["String"]["output"]>
}

/** Represents a content redirect */
export type BasicContentRedirect = {
  __typename?: "BasicContentRedirect"
  /** Is the redirect permanent */
  isPermanent: Scalars["Boolean"]["output"]
  /** The url to redirect to */
  redirectUrl: Scalars["String"]["output"]
}

/** Represents a content redirect */
export type BasicContentRedirectFilterInput = {
  and?: InputMaybe<Array<BasicContentRedirectFilterInput>>
  /** Is the redirect permanent */
  isPermanent?: InputMaybe<BooleanOperationFilterInput>
  or?: InputMaybe<Array<BasicContentRedirectFilterInput>>
  /** The url to redirect to */
  redirectUrl?: InputMaybe<StringOperationFilterInput>
}

/** Represents a content redirect */
export type BasicContentRedirectSortInput = {
  /** Is the redirect permanent */
  isPermanent?: InputMaybe<SortEnumType>
  /** The url to redirect to */
  redirectUrl?: InputMaybe<SortEnumType>
}

/** Represents a content item. */
export type BasicContentSortInput = {
  /** Gets the absolute url of the content item. */
  absoluteUrl?: InputMaybe<SortEnumType>
  /** Gets the content type. */
  contentType?: InputMaybe<BasicContentTypeSortInput>
  /** Gets the date that the content was created. */
  createDate?: InputMaybe<SortEnumType>
  /** Gets the identifier of the user who created the content item. */
  creatorId?: InputMaybe<SortEnumType>
  /** Gets the unique identifier of the content item. */
  id?: InputMaybe<SortEnumType>
  /** Gets the type of the content item (document, media...). */
  itemType?: InputMaybe<SortEnumType>
  /** Gets the unique key of the element. */
  key?: InputMaybe<SortEnumType>
  /** Gets the tree level of the content item. */
  level?: InputMaybe<SortEnumType>
  /** Gets the name of the content item for the current culture. */
  name?: InputMaybe<SortEnumType>
  /** Gets the parent of the content item. */
  parent?: InputMaybe<BasicContentSortInput>
  /** Gets the tree path of the content item. */
  path?: InputMaybe<SortEnumType>
  /** Gets the redirect information. */
  redirect?: InputMaybe<BasicContentRedirectSortInput>
  /** Gets the sort order of the content item. */
  sortOrder?: InputMaybe<SortEnumType>
  /** Gets the identifier of the template to use to render the content item. */
  templateId?: InputMaybe<SortEnumType>
  /** Gets the date the content item was last updated. */
  updateDate?: InputMaybe<SortEnumType>
  /** Gets the url of the content item. */
  url?: InputMaybe<SortEnumType>
  /** Gets the URL segment of the content item for the current culture. */
  urlSegment?: InputMaybe<SortEnumType>
  /** Gets the identifier of the user who last updated the content item. */
  writerId?: InputMaybe<SortEnumType>
}

/** Represents a content type. */
export type BasicContentType = {
  __typename?: "BasicContentType"
  /** Gets the content type alias. */
  alias?: Maybe<Scalars["String"]["output"]>
  /** Gets the aliases of the content types participating in the composition. */
  compositionAliases?: Maybe<Array<Scalars["String"]["output"]>>
  /** Gets the content type identifier. */
  id: Scalars["Int"]["output"]
  /** Gets a value indicating whether this content type is for an element. */
  isElement: Scalars["Boolean"]["output"]
  /** Gets the content item type. */
  itemType: PublishedItemType
  /** Gets the unique key for the content type. */
  key: Scalars["UUID"]["output"]
  /** Gets the content variations of the content type. */
  variations: ContentVariation
}

/** Represents a content type. */
export type BasicContentTypeFilterInput = {
  /** Gets the content type alias. */
  alias?: InputMaybe<StringOperationFilterInput>
  and?: InputMaybe<Array<BasicContentTypeFilterInput>>
  /** Gets the aliases of the content types participating in the composition. */
  compositionAliases?: InputMaybe<ListStringOperationFilterInput>
  /** Gets the content type identifier. */
  id?: InputMaybe<IntOperationFilterInput>
  /** Gets a value indicating whether this content type is for an element. */
  isElement?: InputMaybe<BooleanOperationFilterInput>
  /** Gets the content item type. */
  itemType?: InputMaybe<PublishedItemTypeOperationFilterInput>
  /** Gets the unique key for the content type. */
  key?: InputMaybe<UuidOperationFilterInput>
  or?: InputMaybe<Array<BasicContentTypeFilterInput>>
  /** Gets the content variations of the content type. */
  variations?: InputMaybe<ContentVariationOperationFilterInput>
}

/** Represents a content type. */
export type BasicContentTypeSortInput = {
  /** Gets the content type alias. */
  alias?: InputMaybe<SortEnumType>
  /** Gets the content type identifier. */
  id?: InputMaybe<SortEnumType>
  /** Gets a value indicating whether this content type is for an element. */
  isElement?: InputMaybe<SortEnumType>
  /** Gets the content item type. */
  itemType?: InputMaybe<SortEnumType>
  /** Gets the unique key for the content type. */
  key?: InputMaybe<SortEnumType>
  /** Gets the content variations of the content type. */
  variations?: InputMaybe<SortEnumType>
}

/** Represents a date time property value. */
export type BasicDateTimePicker = PropertyValue & {
  __typename?: "BasicDateTimePicker"
  model: Scalars["String"]["output"]
  /** Gets the value of the property. */
  value?: Maybe<Scalars["DateTime"]["output"]>
}

/** Represents a date time property value. */
export type BasicLabel = PropertyValue & {
  __typename?: "BasicLabel"
  model: Scalars["String"]["output"]
  /** Gets the value of the property. */
  value?: Maybe<Scalars["Any"]["output"]>
}

/** Represents a media picker item. */
export type BasicMediaPicker = PropertyValue & {
  __typename?: "BasicMediaPicker"
  /** Gets the media items of a picker. */
  mediaItems: Array<BasicMediaPickerItem>
  model: Scalars["String"]["output"]
}

/** Represents a media item. */
export type BasicMediaPickerItem = {
  __typename?: "BasicMediaPickerItem"
  /** Gets the id of a media item. */
  id: Scalars["Int"]["output"]
  /** Gets the absolute url of a media item. */
  url: Scalars["String"]["output"]
}

/** Represents a member picker. */
export type BasicMemberPicker = PropertyValue & {
  __typename?: "BasicMemberPicker"
  /** Gets the members. */
  members: Array<BasicMemberPickerItem>
  model: Scalars["String"]["output"]
}

/** Represents a member item. */
export type BasicMemberPickerItem = {
  __typename?: "BasicMemberPickerItem"
  /** Gets the id of the member. */
  id?: Maybe<Scalars["Int"]["output"]>
  /** Gets the name of a member. */
  name?: Maybe<Scalars["String"]["output"]>
  /** Gets the properties of a member. */
  properties: Array<Maybe<BasicProperty>>
}

/** Represents a multi url picker. */
export type BasicMultiUrlPicker = PropertyValue & {
  __typename?: "BasicMultiUrlPicker"
  /** Gets the links. */
  links: Array<BasicMultiUrlPickerItem>
  model: Scalars["String"]["output"]
}

/** Represents a link item. */
export type BasicMultiUrlPickerItem = {
  __typename?: "BasicMultiUrlPickerItem"
  /** Gets the name of the link. */
  name?: Maybe<Scalars["String"]["output"]>
  /** Gets the target of the link. */
  target?: Maybe<Scalars["String"]["output"]>
  /** Gets the type of the link. */
  type: LinkType
  /** Gets the url of a link. */
  url?: Maybe<Scalars["String"]["output"]>
}

/** Represents nested content. */
export type BasicNestedContent = PropertyValue & {
  __typename?: "BasicNestedContent"
  /** Gets the elements of a nested content. */
  elements?: Maybe<Array<BasicNestedContentElement>>
  model: Scalars["String"]["output"]
}

/** Represents nested content. */
export type BasicNestedContentElement = {
  __typename?: "BasicNestedContentElement"
  /** Gets the properties of the nested content. */
  properties: Array<Maybe<BasicProperty>>
}

/** Represents a property. */
export type BasicProperty = {
  __typename?: "BasicProperty"
  /** Gets the alias of a property. */
  alias?: Maybe<Scalars["String"]["output"]>
  /** Gets the editor alias of a property. */
  editorAlias?: Maybe<Scalars["String"]["output"]>
  /** Gets the value of a property. */
  value?: Maybe<PropertyValue>
}

/** Represents a property. */
export type BasicPropertyFilterInput = {
  /** Gets the alias of a property. */
  alias?: InputMaybe<StringOperationFilterInput>
  and?: InputMaybe<Array<BasicPropertyFilterInput>>
  /** Gets the editor alias of a property. */
  editorAlias?: InputMaybe<StringOperationFilterInput>
  or?: InputMaybe<Array<BasicPropertyFilterInput>>
  /** Gets the value of a property. */
  value?: InputMaybe<PropertyValueFilterInput>
}

/** Represents a basic property value. */
export type BasicPropertyValue = PropertyValue & {
  __typename?: "BasicPropertyValue"
  model: Scalars["String"]["output"]
  /** Gets the value of the property. */
  value?: Maybe<Scalars["Any"]["output"]>
}

/** Represents a rich text editor. */
export type BasicRichText = PropertyValue & {
  __typename?: "BasicRichText"
  model: Scalars["String"]["output"]
  /** Gets the original value of the rich text editor or markdown editor. */
  sourceValue?: Maybe<Scalars["String"]["output"]>
  /** Gets the HTML value of the rich text editor or markdown editor. */
  value?: Maybe<Scalars["String"]["output"]>
}

/** Represents an unsupported property value. */
export type BasicUnsupportedPropertyValue = PropertyValue & {
  __typename?: "BasicUnsupportedPropertyValue"
  /** Gets the message of the property. */
  message: Scalars["String"]["output"]
  model: Scalars["String"]["output"]
}

export type BooleanOperationFilterInput = {
  eq?: InputMaybe<Scalars["Boolean"]["input"]>
  neq?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type ButtonComponent = IButtonComponent & {
  __typename?: "ButtonComponent"
  /** כפתור */
  button?: Maybe<BasicMultiUrlPicker>
}

export type ContactUs = IContactUs & {
  __typename?: "ContactUs"
  /** בוקסות התקשרות - מיועד לעמוד צור קשר */
  contactBoxs?: Maybe<BasicBlockListModel>
  /** פרטי התקשרות */
  contactInfo?: Maybe<BasicBlockListModel>
  /** כותרת לטאב */
  tabTitle?: Maybe<BasicPropertyValue>
}

export type ContactUsBox = IContactUsBox & {
  __typename?: "ContactUsBox"
  /** קישורי התקשרות */
  boxItems?: Maybe<BasicBlockListModel>
  /** כותרת צור קשר */
  contactUsTitle?: Maybe<BasicPropertyValue>
}

export type ContactUsBoxItem = IContactUsBoxItem & {
  __typename?: "ContactUsBoxItem"
  /**
   * איקון- SVG/PNG
   * 56X56
   */
  icon?: Maybe<MintMediaPicker>
  /** קישור ליצירת קשר */
  linktocontact?: Maybe<BasicMultiUrlPicker>
}

export type ContactUsBoxWithText = IContactUsBoxWithText & {
  __typename?: "ContactUsBoxWithText"
  /** קישורי התקשרות */
  boxItems?: Maybe<BasicBlockListModel>
  contactInfoText?: Maybe<BasicRichText>
  /** כותרת צור קשר */
  contactUsTitle?: Maybe<BasicPropertyValue>
}

export type ContactUsDesktop = IContactUsDesktop & {
  __typename?: "ContactUsDesktop"
  /** רשימת רכיבי צור קשר */
  itemsList?: Maybe<BasicBlockListModel>
  /** כותרת */
  title?: Maybe<BasicPropertyValue>
}

export type ContactUsInfoItem = IContactUsInfoItem & {
  __typename?: "ContactUsInfoItem"
  /** כתובת */
  address?: Maybe<BasicPropertyValue>
  /**
   * איקון לצד כותרת כתובת - SVG/PNG
   * 20X20
   */
  addressIcon?: Maybe<MintMediaPicker>
  /** כותרת כתובת */
  addressTitle?: Maybe<BasicPropertyValue>
  /** העלאת מסמכים */
  documents?: Maybe<BasicMultiUrlPicker>
  /**
   * איקון לצד כותרת מסמכים - SVG/ PNG
   * 20X20
   */
  documentsIcon?: Maybe<MintMediaPicker>
  /** כותרת מסמכים */
  documentsTitle?: Maybe<BasicPropertyValue>
  /** כתובת מייל */
  emailAddress?: Maybe<BasicMultiUrlPicker>
  /**
   * איקון מייל - SVG/ PNG
   * 40X40
   */
  emailIcon?: Maybe<MintMediaPicker>
  /**
   * איקון לצד כותרת פקס - SVG/ PNG
   * 20X20
   */
  faxIcon?: Maybe<MintMediaPicker>
  /** מספר פקס */
  faxNumber?: Maybe<BasicPropertyValue>
  /** כותרת פקס */
  faxTitle?: Maybe<BasicPropertyValue>
  /**
   * תוכן חשוב לדעת-
   *  חובה להזין כותרת כדי שהתוכן של אזור חשוב לדעת יופיע
   */
  importantToKnowContent?: Maybe<BasicRichText>
  /** כותרת חשוב לדעת- חובה להזין כותרת כדי שהתוכן של אזור חשוב לדעת יופיע */
  importantToKnowTitle?: Maybe<BasicPropertyValue>
  /** כותרת */
  itemTitle?: Maybe<BasicPropertyValue>
  /** פירוט שעות פעילות */
  openingHoursContent?: Maybe<BasicBlockListModel>
  /**
   * איקון שעות פעילות - SVG/ PNG
   * 20X20
   */
  openingHoursIcon?: Maybe<MintMediaPicker>
  /** כותרתר שעות פעילות */
  openingHoursTitle?: Maybe<BasicPropertyValue>
  /**
   * איקון טלפון- PNG/ SVG
   * 40X40
   */
  phoneIcon?: Maybe<MintMediaPicker>
  /** טלפון */
  phoneNumber?: Maybe<BasicMultiUrlPicker>
  /**
   * כפתור לטופס-
   * יש לבחור את העמוד ולהוסיף # + מספר הרכיב של אזור הפניה.
   * מיועד לעמוד צור קשר.
   */
  sendTo?: Maybe<BasicMultiUrlPicker>
}

export type ContactUsItem = IContactUsItem & {
  __typename?: "ContactUsItem"
  /**
   * אייקון PNG\SVG
   * width: 40;
   * height: 40;
   */
  icon?: Maybe<MintMediaPicker>
  /** קישור */
  link?: Maybe<BasicMultiUrlPicker>
}

export type ContactUsMobile = IContactUsMobile & {
  __typename?: "ContactUsMobile"
  /**
   * תמונה PNG\JPG
   * width: 88;
   * height: 88;
   */
  image?: Maybe<MintMediaPicker>
  /** רשימת רכיבי צור קשר */
  itemsList?: Maybe<BasicBlockListModel>
  /** תיאור */
  subtitle?: Maybe<BasicPropertyValue>
  /** כותרת */
  title?: Maybe<BasicPropertyValue>
}

/** A connection to a list of items. */
export type ContentAtRootConnection = {
  __typename?: "ContentAtRootConnection"
  /** A list of edges. */
  edges?: Maybe<Array<ContentAtRootEdge>>
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<BasicContent>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type ContentAtRootEdge = {
  __typename?: "ContentAtRootEdge"
  /** A cursor for use in pagination. */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge. */
  node?: Maybe<BasicContent>
}

/** A connection to a list of items. */
export type ContentByContentTypeConnection = {
  __typename?: "ContentByContentTypeConnection"
  /** A list of edges. */
  edges?: Maybe<Array<ContentByContentTypeEdge>>
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<BasicContent>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type ContentByContentTypeEdge = {
  __typename?: "ContentByContentTypeEdge"
  /** A cursor for use in pagination. */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge. */
  node?: Maybe<BasicContent>
}

/** A connection to a list of items. */
export type ContentByTagConnection = {
  __typename?: "ContentByTagConnection"
  /** A list of edges. */
  edges?: Maybe<Array<ContentByTagEdge>>
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<BasicContent>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type ContentByTagEdge = {
  __typename?: "ContentByTagEdge"
  /** A cursor for use in pagination. */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge. */
  node?: Maybe<BasicContent>
}

/** A connection to a list of items. */
export type ContentDescendantsByAbsoluteRouteConnection = {
  __typename?: "ContentDescendantsByAbsoluteRouteConnection"
  /** A list of edges. */
  edges?: Maybe<Array<ContentDescendantsByAbsoluteRouteEdge>>
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<BasicContent>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type ContentDescendantsByAbsoluteRouteEdge = {
  __typename?: "ContentDescendantsByAbsoluteRouteEdge"
  /** A cursor for use in pagination. */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge. */
  node?: Maybe<BasicContent>
}

/** A connection to a list of items. */
export type ContentDescendantsByContentTypeConnection = {
  __typename?: "ContentDescendantsByContentTypeConnection"
  /** A list of edges. */
  edges?: Maybe<Array<ContentDescendantsByContentTypeEdge>>
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<BasicContent>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type ContentDescendantsByContentTypeEdge = {
  __typename?: "ContentDescendantsByContentTypeEdge"
  /** A cursor for use in pagination. */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge. */
  node?: Maybe<BasicContent>
}

/** A connection to a list of items. */
export type ContentDescendantsByGuidConnection = {
  __typename?: "ContentDescendantsByGuidConnection"
  /** A list of edges. */
  edges?: Maybe<Array<ContentDescendantsByGuidEdge>>
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<BasicContent>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type ContentDescendantsByGuidEdge = {
  __typename?: "ContentDescendantsByGuidEdge"
  /** A cursor for use in pagination. */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge. */
  node?: Maybe<BasicContent>
}

/** A connection to a list of items. */
export type ContentDescendantsByIdConnection = {
  __typename?: "ContentDescendantsByIdConnection"
  /** A list of edges. */
  edges?: Maybe<Array<ContentDescendantsByIdEdge>>
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<BasicContent>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type ContentDescendantsByIdEdge = {
  __typename?: "ContentDescendantsByIdEdge"
  /** A cursor for use in pagination. */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge. */
  node?: Maybe<BasicContent>
}

/** פריט בתפריט עם אפשרות לבחור תוכן ספציפי באתר */
export type ContentMenuItem = IContentMenuItem & {
  __typename?: "ContentMenuItem"
  content?: Maybe<BasicContentPicker>
  title?: Maybe<BasicPropertyValue>
}

/** עמוד ליצירת תוכן כללי באופן חופשי */
export type ContentPage = IContentPage &
  IDynamicBlockList &
  IPageInfoBlock & {
    __typename?: "ContentPage"
    blocks?: Maybe<BasicBlockListModel>
    /** יש להגדיר כתובת מלאה כולל דומיין */
    canonicalUrl?: Maybe<BasicPropertyValue>
    jsonPdSchema?: Maybe<BasicPropertyValue>
    /** תגית מטא עבור תיאור העמוד (SEO) */
    metaDescription?: Maybe<BasicPropertyValue>
    /** תגית מטא עבור כותרת העמוד (SEO) */
    metaTitle?: Maybe<BasicPropertyValue>
    /** תמונה שתופיע בשיתוף העמוד */
    ogImageSHARE?: Maybe<MintMediaPicker>
    /** לצורך מיפוי כתובות אתר ישנות לעמוד זה. נא לציין כתובת יחסית ללא דומיין כותת סלאש ראשון בהתחלה */
    oldUrls?: Maybe<BasicMultiUrlPicker>
    robotsTxt?: Maybe<BasicPropertyValue>
    /** שם העמוד גם עבור Breadcrumbs */
    titleBreadcrumbs?: Maybe<BasicPropertyValue>
  }

export enum ContentVariation {
  Culture = "CULTURE",
  CultureAndSegment = "CULTURE_AND_SEGMENT",
  Nothing = "NOTHING",
  Segment = "SEGMENT",
}

export type ContentVariationOperationFilterInput = {
  eq?: InputMaybe<ContentVariation>
  in?: InputMaybe<Array<ContentVariation>>
  neq?: InputMaybe<ContentVariation>
  nin?: InputMaybe<Array<ContentVariation>>
}

/** פריט בתפריט שמבוסס על לינק חופשי לכל יעד */
export type CustomMenuItem = ICustomMenuItem & {
  __typename?: "CustomMenuItem"
  title?: Maybe<BasicPropertyValue>
  url?: Maybe<BasicPropertyValue>
}

export type DateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars["DateTime"]["input"]>
  gt?: InputMaybe<Scalars["DateTime"]["input"]>
  gte?: InputMaybe<Scalars["DateTime"]["input"]>
  in?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]["input"]>>>
  lt?: InputMaybe<Scalars["DateTime"]["input"]>
  lte?: InputMaybe<Scalars["DateTime"]["input"]>
  neq?: InputMaybe<Scalars["DateTime"]["input"]>
  ngt?: InputMaybe<Scalars["DateTime"]["input"]>
  ngte?: InputMaybe<Scalars["DateTime"]["input"]>
  nin?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]["input"]>>>
  nlt?: InputMaybe<Scalars["DateTime"]["input"]>
  nlte?: InputMaybe<Scalars["DateTime"]["input"]>
}

export type DynamicBlockList = IDynamicBlockList & {
  __typename?: "DynamicBlockList"
  blocks?: Maybe<BasicBlockListModel>
}

export type EmployeeRecommendations = IEmployeeRecommendations & {
  __typename?: "EmployeeRecommendations"
  /**
   * תמונה PNG\JPG
   * 1440*48
   */
  image?: Maybe<MintMediaPicker>
  /** רשימת עובדים */
  itemsList?: Maybe<BasicBlockListModel>
  /** כותרת */
  title?: Maybe<BasicPropertyValue>
}

export type EmployeeRecommendationsItem = IEmployeeRecommendationsItem & {
  __typename?: "EmployeeRecommendationsItem"
  /**
   * תמונה PNG\JPG
   * 84*84
   */
  image?: Maybe<MintMediaPicker>
  /**
   * אייקון ללינקדין PNG\SVG
   * 32*32
   */
  linkedinIcon?: Maybe<MintMediaPicker>
  /** קישור ללינקדין */
  linkedinLink?: Maybe<BasicMultiUrlPicker>
  /** תפקיד */
  role?: Maybe<BasicPropertyValue>
  /** טקסט */
  text?: Maybe<BasicPropertyValue>
  /** כותרת- שם */
  title?: Maybe<BasicPropertyValue>
}

/** Represents a content type that doesn't have any properties and therefore needs a placeholder */
export type EmptyINamedContentProperties = {
  __typename?: "EmptyINamedContentProperties"
  /** Placeholder field. Will never hold a value. */
  Empty_Field: Scalars["String"]["output"]
}

export type Faq = Ifaq & {
  __typename?: "FAQ"
  /** כפתור */
  button?: Maybe<BasicMultiUrlPicker>
  /** תאור */
  description?: Maybe<BasicRichText>
  /** שורת טקסט בתוך חיפוש */
  fAQSearchLine?: Maybe<BasicPropertyValue>
  /** רשימת שאלות ותשובות */
  itemsList?: Maybe<BasicBlockListModel>
  /** הצגת שורת חיפוש */
  showSearchBox?: Maybe<BasicPropertyValue>
  /** כותרת */
  title?: Maybe<BasicPropertyValue>
}

export type FaqItem = IfaqItem & {
  __typename?: "FAQItem"
  /** תשובה */
  answer?: Maybe<BasicRichText>
  /** כפתור - אופציונלי לעמוד זכאות להנחות */
  button?: Maybe<BasicMultiUrlPicker>
  /** שאלה */
  question?: Maybe<BasicPropertyValue>
}

export type FinePayment = IFinePayment & {
  __typename?: "FinePayment"
  /** שלבים */
  finePaymentSteps?: Maybe<BasicBlockListModel>
}

export type FinePaymentSteps = IFinePaymentSteps & {
  __typename?: "FinePaymentSteps"
  /** פרטי יצירת קשר לערעור */
  contactBlock?: Maybe<BasicBlockListModel>
  /**
   * איקון - SVG/PNG
   * 80X80
   */
  icon?: Maybe<MintMediaPicker>
  /** שם השלב */
  stepName?: Maybe<BasicPropertyValue>
  /** כותרת משנה */
  subTitle?: Maybe<BasicPropertyValue>
  /** כותרת השלב */
  title?: Maybe<BasicPropertyValue>
}

export type Footer = IFooter & {
  __typename?: "Footer"
  /** קישורים להורדת האפליקציה */
  appDownloadList?: Maybe<BasicBlockListModel>
  /** טקסט הורדת האפליקציה */
  appDownloadText?: Maybe<BasicPropertyValue>
  /** קישורים תחתונים- נגישות פרטיות וכו */
  bottomLinks?: Maybe<BasicBlockListModel>
  /**
   * לוגו- PNG/SVG
   * 64X64
   */
  logo?: Maybe<MintMediaPicker>
  /** תפריט פוטר */
  megaMenu?: Maybe<BasicBlockListModel>
  /** בלוק רשתות חברתיות */
  social?: Maybe<BasicBlockListModel>
  /** טקסט - זכויות יוצרים */
  text?: Maybe<BasicPropertyValue>
}

export type FooterCategories = IFooterCategories & {
  __typename?: "FooterCategories"
  /** קישורי הקטגוריה */
  categoriesLinks?: Maybe<BasicMultiUrlPicker>
  /** שם הקטגוריה */
  categoryName?: Maybe<BasicPropertyValue>
}

export type FreeContentPage = IFreeContentPage &
  IPageInfoBlock & {
    __typename?: "FreeContentPage"
    body?: Maybe<BasicRichText>
    /** יש להגדיר כתובת מלאה כולל דומיין */
    canonicalUrl?: Maybe<BasicPropertyValue>
    jsonPdSchema?: Maybe<BasicPropertyValue>
    /** תגית מטא עבור תיאור העמוד (SEO) */
    metaDescription?: Maybe<BasicPropertyValue>
    /** תגית מטא עבור כותרת העמוד (SEO) */
    metaTitle?: Maybe<BasicPropertyValue>
    /** תמונה שתופיע בשיתוף העמוד */
    ogImageSHARE?: Maybe<MintMediaPicker>
    /** לצורך מיפוי כתובות אתר ישנות לעמוד זה. נא לציין כתובת יחסית ללא דומיין כותת סלאש ראשון בהתחלה */
    oldUrls?: Maybe<BasicMultiUrlPicker>
    robotsTxt?: Maybe<BasicPropertyValue>
    /** שם העמוד גם עבור Breadcrumbs */
    titleBreadcrumbs?: Maybe<BasicPropertyValue>
  }

export type HeaderCategories = IHeaderCategories & {
  __typename?: "HeaderCategories"
  /** קישורי הקטגוריה */
  categoriesLinks?: Maybe<BasicBlockListModel>
  /** שם הקטגוריה */
  categoryName?: Maybe<BasicPropertyValue>
}

export type HeaderDesktop = IHeaderDesktop & {
  __typename?: "HeaderDesktop"
  /**
   * לוגו צור קשר
   * PNG/ SVG
   * width:40px
   * height:40px
   */
  contactLogo?: Maybe<MintMediaPicker>
  contactUs?: Maybe<BasicBlockListModel>
  /**
   * לוגו האתר -
   * PNG/ SVG
   * width:40px
   * height:40px
   */
  siteLogo?: Maybe<MintMediaPicker>
}

export type HeaderMobile = IHeaderMobile & {
  __typename?: "HeaderMobile"
  /**
   * לוגו צור קשר
   * PNG/ SVG
   * width:88px
   * height:88px
   */
  contactLogo?: Maybe<MintMediaPicker>
  contactUs?: Maybe<BasicBlockListModel>
  /**
   * לוגו האתר -
   * PNG/ SVG
   * width:40px
   * height:40px
   */
  siteLogo?: Maybe<MintMediaPicker>
}

export type HeroBanner = IHeroBanner & {
  __typename?: "HeroBanner"
  /**
   * תמונה לדסקטופ- JPG/ PNG
   * width:1440px; height: 300px
   */
  imageForDesktop?: Maybe<MintMediaPicker>
  /**
   * תמונה למובייל - png/JPG
   * with:360px;
   * height:166px;
   */
  imageForMobile?: Maybe<MintMediaPicker>
  /** כותרת העמוד */
  pageMainTitle?: Maybe<BasicPropertyValue>
}

export type HeroBannerHomePage = IHeroBannerHomePage & {
  __typename?: "HeroBannerHomePage"
  /** כפתור חיפוש */
  button?: Maybe<BasicMultiUrlPicker>
  /**
   * במידה ואין אנימציה- יש להזין תמונה או סרטון - JPG/ PNG/MP4
   * 1920X643
   */
  imageOrVideo?: Maybe<MintMediaPicker>
  /** תיאור חיפוש */
  searchDescription?: Maybe<BasicPropertyValue>
  /** כותרת חיפוש */
  searchTitle?: Maybe<BasicPropertyValue>
  /** כותרת הבאנר */
  title?: Maybe<BasicRichText>
}

export type HistoryItem = IHistoryItem & {
  __typename?: "HistoryItem"
  /**
   * תמונה מוקטנת לדף הבית - דסקטופ PNG\JPG
   * with:184px; height:173
   */
  desktopImage?: Maybe<MintMediaPicker>
  /**
   * תמונה לדסקטופ- JPG/ PNG
   * width:487px; height:260px;
   */
  imageForDesktop?: Maybe<MintMediaPicker>
  /**
   * תמונה למובייל- PNG/ JPG
   * width:304px; height:184px
   */
  imageForMobil?: Maybe<MintMediaPicker>
  /**
   * תמונה מוקטנת לדף הבית - מובייל
   * PNG\JPG
   * with:136px; height:135
   */
  mobileImage?: Maybe<MintMediaPicker>
  /** תאור */
  shortText?: Maybe<BasicPropertyValue>
  /** תאור קצר לדף הבית */
  subtitle?: Maybe<BasicPropertyValue>
  /** כותרת */
  title?: Maybe<BasicPropertyValue>
  /** שנה לעמוד הבית */
  yearForHomePage?: Maybe<BasicDateTimePicker>
  /** שנים */
  years?: Maybe<BasicPropertyValue>
}

/** תבנית להקמת דף בית */
export type HomePage = IHomePage &
  IPageInfoBlock & {
    __typename?: "HomePage"
    /** יש להגדיר כתובת מלאה כולל דומיין */
    canonicalUrl?: Maybe<BasicPropertyValue>
    jsonPdSchema?: Maybe<BasicPropertyValue>
    /** תגית מטא עבור תיאור העמוד (SEO) */
    metaDescription?: Maybe<BasicPropertyValue>
    /** תגית מטא עבור כותרת העמוד (SEO) */
    metaTitle?: Maybe<BasicPropertyValue>
    /** תמונה שתופיע בשיתוף העמוד */
    ogImageSHARE?: Maybe<MintMediaPicker>
    /** לצורך מיפוי כתובות אתר ישנות לעמוד זה. נא לציין כתובת יחסית ללא דומיין כותת סלאש ראשון בהתחלה */
    oldUrls?: Maybe<BasicMultiUrlPicker>
    robotsTxt?: Maybe<BasicPropertyValue>
    /** שם העמוד גם עבור Breadcrumbs */
    titleBreadcrumbs?: Maybe<BasicPropertyValue>
  }

export type IAdynamicTitleAndContant = {
  /** תוכן */
  content?: Maybe<BasicRichText>
  /** כותרת */
  title?: Maybe<BasicPropertyValue>
}

export type IAnchorMenu = {
  /** רשימת קישורים לעוגן */
  anchorMenuItems?: Maybe<BasicBlockListModel>
}

export type IAnchorMenuItems = {
  /** ID לעוגן */
  anchorId?: Maybe<BasicPropertyValue>
  /** שם הקישור */
  itemText?: Maybe<BasicPropertyValue>
}

/** תבנית להקמת עמוד חדשות */
export type IArticle = {
  /** כותב הכתבה */
  articleAuthor?: Maybe<BasicPropertyValue>
  /** תוכן המאמר */
  articleContent?: Maybe<BasicBlockListModel>
  /** תאריך המאמר */
  articleDate?: Maybe<BasicDateTimePicker>
  /** תאור קשר של הכתבה */
  articleShortDescription?: Maybe<BasicPropertyValue>
  /** כותרת הכתבה */
  articleTitle?: Maybe<BasicPropertyValue>
  /** יש להגדיר כתובת מלאה כולל דומיין */
  canonicalUrl?: Maybe<BasicPropertyValue>
  jsonPdSchema?: Maybe<BasicPropertyValue>
  /** תגית מטא עבור תיאור העמוד (SEO) */
  metaDescription?: Maybe<BasicPropertyValue>
  /** תגית מטא עבור כותרת העמוד (SEO) */
  metaTitle?: Maybe<BasicPropertyValue>
  /** תמונה שתופיע בשיתוף העמוד */
  ogImageSHARE?: Maybe<MintMediaPicker>
  /** לצורך מיפוי כתובות אתר ישנות לעמוד זה. נא לציין כתובת יחסית ללא דומיין כותת סלאש ראשון בהתחלה */
  oldUrls?: Maybe<BasicMultiUrlPicker>
  robotsTxt?: Maybe<BasicPropertyValue>
  /**
   * תמונה מוקטנת - JPG/PNG
   * 320X144
   */
  thumbnailImage?: Maybe<MintMediaPicker>
  /** שם העמוד גם עבור Breadcrumbs */
  titleBreadcrumbs?: Maybe<BasicPropertyValue>
}

export type IArticlesCategory = {
  /** שם הקטגוריה */
  articlesCategoryName?: Maybe<BasicPropertyValue>
}

/** לובי כתבות */
export type IArticlesLobby = {
  /** יש להגדיר כתובת מלאה כולל דומיין */
  canonicalUrl?: Maybe<BasicPropertyValue>
  jsonPdSchema?: Maybe<BasicPropertyValue>
  /** תגית מטא עבור תיאור העמוד (SEO) */
  metaDescription?: Maybe<BasicPropertyValue>
  /** תגית מטא עבור כותרת העמוד (SEO) */
  metaTitle?: Maybe<BasicPropertyValue>
  /** תמונה שתופיע בשיתוף העמוד */
  ogImageSHARE?: Maybe<MintMediaPicker>
  /** לצורך מיפוי כתובות אתר ישנות לעמוד זה. נא לציין כתובת יחסית ללא דומיין כותת סלאש ראשון בהתחלה */
  oldUrls?: Maybe<BasicMultiUrlPicker>
  /** כותרת ראשית */
  pageMainTitle?: Maybe<BasicPropertyValue>
  robotsTxt?: Maybe<BasicPropertyValue>
  /** שם העמוד גם עבור Breadcrumbs */
  titleBreadcrumbs?: Maybe<BasicPropertyValue>
}

export type IBannerModule = {
  /** צבע רקע - לבן */
  background?: Maybe<BasicPropertyValue>
  /** כפתור */
  button?: Maybe<BasicMultiUrlPicker>
  /**
   * תמונה לדסקטופ PNG\JPG
   * with:700; height:375
   */
  desktopImage?: Maybe<MintMediaPicker>
  /** הסתר את הבאנר */
  hideBanner?: Maybe<BasicPropertyValue>
  /** רשימת שירותים */
  itemsList?: Maybe<BasicBlockListModel>
  /**
   * תמונה למובייל PNG\JPG
   * with:360px;
   * height:179px;
   */
  mobileImage?: Maybe<MintMediaPicker>
  /** תת כותרת */
  subtitle?: Maybe<BasicRichText>
  /** כותרת */
  title?: Maybe<BasicRichText>
}

export type IBasicBannerModule = {
  /** צבע רקע - לבן */
  background?: Maybe<BasicPropertyValue>
  /** כפתור */
  button?: Maybe<BasicMultiUrlPicker>
  /**
   * תמונה לדסקטופ PNG\JPG
   * with:700; height:375
   */
  desktopImage?: Maybe<MintMediaPicker>
  /**
   * תמונה למובייל PNG\JPG
   * with:360px;
   * height:179px;
   */
  mobileImage?: Maybe<MintMediaPicker>
  /** תת כותרת */
  subtitle?: Maybe<BasicRichText>
  /** כותרת */
  title?: Maybe<BasicRichText>
}

export type IButtonComponent = {
  /** כפתור */
  button?: Maybe<BasicMultiUrlPicker>
}

export type IContactUs = {
  /** בוקסות התקשרות - מיועד לעמוד צור קשר */
  contactBoxs?: Maybe<BasicBlockListModel>
  /** פרטי התקשרות */
  contactInfo?: Maybe<BasicBlockListModel>
  /** כותרת לטאב */
  tabTitle?: Maybe<BasicPropertyValue>
}

export type IContactUsBox = {
  /** קישורי התקשרות */
  boxItems?: Maybe<BasicBlockListModel>
  /** כותרת צור קשר */
  contactUsTitle?: Maybe<BasicPropertyValue>
}

export type IContactUsBoxItem = {
  /**
   * איקון- SVG/PNG
   * 56X56
   */
  icon?: Maybe<MintMediaPicker>
  /** קישור ליצירת קשר */
  linktocontact?: Maybe<BasicMultiUrlPicker>
}

export type IContactUsBoxWithText = {
  /** קישורי התקשרות */
  boxItems?: Maybe<BasicBlockListModel>
  contactInfoText?: Maybe<BasicRichText>
  /** כותרת צור קשר */
  contactUsTitle?: Maybe<BasicPropertyValue>
}

export type IContactUsDesktop = {
  /** רשימת רכיבי צור קשר */
  itemsList?: Maybe<BasicBlockListModel>
  /** כותרת */
  title?: Maybe<BasicPropertyValue>
}

export type IContactUsInfoItem = {
  /** כתובת */
  address?: Maybe<BasicPropertyValue>
  /**
   * איקון לצד כותרת כתובת - SVG/PNG
   * 20X20
   */
  addressIcon?: Maybe<MintMediaPicker>
  /** כותרת כתובת */
  addressTitle?: Maybe<BasicPropertyValue>
  /** העלאת מסמכים */
  documents?: Maybe<BasicMultiUrlPicker>
  /**
   * איקון לצד כותרת מסמכים - SVG/ PNG
   * 20X20
   */
  documentsIcon?: Maybe<MintMediaPicker>
  /** כותרת מסמכים */
  documentsTitle?: Maybe<BasicPropertyValue>
  /** כתובת מייל */
  emailAddress?: Maybe<BasicMultiUrlPicker>
  /**
   * איקון מייל - SVG/ PNG
   * 40X40
   */
  emailIcon?: Maybe<MintMediaPicker>
  /**
   * איקון לצד כותרת פקס - SVG/ PNG
   * 20X20
   */
  faxIcon?: Maybe<MintMediaPicker>
  /** מספר פקס */
  faxNumber?: Maybe<BasicPropertyValue>
  /** כותרת פקס */
  faxTitle?: Maybe<BasicPropertyValue>
  /**
   * תוכן חשוב לדעת-
   *  חובה להזין כותרת כדי שהתוכן של אזור חשוב לדעת יופיע
   */
  importantToKnowContent?: Maybe<BasicRichText>
  /** כותרת חשוב לדעת- חובה להזין כותרת כדי שהתוכן של אזור חשוב לדעת יופיע */
  importantToKnowTitle?: Maybe<BasicPropertyValue>
  /** כותרת */
  itemTitle?: Maybe<BasicPropertyValue>
  /** פירוט שעות פעילות */
  openingHoursContent?: Maybe<BasicBlockListModel>
  /**
   * איקון שעות פעילות - SVG/ PNG
   * 20X20
   */
  openingHoursIcon?: Maybe<MintMediaPicker>
  /** כותרתר שעות פעילות */
  openingHoursTitle?: Maybe<BasicPropertyValue>
  /**
   * איקון טלפון- PNG/ SVG
   * 40X40
   */
  phoneIcon?: Maybe<MintMediaPicker>
  /** טלפון */
  phoneNumber?: Maybe<BasicMultiUrlPicker>
  /**
   * כפתור לטופס-
   * יש לבחור את העמוד ולהוסיף # + מספר הרכיב של אזור הפניה.
   * מיועד לעמוד צור קשר.
   */
  sendTo?: Maybe<BasicMultiUrlPicker>
}

export type IContactUsItem = {
  /**
   * אייקון PNG\SVG
   * width: 40;
   * height: 40;
   */
  icon?: Maybe<MintMediaPicker>
  /** קישור */
  link?: Maybe<BasicMultiUrlPicker>
}

export type IContactUsMobile = {
  /**
   * תמונה PNG\JPG
   * width: 88;
   * height: 88;
   */
  image?: Maybe<MintMediaPicker>
  /** רשימת רכיבי צור קשר */
  itemsList?: Maybe<BasicBlockListModel>
  /** תיאור */
  subtitle?: Maybe<BasicPropertyValue>
  /** כותרת */
  title?: Maybe<BasicPropertyValue>
}

/** פריט בתפריט עם אפשרות לבחור תוכן ספציפי באתר */
export type IContentMenuItem = {
  content?: Maybe<BasicContentPicker>
  title?: Maybe<BasicPropertyValue>
}

/** עמוד ליצירת תוכן כללי באופן חופשי */
export type IContentPage = {
  blocks?: Maybe<BasicBlockListModel>
  /** יש להגדיר כתובת מלאה כולל דומיין */
  canonicalUrl?: Maybe<BasicPropertyValue>
  jsonPdSchema?: Maybe<BasicPropertyValue>
  /** תגית מטא עבור תיאור העמוד (SEO) */
  metaDescription?: Maybe<BasicPropertyValue>
  /** תגית מטא עבור כותרת העמוד (SEO) */
  metaTitle?: Maybe<BasicPropertyValue>
  /** תמונה שתופיע בשיתוף העמוד */
  ogImageSHARE?: Maybe<MintMediaPicker>
  /** לצורך מיפוי כתובות אתר ישנות לעמוד זה. נא לציין כתובת יחסית ללא דומיין כותת סלאש ראשון בהתחלה */
  oldUrls?: Maybe<BasicMultiUrlPicker>
  robotsTxt?: Maybe<BasicPropertyValue>
  /** שם העמוד גם עבור Breadcrumbs */
  titleBreadcrumbs?: Maybe<BasicPropertyValue>
}

/** פריט בתפריט שמבוסס על לינק חופשי לכל יעד */
export type ICustomMenuItem = {
  title?: Maybe<BasicPropertyValue>
  url?: Maybe<BasicPropertyValue>
}

export type IDynamicBlockList = {
  blocks?: Maybe<BasicBlockListModel>
}

export type IEmployeeRecommendations = {
  /**
   * תמונה PNG\JPG
   * 1440*48
   */
  image?: Maybe<MintMediaPicker>
  /** רשימת עובדים */
  itemsList?: Maybe<BasicBlockListModel>
  /** כותרת */
  title?: Maybe<BasicPropertyValue>
}

export type IEmployeeRecommendationsItem = {
  /**
   * תמונה PNG\JPG
   * 84*84
   */
  image?: Maybe<MintMediaPicker>
  /**
   * אייקון ללינקדין PNG\SVG
   * 32*32
   */
  linkedinIcon?: Maybe<MintMediaPicker>
  /** קישור ללינקדין */
  linkedinLink?: Maybe<BasicMultiUrlPicker>
  /** תפקיד */
  role?: Maybe<BasicPropertyValue>
  /** טקסט */
  text?: Maybe<BasicPropertyValue>
  /** כותרת- שם */
  title?: Maybe<BasicPropertyValue>
}

export type Ifaq = {
  /** כפתור */
  button?: Maybe<BasicMultiUrlPicker>
  /** תאור */
  description?: Maybe<BasicRichText>
  /** שורת טקסט בתוך חיפוש */
  fAQSearchLine?: Maybe<BasicPropertyValue>
  /** רשימת שאלות ותשובות */
  itemsList?: Maybe<BasicBlockListModel>
  /** הצגת שורת חיפוש */
  showSearchBox?: Maybe<BasicPropertyValue>
  /** כותרת */
  title?: Maybe<BasicPropertyValue>
}

export type IfaqItem = {
  /** תשובה */
  answer?: Maybe<BasicRichText>
  /** כפתור - אופציונלי לעמוד זכאות להנחות */
  button?: Maybe<BasicMultiUrlPicker>
  /** שאלה */
  question?: Maybe<BasicPropertyValue>
}

export type IFinePayment = {
  /** שלבים */
  finePaymentSteps?: Maybe<BasicBlockListModel>
}

export type IFinePaymentSteps = {
  /** פרטי יצירת קשר לערעור */
  contactBlock?: Maybe<BasicBlockListModel>
  /**
   * איקון - SVG/PNG
   * 80X80
   */
  icon?: Maybe<MintMediaPicker>
  /** שם השלב */
  stepName?: Maybe<BasicPropertyValue>
  /** כותרת משנה */
  subTitle?: Maybe<BasicPropertyValue>
  /** כותרת השלב */
  title?: Maybe<BasicPropertyValue>
}

export type IFooter = {
  /** קישורים להורדת האפליקציה */
  appDownloadList?: Maybe<BasicBlockListModel>
  /** טקסט הורדת האפליקציה */
  appDownloadText?: Maybe<BasicPropertyValue>
  /** קישורים תחתונים- נגישות פרטיות וכו */
  bottomLinks?: Maybe<BasicBlockListModel>
  /**
   * לוגו- PNG/SVG
   * 64X64
   */
  logo?: Maybe<MintMediaPicker>
  /** תפריט פוטר */
  megaMenu?: Maybe<BasicBlockListModel>
  /** בלוק רשתות חברתיות */
  social?: Maybe<BasicBlockListModel>
  /** טקסט - זכויות יוצרים */
  text?: Maybe<BasicPropertyValue>
}

export type IFooterCategories = {
  /** קישורי הקטגוריה */
  categoriesLinks?: Maybe<BasicMultiUrlPicker>
  /** שם הקטגוריה */
  categoryName?: Maybe<BasicPropertyValue>
}

export type IFreeContentPage = {
  body?: Maybe<BasicRichText>
  /** יש להגדיר כתובת מלאה כולל דומיין */
  canonicalUrl?: Maybe<BasicPropertyValue>
  jsonPdSchema?: Maybe<BasicPropertyValue>
  /** תגית מטא עבור תיאור העמוד (SEO) */
  metaDescription?: Maybe<BasicPropertyValue>
  /** תגית מטא עבור כותרת העמוד (SEO) */
  metaTitle?: Maybe<BasicPropertyValue>
  /** תמונה שתופיע בשיתוף העמוד */
  ogImageSHARE?: Maybe<MintMediaPicker>
  /** לצורך מיפוי כתובות אתר ישנות לעמוד זה. נא לציין כתובת יחסית ללא דומיין כותת סלאש ראשון בהתחלה */
  oldUrls?: Maybe<BasicMultiUrlPicker>
  robotsTxt?: Maybe<BasicPropertyValue>
  /** שם העמוד גם עבור Breadcrumbs */
  titleBreadcrumbs?: Maybe<BasicPropertyValue>
}

export type IHeaderCategories = {
  /** קישורי הקטגוריה */
  categoriesLinks?: Maybe<BasicBlockListModel>
  /** שם הקטגוריה */
  categoryName?: Maybe<BasicPropertyValue>
}

export type IHeaderDesktop = {
  /**
   * לוגו צור קשר
   * PNG/ SVG
   * width:40px
   * height:40px
   */
  contactLogo?: Maybe<MintMediaPicker>
  contactUs?: Maybe<BasicBlockListModel>
  /**
   * לוגו האתר -
   * PNG/ SVG
   * width:40px
   * height:40px
   */
  siteLogo?: Maybe<MintMediaPicker>
}

export type IHeaderMobile = {
  /**
   * לוגו צור קשר
   * PNG/ SVG
   * width:88px
   * height:88px
   */
  contactLogo?: Maybe<MintMediaPicker>
  contactUs?: Maybe<BasicBlockListModel>
  /**
   * לוגו האתר -
   * PNG/ SVG
   * width:40px
   * height:40px
   */
  siteLogo?: Maybe<MintMediaPicker>
}

export type IHeroBanner = {
  /**
   * תמונה לדסקטופ- JPG/ PNG
   * width:1440px; height: 300px
   */
  imageForDesktop?: Maybe<MintMediaPicker>
  /**
   * תמונה למובייל - png/JPG
   * with:360px;
   * height:166px;
   */
  imageForMobile?: Maybe<MintMediaPicker>
  /** כותרת העמוד */
  pageMainTitle?: Maybe<BasicPropertyValue>
}

export type IHeroBannerHomePage = {
  /** כפתור חיפוש */
  button?: Maybe<BasicMultiUrlPicker>
  /**
   * במידה ואין אנימציה- יש להזין תמונה או סרטון - JPG/ PNG/MP4
   * 1920X643
   */
  imageOrVideo?: Maybe<MintMediaPicker>
  /** תיאור חיפוש */
  searchDescription?: Maybe<BasicPropertyValue>
  /** כותרת חיפוש */
  searchTitle?: Maybe<BasicPropertyValue>
  /** כותרת הבאנר */
  title?: Maybe<BasicRichText>
}

export type IHistoryItem = {
  /**
   * תמונה מוקטנת לדף הבית - דסקטופ PNG\JPG
   * with:184px; height:173
   */
  desktopImage?: Maybe<MintMediaPicker>
  /**
   * תמונה לדסקטופ- JPG/ PNG
   * width:487px; height:260px;
   */
  imageForDesktop?: Maybe<MintMediaPicker>
  /**
   * תמונה למובייל- PNG/ JPG
   * width:304px; height:184px
   */
  imageForMobil?: Maybe<MintMediaPicker>
  /**
   * תמונה מוקטנת לדף הבית - מובייל
   * PNG\JPG
   * with:136px; height:135
   */
  mobileImage?: Maybe<MintMediaPicker>
  /** תאור */
  shortText?: Maybe<BasicPropertyValue>
  /** תאור קצר לדף הבית */
  subtitle?: Maybe<BasicPropertyValue>
  /** כותרת */
  title?: Maybe<BasicPropertyValue>
  /** שנה לעמוד הבית */
  yearForHomePage?: Maybe<BasicDateTimePicker>
  /** שנים */
  years?: Maybe<BasicPropertyValue>
}

/** תבנית להקמת דף בית */
export type IHomePage = {
  /** יש להגדיר כתובת מלאה כולל דומיין */
  canonicalUrl?: Maybe<BasicPropertyValue>
  jsonPdSchema?: Maybe<BasicPropertyValue>
  /** תגית מטא עבור תיאור העמוד (SEO) */
  metaDescription?: Maybe<BasicPropertyValue>
  /** תגית מטא עבור כותרת העמוד (SEO) */
  metaTitle?: Maybe<BasicPropertyValue>
  /** תמונה שתופיע בשיתוף העמוד */
  ogImageSHARE?: Maybe<MintMediaPicker>
  /** לצורך מיפוי כתובות אתר ישנות לעמוד זה. נא לציין כתובת יחסית ללא דומיין כותת סלאש ראשון בהתחלה */
  oldUrls?: Maybe<BasicMultiUrlPicker>
  robotsTxt?: Maybe<BasicPropertyValue>
  /** שם העמוד גם עבור Breadcrumbs */
  titleBreadcrumbs?: Maybe<BasicPropertyValue>
}

export type IInformation = {
  /**
   * איקון- SVG/ PNG
   * with:56px; height:56px;
   */
  icon?: Maybe<MintMediaPicker>
  /** טקסט מתאר */
  text?: Maybe<BasicPropertyValue>
  /** לינק */
  url?: Maybe<BasicMultiUrlPicker>
}

export type IInformationForPassangers = {
  /** טקסט תאור */
  description?: Maybe<BasicRichText>
  /** רשימת קישורי אינפורמציות */
  infoIconList?: Maybe<BasicBlockListModel>
}

export type IInquiriesAndRequests = {
  /** כותרת לטאב */
  tabTitle?: Maybe<BasicPropertyValue>
}

export type ILinesItem = {
  /** כיוון הנסיעה */
  direction?: Maybe<BasicPropertyValue>
  /** מספר הקו */
  lineNumber?: Maybe<BasicPropertyValue>
}

export type ILinkItem = {
  /** נתיב הקישור */
  linkUrl?: Maybe<BasicMultiUrlPicker>
}

export type ILogoComponent = {
  /**
   * לוגו PNG\SVG
   * width: 222;
   * height: 80;
   */
  logo?: Maybe<MintMediaPicker>
}

export type IMainTitleBlock = {
  /** כותרת ראשית */
  title?: Maybe<BasicPropertyValue>
}

export type IMultyUrLsTitleAndText = {
  /**
   * רשימת קישורים.
   * במידה ומעלים תמונה או סרטון יש להעלות PNG\JPG ברזולוציה של
   * 1440*440
   */
  itemsList?: Maybe<BasicMultiUrlPicker>
  /** טקסט - לעמוד מטה */
  text?: Maybe<BasicPropertyValue>
  /** כותרת */
  title?: Maybe<BasicPropertyValue>
}

/** Represents a property that can be queried by the alias name. */
export type INamedContentProperties =
  | AdynamicTitleAndContant
  | AnchorMenu
  | AnchorMenuItems
  | Article
  | ArticlesCategory
  | ArticlesLobby
  | BannerModule
  | BasicBannerModule
  | ButtonComponent
  | ContactUs
  | ContactUsBox
  | ContactUsBoxItem
  | ContactUsBoxWithText
  | ContactUsDesktop
  | ContactUsInfoItem
  | ContactUsItem
  | ContactUsMobile
  | ContentMenuItem
  | ContentPage
  | CustomMenuItem
  | DynamicBlockList
  | EmployeeRecommendations
  | EmployeeRecommendationsItem
  | EmptyINamedContentProperties
  | Faq
  | FaqItem
  | FinePayment
  | FinePaymentSteps
  | Footer
  | FooterCategories
  | FreeContentPage
  | HeaderCategories
  | HeaderDesktop
  | HeaderMobile
  | HeroBanner
  | HeroBannerHomePage
  | HistoryItem
  | HomePage
  | Information
  | InformationForPassangers
  | InquiriesAndRequests
  | LinesItem
  | LinkItem
  | LogoComponent
  | MainTitleBlock
  | MultyUrLsTitleAndText
  | NumericItem
  | OpeningTimeItem
  | OperatingHoursContactInfo
  | OperatingHoursContactInfoItem
  | PageInfoBlock
  | PaymentMethod
  | PaymentMethodItem
  | PaymentMethodsInPublicTransport
  | PowerNumbers
  | PowerNumbersItem
  | RavKavServiceStation
  | RecommendationsBlock
  | ServiceShortcuts
  | ServiceShortcutsItem
  | ServiceStationItem
  | ServiceStationTabs
  | SocialBlock
  | SocialMedia
  | Statistics
  | StatisticsSectionItem
  | StatusLost
  | TabsContent
  | TabsContent1
  | TabsContentItem
  | TabsContentItem1
  | Team
  | TeamCategory
  | TeamItem
  | Timeline
  | TimelineItem
  | TitleTextAndMediaBlock
  | TrafficUpdatePage
  | TrafficUpdates
  | TrafficUpdatesItemsList
  | UpdatesItem
  | VisionTab

export type INumericItem = {
  /** רכיב */
  item?: Maybe<BasicPropertyValue>
}

export type IOpeningTimeItem = {
  /** יום */
  day?: Maybe<BasicPropertyValue>
  /** שעות */
  hour?: Maybe<BasicPropertyValue>
}

export type IOperatingHoursContactInfo = {
  /** רשימת רכיבים */
  itemsList?: Maybe<BasicBlockListModel>
  /** כותרת */
  title?: Maybe<BasicPropertyValue>
}

export type IOperatingHoursContactInfoItem = {
  /** מייל */
  emailAddress?: Maybe<BasicMultiUrlPicker>
  /** שעות פעילות */
  operatingHours?: Maybe<BasicRichText>
  /** מספר טלפון */
  phoneNumber?: Maybe<BasicMultiUrlPicker>
  /** כותרת */
  title?: Maybe<BasicPropertyValue>
}

/** בלוק להוספת פרטי עמוד כללים ותגיות מטא */
export type IPageInfoBlock = {
  /** יש להגדיר כתובת מלאה כולל דומיין */
  canonicalUrl?: Maybe<BasicPropertyValue>
  jsonPdSchema?: Maybe<BasicPropertyValue>
  /** תגית מטא עבור תיאור העמוד (SEO) */
  metaDescription?: Maybe<BasicPropertyValue>
  /** תגית מטא עבור כותרת העמוד (SEO) */
  metaTitle?: Maybe<BasicPropertyValue>
  /** תמונה שתופיע בשיתוף העמוד */
  ogImageSHARE?: Maybe<MintMediaPicker>
  /** לצורך מיפוי כתובות אתר ישנות לעמוד זה. נא לציין כתובת יחסית ללא דומיין כותת סלאש ראשון בהתחלה */
  oldUrls?: Maybe<BasicMultiUrlPicker>
  robotsTxt?: Maybe<BasicPropertyValue>
  /** שם העמוד גם עבור Breadcrumbs */
  titleBreadcrumbs?: Maybe<BasicPropertyValue>
}

export type IPaymentMethod = {
  /** רשימת רכיבי תשלום */
  itemsList?: Maybe<BasicBlockListModel>
  /** כותרת הטוגל */
  toggle?: Maybe<BasicPropertyValue>
}

export type IPaymentMethodItem = {
  /** רשימת כפתורים */
  buttons?: Maybe<BasicMultiUrlPicker>
  /**
   * לוגו PNG\SVG
   * 126*48
   */
  logo?: Maybe<MintMediaPicker>
  /** כותרת */
  title?: Maybe<BasicPropertyValue>
}

export type IPaymentMethodsInPublicTransport = {
  /** רשימת טוגלים */
  itemsList?: Maybe<BasicBlockListModel>
  /** כותרת */
  title?: Maybe<BasicPropertyValue>
}

export type IPowerNumbers = {
  /** רשימת רכיבים */
  itemsList?: Maybe<BasicBlockListModel>
  /** כותרת */
  title?: Maybe<BasicPropertyValue>
}

export type IPowerNumbersItem = {
  /** כפתור */
  button?: Maybe<BasicMultiUrlPicker>
  /**
   * אייקון PNG\SVG
   * width: 56px;
   * height: 56px;
   */
  icon?: Maybe<MintMediaPicker>
  /** רשימת סטטיסטיקות */
  itemsList?: Maybe<BasicBlockListModel>
  /** כותרת */
  title?: Maybe<BasicPropertyValue>
}

export type IRavKavServiceStation = {
  /** רשימת אזורים ועמדות */
  itemsList?: Maybe<BasicBlockListModel>
  /** כותרת */
  title?: Maybe<BasicPropertyValue>
}

export type IRecommendationsBlock = {
  /** הצגת המלצות */
  showRecommendations?: Maybe<BasicContentPicker>
}

export type IServiceShortcuts = {
  /** רשימת שירותים */
  itemsList?: Maybe<BasicBlockListModel>
}

export type IServiceShortcutsItem = {
  /**
   * אייקון SVG\PNG
   * width: 56px;
   * height: 56px;
   */
  icon?: Maybe<MintMediaPicker>
  /** קישור */
  link?: Maybe<BasicMultiUrlPicker>
}

export type IServiceStationItem = {
  /** איקון לצד טקסט נגישות - SVG/PNG */
  accessibleIcon?: Maybe<MintMediaPicker>
  /** טקסט נגישות */
  accessibleText?: Maybe<BasicPropertyValue>
  /** כתובת וקישור */
  addressLink?: Maybe<BasicMultiUrlPicker>
  /** רשימת רכיבי שעות פעילות */
  itemsList?: Maybe<BasicBlockListModel>
  /**
   * איקון לצד כותרת מיקום - SVG/PNG
   * 20X20
   */
  loacationIcon?: Maybe<MintMediaPicker>
  /** כותרת מיקום */
  locationTitle?: Maybe<BasicPropertyValue>
  /** כותרת */
  title?: Maybe<BasicPropertyValue>
}

export type IServiceStationTabs = {
  /**
   * ID לטאב
   * יש להזין ID באנגלית, ללא רווחים וללא תווים
   */
  encorID?: Maybe<BasicPropertyValue>
  /** רשימת רכיבי עמדות רב קו */
  itemsList?: Maybe<BasicBlockListModel>
  /** שם הטאב */
  tab?: Maybe<BasicPropertyValue>
}

export type ISocialBlock = {
  /** רשימת רכיבי סושיאל */
  itemsList?: Maybe<BasicBlockListModel>
  /** כותרת */
  title?: Maybe<BasicPropertyValue>
}

export type ISocialMedia = {
  /**
   * אייקון PNG\SVG
   * width: 24px;
   * height: 24px;
   */
  icon?: Maybe<MintMediaPicker>
  /**
   * איקון למצב הובר
   *  PNG\SVG
   * width: 24px;
   * height: 24px;
   */
  iconHover?: Maybe<MintMediaPicker>
  /** קישור */
  link?: Maybe<BasicMultiUrlPicker>
}

export type IStatistics = {
  /** רשימת רכיבים */
  itemsList?: Maybe<BasicBlockListModel>
}

export type IStatisticsSectionItem = {
  /** תווית למספר */
  label?: Maybe<BasicPropertyValue>
  /** מספר סטטיסטי */
  number?: Maybe<BasicPropertyValue>
}

export type IStatusLost = {
  /** בוקסות התקשרות */
  contactBoxs?: Maybe<BasicBlockListModel>
  /** כותרת לטופס */
  formTitle?: Maybe<BasicPropertyValue>
  /** כותרת לטאב */
  tabTitle?: Maybe<BasicPropertyValue>
  /**
   * אייקון לטיפ PNG\SVG
   * width: 32;
   * height: 32;
   */
  tipIcon?: Maybe<MintMediaPicker>
  /** טקסט - טיפ */
  tipText?: Maybe<BasicRichText>
}

export type ITabsContent = {
  /** רשימת רכיבים */
  itemsList?: Maybe<BasicBlockListModel>
}

export type ITabsContent1 = {
  /** רשימת רכיבים */
  itemsList?: Maybe<BasicBlockListModel>
}

export type ITabsContentItem = {
  /** רכיבי תוכן */
  itemsList?: Maybe<BasicBlockListModel>
  /** שם הטאב */
  tab?: Maybe<BasicPropertyValue>
}

export type ITabsContentItem1 = {
  /** שם לעוגן - באנגלית */
  anchorName?: Maybe<BasicPropertyValue>
  /** רכיבי תוכן */
  itemsList?: Maybe<BasicBlockListModel>
}

export type ITeam = {
  /** רשימת קטגוריות */
  itemsList?: Maybe<BasicBlockListModel>
  /** תוכן עמודת חזון */
  visionTab?: Maybe<BasicBlockListModel>
}

export type ITeamCategory = {
  /** שם הקטגוריה */
  categoryName?: Maybe<BasicPropertyValue>
  /** רשימת אנשי הצוות */
  teamList?: Maybe<BasicBlockListModel>
}

export type ITeamItem = {
  /** קישור ללינקדאין */
  linkedinLink?: Maybe<BasicMultiUrlPicker>
  /** תאור איש הצוות */
  teamDescription?: Maybe<BasicRichText>
  /**
   * תמונה ראשי- JPG/ PNG
   * with:352px; height:336px;
   */
  teamMainImage?: Maybe<MintMediaPicker>
  /** שם איש הצוות */
  teamName?: Maybe<BasicPropertyValue>
  /** תפקיד איש הצוות */
  teamRole?: Maybe<BasicPropertyValue>
  /**
   * תמונה מוקטנת - PNG/JPG
   * 84X84
   */
  teamThumbnailImage?: Maybe<MintMediaPicker>
}

export type ITimeline = {
  /** כפתור */
  button?: Maybe<BasicMultiUrlPicker>
  /** בחר רכיבי הסטוריה להצגה בדף הבית */
  selectItemToShow?: Maybe<BasicContentPicker>
  /** כותרת */
  title?: Maybe<BasicPropertyValue>
}

export type ITimelineItem = {
  /** כפתור - אופציונלי */
  button?: Maybe<BasicMultiUrlPicker>
  /**
   * תמונה לדסקטופ PNG\JPG
   * with:184px; height:173
   */
  desktopImage?: Maybe<MintMediaPicker>
  /**
   * תמונה למובייל PNG\JPG
   * with:136px; height:135
   */
  mobileImage?: Maybe<MintMediaPicker>
  /** תיאור */
  subtitle?: Maybe<BasicPropertyValue>
  /** כותרת - שנה */
  title?: Maybe<BasicPropertyValue>
}

export type ITitleTextAndMediaBlock = {
  /** תוכן */
  content?: Maybe<BasicRichText>
  /**
   * מדיה- תמונה או קישור ליוטיוב
   * 800X400
   */
  media?: Maybe<BasicMultiUrlPicker>
  /** כותרת משנית */
  subTitle?: Maybe<BasicPropertyValue>
}

/** תבנית להקמת עמוד עדכוני תנועה */
export type ITrafficUpdatePage = {
  /** יש להגדיר כתובת מלאה כולל דומיין */
  canonicalUrl?: Maybe<BasicPropertyValue>
  /** רכיבי כותרת וטקסט */
  itemsList?: Maybe<BasicBlockListModel>
  jsonPdSchema?: Maybe<BasicPropertyValue>
  /** תגית מטא עבור תיאור העמוד (SEO) */
  metaDescription?: Maybe<BasicPropertyValue>
  /** תגית מטא עבור כותרת העמוד (SEO) */
  metaTitle?: Maybe<BasicPropertyValue>
  /** תמונה שתופיע בשיתוף העמוד */
  ogImageSHARE?: Maybe<MintMediaPicker>
  /** לצורך מיפוי כתובות אתר ישנות לעמוד זה. נא לציין כתובת יחסית ללא דומיין כותת סלאש ראשון בהתחלה */
  oldUrls?: Maybe<BasicMultiUrlPicker>
  robotsTxt?: Maybe<BasicPropertyValue>
  /** שם העמוד גם עבור Breadcrumbs */
  titleBreadcrumbs?: Maybe<BasicPropertyValue>
  /** עדכון התנועה */
  trafficUpdate?: Maybe<BasicBlockListModel>
}

export type ITrafficUpdates = {
  /** כפתור - עד 50 תווים */
  button?: Maybe<BasicMultiUrlPicker>
  /**
   * קישור - לכל העדכונים
   * עד 50 תווים
   */
  link?: Maybe<BasicMultiUrlPicker>
  /** תת כותרת */
  subtitle?: Maybe<BasicPropertyValue>
  /** כותרת */
  title?: Maybe<BasicPropertyValue>
}

export type ITrafficUpdatesItemsList = {
  /** רשימת עדכונים */
  itemsList?: Maybe<BasicBlockListModel>
}

export type IUpdatesItem = {
  /**
   * תיאור
   * במובייל יוצגו רק 80 התווים הראשונים, ולא יותר מ2 שורות.
   */
  description?: Maybe<BasicPropertyValue>
  /** תאריך ושעת סיום */
  endDate?: Maybe<BasicDateTimePicker>
  /** רשימת קווים שמושפעים מהשינוי */
  linesList?: Maybe<BasicBlockListModel>
  /** תאריך ושעת התחלה */
  startDate?: Maybe<BasicDateTimePicker>
  /** סיבת העדכון */
  updateReason?: Maybe<BasicPropertyValue>
}

export type IVisionTab = {
  /** תוכן האזור */
  content?: Maybe<BasicBlockListModel>
  /** שם הטאב */
  tabName?: Maybe<BasicPropertyValue>
}

export type Information = IInformation & {
  __typename?: "Information"
  /**
   * איקון- SVG/ PNG
   * with:56px; height:56px;
   */
  icon?: Maybe<MintMediaPicker>
  /** טקסט מתאר */
  text?: Maybe<BasicPropertyValue>
  /** לינק */
  url?: Maybe<BasicMultiUrlPicker>
}

export type InformationForPassangers = IInformationForPassangers & {
  __typename?: "InformationForPassangers"
  /** טקסט תאור */
  description?: Maybe<BasicRichText>
  /** רשימת קישורי אינפורמציות */
  infoIconList?: Maybe<BasicBlockListModel>
}

export type InquiriesAndRequests = IInquiriesAndRequests & {
  __typename?: "InquiriesAndRequests"
  /** כותרת לטאב */
  tabTitle?: Maybe<BasicPropertyValue>
}

export type IntOperationFilterInput = {
  eq?: InputMaybe<Scalars["Int"]["input"]>
  gt?: InputMaybe<Scalars["Int"]["input"]>
  gte?: InputMaybe<Scalars["Int"]["input"]>
  in?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>
  lt?: InputMaybe<Scalars["Int"]["input"]>
  lte?: InputMaybe<Scalars["Int"]["input"]>
  neq?: InputMaybe<Scalars["Int"]["input"]>
  ngt?: InputMaybe<Scalars["Int"]["input"]>
  ngte?: InputMaybe<Scalars["Int"]["input"]>
  nin?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>
  nlt?: InputMaybe<Scalars["Int"]["input"]>
  nlte?: InputMaybe<Scalars["Int"]["input"]>
}

export type KeyValuePairOfStringAndPublishedCultureInfo = {
  __typename?: "KeyValuePairOfStringAndPublishedCultureInfo"
  key: Scalars["String"]["output"]
  value: PublishedCultureInfo
}

export type KeyValuePairOfStringAndPublishedCultureInfoFilterInput = {
  and?: InputMaybe<
    Array<KeyValuePairOfStringAndPublishedCultureInfoFilterInput>
  >
  key?: InputMaybe<StringOperationFilterInput>
  or?: InputMaybe<Array<KeyValuePairOfStringAndPublishedCultureInfoFilterInput>>
  value?: InputMaybe<PublishedCultureInfoFilterInput>
}

export type LinesItem = ILinesItem & {
  __typename?: "LinesItem"
  /** כיוון הנסיעה */
  direction?: Maybe<BasicPropertyValue>
  /** מספר הקו */
  lineNumber?: Maybe<BasicPropertyValue>
}

export type LinkItem = ILinkItem & {
  __typename?: "LinkItem"
  /** נתיב הקישור */
  linkUrl?: Maybe<BasicMultiUrlPicker>
}

export enum LinkType {
  Content = "CONTENT",
  External = "EXTERNAL",
  Media = "MEDIA",
}

export type ListFilterInputTypeOfBasicContentFilterInput = {
  all?: InputMaybe<BasicContentFilterInput>
  any?: InputMaybe<Scalars["Boolean"]["input"]>
  none?: InputMaybe<BasicContentFilterInput>
  some?: InputMaybe<BasicContentFilterInput>
}

export type ListFilterInputTypeOfBasicPropertyFilterInput = {
  all?: InputMaybe<BasicPropertyFilterInput>
  any?: InputMaybe<Scalars["Boolean"]["input"]>
  none?: InputMaybe<BasicPropertyFilterInput>
  some?: InputMaybe<BasicPropertyFilterInput>
}

export type ListFilterInputTypeOfKeyValuePairOfStringAndPublishedCultureInfoFilterInput =
  {
    all?: InputMaybe<KeyValuePairOfStringAndPublishedCultureInfoFilterInput>
    any?: InputMaybe<Scalars["Boolean"]["input"]>
    none?: InputMaybe<KeyValuePairOfStringAndPublishedCultureInfoFilterInput>
    some?: InputMaybe<KeyValuePairOfStringAndPublishedCultureInfoFilterInput>
  }

export type ListStringOperationFilterInput = {
  all?: InputMaybe<StringOperationFilterInput>
  any?: InputMaybe<Scalars["Boolean"]["input"]>
  none?: InputMaybe<StringOperationFilterInput>
  some?: InputMaybe<StringOperationFilterInput>
}

export type LogoComponent = ILogoComponent & {
  __typename?: "LogoComponent"
  /**
   * לוגו PNG\SVG
   * width: 222;
   * height: 80;
   */
  logo?: Maybe<MintMediaPicker>
}

export type MainTitleBlock = IMainTitleBlock & {
  __typename?: "MainTitleBlock"
  /** כותרת ראשית */
  title?: Maybe<BasicPropertyValue>
}

export type MintMediaPicker = PropertyValue & {
  __typename?: "MintMediaPicker"
  /** Gets the media items of a picker. */
  mediaItems: Array<MintMediaPickerItem>
  model: Scalars["String"]["output"]
}

export type MintMediaPickerItem = {
  __typename?: "MintMediaPickerItem"
  altText?: Maybe<Scalars["String"]["output"]>
  /** Gets the id of a media item. */
  id: Scalars["Int"]["output"]
  /** Gets the absolute url of a media item. */
  url: Scalars["String"]["output"]
}

export type MultyUrLsTitleAndText = IMultyUrLsTitleAndText & {
  __typename?: "MultyURLsTitleAndText"
  /**
   * רשימת קישורים.
   * במידה ומעלים תמונה או סרטון יש להעלות PNG\JPG ברזולוציה של
   * 1440*440
   */
  itemsList?: Maybe<BasicMultiUrlPicker>
  /** טקסט - לעמוד מטה */
  text?: Maybe<BasicPropertyValue>
  /** כותרת */
  title?: Maybe<BasicPropertyValue>
}

export type NullableOfPublishedItemTypeOperationFilterInput = {
  eq?: InputMaybe<PublishedItemType>
  in?: InputMaybe<Array<InputMaybe<PublishedItemType>>>
  neq?: InputMaybe<PublishedItemType>
  nin?: InputMaybe<Array<InputMaybe<PublishedItemType>>>
}

export type NumericItem = INumericItem & {
  __typename?: "NumericItem"
  /** רכיב */
  item?: Maybe<BasicPropertyValue>
}

export type OpeningTimeItem = IOpeningTimeItem & {
  __typename?: "OpeningTimeItem"
  /** יום */
  day?: Maybe<BasicPropertyValue>
  /** שעות */
  hour?: Maybe<BasicPropertyValue>
}

export type OperatingHoursContactInfo = IOperatingHoursContactInfo & {
  __typename?: "OperatingHoursContactInfo"
  /** רשימת רכיבים */
  itemsList?: Maybe<BasicBlockListModel>
  /** כותרת */
  title?: Maybe<BasicPropertyValue>
}

export type OperatingHoursContactInfoItem = IOperatingHoursContactInfoItem & {
  __typename?: "OperatingHoursContactInfoItem"
  /** מייל */
  emailAddress?: Maybe<BasicMultiUrlPicker>
  /** שעות פעילות */
  operatingHours?: Maybe<BasicRichText>
  /** מספר טלפון */
  phoneNumber?: Maybe<BasicMultiUrlPicker>
  /** כותרת */
  title?: Maybe<BasicPropertyValue>
}

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: "PageInfo"
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars["String"]["output"]>
  /** Indicates whether more edges exist following the set defined by the clients arguments. */
  hasNextPage: Scalars["Boolean"]["output"]
  /** Indicates whether more edges exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars["Boolean"]["output"]
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars["String"]["output"]>
}

/** בלוק להוספת פרטי עמוד כללים ותגיות מטא */
export type PageInfoBlock = IPageInfoBlock & {
  __typename?: "PageInfoBlock"
  /** יש להגדיר כתובת מלאה כולל דומיין */
  canonicalUrl?: Maybe<BasicPropertyValue>
  jsonPdSchema?: Maybe<BasicPropertyValue>
  /** תגית מטא עבור תיאור העמוד (SEO) */
  metaDescription?: Maybe<BasicPropertyValue>
  /** תגית מטא עבור כותרת העמוד (SEO) */
  metaTitle?: Maybe<BasicPropertyValue>
  /** תמונה שתופיע בשיתוף העמוד */
  ogImageSHARE?: Maybe<MintMediaPicker>
  /** לצורך מיפוי כתובות אתר ישנות לעמוד זה. נא לציין כתובת יחסית ללא דומיין כותת סלאש ראשון בהתחלה */
  oldUrls?: Maybe<BasicMultiUrlPicker>
  robotsTxt?: Maybe<BasicPropertyValue>
  /** שם העמוד גם עבור Breadcrumbs */
  titleBreadcrumbs?: Maybe<BasicPropertyValue>
}

export type PaymentMethod = IPaymentMethod & {
  __typename?: "PaymentMethod"
  /** רשימת רכיבי תשלום */
  itemsList?: Maybe<BasicBlockListModel>
  /** כותרת הטוגל */
  toggle?: Maybe<BasicPropertyValue>
}

export type PaymentMethodItem = IPaymentMethodItem & {
  __typename?: "PaymentMethodItem"
  /** רשימת כפתורים */
  buttons?: Maybe<BasicMultiUrlPicker>
  /**
   * לוגו PNG\SVG
   * 126*48
   */
  logo?: Maybe<MintMediaPicker>
  /** כותרת */
  title?: Maybe<BasicPropertyValue>
}

export type PaymentMethodsInPublicTransport =
  IPaymentMethodsInPublicTransport & {
    __typename?: "PaymentMethodsInPublicTransport"
    /** רשימת טוגלים */
    itemsList?: Maybe<BasicBlockListModel>
    /** כותרת */
    title?: Maybe<BasicPropertyValue>
  }

export type PowerNumbers = IPowerNumbers & {
  __typename?: "PowerNumbers"
  /** רשימת רכיבים */
  itemsList?: Maybe<BasicBlockListModel>
  /** כותרת */
  title?: Maybe<BasicPropertyValue>
}

export type PowerNumbersItem = IPowerNumbersItem & {
  __typename?: "PowerNumbersItem"
  /** כפתור */
  button?: Maybe<BasicMultiUrlPicker>
  /**
   * אייקון PNG\SVG
   * width: 56px;
   * height: 56px;
   */
  icon?: Maybe<MintMediaPicker>
  /** רשימת סטטיסטיקות */
  itemsList?: Maybe<BasicBlockListModel>
  /** כותרת */
  title?: Maybe<BasicPropertyValue>
}

export enum PropertyFallback {
  Ancestors = "ANCESTORS",
  DefaultValue = "DEFAULT_VALUE",
  Language = "LANGUAGE",
  None = "NONE",
}

export type PropertyValue = {
  model: Scalars["String"]["output"]
}

export type PropertyValueFilterInput = {
  and?: InputMaybe<Array<PropertyValueFilterInput>>
  model?: InputMaybe<StringOperationFilterInput>
  or?: InputMaybe<Array<PropertyValueFilterInput>>
}

export type PublishedCultureInfo = {
  __typename?: "PublishedCultureInfo"
  culture: Scalars["String"]["output"]
  date: Scalars["DateTime"]["output"]
  name: Scalars["String"]["output"]
  urlSegment?: Maybe<Scalars["String"]["output"]>
}

export type PublishedCultureInfoFilterInput = {
  and?: InputMaybe<Array<PublishedCultureInfoFilterInput>>
  culture?: InputMaybe<StringOperationFilterInput>
  date?: InputMaybe<DateTimeOperationFilterInput>
  name?: InputMaybe<StringOperationFilterInput>
  or?: InputMaybe<Array<PublishedCultureInfoFilterInput>>
  urlSegment?: InputMaybe<StringOperationFilterInput>
}

export enum PublishedItemType {
  Content = "CONTENT",
  Element = "ELEMENT",
  Media = "MEDIA",
  Member = "MEMBER",
  Unknown = "UNKNOWN",
}

export type PublishedItemTypeOperationFilterInput = {
  eq?: InputMaybe<PublishedItemType>
  in?: InputMaybe<Array<PublishedItemType>>
  neq?: InputMaybe<PublishedItemType>
  nin?: InputMaybe<Array<PublishedItemType>>
}

export type Query = {
  __typename?: "Query"
  /** Gets all the content items at root level. */
  contentAtRoot?: Maybe<ContentAtRootConnection>
  /** Gets a content item by an absolute route. */
  contentByAbsoluteRoute?: Maybe<BasicContent>
  /** Gets all the content items by content type. */
  contentByContentType?: Maybe<ContentByContentTypeConnection>
  /** Gets a content item by guid. */
  contentByGuid?: Maybe<BasicContent>
  /** Gets a content item by id. */
  contentById?: Maybe<BasicContent>
  /** Gets content items by tag. */
  contentByTag?: Maybe<ContentByTagConnection>
  /** Gets content item descendants by an absolute route. */
  contentDescendantsByAbsoluteRoute?: Maybe<ContentDescendantsByAbsoluteRouteConnection>
  /** Gets all descendants of content items with a specific content type. */
  contentDescendantsByContentType?: Maybe<ContentDescendantsByContentTypeConnection>
  /** Gets descendants on a content item selected by guid. */
  contentDescendantsByGuid?: Maybe<ContentDescendantsByGuidConnection>
  /** Gets descendants on a content item selected by id. */
  contentDescendantsById?: Maybe<ContentDescendantsByIdConnection>
}

export type QueryContentAtRootArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  before?: InputMaybe<Scalars["String"]["input"]>
  culture?: InputMaybe<Scalars["String"]["input"]>
  fallback?: InputMaybe<Array<PropertyFallback>>
  first?: InputMaybe<Scalars["Int"]["input"]>
  last?: InputMaybe<Scalars["Int"]["input"]>
  order?: InputMaybe<Array<BasicContentSortInput>>
  preview?: Scalars["Boolean"]["input"]
  segment?: InputMaybe<Scalars["String"]["input"]>
  where?: InputMaybe<BasicContentFilterInput>
}

export type QueryContentByAbsoluteRouteArgs = {
  baseUrl?: Scalars["String"]["input"]
  culture?: InputMaybe<Scalars["String"]["input"]>
  fallback?: InputMaybe<Array<PropertyFallback>>
  order?: InputMaybe<Array<BasicContentSortInput>>
  preview?: Scalars["Boolean"]["input"]
  route: Scalars["String"]["input"]
  routeMode?: RouteMode
  segment?: InputMaybe<Scalars["String"]["input"]>
  where?: InputMaybe<BasicContentFilterInput>
}

export type QueryContentByContentTypeArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  before?: InputMaybe<Scalars["String"]["input"]>
  contentType: Scalars["String"]["input"]
  culture?: InputMaybe<Scalars["String"]["input"]>
  fallback?: InputMaybe<Array<PropertyFallback>>
  first?: InputMaybe<Scalars["Int"]["input"]>
  last?: InputMaybe<Scalars["Int"]["input"]>
  order?: InputMaybe<Array<BasicContentSortInput>>
  segment?: InputMaybe<Scalars["String"]["input"]>
  where?: InputMaybe<BasicContentFilterInput>
}

export type QueryContentByGuidArgs = {
  culture?: InputMaybe<Scalars["String"]["input"]>
  fallback?: InputMaybe<Array<PropertyFallback>>
  id: Scalars["UUID"]["input"]
  order?: InputMaybe<Array<BasicContentSortInput>>
  preview?: Scalars["Boolean"]["input"]
  segment?: InputMaybe<Scalars["String"]["input"]>
  where?: InputMaybe<BasicContentFilterInput>
}

export type QueryContentByIdArgs = {
  culture?: InputMaybe<Scalars["String"]["input"]>
  fallback?: InputMaybe<Array<PropertyFallback>>
  id: Scalars["Int"]["input"]
  order?: InputMaybe<Array<BasicContentSortInput>>
  preview?: Scalars["Boolean"]["input"]
  segment?: InputMaybe<Scalars["String"]["input"]>
  where?: InputMaybe<BasicContentFilterInput>
}

export type QueryContentByTagArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  before?: InputMaybe<Scalars["String"]["input"]>
  culture?: InputMaybe<Scalars["String"]["input"]>
  fallback?: InputMaybe<Array<PropertyFallback>>
  first?: InputMaybe<Scalars["Int"]["input"]>
  last?: InputMaybe<Scalars["Int"]["input"]>
  order?: InputMaybe<Array<BasicContentSortInput>>
  segment?: InputMaybe<Scalars["String"]["input"]>
  tag: Scalars["String"]["input"]
  tagGroup?: InputMaybe<Scalars["String"]["input"]>
  where?: InputMaybe<BasicContentFilterInput>
}

export type QueryContentDescendantsByAbsoluteRouteArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  baseUrl?: Scalars["String"]["input"]
  before?: InputMaybe<Scalars["String"]["input"]>
  culture?: InputMaybe<Scalars["String"]["input"]>
  fallback?: InputMaybe<Array<PropertyFallback>>
  first?: InputMaybe<Scalars["Int"]["input"]>
  last?: InputMaybe<Scalars["Int"]["input"]>
  order?: InputMaybe<Array<BasicContentSortInput>>
  preview?: Scalars["Boolean"]["input"]
  route: Scalars["String"]["input"]
  routeMode?: RouteMode
  segment?: InputMaybe<Scalars["String"]["input"]>
  where?: InputMaybe<BasicContentFilterInput>
}

export type QueryContentDescendantsByContentTypeArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  before?: InputMaybe<Scalars["String"]["input"]>
  contentType: Scalars["String"]["input"]
  culture?: InputMaybe<Scalars["String"]["input"]>
  fallback?: InputMaybe<Array<PropertyFallback>>
  first?: InputMaybe<Scalars["Int"]["input"]>
  last?: InputMaybe<Scalars["Int"]["input"]>
  order?: InputMaybe<Array<BasicContentSortInput>>
  segment?: InputMaybe<Scalars["String"]["input"]>
  where?: InputMaybe<BasicContentFilterInput>
}

export type QueryContentDescendantsByGuidArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  before?: InputMaybe<Scalars["String"]["input"]>
  culture?: InputMaybe<Scalars["String"]["input"]>
  fallback?: InputMaybe<Array<PropertyFallback>>
  first?: InputMaybe<Scalars["Int"]["input"]>
  id: Scalars["UUID"]["input"]
  last?: InputMaybe<Scalars["Int"]["input"]>
  order?: InputMaybe<Array<BasicContentSortInput>>
  preview?: Scalars["Boolean"]["input"]
  segment?: InputMaybe<Scalars["String"]["input"]>
  where?: InputMaybe<BasicContentFilterInput>
}

export type QueryContentDescendantsByIdArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  before?: InputMaybe<Scalars["String"]["input"]>
  culture?: InputMaybe<Scalars["String"]["input"]>
  fallback?: InputMaybe<Array<PropertyFallback>>
  first?: InputMaybe<Scalars["Int"]["input"]>
  id: Scalars["Int"]["input"]
  last?: InputMaybe<Scalars["Int"]["input"]>
  order?: InputMaybe<Array<BasicContentSortInput>>
  preview?: Scalars["Boolean"]["input"]
  segment?: InputMaybe<Scalars["String"]["input"]>
  where?: InputMaybe<BasicContentFilterInput>
}

export type RavKavServiceStation = IRavKavServiceStation & {
  __typename?: "RavKavServiceStation"
  /** רשימת אזורים ועמדות */
  itemsList?: Maybe<BasicBlockListModel>
  /** כותרת */
  title?: Maybe<BasicPropertyValue>
}

export type RecommendationsBlock = IRecommendationsBlock & {
  __typename?: "RecommendationsBlock"
  /** הצגת המלצות */
  showRecommendations?: Maybe<BasicContentPicker>
}

/** Modes for requesting by route */
export enum RouteMode {
  /** Cache only will only look in the content cache for the url */
  CacheOnly = "CACHE_ONLY",
  /** Cache or routing will first use the content cache to find content and then use routing. This will only find redirects if no content is found in the content cache */
  CacheOrRouting = "CACHE_OR_ROUTING",
  /** Routing will use routing to determine a route. This will also show redirects */
  Routing = "ROUTING",
  /** Routing or cache will first use routing to find content and then use the cache if none is found. This also shows redirects */
  RoutingOrCache = "ROUTING_OR_CACHE",
}

export type ServiceShortcuts = IServiceShortcuts & {
  __typename?: "ServiceShortcuts"
  /** רשימת שירותים */
  itemsList?: Maybe<BasicBlockListModel>
}

export type ServiceShortcutsItem = IServiceShortcutsItem & {
  __typename?: "ServiceShortcutsItem"
  /**
   * אייקון SVG\PNG
   * width: 56px;
   * height: 56px;
   */
  icon?: Maybe<MintMediaPicker>
  /** קישור */
  link?: Maybe<BasicMultiUrlPicker>
}

export type ServiceStationItem = IServiceStationItem & {
  __typename?: "ServiceStationItem"
  /** איקון לצד טקסט נגישות - SVG/PNG */
  accessibleIcon?: Maybe<MintMediaPicker>
  /** טקסט נגישות */
  accessibleText?: Maybe<BasicPropertyValue>
  /** כתובת וקישור */
  addressLink?: Maybe<BasicMultiUrlPicker>
  /** רשימת רכיבי שעות פעילות */
  itemsList?: Maybe<BasicBlockListModel>
  /**
   * איקון לצד כותרת מיקום - SVG/PNG
   * 20X20
   */
  loacationIcon?: Maybe<MintMediaPicker>
  /** כותרת מיקום */
  locationTitle?: Maybe<BasicPropertyValue>
  /** כותרת */
  title?: Maybe<BasicPropertyValue>
}

export type ServiceStationTabs = IServiceStationTabs & {
  __typename?: "ServiceStationTabs"
  /**
   * ID לטאב
   * יש להזין ID באנגלית, ללא רווחים וללא תווים
   */
  encorID?: Maybe<BasicPropertyValue>
  /** רשימת רכיבי עמדות רב קו */
  itemsList?: Maybe<BasicBlockListModel>
  /** שם הטאב */
  tab?: Maybe<BasicPropertyValue>
}

export type SocialBlock = ISocialBlock & {
  __typename?: "SocialBlock"
  /** רשימת רכיבי סושיאל */
  itemsList?: Maybe<BasicBlockListModel>
  /** כותרת */
  title?: Maybe<BasicPropertyValue>
}

export type SocialMedia = ISocialMedia & {
  __typename?: "SocialMedia"
  /**
   * אייקון PNG\SVG
   * width: 24px;
   * height: 24px;
   */
  icon?: Maybe<MintMediaPicker>
  /**
   * איקון למצב הובר
   *  PNG\SVG
   * width: 24px;
   * height: 24px;
   */
  iconHover?: Maybe<MintMediaPicker>
  /** קישור */
  link?: Maybe<BasicMultiUrlPicker>
}

export enum SortEnumType {
  Asc = "ASC",
  Desc = "DESC",
}

export type Statistics = IStatistics & {
  __typename?: "Statistics"
  /** רשימת רכיבים */
  itemsList?: Maybe<BasicBlockListModel>
}

export type StatisticsSectionItem = IStatisticsSectionItem & {
  __typename?: "StatisticsSectionItem"
  /** תווית למספר */
  label?: Maybe<BasicPropertyValue>
  /** מספר סטטיסטי */
  number?: Maybe<BasicPropertyValue>
}

export type StatusLost = IStatusLost & {
  __typename?: "StatusLost"
  /** בוקסות התקשרות */
  contactBoxs?: Maybe<BasicBlockListModel>
  /** כותרת לטופס */
  formTitle?: Maybe<BasicPropertyValue>
  /** כותרת לטאב */
  tabTitle?: Maybe<BasicPropertyValue>
  /**
   * אייקון לטיפ PNG\SVG
   * width: 32;
   * height: 32;
   */
  tipIcon?: Maybe<MintMediaPicker>
  /** טקסט - טיפ */
  tipText?: Maybe<BasicRichText>
}

export type StringOperationFilterInput = {
  and?: InputMaybe<Array<StringOperationFilterInput>>
  contains?: InputMaybe<Scalars["String"]["input"]>
  endsWith?: InputMaybe<Scalars["String"]["input"]>
  eq?: InputMaybe<Scalars["String"]["input"]>
  in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  ncontains?: InputMaybe<Scalars["String"]["input"]>
  nendsWith?: InputMaybe<Scalars["String"]["input"]>
  neq?: InputMaybe<Scalars["String"]["input"]>
  nin?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  nstartsWith?: InputMaybe<Scalars["String"]["input"]>
  or?: InputMaybe<Array<StringOperationFilterInput>>
  startsWith?: InputMaybe<Scalars["String"]["input"]>
}

export type TabsContent = ITabsContent & {
  __typename?: "TabsContent"
  /** רשימת רכיבים */
  itemsList?: Maybe<BasicBlockListModel>
}

export type TabsContent1 = ITabsContent1 & {
  __typename?: "TabsContent1"
  /** רשימת רכיבים */
  itemsList?: Maybe<BasicBlockListModel>
}

export type TabsContentItem = ITabsContentItem & {
  __typename?: "TabsContentItem"
  /** רכיבי תוכן */
  itemsList?: Maybe<BasicBlockListModel>
  /** שם הטאב */
  tab?: Maybe<BasicPropertyValue>
}

export type TabsContentItem1 = ITabsContentItem1 & {
  __typename?: "TabsContentItem1"
  /** שם לעוגן - באנגלית */
  anchorName?: Maybe<BasicPropertyValue>
  /** רכיבי תוכן */
  itemsList?: Maybe<BasicBlockListModel>
}

export type Team = ITeam & {
  __typename?: "Team"
  /** רשימת קטגוריות */
  itemsList?: Maybe<BasicBlockListModel>
  /** תוכן עמודת חזון */
  visionTab?: Maybe<BasicBlockListModel>
}

export type TeamCategory = ITeamCategory & {
  __typename?: "TeamCategory"
  /** שם הקטגוריה */
  categoryName?: Maybe<BasicPropertyValue>
  /** רשימת אנשי הצוות */
  teamList?: Maybe<BasicBlockListModel>
}

export type TeamItem = ITeamItem & {
  __typename?: "TeamItem"
  /** קישור ללינקדאין */
  linkedinLink?: Maybe<BasicMultiUrlPicker>
  /** תאור איש הצוות */
  teamDescription?: Maybe<BasicRichText>
  /**
   * תמונה ראשי- JPG/ PNG
   * with:352px; height:336px;
   */
  teamMainImage?: Maybe<MintMediaPicker>
  /** שם איש הצוות */
  teamName?: Maybe<BasicPropertyValue>
  /** תפקיד איש הצוות */
  teamRole?: Maybe<BasicPropertyValue>
  /**
   * תמונה מוקטנת - PNG/JPG
   * 84X84
   */
  teamThumbnailImage?: Maybe<MintMediaPicker>
}

export type Timeline = ITimeline & {
  __typename?: "Timeline"
  /** כפתור */
  button?: Maybe<BasicMultiUrlPicker>
  /** בחר רכיבי הסטוריה להצגה בדף הבית */
  selectItemToShow?: Maybe<BasicContentPicker>
  /** כותרת */
  title?: Maybe<BasicPropertyValue>
}

export type TimelineItem = ITimelineItem & {
  __typename?: "TimelineItem"
  /** כפתור - אופציונלי */
  button?: Maybe<BasicMultiUrlPicker>
  /**
   * תמונה לדסקטופ PNG\JPG
   * with:184px; height:173
   */
  desktopImage?: Maybe<MintMediaPicker>
  /**
   * תמונה למובייל PNG\JPG
   * with:136px; height:135
   */
  mobileImage?: Maybe<MintMediaPicker>
  /** תיאור */
  subtitle?: Maybe<BasicPropertyValue>
  /** כותרת - שנה */
  title?: Maybe<BasicPropertyValue>
}

export type TitleTextAndMediaBlock = ITitleTextAndMediaBlock & {
  __typename?: "TitleTextAndMediaBlock"
  /** תוכן */
  content?: Maybe<BasicRichText>
  /**
   * מדיה- תמונה או קישור ליוטיוב
   * 800X400
   */
  media?: Maybe<BasicMultiUrlPicker>
  /** כותרת משנית */
  subTitle?: Maybe<BasicPropertyValue>
}

/** תבנית להקמת עמוד עדכוני תנועה */
export type TrafficUpdatePage = IPageInfoBlock &
  ITrafficUpdatePage & {
    __typename?: "TrafficUpdatePage"
    /** יש להגדיר כתובת מלאה כולל דומיין */
    canonicalUrl?: Maybe<BasicPropertyValue>
    /** רכיבי כותרת וטקסט */
    itemsList?: Maybe<BasicBlockListModel>
    jsonPdSchema?: Maybe<BasicPropertyValue>
    /** תגית מטא עבור תיאור העמוד (SEO) */
    metaDescription?: Maybe<BasicPropertyValue>
    /** תגית מטא עבור כותרת העמוד (SEO) */
    metaTitle?: Maybe<BasicPropertyValue>
    /** תמונה שתופיע בשיתוף העמוד */
    ogImageSHARE?: Maybe<MintMediaPicker>
    /** לצורך מיפוי כתובות אתר ישנות לעמוד זה. נא לציין כתובת יחסית ללא דומיין כותת סלאש ראשון בהתחלה */
    oldUrls?: Maybe<BasicMultiUrlPicker>
    robotsTxt?: Maybe<BasicPropertyValue>
    /** שם העמוד גם עבור Breadcrumbs */
    titleBreadcrumbs?: Maybe<BasicPropertyValue>
    /** עדכון התנועה */
    trafficUpdate?: Maybe<BasicBlockListModel>
  }

export type TrafficUpdates = ITrafficUpdates & {
  __typename?: "TrafficUpdates"
  /** כפתור - עד 50 תווים */
  button?: Maybe<BasicMultiUrlPicker>
  /**
   * קישור - לכל העדכונים
   * עד 50 תווים
   */
  link?: Maybe<BasicMultiUrlPicker>
  /** תת כותרת */
  subtitle?: Maybe<BasicPropertyValue>
  /** כותרת */
  title?: Maybe<BasicPropertyValue>
}

export type TrafficUpdatesItemsList = ITrafficUpdatesItemsList & {
  __typename?: "TrafficUpdatesItemsList"
  /** רשימת עדכונים */
  itemsList?: Maybe<BasicBlockListModel>
}

export type UpdatesItem = IUpdatesItem & {
  __typename?: "UpdatesItem"
  /**
   * תיאור
   * במובייל יוצגו רק 80 התווים הראשונים, ולא יותר מ2 שורות.
   */
  description?: Maybe<BasicPropertyValue>
  /** תאריך ושעת סיום */
  endDate?: Maybe<BasicDateTimePicker>
  /** רשימת קווים שמושפעים מהשינוי */
  linesList?: Maybe<BasicBlockListModel>
  /** תאריך ושעת התחלה */
  startDate?: Maybe<BasicDateTimePicker>
  /** סיבת העדכון */
  updateReason?: Maybe<BasicPropertyValue>
}

export type UuidOperationFilterInput = {
  eq?: InputMaybe<Scalars["UUID"]["input"]>
  gt?: InputMaybe<Scalars["UUID"]["input"]>
  gte?: InputMaybe<Scalars["UUID"]["input"]>
  in?: InputMaybe<Array<InputMaybe<Scalars["UUID"]["input"]>>>
  lt?: InputMaybe<Scalars["UUID"]["input"]>
  lte?: InputMaybe<Scalars["UUID"]["input"]>
  neq?: InputMaybe<Scalars["UUID"]["input"]>
  ngt?: InputMaybe<Scalars["UUID"]["input"]>
  ngte?: InputMaybe<Scalars["UUID"]["input"]>
  nin?: InputMaybe<Array<InputMaybe<Scalars["UUID"]["input"]>>>
  nlt?: InputMaybe<Scalars["UUID"]["input"]>
  nlte?: InputMaybe<Scalars["UUID"]["input"]>
}

export type VisionTab = IVisionTab & {
  __typename?: "VisionTab"
  /** תוכן האזור */
  content?: Maybe<BasicBlockListModel>
  /** שם הטאב */
  tabName?: Maybe<BasicPropertyValue>
}

export type GetArticlesQueryVariables = Exact<{
  culture?: InputMaybe<Scalars["String"]["input"]>
  route: Scalars["String"]["input"]
}>

export type GetArticlesQuery = {
  __typename?: "Query"
  projects?: {
    __typename?: "ContentDescendantsByAbsoluteRouteConnection"
    nodes?: Array<{
      __typename?: "BasicContent"
      id?: number | null
      url?: string | null
      contentType?: {
        __typename?: "BasicContentType"
        alias?: string | null
      } | null
      parent?: {
        __typename?: "BasicContent"
        url?: string | null
        namedProperties:
          | { __typename?: "AdynamicTitleAndContant" }
          | { __typename?: "AnchorMenu" }
          | { __typename?: "AnchorMenuItems" }
          | { __typename?: "Article" }
          | {
              __typename?: "ArticlesCategory"
              articlesCategoryName?: {
                __typename?: "BasicPropertyValue"
                value?: any | null
              } | null
            }
          | { __typename?: "ArticlesLobby" }
          | { __typename?: "BannerModule" }
          | { __typename?: "BasicBannerModule" }
          | { __typename?: "ButtonComponent" }
          | { __typename?: "ContactUs" }
          | { __typename?: "ContactUsBox" }
          | { __typename?: "ContactUsBoxItem" }
          | { __typename?: "ContactUsBoxWithText" }
          | { __typename?: "ContactUsDesktop" }
          | { __typename?: "ContactUsInfoItem" }
          | { __typename?: "ContactUsItem" }
          | { __typename?: "ContactUsMobile" }
          | { __typename?: "ContentMenuItem" }
          | { __typename?: "ContentPage" }
          | { __typename?: "CustomMenuItem" }
          | { __typename?: "DynamicBlockList" }
          | { __typename?: "EmployeeRecommendations" }
          | { __typename?: "EmployeeRecommendationsItem" }
          | { __typename?: "EmptyINamedContentProperties" }
          | { __typename?: "FAQ" }
          | { __typename?: "FAQItem" }
          | { __typename?: "FinePayment" }
          | { __typename?: "FinePaymentSteps" }
          | { __typename?: "Footer" }
          | { __typename?: "FooterCategories" }
          | { __typename?: "FreeContentPage" }
          | { __typename?: "HeaderCategories" }
          | { __typename?: "HeaderDesktop" }
          | { __typename?: "HeaderMobile" }
          | { __typename?: "HeroBanner" }
          | { __typename?: "HeroBannerHomePage" }
          | { __typename?: "HistoryItem" }
          | { __typename?: "HomePage" }
          | { __typename?: "Information" }
          | { __typename?: "InformationForPassangers" }
          | { __typename?: "InquiriesAndRequests" }
          | { __typename?: "LinesItem" }
          | { __typename?: "LinkItem" }
          | { __typename?: "LogoComponent" }
          | { __typename?: "MainTitleBlock" }
          | { __typename?: "MultyURLsTitleAndText" }
          | { __typename?: "NumericItem" }
          | { __typename?: "OpeningTimeItem" }
          | { __typename?: "OperatingHoursContactInfo" }
          | { __typename?: "OperatingHoursContactInfoItem" }
          | { __typename?: "PageInfoBlock" }
          | { __typename?: "PaymentMethod" }
          | { __typename?: "PaymentMethodItem" }
          | { __typename?: "PaymentMethodsInPublicTransport" }
          | { __typename?: "PowerNumbers" }
          | { __typename?: "PowerNumbersItem" }
          | { __typename?: "RavKavServiceStation" }
          | { __typename?: "RecommendationsBlock" }
          | { __typename?: "ServiceShortcuts" }
          | { __typename?: "ServiceShortcutsItem" }
          | { __typename?: "ServiceStationItem" }
          | { __typename?: "ServiceStationTabs" }
          | { __typename?: "SocialBlock" }
          | { __typename?: "SocialMedia" }
          | { __typename?: "Statistics" }
          | { __typename?: "StatisticsSectionItem" }
          | { __typename?: "StatusLost" }
          | { __typename?: "TabsContent" }
          | { __typename?: "TabsContent1" }
          | { __typename?: "TabsContentItem" }
          | { __typename?: "TabsContentItem1" }
          | { __typename?: "Team" }
          | { __typename?: "TeamCategory" }
          | { __typename?: "TeamItem" }
          | { __typename?: "Timeline" }
          | { __typename?: "TimelineItem" }
          | { __typename?: "TitleTextAndMediaBlock" }
          | { __typename?: "TrafficUpdatePage" }
          | { __typename?: "TrafficUpdates" }
          | { __typename?: "TrafficUpdatesItemsList" }
          | { __typename?: "UpdatesItem" }
          | { __typename?: "VisionTab" }
      } | null
      namedProperties:
        | { __typename?: "AdynamicTitleAndContant" }
        | { __typename?: "AnchorMenu" }
        | { __typename?: "AnchorMenuItems" }
        | {
            __typename?: "Article"
            articleTitle?: {
              __typename?: "BasicPropertyValue"
              value?: any | null
            } | null
            articleShortDescription?: {
              __typename?: "BasicPropertyValue"
              value?: any | null
            } | null
            thumbnailImage?: {
              __typename?: "MintMediaPicker"
              mediaItems: Array<{
                __typename?: "MintMediaPickerItem"
                url: string
              }>
            } | null
            articleDate?: {
              __typename?: "BasicDateTimePicker"
              value?: any | null
            } | null
          }
        | { __typename?: "ArticlesCategory" }
        | { __typename?: "ArticlesLobby" }
        | { __typename?: "BannerModule" }
        | { __typename?: "BasicBannerModule" }
        | { __typename?: "ButtonComponent" }
        | { __typename?: "ContactUs" }
        | { __typename?: "ContactUsBox" }
        | { __typename?: "ContactUsBoxItem" }
        | { __typename?: "ContactUsBoxWithText" }
        | { __typename?: "ContactUsDesktop" }
        | { __typename?: "ContactUsInfoItem" }
        | { __typename?: "ContactUsItem" }
        | { __typename?: "ContactUsMobile" }
        | { __typename?: "ContentMenuItem" }
        | { __typename?: "ContentPage" }
        | { __typename?: "CustomMenuItem" }
        | { __typename?: "DynamicBlockList" }
        | { __typename?: "EmployeeRecommendations" }
        | { __typename?: "EmployeeRecommendationsItem" }
        | { __typename?: "EmptyINamedContentProperties" }
        | { __typename?: "FAQ" }
        | { __typename?: "FAQItem" }
        | { __typename?: "FinePayment" }
        | { __typename?: "FinePaymentSteps" }
        | { __typename?: "Footer" }
        | { __typename?: "FooterCategories" }
        | { __typename?: "FreeContentPage" }
        | { __typename?: "HeaderCategories" }
        | { __typename?: "HeaderDesktop" }
        | { __typename?: "HeaderMobile" }
        | { __typename?: "HeroBanner" }
        | { __typename?: "HeroBannerHomePage" }
        | { __typename?: "HistoryItem" }
        | { __typename?: "HomePage" }
        | { __typename?: "Information" }
        | { __typename?: "InformationForPassangers" }
        | { __typename?: "InquiriesAndRequests" }
        | { __typename?: "LinesItem" }
        | { __typename?: "LinkItem" }
        | { __typename?: "LogoComponent" }
        | { __typename?: "MainTitleBlock" }
        | { __typename?: "MultyURLsTitleAndText" }
        | { __typename?: "NumericItem" }
        | { __typename?: "OpeningTimeItem" }
        | { __typename?: "OperatingHoursContactInfo" }
        | { __typename?: "OperatingHoursContactInfoItem" }
        | { __typename?: "PageInfoBlock" }
        | { __typename?: "PaymentMethod" }
        | { __typename?: "PaymentMethodItem" }
        | { __typename?: "PaymentMethodsInPublicTransport" }
        | { __typename?: "PowerNumbers" }
        | { __typename?: "PowerNumbersItem" }
        | { __typename?: "RavKavServiceStation" }
        | { __typename?: "RecommendationsBlock" }
        | { __typename?: "ServiceShortcuts" }
        | { __typename?: "ServiceShortcutsItem" }
        | { __typename?: "ServiceStationItem" }
        | { __typename?: "ServiceStationTabs" }
        | { __typename?: "SocialBlock" }
        | { __typename?: "SocialMedia" }
        | { __typename?: "Statistics" }
        | { __typename?: "StatisticsSectionItem" }
        | { __typename?: "StatusLost" }
        | { __typename?: "TabsContent" }
        | { __typename?: "TabsContent1" }
        | { __typename?: "TabsContentItem" }
        | { __typename?: "TabsContentItem1" }
        | { __typename?: "Team" }
        | { __typename?: "TeamCategory" }
        | { __typename?: "TeamItem" }
        | { __typename?: "Timeline" }
        | { __typename?: "TimelineItem" }
        | { __typename?: "TitleTextAndMediaBlock" }
        | { __typename?: "TrafficUpdatePage" }
        | { __typename?: "TrafficUpdates" }
        | { __typename?: "TrafficUpdatesItemsList" }
        | { __typename?: "UpdatesItem" }
        | { __typename?: "VisionTab" }
    } | null> | null
  } | null
}

export type GetComponentQueryVariables = Exact<{
  route: Scalars["String"]["input"]
  culture: Scalars["String"]["input"]
}>

export type GetComponentQuery = {
  __typename?: "Query"
  components?: {
    __typename?: "ContentDescendantsByAbsoluteRouteConnection"
    edges?: Array<{
      __typename?: "ContentDescendantsByAbsoluteRouteEdge"
      cursor: string
      node?: {
        __typename?: "BasicContent"
        name?: string | null
        id?: number | null
        url?: string | null
        absoluteUrl?: string | null
        contentType?: {
          __typename?: "BasicContentType"
          alias?: string | null
        } | null
        children?: Array<{
          __typename?: "BasicContent"
          id?: number | null
          contentType?: {
            __typename?: "BasicContentType"
            alias?: string | null
          } | null
        } | null> | null
        parent?: {
          __typename?: "BasicContent"
          name?: string | null
          level?: number | null
          parent?: {
            __typename?: "BasicContent"
            level?: number | null
            name?: string | null
            parent?: {
              __typename?: "BasicContent"
              level?: number | null
              name?: string | null
              parent?: {
                __typename?: "BasicContent"
                level?: number | null
                name?: string | null
                parent?: {
                  __typename?: "BasicContent"
                  level?: number | null
                  name?: string | null
                  parent?: {
                    __typename?: "BasicContent"
                    name?: string | null
                    level?: number | null
                  } | null
                } | null
              } | null
            } | null
          } | null
        } | null
        properties?: Array<{
          __typename?: "BasicProperty"
          propertyName?: string | null
          propertyValue?:
            | {
                __typename?: "BasicBlockGridModel"
                gridColumns?: number | null
                valueType: string
                blocks?: Array<{
                  __typename?: "BasicBlockGridItem"
                  columnSpan: number
                  rowSpan: number
                  contentProperties: Array<{
                    __typename?: "BasicProperty"
                    value?:
                      | {
                          __typename?: "BasicBlockGridModel"
                          valueType: string
                        }
                      | {
                          __typename?: "BasicBlockListModel"
                          valueType: string
                        }
                      | {
                          __typename?: "BasicContentPicker"
                          valueType: string
                          contentList: Array<{
                            __typename?: "BasicContentPickerItem"
                            id: number
                            absoluteUrl: string
                            key: any
                            name?: string | null
                            url: string
                            urlSegment?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicDateTimePicker"
                          valueType: string
                          dateTime?: any | null
                        }
                      | {
                          __typename?: "BasicLabel"
                          valueType: string
                          label?: any | null
                        }
                      | { __typename?: "BasicMediaPicker"; valueType: string }
                      | {
                          __typename?: "BasicMemberPicker"
                          valueType: string
                          members: Array<{
                            __typename?: "BasicMemberPickerItem"
                            id?: number | null
                            name?: string | null
                            properties: Array<{
                              __typename?: "BasicProperty"
                              alias?: string | null
                              editorAlias?: string | null
                              value?:
                                | {
                                    __typename?: "BasicBlockGridModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicBlockListModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicContentPicker"
                                    model: string
                                    contentList: Array<{
                                      __typename?: "BasicContentPickerItem"
                                      id: number
                                      absoluteUrl: string
                                      key: any
                                      name?: string | null
                                      url: string
                                      urlSegment?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicDateTimePicker"
                                    model: string
                                    dateTime?: any | null
                                  }
                                | {
                                    __typename?: "BasicLabel"
                                    model: string
                                    label?: any | null
                                  }
                                | {
                                    __typename?: "BasicMediaPicker"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicMemberPicker"
                                    model: string
                                    members: Array<{
                                      __typename?: "BasicMemberPickerItem"
                                      id?: number | null
                                      name?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicMultiUrlPicker"
                                    model: string
                                    links: Array<{
                                      __typename?: "BasicMultiUrlPickerItem"
                                      name?: string | null
                                      target?: string | null
                                      type: LinkType
                                      url?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicNestedContent"
                                    model: string
                                    elements?: Array<{
                                      __typename?: "BasicNestedContentElement"
                                      properties: Array<{
                                        __typename?: "BasicProperty"
                                        alias?: string | null
                                        editorAlias?: string | null
                                        value?:
                                          | {
                                              __typename?: "BasicBlockGridModel"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicBlockListModel"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicContentPicker"
                                              model: string
                                              contentList: Array<{
                                                __typename?: "BasicContentPickerItem"
                                                id: number
                                                absoluteUrl: string
                                                key: any
                                                name?: string | null
                                                url: string
                                                urlSegment?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicDateTimePicker"
                                              model: string
                                              dateTime?: any | null
                                            }
                                          | {
                                              __typename?: "BasicLabel"
                                              model: string
                                              label?: any | null
                                            }
                                          | {
                                              __typename?: "BasicMediaPicker"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicMemberPicker"
                                              model: string
                                              members: Array<{
                                                __typename?: "BasicMemberPickerItem"
                                                id?: number | null
                                                name?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicMultiUrlPicker"
                                              model: string
                                              links: Array<{
                                                __typename?: "BasicMultiUrlPickerItem"
                                                name?: string | null
                                                target?: string | null
                                                type: LinkType
                                                url?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicNestedContent"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicPropertyValue"
                                              model: string
                                              value?: any | null
                                            }
                                          | {
                                              __typename?: "BasicRichText"
                                              model: string
                                              sourceValue?: string | null
                                              richText?: string | null
                                            }
                                          | {
                                              __typename?: "BasicUnsupportedPropertyValue"
                                              model: string
                                              message: string
                                            }
                                          | {
                                              __typename?: "MintMediaPicker"
                                              model: string
                                              mediaItems: Array<{
                                                __typename?: "MintMediaPickerItem"
                                                id: number
                                                url: string
                                                altText?: string | null
                                              }>
                                            }
                                          | null
                                      } | null>
                                    }> | null
                                  }
                                | {
                                    __typename?: "BasicPropertyValue"
                                    model: string
                                    value?: any | null
                                  }
                                | {
                                    __typename?: "BasicRichText"
                                    model: string
                                    sourceValue?: string | null
                                    richText?: string | null
                                  }
                                | {
                                    __typename?: "BasicUnsupportedPropertyValue"
                                    model: string
                                    message: string
                                  }
                                | {
                                    __typename?: "MintMediaPicker"
                                    model: string
                                    mediaItems: Array<{
                                      __typename?: "MintMediaPickerItem"
                                      id: number
                                      url: string
                                      altText?: string | null
                                    }>
                                  }
                                | null
                            } | null>
                          }>
                        }
                      | {
                          __typename?: "BasicMultiUrlPicker"
                          valueType: string
                          links: Array<{
                            __typename?: "BasicMultiUrlPickerItem"
                            name?: string | null
                            target?: string | null
                            type: LinkType
                            url?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicNestedContent"
                          valueType: string
                          elements?: Array<{
                            __typename?: "BasicNestedContentElement"
                            properties: Array<{
                              __typename?: "BasicProperty"
                              alias?: string | null
                              editorAlias?: string | null
                              value?:
                                | {
                                    __typename?: "BasicBlockGridModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicBlockListModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicContentPicker"
                                    model: string
                                    contentList: Array<{
                                      __typename?: "BasicContentPickerItem"
                                      id: number
                                      absoluteUrl: string
                                      key: any
                                      name?: string | null
                                      url: string
                                      urlSegment?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicDateTimePicker"
                                    model: string
                                    dateTime?: any | null
                                  }
                                | {
                                    __typename?: "BasicLabel"
                                    model: string
                                    label?: any | null
                                  }
                                | {
                                    __typename?: "BasicMediaPicker"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicMemberPicker"
                                    model: string
                                    members: Array<{
                                      __typename?: "BasicMemberPickerItem"
                                      id?: number | null
                                      name?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicMultiUrlPicker"
                                    model: string
                                    links: Array<{
                                      __typename?: "BasicMultiUrlPickerItem"
                                      name?: string | null
                                      target?: string | null
                                      type: LinkType
                                      url?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicNestedContent"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicPropertyValue"
                                    model: string
                                    value?: any | null
                                  }
                                | {
                                    __typename?: "BasicRichText"
                                    model: string
                                    sourceValue?: string | null
                                    richText?: string | null
                                  }
                                | {
                                    __typename?: "BasicUnsupportedPropertyValue"
                                    model: string
                                    message: string
                                  }
                                | {
                                    __typename?: "MintMediaPicker"
                                    model: string
                                    mediaItems: Array<{
                                      __typename?: "MintMediaPickerItem"
                                      id: number
                                      url: string
                                      altText?: string | null
                                    }>
                                  }
                                | null
                            } | null>
                          }> | null
                        }
                      | {
                          __typename?: "BasicPropertyValue"
                          valueType: string
                          value?: any | null
                        }
                      | {
                          __typename?: "BasicRichText"
                          sourceValue?: string | null
                          valueType: string
                          richText?: string | null
                        }
                      | {
                          __typename?: "BasicUnsupportedPropertyValue"
                          message: string
                          valueType: string
                        }
                      | {
                          __typename?: "MintMediaPicker"
                          valueType: string
                          mediaItems: Array<{
                            __typename?: "MintMediaPickerItem"
                            id: number
                            url: string
                            altText?: string | null
                          }>
                        }
                      | null
                  } | null>
                  settingsProperties: Array<{
                    __typename?: "BasicProperty"
                    value?:
                      | {
                          __typename?: "BasicBlockGridModel"
                          valueType: string
                        }
                      | {
                          __typename?: "BasicBlockListModel"
                          valueType: string
                        }
                      | {
                          __typename?: "BasicContentPicker"
                          valueType: string
                          contentList: Array<{
                            __typename?: "BasicContentPickerItem"
                            id: number
                            absoluteUrl: string
                            key: any
                            name?: string | null
                            url: string
                            urlSegment?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicDateTimePicker"
                          valueType: string
                          dateTime?: any | null
                        }
                      | {
                          __typename?: "BasicLabel"
                          valueType: string
                          label?: any | null
                        }
                      | { __typename?: "BasicMediaPicker"; valueType: string }
                      | {
                          __typename?: "BasicMemberPicker"
                          valueType: string
                          members: Array<{
                            __typename?: "BasicMemberPickerItem"
                            id?: number | null
                            name?: string | null
                            properties: Array<{
                              __typename?: "BasicProperty"
                              alias?: string | null
                              editorAlias?: string | null
                              value?:
                                | {
                                    __typename?: "BasicBlockGridModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicBlockListModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicContentPicker"
                                    model: string
                                    contentList: Array<{
                                      __typename?: "BasicContentPickerItem"
                                      id: number
                                      absoluteUrl: string
                                      key: any
                                      name?: string | null
                                      url: string
                                      urlSegment?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicDateTimePicker"
                                    model: string
                                    dateTime?: any | null
                                  }
                                | {
                                    __typename?: "BasicLabel"
                                    model: string
                                    label?: any | null
                                  }
                                | {
                                    __typename?: "BasicMediaPicker"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicMemberPicker"
                                    model: string
                                    members: Array<{
                                      __typename?: "BasicMemberPickerItem"
                                      id?: number | null
                                      name?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicMultiUrlPicker"
                                    model: string
                                    links: Array<{
                                      __typename?: "BasicMultiUrlPickerItem"
                                      name?: string | null
                                      target?: string | null
                                      type: LinkType
                                      url?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicNestedContent"
                                    model: string
                                    elements?: Array<{
                                      __typename?: "BasicNestedContentElement"
                                      properties: Array<{
                                        __typename?: "BasicProperty"
                                        alias?: string | null
                                        editorAlias?: string | null
                                        value?:
                                          | {
                                              __typename?: "BasicBlockGridModel"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicBlockListModel"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicContentPicker"
                                              model: string
                                              contentList: Array<{
                                                __typename?: "BasicContentPickerItem"
                                                id: number
                                                absoluteUrl: string
                                                key: any
                                                name?: string | null
                                                url: string
                                                urlSegment?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicDateTimePicker"
                                              model: string
                                              dateTime?: any | null
                                            }
                                          | {
                                              __typename?: "BasicLabel"
                                              model: string
                                              label?: any | null
                                            }
                                          | {
                                              __typename?: "BasicMediaPicker"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicMemberPicker"
                                              model: string
                                              members: Array<{
                                                __typename?: "BasicMemberPickerItem"
                                                id?: number | null
                                                name?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicMultiUrlPicker"
                                              model: string
                                              links: Array<{
                                                __typename?: "BasicMultiUrlPickerItem"
                                                name?: string | null
                                                target?: string | null
                                                type: LinkType
                                                url?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicNestedContent"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicPropertyValue"
                                              model: string
                                              value?: any | null
                                            }
                                          | {
                                              __typename?: "BasicRichText"
                                              model: string
                                              sourceValue?: string | null
                                              richText?: string | null
                                            }
                                          | {
                                              __typename?: "BasicUnsupportedPropertyValue"
                                              model: string
                                              message: string
                                            }
                                          | {
                                              __typename?: "MintMediaPicker"
                                              model: string
                                              mediaItems: Array<{
                                                __typename?: "MintMediaPickerItem"
                                                id: number
                                                url: string
                                                altText?: string | null
                                              }>
                                            }
                                          | null
                                      } | null>
                                    }> | null
                                  }
                                | {
                                    __typename?: "BasicPropertyValue"
                                    model: string
                                    value?: any | null
                                  }
                                | {
                                    __typename?: "BasicRichText"
                                    model: string
                                    sourceValue?: string | null
                                    richText?: string | null
                                  }
                                | {
                                    __typename?: "BasicUnsupportedPropertyValue"
                                    model: string
                                    message: string
                                  }
                                | {
                                    __typename?: "MintMediaPicker"
                                    model: string
                                    mediaItems: Array<{
                                      __typename?: "MintMediaPickerItem"
                                      id: number
                                      url: string
                                      altText?: string | null
                                    }>
                                  }
                                | null
                            } | null>
                          }>
                        }
                      | {
                          __typename?: "BasicMultiUrlPicker"
                          valueType: string
                          links: Array<{
                            __typename?: "BasicMultiUrlPickerItem"
                            name?: string | null
                            target?: string | null
                            type: LinkType
                            url?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicNestedContent"
                          valueType: string
                          elements?: Array<{
                            __typename?: "BasicNestedContentElement"
                            properties: Array<{
                              __typename?: "BasicProperty"
                              alias?: string | null
                              editorAlias?: string | null
                              value?:
                                | {
                                    __typename?: "BasicBlockGridModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicBlockListModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicContentPicker"
                                    model: string
                                    contentList: Array<{
                                      __typename?: "BasicContentPickerItem"
                                      id: number
                                      absoluteUrl: string
                                      key: any
                                      name?: string | null
                                      url: string
                                      urlSegment?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicDateTimePicker"
                                    model: string
                                    dateTime?: any | null
                                  }
                                | {
                                    __typename?: "BasicLabel"
                                    model: string
                                    label?: any | null
                                  }
                                | {
                                    __typename?: "BasicMediaPicker"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicMemberPicker"
                                    model: string
                                    members: Array<{
                                      __typename?: "BasicMemberPickerItem"
                                      id?: number | null
                                      name?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicMultiUrlPicker"
                                    model: string
                                    links: Array<{
                                      __typename?: "BasicMultiUrlPickerItem"
                                      name?: string | null
                                      target?: string | null
                                      type: LinkType
                                      url?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicNestedContent"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicPropertyValue"
                                    model: string
                                    value?: any | null
                                  }
                                | {
                                    __typename?: "BasicRichText"
                                    model: string
                                    sourceValue?: string | null
                                    richText?: string | null
                                  }
                                | {
                                    __typename?: "BasicUnsupportedPropertyValue"
                                    model: string
                                    message: string
                                  }
                                | {
                                    __typename?: "MintMediaPicker"
                                    model: string
                                    mediaItems: Array<{
                                      __typename?: "MintMediaPickerItem"
                                      id: number
                                      url: string
                                      altText?: string | null
                                    }>
                                  }
                                | null
                            } | null>
                          }> | null
                        }
                      | {
                          __typename?: "BasicPropertyValue"
                          valueType: string
                          value?: any | null
                        }
                      | {
                          __typename?: "BasicRichText"
                          sourceValue?: string | null
                          valueType: string
                          richText?: string | null
                        }
                      | {
                          __typename?: "BasicUnsupportedPropertyValue"
                          message: string
                          valueType: string
                        }
                      | {
                          __typename?: "MintMediaPicker"
                          valueType: string
                          mediaItems: Array<{
                            __typename?: "MintMediaPickerItem"
                            id: number
                            url: string
                            altText?: string | null
                          }>
                        }
                      | null
                  } | null>
                  areas: Array<{
                    __typename?: "BasicBlockGridArea"
                    alias?: string | null
                    rowSpan: number
                    columnSpan: number
                    blocks?: Array<{
                      __typename?: "BasicBlockGridItem"
                      columnSpan: number
                      rowSpan: number
                      contentProperties: Array<{
                        __typename?: "BasicProperty"
                        value?:
                          | {
                              __typename?: "BasicBlockGridModel"
                              valueType: string
                            }
                          | {
                              __typename?: "BasicBlockListModel"
                              valueType: string
                            }
                          | {
                              __typename?: "BasicContentPicker"
                              valueType: string
                              contentList: Array<{
                                __typename?: "BasicContentPickerItem"
                                id: number
                                absoluteUrl: string
                                key: any
                                name?: string | null
                                url: string
                                urlSegment?: string | null
                              }>
                            }
                          | {
                              __typename?: "BasicDateTimePicker"
                              valueType: string
                              dateTime?: any | null
                            }
                          | {
                              __typename?: "BasicLabel"
                              valueType: string
                              label?: any | null
                            }
                          | {
                              __typename?: "BasicMediaPicker"
                              valueType: string
                            }
                          | {
                              __typename?: "BasicMemberPicker"
                              valueType: string
                              members: Array<{
                                __typename?: "BasicMemberPickerItem"
                                id?: number | null
                                name?: string | null
                                properties: Array<{
                                  __typename?: "BasicProperty"
                                  alias?: string | null
                                  editorAlias?: string | null
                                  value?:
                                    | {
                                        __typename?: "BasicBlockGridModel"
                                        model: string
                                      }
                                    | {
                                        __typename?: "BasicBlockListModel"
                                        model: string
                                      }
                                    | {
                                        __typename?: "BasicContentPicker"
                                        model: string
                                        contentList: Array<{
                                          __typename?: "BasicContentPickerItem"
                                          id: number
                                          absoluteUrl: string
                                          key: any
                                          name?: string | null
                                          url: string
                                          urlSegment?: string | null
                                        }>
                                      }
                                    | {
                                        __typename?: "BasicDateTimePicker"
                                        model: string
                                        dateTime?: any | null
                                      }
                                    | {
                                        __typename?: "BasicLabel"
                                        model: string
                                        label?: any | null
                                      }
                                    | {
                                        __typename?: "BasicMediaPicker"
                                        model: string
                                      }
                                    | {
                                        __typename?: "BasicMemberPicker"
                                        model: string
                                        members: Array<{
                                          __typename?: "BasicMemberPickerItem"
                                          id?: number | null
                                          name?: string | null
                                        }>
                                      }
                                    | {
                                        __typename?: "BasicMultiUrlPicker"
                                        model: string
                                        links: Array<{
                                          __typename?: "BasicMultiUrlPickerItem"
                                          name?: string | null
                                          target?: string | null
                                          type: LinkType
                                          url?: string | null
                                        }>
                                      }
                                    | {
                                        __typename?: "BasicNestedContent"
                                        model: string
                                        elements?: Array<{
                                          __typename?: "BasicNestedContentElement"
                                          properties: Array<{
                                            __typename?: "BasicProperty"
                                            alias?: string | null
                                            editorAlias?: string | null
                                            value?:
                                              | {
                                                  __typename?: "BasicBlockGridModel"
                                                  model: string
                                                }
                                              | {
                                                  __typename?: "BasicBlockListModel"
                                                  model: string
                                                }
                                              | {
                                                  __typename?: "BasicContentPicker"
                                                  model: string
                                                  contentList: Array<{
                                                    __typename?: "BasicContentPickerItem"
                                                    id: number
                                                    absoluteUrl: string
                                                    key: any
                                                    name?: string | null
                                                    url: string
                                                    urlSegment?: string | null
                                                  }>
                                                }
                                              | {
                                                  __typename?: "BasicDateTimePicker"
                                                  model: string
                                                  dateTime?: any | null
                                                }
                                              | {
                                                  __typename?: "BasicLabel"
                                                  model: string
                                                  label?: any | null
                                                }
                                              | {
                                                  __typename?: "BasicMediaPicker"
                                                  model: string
                                                }
                                              | {
                                                  __typename?: "BasicMemberPicker"
                                                  model: string
                                                  members: Array<{
                                                    __typename?: "BasicMemberPickerItem"
                                                    id?: number | null
                                                    name?: string | null
                                                  }>
                                                }
                                              | {
                                                  __typename?: "BasicMultiUrlPicker"
                                                  model: string
                                                  links: Array<{
                                                    __typename?: "BasicMultiUrlPickerItem"
                                                    name?: string | null
                                                    target?: string | null
                                                    type: LinkType
                                                    url?: string | null
                                                  }>
                                                }
                                              | {
                                                  __typename?: "BasicNestedContent"
                                                  model: string
                                                }
                                              | {
                                                  __typename?: "BasicPropertyValue"
                                                  model: string
                                                  value?: any | null
                                                }
                                              | {
                                                  __typename?: "BasicRichText"
                                                  model: string
                                                  sourceValue?: string | null
                                                  richText?: string | null
                                                }
                                              | {
                                                  __typename?: "BasicUnsupportedPropertyValue"
                                                  model: string
                                                  message: string
                                                }
                                              | {
                                                  __typename?: "MintMediaPicker"
                                                  model: string
                                                  mediaItems: Array<{
                                                    __typename?: "MintMediaPickerItem"
                                                    id: number
                                                    url: string
                                                    altText?: string | null
                                                  }>
                                                }
                                              | null
                                          } | null>
                                        }> | null
                                      }
                                    | {
                                        __typename?: "BasicPropertyValue"
                                        model: string
                                        value?: any | null
                                      }
                                    | {
                                        __typename?: "BasicRichText"
                                        model: string
                                        sourceValue?: string | null
                                        richText?: string | null
                                      }
                                    | {
                                        __typename?: "BasicUnsupportedPropertyValue"
                                        model: string
                                        message: string
                                      }
                                    | {
                                        __typename?: "MintMediaPicker"
                                        model: string
                                        mediaItems: Array<{
                                          __typename?: "MintMediaPickerItem"
                                          id: number
                                          url: string
                                          altText?: string | null
                                        }>
                                      }
                                    | null
                                } | null>
                              }>
                            }
                          | {
                              __typename?: "BasicMultiUrlPicker"
                              valueType: string
                              links: Array<{
                                __typename?: "BasicMultiUrlPickerItem"
                                name?: string | null
                                target?: string | null
                                type: LinkType
                                url?: string | null
                              }>
                            }
                          | {
                              __typename?: "BasicNestedContent"
                              valueType: string
                              elements?: Array<{
                                __typename?: "BasicNestedContentElement"
                                properties: Array<{
                                  __typename?: "BasicProperty"
                                  alias?: string | null
                                  editorAlias?: string | null
                                  value?:
                                    | {
                                        __typename?: "BasicBlockGridModel"
                                        model: string
                                      }
                                    | {
                                        __typename?: "BasicBlockListModel"
                                        model: string
                                      }
                                    | {
                                        __typename?: "BasicContentPicker"
                                        model: string
                                        contentList: Array<{
                                          __typename?: "BasicContentPickerItem"
                                          id: number
                                          absoluteUrl: string
                                          key: any
                                          name?: string | null
                                          url: string
                                          urlSegment?: string | null
                                        }>
                                      }
                                    | {
                                        __typename?: "BasicDateTimePicker"
                                        model: string
                                        dateTime?: any | null
                                      }
                                    | {
                                        __typename?: "BasicLabel"
                                        model: string
                                        label?: any | null
                                      }
                                    | {
                                        __typename?: "BasicMediaPicker"
                                        model: string
                                      }
                                    | {
                                        __typename?: "BasicMemberPicker"
                                        model: string
                                        members: Array<{
                                          __typename?: "BasicMemberPickerItem"
                                          id?: number | null
                                          name?: string | null
                                        }>
                                      }
                                    | {
                                        __typename?: "BasicMultiUrlPicker"
                                        model: string
                                        links: Array<{
                                          __typename?: "BasicMultiUrlPickerItem"
                                          name?: string | null
                                          target?: string | null
                                          type: LinkType
                                          url?: string | null
                                        }>
                                      }
                                    | {
                                        __typename?: "BasicNestedContent"
                                        model: string
                                      }
                                    | {
                                        __typename?: "BasicPropertyValue"
                                        model: string
                                        value?: any | null
                                      }
                                    | {
                                        __typename?: "BasicRichText"
                                        model: string
                                        sourceValue?: string | null
                                        richText?: string | null
                                      }
                                    | {
                                        __typename?: "BasicUnsupportedPropertyValue"
                                        model: string
                                        message: string
                                      }
                                    | {
                                        __typename?: "MintMediaPicker"
                                        model: string
                                        mediaItems: Array<{
                                          __typename?: "MintMediaPickerItem"
                                          id: number
                                          url: string
                                          altText?: string | null
                                        }>
                                      }
                                    | null
                                } | null>
                              }> | null
                            }
                          | {
                              __typename?: "BasicPropertyValue"
                              valueType: string
                              value?: any | null
                            }
                          | {
                              __typename?: "BasicRichText"
                              sourceValue?: string | null
                              valueType: string
                              richText?: string | null
                            }
                          | {
                              __typename?: "BasicUnsupportedPropertyValue"
                              message: string
                              valueType: string
                            }
                          | {
                              __typename?: "MintMediaPicker"
                              valueType: string
                              mediaItems: Array<{
                                __typename?: "MintMediaPickerItem"
                                id: number
                                url: string
                                altText?: string | null
                              }>
                            }
                          | null
                      } | null>
                      settingsProperties: Array<{
                        __typename?: "BasicProperty"
                        value?:
                          | {
                              __typename?: "BasicBlockGridModel"
                              valueType: string
                            }
                          | {
                              __typename?: "BasicBlockListModel"
                              valueType: string
                            }
                          | {
                              __typename?: "BasicContentPicker"
                              valueType: string
                              contentList: Array<{
                                __typename?: "BasicContentPickerItem"
                                id: number
                                absoluteUrl: string
                                key: any
                                name?: string | null
                                url: string
                                urlSegment?: string | null
                              }>
                            }
                          | {
                              __typename?: "BasicDateTimePicker"
                              valueType: string
                              dateTime?: any | null
                            }
                          | {
                              __typename?: "BasicLabel"
                              valueType: string
                              label?: any | null
                            }
                          | {
                              __typename?: "BasicMediaPicker"
                              valueType: string
                            }
                          | {
                              __typename?: "BasicMemberPicker"
                              valueType: string
                              members: Array<{
                                __typename?: "BasicMemberPickerItem"
                                id?: number | null
                                name?: string | null
                                properties: Array<{
                                  __typename?: "BasicProperty"
                                  alias?: string | null
                                  editorAlias?: string | null
                                  value?:
                                    | {
                                        __typename?: "BasicBlockGridModel"
                                        model: string
                                      }
                                    | {
                                        __typename?: "BasicBlockListModel"
                                        model: string
                                      }
                                    | {
                                        __typename?: "BasicContentPicker"
                                        model: string
                                        contentList: Array<{
                                          __typename?: "BasicContentPickerItem"
                                          id: number
                                          absoluteUrl: string
                                          key: any
                                          name?: string | null
                                          url: string
                                          urlSegment?: string | null
                                        }>
                                      }
                                    | {
                                        __typename?: "BasicDateTimePicker"
                                        model: string
                                        dateTime?: any | null
                                      }
                                    | {
                                        __typename?: "BasicLabel"
                                        model: string
                                        label?: any | null
                                      }
                                    | {
                                        __typename?: "BasicMediaPicker"
                                        model: string
                                      }
                                    | {
                                        __typename?: "BasicMemberPicker"
                                        model: string
                                        members: Array<{
                                          __typename?: "BasicMemberPickerItem"
                                          id?: number | null
                                          name?: string | null
                                        }>
                                      }
                                    | {
                                        __typename?: "BasicMultiUrlPicker"
                                        model: string
                                        links: Array<{
                                          __typename?: "BasicMultiUrlPickerItem"
                                          name?: string | null
                                          target?: string | null
                                          type: LinkType
                                          url?: string | null
                                        }>
                                      }
                                    | {
                                        __typename?: "BasicNestedContent"
                                        model: string
                                        elements?: Array<{
                                          __typename?: "BasicNestedContentElement"
                                          properties: Array<{
                                            __typename?: "BasicProperty"
                                            alias?: string | null
                                            editorAlias?: string | null
                                            value?:
                                              | {
                                                  __typename?: "BasicBlockGridModel"
                                                  model: string
                                                }
                                              | {
                                                  __typename?: "BasicBlockListModel"
                                                  model: string
                                                }
                                              | {
                                                  __typename?: "BasicContentPicker"
                                                  model: string
                                                  contentList: Array<{
                                                    __typename?: "BasicContentPickerItem"
                                                    id: number
                                                    absoluteUrl: string
                                                    key: any
                                                    name?: string | null
                                                    url: string
                                                    urlSegment?: string | null
                                                  }>
                                                }
                                              | {
                                                  __typename?: "BasicDateTimePicker"
                                                  model: string
                                                  dateTime?: any | null
                                                }
                                              | {
                                                  __typename?: "BasicLabel"
                                                  model: string
                                                  label?: any | null
                                                }
                                              | {
                                                  __typename?: "BasicMediaPicker"
                                                  model: string
                                                }
                                              | {
                                                  __typename?: "BasicMemberPicker"
                                                  model: string
                                                  members: Array<{
                                                    __typename?: "BasicMemberPickerItem"
                                                    id?: number | null
                                                    name?: string | null
                                                  }>
                                                }
                                              | {
                                                  __typename?: "BasicMultiUrlPicker"
                                                  model: string
                                                  links: Array<{
                                                    __typename?: "BasicMultiUrlPickerItem"
                                                    name?: string | null
                                                    target?: string | null
                                                    type: LinkType
                                                    url?: string | null
                                                  }>
                                                }
                                              | {
                                                  __typename?: "BasicNestedContent"
                                                  model: string
                                                }
                                              | {
                                                  __typename?: "BasicPropertyValue"
                                                  model: string
                                                  value?: any | null
                                                }
                                              | {
                                                  __typename?: "BasicRichText"
                                                  model: string
                                                  sourceValue?: string | null
                                                  richText?: string | null
                                                }
                                              | {
                                                  __typename?: "BasicUnsupportedPropertyValue"
                                                  model: string
                                                  message: string
                                                }
                                              | {
                                                  __typename?: "MintMediaPicker"
                                                  model: string
                                                  mediaItems: Array<{
                                                    __typename?: "MintMediaPickerItem"
                                                    id: number
                                                    url: string
                                                    altText?: string | null
                                                  }>
                                                }
                                              | null
                                          } | null>
                                        }> | null
                                      }
                                    | {
                                        __typename?: "BasicPropertyValue"
                                        model: string
                                        value?: any | null
                                      }
                                    | {
                                        __typename?: "BasicRichText"
                                        model: string
                                        sourceValue?: string | null
                                        richText?: string | null
                                      }
                                    | {
                                        __typename?: "BasicUnsupportedPropertyValue"
                                        model: string
                                        message: string
                                      }
                                    | {
                                        __typename?: "MintMediaPicker"
                                        model: string
                                        mediaItems: Array<{
                                          __typename?: "MintMediaPickerItem"
                                          id: number
                                          url: string
                                          altText?: string | null
                                        }>
                                      }
                                    | null
                                } | null>
                              }>
                            }
                          | {
                              __typename?: "BasicMultiUrlPicker"
                              valueType: string
                              links: Array<{
                                __typename?: "BasicMultiUrlPickerItem"
                                name?: string | null
                                target?: string | null
                                type: LinkType
                                url?: string | null
                              }>
                            }
                          | {
                              __typename?: "BasicNestedContent"
                              valueType: string
                              elements?: Array<{
                                __typename?: "BasicNestedContentElement"
                                properties: Array<{
                                  __typename?: "BasicProperty"
                                  alias?: string | null
                                  editorAlias?: string | null
                                  value?:
                                    | {
                                        __typename?: "BasicBlockGridModel"
                                        model: string
                                      }
                                    | {
                                        __typename?: "BasicBlockListModel"
                                        model: string
                                      }
                                    | {
                                        __typename?: "BasicContentPicker"
                                        model: string
                                        contentList: Array<{
                                          __typename?: "BasicContentPickerItem"
                                          id: number
                                          absoluteUrl: string
                                          key: any
                                          name?: string | null
                                          url: string
                                          urlSegment?: string | null
                                        }>
                                      }
                                    | {
                                        __typename?: "BasicDateTimePicker"
                                        model: string
                                        dateTime?: any | null
                                      }
                                    | {
                                        __typename?: "BasicLabel"
                                        model: string
                                        label?: any | null
                                      }
                                    | {
                                        __typename?: "BasicMediaPicker"
                                        model: string
                                      }
                                    | {
                                        __typename?: "BasicMemberPicker"
                                        model: string
                                        members: Array<{
                                          __typename?: "BasicMemberPickerItem"
                                          id?: number | null
                                          name?: string | null
                                        }>
                                      }
                                    | {
                                        __typename?: "BasicMultiUrlPicker"
                                        model: string
                                        links: Array<{
                                          __typename?: "BasicMultiUrlPickerItem"
                                          name?: string | null
                                          target?: string | null
                                          type: LinkType
                                          url?: string | null
                                        }>
                                      }
                                    | {
                                        __typename?: "BasicNestedContent"
                                        model: string
                                      }
                                    | {
                                        __typename?: "BasicPropertyValue"
                                        model: string
                                        value?: any | null
                                      }
                                    | {
                                        __typename?: "BasicRichText"
                                        model: string
                                        sourceValue?: string | null
                                        richText?: string | null
                                      }
                                    | {
                                        __typename?: "BasicUnsupportedPropertyValue"
                                        model: string
                                        message: string
                                      }
                                    | {
                                        __typename?: "MintMediaPicker"
                                        model: string
                                        mediaItems: Array<{
                                          __typename?: "MintMediaPickerItem"
                                          id: number
                                          url: string
                                          altText?: string | null
                                        }>
                                      }
                                    | null
                                } | null>
                              }> | null
                            }
                          | {
                              __typename?: "BasicPropertyValue"
                              valueType: string
                              value?: any | null
                            }
                          | {
                              __typename?: "BasicRichText"
                              sourceValue?: string | null
                              valueType: string
                              richText?: string | null
                            }
                          | {
                              __typename?: "BasicUnsupportedPropertyValue"
                              message: string
                              valueType: string
                            }
                          | {
                              __typename?: "MintMediaPicker"
                              valueType: string
                              mediaItems: Array<{
                                __typename?: "MintMediaPickerItem"
                                id: number
                                url: string
                                altText?: string | null
                              }>
                            }
                          | null
                      } | null>
                      areas: Array<{
                        __typename?: "BasicBlockGridArea"
                        alias?: string | null
                        rowSpan: number
                        columnSpan: number
                      } | null>
                    }> | null
                  } | null>
                }> | null
              }
            | {
                __typename?: "BasicBlockListModel"
                valueType: string
                blocks?: Array<{
                  __typename?: "BasicBlockListItem"
                  blockType?: string | null
                  properties: Array<{
                    __typename?: "BasicProperty"
                    propertyName?: string | null
                    propertyValue?:
                      | {
                          __typename?: "BasicBlockGridModel"
                          valueType: string
                        }
                      | {
                          __typename?: "BasicBlockListModel"
                          valueType: string
                          blocks?: Array<{
                            __typename?: "BasicBlockListItem"
                            blockType?: string | null
                            properties: Array<{
                              __typename?: "BasicProperty"
                              propertyName?: string | null
                              propertyValue?:
                                | {
                                    __typename?: "BasicBlockGridModel"
                                    valueType: string
                                  }
                                | {
                                    __typename?: "BasicBlockListModel"
                                    valueType: string
                                    blocks?: Array<{
                                      __typename?: "BasicBlockListItem"
                                      blockType?: string | null
                                      properties: Array<{
                                        __typename?: "BasicProperty"
                                        propertyName?: string | null
                                        propertyValue?:
                                          | {
                                              __typename?: "BasicBlockGridModel"
                                              valueType: string
                                            }
                                          | {
                                              __typename?: "BasicBlockListModel"
                                              valueType: string
                                            }
                                          | {
                                              __typename?: "BasicContentPicker"
                                              valueType: string
                                              contentList: Array<{
                                                __typename?: "BasicContentPickerItem"
                                                id: number
                                                absoluteUrl: string
                                                key: any
                                                name?: string | null
                                                url: string
                                                urlSegment?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicDateTimePicker"
                                              valueType: string
                                              dateTime?: any | null
                                            }
                                          | {
                                              __typename?: "BasicLabel"
                                              valueType: string
                                              label?: any | null
                                            }
                                          | {
                                              __typename?: "BasicMediaPicker"
                                              valueType: string
                                            }
                                          | {
                                              __typename?: "BasicMemberPicker"
                                              valueType: string
                                              members: Array<{
                                                __typename?: "BasicMemberPickerItem"
                                                id?: number | null
                                                name?: string | null
                                                properties: Array<{
                                                  __typename?: "BasicProperty"
                                                  alias?: string | null
                                                  editorAlias?: string | null
                                                  value?:
                                                    | {
                                                        __typename?: "BasicBlockGridModel"
                                                        model: string
                                                      }
                                                    | {
                                                        __typename?: "BasicBlockListModel"
                                                        model: string
                                                      }
                                                    | {
                                                        __typename?: "BasicContentPicker"
                                                        model: string
                                                        contentList: Array<{
                                                          __typename?: "BasicContentPickerItem"
                                                          id: number
                                                          absoluteUrl: string
                                                          key: any
                                                          name?: string | null
                                                          url: string
                                                          urlSegment?:
                                                            | string
                                                            | null
                                                        }>
                                                      }
                                                    | {
                                                        __typename?: "BasicDateTimePicker"
                                                        model: string
                                                        dateTime?: any | null
                                                      }
                                                    | {
                                                        __typename?: "BasicLabel"
                                                        model: string
                                                        label?: any | null
                                                      }
                                                    | {
                                                        __typename?: "BasicMediaPicker"
                                                        model: string
                                                      }
                                                    | {
                                                        __typename?: "BasicMemberPicker"
                                                        model: string
                                                        members: Array<{
                                                          __typename?: "BasicMemberPickerItem"
                                                          id?: number | null
                                                          name?: string | null
                                                        }>
                                                      }
                                                    | {
                                                        __typename?: "BasicMultiUrlPicker"
                                                        model: string
                                                        links: Array<{
                                                          __typename?: "BasicMultiUrlPickerItem"
                                                          name?: string | null
                                                          target?: string | null
                                                          type: LinkType
                                                          url?: string | null
                                                        }>
                                                      }
                                                    | {
                                                        __typename?: "BasicNestedContent"
                                                        model: string
                                                        elements?: Array<{
                                                          __typename?: "BasicNestedContentElement"
                                                          properties: Array<{
                                                            __typename?: "BasicProperty"
                                                            alias?:
                                                              | string
                                                              | null
                                                            editorAlias?:
                                                              | string
                                                              | null
                                                            value?:
                                                              | {
                                                                  __typename?: "BasicBlockGridModel"
                                                                  model: string
                                                                }
                                                              | {
                                                                  __typename?: "BasicBlockListModel"
                                                                  model: string
                                                                }
                                                              | {
                                                                  __typename?: "BasicContentPicker"
                                                                  model: string
                                                                  contentList: Array<{
                                                                    __typename?: "BasicContentPickerItem"
                                                                    id: number
                                                                    absoluteUrl: string
                                                                    key: any
                                                                    name?:
                                                                      | string
                                                                      | null
                                                                    url: string
                                                                    urlSegment?:
                                                                      | string
                                                                      | null
                                                                  }>
                                                                }
                                                              | {
                                                                  __typename?: "BasicDateTimePicker"
                                                                  model: string
                                                                  dateTime?:
                                                                    | any
                                                                    | null
                                                                }
                                                              | {
                                                                  __typename?: "BasicLabel"
                                                                  model: string
                                                                  label?:
                                                                    | any
                                                                    | null
                                                                }
                                                              | {
                                                                  __typename?: "BasicMediaPicker"
                                                                  model: string
                                                                }
                                                              | {
                                                                  __typename?: "BasicMemberPicker"
                                                                  model: string
                                                                  members: Array<{
                                                                    __typename?: "BasicMemberPickerItem"
                                                                    id?:
                                                                      | number
                                                                      | null
                                                                    name?:
                                                                      | string
                                                                      | null
                                                                  }>
                                                                }
                                                              | {
                                                                  __typename?: "BasicMultiUrlPicker"
                                                                  model: string
                                                                  links: Array<{
                                                                    __typename?: "BasicMultiUrlPickerItem"
                                                                    name?:
                                                                      | string
                                                                      | null
                                                                    target?:
                                                                      | string
                                                                      | null
                                                                    type: LinkType
                                                                    url?:
                                                                      | string
                                                                      | null
                                                                  }>
                                                                }
                                                              | {
                                                                  __typename?: "BasicNestedContent"
                                                                  model: string
                                                                }
                                                              | {
                                                                  __typename?: "BasicPropertyValue"
                                                                  model: string
                                                                  value?:
                                                                    | any
                                                                    | null
                                                                }
                                                              | {
                                                                  __typename?: "BasicRichText"
                                                                  model: string
                                                                  sourceValue?:
                                                                    | string
                                                                    | null
                                                                  richText?:
                                                                    | string
                                                                    | null
                                                                }
                                                              | {
                                                                  __typename?: "BasicUnsupportedPropertyValue"
                                                                  model: string
                                                                  message: string
                                                                }
                                                              | {
                                                                  __typename?: "MintMediaPicker"
                                                                  model: string
                                                                  mediaItems: Array<{
                                                                    __typename?: "MintMediaPickerItem"
                                                                    id: number
                                                                    url: string
                                                                    altText?:
                                                                      | string
                                                                      | null
                                                                  }>
                                                                }
                                                              | null
                                                          } | null>
                                                        }> | null
                                                      }
                                                    | {
                                                        __typename?: "BasicPropertyValue"
                                                        model: string
                                                        value?: any | null
                                                      }
                                                    | {
                                                        __typename?: "BasicRichText"
                                                        model: string
                                                        sourceValue?:
                                                          | string
                                                          | null
                                                        richText?: string | null
                                                      }
                                                    | {
                                                        __typename?: "BasicUnsupportedPropertyValue"
                                                        model: string
                                                        message: string
                                                      }
                                                    | {
                                                        __typename?: "MintMediaPicker"
                                                        model: string
                                                        mediaItems: Array<{
                                                          __typename?: "MintMediaPickerItem"
                                                          id: number
                                                          url: string
                                                          altText?:
                                                            | string
                                                            | null
                                                        }>
                                                      }
                                                    | null
                                                } | null>
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicMultiUrlPicker"
                                              valueType: string
                                              links: Array<{
                                                __typename?: "BasicMultiUrlPickerItem"
                                                name?: string | null
                                                target?: string | null
                                                type: LinkType
                                                url?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicNestedContent"
                                              valueType: string
                                              elements?: Array<{
                                                __typename?: "BasicNestedContentElement"
                                                properties: Array<{
                                                  __typename?: "BasicProperty"
                                                  alias?: string | null
                                                  editorAlias?: string | null
                                                  value?:
                                                    | {
                                                        __typename?: "BasicBlockGridModel"
                                                        model: string
                                                      }
                                                    | {
                                                        __typename?: "BasicBlockListModel"
                                                        model: string
                                                      }
                                                    | {
                                                        __typename?: "BasicContentPicker"
                                                        model: string
                                                        contentList: Array<{
                                                          __typename?: "BasicContentPickerItem"
                                                          id: number
                                                          absoluteUrl: string
                                                          key: any
                                                          name?: string | null
                                                          url: string
                                                          urlSegment?:
                                                            | string
                                                            | null
                                                        }>
                                                      }
                                                    | {
                                                        __typename?: "BasicDateTimePicker"
                                                        model: string
                                                        dateTime?: any | null
                                                      }
                                                    | {
                                                        __typename?: "BasicLabel"
                                                        model: string
                                                        label?: any | null
                                                      }
                                                    | {
                                                        __typename?: "BasicMediaPicker"
                                                        model: string
                                                      }
                                                    | {
                                                        __typename?: "BasicMemberPicker"
                                                        model: string
                                                        members: Array<{
                                                          __typename?: "BasicMemberPickerItem"
                                                          id?: number | null
                                                          name?: string | null
                                                        }>
                                                      }
                                                    | {
                                                        __typename?: "BasicMultiUrlPicker"
                                                        model: string
                                                        links: Array<{
                                                          __typename?: "BasicMultiUrlPickerItem"
                                                          name?: string | null
                                                          target?: string | null
                                                          type: LinkType
                                                          url?: string | null
                                                        }>
                                                      }
                                                    | {
                                                        __typename?: "BasicNestedContent"
                                                        model: string
                                                      }
                                                    | {
                                                        __typename?: "BasicPropertyValue"
                                                        model: string
                                                        value?: any | null
                                                      }
                                                    | {
                                                        __typename?: "BasicRichText"
                                                        model: string
                                                        sourceValue?:
                                                          | string
                                                          | null
                                                        richText?: string | null
                                                      }
                                                    | {
                                                        __typename?: "BasicUnsupportedPropertyValue"
                                                        model: string
                                                        message: string
                                                      }
                                                    | {
                                                        __typename?: "MintMediaPicker"
                                                        model: string
                                                        mediaItems: Array<{
                                                          __typename?: "MintMediaPickerItem"
                                                          id: number
                                                          url: string
                                                          altText?:
                                                            | string
                                                            | null
                                                        }>
                                                      }
                                                    | null
                                                } | null>
                                              }> | null
                                            }
                                          | {
                                              __typename?: "BasicPropertyValue"
                                              valueType: string
                                              value?: any | null
                                            }
                                          | {
                                              __typename?: "BasicRichText"
                                              sourceValue?: string | null
                                              valueType: string
                                              richText?: string | null
                                            }
                                          | {
                                              __typename?: "BasicUnsupportedPropertyValue"
                                              message: string
                                              valueType: string
                                            }
                                          | {
                                              __typename?: "MintMediaPicker"
                                              valueType: string
                                              mediaItems: Array<{
                                                __typename?: "MintMediaPickerItem"
                                                id: number
                                                url: string
                                                altText?: string | null
                                              }>
                                            }
                                          | null
                                      } | null>
                                    }> | null
                                  }
                                | {
                                    __typename?: "BasicContentPicker"
                                    valueType: string
                                    contentList: Array<{
                                      __typename?: "BasicContentPickerItem"
                                      id: number
                                      absoluteUrl: string
                                      key: any
                                      name?: string | null
                                      url: string
                                      urlSegment?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicDateTimePicker"
                                    valueType: string
                                    dateTime?: any | null
                                  }
                                | {
                                    __typename?: "BasicLabel"
                                    valueType: string
                                    label?: any | null
                                  }
                                | {
                                    __typename?: "BasicMediaPicker"
                                    valueType: string
                                  }
                                | {
                                    __typename?: "BasicMemberPicker"
                                    valueType: string
                                    members: Array<{
                                      __typename?: "BasicMemberPickerItem"
                                      id?: number | null
                                      name?: string | null
                                      properties: Array<{
                                        __typename?: "BasicProperty"
                                        alias?: string | null
                                        editorAlias?: string | null
                                        value?:
                                          | {
                                              __typename?: "BasicBlockGridModel"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicBlockListModel"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicContentPicker"
                                              model: string
                                              contentList: Array<{
                                                __typename?: "BasicContentPickerItem"
                                                id: number
                                                absoluteUrl: string
                                                key: any
                                                name?: string | null
                                                url: string
                                                urlSegment?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicDateTimePicker"
                                              model: string
                                              dateTime?: any | null
                                            }
                                          | {
                                              __typename?: "BasicLabel"
                                              model: string
                                              label?: any | null
                                            }
                                          | {
                                              __typename?: "BasicMediaPicker"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicMemberPicker"
                                              model: string
                                              members: Array<{
                                                __typename?: "BasicMemberPickerItem"
                                                id?: number | null
                                                name?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicMultiUrlPicker"
                                              model: string
                                              links: Array<{
                                                __typename?: "BasicMultiUrlPickerItem"
                                                name?: string | null
                                                target?: string | null
                                                type: LinkType
                                                url?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicNestedContent"
                                              model: string
                                              elements?: Array<{
                                                __typename?: "BasicNestedContentElement"
                                                properties: Array<{
                                                  __typename?: "BasicProperty"
                                                  alias?: string | null
                                                  editorAlias?: string | null
                                                  value?:
                                                    | {
                                                        __typename?: "BasicBlockGridModel"
                                                        model: string
                                                      }
                                                    | {
                                                        __typename?: "BasicBlockListModel"
                                                        model: string
                                                      }
                                                    | {
                                                        __typename?: "BasicContentPicker"
                                                        model: string
                                                        contentList: Array<{
                                                          __typename?: "BasicContentPickerItem"
                                                          id: number
                                                          absoluteUrl: string
                                                          key: any
                                                          name?: string | null
                                                          url: string
                                                          urlSegment?:
                                                            | string
                                                            | null
                                                        }>
                                                      }
                                                    | {
                                                        __typename?: "BasicDateTimePicker"
                                                        model: string
                                                        dateTime?: any | null
                                                      }
                                                    | {
                                                        __typename?: "BasicLabel"
                                                        model: string
                                                        label?: any | null
                                                      }
                                                    | {
                                                        __typename?: "BasicMediaPicker"
                                                        model: string
                                                      }
                                                    | {
                                                        __typename?: "BasicMemberPicker"
                                                        model: string
                                                        members: Array<{
                                                          __typename?: "BasicMemberPickerItem"
                                                          id?: number | null
                                                          name?: string | null
                                                        }>
                                                      }
                                                    | {
                                                        __typename?: "BasicMultiUrlPicker"
                                                        model: string
                                                        links: Array<{
                                                          __typename?: "BasicMultiUrlPickerItem"
                                                          name?: string | null
                                                          target?: string | null
                                                          type: LinkType
                                                          url?: string | null
                                                        }>
                                                      }
                                                    | {
                                                        __typename?: "BasicNestedContent"
                                                        model: string
                                                      }
                                                    | {
                                                        __typename?: "BasicPropertyValue"
                                                        model: string
                                                        value?: any | null
                                                      }
                                                    | {
                                                        __typename?: "BasicRichText"
                                                        model: string
                                                        sourceValue?:
                                                          | string
                                                          | null
                                                        richText?: string | null
                                                      }
                                                    | {
                                                        __typename?: "BasicUnsupportedPropertyValue"
                                                        model: string
                                                        message: string
                                                      }
                                                    | {
                                                        __typename?: "MintMediaPicker"
                                                        model: string
                                                        mediaItems: Array<{
                                                          __typename?: "MintMediaPickerItem"
                                                          id: number
                                                          url: string
                                                          altText?:
                                                            | string
                                                            | null
                                                        }>
                                                      }
                                                    | null
                                                } | null>
                                              }> | null
                                            }
                                          | {
                                              __typename?: "BasicPropertyValue"
                                              model: string
                                              value?: any | null
                                            }
                                          | {
                                              __typename?: "BasicRichText"
                                              model: string
                                              sourceValue?: string | null
                                              richText?: string | null
                                            }
                                          | {
                                              __typename?: "BasicUnsupportedPropertyValue"
                                              model: string
                                              message: string
                                            }
                                          | {
                                              __typename?: "MintMediaPicker"
                                              model: string
                                              mediaItems: Array<{
                                                __typename?: "MintMediaPickerItem"
                                                id: number
                                                url: string
                                                altText?: string | null
                                              }>
                                            }
                                          | null
                                      } | null>
                                    }>
                                  }
                                | {
                                    __typename?: "BasicMultiUrlPicker"
                                    valueType: string
                                    links: Array<{
                                      __typename?: "BasicMultiUrlPickerItem"
                                      name?: string | null
                                      target?: string | null
                                      type: LinkType
                                      url?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicNestedContent"
                                    valueType: string
                                    elements?: Array<{
                                      __typename?: "BasicNestedContentElement"
                                      properties: Array<{
                                        __typename?: "BasicProperty"
                                        alias?: string | null
                                        editorAlias?: string | null
                                        value?:
                                          | {
                                              __typename?: "BasicBlockGridModel"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicBlockListModel"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicContentPicker"
                                              model: string
                                              contentList: Array<{
                                                __typename?: "BasicContentPickerItem"
                                                id: number
                                                absoluteUrl: string
                                                key: any
                                                name?: string | null
                                                url: string
                                                urlSegment?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicDateTimePicker"
                                              model: string
                                              dateTime?: any | null
                                            }
                                          | {
                                              __typename?: "BasicLabel"
                                              model: string
                                              label?: any | null
                                            }
                                          | {
                                              __typename?: "BasicMediaPicker"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicMemberPicker"
                                              model: string
                                              members: Array<{
                                                __typename?: "BasicMemberPickerItem"
                                                id?: number | null
                                                name?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicMultiUrlPicker"
                                              model: string
                                              links: Array<{
                                                __typename?: "BasicMultiUrlPickerItem"
                                                name?: string | null
                                                target?: string | null
                                                type: LinkType
                                                url?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicNestedContent"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicPropertyValue"
                                              model: string
                                              value?: any | null
                                            }
                                          | {
                                              __typename?: "BasicRichText"
                                              model: string
                                              sourceValue?: string | null
                                              richText?: string | null
                                            }
                                          | {
                                              __typename?: "BasicUnsupportedPropertyValue"
                                              model: string
                                              message: string
                                            }
                                          | {
                                              __typename?: "MintMediaPicker"
                                              model: string
                                              mediaItems: Array<{
                                                __typename?: "MintMediaPickerItem"
                                                id: number
                                                url: string
                                                altText?: string | null
                                              }>
                                            }
                                          | null
                                      } | null>
                                    }> | null
                                  }
                                | {
                                    __typename?: "BasicPropertyValue"
                                    valueType: string
                                    value?: any | null
                                  }
                                | {
                                    __typename?: "BasicRichText"
                                    sourceValue?: string | null
                                    valueType: string
                                    richText?: string | null
                                  }
                                | {
                                    __typename?: "BasicUnsupportedPropertyValue"
                                    message: string
                                    valueType: string
                                  }
                                | {
                                    __typename?: "MintMediaPicker"
                                    valueType: string
                                    mediaItems: Array<{
                                      __typename?: "MintMediaPickerItem"
                                      id: number
                                      url: string
                                      altText?: string | null
                                    }>
                                  }
                                | null
                            } | null>
                          }> | null
                        }
                      | {
                          __typename?: "BasicContentPicker"
                          valueType: string
                          contentList: Array<{
                            __typename?: "BasicContentPickerItem"
                            id: number
                            absoluteUrl: string
                            key: any
                            name?: string | null
                            url: string
                            urlSegment?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicDateTimePicker"
                          valueType: string
                          dateTime?: any | null
                        }
                      | {
                          __typename?: "BasicLabel"
                          valueType: string
                          label?: any | null
                        }
                      | { __typename?: "BasicMediaPicker"; valueType: string }
                      | {
                          __typename?: "BasicMemberPicker"
                          valueType: string
                          members: Array<{
                            __typename?: "BasicMemberPickerItem"
                            id?: number | null
                            name?: string | null
                            properties: Array<{
                              __typename?: "BasicProperty"
                              alias?: string | null
                              editorAlias?: string | null
                              value?:
                                | {
                                    __typename?: "BasicBlockGridModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicBlockListModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicContentPicker"
                                    model: string
                                    contentList: Array<{
                                      __typename?: "BasicContentPickerItem"
                                      id: number
                                      absoluteUrl: string
                                      key: any
                                      name?: string | null
                                      url: string
                                      urlSegment?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicDateTimePicker"
                                    model: string
                                    dateTime?: any | null
                                  }
                                | {
                                    __typename?: "BasicLabel"
                                    model: string
                                    label?: any | null
                                  }
                                | {
                                    __typename?: "BasicMediaPicker"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicMemberPicker"
                                    model: string
                                    members: Array<{
                                      __typename?: "BasicMemberPickerItem"
                                      id?: number | null
                                      name?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicMultiUrlPicker"
                                    model: string
                                    links: Array<{
                                      __typename?: "BasicMultiUrlPickerItem"
                                      name?: string | null
                                      target?: string | null
                                      type: LinkType
                                      url?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicNestedContent"
                                    model: string
                                    elements?: Array<{
                                      __typename?: "BasicNestedContentElement"
                                      properties: Array<{
                                        __typename?: "BasicProperty"
                                        alias?: string | null
                                        editorAlias?: string | null
                                        value?:
                                          | {
                                              __typename?: "BasicBlockGridModel"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicBlockListModel"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicContentPicker"
                                              model: string
                                              contentList: Array<{
                                                __typename?: "BasicContentPickerItem"
                                                id: number
                                                absoluteUrl: string
                                                key: any
                                                name?: string | null
                                                url: string
                                                urlSegment?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicDateTimePicker"
                                              model: string
                                              dateTime?: any | null
                                            }
                                          | {
                                              __typename?: "BasicLabel"
                                              model: string
                                              label?: any | null
                                            }
                                          | {
                                              __typename?: "BasicMediaPicker"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicMemberPicker"
                                              model: string
                                              members: Array<{
                                                __typename?: "BasicMemberPickerItem"
                                                id?: number | null
                                                name?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicMultiUrlPicker"
                                              model: string
                                              links: Array<{
                                                __typename?: "BasicMultiUrlPickerItem"
                                                name?: string | null
                                                target?: string | null
                                                type: LinkType
                                                url?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicNestedContent"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicPropertyValue"
                                              model: string
                                              value?: any | null
                                            }
                                          | {
                                              __typename?: "BasicRichText"
                                              model: string
                                              sourceValue?: string | null
                                              richText?: string | null
                                            }
                                          | {
                                              __typename?: "BasicUnsupportedPropertyValue"
                                              model: string
                                              message: string
                                            }
                                          | {
                                              __typename?: "MintMediaPicker"
                                              model: string
                                              mediaItems: Array<{
                                                __typename?: "MintMediaPickerItem"
                                                id: number
                                                url: string
                                                altText?: string | null
                                              }>
                                            }
                                          | null
                                      } | null>
                                    }> | null
                                  }
                                | {
                                    __typename?: "BasicPropertyValue"
                                    model: string
                                    value?: any | null
                                  }
                                | {
                                    __typename?: "BasicRichText"
                                    model: string
                                    sourceValue?: string | null
                                    richText?: string | null
                                  }
                                | {
                                    __typename?: "BasicUnsupportedPropertyValue"
                                    model: string
                                    message: string
                                  }
                                | {
                                    __typename?: "MintMediaPicker"
                                    model: string
                                    mediaItems: Array<{
                                      __typename?: "MintMediaPickerItem"
                                      id: number
                                      url: string
                                      altText?: string | null
                                    }>
                                  }
                                | null
                            } | null>
                          }>
                        }
                      | {
                          __typename?: "BasicMultiUrlPicker"
                          valueType: string
                          links: Array<{
                            __typename?: "BasicMultiUrlPickerItem"
                            name?: string | null
                            target?: string | null
                            type: LinkType
                            url?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicNestedContent"
                          valueType: string
                          elements?: Array<{
                            __typename?: "BasicNestedContentElement"
                            properties: Array<{
                              __typename?: "BasicProperty"
                              alias?: string | null
                              editorAlias?: string | null
                              value?:
                                | {
                                    __typename?: "BasicBlockGridModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicBlockListModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicContentPicker"
                                    model: string
                                    contentList: Array<{
                                      __typename?: "BasicContentPickerItem"
                                      id: number
                                      absoluteUrl: string
                                      key: any
                                      name?: string | null
                                      url: string
                                      urlSegment?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicDateTimePicker"
                                    model: string
                                    dateTime?: any | null
                                  }
                                | {
                                    __typename?: "BasicLabel"
                                    model: string
                                    label?: any | null
                                  }
                                | {
                                    __typename?: "BasicMediaPicker"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicMemberPicker"
                                    model: string
                                    members: Array<{
                                      __typename?: "BasicMemberPickerItem"
                                      id?: number | null
                                      name?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicMultiUrlPicker"
                                    model: string
                                    links: Array<{
                                      __typename?: "BasicMultiUrlPickerItem"
                                      name?: string | null
                                      target?: string | null
                                      type: LinkType
                                      url?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicNestedContent"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicPropertyValue"
                                    model: string
                                    value?: any | null
                                  }
                                | {
                                    __typename?: "BasicRichText"
                                    model: string
                                    sourceValue?: string | null
                                    richText?: string | null
                                  }
                                | {
                                    __typename?: "BasicUnsupportedPropertyValue"
                                    model: string
                                    message: string
                                  }
                                | {
                                    __typename?: "MintMediaPicker"
                                    model: string
                                    mediaItems: Array<{
                                      __typename?: "MintMediaPickerItem"
                                      id: number
                                      url: string
                                      altText?: string | null
                                    }>
                                  }
                                | null
                            } | null>
                          }> | null
                        }
                      | {
                          __typename?: "BasicPropertyValue"
                          valueType: string
                          value?: any | null
                        }
                      | {
                          __typename?: "BasicRichText"
                          sourceValue?: string | null
                          valueType: string
                          richText?: string | null
                        }
                      | {
                          __typename?: "BasicUnsupportedPropertyValue"
                          message: string
                          valueType: string
                        }
                      | {
                          __typename?: "MintMediaPicker"
                          valueType: string
                          mediaItems: Array<{
                            __typename?: "MintMediaPickerItem"
                            id: number
                            url: string
                            altText?: string | null
                          }>
                        }
                      | null
                  } | null>
                }> | null
              }
            | {
                __typename?: "BasicContentPicker"
                valueType: string
                contentList: Array<{
                  __typename?: "BasicContentPickerItem"
                  id: number
                  absoluteUrl: string
                  key: any
                  name?: string | null
                  url: string
                  urlSegment?: string | null
                }>
              }
            | {
                __typename?: "BasicDateTimePicker"
                valueType: string
                dateTime?: any | null
              }
            | {
                __typename?: "BasicLabel"
                valueType: string
                label?: any | null
              }
            | { __typename?: "BasicMediaPicker"; valueType: string }
            | {
                __typename?: "BasicMemberPicker"
                valueType: string
                members: Array<{
                  __typename?: "BasicMemberPickerItem"
                  id?: number | null
                  name?: string | null
                  properties: Array<{
                    __typename?: "BasicProperty"
                    alias?: string | null
                    editorAlias?: string | null
                    value?:
                      | { __typename?: "BasicBlockGridModel"; model: string }
                      | { __typename?: "BasicBlockListModel"; model: string }
                      | {
                          __typename?: "BasicContentPicker"
                          model: string
                          contentList: Array<{
                            __typename?: "BasicContentPickerItem"
                            id: number
                            absoluteUrl: string
                            key: any
                            name?: string | null
                            url: string
                            urlSegment?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicDateTimePicker"
                          model: string
                          dateTime?: any | null
                        }
                      | {
                          __typename?: "BasicLabel"
                          model: string
                          label?: any | null
                        }
                      | { __typename?: "BasicMediaPicker"; model: string }
                      | {
                          __typename?: "BasicMemberPicker"
                          model: string
                          members: Array<{
                            __typename?: "BasicMemberPickerItem"
                            id?: number | null
                            name?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicMultiUrlPicker"
                          model: string
                          links: Array<{
                            __typename?: "BasicMultiUrlPickerItem"
                            name?: string | null
                            target?: string | null
                            type: LinkType
                            url?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicNestedContent"
                          model: string
                          elements?: Array<{
                            __typename?: "BasicNestedContentElement"
                            properties: Array<{
                              __typename?: "BasicProperty"
                              alias?: string | null
                              editorAlias?: string | null
                              value?:
                                | {
                                    __typename?: "BasicBlockGridModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicBlockListModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicContentPicker"
                                    model: string
                                    contentList: Array<{
                                      __typename?: "BasicContentPickerItem"
                                      id: number
                                      absoluteUrl: string
                                      key: any
                                      name?: string | null
                                      url: string
                                      urlSegment?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicDateTimePicker"
                                    model: string
                                    dateTime?: any | null
                                  }
                                | {
                                    __typename?: "BasicLabel"
                                    model: string
                                    label?: any | null
                                  }
                                | {
                                    __typename?: "BasicMediaPicker"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicMemberPicker"
                                    model: string
                                    members: Array<{
                                      __typename?: "BasicMemberPickerItem"
                                      id?: number | null
                                      name?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicMultiUrlPicker"
                                    model: string
                                    links: Array<{
                                      __typename?: "BasicMultiUrlPickerItem"
                                      name?: string | null
                                      target?: string | null
                                      type: LinkType
                                      url?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicNestedContent"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicPropertyValue"
                                    model: string
                                    value?: any | null
                                  }
                                | {
                                    __typename?: "BasicRichText"
                                    model: string
                                    sourceValue?: string | null
                                    richText?: string | null
                                  }
                                | {
                                    __typename?: "BasicUnsupportedPropertyValue"
                                    model: string
                                    message: string
                                  }
                                | {
                                    __typename?: "MintMediaPicker"
                                    model: string
                                    mediaItems: Array<{
                                      __typename?: "MintMediaPickerItem"
                                      id: number
                                      url: string
                                      altText?: string | null
                                    }>
                                  }
                                | null
                            } | null>
                          }> | null
                        }
                      | {
                          __typename?: "BasicPropertyValue"
                          model: string
                          value?: any | null
                        }
                      | {
                          __typename?: "BasicRichText"
                          model: string
                          sourceValue?: string | null
                          richText?: string | null
                        }
                      | {
                          __typename?: "BasicUnsupportedPropertyValue"
                          model: string
                          message: string
                        }
                      | {
                          __typename?: "MintMediaPicker"
                          model: string
                          mediaItems: Array<{
                            __typename?: "MintMediaPickerItem"
                            id: number
                            url: string
                            altText?: string | null
                          }>
                        }
                      | null
                  } | null>
                }>
              }
            | {
                __typename?: "BasicMultiUrlPicker"
                valueType: string
                links: Array<{
                  __typename?: "BasicMultiUrlPickerItem"
                  name?: string | null
                  target?: string | null
                  type: LinkType
                  url?: string | null
                }>
              }
            | {
                __typename?: "BasicNestedContent"
                valueType: string
                elements?: Array<{
                  __typename?: "BasicNestedContentElement"
                  properties: Array<{
                    __typename?: "BasicProperty"
                    alias?: string | null
                    editorAlias?: string | null
                    value?:
                      | { __typename?: "BasicBlockGridModel"; model: string }
                      | { __typename?: "BasicBlockListModel"; model: string }
                      | {
                          __typename?: "BasicContentPicker"
                          model: string
                          contentList: Array<{
                            __typename?: "BasicContentPickerItem"
                            id: number
                            absoluteUrl: string
                            key: any
                            name?: string | null
                            url: string
                            urlSegment?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicDateTimePicker"
                          model: string
                          dateTime?: any | null
                        }
                      | {
                          __typename?: "BasicLabel"
                          model: string
                          label?: any | null
                        }
                      | { __typename?: "BasicMediaPicker"; model: string }
                      | {
                          __typename?: "BasicMemberPicker"
                          model: string
                          members: Array<{
                            __typename?: "BasicMemberPickerItem"
                            id?: number | null
                            name?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicMultiUrlPicker"
                          model: string
                          links: Array<{
                            __typename?: "BasicMultiUrlPickerItem"
                            name?: string | null
                            target?: string | null
                            type: LinkType
                            url?: string | null
                          }>
                        }
                      | { __typename?: "BasicNestedContent"; model: string }
                      | {
                          __typename?: "BasicPropertyValue"
                          model: string
                          value?: any | null
                        }
                      | {
                          __typename?: "BasicRichText"
                          model: string
                          sourceValue?: string | null
                          richText?: string | null
                        }
                      | {
                          __typename?: "BasicUnsupportedPropertyValue"
                          model: string
                          message: string
                        }
                      | {
                          __typename?: "MintMediaPicker"
                          model: string
                          mediaItems: Array<{
                            __typename?: "MintMediaPickerItem"
                            id: number
                            url: string
                            altText?: string | null
                          }>
                        }
                      | null
                  } | null>
                }> | null
              }
            | {
                __typename?: "BasicPropertyValue"
                valueType: string
                value?: any | null
              }
            | {
                __typename?: "BasicRichText"
                sourceValue?: string | null
                valueType: string
                richText?: string | null
              }
            | {
                __typename?: "BasicUnsupportedPropertyValue"
                message: string
                valueType: string
              }
            | {
                __typename?: "MintMediaPicker"
                valueType: string
                mediaItems: Array<{
                  __typename?: "MintMediaPickerItem"
                  id: number
                  url: string
                  altText?: string | null
                }>
              }
            | null
        } | null> | null
      } | null
    }> | null
  } | null
}

type PropertyEditorsComponent_BasicBlockGridModel_Fragment = {
  __typename?: "BasicBlockGridModel"
  valueType: string
}

type PropertyEditorsComponent_BasicBlockListModel_Fragment = {
  __typename?: "BasicBlockListModel"
  valueType: string
}

type PropertyEditorsComponent_BasicContentPicker_Fragment = {
  __typename?: "BasicContentPicker"
  valueType: string
  contentList: Array<{
    __typename?: "BasicContentPickerItem"
    id: number
    absoluteUrl: string
    key: any
    name?: string | null
    url: string
    urlSegment?: string | null
  }>
}

type PropertyEditorsComponent_BasicDateTimePicker_Fragment = {
  __typename?: "BasicDateTimePicker"
  valueType: string
  dateTime?: any | null
}

type PropertyEditorsComponent_BasicLabel_Fragment = {
  __typename?: "BasicLabel"
  valueType: string
  label?: any | null
}

type PropertyEditorsComponent_BasicMediaPicker_Fragment = {
  __typename?: "BasicMediaPicker"
  valueType: string
}

type PropertyEditorsComponent_BasicMemberPicker_Fragment = {
  __typename?: "BasicMemberPicker"
  valueType: string
  members: Array<{
    __typename?: "BasicMemberPickerItem"
    id?: number | null
    name?: string | null
    properties: Array<{
      __typename?: "BasicProperty"
      alias?: string | null
      editorAlias?: string | null
      value?:
        | { __typename?: "BasicBlockGridModel"; model: string }
        | { __typename?: "BasicBlockListModel"; model: string }
        | {
            __typename?: "BasicContentPicker"
            model: string
            contentList: Array<{
              __typename?: "BasicContentPickerItem"
              id: number
              absoluteUrl: string
              key: any
              name?: string | null
              url: string
              urlSegment?: string | null
            }>
          }
        | {
            __typename?: "BasicDateTimePicker"
            model: string
            dateTime?: any | null
          }
        | { __typename?: "BasicLabel"; model: string; label?: any | null }
        | { __typename?: "BasicMediaPicker"; model: string }
        | {
            __typename?: "BasicMemberPicker"
            model: string
            members: Array<{
              __typename?: "BasicMemberPickerItem"
              id?: number | null
              name?: string | null
            }>
          }
        | {
            __typename?: "BasicMultiUrlPicker"
            model: string
            links: Array<{
              __typename?: "BasicMultiUrlPickerItem"
              name?: string | null
              target?: string | null
              type: LinkType
              url?: string | null
            }>
          }
        | {
            __typename?: "BasicNestedContent"
            model: string
            elements?: Array<{
              __typename?: "BasicNestedContentElement"
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | { __typename?: "BasicNestedContent"; model: string }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      sourceValue?: string | null
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }> | null
          }
        | {
            __typename?: "BasicPropertyValue"
            model: string
            value?: any | null
          }
        | {
            __typename?: "BasicRichText"
            model: string
            sourceValue?: string | null
            richText?: string | null
          }
        | {
            __typename?: "BasicUnsupportedPropertyValue"
            model: string
            message: string
          }
        | {
            __typename?: "MintMediaPicker"
            model: string
            mediaItems: Array<{
              __typename?: "MintMediaPickerItem"
              id: number
              url: string
              altText?: string | null
            }>
          }
        | null
    } | null>
  }>
}

type PropertyEditorsComponent_BasicMultiUrlPicker_Fragment = {
  __typename?: "BasicMultiUrlPicker"
  valueType: string
  links: Array<{
    __typename?: "BasicMultiUrlPickerItem"
    name?: string | null
    target?: string | null
    type: LinkType
    url?: string | null
  }>
}

type PropertyEditorsComponent_BasicNestedContent_Fragment = {
  __typename?: "BasicNestedContent"
  valueType: string
  elements?: Array<{
    __typename?: "BasicNestedContentElement"
    properties: Array<{
      __typename?: "BasicProperty"
      alias?: string | null
      editorAlias?: string | null
      value?:
        | { __typename?: "BasicBlockGridModel"; model: string }
        | { __typename?: "BasicBlockListModel"; model: string }
        | {
            __typename?: "BasicContentPicker"
            model: string
            contentList: Array<{
              __typename?: "BasicContentPickerItem"
              id: number
              absoluteUrl: string
              key: any
              name?: string | null
              url: string
              urlSegment?: string | null
            }>
          }
        | {
            __typename?: "BasicDateTimePicker"
            model: string
            dateTime?: any | null
          }
        | { __typename?: "BasicLabel"; model: string; label?: any | null }
        | { __typename?: "BasicMediaPicker"; model: string }
        | {
            __typename?: "BasicMemberPicker"
            model: string
            members: Array<{
              __typename?: "BasicMemberPickerItem"
              id?: number | null
              name?: string | null
            }>
          }
        | {
            __typename?: "BasicMultiUrlPicker"
            model: string
            links: Array<{
              __typename?: "BasicMultiUrlPickerItem"
              name?: string | null
              target?: string | null
              type: LinkType
              url?: string | null
            }>
          }
        | { __typename?: "BasicNestedContent"; model: string }
        | {
            __typename?: "BasicPropertyValue"
            model: string
            value?: any | null
          }
        | {
            __typename?: "BasicRichText"
            model: string
            sourceValue?: string | null
            richText?: string | null
          }
        | {
            __typename?: "BasicUnsupportedPropertyValue"
            model: string
            message: string
          }
        | {
            __typename?: "MintMediaPicker"
            model: string
            mediaItems: Array<{
              __typename?: "MintMediaPickerItem"
              id: number
              url: string
              altText?: string | null
            }>
          }
        | null
    } | null>
  }> | null
}

type PropertyEditorsComponent_BasicPropertyValue_Fragment = {
  __typename?: "BasicPropertyValue"
  valueType: string
  value?: any | null
}

type PropertyEditorsComponent_BasicRichText_Fragment = {
  __typename?: "BasicRichText"
  sourceValue?: string | null
  valueType: string
  richText?: string | null
}

type PropertyEditorsComponent_BasicUnsupportedPropertyValue_Fragment = {
  __typename?: "BasicUnsupportedPropertyValue"
  message: string
  valueType: string
}

type PropertyEditorsComponent_MintMediaPicker_Fragment = {
  __typename?: "MintMediaPicker"
  valueType: string
  mediaItems: Array<{
    __typename?: "MintMediaPickerItem"
    id: number
    url: string
    altText?: string | null
  }>
}

export type PropertyEditorsComponentFragment =
  | PropertyEditorsComponent_BasicBlockGridModel_Fragment
  | PropertyEditorsComponent_BasicBlockListModel_Fragment
  | PropertyEditorsComponent_BasicContentPicker_Fragment
  | PropertyEditorsComponent_BasicDateTimePicker_Fragment
  | PropertyEditorsComponent_BasicLabel_Fragment
  | PropertyEditorsComponent_BasicMediaPicker_Fragment
  | PropertyEditorsComponent_BasicMemberPicker_Fragment
  | PropertyEditorsComponent_BasicMultiUrlPicker_Fragment
  | PropertyEditorsComponent_BasicNestedContent_Fragment
  | PropertyEditorsComponent_BasicPropertyValue_Fragment
  | PropertyEditorsComponent_BasicRichText_Fragment
  | PropertyEditorsComponent_BasicUnsupportedPropertyValue_Fragment
  | PropertyEditorsComponent_MintMediaPicker_Fragment

type DateTimePicker_BasicBlockGridModel_Fragment = {
  __typename?: "BasicBlockGridModel"
}

type DateTimePicker_BasicBlockListModel_Fragment = {
  __typename?: "BasicBlockListModel"
}

type DateTimePicker_BasicContentPicker_Fragment = {
  __typename?: "BasicContentPicker"
}

type DateTimePicker_BasicDateTimePicker_Fragment = {
  __typename?: "BasicDateTimePicker"
  dateTime?: any | null
}

type DateTimePicker_BasicLabel_Fragment = { __typename?: "BasicLabel" }

type DateTimePicker_BasicMediaPicker_Fragment = {
  __typename?: "BasicMediaPicker"
}

type DateTimePicker_BasicMemberPicker_Fragment = {
  __typename?: "BasicMemberPicker"
}

type DateTimePicker_BasicMultiUrlPicker_Fragment = {
  __typename?: "BasicMultiUrlPicker"
}

type DateTimePicker_BasicNestedContent_Fragment = {
  __typename?: "BasicNestedContent"
}

type DateTimePicker_BasicPropertyValue_Fragment = {
  __typename?: "BasicPropertyValue"
}

type DateTimePicker_BasicRichText_Fragment = { __typename?: "BasicRichText" }

type DateTimePicker_BasicUnsupportedPropertyValue_Fragment = {
  __typename?: "BasicUnsupportedPropertyValue"
}

type DateTimePicker_MintMediaPicker_Fragment = {
  __typename?: "MintMediaPicker"
}

export type DateTimePickerFragment =
  | DateTimePicker_BasicBlockGridModel_Fragment
  | DateTimePicker_BasicBlockListModel_Fragment
  | DateTimePicker_BasicContentPicker_Fragment
  | DateTimePicker_BasicDateTimePicker_Fragment
  | DateTimePicker_BasicLabel_Fragment
  | DateTimePicker_BasicMediaPicker_Fragment
  | DateTimePicker_BasicMemberPicker_Fragment
  | DateTimePicker_BasicMultiUrlPicker_Fragment
  | DateTimePicker_BasicNestedContent_Fragment
  | DateTimePicker_BasicPropertyValue_Fragment
  | DateTimePicker_BasicRichText_Fragment
  | DateTimePicker_BasicUnsupportedPropertyValue_Fragment
  | DateTimePicker_MintMediaPicker_Fragment

type BasicValue_BasicBlockGridModel_Fragment = {
  __typename?: "BasicBlockGridModel"
}

type BasicValue_BasicBlockListModel_Fragment = {
  __typename?: "BasicBlockListModel"
}

type BasicValue_BasicContentPicker_Fragment = {
  __typename?: "BasicContentPicker"
}

type BasicValue_BasicDateTimePicker_Fragment = {
  __typename?: "BasicDateTimePicker"
}

type BasicValue_BasicLabel_Fragment = { __typename?: "BasicLabel" }

type BasicValue_BasicMediaPicker_Fragment = { __typename?: "BasicMediaPicker" }

type BasicValue_BasicMemberPicker_Fragment = {
  __typename?: "BasicMemberPicker"
}

type BasicValue_BasicMultiUrlPicker_Fragment = {
  __typename?: "BasicMultiUrlPicker"
}

type BasicValue_BasicNestedContent_Fragment = {
  __typename?: "BasicNestedContent"
}

type BasicValue_BasicPropertyValue_Fragment = {
  __typename?: "BasicPropertyValue"
  value?: any | null
}

type BasicValue_BasicRichText_Fragment = { __typename?: "BasicRichText" }

type BasicValue_BasicUnsupportedPropertyValue_Fragment = {
  __typename?: "BasicUnsupportedPropertyValue"
}

type BasicValue_MintMediaPicker_Fragment = { __typename?: "MintMediaPicker" }

export type BasicValueFragment =
  | BasicValue_BasicBlockGridModel_Fragment
  | BasicValue_BasicBlockListModel_Fragment
  | BasicValue_BasicContentPicker_Fragment
  | BasicValue_BasicDateTimePicker_Fragment
  | BasicValue_BasicLabel_Fragment
  | BasicValue_BasicMediaPicker_Fragment
  | BasicValue_BasicMemberPicker_Fragment
  | BasicValue_BasicMultiUrlPicker_Fragment
  | BasicValue_BasicNestedContent_Fragment
  | BasicValue_BasicPropertyValue_Fragment
  | BasicValue_BasicRichText_Fragment
  | BasicValue_BasicUnsupportedPropertyValue_Fragment
  | BasicValue_MintMediaPicker_Fragment

type ContentPicker_BasicBlockGridModel_Fragment = {
  __typename?: "BasicBlockGridModel"
}

type ContentPicker_BasicBlockListModel_Fragment = {
  __typename?: "BasicBlockListModel"
}

type ContentPicker_BasicContentPicker_Fragment = {
  __typename?: "BasicContentPicker"
  contentList: Array<{
    __typename?: "BasicContentPickerItem"
    id: number
    absoluteUrl: string
    key: any
    name?: string | null
    url: string
    urlSegment?: string | null
  }>
}

type ContentPicker_BasicDateTimePicker_Fragment = {
  __typename?: "BasicDateTimePicker"
}

type ContentPicker_BasicLabel_Fragment = { __typename?: "BasicLabel" }

type ContentPicker_BasicMediaPicker_Fragment = {
  __typename?: "BasicMediaPicker"
}

type ContentPicker_BasicMemberPicker_Fragment = {
  __typename?: "BasicMemberPicker"
}

type ContentPicker_BasicMultiUrlPicker_Fragment = {
  __typename?: "BasicMultiUrlPicker"
}

type ContentPicker_BasicNestedContent_Fragment = {
  __typename?: "BasicNestedContent"
}

type ContentPicker_BasicPropertyValue_Fragment = {
  __typename?: "BasicPropertyValue"
}

type ContentPicker_BasicRichText_Fragment = { __typename?: "BasicRichText" }

type ContentPicker_BasicUnsupportedPropertyValue_Fragment = {
  __typename?: "BasicUnsupportedPropertyValue"
}

type ContentPicker_MintMediaPicker_Fragment = { __typename?: "MintMediaPicker" }

export type ContentPickerFragment =
  | ContentPicker_BasicBlockGridModel_Fragment
  | ContentPicker_BasicBlockListModel_Fragment
  | ContentPicker_BasicContentPicker_Fragment
  | ContentPicker_BasicDateTimePicker_Fragment
  | ContentPicker_BasicLabel_Fragment
  | ContentPicker_BasicMediaPicker_Fragment
  | ContentPicker_BasicMemberPicker_Fragment
  | ContentPicker_BasicMultiUrlPicker_Fragment
  | ContentPicker_BasicNestedContent_Fragment
  | ContentPicker_BasicPropertyValue_Fragment
  | ContentPicker_BasicRichText_Fragment
  | ContentPicker_BasicUnsupportedPropertyValue_Fragment
  | ContentPicker_MintMediaPicker_Fragment

type Label_BasicBlockGridModel_Fragment = { __typename?: "BasicBlockGridModel" }

type Label_BasicBlockListModel_Fragment = { __typename?: "BasicBlockListModel" }

type Label_BasicContentPicker_Fragment = { __typename?: "BasicContentPicker" }

type Label_BasicDateTimePicker_Fragment = { __typename?: "BasicDateTimePicker" }

type Label_BasicLabel_Fragment = {
  __typename?: "BasicLabel"
  label?: any | null
}

type Label_BasicMediaPicker_Fragment = { __typename?: "BasicMediaPicker" }

type Label_BasicMemberPicker_Fragment = { __typename?: "BasicMemberPicker" }

type Label_BasicMultiUrlPicker_Fragment = { __typename?: "BasicMultiUrlPicker" }

type Label_BasicNestedContent_Fragment = { __typename?: "BasicNestedContent" }

type Label_BasicPropertyValue_Fragment = { __typename?: "BasicPropertyValue" }

type Label_BasicRichText_Fragment = { __typename?: "BasicRichText" }

type Label_BasicUnsupportedPropertyValue_Fragment = {
  __typename?: "BasicUnsupportedPropertyValue"
}

type Label_MintMediaPicker_Fragment = { __typename?: "MintMediaPicker" }

export type LabelFragment =
  | Label_BasicBlockGridModel_Fragment
  | Label_BasicBlockListModel_Fragment
  | Label_BasicContentPicker_Fragment
  | Label_BasicDateTimePicker_Fragment
  | Label_BasicLabel_Fragment
  | Label_BasicMediaPicker_Fragment
  | Label_BasicMemberPicker_Fragment
  | Label_BasicMultiUrlPicker_Fragment
  | Label_BasicNestedContent_Fragment
  | Label_BasicPropertyValue_Fragment
  | Label_BasicRichText_Fragment
  | Label_BasicUnsupportedPropertyValue_Fragment
  | Label_MintMediaPicker_Fragment

type MediaPickerComp_BasicBlockGridModel_Fragment = {
  __typename?: "BasicBlockGridModel"
}

type MediaPickerComp_BasicBlockListModel_Fragment = {
  __typename?: "BasicBlockListModel"
}

type MediaPickerComp_BasicContentPicker_Fragment = {
  __typename?: "BasicContentPicker"
}

type MediaPickerComp_BasicDateTimePicker_Fragment = {
  __typename?: "BasicDateTimePicker"
}

type MediaPickerComp_BasicLabel_Fragment = { __typename?: "BasicLabel" }

type MediaPickerComp_BasicMediaPicker_Fragment = {
  __typename?: "BasicMediaPicker"
}

type MediaPickerComp_BasicMemberPicker_Fragment = {
  __typename?: "BasicMemberPicker"
}

type MediaPickerComp_BasicMultiUrlPicker_Fragment = {
  __typename?: "BasicMultiUrlPicker"
}

type MediaPickerComp_BasicNestedContent_Fragment = {
  __typename?: "BasicNestedContent"
}

type MediaPickerComp_BasicPropertyValue_Fragment = {
  __typename?: "BasicPropertyValue"
}

type MediaPickerComp_BasicRichText_Fragment = { __typename?: "BasicRichText" }

type MediaPickerComp_BasicUnsupportedPropertyValue_Fragment = {
  __typename?: "BasicUnsupportedPropertyValue"
}

type MediaPickerComp_MintMediaPicker_Fragment = {
  __typename?: "MintMediaPicker"
  mediaItems: Array<{
    __typename?: "MintMediaPickerItem"
    id: number
    url: string
    altText?: string | null
  }>
}

export type MediaPickerCompFragment =
  | MediaPickerComp_BasicBlockGridModel_Fragment
  | MediaPickerComp_BasicBlockListModel_Fragment
  | MediaPickerComp_BasicContentPicker_Fragment
  | MediaPickerComp_BasicDateTimePicker_Fragment
  | MediaPickerComp_BasicLabel_Fragment
  | MediaPickerComp_BasicMediaPicker_Fragment
  | MediaPickerComp_BasicMemberPicker_Fragment
  | MediaPickerComp_BasicMultiUrlPicker_Fragment
  | MediaPickerComp_BasicNestedContent_Fragment
  | MediaPickerComp_BasicPropertyValue_Fragment
  | MediaPickerComp_BasicRichText_Fragment
  | MediaPickerComp_BasicUnsupportedPropertyValue_Fragment
  | MediaPickerComp_MintMediaPicker_Fragment

type MemberPickerComponent_BasicBlockGridModel_Fragment = {
  __typename?: "BasicBlockGridModel"
}

type MemberPickerComponent_BasicBlockListModel_Fragment = {
  __typename?: "BasicBlockListModel"
}

type MemberPickerComponent_BasicContentPicker_Fragment = {
  __typename?: "BasicContentPicker"
}

type MemberPickerComponent_BasicDateTimePicker_Fragment = {
  __typename?: "BasicDateTimePicker"
}

type MemberPickerComponent_BasicLabel_Fragment = { __typename?: "BasicLabel" }

type MemberPickerComponent_BasicMediaPicker_Fragment = {
  __typename?: "BasicMediaPicker"
}

type MemberPickerComponent_BasicMemberPicker_Fragment = {
  __typename?: "BasicMemberPicker"
  members: Array<{
    __typename?: "BasicMemberPickerItem"
    id?: number | null
    name?: string | null
    properties: Array<{
      __typename?: "BasicProperty"
      alias?: string | null
      editorAlias?: string | null
      value?:
        | { __typename?: "BasicBlockGridModel"; model: string }
        | { __typename?: "BasicBlockListModel"; model: string }
        | {
            __typename?: "BasicContentPicker"
            model: string
            contentList: Array<{
              __typename?: "BasicContentPickerItem"
              id: number
              absoluteUrl: string
              key: any
              name?: string | null
              url: string
              urlSegment?: string | null
            }>
          }
        | {
            __typename?: "BasicDateTimePicker"
            model: string
            dateTime?: any | null
          }
        | { __typename?: "BasicLabel"; model: string; label?: any | null }
        | { __typename?: "BasicMediaPicker"; model: string }
        | {
            __typename?: "BasicMemberPicker"
            model: string
            members: Array<{
              __typename?: "BasicMemberPickerItem"
              id?: number | null
              name?: string | null
            }>
          }
        | {
            __typename?: "BasicMultiUrlPicker"
            model: string
            links: Array<{
              __typename?: "BasicMultiUrlPickerItem"
              name?: string | null
              target?: string | null
              type: LinkType
              url?: string | null
            }>
          }
        | {
            __typename?: "BasicNestedContent"
            model: string
            elements?: Array<{
              __typename?: "BasicNestedContentElement"
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | { __typename?: "BasicNestedContent"; model: string }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      sourceValue?: string | null
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }> | null
          }
        | {
            __typename?: "BasicPropertyValue"
            model: string
            value?: any | null
          }
        | {
            __typename?: "BasicRichText"
            model: string
            sourceValue?: string | null
            richText?: string | null
          }
        | {
            __typename?: "BasicUnsupportedPropertyValue"
            model: string
            message: string
          }
        | {
            __typename?: "MintMediaPicker"
            model: string
            mediaItems: Array<{
              __typename?: "MintMediaPickerItem"
              id: number
              url: string
              altText?: string | null
            }>
          }
        | null
    } | null>
  }>
}

type MemberPickerComponent_BasicMultiUrlPicker_Fragment = {
  __typename?: "BasicMultiUrlPicker"
}

type MemberPickerComponent_BasicNestedContent_Fragment = {
  __typename?: "BasicNestedContent"
}

type MemberPickerComponent_BasicPropertyValue_Fragment = {
  __typename?: "BasicPropertyValue"
}

type MemberPickerComponent_BasicRichText_Fragment = {
  __typename?: "BasicRichText"
}

type MemberPickerComponent_BasicUnsupportedPropertyValue_Fragment = {
  __typename?: "BasicUnsupportedPropertyValue"
}

type MemberPickerComponent_MintMediaPicker_Fragment = {
  __typename?: "MintMediaPicker"
}

export type MemberPickerComponentFragment =
  | MemberPickerComponent_BasicBlockGridModel_Fragment
  | MemberPickerComponent_BasicBlockListModel_Fragment
  | MemberPickerComponent_BasicContentPicker_Fragment
  | MemberPickerComponent_BasicDateTimePicker_Fragment
  | MemberPickerComponent_BasicLabel_Fragment
  | MemberPickerComponent_BasicMediaPicker_Fragment
  | MemberPickerComponent_BasicMemberPicker_Fragment
  | MemberPickerComponent_BasicMultiUrlPicker_Fragment
  | MemberPickerComponent_BasicNestedContent_Fragment
  | MemberPickerComponent_BasicPropertyValue_Fragment
  | MemberPickerComponent_BasicRichText_Fragment
  | MemberPickerComponent_BasicUnsupportedPropertyValue_Fragment
  | MemberPickerComponent_MintMediaPicker_Fragment

type MemberPropertyEditorsComponent_BasicBlockGridModel_Fragment = {
  __typename?: "BasicBlockGridModel"
  model: string
}

type MemberPropertyEditorsComponent_BasicBlockListModel_Fragment = {
  __typename?: "BasicBlockListModel"
  model: string
}

type MemberPropertyEditorsComponent_BasicContentPicker_Fragment = {
  __typename?: "BasicContentPicker"
  model: string
  contentList: Array<{
    __typename?: "BasicContentPickerItem"
    id: number
    absoluteUrl: string
    key: any
    name?: string | null
    url: string
    urlSegment?: string | null
  }>
}

type MemberPropertyEditorsComponent_BasicDateTimePicker_Fragment = {
  __typename?: "BasicDateTimePicker"
  model: string
  dateTime?: any | null
}

type MemberPropertyEditorsComponent_BasicLabel_Fragment = {
  __typename?: "BasicLabel"
  model: string
  label?: any | null
}

type MemberPropertyEditorsComponent_BasicMediaPicker_Fragment = {
  __typename?: "BasicMediaPicker"
  model: string
}

type MemberPropertyEditorsComponent_BasicMemberPicker_Fragment = {
  __typename?: "BasicMemberPicker"
  model: string
  members: Array<{
    __typename?: "BasicMemberPickerItem"
    id?: number | null
    name?: string | null
  }>
}

type MemberPropertyEditorsComponent_BasicMultiUrlPicker_Fragment = {
  __typename?: "BasicMultiUrlPicker"
  model: string
  links: Array<{
    __typename?: "BasicMultiUrlPickerItem"
    name?: string | null
    target?: string | null
    type: LinkType
    url?: string | null
  }>
}

type MemberPropertyEditorsComponent_BasicNestedContent_Fragment = {
  __typename?: "BasicNestedContent"
  model: string
  elements?: Array<{
    __typename?: "BasicNestedContentElement"
    properties: Array<{
      __typename?: "BasicProperty"
      alias?: string | null
      editorAlias?: string | null
      value?:
        | { __typename?: "BasicBlockGridModel"; model: string }
        | { __typename?: "BasicBlockListModel"; model: string }
        | {
            __typename?: "BasicContentPicker"
            model: string
            contentList: Array<{
              __typename?: "BasicContentPickerItem"
              id: number
              absoluteUrl: string
              key: any
              name?: string | null
              url: string
              urlSegment?: string | null
            }>
          }
        | {
            __typename?: "BasicDateTimePicker"
            model: string
            dateTime?: any | null
          }
        | { __typename?: "BasicLabel"; model: string; label?: any | null }
        | { __typename?: "BasicMediaPicker"; model: string }
        | {
            __typename?: "BasicMemberPicker"
            model: string
            members: Array<{
              __typename?: "BasicMemberPickerItem"
              id?: number | null
              name?: string | null
            }>
          }
        | {
            __typename?: "BasicMultiUrlPicker"
            model: string
            links: Array<{
              __typename?: "BasicMultiUrlPickerItem"
              name?: string | null
              target?: string | null
              type: LinkType
              url?: string | null
            }>
          }
        | { __typename?: "BasicNestedContent"; model: string }
        | {
            __typename?: "BasicPropertyValue"
            model: string
            value?: any | null
          }
        | {
            __typename?: "BasicRichText"
            model: string
            sourceValue?: string | null
            richText?: string | null
          }
        | {
            __typename?: "BasicUnsupportedPropertyValue"
            model: string
            message: string
          }
        | {
            __typename?: "MintMediaPicker"
            model: string
            mediaItems: Array<{
              __typename?: "MintMediaPickerItem"
              id: number
              url: string
              altText?: string | null
            }>
          }
        | null
    } | null>
  }> | null
}

type MemberPropertyEditorsComponent_BasicPropertyValue_Fragment = {
  __typename?: "BasicPropertyValue"
  model: string
  value?: any | null
}

type MemberPropertyEditorsComponent_BasicRichText_Fragment = {
  __typename?: "BasicRichText"
  model: string
  sourceValue?: string | null
  richText?: string | null
}

type MemberPropertyEditorsComponent_BasicUnsupportedPropertyValue_Fragment = {
  __typename?: "BasicUnsupportedPropertyValue"
  model: string
  message: string
}

type MemberPropertyEditorsComponent_MintMediaPicker_Fragment = {
  __typename?: "MintMediaPicker"
  model: string
  mediaItems: Array<{
    __typename?: "MintMediaPickerItem"
    id: number
    url: string
    altText?: string | null
  }>
}

export type MemberPropertyEditorsComponentFragment =
  | MemberPropertyEditorsComponent_BasicBlockGridModel_Fragment
  | MemberPropertyEditorsComponent_BasicBlockListModel_Fragment
  | MemberPropertyEditorsComponent_BasicContentPicker_Fragment
  | MemberPropertyEditorsComponent_BasicDateTimePicker_Fragment
  | MemberPropertyEditorsComponent_BasicLabel_Fragment
  | MemberPropertyEditorsComponent_BasicMediaPicker_Fragment
  | MemberPropertyEditorsComponent_BasicMemberPicker_Fragment
  | MemberPropertyEditorsComponent_BasicMultiUrlPicker_Fragment
  | MemberPropertyEditorsComponent_BasicNestedContent_Fragment
  | MemberPropertyEditorsComponent_BasicPropertyValue_Fragment
  | MemberPropertyEditorsComponent_BasicRichText_Fragment
  | MemberPropertyEditorsComponent_BasicUnsupportedPropertyValue_Fragment
  | MemberPropertyEditorsComponent_MintMediaPicker_Fragment

type SlimMemberPicker_BasicBlockGridModel_Fragment = {
  __typename?: "BasicBlockGridModel"
}

type SlimMemberPicker_BasicBlockListModel_Fragment = {
  __typename?: "BasicBlockListModel"
}

type SlimMemberPicker_BasicContentPicker_Fragment = {
  __typename?: "BasicContentPicker"
}

type SlimMemberPicker_BasicDateTimePicker_Fragment = {
  __typename?: "BasicDateTimePicker"
}

type SlimMemberPicker_BasicLabel_Fragment = { __typename?: "BasicLabel" }

type SlimMemberPicker_BasicMediaPicker_Fragment = {
  __typename?: "BasicMediaPicker"
}

type SlimMemberPicker_BasicMemberPicker_Fragment = {
  __typename?: "BasicMemberPicker"
  members: Array<{
    __typename?: "BasicMemberPickerItem"
    id?: number | null
    name?: string | null
  }>
}

type SlimMemberPicker_BasicMultiUrlPicker_Fragment = {
  __typename?: "BasicMultiUrlPicker"
}

type SlimMemberPicker_BasicNestedContent_Fragment = {
  __typename?: "BasicNestedContent"
}

type SlimMemberPicker_BasicPropertyValue_Fragment = {
  __typename?: "BasicPropertyValue"
}

type SlimMemberPicker_BasicRichText_Fragment = { __typename?: "BasicRichText" }

type SlimMemberPicker_BasicUnsupportedPropertyValue_Fragment = {
  __typename?: "BasicUnsupportedPropertyValue"
}

type SlimMemberPicker_MintMediaPicker_Fragment = {
  __typename?: "MintMediaPicker"
}

export type SlimMemberPickerFragment =
  | SlimMemberPicker_BasicBlockGridModel_Fragment
  | SlimMemberPicker_BasicBlockListModel_Fragment
  | SlimMemberPicker_BasicContentPicker_Fragment
  | SlimMemberPicker_BasicDateTimePicker_Fragment
  | SlimMemberPicker_BasicLabel_Fragment
  | SlimMemberPicker_BasicMediaPicker_Fragment
  | SlimMemberPicker_BasicMemberPicker_Fragment
  | SlimMemberPicker_BasicMultiUrlPicker_Fragment
  | SlimMemberPicker_BasicNestedContent_Fragment
  | SlimMemberPicker_BasicPropertyValue_Fragment
  | SlimMemberPicker_BasicRichText_Fragment
  | SlimMemberPicker_BasicUnsupportedPropertyValue_Fragment
  | SlimMemberPicker_MintMediaPicker_Fragment

type MultiUrlPicker_BasicBlockGridModel_Fragment = {
  __typename?: "BasicBlockGridModel"
}

type MultiUrlPicker_BasicBlockListModel_Fragment = {
  __typename?: "BasicBlockListModel"
}

type MultiUrlPicker_BasicContentPicker_Fragment = {
  __typename?: "BasicContentPicker"
}

type MultiUrlPicker_BasicDateTimePicker_Fragment = {
  __typename?: "BasicDateTimePicker"
}

type MultiUrlPicker_BasicLabel_Fragment = { __typename?: "BasicLabel" }

type MultiUrlPicker_BasicMediaPicker_Fragment = {
  __typename?: "BasicMediaPicker"
}

type MultiUrlPicker_BasicMemberPicker_Fragment = {
  __typename?: "BasicMemberPicker"
}

type MultiUrlPicker_BasicMultiUrlPicker_Fragment = {
  __typename?: "BasicMultiUrlPicker"
  links: Array<{
    __typename?: "BasicMultiUrlPickerItem"
    name?: string | null
    target?: string | null
    type: LinkType
    url?: string | null
  }>
}

type MultiUrlPicker_BasicNestedContent_Fragment = {
  __typename?: "BasicNestedContent"
}

type MultiUrlPicker_BasicPropertyValue_Fragment = {
  __typename?: "BasicPropertyValue"
}

type MultiUrlPicker_BasicRichText_Fragment = { __typename?: "BasicRichText" }

type MultiUrlPicker_BasicUnsupportedPropertyValue_Fragment = {
  __typename?: "BasicUnsupportedPropertyValue"
}

type MultiUrlPicker_MintMediaPicker_Fragment = {
  __typename?: "MintMediaPicker"
}

export type MultiUrlPickerFragment =
  | MultiUrlPicker_BasicBlockGridModel_Fragment
  | MultiUrlPicker_BasicBlockListModel_Fragment
  | MultiUrlPicker_BasicContentPicker_Fragment
  | MultiUrlPicker_BasicDateTimePicker_Fragment
  | MultiUrlPicker_BasicLabel_Fragment
  | MultiUrlPicker_BasicMediaPicker_Fragment
  | MultiUrlPicker_BasicMemberPicker_Fragment
  | MultiUrlPicker_BasicMultiUrlPicker_Fragment
  | MultiUrlPicker_BasicNestedContent_Fragment
  | MultiUrlPicker_BasicPropertyValue_Fragment
  | MultiUrlPicker_BasicRichText_Fragment
  | MultiUrlPicker_BasicUnsupportedPropertyValue_Fragment
  | MultiUrlPicker_MintMediaPicker_Fragment

type NestedContentComponent_BasicBlockGridModel_Fragment = {
  __typename?: "BasicBlockGridModel"
}

type NestedContentComponent_BasicBlockListModel_Fragment = {
  __typename?: "BasicBlockListModel"
}

type NestedContentComponent_BasicContentPicker_Fragment = {
  __typename?: "BasicContentPicker"
}

type NestedContentComponent_BasicDateTimePicker_Fragment = {
  __typename?: "BasicDateTimePicker"
}

type NestedContentComponent_BasicLabel_Fragment = { __typename?: "BasicLabel" }

type NestedContentComponent_BasicMediaPicker_Fragment = {
  __typename?: "BasicMediaPicker"
}

type NestedContentComponent_BasicMemberPicker_Fragment = {
  __typename?: "BasicMemberPicker"
}

type NestedContentComponent_BasicMultiUrlPicker_Fragment = {
  __typename?: "BasicMultiUrlPicker"
}

type NestedContentComponent_BasicNestedContent_Fragment = {
  __typename?: "BasicNestedContent"
  elements?: Array<{
    __typename?: "BasicNestedContentElement"
    properties: Array<{
      __typename?: "BasicProperty"
      alias?: string | null
      editorAlias?: string | null
      value?:
        | { __typename?: "BasicBlockGridModel"; model: string }
        | { __typename?: "BasicBlockListModel"; model: string }
        | {
            __typename?: "BasicContentPicker"
            model: string
            contentList: Array<{
              __typename?: "BasicContentPickerItem"
              id: number
              absoluteUrl: string
              key: any
              name?: string | null
              url: string
              urlSegment?: string | null
            }>
          }
        | {
            __typename?: "BasicDateTimePicker"
            model: string
            dateTime?: any | null
          }
        | { __typename?: "BasicLabel"; model: string; label?: any | null }
        | { __typename?: "BasicMediaPicker"; model: string }
        | {
            __typename?: "BasicMemberPicker"
            model: string
            members: Array<{
              __typename?: "BasicMemberPickerItem"
              id?: number | null
              name?: string | null
            }>
          }
        | {
            __typename?: "BasicMultiUrlPicker"
            model: string
            links: Array<{
              __typename?: "BasicMultiUrlPickerItem"
              name?: string | null
              target?: string | null
              type: LinkType
              url?: string | null
            }>
          }
        | { __typename?: "BasicNestedContent"; model: string }
        | {
            __typename?: "BasicPropertyValue"
            model: string
            value?: any | null
          }
        | {
            __typename?: "BasicRichText"
            model: string
            sourceValue?: string | null
            richText?: string | null
          }
        | {
            __typename?: "BasicUnsupportedPropertyValue"
            model: string
            message: string
          }
        | {
            __typename?: "MintMediaPicker"
            model: string
            mediaItems: Array<{
              __typename?: "MintMediaPickerItem"
              id: number
              url: string
              altText?: string | null
            }>
          }
        | null
    } | null>
  }> | null
}

type NestedContentComponent_BasicPropertyValue_Fragment = {
  __typename?: "BasicPropertyValue"
}

type NestedContentComponent_BasicRichText_Fragment = {
  __typename?: "BasicRichText"
}

type NestedContentComponent_BasicUnsupportedPropertyValue_Fragment = {
  __typename?: "BasicUnsupportedPropertyValue"
}

type NestedContentComponent_MintMediaPicker_Fragment = {
  __typename?: "MintMediaPicker"
}

export type NestedContentComponentFragment =
  | NestedContentComponent_BasicBlockGridModel_Fragment
  | NestedContentComponent_BasicBlockListModel_Fragment
  | NestedContentComponent_BasicContentPicker_Fragment
  | NestedContentComponent_BasicDateTimePicker_Fragment
  | NestedContentComponent_BasicLabel_Fragment
  | NestedContentComponent_BasicMediaPicker_Fragment
  | NestedContentComponent_BasicMemberPicker_Fragment
  | NestedContentComponent_BasicMultiUrlPicker_Fragment
  | NestedContentComponent_BasicNestedContent_Fragment
  | NestedContentComponent_BasicPropertyValue_Fragment
  | NestedContentComponent_BasicRichText_Fragment
  | NestedContentComponent_BasicUnsupportedPropertyValue_Fragment
  | NestedContentComponent_MintMediaPicker_Fragment

type NestedContentPropertyEditorsComponent_BasicBlockGridModel_Fragment = {
  __typename?: "BasicBlockGridModel"
  model: string
}

type NestedContentPropertyEditorsComponent_BasicBlockListModel_Fragment = {
  __typename?: "BasicBlockListModel"
  model: string
}

type NestedContentPropertyEditorsComponent_BasicContentPicker_Fragment = {
  __typename?: "BasicContentPicker"
  model: string
  contentList: Array<{
    __typename?: "BasicContentPickerItem"
    id: number
    absoluteUrl: string
    key: any
    name?: string | null
    url: string
    urlSegment?: string | null
  }>
}

type NestedContentPropertyEditorsComponent_BasicDateTimePicker_Fragment = {
  __typename?: "BasicDateTimePicker"
  model: string
  dateTime?: any | null
}

type NestedContentPropertyEditorsComponent_BasicLabel_Fragment = {
  __typename?: "BasicLabel"
  model: string
  label?: any | null
}

type NestedContentPropertyEditorsComponent_BasicMediaPicker_Fragment = {
  __typename?: "BasicMediaPicker"
  model: string
}

type NestedContentPropertyEditorsComponent_BasicMemberPicker_Fragment = {
  __typename?: "BasicMemberPicker"
  model: string
  members: Array<{
    __typename?: "BasicMemberPickerItem"
    id?: number | null
    name?: string | null
  }>
}

type NestedContentPropertyEditorsComponent_BasicMultiUrlPicker_Fragment = {
  __typename?: "BasicMultiUrlPicker"
  model: string
  links: Array<{
    __typename?: "BasicMultiUrlPickerItem"
    name?: string | null
    target?: string | null
    type: LinkType
    url?: string | null
  }>
}

type NestedContentPropertyEditorsComponent_BasicNestedContent_Fragment = {
  __typename?: "BasicNestedContent"
  model: string
}

type NestedContentPropertyEditorsComponent_BasicPropertyValue_Fragment = {
  __typename?: "BasicPropertyValue"
  model: string
  value?: any | null
}

type NestedContentPropertyEditorsComponent_BasicRichText_Fragment = {
  __typename?: "BasicRichText"
  model: string
  sourceValue?: string | null
  richText?: string | null
}

type NestedContentPropertyEditorsComponent_BasicUnsupportedPropertyValue_Fragment =
  {
    __typename?: "BasicUnsupportedPropertyValue"
    model: string
    message: string
  }

type NestedContentPropertyEditorsComponent_MintMediaPicker_Fragment = {
  __typename?: "MintMediaPicker"
  model: string
  mediaItems: Array<{
    __typename?: "MintMediaPickerItem"
    id: number
    url: string
    altText?: string | null
  }>
}

export type NestedContentPropertyEditorsComponentFragment =
  | NestedContentPropertyEditorsComponent_BasicBlockGridModel_Fragment
  | NestedContentPropertyEditorsComponent_BasicBlockListModel_Fragment
  | NestedContentPropertyEditorsComponent_BasicContentPicker_Fragment
  | NestedContentPropertyEditorsComponent_BasicDateTimePicker_Fragment
  | NestedContentPropertyEditorsComponent_BasicLabel_Fragment
  | NestedContentPropertyEditorsComponent_BasicMediaPicker_Fragment
  | NestedContentPropertyEditorsComponent_BasicMemberPicker_Fragment
  | NestedContentPropertyEditorsComponent_BasicMultiUrlPicker_Fragment
  | NestedContentPropertyEditorsComponent_BasicNestedContent_Fragment
  | NestedContentPropertyEditorsComponent_BasicPropertyValue_Fragment
  | NestedContentPropertyEditorsComponent_BasicRichText_Fragment
  | NestedContentPropertyEditorsComponent_BasicUnsupportedPropertyValue_Fragment
  | NestedContentPropertyEditorsComponent_MintMediaPicker_Fragment

type RichTextEditorComponent_BasicBlockGridModel_Fragment = {
  __typename?: "BasicBlockGridModel"
}

type RichTextEditorComponent_BasicBlockListModel_Fragment = {
  __typename?: "BasicBlockListModel"
}

type RichTextEditorComponent_BasicContentPicker_Fragment = {
  __typename?: "BasicContentPicker"
}

type RichTextEditorComponent_BasicDateTimePicker_Fragment = {
  __typename?: "BasicDateTimePicker"
}

type RichTextEditorComponent_BasicLabel_Fragment = { __typename?: "BasicLabel" }

type RichTextEditorComponent_BasicMediaPicker_Fragment = {
  __typename?: "BasicMediaPicker"
}

type RichTextEditorComponent_BasicMemberPicker_Fragment = {
  __typename?: "BasicMemberPicker"
}

type RichTextEditorComponent_BasicMultiUrlPicker_Fragment = {
  __typename?: "BasicMultiUrlPicker"
}

type RichTextEditorComponent_BasicNestedContent_Fragment = {
  __typename?: "BasicNestedContent"
}

type RichTextEditorComponent_BasicPropertyValue_Fragment = {
  __typename?: "BasicPropertyValue"
}

type RichTextEditorComponent_BasicRichText_Fragment = {
  __typename?: "BasicRichText"
  sourceValue?: string | null
  richText?: string | null
}

type RichTextEditorComponent_BasicUnsupportedPropertyValue_Fragment = {
  __typename?: "BasicUnsupportedPropertyValue"
}

type RichTextEditorComponent_MintMediaPicker_Fragment = {
  __typename?: "MintMediaPicker"
}

export type RichTextEditorComponentFragment =
  | RichTextEditorComponent_BasicBlockGridModel_Fragment
  | RichTextEditorComponent_BasicBlockListModel_Fragment
  | RichTextEditorComponent_BasicContentPicker_Fragment
  | RichTextEditorComponent_BasicDateTimePicker_Fragment
  | RichTextEditorComponent_BasicLabel_Fragment
  | RichTextEditorComponent_BasicMediaPicker_Fragment
  | RichTextEditorComponent_BasicMemberPicker_Fragment
  | RichTextEditorComponent_BasicMultiUrlPicker_Fragment
  | RichTextEditorComponent_BasicNestedContent_Fragment
  | RichTextEditorComponent_BasicPropertyValue_Fragment
  | RichTextEditorComponent_BasicRichText_Fragment
  | RichTextEditorComponent_BasicUnsupportedPropertyValue_Fragment
  | RichTextEditorComponent_MintMediaPicker_Fragment

type UnsupportedEditor_BasicBlockGridModel_Fragment = {
  __typename?: "BasicBlockGridModel"
}

type UnsupportedEditor_BasicBlockListModel_Fragment = {
  __typename?: "BasicBlockListModel"
}

type UnsupportedEditor_BasicContentPicker_Fragment = {
  __typename?: "BasicContentPicker"
}

type UnsupportedEditor_BasicDateTimePicker_Fragment = {
  __typename?: "BasicDateTimePicker"
}

type UnsupportedEditor_BasicLabel_Fragment = { __typename?: "BasicLabel" }

type UnsupportedEditor_BasicMediaPicker_Fragment = {
  __typename?: "BasicMediaPicker"
}

type UnsupportedEditor_BasicMemberPicker_Fragment = {
  __typename?: "BasicMemberPicker"
}

type UnsupportedEditor_BasicMultiUrlPicker_Fragment = {
  __typename?: "BasicMultiUrlPicker"
}

type UnsupportedEditor_BasicNestedContent_Fragment = {
  __typename?: "BasicNestedContent"
}

type UnsupportedEditor_BasicPropertyValue_Fragment = {
  __typename?: "BasicPropertyValue"
}

type UnsupportedEditor_BasicRichText_Fragment = { __typename?: "BasicRichText" }

type UnsupportedEditor_BasicUnsupportedPropertyValue_Fragment = {
  __typename?: "BasicUnsupportedPropertyValue"
  message: string
}

type UnsupportedEditor_MintMediaPicker_Fragment = {
  __typename?: "MintMediaPicker"
}

export type UnsupportedEditorFragment =
  | UnsupportedEditor_BasicBlockGridModel_Fragment
  | UnsupportedEditor_BasicBlockListModel_Fragment
  | UnsupportedEditor_BasicContentPicker_Fragment
  | UnsupportedEditor_BasicDateTimePicker_Fragment
  | UnsupportedEditor_BasicLabel_Fragment
  | UnsupportedEditor_BasicMediaPicker_Fragment
  | UnsupportedEditor_BasicMemberPicker_Fragment
  | UnsupportedEditor_BasicMultiUrlPicker_Fragment
  | UnsupportedEditor_BasicNestedContent_Fragment
  | UnsupportedEditor_BasicPropertyValue_Fragment
  | UnsupportedEditor_BasicRichText_Fragment
  | UnsupportedEditor_BasicUnsupportedPropertyValue_Fragment
  | UnsupportedEditor_MintMediaPicker_Fragment

type BlockEditorComponent_BasicBlockGridModel_Fragment = {
  __typename?: "BasicBlockGridModel"
}

type BlockEditorComponent_BasicBlockListModel_Fragment = {
  __typename?: "BasicBlockListModel"
  blocks?: Array<{
    __typename?: "BasicBlockListItem"
    blockType?: string | null
    properties: Array<{
      __typename?: "BasicProperty"
      propertyName?: string | null
      propertyValue?:
        | { __typename?: "BasicBlockGridModel"; valueType: string }
        | {
            __typename?: "BasicBlockListModel"
            valueType: string
            blocks?: Array<{
              __typename?: "BasicBlockListItem"
              blockType?: string | null
              properties: Array<{
                __typename?: "BasicProperty"
                propertyName?: string | null
                propertyValue?:
                  | { __typename?: "BasicBlockGridModel"; valueType: string }
                  | {
                      __typename?: "BasicBlockListModel"
                      valueType: string
                      blocks?: Array<{
                        __typename?: "BasicBlockListItem"
                        blockType?: string | null
                        properties: Array<{
                          __typename?: "BasicProperty"
                          propertyName?: string | null
                          propertyValue?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                valueType: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                valueType: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                valueType: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                valueType: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                valueType: string
                                label?: any | null
                              }
                            | {
                                __typename?: "BasicMediaPicker"
                                valueType: string
                              }
                            | {
                                __typename?: "BasicMemberPicker"
                                valueType: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    alias?: string | null
                                    editorAlias?: string | null
                                    value?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          model: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          model: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          model: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          model: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          model: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          model: string
                                          elements?: Array<{
                                            __typename?: "BasicNestedContentElement"
                                            properties: Array<{
                                              __typename?: "BasicProperty"
                                              alias?: string | null
                                              editorAlias?: string | null
                                              value?:
                                                | {
                                                    __typename?: "BasicBlockGridModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicBlockListModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicContentPicker"
                                                    model: string
                                                    contentList: Array<{
                                                      __typename?: "BasicContentPickerItem"
                                                      id: number
                                                      absoluteUrl: string
                                                      key: any
                                                      name?: string | null
                                                      url: string
                                                      urlSegment?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicDateTimePicker"
                                                    model: string
                                                    dateTime?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicLabel"
                                                    model: string
                                                    label?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicMediaPicker"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicMemberPicker"
                                                    model: string
                                                    members: Array<{
                                                      __typename?: "BasicMemberPickerItem"
                                                      id?: number | null
                                                      name?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicMultiUrlPicker"
                                                    model: string
                                                    links: Array<{
                                                      __typename?: "BasicMultiUrlPickerItem"
                                                      name?: string | null
                                                      target?: string | null
                                                      type: LinkType
                                                      url?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicNestedContent"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicPropertyValue"
                                                    model: string
                                                    value?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicRichText"
                                                    model: string
                                                    sourceValue?: string | null
                                                    richText?: string | null
                                                  }
                                                | {
                                                    __typename?: "BasicUnsupportedPropertyValue"
                                                    model: string
                                                    message: string
                                                  }
                                                | {
                                                    __typename?: "MintMediaPicker"
                                                    model: string
                                                    mediaItems: Array<{
                                                      __typename?: "MintMediaPickerItem"
                                                      id: number
                                                      url: string
                                                      altText?: string | null
                                                    }>
                                                  }
                                                | null
                                            } | null>
                                          }> | null
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          model: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          model: string
                                          sourceValue?: string | null
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          model: string
                                          message: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          model: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                valueType: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                valueType: string
                                elements?: Array<{
                                  __typename?: "BasicNestedContentElement"
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    alias?: string | null
                                    editorAlias?: string | null
                                    value?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          model: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          model: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          model: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          model: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          model: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          model: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          model: string
                                          sourceValue?: string | null
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          model: string
                                          message: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          model: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }> | null
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                valueType: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                sourceValue?: string | null
                                valueType: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                message: string
                                valueType: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                valueType: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicContentPicker"
                      valueType: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      valueType: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      valueType: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; valueType: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      valueType: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                                elements?: Array<{
                                  __typename?: "BasicNestedContentElement"
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    alias?: string | null
                                    editorAlias?: string | null
                                    value?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          model: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          model: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          model: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          model: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          model: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          model: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          model: string
                                          sourceValue?: string | null
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          model: string
                                          message: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          model: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }> | null
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                sourceValue?: string | null
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      valueType: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicNestedContent"
                      valueType: string
                      elements?: Array<{
                        __typename?: "BasicNestedContentElement"
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                sourceValue?: string | null
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicPropertyValue"
                      valueType: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      sourceValue?: string | null
                      valueType: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      message: string
                      valueType: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      valueType: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }> | null
          }
        | {
            __typename?: "BasicContentPicker"
            valueType: string
            contentList: Array<{
              __typename?: "BasicContentPickerItem"
              id: number
              absoluteUrl: string
              key: any
              name?: string | null
              url: string
              urlSegment?: string | null
            }>
          }
        | {
            __typename?: "BasicDateTimePicker"
            valueType: string
            dateTime?: any | null
          }
        | { __typename?: "BasicLabel"; valueType: string; label?: any | null }
        | { __typename?: "BasicMediaPicker"; valueType: string }
        | {
            __typename?: "BasicMemberPicker"
            valueType: string
            members: Array<{
              __typename?: "BasicMemberPickerItem"
              id?: number | null
              name?: string | null
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicNestedContent"
                      model: string
                      elements?: Array<{
                        __typename?: "BasicNestedContentElement"
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                sourceValue?: string | null
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      sourceValue?: string | null
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }>
          }
        | {
            __typename?: "BasicMultiUrlPicker"
            valueType: string
            links: Array<{
              __typename?: "BasicMultiUrlPickerItem"
              name?: string | null
              target?: string | null
              type: LinkType
              url?: string | null
            }>
          }
        | {
            __typename?: "BasicNestedContent"
            valueType: string
            elements?: Array<{
              __typename?: "BasicNestedContentElement"
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | { __typename?: "BasicNestedContent"; model: string }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      sourceValue?: string | null
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }> | null
          }
        | {
            __typename?: "BasicPropertyValue"
            valueType: string
            value?: any | null
          }
        | {
            __typename?: "BasicRichText"
            sourceValue?: string | null
            valueType: string
            richText?: string | null
          }
        | {
            __typename?: "BasicUnsupportedPropertyValue"
            message: string
            valueType: string
          }
        | {
            __typename?: "MintMediaPicker"
            valueType: string
            mediaItems: Array<{
              __typename?: "MintMediaPickerItem"
              id: number
              url: string
              altText?: string | null
            }>
          }
        | null
    } | null>
  }> | null
}

type BlockEditorComponent_BasicContentPicker_Fragment = {
  __typename?: "BasicContentPicker"
}

type BlockEditorComponent_BasicDateTimePicker_Fragment = {
  __typename?: "BasicDateTimePicker"
}

type BlockEditorComponent_BasicLabel_Fragment = { __typename?: "BasicLabel" }

type BlockEditorComponent_BasicMediaPicker_Fragment = {
  __typename?: "BasicMediaPicker"
}

type BlockEditorComponent_BasicMemberPicker_Fragment = {
  __typename?: "BasicMemberPicker"
}

type BlockEditorComponent_BasicMultiUrlPicker_Fragment = {
  __typename?: "BasicMultiUrlPicker"
}

type BlockEditorComponent_BasicNestedContent_Fragment = {
  __typename?: "BasicNestedContent"
}

type BlockEditorComponent_BasicPropertyValue_Fragment = {
  __typename?: "BasicPropertyValue"
}

type BlockEditorComponent_BasicRichText_Fragment = {
  __typename?: "BasicRichText"
}

type BlockEditorComponent_BasicUnsupportedPropertyValue_Fragment = {
  __typename?: "BasicUnsupportedPropertyValue"
}

type BlockEditorComponent_MintMediaPicker_Fragment = {
  __typename?: "MintMediaPicker"
}

export type BlockEditorComponentFragment =
  | BlockEditorComponent_BasicBlockGridModel_Fragment
  | BlockEditorComponent_BasicBlockListModel_Fragment
  | BlockEditorComponent_BasicContentPicker_Fragment
  | BlockEditorComponent_BasicDateTimePicker_Fragment
  | BlockEditorComponent_BasicLabel_Fragment
  | BlockEditorComponent_BasicMediaPicker_Fragment
  | BlockEditorComponent_BasicMemberPicker_Fragment
  | BlockEditorComponent_BasicMultiUrlPicker_Fragment
  | BlockEditorComponent_BasicNestedContent_Fragment
  | BlockEditorComponent_BasicPropertyValue_Fragment
  | BlockEditorComponent_BasicRichText_Fragment
  | BlockEditorComponent_BasicUnsupportedPropertyValue_Fragment
  | BlockEditorComponent_MintMediaPicker_Fragment

type BlockGridEditorComponent_BasicBlockGridModel_Fragment = {
  __typename?: "BasicBlockGridModel"
  gridColumns?: number | null
  blocks?: Array<{
    __typename?: "BasicBlockGridItem"
    columnSpan: number
    rowSpan: number
    contentProperties: Array<{
      __typename?: "BasicProperty"
      value?:
        | { __typename?: "BasicBlockGridModel"; valueType: string }
        | { __typename?: "BasicBlockListModel"; valueType: string }
        | {
            __typename?: "BasicContentPicker"
            valueType: string
            contentList: Array<{
              __typename?: "BasicContentPickerItem"
              id: number
              absoluteUrl: string
              key: any
              name?: string | null
              url: string
              urlSegment?: string | null
            }>
          }
        | {
            __typename?: "BasicDateTimePicker"
            valueType: string
            dateTime?: any | null
          }
        | { __typename?: "BasicLabel"; valueType: string; label?: any | null }
        | { __typename?: "BasicMediaPicker"; valueType: string }
        | {
            __typename?: "BasicMemberPicker"
            valueType: string
            members: Array<{
              __typename?: "BasicMemberPickerItem"
              id?: number | null
              name?: string | null
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicNestedContent"
                      model: string
                      elements?: Array<{
                        __typename?: "BasicNestedContentElement"
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                sourceValue?: string | null
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      sourceValue?: string | null
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }>
          }
        | {
            __typename?: "BasicMultiUrlPicker"
            valueType: string
            links: Array<{
              __typename?: "BasicMultiUrlPickerItem"
              name?: string | null
              target?: string | null
              type: LinkType
              url?: string | null
            }>
          }
        | {
            __typename?: "BasicNestedContent"
            valueType: string
            elements?: Array<{
              __typename?: "BasicNestedContentElement"
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | { __typename?: "BasicNestedContent"; model: string }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      sourceValue?: string | null
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }> | null
          }
        | {
            __typename?: "BasicPropertyValue"
            valueType: string
            value?: any | null
          }
        | {
            __typename?: "BasicRichText"
            sourceValue?: string | null
            valueType: string
            richText?: string | null
          }
        | {
            __typename?: "BasicUnsupportedPropertyValue"
            message: string
            valueType: string
          }
        | {
            __typename?: "MintMediaPicker"
            valueType: string
            mediaItems: Array<{
              __typename?: "MintMediaPickerItem"
              id: number
              url: string
              altText?: string | null
            }>
          }
        | null
    } | null>
    settingsProperties: Array<{
      __typename?: "BasicProperty"
      value?:
        | { __typename?: "BasicBlockGridModel"; valueType: string }
        | { __typename?: "BasicBlockListModel"; valueType: string }
        | {
            __typename?: "BasicContentPicker"
            valueType: string
            contentList: Array<{
              __typename?: "BasicContentPickerItem"
              id: number
              absoluteUrl: string
              key: any
              name?: string | null
              url: string
              urlSegment?: string | null
            }>
          }
        | {
            __typename?: "BasicDateTimePicker"
            valueType: string
            dateTime?: any | null
          }
        | { __typename?: "BasicLabel"; valueType: string; label?: any | null }
        | { __typename?: "BasicMediaPicker"; valueType: string }
        | {
            __typename?: "BasicMemberPicker"
            valueType: string
            members: Array<{
              __typename?: "BasicMemberPickerItem"
              id?: number | null
              name?: string | null
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicNestedContent"
                      model: string
                      elements?: Array<{
                        __typename?: "BasicNestedContentElement"
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                sourceValue?: string | null
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      sourceValue?: string | null
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }>
          }
        | {
            __typename?: "BasicMultiUrlPicker"
            valueType: string
            links: Array<{
              __typename?: "BasicMultiUrlPickerItem"
              name?: string | null
              target?: string | null
              type: LinkType
              url?: string | null
            }>
          }
        | {
            __typename?: "BasicNestedContent"
            valueType: string
            elements?: Array<{
              __typename?: "BasicNestedContentElement"
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | { __typename?: "BasicNestedContent"; model: string }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      sourceValue?: string | null
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }> | null
          }
        | {
            __typename?: "BasicPropertyValue"
            valueType: string
            value?: any | null
          }
        | {
            __typename?: "BasicRichText"
            sourceValue?: string | null
            valueType: string
            richText?: string | null
          }
        | {
            __typename?: "BasicUnsupportedPropertyValue"
            message: string
            valueType: string
          }
        | {
            __typename?: "MintMediaPicker"
            valueType: string
            mediaItems: Array<{
              __typename?: "MintMediaPickerItem"
              id: number
              url: string
              altText?: string | null
            }>
          }
        | null
    } | null>
    areas: Array<{
      __typename?: "BasicBlockGridArea"
      alias?: string | null
      rowSpan: number
      columnSpan: number
      blocks?: Array<{
        __typename?: "BasicBlockGridItem"
        columnSpan: number
        rowSpan: number
        contentProperties: Array<{
          __typename?: "BasicProperty"
          value?:
            | { __typename?: "BasicBlockGridModel"; valueType: string }
            | { __typename?: "BasicBlockListModel"; valueType: string }
            | {
                __typename?: "BasicContentPicker"
                valueType: string
                contentList: Array<{
                  __typename?: "BasicContentPickerItem"
                  id: number
                  absoluteUrl: string
                  key: any
                  name?: string | null
                  url: string
                  urlSegment?: string | null
                }>
              }
            | {
                __typename?: "BasicDateTimePicker"
                valueType: string
                dateTime?: any | null
              }
            | {
                __typename?: "BasicLabel"
                valueType: string
                label?: any | null
              }
            | { __typename?: "BasicMediaPicker"; valueType: string }
            | {
                __typename?: "BasicMemberPicker"
                valueType: string
                members: Array<{
                  __typename?: "BasicMemberPickerItem"
                  id?: number | null
                  name?: string | null
                  properties: Array<{
                    __typename?: "BasicProperty"
                    alias?: string | null
                    editorAlias?: string | null
                    value?:
                      | { __typename?: "BasicBlockGridModel"; model: string }
                      | { __typename?: "BasicBlockListModel"; model: string }
                      | {
                          __typename?: "BasicContentPicker"
                          model: string
                          contentList: Array<{
                            __typename?: "BasicContentPickerItem"
                            id: number
                            absoluteUrl: string
                            key: any
                            name?: string | null
                            url: string
                            urlSegment?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicDateTimePicker"
                          model: string
                          dateTime?: any | null
                        }
                      | {
                          __typename?: "BasicLabel"
                          model: string
                          label?: any | null
                        }
                      | { __typename?: "BasicMediaPicker"; model: string }
                      | {
                          __typename?: "BasicMemberPicker"
                          model: string
                          members: Array<{
                            __typename?: "BasicMemberPickerItem"
                            id?: number | null
                            name?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicMultiUrlPicker"
                          model: string
                          links: Array<{
                            __typename?: "BasicMultiUrlPickerItem"
                            name?: string | null
                            target?: string | null
                            type: LinkType
                            url?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicNestedContent"
                          model: string
                          elements?: Array<{
                            __typename?: "BasicNestedContentElement"
                            properties: Array<{
                              __typename?: "BasicProperty"
                              alias?: string | null
                              editorAlias?: string | null
                              value?:
                                | {
                                    __typename?: "BasicBlockGridModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicBlockListModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicContentPicker"
                                    model: string
                                    contentList: Array<{
                                      __typename?: "BasicContentPickerItem"
                                      id: number
                                      absoluteUrl: string
                                      key: any
                                      name?: string | null
                                      url: string
                                      urlSegment?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicDateTimePicker"
                                    model: string
                                    dateTime?: any | null
                                  }
                                | {
                                    __typename?: "BasicLabel"
                                    model: string
                                    label?: any | null
                                  }
                                | {
                                    __typename?: "BasicMediaPicker"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicMemberPicker"
                                    model: string
                                    members: Array<{
                                      __typename?: "BasicMemberPickerItem"
                                      id?: number | null
                                      name?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicMultiUrlPicker"
                                    model: string
                                    links: Array<{
                                      __typename?: "BasicMultiUrlPickerItem"
                                      name?: string | null
                                      target?: string | null
                                      type: LinkType
                                      url?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicNestedContent"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicPropertyValue"
                                    model: string
                                    value?: any | null
                                  }
                                | {
                                    __typename?: "BasicRichText"
                                    model: string
                                    sourceValue?: string | null
                                    richText?: string | null
                                  }
                                | {
                                    __typename?: "BasicUnsupportedPropertyValue"
                                    model: string
                                    message: string
                                  }
                                | {
                                    __typename?: "MintMediaPicker"
                                    model: string
                                    mediaItems: Array<{
                                      __typename?: "MintMediaPickerItem"
                                      id: number
                                      url: string
                                      altText?: string | null
                                    }>
                                  }
                                | null
                            } | null>
                          }> | null
                        }
                      | {
                          __typename?: "BasicPropertyValue"
                          model: string
                          value?: any | null
                        }
                      | {
                          __typename?: "BasicRichText"
                          model: string
                          sourceValue?: string | null
                          richText?: string | null
                        }
                      | {
                          __typename?: "BasicUnsupportedPropertyValue"
                          model: string
                          message: string
                        }
                      | {
                          __typename?: "MintMediaPicker"
                          model: string
                          mediaItems: Array<{
                            __typename?: "MintMediaPickerItem"
                            id: number
                            url: string
                            altText?: string | null
                          }>
                        }
                      | null
                  } | null>
                }>
              }
            | {
                __typename?: "BasicMultiUrlPicker"
                valueType: string
                links: Array<{
                  __typename?: "BasicMultiUrlPickerItem"
                  name?: string | null
                  target?: string | null
                  type: LinkType
                  url?: string | null
                }>
              }
            | {
                __typename?: "BasicNestedContent"
                valueType: string
                elements?: Array<{
                  __typename?: "BasicNestedContentElement"
                  properties: Array<{
                    __typename?: "BasicProperty"
                    alias?: string | null
                    editorAlias?: string | null
                    value?:
                      | { __typename?: "BasicBlockGridModel"; model: string }
                      | { __typename?: "BasicBlockListModel"; model: string }
                      | {
                          __typename?: "BasicContentPicker"
                          model: string
                          contentList: Array<{
                            __typename?: "BasicContentPickerItem"
                            id: number
                            absoluteUrl: string
                            key: any
                            name?: string | null
                            url: string
                            urlSegment?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicDateTimePicker"
                          model: string
                          dateTime?: any | null
                        }
                      | {
                          __typename?: "BasicLabel"
                          model: string
                          label?: any | null
                        }
                      | { __typename?: "BasicMediaPicker"; model: string }
                      | {
                          __typename?: "BasicMemberPicker"
                          model: string
                          members: Array<{
                            __typename?: "BasicMemberPickerItem"
                            id?: number | null
                            name?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicMultiUrlPicker"
                          model: string
                          links: Array<{
                            __typename?: "BasicMultiUrlPickerItem"
                            name?: string | null
                            target?: string | null
                            type: LinkType
                            url?: string | null
                          }>
                        }
                      | { __typename?: "BasicNestedContent"; model: string }
                      | {
                          __typename?: "BasicPropertyValue"
                          model: string
                          value?: any | null
                        }
                      | {
                          __typename?: "BasicRichText"
                          model: string
                          sourceValue?: string | null
                          richText?: string | null
                        }
                      | {
                          __typename?: "BasicUnsupportedPropertyValue"
                          model: string
                          message: string
                        }
                      | {
                          __typename?: "MintMediaPicker"
                          model: string
                          mediaItems: Array<{
                            __typename?: "MintMediaPickerItem"
                            id: number
                            url: string
                            altText?: string | null
                          }>
                        }
                      | null
                  } | null>
                }> | null
              }
            | {
                __typename?: "BasicPropertyValue"
                valueType: string
                value?: any | null
              }
            | {
                __typename?: "BasicRichText"
                sourceValue?: string | null
                valueType: string
                richText?: string | null
              }
            | {
                __typename?: "BasicUnsupportedPropertyValue"
                message: string
                valueType: string
              }
            | {
                __typename?: "MintMediaPicker"
                valueType: string
                mediaItems: Array<{
                  __typename?: "MintMediaPickerItem"
                  id: number
                  url: string
                  altText?: string | null
                }>
              }
            | null
        } | null>
        settingsProperties: Array<{
          __typename?: "BasicProperty"
          value?:
            | { __typename?: "BasicBlockGridModel"; valueType: string }
            | { __typename?: "BasicBlockListModel"; valueType: string }
            | {
                __typename?: "BasicContentPicker"
                valueType: string
                contentList: Array<{
                  __typename?: "BasicContentPickerItem"
                  id: number
                  absoluteUrl: string
                  key: any
                  name?: string | null
                  url: string
                  urlSegment?: string | null
                }>
              }
            | {
                __typename?: "BasicDateTimePicker"
                valueType: string
                dateTime?: any | null
              }
            | {
                __typename?: "BasicLabel"
                valueType: string
                label?: any | null
              }
            | { __typename?: "BasicMediaPicker"; valueType: string }
            | {
                __typename?: "BasicMemberPicker"
                valueType: string
                members: Array<{
                  __typename?: "BasicMemberPickerItem"
                  id?: number | null
                  name?: string | null
                  properties: Array<{
                    __typename?: "BasicProperty"
                    alias?: string | null
                    editorAlias?: string | null
                    value?:
                      | { __typename?: "BasicBlockGridModel"; model: string }
                      | { __typename?: "BasicBlockListModel"; model: string }
                      | {
                          __typename?: "BasicContentPicker"
                          model: string
                          contentList: Array<{
                            __typename?: "BasicContentPickerItem"
                            id: number
                            absoluteUrl: string
                            key: any
                            name?: string | null
                            url: string
                            urlSegment?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicDateTimePicker"
                          model: string
                          dateTime?: any | null
                        }
                      | {
                          __typename?: "BasicLabel"
                          model: string
                          label?: any | null
                        }
                      | { __typename?: "BasicMediaPicker"; model: string }
                      | {
                          __typename?: "BasicMemberPicker"
                          model: string
                          members: Array<{
                            __typename?: "BasicMemberPickerItem"
                            id?: number | null
                            name?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicMultiUrlPicker"
                          model: string
                          links: Array<{
                            __typename?: "BasicMultiUrlPickerItem"
                            name?: string | null
                            target?: string | null
                            type: LinkType
                            url?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicNestedContent"
                          model: string
                          elements?: Array<{
                            __typename?: "BasicNestedContentElement"
                            properties: Array<{
                              __typename?: "BasicProperty"
                              alias?: string | null
                              editorAlias?: string | null
                              value?:
                                | {
                                    __typename?: "BasicBlockGridModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicBlockListModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicContentPicker"
                                    model: string
                                    contentList: Array<{
                                      __typename?: "BasicContentPickerItem"
                                      id: number
                                      absoluteUrl: string
                                      key: any
                                      name?: string | null
                                      url: string
                                      urlSegment?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicDateTimePicker"
                                    model: string
                                    dateTime?: any | null
                                  }
                                | {
                                    __typename?: "BasicLabel"
                                    model: string
                                    label?: any | null
                                  }
                                | {
                                    __typename?: "BasicMediaPicker"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicMemberPicker"
                                    model: string
                                    members: Array<{
                                      __typename?: "BasicMemberPickerItem"
                                      id?: number | null
                                      name?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicMultiUrlPicker"
                                    model: string
                                    links: Array<{
                                      __typename?: "BasicMultiUrlPickerItem"
                                      name?: string | null
                                      target?: string | null
                                      type: LinkType
                                      url?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicNestedContent"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicPropertyValue"
                                    model: string
                                    value?: any | null
                                  }
                                | {
                                    __typename?: "BasicRichText"
                                    model: string
                                    sourceValue?: string | null
                                    richText?: string | null
                                  }
                                | {
                                    __typename?: "BasicUnsupportedPropertyValue"
                                    model: string
                                    message: string
                                  }
                                | {
                                    __typename?: "MintMediaPicker"
                                    model: string
                                    mediaItems: Array<{
                                      __typename?: "MintMediaPickerItem"
                                      id: number
                                      url: string
                                      altText?: string | null
                                    }>
                                  }
                                | null
                            } | null>
                          }> | null
                        }
                      | {
                          __typename?: "BasicPropertyValue"
                          model: string
                          value?: any | null
                        }
                      | {
                          __typename?: "BasicRichText"
                          model: string
                          sourceValue?: string | null
                          richText?: string | null
                        }
                      | {
                          __typename?: "BasicUnsupportedPropertyValue"
                          model: string
                          message: string
                        }
                      | {
                          __typename?: "MintMediaPicker"
                          model: string
                          mediaItems: Array<{
                            __typename?: "MintMediaPickerItem"
                            id: number
                            url: string
                            altText?: string | null
                          }>
                        }
                      | null
                  } | null>
                }>
              }
            | {
                __typename?: "BasicMultiUrlPicker"
                valueType: string
                links: Array<{
                  __typename?: "BasicMultiUrlPickerItem"
                  name?: string | null
                  target?: string | null
                  type: LinkType
                  url?: string | null
                }>
              }
            | {
                __typename?: "BasicNestedContent"
                valueType: string
                elements?: Array<{
                  __typename?: "BasicNestedContentElement"
                  properties: Array<{
                    __typename?: "BasicProperty"
                    alias?: string | null
                    editorAlias?: string | null
                    value?:
                      | { __typename?: "BasicBlockGridModel"; model: string }
                      | { __typename?: "BasicBlockListModel"; model: string }
                      | {
                          __typename?: "BasicContentPicker"
                          model: string
                          contentList: Array<{
                            __typename?: "BasicContentPickerItem"
                            id: number
                            absoluteUrl: string
                            key: any
                            name?: string | null
                            url: string
                            urlSegment?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicDateTimePicker"
                          model: string
                          dateTime?: any | null
                        }
                      | {
                          __typename?: "BasicLabel"
                          model: string
                          label?: any | null
                        }
                      | { __typename?: "BasicMediaPicker"; model: string }
                      | {
                          __typename?: "BasicMemberPicker"
                          model: string
                          members: Array<{
                            __typename?: "BasicMemberPickerItem"
                            id?: number | null
                            name?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicMultiUrlPicker"
                          model: string
                          links: Array<{
                            __typename?: "BasicMultiUrlPickerItem"
                            name?: string | null
                            target?: string | null
                            type: LinkType
                            url?: string | null
                          }>
                        }
                      | { __typename?: "BasicNestedContent"; model: string }
                      | {
                          __typename?: "BasicPropertyValue"
                          model: string
                          value?: any | null
                        }
                      | {
                          __typename?: "BasicRichText"
                          model: string
                          sourceValue?: string | null
                          richText?: string | null
                        }
                      | {
                          __typename?: "BasicUnsupportedPropertyValue"
                          model: string
                          message: string
                        }
                      | {
                          __typename?: "MintMediaPicker"
                          model: string
                          mediaItems: Array<{
                            __typename?: "MintMediaPickerItem"
                            id: number
                            url: string
                            altText?: string | null
                          }>
                        }
                      | null
                  } | null>
                }> | null
              }
            | {
                __typename?: "BasicPropertyValue"
                valueType: string
                value?: any | null
              }
            | {
                __typename?: "BasicRichText"
                sourceValue?: string | null
                valueType: string
                richText?: string | null
              }
            | {
                __typename?: "BasicUnsupportedPropertyValue"
                message: string
                valueType: string
              }
            | {
                __typename?: "MintMediaPicker"
                valueType: string
                mediaItems: Array<{
                  __typename?: "MintMediaPickerItem"
                  id: number
                  url: string
                  altText?: string | null
                }>
              }
            | null
        } | null>
        areas: Array<{
          __typename?: "BasicBlockGridArea"
          alias?: string | null
          rowSpan: number
          columnSpan: number
        } | null>
      }> | null
    } | null>
  }> | null
}

type BlockGridEditorComponent_BasicBlockListModel_Fragment = {
  __typename?: "BasicBlockListModel"
}

type BlockGridEditorComponent_BasicContentPicker_Fragment = {
  __typename?: "BasicContentPicker"
}

type BlockGridEditorComponent_BasicDateTimePicker_Fragment = {
  __typename?: "BasicDateTimePicker"
}

type BlockGridEditorComponent_BasicLabel_Fragment = {
  __typename?: "BasicLabel"
}

type BlockGridEditorComponent_BasicMediaPicker_Fragment = {
  __typename?: "BasicMediaPicker"
}

type BlockGridEditorComponent_BasicMemberPicker_Fragment = {
  __typename?: "BasicMemberPicker"
}

type BlockGridEditorComponent_BasicMultiUrlPicker_Fragment = {
  __typename?: "BasicMultiUrlPicker"
}

type BlockGridEditorComponent_BasicNestedContent_Fragment = {
  __typename?: "BasicNestedContent"
}

type BlockGridEditorComponent_BasicPropertyValue_Fragment = {
  __typename?: "BasicPropertyValue"
}

type BlockGridEditorComponent_BasicRichText_Fragment = {
  __typename?: "BasicRichText"
}

type BlockGridEditorComponent_BasicUnsupportedPropertyValue_Fragment = {
  __typename?: "BasicUnsupportedPropertyValue"
}

type BlockGridEditorComponent_MintMediaPicker_Fragment = {
  __typename?: "MintMediaPicker"
}

export type BlockGridEditorComponentFragment =
  | BlockGridEditorComponent_BasicBlockGridModel_Fragment
  | BlockGridEditorComponent_BasicBlockListModel_Fragment
  | BlockGridEditorComponent_BasicContentPicker_Fragment
  | BlockGridEditorComponent_BasicDateTimePicker_Fragment
  | BlockGridEditorComponent_BasicLabel_Fragment
  | BlockGridEditorComponent_BasicMediaPicker_Fragment
  | BlockGridEditorComponent_BasicMemberPicker_Fragment
  | BlockGridEditorComponent_BasicMultiUrlPicker_Fragment
  | BlockGridEditorComponent_BasicNestedContent_Fragment
  | BlockGridEditorComponent_BasicPropertyValue_Fragment
  | BlockGridEditorComponent_BasicRichText_Fragment
  | BlockGridEditorComponent_BasicUnsupportedPropertyValue_Fragment
  | BlockGridEditorComponent_MintMediaPicker_Fragment

type PropertyValuesComponent_BasicBlockGridModel_Fragment = {
  __typename?: "BasicBlockGridModel"
  gridColumns?: number | null
  valueType: string
  blocks?: Array<{
    __typename?: "BasicBlockGridItem"
    columnSpan: number
    rowSpan: number
    contentProperties: Array<{
      __typename?: "BasicProperty"
      value?:
        | { __typename?: "BasicBlockGridModel"; valueType: string }
        | { __typename?: "BasicBlockListModel"; valueType: string }
        | {
            __typename?: "BasicContentPicker"
            valueType: string
            contentList: Array<{
              __typename?: "BasicContentPickerItem"
              id: number
              absoluteUrl: string
              key: any
              name?: string | null
              url: string
              urlSegment?: string | null
            }>
          }
        | {
            __typename?: "BasicDateTimePicker"
            valueType: string
            dateTime?: any | null
          }
        | { __typename?: "BasicLabel"; valueType: string; label?: any | null }
        | { __typename?: "BasicMediaPicker"; valueType: string }
        | {
            __typename?: "BasicMemberPicker"
            valueType: string
            members: Array<{
              __typename?: "BasicMemberPickerItem"
              id?: number | null
              name?: string | null
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicNestedContent"
                      model: string
                      elements?: Array<{
                        __typename?: "BasicNestedContentElement"
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                sourceValue?: string | null
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      sourceValue?: string | null
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }>
          }
        | {
            __typename?: "BasicMultiUrlPicker"
            valueType: string
            links: Array<{
              __typename?: "BasicMultiUrlPickerItem"
              name?: string | null
              target?: string | null
              type: LinkType
              url?: string | null
            }>
          }
        | {
            __typename?: "BasicNestedContent"
            valueType: string
            elements?: Array<{
              __typename?: "BasicNestedContentElement"
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | { __typename?: "BasicNestedContent"; model: string }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      sourceValue?: string | null
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }> | null
          }
        | {
            __typename?: "BasicPropertyValue"
            valueType: string
            value?: any | null
          }
        | {
            __typename?: "BasicRichText"
            sourceValue?: string | null
            valueType: string
            richText?: string | null
          }
        | {
            __typename?: "BasicUnsupportedPropertyValue"
            message: string
            valueType: string
          }
        | {
            __typename?: "MintMediaPicker"
            valueType: string
            mediaItems: Array<{
              __typename?: "MintMediaPickerItem"
              id: number
              url: string
              altText?: string | null
            }>
          }
        | null
    } | null>
    settingsProperties: Array<{
      __typename?: "BasicProperty"
      value?:
        | { __typename?: "BasicBlockGridModel"; valueType: string }
        | { __typename?: "BasicBlockListModel"; valueType: string }
        | {
            __typename?: "BasicContentPicker"
            valueType: string
            contentList: Array<{
              __typename?: "BasicContentPickerItem"
              id: number
              absoluteUrl: string
              key: any
              name?: string | null
              url: string
              urlSegment?: string | null
            }>
          }
        | {
            __typename?: "BasicDateTimePicker"
            valueType: string
            dateTime?: any | null
          }
        | { __typename?: "BasicLabel"; valueType: string; label?: any | null }
        | { __typename?: "BasicMediaPicker"; valueType: string }
        | {
            __typename?: "BasicMemberPicker"
            valueType: string
            members: Array<{
              __typename?: "BasicMemberPickerItem"
              id?: number | null
              name?: string | null
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicNestedContent"
                      model: string
                      elements?: Array<{
                        __typename?: "BasicNestedContentElement"
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                sourceValue?: string | null
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      sourceValue?: string | null
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }>
          }
        | {
            __typename?: "BasicMultiUrlPicker"
            valueType: string
            links: Array<{
              __typename?: "BasicMultiUrlPickerItem"
              name?: string | null
              target?: string | null
              type: LinkType
              url?: string | null
            }>
          }
        | {
            __typename?: "BasicNestedContent"
            valueType: string
            elements?: Array<{
              __typename?: "BasicNestedContentElement"
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | { __typename?: "BasicNestedContent"; model: string }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      sourceValue?: string | null
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }> | null
          }
        | {
            __typename?: "BasicPropertyValue"
            valueType: string
            value?: any | null
          }
        | {
            __typename?: "BasicRichText"
            sourceValue?: string | null
            valueType: string
            richText?: string | null
          }
        | {
            __typename?: "BasicUnsupportedPropertyValue"
            message: string
            valueType: string
          }
        | {
            __typename?: "MintMediaPicker"
            valueType: string
            mediaItems: Array<{
              __typename?: "MintMediaPickerItem"
              id: number
              url: string
              altText?: string | null
            }>
          }
        | null
    } | null>
    areas: Array<{
      __typename?: "BasicBlockGridArea"
      alias?: string | null
      rowSpan: number
      columnSpan: number
      blocks?: Array<{
        __typename?: "BasicBlockGridItem"
        columnSpan: number
        rowSpan: number
        contentProperties: Array<{
          __typename?: "BasicProperty"
          value?:
            | { __typename?: "BasicBlockGridModel"; valueType: string }
            | { __typename?: "BasicBlockListModel"; valueType: string }
            | {
                __typename?: "BasicContentPicker"
                valueType: string
                contentList: Array<{
                  __typename?: "BasicContentPickerItem"
                  id: number
                  absoluteUrl: string
                  key: any
                  name?: string | null
                  url: string
                  urlSegment?: string | null
                }>
              }
            | {
                __typename?: "BasicDateTimePicker"
                valueType: string
                dateTime?: any | null
              }
            | {
                __typename?: "BasicLabel"
                valueType: string
                label?: any | null
              }
            | { __typename?: "BasicMediaPicker"; valueType: string }
            | {
                __typename?: "BasicMemberPicker"
                valueType: string
                members: Array<{
                  __typename?: "BasicMemberPickerItem"
                  id?: number | null
                  name?: string | null
                  properties: Array<{
                    __typename?: "BasicProperty"
                    alias?: string | null
                    editorAlias?: string | null
                    value?:
                      | { __typename?: "BasicBlockGridModel"; model: string }
                      | { __typename?: "BasicBlockListModel"; model: string }
                      | {
                          __typename?: "BasicContentPicker"
                          model: string
                          contentList: Array<{
                            __typename?: "BasicContentPickerItem"
                            id: number
                            absoluteUrl: string
                            key: any
                            name?: string | null
                            url: string
                            urlSegment?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicDateTimePicker"
                          model: string
                          dateTime?: any | null
                        }
                      | {
                          __typename?: "BasicLabel"
                          model: string
                          label?: any | null
                        }
                      | { __typename?: "BasicMediaPicker"; model: string }
                      | {
                          __typename?: "BasicMemberPicker"
                          model: string
                          members: Array<{
                            __typename?: "BasicMemberPickerItem"
                            id?: number | null
                            name?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicMultiUrlPicker"
                          model: string
                          links: Array<{
                            __typename?: "BasicMultiUrlPickerItem"
                            name?: string | null
                            target?: string | null
                            type: LinkType
                            url?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicNestedContent"
                          model: string
                          elements?: Array<{
                            __typename?: "BasicNestedContentElement"
                            properties: Array<{
                              __typename?: "BasicProperty"
                              alias?: string | null
                              editorAlias?: string | null
                              value?:
                                | {
                                    __typename?: "BasicBlockGridModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicBlockListModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicContentPicker"
                                    model: string
                                    contentList: Array<{
                                      __typename?: "BasicContentPickerItem"
                                      id: number
                                      absoluteUrl: string
                                      key: any
                                      name?: string | null
                                      url: string
                                      urlSegment?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicDateTimePicker"
                                    model: string
                                    dateTime?: any | null
                                  }
                                | {
                                    __typename?: "BasicLabel"
                                    model: string
                                    label?: any | null
                                  }
                                | {
                                    __typename?: "BasicMediaPicker"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicMemberPicker"
                                    model: string
                                    members: Array<{
                                      __typename?: "BasicMemberPickerItem"
                                      id?: number | null
                                      name?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicMultiUrlPicker"
                                    model: string
                                    links: Array<{
                                      __typename?: "BasicMultiUrlPickerItem"
                                      name?: string | null
                                      target?: string | null
                                      type: LinkType
                                      url?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicNestedContent"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicPropertyValue"
                                    model: string
                                    value?: any | null
                                  }
                                | {
                                    __typename?: "BasicRichText"
                                    model: string
                                    sourceValue?: string | null
                                    richText?: string | null
                                  }
                                | {
                                    __typename?: "BasicUnsupportedPropertyValue"
                                    model: string
                                    message: string
                                  }
                                | {
                                    __typename?: "MintMediaPicker"
                                    model: string
                                    mediaItems: Array<{
                                      __typename?: "MintMediaPickerItem"
                                      id: number
                                      url: string
                                      altText?: string | null
                                    }>
                                  }
                                | null
                            } | null>
                          }> | null
                        }
                      | {
                          __typename?: "BasicPropertyValue"
                          model: string
                          value?: any | null
                        }
                      | {
                          __typename?: "BasicRichText"
                          model: string
                          sourceValue?: string | null
                          richText?: string | null
                        }
                      | {
                          __typename?: "BasicUnsupportedPropertyValue"
                          model: string
                          message: string
                        }
                      | {
                          __typename?: "MintMediaPicker"
                          model: string
                          mediaItems: Array<{
                            __typename?: "MintMediaPickerItem"
                            id: number
                            url: string
                            altText?: string | null
                          }>
                        }
                      | null
                  } | null>
                }>
              }
            | {
                __typename?: "BasicMultiUrlPicker"
                valueType: string
                links: Array<{
                  __typename?: "BasicMultiUrlPickerItem"
                  name?: string | null
                  target?: string | null
                  type: LinkType
                  url?: string | null
                }>
              }
            | {
                __typename?: "BasicNestedContent"
                valueType: string
                elements?: Array<{
                  __typename?: "BasicNestedContentElement"
                  properties: Array<{
                    __typename?: "BasicProperty"
                    alias?: string | null
                    editorAlias?: string | null
                    value?:
                      | { __typename?: "BasicBlockGridModel"; model: string }
                      | { __typename?: "BasicBlockListModel"; model: string }
                      | {
                          __typename?: "BasicContentPicker"
                          model: string
                          contentList: Array<{
                            __typename?: "BasicContentPickerItem"
                            id: number
                            absoluteUrl: string
                            key: any
                            name?: string | null
                            url: string
                            urlSegment?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicDateTimePicker"
                          model: string
                          dateTime?: any | null
                        }
                      | {
                          __typename?: "BasicLabel"
                          model: string
                          label?: any | null
                        }
                      | { __typename?: "BasicMediaPicker"; model: string }
                      | {
                          __typename?: "BasicMemberPicker"
                          model: string
                          members: Array<{
                            __typename?: "BasicMemberPickerItem"
                            id?: number | null
                            name?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicMultiUrlPicker"
                          model: string
                          links: Array<{
                            __typename?: "BasicMultiUrlPickerItem"
                            name?: string | null
                            target?: string | null
                            type: LinkType
                            url?: string | null
                          }>
                        }
                      | { __typename?: "BasicNestedContent"; model: string }
                      | {
                          __typename?: "BasicPropertyValue"
                          model: string
                          value?: any | null
                        }
                      | {
                          __typename?: "BasicRichText"
                          model: string
                          sourceValue?: string | null
                          richText?: string | null
                        }
                      | {
                          __typename?: "BasicUnsupportedPropertyValue"
                          model: string
                          message: string
                        }
                      | {
                          __typename?: "MintMediaPicker"
                          model: string
                          mediaItems: Array<{
                            __typename?: "MintMediaPickerItem"
                            id: number
                            url: string
                            altText?: string | null
                          }>
                        }
                      | null
                  } | null>
                }> | null
              }
            | {
                __typename?: "BasicPropertyValue"
                valueType: string
                value?: any | null
              }
            | {
                __typename?: "BasicRichText"
                sourceValue?: string | null
                valueType: string
                richText?: string | null
              }
            | {
                __typename?: "BasicUnsupportedPropertyValue"
                message: string
                valueType: string
              }
            | {
                __typename?: "MintMediaPicker"
                valueType: string
                mediaItems: Array<{
                  __typename?: "MintMediaPickerItem"
                  id: number
                  url: string
                  altText?: string | null
                }>
              }
            | null
        } | null>
        settingsProperties: Array<{
          __typename?: "BasicProperty"
          value?:
            | { __typename?: "BasicBlockGridModel"; valueType: string }
            | { __typename?: "BasicBlockListModel"; valueType: string }
            | {
                __typename?: "BasicContentPicker"
                valueType: string
                contentList: Array<{
                  __typename?: "BasicContentPickerItem"
                  id: number
                  absoluteUrl: string
                  key: any
                  name?: string | null
                  url: string
                  urlSegment?: string | null
                }>
              }
            | {
                __typename?: "BasicDateTimePicker"
                valueType: string
                dateTime?: any | null
              }
            | {
                __typename?: "BasicLabel"
                valueType: string
                label?: any | null
              }
            | { __typename?: "BasicMediaPicker"; valueType: string }
            | {
                __typename?: "BasicMemberPicker"
                valueType: string
                members: Array<{
                  __typename?: "BasicMemberPickerItem"
                  id?: number | null
                  name?: string | null
                  properties: Array<{
                    __typename?: "BasicProperty"
                    alias?: string | null
                    editorAlias?: string | null
                    value?:
                      | { __typename?: "BasicBlockGridModel"; model: string }
                      | { __typename?: "BasicBlockListModel"; model: string }
                      | {
                          __typename?: "BasicContentPicker"
                          model: string
                          contentList: Array<{
                            __typename?: "BasicContentPickerItem"
                            id: number
                            absoluteUrl: string
                            key: any
                            name?: string | null
                            url: string
                            urlSegment?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicDateTimePicker"
                          model: string
                          dateTime?: any | null
                        }
                      | {
                          __typename?: "BasicLabel"
                          model: string
                          label?: any | null
                        }
                      | { __typename?: "BasicMediaPicker"; model: string }
                      | {
                          __typename?: "BasicMemberPicker"
                          model: string
                          members: Array<{
                            __typename?: "BasicMemberPickerItem"
                            id?: number | null
                            name?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicMultiUrlPicker"
                          model: string
                          links: Array<{
                            __typename?: "BasicMultiUrlPickerItem"
                            name?: string | null
                            target?: string | null
                            type: LinkType
                            url?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicNestedContent"
                          model: string
                          elements?: Array<{
                            __typename?: "BasicNestedContentElement"
                            properties: Array<{
                              __typename?: "BasicProperty"
                              alias?: string | null
                              editorAlias?: string | null
                              value?:
                                | {
                                    __typename?: "BasicBlockGridModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicBlockListModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicContentPicker"
                                    model: string
                                    contentList: Array<{
                                      __typename?: "BasicContentPickerItem"
                                      id: number
                                      absoluteUrl: string
                                      key: any
                                      name?: string | null
                                      url: string
                                      urlSegment?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicDateTimePicker"
                                    model: string
                                    dateTime?: any | null
                                  }
                                | {
                                    __typename?: "BasicLabel"
                                    model: string
                                    label?: any | null
                                  }
                                | {
                                    __typename?: "BasicMediaPicker"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicMemberPicker"
                                    model: string
                                    members: Array<{
                                      __typename?: "BasicMemberPickerItem"
                                      id?: number | null
                                      name?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicMultiUrlPicker"
                                    model: string
                                    links: Array<{
                                      __typename?: "BasicMultiUrlPickerItem"
                                      name?: string | null
                                      target?: string | null
                                      type: LinkType
                                      url?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicNestedContent"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicPropertyValue"
                                    model: string
                                    value?: any | null
                                  }
                                | {
                                    __typename?: "BasicRichText"
                                    model: string
                                    sourceValue?: string | null
                                    richText?: string | null
                                  }
                                | {
                                    __typename?: "BasicUnsupportedPropertyValue"
                                    model: string
                                    message: string
                                  }
                                | {
                                    __typename?: "MintMediaPicker"
                                    model: string
                                    mediaItems: Array<{
                                      __typename?: "MintMediaPickerItem"
                                      id: number
                                      url: string
                                      altText?: string | null
                                    }>
                                  }
                                | null
                            } | null>
                          }> | null
                        }
                      | {
                          __typename?: "BasicPropertyValue"
                          model: string
                          value?: any | null
                        }
                      | {
                          __typename?: "BasicRichText"
                          model: string
                          sourceValue?: string | null
                          richText?: string | null
                        }
                      | {
                          __typename?: "BasicUnsupportedPropertyValue"
                          model: string
                          message: string
                        }
                      | {
                          __typename?: "MintMediaPicker"
                          model: string
                          mediaItems: Array<{
                            __typename?: "MintMediaPickerItem"
                            id: number
                            url: string
                            altText?: string | null
                          }>
                        }
                      | null
                  } | null>
                }>
              }
            | {
                __typename?: "BasicMultiUrlPicker"
                valueType: string
                links: Array<{
                  __typename?: "BasicMultiUrlPickerItem"
                  name?: string | null
                  target?: string | null
                  type: LinkType
                  url?: string | null
                }>
              }
            | {
                __typename?: "BasicNestedContent"
                valueType: string
                elements?: Array<{
                  __typename?: "BasicNestedContentElement"
                  properties: Array<{
                    __typename?: "BasicProperty"
                    alias?: string | null
                    editorAlias?: string | null
                    value?:
                      | { __typename?: "BasicBlockGridModel"; model: string }
                      | { __typename?: "BasicBlockListModel"; model: string }
                      | {
                          __typename?: "BasicContentPicker"
                          model: string
                          contentList: Array<{
                            __typename?: "BasicContentPickerItem"
                            id: number
                            absoluteUrl: string
                            key: any
                            name?: string | null
                            url: string
                            urlSegment?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicDateTimePicker"
                          model: string
                          dateTime?: any | null
                        }
                      | {
                          __typename?: "BasicLabel"
                          model: string
                          label?: any | null
                        }
                      | { __typename?: "BasicMediaPicker"; model: string }
                      | {
                          __typename?: "BasicMemberPicker"
                          model: string
                          members: Array<{
                            __typename?: "BasicMemberPickerItem"
                            id?: number | null
                            name?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicMultiUrlPicker"
                          model: string
                          links: Array<{
                            __typename?: "BasicMultiUrlPickerItem"
                            name?: string | null
                            target?: string | null
                            type: LinkType
                            url?: string | null
                          }>
                        }
                      | { __typename?: "BasicNestedContent"; model: string }
                      | {
                          __typename?: "BasicPropertyValue"
                          model: string
                          value?: any | null
                        }
                      | {
                          __typename?: "BasicRichText"
                          model: string
                          sourceValue?: string | null
                          richText?: string | null
                        }
                      | {
                          __typename?: "BasicUnsupportedPropertyValue"
                          model: string
                          message: string
                        }
                      | {
                          __typename?: "MintMediaPicker"
                          model: string
                          mediaItems: Array<{
                            __typename?: "MintMediaPickerItem"
                            id: number
                            url: string
                            altText?: string | null
                          }>
                        }
                      | null
                  } | null>
                }> | null
              }
            | {
                __typename?: "BasicPropertyValue"
                valueType: string
                value?: any | null
              }
            | {
                __typename?: "BasicRichText"
                sourceValue?: string | null
                valueType: string
                richText?: string | null
              }
            | {
                __typename?: "BasicUnsupportedPropertyValue"
                message: string
                valueType: string
              }
            | {
                __typename?: "MintMediaPicker"
                valueType: string
                mediaItems: Array<{
                  __typename?: "MintMediaPickerItem"
                  id: number
                  url: string
                  altText?: string | null
                }>
              }
            | null
        } | null>
        areas: Array<{
          __typename?: "BasicBlockGridArea"
          alias?: string | null
          rowSpan: number
          columnSpan: number
        } | null>
      }> | null
    } | null>
  }> | null
}

type PropertyValuesComponent_BasicBlockListModel_Fragment = {
  __typename?: "BasicBlockListModel"
  valueType: string
  blocks?: Array<{
    __typename?: "BasicBlockListItem"
    blockType?: string | null
    properties: Array<{
      __typename?: "BasicProperty"
      propertyName?: string | null
      propertyValue?:
        | { __typename?: "BasicBlockGridModel"; valueType: string }
        | {
            __typename?: "BasicBlockListModel"
            valueType: string
            blocks?: Array<{
              __typename?: "BasicBlockListItem"
              blockType?: string | null
              properties: Array<{
                __typename?: "BasicProperty"
                propertyName?: string | null
                propertyValue?:
                  | { __typename?: "BasicBlockGridModel"; valueType: string }
                  | {
                      __typename?: "BasicBlockListModel"
                      valueType: string
                      blocks?: Array<{
                        __typename?: "BasicBlockListItem"
                        blockType?: string | null
                        properties: Array<{
                          __typename?: "BasicProperty"
                          propertyName?: string | null
                          propertyValue?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                valueType: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                valueType: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                valueType: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                valueType: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                valueType: string
                                label?: any | null
                              }
                            | {
                                __typename?: "BasicMediaPicker"
                                valueType: string
                              }
                            | {
                                __typename?: "BasicMemberPicker"
                                valueType: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    alias?: string | null
                                    editorAlias?: string | null
                                    value?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          model: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          model: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          model: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          model: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          model: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          model: string
                                          elements?: Array<{
                                            __typename?: "BasicNestedContentElement"
                                            properties: Array<{
                                              __typename?: "BasicProperty"
                                              alias?: string | null
                                              editorAlias?: string | null
                                              value?:
                                                | {
                                                    __typename?: "BasicBlockGridModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicBlockListModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicContentPicker"
                                                    model: string
                                                    contentList: Array<{
                                                      __typename?: "BasicContentPickerItem"
                                                      id: number
                                                      absoluteUrl: string
                                                      key: any
                                                      name?: string | null
                                                      url: string
                                                      urlSegment?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicDateTimePicker"
                                                    model: string
                                                    dateTime?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicLabel"
                                                    model: string
                                                    label?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicMediaPicker"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicMemberPicker"
                                                    model: string
                                                    members: Array<{
                                                      __typename?: "BasicMemberPickerItem"
                                                      id?: number | null
                                                      name?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicMultiUrlPicker"
                                                    model: string
                                                    links: Array<{
                                                      __typename?: "BasicMultiUrlPickerItem"
                                                      name?: string | null
                                                      target?: string | null
                                                      type: LinkType
                                                      url?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicNestedContent"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicPropertyValue"
                                                    model: string
                                                    value?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicRichText"
                                                    model: string
                                                    sourceValue?: string | null
                                                    richText?: string | null
                                                  }
                                                | {
                                                    __typename?: "BasicUnsupportedPropertyValue"
                                                    model: string
                                                    message: string
                                                  }
                                                | {
                                                    __typename?: "MintMediaPicker"
                                                    model: string
                                                    mediaItems: Array<{
                                                      __typename?: "MintMediaPickerItem"
                                                      id: number
                                                      url: string
                                                      altText?: string | null
                                                    }>
                                                  }
                                                | null
                                            } | null>
                                          }> | null
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          model: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          model: string
                                          sourceValue?: string | null
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          model: string
                                          message: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          model: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                valueType: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                valueType: string
                                elements?: Array<{
                                  __typename?: "BasicNestedContentElement"
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    alias?: string | null
                                    editorAlias?: string | null
                                    value?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          model: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          model: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          model: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          model: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          model: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          model: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          model: string
                                          sourceValue?: string | null
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          model: string
                                          message: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          model: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }> | null
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                valueType: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                sourceValue?: string | null
                                valueType: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                message: string
                                valueType: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                valueType: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicContentPicker"
                      valueType: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      valueType: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      valueType: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; valueType: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      valueType: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                                elements?: Array<{
                                  __typename?: "BasicNestedContentElement"
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    alias?: string | null
                                    editorAlias?: string | null
                                    value?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          model: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          model: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          model: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          model: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          model: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          model: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          model: string
                                          sourceValue?: string | null
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          model: string
                                          message: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          model: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }> | null
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                sourceValue?: string | null
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      valueType: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicNestedContent"
                      valueType: string
                      elements?: Array<{
                        __typename?: "BasicNestedContentElement"
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                sourceValue?: string | null
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicPropertyValue"
                      valueType: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      sourceValue?: string | null
                      valueType: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      message: string
                      valueType: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      valueType: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }> | null
          }
        | {
            __typename?: "BasicContentPicker"
            valueType: string
            contentList: Array<{
              __typename?: "BasicContentPickerItem"
              id: number
              absoluteUrl: string
              key: any
              name?: string | null
              url: string
              urlSegment?: string | null
            }>
          }
        | {
            __typename?: "BasicDateTimePicker"
            valueType: string
            dateTime?: any | null
          }
        | { __typename?: "BasicLabel"; valueType: string; label?: any | null }
        | { __typename?: "BasicMediaPicker"; valueType: string }
        | {
            __typename?: "BasicMemberPicker"
            valueType: string
            members: Array<{
              __typename?: "BasicMemberPickerItem"
              id?: number | null
              name?: string | null
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicNestedContent"
                      model: string
                      elements?: Array<{
                        __typename?: "BasicNestedContentElement"
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                sourceValue?: string | null
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      sourceValue?: string | null
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }>
          }
        | {
            __typename?: "BasicMultiUrlPicker"
            valueType: string
            links: Array<{
              __typename?: "BasicMultiUrlPickerItem"
              name?: string | null
              target?: string | null
              type: LinkType
              url?: string | null
            }>
          }
        | {
            __typename?: "BasicNestedContent"
            valueType: string
            elements?: Array<{
              __typename?: "BasicNestedContentElement"
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | { __typename?: "BasicNestedContent"; model: string }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      sourceValue?: string | null
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }> | null
          }
        | {
            __typename?: "BasicPropertyValue"
            valueType: string
            value?: any | null
          }
        | {
            __typename?: "BasicRichText"
            sourceValue?: string | null
            valueType: string
            richText?: string | null
          }
        | {
            __typename?: "BasicUnsupportedPropertyValue"
            message: string
            valueType: string
          }
        | {
            __typename?: "MintMediaPicker"
            valueType: string
            mediaItems: Array<{
              __typename?: "MintMediaPickerItem"
              id: number
              url: string
              altText?: string | null
            }>
          }
        | null
    } | null>
  }> | null
}

type PropertyValuesComponent_BasicContentPicker_Fragment = {
  __typename?: "BasicContentPicker"
  valueType: string
  contentList: Array<{
    __typename?: "BasicContentPickerItem"
    id: number
    absoluteUrl: string
    key: any
    name?: string | null
    url: string
    urlSegment?: string | null
  }>
}

type PropertyValuesComponent_BasicDateTimePicker_Fragment = {
  __typename?: "BasicDateTimePicker"
  valueType: string
  dateTime?: any | null
}

type PropertyValuesComponent_BasicLabel_Fragment = {
  __typename?: "BasicLabel"
  valueType: string
  label?: any | null
}

type PropertyValuesComponent_BasicMediaPicker_Fragment = {
  __typename?: "BasicMediaPicker"
  valueType: string
}

type PropertyValuesComponent_BasicMemberPicker_Fragment = {
  __typename?: "BasicMemberPicker"
  valueType: string
  members: Array<{
    __typename?: "BasicMemberPickerItem"
    id?: number | null
    name?: string | null
    properties: Array<{
      __typename?: "BasicProperty"
      alias?: string | null
      editorAlias?: string | null
      value?:
        | { __typename?: "BasicBlockGridModel"; model: string }
        | { __typename?: "BasicBlockListModel"; model: string }
        | {
            __typename?: "BasicContentPicker"
            model: string
            contentList: Array<{
              __typename?: "BasicContentPickerItem"
              id: number
              absoluteUrl: string
              key: any
              name?: string | null
              url: string
              urlSegment?: string | null
            }>
          }
        | {
            __typename?: "BasicDateTimePicker"
            model: string
            dateTime?: any | null
          }
        | { __typename?: "BasicLabel"; model: string; label?: any | null }
        | { __typename?: "BasicMediaPicker"; model: string }
        | {
            __typename?: "BasicMemberPicker"
            model: string
            members: Array<{
              __typename?: "BasicMemberPickerItem"
              id?: number | null
              name?: string | null
            }>
          }
        | {
            __typename?: "BasicMultiUrlPicker"
            model: string
            links: Array<{
              __typename?: "BasicMultiUrlPickerItem"
              name?: string | null
              target?: string | null
              type: LinkType
              url?: string | null
            }>
          }
        | {
            __typename?: "BasicNestedContent"
            model: string
            elements?: Array<{
              __typename?: "BasicNestedContentElement"
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | { __typename?: "BasicNestedContent"; model: string }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      sourceValue?: string | null
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }> | null
          }
        | {
            __typename?: "BasicPropertyValue"
            model: string
            value?: any | null
          }
        | {
            __typename?: "BasicRichText"
            model: string
            sourceValue?: string | null
            richText?: string | null
          }
        | {
            __typename?: "BasicUnsupportedPropertyValue"
            model: string
            message: string
          }
        | {
            __typename?: "MintMediaPicker"
            model: string
            mediaItems: Array<{
              __typename?: "MintMediaPickerItem"
              id: number
              url: string
              altText?: string | null
            }>
          }
        | null
    } | null>
  }>
}

type PropertyValuesComponent_BasicMultiUrlPicker_Fragment = {
  __typename?: "BasicMultiUrlPicker"
  valueType: string
  links: Array<{
    __typename?: "BasicMultiUrlPickerItem"
    name?: string | null
    target?: string | null
    type: LinkType
    url?: string | null
  }>
}

type PropertyValuesComponent_BasicNestedContent_Fragment = {
  __typename?: "BasicNestedContent"
  valueType: string
  elements?: Array<{
    __typename?: "BasicNestedContentElement"
    properties: Array<{
      __typename?: "BasicProperty"
      alias?: string | null
      editorAlias?: string | null
      value?:
        | { __typename?: "BasicBlockGridModel"; model: string }
        | { __typename?: "BasicBlockListModel"; model: string }
        | {
            __typename?: "BasicContentPicker"
            model: string
            contentList: Array<{
              __typename?: "BasicContentPickerItem"
              id: number
              absoluteUrl: string
              key: any
              name?: string | null
              url: string
              urlSegment?: string | null
            }>
          }
        | {
            __typename?: "BasicDateTimePicker"
            model: string
            dateTime?: any | null
          }
        | { __typename?: "BasicLabel"; model: string; label?: any | null }
        | { __typename?: "BasicMediaPicker"; model: string }
        | {
            __typename?: "BasicMemberPicker"
            model: string
            members: Array<{
              __typename?: "BasicMemberPickerItem"
              id?: number | null
              name?: string | null
            }>
          }
        | {
            __typename?: "BasicMultiUrlPicker"
            model: string
            links: Array<{
              __typename?: "BasicMultiUrlPickerItem"
              name?: string | null
              target?: string | null
              type: LinkType
              url?: string | null
            }>
          }
        | { __typename?: "BasicNestedContent"; model: string }
        | {
            __typename?: "BasicPropertyValue"
            model: string
            value?: any | null
          }
        | {
            __typename?: "BasicRichText"
            model: string
            sourceValue?: string | null
            richText?: string | null
          }
        | {
            __typename?: "BasicUnsupportedPropertyValue"
            model: string
            message: string
          }
        | {
            __typename?: "MintMediaPicker"
            model: string
            mediaItems: Array<{
              __typename?: "MintMediaPickerItem"
              id: number
              url: string
              altText?: string | null
            }>
          }
        | null
    } | null>
  }> | null
}

type PropertyValuesComponent_BasicPropertyValue_Fragment = {
  __typename?: "BasicPropertyValue"
  valueType: string
  value?: any | null
}

type PropertyValuesComponent_BasicRichText_Fragment = {
  __typename?: "BasicRichText"
  sourceValue?: string | null
  valueType: string
  richText?: string | null
}

type PropertyValuesComponent_BasicUnsupportedPropertyValue_Fragment = {
  __typename?: "BasicUnsupportedPropertyValue"
  message: string
  valueType: string
}

type PropertyValuesComponent_MintMediaPicker_Fragment = {
  __typename?: "MintMediaPicker"
  valueType: string
  mediaItems: Array<{
    __typename?: "MintMediaPickerItem"
    id: number
    url: string
    altText?: string | null
  }>
}

export type PropertyValuesComponentFragment =
  | PropertyValuesComponent_BasicBlockGridModel_Fragment
  | PropertyValuesComponent_BasicBlockListModel_Fragment
  | PropertyValuesComponent_BasicContentPicker_Fragment
  | PropertyValuesComponent_BasicDateTimePicker_Fragment
  | PropertyValuesComponent_BasicLabel_Fragment
  | PropertyValuesComponent_BasicMediaPicker_Fragment
  | PropertyValuesComponent_BasicMemberPicker_Fragment
  | PropertyValuesComponent_BasicMultiUrlPicker_Fragment
  | PropertyValuesComponent_BasicNestedContent_Fragment
  | PropertyValuesComponent_BasicPropertyValue_Fragment
  | PropertyValuesComponent_BasicRichText_Fragment
  | PropertyValuesComponent_BasicUnsupportedPropertyValue_Fragment
  | PropertyValuesComponent_MintMediaPicker_Fragment

export type GetFootersQueryVariables = Exact<{
  desktopFooter: Scalars["String"]["input"]
  header: Scalars["String"]["input"]
  headerMobile: Scalars["String"]["input"]
  culture: Scalars["String"]["input"]
}>

export type GetFootersQuery = {
  __typename?: "Query"
  header?: {
    __typename?: "BasicContent"
    name?: string | null
    properties?: Array<{
      __typename?: "BasicProperty"
      propertyName?: string | null
      propertyValue?:
        | {
            __typename?: "BasicBlockGridModel"
            gridColumns?: number | null
            valueType: string
            blocks?: Array<{
              __typename?: "BasicBlockGridItem"
              columnSpan: number
              rowSpan: number
              contentProperties: Array<{
                __typename?: "BasicProperty"
                value?:
                  | { __typename?: "BasicBlockGridModel"; valueType: string }
                  | { __typename?: "BasicBlockListModel"; valueType: string }
                  | {
                      __typename?: "BasicContentPicker"
                      valueType: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      valueType: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      valueType: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; valueType: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      valueType: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                                elements?: Array<{
                                  __typename?: "BasicNestedContentElement"
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    alias?: string | null
                                    editorAlias?: string | null
                                    value?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          model: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          model: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          model: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          model: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          model: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          model: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          model: string
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          model: string
                                          message: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          model: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }> | null
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      valueType: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicNestedContent"
                      valueType: string
                      elements?: Array<{
                        __typename?: "BasicNestedContentElement"
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicPropertyValue"
                      valueType: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      valueType: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      message: string
                      valueType: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      valueType: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
              settingsProperties: Array<{
                __typename?: "BasicProperty"
                value?:
                  | { __typename?: "BasicBlockGridModel"; valueType: string }
                  | { __typename?: "BasicBlockListModel"; valueType: string }
                  | {
                      __typename?: "BasicContentPicker"
                      valueType: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      valueType: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      valueType: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; valueType: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      valueType: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                                elements?: Array<{
                                  __typename?: "BasicNestedContentElement"
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    alias?: string | null
                                    editorAlias?: string | null
                                    value?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          model: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          model: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          model: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          model: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          model: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          model: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          model: string
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          model: string
                                          message: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          model: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }> | null
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      valueType: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicNestedContent"
                      valueType: string
                      elements?: Array<{
                        __typename?: "BasicNestedContentElement"
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicPropertyValue"
                      valueType: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      valueType: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      message: string
                      valueType: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      valueType: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
              areas: Array<{
                __typename?: "BasicBlockGridArea"
                alias?: string | null
                rowSpan: number
                columnSpan: number
                blocks?: Array<{
                  __typename?: "BasicBlockGridItem"
                  columnSpan: number
                  rowSpan: number
                  contentProperties: Array<{
                    __typename?: "BasicProperty"
                    value?:
                      | {
                          __typename?: "BasicBlockGridModel"
                          valueType: string
                        }
                      | {
                          __typename?: "BasicBlockListModel"
                          valueType: string
                        }
                      | {
                          __typename?: "BasicContentPicker"
                          valueType: string
                          contentList: Array<{
                            __typename?: "BasicContentPickerItem"
                            id: number
                            absoluteUrl: string
                            key: any
                            name?: string | null
                            url: string
                            urlSegment?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicDateTimePicker"
                          valueType: string
                          dateTime?: any | null
                        }
                      | {
                          __typename?: "BasicLabel"
                          valueType: string
                          label?: any | null
                        }
                      | { __typename?: "BasicMediaPicker"; valueType: string }
                      | {
                          __typename?: "BasicMemberPicker"
                          valueType: string
                          members: Array<{
                            __typename?: "BasicMemberPickerItem"
                            id?: number | null
                            name?: string | null
                            properties: Array<{
                              __typename?: "BasicProperty"
                              alias?: string | null
                              editorAlias?: string | null
                              value?:
                                | {
                                    __typename?: "BasicBlockGridModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicBlockListModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicContentPicker"
                                    model: string
                                    contentList: Array<{
                                      __typename?: "BasicContentPickerItem"
                                      id: number
                                      absoluteUrl: string
                                      key: any
                                      name?: string | null
                                      url: string
                                      urlSegment?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicDateTimePicker"
                                    model: string
                                    dateTime?: any | null
                                  }
                                | {
                                    __typename?: "BasicLabel"
                                    model: string
                                    label?: any | null
                                  }
                                | {
                                    __typename?: "BasicMediaPicker"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicMemberPicker"
                                    model: string
                                    members: Array<{
                                      __typename?: "BasicMemberPickerItem"
                                      id?: number | null
                                      name?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicMultiUrlPicker"
                                    model: string
                                    links: Array<{
                                      __typename?: "BasicMultiUrlPickerItem"
                                      name?: string | null
                                      target?: string | null
                                      type: LinkType
                                      url?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicNestedContent"
                                    model: string
                                    elements?: Array<{
                                      __typename?: "BasicNestedContentElement"
                                      properties: Array<{
                                        __typename?: "BasicProperty"
                                        alias?: string | null
                                        editorAlias?: string | null
                                        value?:
                                          | {
                                              __typename?: "BasicBlockGridModel"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicBlockListModel"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicContentPicker"
                                              model: string
                                              contentList: Array<{
                                                __typename?: "BasicContentPickerItem"
                                                id: number
                                                absoluteUrl: string
                                                key: any
                                                name?: string | null
                                                url: string
                                                urlSegment?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicDateTimePicker"
                                              model: string
                                              dateTime?: any | null
                                            }
                                          | {
                                              __typename?: "BasicLabel"
                                              model: string
                                              label?: any | null
                                            }
                                          | {
                                              __typename?: "BasicMediaPicker"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicMemberPicker"
                                              model: string
                                              members: Array<{
                                                __typename?: "BasicMemberPickerItem"
                                                id?: number | null
                                                name?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicMultiUrlPicker"
                                              model: string
                                              links: Array<{
                                                __typename?: "BasicMultiUrlPickerItem"
                                                name?: string | null
                                                target?: string | null
                                                type: LinkType
                                                url?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicNestedContent"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicPropertyValue"
                                              model: string
                                              value?: any | null
                                            }
                                          | {
                                              __typename?: "BasicRichText"
                                              model: string
                                              richText?: string | null
                                            }
                                          | {
                                              __typename?: "BasicUnsupportedPropertyValue"
                                              model: string
                                              message: string
                                            }
                                          | {
                                              __typename?: "MintMediaPicker"
                                              model: string
                                              mediaItems: Array<{
                                                __typename?: "MintMediaPickerItem"
                                                id: number
                                                url: string
                                                altText?: string | null
                                              }>
                                            }
                                          | null
                                      } | null>
                                    }> | null
                                  }
                                | {
                                    __typename?: "BasicPropertyValue"
                                    model: string
                                    value?: any | null
                                  }
                                | {
                                    __typename?: "BasicRichText"
                                    model: string
                                    richText?: string | null
                                  }
                                | {
                                    __typename?: "BasicUnsupportedPropertyValue"
                                    model: string
                                    message: string
                                  }
                                | {
                                    __typename?: "MintMediaPicker"
                                    model: string
                                    mediaItems: Array<{
                                      __typename?: "MintMediaPickerItem"
                                      id: number
                                      url: string
                                      altText?: string | null
                                    }>
                                  }
                                | null
                            } | null>
                          }>
                        }
                      | {
                          __typename?: "BasicMultiUrlPicker"
                          valueType: string
                          links: Array<{
                            __typename?: "BasicMultiUrlPickerItem"
                            name?: string | null
                            target?: string | null
                            type: LinkType
                            url?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicNestedContent"
                          valueType: string
                          elements?: Array<{
                            __typename?: "BasicNestedContentElement"
                            properties: Array<{
                              __typename?: "BasicProperty"
                              alias?: string | null
                              editorAlias?: string | null
                              value?:
                                | {
                                    __typename?: "BasicBlockGridModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicBlockListModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicContentPicker"
                                    model: string
                                    contentList: Array<{
                                      __typename?: "BasicContentPickerItem"
                                      id: number
                                      absoluteUrl: string
                                      key: any
                                      name?: string | null
                                      url: string
                                      urlSegment?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicDateTimePicker"
                                    model: string
                                    dateTime?: any | null
                                  }
                                | {
                                    __typename?: "BasicLabel"
                                    model: string
                                    label?: any | null
                                  }
                                | {
                                    __typename?: "BasicMediaPicker"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicMemberPicker"
                                    model: string
                                    members: Array<{
                                      __typename?: "BasicMemberPickerItem"
                                      id?: number | null
                                      name?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicMultiUrlPicker"
                                    model: string
                                    links: Array<{
                                      __typename?: "BasicMultiUrlPickerItem"
                                      name?: string | null
                                      target?: string | null
                                      type: LinkType
                                      url?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicNestedContent"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicPropertyValue"
                                    model: string
                                    value?: any | null
                                  }
                                | {
                                    __typename?: "BasicRichText"
                                    model: string
                                    richText?: string | null
                                  }
                                | {
                                    __typename?: "BasicUnsupportedPropertyValue"
                                    model: string
                                    message: string
                                  }
                                | {
                                    __typename?: "MintMediaPicker"
                                    model: string
                                    mediaItems: Array<{
                                      __typename?: "MintMediaPickerItem"
                                      id: number
                                      url: string
                                      altText?: string | null
                                    }>
                                  }
                                | null
                            } | null>
                          }> | null
                        }
                      | {
                          __typename?: "BasicPropertyValue"
                          valueType: string
                          value?: any | null
                        }
                      | {
                          __typename?: "BasicRichText"
                          valueType: string
                          richText?: string | null
                        }
                      | {
                          __typename?: "BasicUnsupportedPropertyValue"
                          message: string
                          valueType: string
                        }
                      | {
                          __typename?: "MintMediaPicker"
                          valueType: string
                          mediaItems: Array<{
                            __typename?: "MintMediaPickerItem"
                            id: number
                            url: string
                            altText?: string | null
                          }>
                        }
                      | null
                  } | null>
                  settingsProperties: Array<{
                    __typename?: "BasicProperty"
                    value?:
                      | {
                          __typename?: "BasicBlockGridModel"
                          valueType: string
                        }
                      | {
                          __typename?: "BasicBlockListModel"
                          valueType: string
                        }
                      | {
                          __typename?: "BasicContentPicker"
                          valueType: string
                          contentList: Array<{
                            __typename?: "BasicContentPickerItem"
                            id: number
                            absoluteUrl: string
                            key: any
                            name?: string | null
                            url: string
                            urlSegment?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicDateTimePicker"
                          valueType: string
                          dateTime?: any | null
                        }
                      | {
                          __typename?: "BasicLabel"
                          valueType: string
                          label?: any | null
                        }
                      | { __typename?: "BasicMediaPicker"; valueType: string }
                      | {
                          __typename?: "BasicMemberPicker"
                          valueType: string
                          members: Array<{
                            __typename?: "BasicMemberPickerItem"
                            id?: number | null
                            name?: string | null
                            properties: Array<{
                              __typename?: "BasicProperty"
                              alias?: string | null
                              editorAlias?: string | null
                              value?:
                                | {
                                    __typename?: "BasicBlockGridModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicBlockListModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicContentPicker"
                                    model: string
                                    contentList: Array<{
                                      __typename?: "BasicContentPickerItem"
                                      id: number
                                      absoluteUrl: string
                                      key: any
                                      name?: string | null
                                      url: string
                                      urlSegment?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicDateTimePicker"
                                    model: string
                                    dateTime?: any | null
                                  }
                                | {
                                    __typename?: "BasicLabel"
                                    model: string
                                    label?: any | null
                                  }
                                | {
                                    __typename?: "BasicMediaPicker"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicMemberPicker"
                                    model: string
                                    members: Array<{
                                      __typename?: "BasicMemberPickerItem"
                                      id?: number | null
                                      name?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicMultiUrlPicker"
                                    model: string
                                    links: Array<{
                                      __typename?: "BasicMultiUrlPickerItem"
                                      name?: string | null
                                      target?: string | null
                                      type: LinkType
                                      url?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicNestedContent"
                                    model: string
                                    elements?: Array<{
                                      __typename?: "BasicNestedContentElement"
                                      properties: Array<{
                                        __typename?: "BasicProperty"
                                        alias?: string | null
                                        editorAlias?: string | null
                                        value?:
                                          | {
                                              __typename?: "BasicBlockGridModel"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicBlockListModel"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicContentPicker"
                                              model: string
                                              contentList: Array<{
                                                __typename?: "BasicContentPickerItem"
                                                id: number
                                                absoluteUrl: string
                                                key: any
                                                name?: string | null
                                                url: string
                                                urlSegment?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicDateTimePicker"
                                              model: string
                                              dateTime?: any | null
                                            }
                                          | {
                                              __typename?: "BasicLabel"
                                              model: string
                                              label?: any | null
                                            }
                                          | {
                                              __typename?: "BasicMediaPicker"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicMemberPicker"
                                              model: string
                                              members: Array<{
                                                __typename?: "BasicMemberPickerItem"
                                                id?: number | null
                                                name?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicMultiUrlPicker"
                                              model: string
                                              links: Array<{
                                                __typename?: "BasicMultiUrlPickerItem"
                                                name?: string | null
                                                target?: string | null
                                                type: LinkType
                                                url?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicNestedContent"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicPropertyValue"
                                              model: string
                                              value?: any | null
                                            }
                                          | {
                                              __typename?: "BasicRichText"
                                              model: string
                                              richText?: string | null
                                            }
                                          | {
                                              __typename?: "BasicUnsupportedPropertyValue"
                                              model: string
                                              message: string
                                            }
                                          | {
                                              __typename?: "MintMediaPicker"
                                              model: string
                                              mediaItems: Array<{
                                                __typename?: "MintMediaPickerItem"
                                                id: number
                                                url: string
                                                altText?: string | null
                                              }>
                                            }
                                          | null
                                      } | null>
                                    }> | null
                                  }
                                | {
                                    __typename?: "BasicPropertyValue"
                                    model: string
                                    value?: any | null
                                  }
                                | {
                                    __typename?: "BasicRichText"
                                    model: string
                                    richText?: string | null
                                  }
                                | {
                                    __typename?: "BasicUnsupportedPropertyValue"
                                    model: string
                                    message: string
                                  }
                                | {
                                    __typename?: "MintMediaPicker"
                                    model: string
                                    mediaItems: Array<{
                                      __typename?: "MintMediaPickerItem"
                                      id: number
                                      url: string
                                      altText?: string | null
                                    }>
                                  }
                                | null
                            } | null>
                          }>
                        }
                      | {
                          __typename?: "BasicMultiUrlPicker"
                          valueType: string
                          links: Array<{
                            __typename?: "BasicMultiUrlPickerItem"
                            name?: string | null
                            target?: string | null
                            type: LinkType
                            url?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicNestedContent"
                          valueType: string
                          elements?: Array<{
                            __typename?: "BasicNestedContentElement"
                            properties: Array<{
                              __typename?: "BasicProperty"
                              alias?: string | null
                              editorAlias?: string | null
                              value?:
                                | {
                                    __typename?: "BasicBlockGridModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicBlockListModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicContentPicker"
                                    model: string
                                    contentList: Array<{
                                      __typename?: "BasicContentPickerItem"
                                      id: number
                                      absoluteUrl: string
                                      key: any
                                      name?: string | null
                                      url: string
                                      urlSegment?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicDateTimePicker"
                                    model: string
                                    dateTime?: any | null
                                  }
                                | {
                                    __typename?: "BasicLabel"
                                    model: string
                                    label?: any | null
                                  }
                                | {
                                    __typename?: "BasicMediaPicker"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicMemberPicker"
                                    model: string
                                    members: Array<{
                                      __typename?: "BasicMemberPickerItem"
                                      id?: number | null
                                      name?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicMultiUrlPicker"
                                    model: string
                                    links: Array<{
                                      __typename?: "BasicMultiUrlPickerItem"
                                      name?: string | null
                                      target?: string | null
                                      type: LinkType
                                      url?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicNestedContent"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicPropertyValue"
                                    model: string
                                    value?: any | null
                                  }
                                | {
                                    __typename?: "BasicRichText"
                                    model: string
                                    richText?: string | null
                                  }
                                | {
                                    __typename?: "BasicUnsupportedPropertyValue"
                                    model: string
                                    message: string
                                  }
                                | {
                                    __typename?: "MintMediaPicker"
                                    model: string
                                    mediaItems: Array<{
                                      __typename?: "MintMediaPickerItem"
                                      id: number
                                      url: string
                                      altText?: string | null
                                    }>
                                  }
                                | null
                            } | null>
                          }> | null
                        }
                      | {
                          __typename?: "BasicPropertyValue"
                          valueType: string
                          value?: any | null
                        }
                      | {
                          __typename?: "BasicRichText"
                          valueType: string
                          richText?: string | null
                        }
                      | {
                          __typename?: "BasicUnsupportedPropertyValue"
                          message: string
                          valueType: string
                        }
                      | {
                          __typename?: "MintMediaPicker"
                          valueType: string
                          mediaItems: Array<{
                            __typename?: "MintMediaPickerItem"
                            id: number
                            url: string
                            altText?: string | null
                          }>
                        }
                      | null
                  } | null>
                  areas: Array<{
                    __typename?: "BasicBlockGridArea"
                    alias?: string | null
                    rowSpan: number
                    columnSpan: number
                  } | null>
                }> | null
              } | null>
            }> | null
          }
        | {
            __typename?: "BasicBlockListModel"
            valueType: string
            blocks?: Array<{
              __typename?: "BasicBlockListItem"
              blockType?: string | null
              properties: Array<{
                __typename?: "BasicProperty"
                propertyName?: string | null
                propertyValue?:
                  | { __typename?: "BasicBlockGridModel"; valueType: string }
                  | {
                      __typename?: "BasicBlockListModel"
                      valueType: string
                      blocks?: Array<{
                        __typename?: "BasicBlockListItem"
                        blockType?: string | null
                        properties: Array<{
                          __typename?: "BasicProperty"
                          propertyName?: string | null
                          propertyValue?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                valueType: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                valueType: string
                                blocks?: Array<{
                                  __typename?: "BasicBlockListItem"
                                  blockType?: string | null
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    propertyName?: string | null
                                    propertyValue?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          valueType: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          valueType: string
                                          blocks?: Array<{
                                            __typename?: "BasicBlockListItem"
                                            blockType?: string | null
                                            properties: Array<{
                                              __typename?: "BasicProperty"
                                              propertyName?: string | null
                                              propertyValue?:
                                                | {
                                                    __typename?: "BasicBlockGridModel"
                                                    valueType: string
                                                  }
                                                | {
                                                    __typename?: "BasicBlockListModel"
                                                    valueType: string
                                                    blocks?: Array<{
                                                      __typename?: "BasicBlockListItem"
                                                      blockType?: string | null
                                                      properties: Array<{
                                                        __typename?: "BasicProperty"
                                                        propertyName?:
                                                          | string
                                                          | null
                                                        propertyValue?:
                                                          | {
                                                              __typename?: "BasicBlockGridModel"
                                                              valueType: string
                                                            }
                                                          | {
                                                              __typename?: "BasicBlockListModel"
                                                              valueType: string
                                                            }
                                                          | {
                                                              __typename?: "BasicContentPicker"
                                                              valueType: string
                                                              contentList: Array<{
                                                                __typename?: "BasicContentPickerItem"
                                                                id: number
                                                                absoluteUrl: string
                                                                key: any
                                                                name?:
                                                                  | string
                                                                  | null
                                                                url: string
                                                                urlSegment?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicDateTimePicker"
                                                              valueType: string
                                                              dateTime?:
                                                                | any
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicLabel"
                                                              valueType: string
                                                              label?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicMediaPicker"
                                                              valueType: string
                                                            }
                                                          | {
                                                              __typename?: "BasicMemberPicker"
                                                              valueType: string
                                                              members: Array<{
                                                                __typename?: "BasicMemberPickerItem"
                                                                id?:
                                                                  | number
                                                                  | null
                                                                name?:
                                                                  | string
                                                                  | null
                                                                properties: Array<{
                                                                  __typename?: "BasicProperty"
                                                                  alias?:
                                                                    | string
                                                                    | null
                                                                  editorAlias?:
                                                                    | string
                                                                    | null
                                                                  value?:
                                                                    | {
                                                                        __typename?: "BasicBlockGridModel"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicBlockListModel"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicContentPicker"
                                                                        model: string
                                                                        contentList: Array<{
                                                                          __typename?: "BasicContentPickerItem"
                                                                          id: number
                                                                          absoluteUrl: string
                                                                          key: any
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                          url: string
                                                                          urlSegment?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicDateTimePicker"
                                                                        model: string
                                                                        dateTime?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicLabel"
                                                                        model: string
                                                                        label?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMediaPicker"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMemberPicker"
                                                                        model: string
                                                                        members: Array<{
                                                                          __typename?: "BasicMemberPickerItem"
                                                                          id?:
                                                                            | number
                                                                            | null
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMultiUrlPicker"
                                                                        model: string
                                                                        links: Array<{
                                                                          __typename?: "BasicMultiUrlPickerItem"
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                          target?:
                                                                            | string
                                                                            | null
                                                                          type: LinkType
                                                                          url?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicNestedContent"
                                                                        model: string
                                                                        elements?: Array<{
                                                                          __typename?: "BasicNestedContentElement"
                                                                          properties: Array<{
                                                                            __typename?: "BasicProperty"
                                                                            alias?:
                                                                              | string
                                                                              | null
                                                                            editorAlias?:
                                                                              | string
                                                                              | null
                                                                            value?:
                                                                              | {
                                                                                  __typename?: "BasicBlockGridModel"
                                                                                  model: string
                                                                                }
                                                                              | {
                                                                                  __typename?: "BasicBlockListModel"
                                                                                  model: string
                                                                                }
                                                                              | {
                                                                                  __typename?: "BasicContentPicker"
                                                                                  model: string
                                                                                  contentList: Array<{
                                                                                    __typename?: "BasicContentPickerItem"
                                                                                    id: number
                                                                                    absoluteUrl: string
                                                                                    key: any
                                                                                    name?:
                                                                                      | string
                                                                                      | null
                                                                                    url: string
                                                                                    urlSegment?:
                                                                                      | string
                                                                                      | null
                                                                                  }>
                                                                                }
                                                                              | {
                                                                                  __typename?: "BasicDateTimePicker"
                                                                                  model: string
                                                                                  dateTime?:
                                                                                    | any
                                                                                    | null
                                                                                }
                                                                              | {
                                                                                  __typename?: "BasicLabel"
                                                                                  model: string
                                                                                  label?:
                                                                                    | any
                                                                                    | null
                                                                                }
                                                                              | {
                                                                                  __typename?: "BasicMediaPicker"
                                                                                  model: string
                                                                                }
                                                                              | {
                                                                                  __typename?: "BasicMemberPicker"
                                                                                  model: string
                                                                                  members: Array<{
                                                                                    __typename?: "BasicMemberPickerItem"
                                                                                    id?:
                                                                                      | number
                                                                                      | null
                                                                                    name?:
                                                                                      | string
                                                                                      | null
                                                                                  }>
                                                                                }
                                                                              | {
                                                                                  __typename?: "BasicMultiUrlPicker"
                                                                                  model: string
                                                                                  links: Array<{
                                                                                    __typename?: "BasicMultiUrlPickerItem"
                                                                                    name?:
                                                                                      | string
                                                                                      | null
                                                                                    target?:
                                                                                      | string
                                                                                      | null
                                                                                    type: LinkType
                                                                                    url?:
                                                                                      | string
                                                                                      | null
                                                                                  }>
                                                                                }
                                                                              | {
                                                                                  __typename?: "BasicNestedContent"
                                                                                  model: string
                                                                                }
                                                                              | {
                                                                                  __typename?: "BasicPropertyValue"
                                                                                  model: string
                                                                                  value?:
                                                                                    | any
                                                                                    | null
                                                                                }
                                                                              | {
                                                                                  __typename?: "BasicRichText"
                                                                                  model: string
                                                                                  richText?:
                                                                                    | string
                                                                                    | null
                                                                                }
                                                                              | {
                                                                                  __typename?: "BasicUnsupportedPropertyValue"
                                                                                  model: string
                                                                                  message: string
                                                                                }
                                                                              | {
                                                                                  __typename?: "MintMediaPicker"
                                                                                  model: string
                                                                                  mediaItems: Array<{
                                                                                    __typename?: "MintMediaPickerItem"
                                                                                    id: number
                                                                                    url: string
                                                                                    altText?:
                                                                                      | string
                                                                                      | null
                                                                                  }>
                                                                                }
                                                                              | null
                                                                          } | null>
                                                                        }> | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicPropertyValue"
                                                                        model: string
                                                                        value?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicRichText"
                                                                        model: string
                                                                        richText?:
                                                                          | string
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicUnsupportedPropertyValue"
                                                                        model: string
                                                                        message: string
                                                                      }
                                                                    | {
                                                                        __typename?: "MintMediaPicker"
                                                                        model: string
                                                                        mediaItems: Array<{
                                                                          __typename?: "MintMediaPickerItem"
                                                                          id: number
                                                                          url: string
                                                                          altText?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | null
                                                                } | null>
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicMultiUrlPicker"
                                                              valueType: string
                                                              links: Array<{
                                                                __typename?: "BasicMultiUrlPickerItem"
                                                                name?:
                                                                  | string
                                                                  | null
                                                                target?:
                                                                  | string
                                                                  | null
                                                                type: LinkType
                                                                url?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicNestedContent"
                                                              valueType: string
                                                              elements?: Array<{
                                                                __typename?: "BasicNestedContentElement"
                                                                properties: Array<{
                                                                  __typename?: "BasicProperty"
                                                                  alias?:
                                                                    | string
                                                                    | null
                                                                  editorAlias?:
                                                                    | string
                                                                    | null
                                                                  value?:
                                                                    | {
                                                                        __typename?: "BasicBlockGridModel"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicBlockListModel"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicContentPicker"
                                                                        model: string
                                                                        contentList: Array<{
                                                                          __typename?: "BasicContentPickerItem"
                                                                          id: number
                                                                          absoluteUrl: string
                                                                          key: any
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                          url: string
                                                                          urlSegment?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicDateTimePicker"
                                                                        model: string
                                                                        dateTime?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicLabel"
                                                                        model: string
                                                                        label?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMediaPicker"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMemberPicker"
                                                                        model: string
                                                                        members: Array<{
                                                                          __typename?: "BasicMemberPickerItem"
                                                                          id?:
                                                                            | number
                                                                            | null
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMultiUrlPicker"
                                                                        model: string
                                                                        links: Array<{
                                                                          __typename?: "BasicMultiUrlPickerItem"
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                          target?:
                                                                            | string
                                                                            | null
                                                                          type: LinkType
                                                                          url?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicNestedContent"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicPropertyValue"
                                                                        model: string
                                                                        value?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicRichText"
                                                                        model: string
                                                                        richText?:
                                                                          | string
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicUnsupportedPropertyValue"
                                                                        model: string
                                                                        message: string
                                                                      }
                                                                    | {
                                                                        __typename?: "MintMediaPicker"
                                                                        model: string
                                                                        mediaItems: Array<{
                                                                          __typename?: "MintMediaPickerItem"
                                                                          id: number
                                                                          url: string
                                                                          altText?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | null
                                                                } | null>
                                                              }> | null
                                                            }
                                                          | {
                                                              __typename?: "BasicPropertyValue"
                                                              valueType: string
                                                              value?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicRichText"
                                                              valueType: string
                                                              richText?:
                                                                | string
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicUnsupportedPropertyValue"
                                                              message: string
                                                              valueType: string
                                                            }
                                                          | {
                                                              __typename?: "MintMediaPicker"
                                                              valueType: string
                                                              mediaItems: Array<{
                                                                __typename?: "MintMediaPickerItem"
                                                                id: number
                                                                url: string
                                                                altText?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | null
                                                      } | null>
                                                    }> | null
                                                  }
                                                | {
                                                    __typename?: "BasicContentPicker"
                                                    valueType: string
                                                    contentList: Array<{
                                                      __typename?: "BasicContentPickerItem"
                                                      id: number
                                                      absoluteUrl: string
                                                      key: any
                                                      name?: string | null
                                                      url: string
                                                      urlSegment?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicDateTimePicker"
                                                    valueType: string
                                                    dateTime?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicLabel"
                                                    valueType: string
                                                    label?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicMediaPicker"
                                                    valueType: string
                                                  }
                                                | {
                                                    __typename?: "BasicMemberPicker"
                                                    valueType: string
                                                    members: Array<{
                                                      __typename?: "BasicMemberPickerItem"
                                                      id?: number | null
                                                      name?: string | null
                                                      properties: Array<{
                                                        __typename?: "BasicProperty"
                                                        alias?: string | null
                                                        editorAlias?:
                                                          | string
                                                          | null
                                                        value?:
                                                          | {
                                                              __typename?: "BasicBlockGridModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicBlockListModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicContentPicker"
                                                              model: string
                                                              contentList: Array<{
                                                                __typename?: "BasicContentPickerItem"
                                                                id: number
                                                                absoluteUrl: string
                                                                key: any
                                                                name?:
                                                                  | string
                                                                  | null
                                                                url: string
                                                                urlSegment?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicDateTimePicker"
                                                              model: string
                                                              dateTime?:
                                                                | any
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicLabel"
                                                              model: string
                                                              label?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicMediaPicker"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicMemberPicker"
                                                              model: string
                                                              members: Array<{
                                                                __typename?: "BasicMemberPickerItem"
                                                                id?:
                                                                  | number
                                                                  | null
                                                                name?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicMultiUrlPicker"
                                                              model: string
                                                              links: Array<{
                                                                __typename?: "BasicMultiUrlPickerItem"
                                                                name?:
                                                                  | string
                                                                  | null
                                                                target?:
                                                                  | string
                                                                  | null
                                                                type: LinkType
                                                                url?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicNestedContent"
                                                              model: string
                                                              elements?: Array<{
                                                                __typename?: "BasicNestedContentElement"
                                                                properties: Array<{
                                                                  __typename?: "BasicProperty"
                                                                  alias?:
                                                                    | string
                                                                    | null
                                                                  editorAlias?:
                                                                    | string
                                                                    | null
                                                                  value?:
                                                                    | {
                                                                        __typename?: "BasicBlockGridModel"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicBlockListModel"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicContentPicker"
                                                                        model: string
                                                                        contentList: Array<{
                                                                          __typename?: "BasicContentPickerItem"
                                                                          id: number
                                                                          absoluteUrl: string
                                                                          key: any
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                          url: string
                                                                          urlSegment?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicDateTimePicker"
                                                                        model: string
                                                                        dateTime?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicLabel"
                                                                        model: string
                                                                        label?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMediaPicker"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMemberPicker"
                                                                        model: string
                                                                        members: Array<{
                                                                          __typename?: "BasicMemberPickerItem"
                                                                          id?:
                                                                            | number
                                                                            | null
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMultiUrlPicker"
                                                                        model: string
                                                                        links: Array<{
                                                                          __typename?: "BasicMultiUrlPickerItem"
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                          target?:
                                                                            | string
                                                                            | null
                                                                          type: LinkType
                                                                          url?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicNestedContent"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicPropertyValue"
                                                                        model: string
                                                                        value?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicRichText"
                                                                        model: string
                                                                        richText?:
                                                                          | string
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicUnsupportedPropertyValue"
                                                                        model: string
                                                                        message: string
                                                                      }
                                                                    | {
                                                                        __typename?: "MintMediaPicker"
                                                                        model: string
                                                                        mediaItems: Array<{
                                                                          __typename?: "MintMediaPickerItem"
                                                                          id: number
                                                                          url: string
                                                                          altText?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | null
                                                                } | null>
                                                              }> | null
                                                            }
                                                          | {
                                                              __typename?: "BasicPropertyValue"
                                                              model: string
                                                              value?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicRichText"
                                                              model: string
                                                              richText?:
                                                                | string
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicUnsupportedPropertyValue"
                                                              model: string
                                                              message: string
                                                            }
                                                          | {
                                                              __typename?: "MintMediaPicker"
                                                              model: string
                                                              mediaItems: Array<{
                                                                __typename?: "MintMediaPickerItem"
                                                                id: number
                                                                url: string
                                                                altText?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | null
                                                      } | null>
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicMultiUrlPicker"
                                                    valueType: string
                                                    links: Array<{
                                                      __typename?: "BasicMultiUrlPickerItem"
                                                      name?: string | null
                                                      target?: string | null
                                                      type: LinkType
                                                      url?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicNestedContent"
                                                    valueType: string
                                                    elements?: Array<{
                                                      __typename?: "BasicNestedContentElement"
                                                      properties: Array<{
                                                        __typename?: "BasicProperty"
                                                        alias?: string | null
                                                        editorAlias?:
                                                          | string
                                                          | null
                                                        value?:
                                                          | {
                                                              __typename?: "BasicBlockGridModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicBlockListModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicContentPicker"
                                                              model: string
                                                              contentList: Array<{
                                                                __typename?: "BasicContentPickerItem"
                                                                id: number
                                                                absoluteUrl: string
                                                                key: any
                                                                name?:
                                                                  | string
                                                                  | null
                                                                url: string
                                                                urlSegment?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicDateTimePicker"
                                                              model: string
                                                              dateTime?:
                                                                | any
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicLabel"
                                                              model: string
                                                              label?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicMediaPicker"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicMemberPicker"
                                                              model: string
                                                              members: Array<{
                                                                __typename?: "BasicMemberPickerItem"
                                                                id?:
                                                                  | number
                                                                  | null
                                                                name?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicMultiUrlPicker"
                                                              model: string
                                                              links: Array<{
                                                                __typename?: "BasicMultiUrlPickerItem"
                                                                name?:
                                                                  | string
                                                                  | null
                                                                target?:
                                                                  | string
                                                                  | null
                                                                type: LinkType
                                                                url?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicNestedContent"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicPropertyValue"
                                                              model: string
                                                              value?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicRichText"
                                                              model: string
                                                              richText?:
                                                                | string
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicUnsupportedPropertyValue"
                                                              model: string
                                                              message: string
                                                            }
                                                          | {
                                                              __typename?: "MintMediaPicker"
                                                              model: string
                                                              mediaItems: Array<{
                                                                __typename?: "MintMediaPickerItem"
                                                                id: number
                                                                url: string
                                                                altText?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | null
                                                      } | null>
                                                    }> | null
                                                  }
                                                | {
                                                    __typename?: "BasicPropertyValue"
                                                    valueType: string
                                                    value?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicRichText"
                                                    valueType: string
                                                    richText?: string | null
                                                  }
                                                | {
                                                    __typename?: "BasicUnsupportedPropertyValue"
                                                    message: string
                                                    valueType: string
                                                  }
                                                | {
                                                    __typename?: "MintMediaPicker"
                                                    valueType: string
                                                    mediaItems: Array<{
                                                      __typename?: "MintMediaPickerItem"
                                                      id: number
                                                      url: string
                                                      altText?: string | null
                                                    }>
                                                  }
                                                | null
                                            } | null>
                                          }> | null
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          valueType: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          valueType: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          valueType: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          valueType: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          valueType: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                            properties: Array<{
                                              __typename?: "BasicProperty"
                                              alias?: string | null
                                              editorAlias?: string | null
                                              value?:
                                                | {
                                                    __typename?: "BasicBlockGridModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicBlockListModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicContentPicker"
                                                    model: string
                                                    contentList: Array<{
                                                      __typename?: "BasicContentPickerItem"
                                                      id: number
                                                      absoluteUrl: string
                                                      key: any
                                                      name?: string | null
                                                      url: string
                                                      urlSegment?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicDateTimePicker"
                                                    model: string
                                                    dateTime?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicLabel"
                                                    model: string
                                                    label?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicMediaPicker"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicMemberPicker"
                                                    model: string
                                                    members: Array<{
                                                      __typename?: "BasicMemberPickerItem"
                                                      id?: number | null
                                                      name?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicMultiUrlPicker"
                                                    model: string
                                                    links: Array<{
                                                      __typename?: "BasicMultiUrlPickerItem"
                                                      name?: string | null
                                                      target?: string | null
                                                      type: LinkType
                                                      url?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicNestedContent"
                                                    model: string
                                                    elements?: Array<{
                                                      __typename?: "BasicNestedContentElement"
                                                      properties: Array<{
                                                        __typename?: "BasicProperty"
                                                        alias?: string | null
                                                        editorAlias?:
                                                          | string
                                                          | null
                                                        value?:
                                                          | {
                                                              __typename?: "BasicBlockGridModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicBlockListModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicContentPicker"
                                                              model: string
                                                              contentList: Array<{
                                                                __typename?: "BasicContentPickerItem"
                                                                id: number
                                                                absoluteUrl: string
                                                                key: any
                                                                name?:
                                                                  | string
                                                                  | null
                                                                url: string
                                                                urlSegment?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicDateTimePicker"
                                                              model: string
                                                              dateTime?:
                                                                | any
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicLabel"
                                                              model: string
                                                              label?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicMediaPicker"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicMemberPicker"
                                                              model: string
                                                              members: Array<{
                                                                __typename?: "BasicMemberPickerItem"
                                                                id?:
                                                                  | number
                                                                  | null
                                                                name?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicMultiUrlPicker"
                                                              model: string
                                                              links: Array<{
                                                                __typename?: "BasicMultiUrlPickerItem"
                                                                name?:
                                                                  | string
                                                                  | null
                                                                target?:
                                                                  | string
                                                                  | null
                                                                type: LinkType
                                                                url?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicNestedContent"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicPropertyValue"
                                                              model: string
                                                              value?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicRichText"
                                                              model: string
                                                              richText?:
                                                                | string
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicUnsupportedPropertyValue"
                                                              model: string
                                                              message: string
                                                            }
                                                          | {
                                                              __typename?: "MintMediaPicker"
                                                              model: string
                                                              mediaItems: Array<{
                                                                __typename?: "MintMediaPickerItem"
                                                                id: number
                                                                url: string
                                                                altText?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | null
                                                      } | null>
                                                    }> | null
                                                  }
                                                | {
                                                    __typename?: "BasicPropertyValue"
                                                    model: string
                                                    value?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicRichText"
                                                    model: string
                                                    richText?: string | null
                                                  }
                                                | {
                                                    __typename?: "BasicUnsupportedPropertyValue"
                                                    model: string
                                                    message: string
                                                  }
                                                | {
                                                    __typename?: "MintMediaPicker"
                                                    model: string
                                                    mediaItems: Array<{
                                                      __typename?: "MintMediaPickerItem"
                                                      id: number
                                                      url: string
                                                      altText?: string | null
                                                    }>
                                                  }
                                                | null
                                            } | null>
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          valueType: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          valueType: string
                                          elements?: Array<{
                                            __typename?: "BasicNestedContentElement"
                                            properties: Array<{
                                              __typename?: "BasicProperty"
                                              alias?: string | null
                                              editorAlias?: string | null
                                              value?:
                                                | {
                                                    __typename?: "BasicBlockGridModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicBlockListModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicContentPicker"
                                                    model: string
                                                    contentList: Array<{
                                                      __typename?: "BasicContentPickerItem"
                                                      id: number
                                                      absoluteUrl: string
                                                      key: any
                                                      name?: string | null
                                                      url: string
                                                      urlSegment?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicDateTimePicker"
                                                    model: string
                                                    dateTime?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicLabel"
                                                    model: string
                                                    label?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicMediaPicker"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicMemberPicker"
                                                    model: string
                                                    members: Array<{
                                                      __typename?: "BasicMemberPickerItem"
                                                      id?: number | null
                                                      name?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicMultiUrlPicker"
                                                    model: string
                                                    links: Array<{
                                                      __typename?: "BasicMultiUrlPickerItem"
                                                      name?: string | null
                                                      target?: string | null
                                                      type: LinkType
                                                      url?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicNestedContent"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicPropertyValue"
                                                    model: string
                                                    value?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicRichText"
                                                    model: string
                                                    richText?: string | null
                                                  }
                                                | {
                                                    __typename?: "BasicUnsupportedPropertyValue"
                                                    model: string
                                                    message: string
                                                  }
                                                | {
                                                    __typename?: "MintMediaPicker"
                                                    model: string
                                                    mediaItems: Array<{
                                                      __typename?: "MintMediaPickerItem"
                                                      id: number
                                                      url: string
                                                      altText?: string | null
                                                    }>
                                                  }
                                                | null
                                            } | null>
                                          }> | null
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          valueType: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          valueType: string
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          message: string
                                          valueType: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          valueType: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }> | null
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                valueType: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                valueType: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                valueType: string
                                label?: any | null
                              }
                            | {
                                __typename?: "BasicMediaPicker"
                                valueType: string
                              }
                            | {
                                __typename?: "BasicMemberPicker"
                                valueType: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    alias?: string | null
                                    editorAlias?: string | null
                                    value?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          model: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          model: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          model: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          model: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          model: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          model: string
                                          elements?: Array<{
                                            __typename?: "BasicNestedContentElement"
                                            properties: Array<{
                                              __typename?: "BasicProperty"
                                              alias?: string | null
                                              editorAlias?: string | null
                                              value?:
                                                | {
                                                    __typename?: "BasicBlockGridModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicBlockListModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicContentPicker"
                                                    model: string
                                                    contentList: Array<{
                                                      __typename?: "BasicContentPickerItem"
                                                      id: number
                                                      absoluteUrl: string
                                                      key: any
                                                      name?: string | null
                                                      url: string
                                                      urlSegment?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicDateTimePicker"
                                                    model: string
                                                    dateTime?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicLabel"
                                                    model: string
                                                    label?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicMediaPicker"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicMemberPicker"
                                                    model: string
                                                    members: Array<{
                                                      __typename?: "BasicMemberPickerItem"
                                                      id?: number | null
                                                      name?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicMultiUrlPicker"
                                                    model: string
                                                    links: Array<{
                                                      __typename?: "BasicMultiUrlPickerItem"
                                                      name?: string | null
                                                      target?: string | null
                                                      type: LinkType
                                                      url?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicNestedContent"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicPropertyValue"
                                                    model: string
                                                    value?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicRichText"
                                                    model: string
                                                    richText?: string | null
                                                  }
                                                | {
                                                    __typename?: "BasicUnsupportedPropertyValue"
                                                    model: string
                                                    message: string
                                                  }
                                                | {
                                                    __typename?: "MintMediaPicker"
                                                    model: string
                                                    mediaItems: Array<{
                                                      __typename?: "MintMediaPickerItem"
                                                      id: number
                                                      url: string
                                                      altText?: string | null
                                                    }>
                                                  }
                                                | null
                                            } | null>
                                          }> | null
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          model: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          model: string
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          model: string
                                          message: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          model: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                valueType: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                valueType: string
                                elements?: Array<{
                                  __typename?: "BasicNestedContentElement"
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    alias?: string | null
                                    editorAlias?: string | null
                                    value?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          model: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          model: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          model: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          model: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          model: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          model: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          model: string
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          model: string
                                          message: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          model: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }> | null
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                valueType: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                valueType: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                message: string
                                valueType: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                valueType: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicContentPicker"
                      valueType: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      valueType: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      valueType: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; valueType: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      valueType: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                                elements?: Array<{
                                  __typename?: "BasicNestedContentElement"
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    alias?: string | null
                                    editorAlias?: string | null
                                    value?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          model: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          model: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          model: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          model: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          model: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          model: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          model: string
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          model: string
                                          message: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          model: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }> | null
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      valueType: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicNestedContent"
                      valueType: string
                      elements?: Array<{
                        __typename?: "BasicNestedContentElement"
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicPropertyValue"
                      valueType: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      valueType: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      message: string
                      valueType: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      valueType: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }> | null
          }
        | {
            __typename?: "BasicContentPicker"
            valueType: string
            contentList: Array<{
              __typename?: "BasicContentPickerItem"
              id: number
              absoluteUrl: string
              key: any
              name?: string | null
              url: string
              urlSegment?: string | null
            }>
          }
        | {
            __typename?: "BasicDateTimePicker"
            valueType: string
            dateTime?: any | null
          }
        | { __typename?: "BasicLabel"; valueType: string; label?: any | null }
        | { __typename?: "BasicMediaPicker"; valueType: string }
        | {
            __typename?: "BasicMemberPicker"
            valueType: string
            members: Array<{
              __typename?: "BasicMemberPickerItem"
              id?: number | null
              name?: string | null
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicNestedContent"
                      model: string
                      elements?: Array<{
                        __typename?: "BasicNestedContentElement"
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }>
          }
        | {
            __typename?: "BasicMultiUrlPicker"
            valueType: string
            links: Array<{
              __typename?: "BasicMultiUrlPickerItem"
              name?: string | null
              target?: string | null
              type: LinkType
              url?: string | null
            }>
          }
        | {
            __typename?: "BasicNestedContent"
            valueType: string
            elements?: Array<{
              __typename?: "BasicNestedContentElement"
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | { __typename?: "BasicNestedContent"; model: string }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }> | null
          }
        | {
            __typename?: "BasicPropertyValue"
            valueType: string
            value?: any | null
          }
        | {
            __typename?: "BasicRichText"
            valueType: string
            richText?: string | null
          }
        | {
            __typename?: "BasicUnsupportedPropertyValue"
            message: string
            valueType: string
          }
        | {
            __typename?: "MintMediaPicker"
            valueType: string
            mediaItems: Array<{
              __typename?: "MintMediaPickerItem"
              id: number
              url: string
              altText?: string | null
            }>
          }
        | null
    } | null> | null
  } | null
  headerMobile?: {
    __typename?: "BasicContent"
    name?: string | null
    properties?: Array<{
      __typename?: "BasicProperty"
      propertyName?: string | null
      propertyValue?:
        | {
            __typename?: "BasicBlockGridModel"
            gridColumns?: number | null
            valueType: string
            blocks?: Array<{
              __typename?: "BasicBlockGridItem"
              columnSpan: number
              rowSpan: number
              contentProperties: Array<{
                __typename?: "BasicProperty"
                value?:
                  | { __typename?: "BasicBlockGridModel"; valueType: string }
                  | { __typename?: "BasicBlockListModel"; valueType: string }
                  | {
                      __typename?: "BasicContentPicker"
                      valueType: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      valueType: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      valueType: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; valueType: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      valueType: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                                elements?: Array<{
                                  __typename?: "BasicNestedContentElement"
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    alias?: string | null
                                    editorAlias?: string | null
                                    value?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          model: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          model: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          model: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          model: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          model: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          model: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          model: string
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          model: string
                                          message: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          model: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }> | null
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      valueType: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicNestedContent"
                      valueType: string
                      elements?: Array<{
                        __typename?: "BasicNestedContentElement"
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicPropertyValue"
                      valueType: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      valueType: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      message: string
                      valueType: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      valueType: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
              settingsProperties: Array<{
                __typename?: "BasicProperty"
                value?:
                  | { __typename?: "BasicBlockGridModel"; valueType: string }
                  | { __typename?: "BasicBlockListModel"; valueType: string }
                  | {
                      __typename?: "BasicContentPicker"
                      valueType: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      valueType: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      valueType: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; valueType: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      valueType: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                                elements?: Array<{
                                  __typename?: "BasicNestedContentElement"
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    alias?: string | null
                                    editorAlias?: string | null
                                    value?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          model: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          model: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          model: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          model: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          model: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          model: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          model: string
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          model: string
                                          message: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          model: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }> | null
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      valueType: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicNestedContent"
                      valueType: string
                      elements?: Array<{
                        __typename?: "BasicNestedContentElement"
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicPropertyValue"
                      valueType: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      valueType: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      message: string
                      valueType: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      valueType: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
              areas: Array<{
                __typename?: "BasicBlockGridArea"
                alias?: string | null
                rowSpan: number
                columnSpan: number
                blocks?: Array<{
                  __typename?: "BasicBlockGridItem"
                  columnSpan: number
                  rowSpan: number
                  contentProperties: Array<{
                    __typename?: "BasicProperty"
                    value?:
                      | {
                          __typename?: "BasicBlockGridModel"
                          valueType: string
                        }
                      | {
                          __typename?: "BasicBlockListModel"
                          valueType: string
                        }
                      | {
                          __typename?: "BasicContentPicker"
                          valueType: string
                          contentList: Array<{
                            __typename?: "BasicContentPickerItem"
                            id: number
                            absoluteUrl: string
                            key: any
                            name?: string | null
                            url: string
                            urlSegment?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicDateTimePicker"
                          valueType: string
                          dateTime?: any | null
                        }
                      | {
                          __typename?: "BasicLabel"
                          valueType: string
                          label?: any | null
                        }
                      | { __typename?: "BasicMediaPicker"; valueType: string }
                      | {
                          __typename?: "BasicMemberPicker"
                          valueType: string
                          members: Array<{
                            __typename?: "BasicMemberPickerItem"
                            id?: number | null
                            name?: string | null
                            properties: Array<{
                              __typename?: "BasicProperty"
                              alias?: string | null
                              editorAlias?: string | null
                              value?:
                                | {
                                    __typename?: "BasicBlockGridModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicBlockListModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicContentPicker"
                                    model: string
                                    contentList: Array<{
                                      __typename?: "BasicContentPickerItem"
                                      id: number
                                      absoluteUrl: string
                                      key: any
                                      name?: string | null
                                      url: string
                                      urlSegment?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicDateTimePicker"
                                    model: string
                                    dateTime?: any | null
                                  }
                                | {
                                    __typename?: "BasicLabel"
                                    model: string
                                    label?: any | null
                                  }
                                | {
                                    __typename?: "BasicMediaPicker"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicMemberPicker"
                                    model: string
                                    members: Array<{
                                      __typename?: "BasicMemberPickerItem"
                                      id?: number | null
                                      name?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicMultiUrlPicker"
                                    model: string
                                    links: Array<{
                                      __typename?: "BasicMultiUrlPickerItem"
                                      name?: string | null
                                      target?: string | null
                                      type: LinkType
                                      url?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicNestedContent"
                                    model: string
                                    elements?: Array<{
                                      __typename?: "BasicNestedContentElement"
                                      properties: Array<{
                                        __typename?: "BasicProperty"
                                        alias?: string | null
                                        editorAlias?: string | null
                                        value?:
                                          | {
                                              __typename?: "BasicBlockGridModel"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicBlockListModel"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicContentPicker"
                                              model: string
                                              contentList: Array<{
                                                __typename?: "BasicContentPickerItem"
                                                id: number
                                                absoluteUrl: string
                                                key: any
                                                name?: string | null
                                                url: string
                                                urlSegment?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicDateTimePicker"
                                              model: string
                                              dateTime?: any | null
                                            }
                                          | {
                                              __typename?: "BasicLabel"
                                              model: string
                                              label?: any | null
                                            }
                                          | {
                                              __typename?: "BasicMediaPicker"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicMemberPicker"
                                              model: string
                                              members: Array<{
                                                __typename?: "BasicMemberPickerItem"
                                                id?: number | null
                                                name?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicMultiUrlPicker"
                                              model: string
                                              links: Array<{
                                                __typename?: "BasicMultiUrlPickerItem"
                                                name?: string | null
                                                target?: string | null
                                                type: LinkType
                                                url?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicNestedContent"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicPropertyValue"
                                              model: string
                                              value?: any | null
                                            }
                                          | {
                                              __typename?: "BasicRichText"
                                              model: string
                                              richText?: string | null
                                            }
                                          | {
                                              __typename?: "BasicUnsupportedPropertyValue"
                                              model: string
                                              message: string
                                            }
                                          | {
                                              __typename?: "MintMediaPicker"
                                              model: string
                                              mediaItems: Array<{
                                                __typename?: "MintMediaPickerItem"
                                                id: number
                                                url: string
                                                altText?: string | null
                                              }>
                                            }
                                          | null
                                      } | null>
                                    }> | null
                                  }
                                | {
                                    __typename?: "BasicPropertyValue"
                                    model: string
                                    value?: any | null
                                  }
                                | {
                                    __typename?: "BasicRichText"
                                    model: string
                                    richText?: string | null
                                  }
                                | {
                                    __typename?: "BasicUnsupportedPropertyValue"
                                    model: string
                                    message: string
                                  }
                                | {
                                    __typename?: "MintMediaPicker"
                                    model: string
                                    mediaItems: Array<{
                                      __typename?: "MintMediaPickerItem"
                                      id: number
                                      url: string
                                      altText?: string | null
                                    }>
                                  }
                                | null
                            } | null>
                          }>
                        }
                      | {
                          __typename?: "BasicMultiUrlPicker"
                          valueType: string
                          links: Array<{
                            __typename?: "BasicMultiUrlPickerItem"
                            name?: string | null
                            target?: string | null
                            type: LinkType
                            url?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicNestedContent"
                          valueType: string
                          elements?: Array<{
                            __typename?: "BasicNestedContentElement"
                            properties: Array<{
                              __typename?: "BasicProperty"
                              alias?: string | null
                              editorAlias?: string | null
                              value?:
                                | {
                                    __typename?: "BasicBlockGridModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicBlockListModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicContentPicker"
                                    model: string
                                    contentList: Array<{
                                      __typename?: "BasicContentPickerItem"
                                      id: number
                                      absoluteUrl: string
                                      key: any
                                      name?: string | null
                                      url: string
                                      urlSegment?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicDateTimePicker"
                                    model: string
                                    dateTime?: any | null
                                  }
                                | {
                                    __typename?: "BasicLabel"
                                    model: string
                                    label?: any | null
                                  }
                                | {
                                    __typename?: "BasicMediaPicker"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicMemberPicker"
                                    model: string
                                    members: Array<{
                                      __typename?: "BasicMemberPickerItem"
                                      id?: number | null
                                      name?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicMultiUrlPicker"
                                    model: string
                                    links: Array<{
                                      __typename?: "BasicMultiUrlPickerItem"
                                      name?: string | null
                                      target?: string | null
                                      type: LinkType
                                      url?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicNestedContent"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicPropertyValue"
                                    model: string
                                    value?: any | null
                                  }
                                | {
                                    __typename?: "BasicRichText"
                                    model: string
                                    richText?: string | null
                                  }
                                | {
                                    __typename?: "BasicUnsupportedPropertyValue"
                                    model: string
                                    message: string
                                  }
                                | {
                                    __typename?: "MintMediaPicker"
                                    model: string
                                    mediaItems: Array<{
                                      __typename?: "MintMediaPickerItem"
                                      id: number
                                      url: string
                                      altText?: string | null
                                    }>
                                  }
                                | null
                            } | null>
                          }> | null
                        }
                      | {
                          __typename?: "BasicPropertyValue"
                          valueType: string
                          value?: any | null
                        }
                      | {
                          __typename?: "BasicRichText"
                          valueType: string
                          richText?: string | null
                        }
                      | {
                          __typename?: "BasicUnsupportedPropertyValue"
                          message: string
                          valueType: string
                        }
                      | {
                          __typename?: "MintMediaPicker"
                          valueType: string
                          mediaItems: Array<{
                            __typename?: "MintMediaPickerItem"
                            id: number
                            url: string
                            altText?: string | null
                          }>
                        }
                      | null
                  } | null>
                  settingsProperties: Array<{
                    __typename?: "BasicProperty"
                    value?:
                      | {
                          __typename?: "BasicBlockGridModel"
                          valueType: string
                        }
                      | {
                          __typename?: "BasicBlockListModel"
                          valueType: string
                        }
                      | {
                          __typename?: "BasicContentPicker"
                          valueType: string
                          contentList: Array<{
                            __typename?: "BasicContentPickerItem"
                            id: number
                            absoluteUrl: string
                            key: any
                            name?: string | null
                            url: string
                            urlSegment?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicDateTimePicker"
                          valueType: string
                          dateTime?: any | null
                        }
                      | {
                          __typename?: "BasicLabel"
                          valueType: string
                          label?: any | null
                        }
                      | { __typename?: "BasicMediaPicker"; valueType: string }
                      | {
                          __typename?: "BasicMemberPicker"
                          valueType: string
                          members: Array<{
                            __typename?: "BasicMemberPickerItem"
                            id?: number | null
                            name?: string | null
                            properties: Array<{
                              __typename?: "BasicProperty"
                              alias?: string | null
                              editorAlias?: string | null
                              value?:
                                | {
                                    __typename?: "BasicBlockGridModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicBlockListModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicContentPicker"
                                    model: string
                                    contentList: Array<{
                                      __typename?: "BasicContentPickerItem"
                                      id: number
                                      absoluteUrl: string
                                      key: any
                                      name?: string | null
                                      url: string
                                      urlSegment?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicDateTimePicker"
                                    model: string
                                    dateTime?: any | null
                                  }
                                | {
                                    __typename?: "BasicLabel"
                                    model: string
                                    label?: any | null
                                  }
                                | {
                                    __typename?: "BasicMediaPicker"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicMemberPicker"
                                    model: string
                                    members: Array<{
                                      __typename?: "BasicMemberPickerItem"
                                      id?: number | null
                                      name?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicMultiUrlPicker"
                                    model: string
                                    links: Array<{
                                      __typename?: "BasicMultiUrlPickerItem"
                                      name?: string | null
                                      target?: string | null
                                      type: LinkType
                                      url?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicNestedContent"
                                    model: string
                                    elements?: Array<{
                                      __typename?: "BasicNestedContentElement"
                                      properties: Array<{
                                        __typename?: "BasicProperty"
                                        alias?: string | null
                                        editorAlias?: string | null
                                        value?:
                                          | {
                                              __typename?: "BasicBlockGridModel"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicBlockListModel"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicContentPicker"
                                              model: string
                                              contentList: Array<{
                                                __typename?: "BasicContentPickerItem"
                                                id: number
                                                absoluteUrl: string
                                                key: any
                                                name?: string | null
                                                url: string
                                                urlSegment?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicDateTimePicker"
                                              model: string
                                              dateTime?: any | null
                                            }
                                          | {
                                              __typename?: "BasicLabel"
                                              model: string
                                              label?: any | null
                                            }
                                          | {
                                              __typename?: "BasicMediaPicker"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicMemberPicker"
                                              model: string
                                              members: Array<{
                                                __typename?: "BasicMemberPickerItem"
                                                id?: number | null
                                                name?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicMultiUrlPicker"
                                              model: string
                                              links: Array<{
                                                __typename?: "BasicMultiUrlPickerItem"
                                                name?: string | null
                                                target?: string | null
                                                type: LinkType
                                                url?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicNestedContent"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicPropertyValue"
                                              model: string
                                              value?: any | null
                                            }
                                          | {
                                              __typename?: "BasicRichText"
                                              model: string
                                              richText?: string | null
                                            }
                                          | {
                                              __typename?: "BasicUnsupportedPropertyValue"
                                              model: string
                                              message: string
                                            }
                                          | {
                                              __typename?: "MintMediaPicker"
                                              model: string
                                              mediaItems: Array<{
                                                __typename?: "MintMediaPickerItem"
                                                id: number
                                                url: string
                                                altText?: string | null
                                              }>
                                            }
                                          | null
                                      } | null>
                                    }> | null
                                  }
                                | {
                                    __typename?: "BasicPropertyValue"
                                    model: string
                                    value?: any | null
                                  }
                                | {
                                    __typename?: "BasicRichText"
                                    model: string
                                    richText?: string | null
                                  }
                                | {
                                    __typename?: "BasicUnsupportedPropertyValue"
                                    model: string
                                    message: string
                                  }
                                | {
                                    __typename?: "MintMediaPicker"
                                    model: string
                                    mediaItems: Array<{
                                      __typename?: "MintMediaPickerItem"
                                      id: number
                                      url: string
                                      altText?: string | null
                                    }>
                                  }
                                | null
                            } | null>
                          }>
                        }
                      | {
                          __typename?: "BasicMultiUrlPicker"
                          valueType: string
                          links: Array<{
                            __typename?: "BasicMultiUrlPickerItem"
                            name?: string | null
                            target?: string | null
                            type: LinkType
                            url?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicNestedContent"
                          valueType: string
                          elements?: Array<{
                            __typename?: "BasicNestedContentElement"
                            properties: Array<{
                              __typename?: "BasicProperty"
                              alias?: string | null
                              editorAlias?: string | null
                              value?:
                                | {
                                    __typename?: "BasicBlockGridModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicBlockListModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicContentPicker"
                                    model: string
                                    contentList: Array<{
                                      __typename?: "BasicContentPickerItem"
                                      id: number
                                      absoluteUrl: string
                                      key: any
                                      name?: string | null
                                      url: string
                                      urlSegment?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicDateTimePicker"
                                    model: string
                                    dateTime?: any | null
                                  }
                                | {
                                    __typename?: "BasicLabel"
                                    model: string
                                    label?: any | null
                                  }
                                | {
                                    __typename?: "BasicMediaPicker"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicMemberPicker"
                                    model: string
                                    members: Array<{
                                      __typename?: "BasicMemberPickerItem"
                                      id?: number | null
                                      name?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicMultiUrlPicker"
                                    model: string
                                    links: Array<{
                                      __typename?: "BasicMultiUrlPickerItem"
                                      name?: string | null
                                      target?: string | null
                                      type: LinkType
                                      url?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicNestedContent"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicPropertyValue"
                                    model: string
                                    value?: any | null
                                  }
                                | {
                                    __typename?: "BasicRichText"
                                    model: string
                                    richText?: string | null
                                  }
                                | {
                                    __typename?: "BasicUnsupportedPropertyValue"
                                    model: string
                                    message: string
                                  }
                                | {
                                    __typename?: "MintMediaPicker"
                                    model: string
                                    mediaItems: Array<{
                                      __typename?: "MintMediaPickerItem"
                                      id: number
                                      url: string
                                      altText?: string | null
                                    }>
                                  }
                                | null
                            } | null>
                          }> | null
                        }
                      | {
                          __typename?: "BasicPropertyValue"
                          valueType: string
                          value?: any | null
                        }
                      | {
                          __typename?: "BasicRichText"
                          valueType: string
                          richText?: string | null
                        }
                      | {
                          __typename?: "BasicUnsupportedPropertyValue"
                          message: string
                          valueType: string
                        }
                      | {
                          __typename?: "MintMediaPicker"
                          valueType: string
                          mediaItems: Array<{
                            __typename?: "MintMediaPickerItem"
                            id: number
                            url: string
                            altText?: string | null
                          }>
                        }
                      | null
                  } | null>
                  areas: Array<{
                    __typename?: "BasicBlockGridArea"
                    alias?: string | null
                    rowSpan: number
                    columnSpan: number
                  } | null>
                }> | null
              } | null>
            }> | null
          }
        | {
            __typename?: "BasicBlockListModel"
            valueType: string
            blocks?: Array<{
              __typename?: "BasicBlockListItem"
              blockType?: string | null
              properties: Array<{
                __typename?: "BasicProperty"
                propertyName?: string | null
                propertyValue?:
                  | { __typename?: "BasicBlockGridModel"; valueType: string }
                  | {
                      __typename?: "BasicBlockListModel"
                      valueType: string
                      blocks?: Array<{
                        __typename?: "BasicBlockListItem"
                        blockType?: string | null
                        properties: Array<{
                          __typename?: "BasicProperty"
                          propertyName?: string | null
                          propertyValue?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                valueType: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                valueType: string
                                blocks?: Array<{
                                  __typename?: "BasicBlockListItem"
                                  blockType?: string | null
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    propertyName?: string | null
                                    propertyValue?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          valueType: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          valueType: string
                                          blocks?: Array<{
                                            __typename?: "BasicBlockListItem"
                                            blockType?: string | null
                                            properties: Array<{
                                              __typename?: "BasicProperty"
                                              propertyName?: string | null
                                              propertyValue?:
                                                | {
                                                    __typename?: "BasicBlockGridModel"
                                                    valueType: string
                                                  }
                                                | {
                                                    __typename?: "BasicBlockListModel"
                                                    valueType: string
                                                    blocks?: Array<{
                                                      __typename?: "BasicBlockListItem"
                                                      blockType?: string | null
                                                      properties: Array<{
                                                        __typename?: "BasicProperty"
                                                        propertyName?:
                                                          | string
                                                          | null
                                                        propertyValue?:
                                                          | {
                                                              __typename?: "BasicBlockGridModel"
                                                              valueType: string
                                                            }
                                                          | {
                                                              __typename?: "BasicBlockListModel"
                                                              valueType: string
                                                            }
                                                          | {
                                                              __typename?: "BasicContentPicker"
                                                              valueType: string
                                                              contentList: Array<{
                                                                __typename?: "BasicContentPickerItem"
                                                                id: number
                                                                absoluteUrl: string
                                                                key: any
                                                                name?:
                                                                  | string
                                                                  | null
                                                                url: string
                                                                urlSegment?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicDateTimePicker"
                                                              valueType: string
                                                              dateTime?:
                                                                | any
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicLabel"
                                                              valueType: string
                                                              label?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicMediaPicker"
                                                              valueType: string
                                                            }
                                                          | {
                                                              __typename?: "BasicMemberPicker"
                                                              valueType: string
                                                              members: Array<{
                                                                __typename?: "BasicMemberPickerItem"
                                                                id?:
                                                                  | number
                                                                  | null
                                                                name?:
                                                                  | string
                                                                  | null
                                                                properties: Array<{
                                                                  __typename?: "BasicProperty"
                                                                  alias?:
                                                                    | string
                                                                    | null
                                                                  editorAlias?:
                                                                    | string
                                                                    | null
                                                                  value?:
                                                                    | {
                                                                        __typename?: "BasicBlockGridModel"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicBlockListModel"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicContentPicker"
                                                                        model: string
                                                                        contentList: Array<{
                                                                          __typename?: "BasicContentPickerItem"
                                                                          id: number
                                                                          absoluteUrl: string
                                                                          key: any
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                          url: string
                                                                          urlSegment?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicDateTimePicker"
                                                                        model: string
                                                                        dateTime?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicLabel"
                                                                        model: string
                                                                        label?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMediaPicker"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMemberPicker"
                                                                        model: string
                                                                        members: Array<{
                                                                          __typename?: "BasicMemberPickerItem"
                                                                          id?:
                                                                            | number
                                                                            | null
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMultiUrlPicker"
                                                                        model: string
                                                                        links: Array<{
                                                                          __typename?: "BasicMultiUrlPickerItem"
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                          target?:
                                                                            | string
                                                                            | null
                                                                          type: LinkType
                                                                          url?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicNestedContent"
                                                                        model: string
                                                                        elements?: Array<{
                                                                          __typename?: "BasicNestedContentElement"
                                                                          properties: Array<{
                                                                            __typename?: "BasicProperty"
                                                                            alias?:
                                                                              | string
                                                                              | null
                                                                            editorAlias?:
                                                                              | string
                                                                              | null
                                                                            value?:
                                                                              | {
                                                                                  __typename?: "BasicBlockGridModel"
                                                                                  model: string
                                                                                }
                                                                              | {
                                                                                  __typename?: "BasicBlockListModel"
                                                                                  model: string
                                                                                }
                                                                              | {
                                                                                  __typename?: "BasicContentPicker"
                                                                                  model: string
                                                                                  contentList: Array<{
                                                                                    __typename?: "BasicContentPickerItem"
                                                                                    id: number
                                                                                    absoluteUrl: string
                                                                                    key: any
                                                                                    name?:
                                                                                      | string
                                                                                      | null
                                                                                    url: string
                                                                                    urlSegment?:
                                                                                      | string
                                                                                      | null
                                                                                  }>
                                                                                }
                                                                              | {
                                                                                  __typename?: "BasicDateTimePicker"
                                                                                  model: string
                                                                                  dateTime?:
                                                                                    | any
                                                                                    | null
                                                                                }
                                                                              | {
                                                                                  __typename?: "BasicLabel"
                                                                                  model: string
                                                                                  label?:
                                                                                    | any
                                                                                    | null
                                                                                }
                                                                              | {
                                                                                  __typename?: "BasicMediaPicker"
                                                                                  model: string
                                                                                }
                                                                              | {
                                                                                  __typename?: "BasicMemberPicker"
                                                                                  model: string
                                                                                  members: Array<{
                                                                                    __typename?: "BasicMemberPickerItem"
                                                                                    id?:
                                                                                      | number
                                                                                      | null
                                                                                    name?:
                                                                                      | string
                                                                                      | null
                                                                                  }>
                                                                                }
                                                                              | {
                                                                                  __typename?: "BasicMultiUrlPicker"
                                                                                  model: string
                                                                                  links: Array<{
                                                                                    __typename?: "BasicMultiUrlPickerItem"
                                                                                    name?:
                                                                                      | string
                                                                                      | null
                                                                                    target?:
                                                                                      | string
                                                                                      | null
                                                                                    type: LinkType
                                                                                    url?:
                                                                                      | string
                                                                                      | null
                                                                                  }>
                                                                                }
                                                                              | {
                                                                                  __typename?: "BasicNestedContent"
                                                                                  model: string
                                                                                }
                                                                              | {
                                                                                  __typename?: "BasicPropertyValue"
                                                                                  model: string
                                                                                  value?:
                                                                                    | any
                                                                                    | null
                                                                                }
                                                                              | {
                                                                                  __typename?: "BasicRichText"
                                                                                  model: string
                                                                                  richText?:
                                                                                    | string
                                                                                    | null
                                                                                }
                                                                              | {
                                                                                  __typename?: "BasicUnsupportedPropertyValue"
                                                                                  model: string
                                                                                  message: string
                                                                                }
                                                                              | {
                                                                                  __typename?: "MintMediaPicker"
                                                                                  model: string
                                                                                  mediaItems: Array<{
                                                                                    __typename?: "MintMediaPickerItem"
                                                                                    id: number
                                                                                    url: string
                                                                                    altText?:
                                                                                      | string
                                                                                      | null
                                                                                  }>
                                                                                }
                                                                              | null
                                                                          } | null>
                                                                        }> | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicPropertyValue"
                                                                        model: string
                                                                        value?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicRichText"
                                                                        model: string
                                                                        richText?:
                                                                          | string
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicUnsupportedPropertyValue"
                                                                        model: string
                                                                        message: string
                                                                      }
                                                                    | {
                                                                        __typename?: "MintMediaPicker"
                                                                        model: string
                                                                        mediaItems: Array<{
                                                                          __typename?: "MintMediaPickerItem"
                                                                          id: number
                                                                          url: string
                                                                          altText?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | null
                                                                } | null>
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicMultiUrlPicker"
                                                              valueType: string
                                                              links: Array<{
                                                                __typename?: "BasicMultiUrlPickerItem"
                                                                name?:
                                                                  | string
                                                                  | null
                                                                target?:
                                                                  | string
                                                                  | null
                                                                type: LinkType
                                                                url?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicNestedContent"
                                                              valueType: string
                                                              elements?: Array<{
                                                                __typename?: "BasicNestedContentElement"
                                                                properties: Array<{
                                                                  __typename?: "BasicProperty"
                                                                  alias?:
                                                                    | string
                                                                    | null
                                                                  editorAlias?:
                                                                    | string
                                                                    | null
                                                                  value?:
                                                                    | {
                                                                        __typename?: "BasicBlockGridModel"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicBlockListModel"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicContentPicker"
                                                                        model: string
                                                                        contentList: Array<{
                                                                          __typename?: "BasicContentPickerItem"
                                                                          id: number
                                                                          absoluteUrl: string
                                                                          key: any
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                          url: string
                                                                          urlSegment?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicDateTimePicker"
                                                                        model: string
                                                                        dateTime?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicLabel"
                                                                        model: string
                                                                        label?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMediaPicker"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMemberPicker"
                                                                        model: string
                                                                        members: Array<{
                                                                          __typename?: "BasicMemberPickerItem"
                                                                          id?:
                                                                            | number
                                                                            | null
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMultiUrlPicker"
                                                                        model: string
                                                                        links: Array<{
                                                                          __typename?: "BasicMultiUrlPickerItem"
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                          target?:
                                                                            | string
                                                                            | null
                                                                          type: LinkType
                                                                          url?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicNestedContent"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicPropertyValue"
                                                                        model: string
                                                                        value?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicRichText"
                                                                        model: string
                                                                        richText?:
                                                                          | string
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicUnsupportedPropertyValue"
                                                                        model: string
                                                                        message: string
                                                                      }
                                                                    | {
                                                                        __typename?: "MintMediaPicker"
                                                                        model: string
                                                                        mediaItems: Array<{
                                                                          __typename?: "MintMediaPickerItem"
                                                                          id: number
                                                                          url: string
                                                                          altText?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | null
                                                                } | null>
                                                              }> | null
                                                            }
                                                          | {
                                                              __typename?: "BasicPropertyValue"
                                                              valueType: string
                                                              value?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicRichText"
                                                              valueType: string
                                                              richText?:
                                                                | string
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicUnsupportedPropertyValue"
                                                              message: string
                                                              valueType: string
                                                            }
                                                          | {
                                                              __typename?: "MintMediaPicker"
                                                              valueType: string
                                                              mediaItems: Array<{
                                                                __typename?: "MintMediaPickerItem"
                                                                id: number
                                                                url: string
                                                                altText?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | null
                                                      } | null>
                                                    }> | null
                                                  }
                                                | {
                                                    __typename?: "BasicContentPicker"
                                                    valueType: string
                                                    contentList: Array<{
                                                      __typename?: "BasicContentPickerItem"
                                                      id: number
                                                      absoluteUrl: string
                                                      key: any
                                                      name?: string | null
                                                      url: string
                                                      urlSegment?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicDateTimePicker"
                                                    valueType: string
                                                    dateTime?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicLabel"
                                                    valueType: string
                                                    label?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicMediaPicker"
                                                    valueType: string
                                                  }
                                                | {
                                                    __typename?: "BasicMemberPicker"
                                                    valueType: string
                                                    members: Array<{
                                                      __typename?: "BasicMemberPickerItem"
                                                      id?: number | null
                                                      name?: string | null
                                                      properties: Array<{
                                                        __typename?: "BasicProperty"
                                                        alias?: string | null
                                                        editorAlias?:
                                                          | string
                                                          | null
                                                        value?:
                                                          | {
                                                              __typename?: "BasicBlockGridModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicBlockListModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicContentPicker"
                                                              model: string
                                                              contentList: Array<{
                                                                __typename?: "BasicContentPickerItem"
                                                                id: number
                                                                absoluteUrl: string
                                                                key: any
                                                                name?:
                                                                  | string
                                                                  | null
                                                                url: string
                                                                urlSegment?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicDateTimePicker"
                                                              model: string
                                                              dateTime?:
                                                                | any
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicLabel"
                                                              model: string
                                                              label?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicMediaPicker"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicMemberPicker"
                                                              model: string
                                                              members: Array<{
                                                                __typename?: "BasicMemberPickerItem"
                                                                id?:
                                                                  | number
                                                                  | null
                                                                name?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicMultiUrlPicker"
                                                              model: string
                                                              links: Array<{
                                                                __typename?: "BasicMultiUrlPickerItem"
                                                                name?:
                                                                  | string
                                                                  | null
                                                                target?:
                                                                  | string
                                                                  | null
                                                                type: LinkType
                                                                url?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicNestedContent"
                                                              model: string
                                                              elements?: Array<{
                                                                __typename?: "BasicNestedContentElement"
                                                                properties: Array<{
                                                                  __typename?: "BasicProperty"
                                                                  alias?:
                                                                    | string
                                                                    | null
                                                                  editorAlias?:
                                                                    | string
                                                                    | null
                                                                  value?:
                                                                    | {
                                                                        __typename?: "BasicBlockGridModel"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicBlockListModel"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicContentPicker"
                                                                        model: string
                                                                        contentList: Array<{
                                                                          __typename?: "BasicContentPickerItem"
                                                                          id: number
                                                                          absoluteUrl: string
                                                                          key: any
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                          url: string
                                                                          urlSegment?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicDateTimePicker"
                                                                        model: string
                                                                        dateTime?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicLabel"
                                                                        model: string
                                                                        label?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMediaPicker"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMemberPicker"
                                                                        model: string
                                                                        members: Array<{
                                                                          __typename?: "BasicMemberPickerItem"
                                                                          id?:
                                                                            | number
                                                                            | null
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMultiUrlPicker"
                                                                        model: string
                                                                        links: Array<{
                                                                          __typename?: "BasicMultiUrlPickerItem"
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                          target?:
                                                                            | string
                                                                            | null
                                                                          type: LinkType
                                                                          url?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicNestedContent"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicPropertyValue"
                                                                        model: string
                                                                        value?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicRichText"
                                                                        model: string
                                                                        richText?:
                                                                          | string
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicUnsupportedPropertyValue"
                                                                        model: string
                                                                        message: string
                                                                      }
                                                                    | {
                                                                        __typename?: "MintMediaPicker"
                                                                        model: string
                                                                        mediaItems: Array<{
                                                                          __typename?: "MintMediaPickerItem"
                                                                          id: number
                                                                          url: string
                                                                          altText?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | null
                                                                } | null>
                                                              }> | null
                                                            }
                                                          | {
                                                              __typename?: "BasicPropertyValue"
                                                              model: string
                                                              value?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicRichText"
                                                              model: string
                                                              richText?:
                                                                | string
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicUnsupportedPropertyValue"
                                                              model: string
                                                              message: string
                                                            }
                                                          | {
                                                              __typename?: "MintMediaPicker"
                                                              model: string
                                                              mediaItems: Array<{
                                                                __typename?: "MintMediaPickerItem"
                                                                id: number
                                                                url: string
                                                                altText?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | null
                                                      } | null>
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicMultiUrlPicker"
                                                    valueType: string
                                                    links: Array<{
                                                      __typename?: "BasicMultiUrlPickerItem"
                                                      name?: string | null
                                                      target?: string | null
                                                      type: LinkType
                                                      url?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicNestedContent"
                                                    valueType: string
                                                    elements?: Array<{
                                                      __typename?: "BasicNestedContentElement"
                                                      properties: Array<{
                                                        __typename?: "BasicProperty"
                                                        alias?: string | null
                                                        editorAlias?:
                                                          | string
                                                          | null
                                                        value?:
                                                          | {
                                                              __typename?: "BasicBlockGridModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicBlockListModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicContentPicker"
                                                              model: string
                                                              contentList: Array<{
                                                                __typename?: "BasicContentPickerItem"
                                                                id: number
                                                                absoluteUrl: string
                                                                key: any
                                                                name?:
                                                                  | string
                                                                  | null
                                                                url: string
                                                                urlSegment?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicDateTimePicker"
                                                              model: string
                                                              dateTime?:
                                                                | any
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicLabel"
                                                              model: string
                                                              label?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicMediaPicker"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicMemberPicker"
                                                              model: string
                                                              members: Array<{
                                                                __typename?: "BasicMemberPickerItem"
                                                                id?:
                                                                  | number
                                                                  | null
                                                                name?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicMultiUrlPicker"
                                                              model: string
                                                              links: Array<{
                                                                __typename?: "BasicMultiUrlPickerItem"
                                                                name?:
                                                                  | string
                                                                  | null
                                                                target?:
                                                                  | string
                                                                  | null
                                                                type: LinkType
                                                                url?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicNestedContent"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicPropertyValue"
                                                              model: string
                                                              value?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicRichText"
                                                              model: string
                                                              richText?:
                                                                | string
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicUnsupportedPropertyValue"
                                                              model: string
                                                              message: string
                                                            }
                                                          | {
                                                              __typename?: "MintMediaPicker"
                                                              model: string
                                                              mediaItems: Array<{
                                                                __typename?: "MintMediaPickerItem"
                                                                id: number
                                                                url: string
                                                                altText?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | null
                                                      } | null>
                                                    }> | null
                                                  }
                                                | {
                                                    __typename?: "BasicPropertyValue"
                                                    valueType: string
                                                    value?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicRichText"
                                                    valueType: string
                                                    richText?: string | null
                                                  }
                                                | {
                                                    __typename?: "BasicUnsupportedPropertyValue"
                                                    message: string
                                                    valueType: string
                                                  }
                                                | {
                                                    __typename?: "MintMediaPicker"
                                                    valueType: string
                                                    mediaItems: Array<{
                                                      __typename?: "MintMediaPickerItem"
                                                      id: number
                                                      url: string
                                                      altText?: string | null
                                                    }>
                                                  }
                                                | null
                                            } | null>
                                          }> | null
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          valueType: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          valueType: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          valueType: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          valueType: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          valueType: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                            properties: Array<{
                                              __typename?: "BasicProperty"
                                              alias?: string | null
                                              editorAlias?: string | null
                                              value?:
                                                | {
                                                    __typename?: "BasicBlockGridModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicBlockListModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicContentPicker"
                                                    model: string
                                                    contentList: Array<{
                                                      __typename?: "BasicContentPickerItem"
                                                      id: number
                                                      absoluteUrl: string
                                                      key: any
                                                      name?: string | null
                                                      url: string
                                                      urlSegment?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicDateTimePicker"
                                                    model: string
                                                    dateTime?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicLabel"
                                                    model: string
                                                    label?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicMediaPicker"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicMemberPicker"
                                                    model: string
                                                    members: Array<{
                                                      __typename?: "BasicMemberPickerItem"
                                                      id?: number | null
                                                      name?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicMultiUrlPicker"
                                                    model: string
                                                    links: Array<{
                                                      __typename?: "BasicMultiUrlPickerItem"
                                                      name?: string | null
                                                      target?: string | null
                                                      type: LinkType
                                                      url?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicNestedContent"
                                                    model: string
                                                    elements?: Array<{
                                                      __typename?: "BasicNestedContentElement"
                                                      properties: Array<{
                                                        __typename?: "BasicProperty"
                                                        alias?: string | null
                                                        editorAlias?:
                                                          | string
                                                          | null
                                                        value?:
                                                          | {
                                                              __typename?: "BasicBlockGridModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicBlockListModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicContentPicker"
                                                              model: string
                                                              contentList: Array<{
                                                                __typename?: "BasicContentPickerItem"
                                                                id: number
                                                                absoluteUrl: string
                                                                key: any
                                                                name?:
                                                                  | string
                                                                  | null
                                                                url: string
                                                                urlSegment?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicDateTimePicker"
                                                              model: string
                                                              dateTime?:
                                                                | any
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicLabel"
                                                              model: string
                                                              label?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicMediaPicker"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicMemberPicker"
                                                              model: string
                                                              members: Array<{
                                                                __typename?: "BasicMemberPickerItem"
                                                                id?:
                                                                  | number
                                                                  | null
                                                                name?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicMultiUrlPicker"
                                                              model: string
                                                              links: Array<{
                                                                __typename?: "BasicMultiUrlPickerItem"
                                                                name?:
                                                                  | string
                                                                  | null
                                                                target?:
                                                                  | string
                                                                  | null
                                                                type: LinkType
                                                                url?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicNestedContent"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicPropertyValue"
                                                              model: string
                                                              value?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicRichText"
                                                              model: string
                                                              richText?:
                                                                | string
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicUnsupportedPropertyValue"
                                                              model: string
                                                              message: string
                                                            }
                                                          | {
                                                              __typename?: "MintMediaPicker"
                                                              model: string
                                                              mediaItems: Array<{
                                                                __typename?: "MintMediaPickerItem"
                                                                id: number
                                                                url: string
                                                                altText?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | null
                                                      } | null>
                                                    }> | null
                                                  }
                                                | {
                                                    __typename?: "BasicPropertyValue"
                                                    model: string
                                                    value?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicRichText"
                                                    model: string
                                                    richText?: string | null
                                                  }
                                                | {
                                                    __typename?: "BasicUnsupportedPropertyValue"
                                                    model: string
                                                    message: string
                                                  }
                                                | {
                                                    __typename?: "MintMediaPicker"
                                                    model: string
                                                    mediaItems: Array<{
                                                      __typename?: "MintMediaPickerItem"
                                                      id: number
                                                      url: string
                                                      altText?: string | null
                                                    }>
                                                  }
                                                | null
                                            } | null>
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          valueType: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          valueType: string
                                          elements?: Array<{
                                            __typename?: "BasicNestedContentElement"
                                            properties: Array<{
                                              __typename?: "BasicProperty"
                                              alias?: string | null
                                              editorAlias?: string | null
                                              value?:
                                                | {
                                                    __typename?: "BasicBlockGridModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicBlockListModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicContentPicker"
                                                    model: string
                                                    contentList: Array<{
                                                      __typename?: "BasicContentPickerItem"
                                                      id: number
                                                      absoluteUrl: string
                                                      key: any
                                                      name?: string | null
                                                      url: string
                                                      urlSegment?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicDateTimePicker"
                                                    model: string
                                                    dateTime?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicLabel"
                                                    model: string
                                                    label?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicMediaPicker"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicMemberPicker"
                                                    model: string
                                                    members: Array<{
                                                      __typename?: "BasicMemberPickerItem"
                                                      id?: number | null
                                                      name?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicMultiUrlPicker"
                                                    model: string
                                                    links: Array<{
                                                      __typename?: "BasicMultiUrlPickerItem"
                                                      name?: string | null
                                                      target?: string | null
                                                      type: LinkType
                                                      url?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicNestedContent"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicPropertyValue"
                                                    model: string
                                                    value?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicRichText"
                                                    model: string
                                                    richText?: string | null
                                                  }
                                                | {
                                                    __typename?: "BasicUnsupportedPropertyValue"
                                                    model: string
                                                    message: string
                                                  }
                                                | {
                                                    __typename?: "MintMediaPicker"
                                                    model: string
                                                    mediaItems: Array<{
                                                      __typename?: "MintMediaPickerItem"
                                                      id: number
                                                      url: string
                                                      altText?: string | null
                                                    }>
                                                  }
                                                | null
                                            } | null>
                                          }> | null
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          valueType: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          valueType: string
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          message: string
                                          valueType: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          valueType: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }> | null
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                valueType: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                valueType: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                valueType: string
                                label?: any | null
                              }
                            | {
                                __typename?: "BasicMediaPicker"
                                valueType: string
                              }
                            | {
                                __typename?: "BasicMemberPicker"
                                valueType: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    alias?: string | null
                                    editorAlias?: string | null
                                    value?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          model: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          model: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          model: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          model: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          model: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          model: string
                                          elements?: Array<{
                                            __typename?: "BasicNestedContentElement"
                                            properties: Array<{
                                              __typename?: "BasicProperty"
                                              alias?: string | null
                                              editorAlias?: string | null
                                              value?:
                                                | {
                                                    __typename?: "BasicBlockGridModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicBlockListModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicContentPicker"
                                                    model: string
                                                    contentList: Array<{
                                                      __typename?: "BasicContentPickerItem"
                                                      id: number
                                                      absoluteUrl: string
                                                      key: any
                                                      name?: string | null
                                                      url: string
                                                      urlSegment?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicDateTimePicker"
                                                    model: string
                                                    dateTime?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicLabel"
                                                    model: string
                                                    label?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicMediaPicker"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicMemberPicker"
                                                    model: string
                                                    members: Array<{
                                                      __typename?: "BasicMemberPickerItem"
                                                      id?: number | null
                                                      name?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicMultiUrlPicker"
                                                    model: string
                                                    links: Array<{
                                                      __typename?: "BasicMultiUrlPickerItem"
                                                      name?: string | null
                                                      target?: string | null
                                                      type: LinkType
                                                      url?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicNestedContent"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicPropertyValue"
                                                    model: string
                                                    value?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicRichText"
                                                    model: string
                                                    richText?: string | null
                                                  }
                                                | {
                                                    __typename?: "BasicUnsupportedPropertyValue"
                                                    model: string
                                                    message: string
                                                  }
                                                | {
                                                    __typename?: "MintMediaPicker"
                                                    model: string
                                                    mediaItems: Array<{
                                                      __typename?: "MintMediaPickerItem"
                                                      id: number
                                                      url: string
                                                      altText?: string | null
                                                    }>
                                                  }
                                                | null
                                            } | null>
                                          }> | null
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          model: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          model: string
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          model: string
                                          message: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          model: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                valueType: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                valueType: string
                                elements?: Array<{
                                  __typename?: "BasicNestedContentElement"
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    alias?: string | null
                                    editorAlias?: string | null
                                    value?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          model: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          model: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          model: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          model: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          model: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          model: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          model: string
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          model: string
                                          message: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          model: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }> | null
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                valueType: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                valueType: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                message: string
                                valueType: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                valueType: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicContentPicker"
                      valueType: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      valueType: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      valueType: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; valueType: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      valueType: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                                elements?: Array<{
                                  __typename?: "BasicNestedContentElement"
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    alias?: string | null
                                    editorAlias?: string | null
                                    value?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          model: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          model: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          model: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          model: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          model: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          model: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          model: string
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          model: string
                                          message: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          model: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }> | null
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      valueType: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicNestedContent"
                      valueType: string
                      elements?: Array<{
                        __typename?: "BasicNestedContentElement"
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicPropertyValue"
                      valueType: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      valueType: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      message: string
                      valueType: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      valueType: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }> | null
          }
        | {
            __typename?: "BasicContentPicker"
            valueType: string
            contentList: Array<{
              __typename?: "BasicContentPickerItem"
              id: number
              absoluteUrl: string
              key: any
              name?: string | null
              url: string
              urlSegment?: string | null
            }>
          }
        | {
            __typename?: "BasicDateTimePicker"
            valueType: string
            dateTime?: any | null
          }
        | { __typename?: "BasicLabel"; valueType: string; label?: any | null }
        | { __typename?: "BasicMediaPicker"; valueType: string }
        | {
            __typename?: "BasicMemberPicker"
            valueType: string
            members: Array<{
              __typename?: "BasicMemberPickerItem"
              id?: number | null
              name?: string | null
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicNestedContent"
                      model: string
                      elements?: Array<{
                        __typename?: "BasicNestedContentElement"
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }>
          }
        | {
            __typename?: "BasicMultiUrlPicker"
            valueType: string
            links: Array<{
              __typename?: "BasicMultiUrlPickerItem"
              name?: string | null
              target?: string | null
              type: LinkType
              url?: string | null
            }>
          }
        | {
            __typename?: "BasicNestedContent"
            valueType: string
            elements?: Array<{
              __typename?: "BasicNestedContentElement"
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | { __typename?: "BasicNestedContent"; model: string }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }> | null
          }
        | {
            __typename?: "BasicPropertyValue"
            valueType: string
            value?: any | null
          }
        | {
            __typename?: "BasicRichText"
            valueType: string
            richText?: string | null
          }
        | {
            __typename?: "BasicUnsupportedPropertyValue"
            message: string
            valueType: string
          }
        | {
            __typename?: "MintMediaPicker"
            valueType: string
            mediaItems: Array<{
              __typename?: "MintMediaPickerItem"
              id: number
              url: string
              altText?: string | null
            }>
          }
        | null
    } | null> | null
  } | null
  footer_desktop?: {
    __typename?: "BasicContent"
    name?: string | null
    properties?: Array<{
      __typename?: "BasicProperty"
      propertyName?: string | null
      propertyValue?:
        | {
            __typename?: "BasicBlockGridModel"
            gridColumns?: number | null
            valueType: string
            blocks?: Array<{
              __typename?: "BasicBlockGridItem"
              columnSpan: number
              rowSpan: number
              contentProperties: Array<{
                __typename?: "BasicProperty"
                value?:
                  | { __typename?: "BasicBlockGridModel"; valueType: string }
                  | { __typename?: "BasicBlockListModel"; valueType: string }
                  | {
                      __typename?: "BasicContentPicker"
                      valueType: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      valueType: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      valueType: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; valueType: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      valueType: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                                elements?: Array<{
                                  __typename?: "BasicNestedContentElement"
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    alias?: string | null
                                    editorAlias?: string | null
                                    value?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          model: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          model: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          model: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          model: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          model: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          model: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          model: string
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          model: string
                                          message: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          model: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }> | null
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      valueType: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicNestedContent"
                      valueType: string
                      elements?: Array<{
                        __typename?: "BasicNestedContentElement"
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicPropertyValue"
                      valueType: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      valueType: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      message: string
                      valueType: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      valueType: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
              settingsProperties: Array<{
                __typename?: "BasicProperty"
                value?:
                  | { __typename?: "BasicBlockGridModel"; valueType: string }
                  | { __typename?: "BasicBlockListModel"; valueType: string }
                  | {
                      __typename?: "BasicContentPicker"
                      valueType: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      valueType: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      valueType: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; valueType: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      valueType: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                                elements?: Array<{
                                  __typename?: "BasicNestedContentElement"
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    alias?: string | null
                                    editorAlias?: string | null
                                    value?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          model: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          model: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          model: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          model: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          model: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          model: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          model: string
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          model: string
                                          message: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          model: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }> | null
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      valueType: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicNestedContent"
                      valueType: string
                      elements?: Array<{
                        __typename?: "BasicNestedContentElement"
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicPropertyValue"
                      valueType: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      valueType: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      message: string
                      valueType: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      valueType: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
              areas: Array<{
                __typename?: "BasicBlockGridArea"
                alias?: string | null
                rowSpan: number
                columnSpan: number
                blocks?: Array<{
                  __typename?: "BasicBlockGridItem"
                  columnSpan: number
                  rowSpan: number
                  contentProperties: Array<{
                    __typename?: "BasicProperty"
                    value?:
                      | {
                          __typename?: "BasicBlockGridModel"
                          valueType: string
                        }
                      | {
                          __typename?: "BasicBlockListModel"
                          valueType: string
                        }
                      | {
                          __typename?: "BasicContentPicker"
                          valueType: string
                          contentList: Array<{
                            __typename?: "BasicContentPickerItem"
                            id: number
                            absoluteUrl: string
                            key: any
                            name?: string | null
                            url: string
                            urlSegment?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicDateTimePicker"
                          valueType: string
                          dateTime?: any | null
                        }
                      | {
                          __typename?: "BasicLabel"
                          valueType: string
                          label?: any | null
                        }
                      | { __typename?: "BasicMediaPicker"; valueType: string }
                      | {
                          __typename?: "BasicMemberPicker"
                          valueType: string
                          members: Array<{
                            __typename?: "BasicMemberPickerItem"
                            id?: number | null
                            name?: string | null
                            properties: Array<{
                              __typename?: "BasicProperty"
                              alias?: string | null
                              editorAlias?: string | null
                              value?:
                                | {
                                    __typename?: "BasicBlockGridModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicBlockListModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicContentPicker"
                                    model: string
                                    contentList: Array<{
                                      __typename?: "BasicContentPickerItem"
                                      id: number
                                      absoluteUrl: string
                                      key: any
                                      name?: string | null
                                      url: string
                                      urlSegment?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicDateTimePicker"
                                    model: string
                                    dateTime?: any | null
                                  }
                                | {
                                    __typename?: "BasicLabel"
                                    model: string
                                    label?: any | null
                                  }
                                | {
                                    __typename?: "BasicMediaPicker"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicMemberPicker"
                                    model: string
                                    members: Array<{
                                      __typename?: "BasicMemberPickerItem"
                                      id?: number | null
                                      name?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicMultiUrlPicker"
                                    model: string
                                    links: Array<{
                                      __typename?: "BasicMultiUrlPickerItem"
                                      name?: string | null
                                      target?: string | null
                                      type: LinkType
                                      url?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicNestedContent"
                                    model: string
                                    elements?: Array<{
                                      __typename?: "BasicNestedContentElement"
                                      properties: Array<{
                                        __typename?: "BasicProperty"
                                        alias?: string | null
                                        editorAlias?: string | null
                                        value?:
                                          | {
                                              __typename?: "BasicBlockGridModel"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicBlockListModel"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicContentPicker"
                                              model: string
                                              contentList: Array<{
                                                __typename?: "BasicContentPickerItem"
                                                id: number
                                                absoluteUrl: string
                                                key: any
                                                name?: string | null
                                                url: string
                                                urlSegment?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicDateTimePicker"
                                              model: string
                                              dateTime?: any | null
                                            }
                                          | {
                                              __typename?: "BasicLabel"
                                              model: string
                                              label?: any | null
                                            }
                                          | {
                                              __typename?: "BasicMediaPicker"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicMemberPicker"
                                              model: string
                                              members: Array<{
                                                __typename?: "BasicMemberPickerItem"
                                                id?: number | null
                                                name?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicMultiUrlPicker"
                                              model: string
                                              links: Array<{
                                                __typename?: "BasicMultiUrlPickerItem"
                                                name?: string | null
                                                target?: string | null
                                                type: LinkType
                                                url?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicNestedContent"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicPropertyValue"
                                              model: string
                                              value?: any | null
                                            }
                                          | {
                                              __typename?: "BasicRichText"
                                              model: string
                                              richText?: string | null
                                            }
                                          | {
                                              __typename?: "BasicUnsupportedPropertyValue"
                                              model: string
                                              message: string
                                            }
                                          | {
                                              __typename?: "MintMediaPicker"
                                              model: string
                                              mediaItems: Array<{
                                                __typename?: "MintMediaPickerItem"
                                                id: number
                                                url: string
                                                altText?: string | null
                                              }>
                                            }
                                          | null
                                      } | null>
                                    }> | null
                                  }
                                | {
                                    __typename?: "BasicPropertyValue"
                                    model: string
                                    value?: any | null
                                  }
                                | {
                                    __typename?: "BasicRichText"
                                    model: string
                                    richText?: string | null
                                  }
                                | {
                                    __typename?: "BasicUnsupportedPropertyValue"
                                    model: string
                                    message: string
                                  }
                                | {
                                    __typename?: "MintMediaPicker"
                                    model: string
                                    mediaItems: Array<{
                                      __typename?: "MintMediaPickerItem"
                                      id: number
                                      url: string
                                      altText?: string | null
                                    }>
                                  }
                                | null
                            } | null>
                          }>
                        }
                      | {
                          __typename?: "BasicMultiUrlPicker"
                          valueType: string
                          links: Array<{
                            __typename?: "BasicMultiUrlPickerItem"
                            name?: string | null
                            target?: string | null
                            type: LinkType
                            url?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicNestedContent"
                          valueType: string
                          elements?: Array<{
                            __typename?: "BasicNestedContentElement"
                            properties: Array<{
                              __typename?: "BasicProperty"
                              alias?: string | null
                              editorAlias?: string | null
                              value?:
                                | {
                                    __typename?: "BasicBlockGridModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicBlockListModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicContentPicker"
                                    model: string
                                    contentList: Array<{
                                      __typename?: "BasicContentPickerItem"
                                      id: number
                                      absoluteUrl: string
                                      key: any
                                      name?: string | null
                                      url: string
                                      urlSegment?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicDateTimePicker"
                                    model: string
                                    dateTime?: any | null
                                  }
                                | {
                                    __typename?: "BasicLabel"
                                    model: string
                                    label?: any | null
                                  }
                                | {
                                    __typename?: "BasicMediaPicker"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicMemberPicker"
                                    model: string
                                    members: Array<{
                                      __typename?: "BasicMemberPickerItem"
                                      id?: number | null
                                      name?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicMultiUrlPicker"
                                    model: string
                                    links: Array<{
                                      __typename?: "BasicMultiUrlPickerItem"
                                      name?: string | null
                                      target?: string | null
                                      type: LinkType
                                      url?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicNestedContent"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicPropertyValue"
                                    model: string
                                    value?: any | null
                                  }
                                | {
                                    __typename?: "BasicRichText"
                                    model: string
                                    richText?: string | null
                                  }
                                | {
                                    __typename?: "BasicUnsupportedPropertyValue"
                                    model: string
                                    message: string
                                  }
                                | {
                                    __typename?: "MintMediaPicker"
                                    model: string
                                    mediaItems: Array<{
                                      __typename?: "MintMediaPickerItem"
                                      id: number
                                      url: string
                                      altText?: string | null
                                    }>
                                  }
                                | null
                            } | null>
                          }> | null
                        }
                      | {
                          __typename?: "BasicPropertyValue"
                          valueType: string
                          value?: any | null
                        }
                      | {
                          __typename?: "BasicRichText"
                          valueType: string
                          richText?: string | null
                        }
                      | {
                          __typename?: "BasicUnsupportedPropertyValue"
                          message: string
                          valueType: string
                        }
                      | {
                          __typename?: "MintMediaPicker"
                          valueType: string
                          mediaItems: Array<{
                            __typename?: "MintMediaPickerItem"
                            id: number
                            url: string
                            altText?: string | null
                          }>
                        }
                      | null
                  } | null>
                  settingsProperties: Array<{
                    __typename?: "BasicProperty"
                    value?:
                      | {
                          __typename?: "BasicBlockGridModel"
                          valueType: string
                        }
                      | {
                          __typename?: "BasicBlockListModel"
                          valueType: string
                        }
                      | {
                          __typename?: "BasicContentPicker"
                          valueType: string
                          contentList: Array<{
                            __typename?: "BasicContentPickerItem"
                            id: number
                            absoluteUrl: string
                            key: any
                            name?: string | null
                            url: string
                            urlSegment?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicDateTimePicker"
                          valueType: string
                          dateTime?: any | null
                        }
                      | {
                          __typename?: "BasicLabel"
                          valueType: string
                          label?: any | null
                        }
                      | { __typename?: "BasicMediaPicker"; valueType: string }
                      | {
                          __typename?: "BasicMemberPicker"
                          valueType: string
                          members: Array<{
                            __typename?: "BasicMemberPickerItem"
                            id?: number | null
                            name?: string | null
                            properties: Array<{
                              __typename?: "BasicProperty"
                              alias?: string | null
                              editorAlias?: string | null
                              value?:
                                | {
                                    __typename?: "BasicBlockGridModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicBlockListModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicContentPicker"
                                    model: string
                                    contentList: Array<{
                                      __typename?: "BasicContentPickerItem"
                                      id: number
                                      absoluteUrl: string
                                      key: any
                                      name?: string | null
                                      url: string
                                      urlSegment?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicDateTimePicker"
                                    model: string
                                    dateTime?: any | null
                                  }
                                | {
                                    __typename?: "BasicLabel"
                                    model: string
                                    label?: any | null
                                  }
                                | {
                                    __typename?: "BasicMediaPicker"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicMemberPicker"
                                    model: string
                                    members: Array<{
                                      __typename?: "BasicMemberPickerItem"
                                      id?: number | null
                                      name?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicMultiUrlPicker"
                                    model: string
                                    links: Array<{
                                      __typename?: "BasicMultiUrlPickerItem"
                                      name?: string | null
                                      target?: string | null
                                      type: LinkType
                                      url?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicNestedContent"
                                    model: string
                                    elements?: Array<{
                                      __typename?: "BasicNestedContentElement"
                                      properties: Array<{
                                        __typename?: "BasicProperty"
                                        alias?: string | null
                                        editorAlias?: string | null
                                        value?:
                                          | {
                                              __typename?: "BasicBlockGridModel"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicBlockListModel"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicContentPicker"
                                              model: string
                                              contentList: Array<{
                                                __typename?: "BasicContentPickerItem"
                                                id: number
                                                absoluteUrl: string
                                                key: any
                                                name?: string | null
                                                url: string
                                                urlSegment?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicDateTimePicker"
                                              model: string
                                              dateTime?: any | null
                                            }
                                          | {
                                              __typename?: "BasicLabel"
                                              model: string
                                              label?: any | null
                                            }
                                          | {
                                              __typename?: "BasicMediaPicker"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicMemberPicker"
                                              model: string
                                              members: Array<{
                                                __typename?: "BasicMemberPickerItem"
                                                id?: number | null
                                                name?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicMultiUrlPicker"
                                              model: string
                                              links: Array<{
                                                __typename?: "BasicMultiUrlPickerItem"
                                                name?: string | null
                                                target?: string | null
                                                type: LinkType
                                                url?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicNestedContent"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicPropertyValue"
                                              model: string
                                              value?: any | null
                                            }
                                          | {
                                              __typename?: "BasicRichText"
                                              model: string
                                              richText?: string | null
                                            }
                                          | {
                                              __typename?: "BasicUnsupportedPropertyValue"
                                              model: string
                                              message: string
                                            }
                                          | {
                                              __typename?: "MintMediaPicker"
                                              model: string
                                              mediaItems: Array<{
                                                __typename?: "MintMediaPickerItem"
                                                id: number
                                                url: string
                                                altText?: string | null
                                              }>
                                            }
                                          | null
                                      } | null>
                                    }> | null
                                  }
                                | {
                                    __typename?: "BasicPropertyValue"
                                    model: string
                                    value?: any | null
                                  }
                                | {
                                    __typename?: "BasicRichText"
                                    model: string
                                    richText?: string | null
                                  }
                                | {
                                    __typename?: "BasicUnsupportedPropertyValue"
                                    model: string
                                    message: string
                                  }
                                | {
                                    __typename?: "MintMediaPicker"
                                    model: string
                                    mediaItems: Array<{
                                      __typename?: "MintMediaPickerItem"
                                      id: number
                                      url: string
                                      altText?: string | null
                                    }>
                                  }
                                | null
                            } | null>
                          }>
                        }
                      | {
                          __typename?: "BasicMultiUrlPicker"
                          valueType: string
                          links: Array<{
                            __typename?: "BasicMultiUrlPickerItem"
                            name?: string | null
                            target?: string | null
                            type: LinkType
                            url?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicNestedContent"
                          valueType: string
                          elements?: Array<{
                            __typename?: "BasicNestedContentElement"
                            properties: Array<{
                              __typename?: "BasicProperty"
                              alias?: string | null
                              editorAlias?: string | null
                              value?:
                                | {
                                    __typename?: "BasicBlockGridModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicBlockListModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicContentPicker"
                                    model: string
                                    contentList: Array<{
                                      __typename?: "BasicContentPickerItem"
                                      id: number
                                      absoluteUrl: string
                                      key: any
                                      name?: string | null
                                      url: string
                                      urlSegment?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicDateTimePicker"
                                    model: string
                                    dateTime?: any | null
                                  }
                                | {
                                    __typename?: "BasicLabel"
                                    model: string
                                    label?: any | null
                                  }
                                | {
                                    __typename?: "BasicMediaPicker"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicMemberPicker"
                                    model: string
                                    members: Array<{
                                      __typename?: "BasicMemberPickerItem"
                                      id?: number | null
                                      name?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicMultiUrlPicker"
                                    model: string
                                    links: Array<{
                                      __typename?: "BasicMultiUrlPickerItem"
                                      name?: string | null
                                      target?: string | null
                                      type: LinkType
                                      url?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicNestedContent"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicPropertyValue"
                                    model: string
                                    value?: any | null
                                  }
                                | {
                                    __typename?: "BasicRichText"
                                    model: string
                                    richText?: string | null
                                  }
                                | {
                                    __typename?: "BasicUnsupportedPropertyValue"
                                    model: string
                                    message: string
                                  }
                                | {
                                    __typename?: "MintMediaPicker"
                                    model: string
                                    mediaItems: Array<{
                                      __typename?: "MintMediaPickerItem"
                                      id: number
                                      url: string
                                      altText?: string | null
                                    }>
                                  }
                                | null
                            } | null>
                          }> | null
                        }
                      | {
                          __typename?: "BasicPropertyValue"
                          valueType: string
                          value?: any | null
                        }
                      | {
                          __typename?: "BasicRichText"
                          valueType: string
                          richText?: string | null
                        }
                      | {
                          __typename?: "BasicUnsupportedPropertyValue"
                          message: string
                          valueType: string
                        }
                      | {
                          __typename?: "MintMediaPicker"
                          valueType: string
                          mediaItems: Array<{
                            __typename?: "MintMediaPickerItem"
                            id: number
                            url: string
                            altText?: string | null
                          }>
                        }
                      | null
                  } | null>
                  areas: Array<{
                    __typename?: "BasicBlockGridArea"
                    alias?: string | null
                    rowSpan: number
                    columnSpan: number
                  } | null>
                }> | null
              } | null>
            }> | null
          }
        | {
            __typename?: "BasicBlockListModel"
            valueType: string
            blocks?: Array<{
              __typename?: "BasicBlockListItem"
              blockType?: string | null
              properties: Array<{
                __typename?: "BasicProperty"
                propertyName?: string | null
                propertyValue?:
                  | { __typename?: "BasicBlockGridModel"; valueType: string }
                  | {
                      __typename?: "BasicBlockListModel"
                      valueType: string
                      blocks?: Array<{
                        __typename?: "BasicBlockListItem"
                        blockType?: string | null
                        properties: Array<{
                          __typename?: "BasicProperty"
                          propertyName?: string | null
                          propertyValue?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                valueType: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                valueType: string
                                blocks?: Array<{
                                  __typename?: "BasicBlockListItem"
                                  blockType?: string | null
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    propertyName?: string | null
                                    propertyValue?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          valueType: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          valueType: string
                                          blocks?: Array<{
                                            __typename?: "BasicBlockListItem"
                                            blockType?: string | null
                                            properties: Array<{
                                              __typename?: "BasicProperty"
                                              propertyName?: string | null
                                              propertyValue?:
                                                | {
                                                    __typename?: "BasicBlockGridModel"
                                                    valueType: string
                                                  }
                                                | {
                                                    __typename?: "BasicBlockListModel"
                                                    valueType: string
                                                    blocks?: Array<{
                                                      __typename?: "BasicBlockListItem"
                                                      blockType?: string | null
                                                      properties: Array<{
                                                        __typename?: "BasicProperty"
                                                        propertyName?:
                                                          | string
                                                          | null
                                                        propertyValue?:
                                                          | {
                                                              __typename?: "BasicBlockGridModel"
                                                              valueType: string
                                                            }
                                                          | {
                                                              __typename?: "BasicBlockListModel"
                                                              valueType: string
                                                            }
                                                          | {
                                                              __typename?: "BasicContentPicker"
                                                              valueType: string
                                                              contentList: Array<{
                                                                __typename?: "BasicContentPickerItem"
                                                                id: number
                                                                absoluteUrl: string
                                                                key: any
                                                                name?:
                                                                  | string
                                                                  | null
                                                                url: string
                                                                urlSegment?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicDateTimePicker"
                                                              valueType: string
                                                              dateTime?:
                                                                | any
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicLabel"
                                                              valueType: string
                                                              label?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicMediaPicker"
                                                              valueType: string
                                                            }
                                                          | {
                                                              __typename?: "BasicMemberPicker"
                                                              valueType: string
                                                              members: Array<{
                                                                __typename?: "BasicMemberPickerItem"
                                                                id?:
                                                                  | number
                                                                  | null
                                                                name?:
                                                                  | string
                                                                  | null
                                                                properties: Array<{
                                                                  __typename?: "BasicProperty"
                                                                  alias?:
                                                                    | string
                                                                    | null
                                                                  editorAlias?:
                                                                    | string
                                                                    | null
                                                                  value?:
                                                                    | {
                                                                        __typename?: "BasicBlockGridModel"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicBlockListModel"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicContentPicker"
                                                                        model: string
                                                                        contentList: Array<{
                                                                          __typename?: "BasicContentPickerItem"
                                                                          id: number
                                                                          absoluteUrl: string
                                                                          key: any
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                          url: string
                                                                          urlSegment?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicDateTimePicker"
                                                                        model: string
                                                                        dateTime?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicLabel"
                                                                        model: string
                                                                        label?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMediaPicker"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMemberPicker"
                                                                        model: string
                                                                        members: Array<{
                                                                          __typename?: "BasicMemberPickerItem"
                                                                          id?:
                                                                            | number
                                                                            | null
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMultiUrlPicker"
                                                                        model: string
                                                                        links: Array<{
                                                                          __typename?: "BasicMultiUrlPickerItem"
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                          target?:
                                                                            | string
                                                                            | null
                                                                          type: LinkType
                                                                          url?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicNestedContent"
                                                                        model: string
                                                                        elements?: Array<{
                                                                          __typename?: "BasicNestedContentElement"
                                                                          properties: Array<{
                                                                            __typename?: "BasicProperty"
                                                                            alias?:
                                                                              | string
                                                                              | null
                                                                            editorAlias?:
                                                                              | string
                                                                              | null
                                                                            value?:
                                                                              | {
                                                                                  __typename?: "BasicBlockGridModel"
                                                                                  model: string
                                                                                }
                                                                              | {
                                                                                  __typename?: "BasicBlockListModel"
                                                                                  model: string
                                                                                }
                                                                              | {
                                                                                  __typename?: "BasicContentPicker"
                                                                                  model: string
                                                                                  contentList: Array<{
                                                                                    __typename?: "BasicContentPickerItem"
                                                                                    id: number
                                                                                    absoluteUrl: string
                                                                                    key: any
                                                                                    name?:
                                                                                      | string
                                                                                      | null
                                                                                    url: string
                                                                                    urlSegment?:
                                                                                      | string
                                                                                      | null
                                                                                  }>
                                                                                }
                                                                              | {
                                                                                  __typename?: "BasicDateTimePicker"
                                                                                  model: string
                                                                                  dateTime?:
                                                                                    | any
                                                                                    | null
                                                                                }
                                                                              | {
                                                                                  __typename?: "BasicLabel"
                                                                                  model: string
                                                                                  label?:
                                                                                    | any
                                                                                    | null
                                                                                }
                                                                              | {
                                                                                  __typename?: "BasicMediaPicker"
                                                                                  model: string
                                                                                }
                                                                              | {
                                                                                  __typename?: "BasicMemberPicker"
                                                                                  model: string
                                                                                  members: Array<{
                                                                                    __typename?: "BasicMemberPickerItem"
                                                                                    id?:
                                                                                      | number
                                                                                      | null
                                                                                    name?:
                                                                                      | string
                                                                                      | null
                                                                                  }>
                                                                                }
                                                                              | {
                                                                                  __typename?: "BasicMultiUrlPicker"
                                                                                  model: string
                                                                                  links: Array<{
                                                                                    __typename?: "BasicMultiUrlPickerItem"
                                                                                    name?:
                                                                                      | string
                                                                                      | null
                                                                                    target?:
                                                                                      | string
                                                                                      | null
                                                                                    type: LinkType
                                                                                    url?:
                                                                                      | string
                                                                                      | null
                                                                                  }>
                                                                                }
                                                                              | {
                                                                                  __typename?: "BasicNestedContent"
                                                                                  model: string
                                                                                }
                                                                              | {
                                                                                  __typename?: "BasicPropertyValue"
                                                                                  model: string
                                                                                  value?:
                                                                                    | any
                                                                                    | null
                                                                                }
                                                                              | {
                                                                                  __typename?: "BasicRichText"
                                                                                  model: string
                                                                                  richText?:
                                                                                    | string
                                                                                    | null
                                                                                }
                                                                              | {
                                                                                  __typename?: "BasicUnsupportedPropertyValue"
                                                                                  model: string
                                                                                  message: string
                                                                                }
                                                                              | {
                                                                                  __typename?: "MintMediaPicker"
                                                                                  model: string
                                                                                  mediaItems: Array<{
                                                                                    __typename?: "MintMediaPickerItem"
                                                                                    id: number
                                                                                    url: string
                                                                                    altText?:
                                                                                      | string
                                                                                      | null
                                                                                  }>
                                                                                }
                                                                              | null
                                                                          } | null>
                                                                        }> | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicPropertyValue"
                                                                        model: string
                                                                        value?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicRichText"
                                                                        model: string
                                                                        richText?:
                                                                          | string
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicUnsupportedPropertyValue"
                                                                        model: string
                                                                        message: string
                                                                      }
                                                                    | {
                                                                        __typename?: "MintMediaPicker"
                                                                        model: string
                                                                        mediaItems: Array<{
                                                                          __typename?: "MintMediaPickerItem"
                                                                          id: number
                                                                          url: string
                                                                          altText?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | null
                                                                } | null>
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicMultiUrlPicker"
                                                              valueType: string
                                                              links: Array<{
                                                                __typename?: "BasicMultiUrlPickerItem"
                                                                name?:
                                                                  | string
                                                                  | null
                                                                target?:
                                                                  | string
                                                                  | null
                                                                type: LinkType
                                                                url?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicNestedContent"
                                                              valueType: string
                                                              elements?: Array<{
                                                                __typename?: "BasicNestedContentElement"
                                                                properties: Array<{
                                                                  __typename?: "BasicProperty"
                                                                  alias?:
                                                                    | string
                                                                    | null
                                                                  editorAlias?:
                                                                    | string
                                                                    | null
                                                                  value?:
                                                                    | {
                                                                        __typename?: "BasicBlockGridModel"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicBlockListModel"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicContentPicker"
                                                                        model: string
                                                                        contentList: Array<{
                                                                          __typename?: "BasicContentPickerItem"
                                                                          id: number
                                                                          absoluteUrl: string
                                                                          key: any
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                          url: string
                                                                          urlSegment?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicDateTimePicker"
                                                                        model: string
                                                                        dateTime?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicLabel"
                                                                        model: string
                                                                        label?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMediaPicker"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMemberPicker"
                                                                        model: string
                                                                        members: Array<{
                                                                          __typename?: "BasicMemberPickerItem"
                                                                          id?:
                                                                            | number
                                                                            | null
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMultiUrlPicker"
                                                                        model: string
                                                                        links: Array<{
                                                                          __typename?: "BasicMultiUrlPickerItem"
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                          target?:
                                                                            | string
                                                                            | null
                                                                          type: LinkType
                                                                          url?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicNestedContent"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicPropertyValue"
                                                                        model: string
                                                                        value?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicRichText"
                                                                        model: string
                                                                        richText?:
                                                                          | string
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicUnsupportedPropertyValue"
                                                                        model: string
                                                                        message: string
                                                                      }
                                                                    | {
                                                                        __typename?: "MintMediaPicker"
                                                                        model: string
                                                                        mediaItems: Array<{
                                                                          __typename?: "MintMediaPickerItem"
                                                                          id: number
                                                                          url: string
                                                                          altText?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | null
                                                                } | null>
                                                              }> | null
                                                            }
                                                          | {
                                                              __typename?: "BasicPropertyValue"
                                                              valueType: string
                                                              value?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicRichText"
                                                              valueType: string
                                                              richText?:
                                                                | string
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicUnsupportedPropertyValue"
                                                              message: string
                                                              valueType: string
                                                            }
                                                          | {
                                                              __typename?: "MintMediaPicker"
                                                              valueType: string
                                                              mediaItems: Array<{
                                                                __typename?: "MintMediaPickerItem"
                                                                id: number
                                                                url: string
                                                                altText?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | null
                                                      } | null>
                                                    }> | null
                                                  }
                                                | {
                                                    __typename?: "BasicContentPicker"
                                                    valueType: string
                                                    contentList: Array<{
                                                      __typename?: "BasicContentPickerItem"
                                                      id: number
                                                      absoluteUrl: string
                                                      key: any
                                                      name?: string | null
                                                      url: string
                                                      urlSegment?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicDateTimePicker"
                                                    valueType: string
                                                    dateTime?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicLabel"
                                                    valueType: string
                                                    label?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicMediaPicker"
                                                    valueType: string
                                                  }
                                                | {
                                                    __typename?: "BasicMemberPicker"
                                                    valueType: string
                                                    members: Array<{
                                                      __typename?: "BasicMemberPickerItem"
                                                      id?: number | null
                                                      name?: string | null
                                                      properties: Array<{
                                                        __typename?: "BasicProperty"
                                                        alias?: string | null
                                                        editorAlias?:
                                                          | string
                                                          | null
                                                        value?:
                                                          | {
                                                              __typename?: "BasicBlockGridModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicBlockListModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicContentPicker"
                                                              model: string
                                                              contentList: Array<{
                                                                __typename?: "BasicContentPickerItem"
                                                                id: number
                                                                absoluteUrl: string
                                                                key: any
                                                                name?:
                                                                  | string
                                                                  | null
                                                                url: string
                                                                urlSegment?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicDateTimePicker"
                                                              model: string
                                                              dateTime?:
                                                                | any
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicLabel"
                                                              model: string
                                                              label?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicMediaPicker"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicMemberPicker"
                                                              model: string
                                                              members: Array<{
                                                                __typename?: "BasicMemberPickerItem"
                                                                id?:
                                                                  | number
                                                                  | null
                                                                name?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicMultiUrlPicker"
                                                              model: string
                                                              links: Array<{
                                                                __typename?: "BasicMultiUrlPickerItem"
                                                                name?:
                                                                  | string
                                                                  | null
                                                                target?:
                                                                  | string
                                                                  | null
                                                                type: LinkType
                                                                url?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicNestedContent"
                                                              model: string
                                                              elements?: Array<{
                                                                __typename?: "BasicNestedContentElement"
                                                                properties: Array<{
                                                                  __typename?: "BasicProperty"
                                                                  alias?:
                                                                    | string
                                                                    | null
                                                                  editorAlias?:
                                                                    | string
                                                                    | null
                                                                  value?:
                                                                    | {
                                                                        __typename?: "BasicBlockGridModel"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicBlockListModel"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicContentPicker"
                                                                        model: string
                                                                        contentList: Array<{
                                                                          __typename?: "BasicContentPickerItem"
                                                                          id: number
                                                                          absoluteUrl: string
                                                                          key: any
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                          url: string
                                                                          urlSegment?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicDateTimePicker"
                                                                        model: string
                                                                        dateTime?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicLabel"
                                                                        model: string
                                                                        label?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMediaPicker"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMemberPicker"
                                                                        model: string
                                                                        members: Array<{
                                                                          __typename?: "BasicMemberPickerItem"
                                                                          id?:
                                                                            | number
                                                                            | null
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMultiUrlPicker"
                                                                        model: string
                                                                        links: Array<{
                                                                          __typename?: "BasicMultiUrlPickerItem"
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                          target?:
                                                                            | string
                                                                            | null
                                                                          type: LinkType
                                                                          url?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicNestedContent"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicPropertyValue"
                                                                        model: string
                                                                        value?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicRichText"
                                                                        model: string
                                                                        richText?:
                                                                          | string
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicUnsupportedPropertyValue"
                                                                        model: string
                                                                        message: string
                                                                      }
                                                                    | {
                                                                        __typename?: "MintMediaPicker"
                                                                        model: string
                                                                        mediaItems: Array<{
                                                                          __typename?: "MintMediaPickerItem"
                                                                          id: number
                                                                          url: string
                                                                          altText?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | null
                                                                } | null>
                                                              }> | null
                                                            }
                                                          | {
                                                              __typename?: "BasicPropertyValue"
                                                              model: string
                                                              value?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicRichText"
                                                              model: string
                                                              richText?:
                                                                | string
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicUnsupportedPropertyValue"
                                                              model: string
                                                              message: string
                                                            }
                                                          | {
                                                              __typename?: "MintMediaPicker"
                                                              model: string
                                                              mediaItems: Array<{
                                                                __typename?: "MintMediaPickerItem"
                                                                id: number
                                                                url: string
                                                                altText?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | null
                                                      } | null>
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicMultiUrlPicker"
                                                    valueType: string
                                                    links: Array<{
                                                      __typename?: "BasicMultiUrlPickerItem"
                                                      name?: string | null
                                                      target?: string | null
                                                      type: LinkType
                                                      url?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicNestedContent"
                                                    valueType: string
                                                    elements?: Array<{
                                                      __typename?: "BasicNestedContentElement"
                                                      properties: Array<{
                                                        __typename?: "BasicProperty"
                                                        alias?: string | null
                                                        editorAlias?:
                                                          | string
                                                          | null
                                                        value?:
                                                          | {
                                                              __typename?: "BasicBlockGridModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicBlockListModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicContentPicker"
                                                              model: string
                                                              contentList: Array<{
                                                                __typename?: "BasicContentPickerItem"
                                                                id: number
                                                                absoluteUrl: string
                                                                key: any
                                                                name?:
                                                                  | string
                                                                  | null
                                                                url: string
                                                                urlSegment?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicDateTimePicker"
                                                              model: string
                                                              dateTime?:
                                                                | any
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicLabel"
                                                              model: string
                                                              label?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicMediaPicker"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicMemberPicker"
                                                              model: string
                                                              members: Array<{
                                                                __typename?: "BasicMemberPickerItem"
                                                                id?:
                                                                  | number
                                                                  | null
                                                                name?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicMultiUrlPicker"
                                                              model: string
                                                              links: Array<{
                                                                __typename?: "BasicMultiUrlPickerItem"
                                                                name?:
                                                                  | string
                                                                  | null
                                                                target?:
                                                                  | string
                                                                  | null
                                                                type: LinkType
                                                                url?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicNestedContent"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicPropertyValue"
                                                              model: string
                                                              value?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicRichText"
                                                              model: string
                                                              richText?:
                                                                | string
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicUnsupportedPropertyValue"
                                                              model: string
                                                              message: string
                                                            }
                                                          | {
                                                              __typename?: "MintMediaPicker"
                                                              model: string
                                                              mediaItems: Array<{
                                                                __typename?: "MintMediaPickerItem"
                                                                id: number
                                                                url: string
                                                                altText?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | null
                                                      } | null>
                                                    }> | null
                                                  }
                                                | {
                                                    __typename?: "BasicPropertyValue"
                                                    valueType: string
                                                    value?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicRichText"
                                                    valueType: string
                                                    richText?: string | null
                                                  }
                                                | {
                                                    __typename?: "BasicUnsupportedPropertyValue"
                                                    message: string
                                                    valueType: string
                                                  }
                                                | {
                                                    __typename?: "MintMediaPicker"
                                                    valueType: string
                                                    mediaItems: Array<{
                                                      __typename?: "MintMediaPickerItem"
                                                      id: number
                                                      url: string
                                                      altText?: string | null
                                                    }>
                                                  }
                                                | null
                                            } | null>
                                          }> | null
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          valueType: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          valueType: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          valueType: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          valueType: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          valueType: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                            properties: Array<{
                                              __typename?: "BasicProperty"
                                              alias?: string | null
                                              editorAlias?: string | null
                                              value?:
                                                | {
                                                    __typename?: "BasicBlockGridModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicBlockListModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicContentPicker"
                                                    model: string
                                                    contentList: Array<{
                                                      __typename?: "BasicContentPickerItem"
                                                      id: number
                                                      absoluteUrl: string
                                                      key: any
                                                      name?: string | null
                                                      url: string
                                                      urlSegment?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicDateTimePicker"
                                                    model: string
                                                    dateTime?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicLabel"
                                                    model: string
                                                    label?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicMediaPicker"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicMemberPicker"
                                                    model: string
                                                    members: Array<{
                                                      __typename?: "BasicMemberPickerItem"
                                                      id?: number | null
                                                      name?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicMultiUrlPicker"
                                                    model: string
                                                    links: Array<{
                                                      __typename?: "BasicMultiUrlPickerItem"
                                                      name?: string | null
                                                      target?: string | null
                                                      type: LinkType
                                                      url?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicNestedContent"
                                                    model: string
                                                    elements?: Array<{
                                                      __typename?: "BasicNestedContentElement"
                                                      properties: Array<{
                                                        __typename?: "BasicProperty"
                                                        alias?: string | null
                                                        editorAlias?:
                                                          | string
                                                          | null
                                                        value?:
                                                          | {
                                                              __typename?: "BasicBlockGridModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicBlockListModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicContentPicker"
                                                              model: string
                                                              contentList: Array<{
                                                                __typename?: "BasicContentPickerItem"
                                                                id: number
                                                                absoluteUrl: string
                                                                key: any
                                                                name?:
                                                                  | string
                                                                  | null
                                                                url: string
                                                                urlSegment?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicDateTimePicker"
                                                              model: string
                                                              dateTime?:
                                                                | any
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicLabel"
                                                              model: string
                                                              label?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicMediaPicker"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicMemberPicker"
                                                              model: string
                                                              members: Array<{
                                                                __typename?: "BasicMemberPickerItem"
                                                                id?:
                                                                  | number
                                                                  | null
                                                                name?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicMultiUrlPicker"
                                                              model: string
                                                              links: Array<{
                                                                __typename?: "BasicMultiUrlPickerItem"
                                                                name?:
                                                                  | string
                                                                  | null
                                                                target?:
                                                                  | string
                                                                  | null
                                                                type: LinkType
                                                                url?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicNestedContent"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicPropertyValue"
                                                              model: string
                                                              value?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicRichText"
                                                              model: string
                                                              richText?:
                                                                | string
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicUnsupportedPropertyValue"
                                                              model: string
                                                              message: string
                                                            }
                                                          | {
                                                              __typename?: "MintMediaPicker"
                                                              model: string
                                                              mediaItems: Array<{
                                                                __typename?: "MintMediaPickerItem"
                                                                id: number
                                                                url: string
                                                                altText?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | null
                                                      } | null>
                                                    }> | null
                                                  }
                                                | {
                                                    __typename?: "BasicPropertyValue"
                                                    model: string
                                                    value?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicRichText"
                                                    model: string
                                                    richText?: string | null
                                                  }
                                                | {
                                                    __typename?: "BasicUnsupportedPropertyValue"
                                                    model: string
                                                    message: string
                                                  }
                                                | {
                                                    __typename?: "MintMediaPicker"
                                                    model: string
                                                    mediaItems: Array<{
                                                      __typename?: "MintMediaPickerItem"
                                                      id: number
                                                      url: string
                                                      altText?: string | null
                                                    }>
                                                  }
                                                | null
                                            } | null>
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          valueType: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          valueType: string
                                          elements?: Array<{
                                            __typename?: "BasicNestedContentElement"
                                            properties: Array<{
                                              __typename?: "BasicProperty"
                                              alias?: string | null
                                              editorAlias?: string | null
                                              value?:
                                                | {
                                                    __typename?: "BasicBlockGridModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicBlockListModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicContentPicker"
                                                    model: string
                                                    contentList: Array<{
                                                      __typename?: "BasicContentPickerItem"
                                                      id: number
                                                      absoluteUrl: string
                                                      key: any
                                                      name?: string | null
                                                      url: string
                                                      urlSegment?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicDateTimePicker"
                                                    model: string
                                                    dateTime?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicLabel"
                                                    model: string
                                                    label?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicMediaPicker"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicMemberPicker"
                                                    model: string
                                                    members: Array<{
                                                      __typename?: "BasicMemberPickerItem"
                                                      id?: number | null
                                                      name?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicMultiUrlPicker"
                                                    model: string
                                                    links: Array<{
                                                      __typename?: "BasicMultiUrlPickerItem"
                                                      name?: string | null
                                                      target?: string | null
                                                      type: LinkType
                                                      url?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicNestedContent"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicPropertyValue"
                                                    model: string
                                                    value?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicRichText"
                                                    model: string
                                                    richText?: string | null
                                                  }
                                                | {
                                                    __typename?: "BasicUnsupportedPropertyValue"
                                                    model: string
                                                    message: string
                                                  }
                                                | {
                                                    __typename?: "MintMediaPicker"
                                                    model: string
                                                    mediaItems: Array<{
                                                      __typename?: "MintMediaPickerItem"
                                                      id: number
                                                      url: string
                                                      altText?: string | null
                                                    }>
                                                  }
                                                | null
                                            } | null>
                                          }> | null
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          valueType: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          valueType: string
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          message: string
                                          valueType: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          valueType: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }> | null
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                valueType: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                valueType: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                valueType: string
                                label?: any | null
                              }
                            | {
                                __typename?: "BasicMediaPicker"
                                valueType: string
                              }
                            | {
                                __typename?: "BasicMemberPicker"
                                valueType: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    alias?: string | null
                                    editorAlias?: string | null
                                    value?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          model: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          model: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          model: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          model: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          model: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          model: string
                                          elements?: Array<{
                                            __typename?: "BasicNestedContentElement"
                                            properties: Array<{
                                              __typename?: "BasicProperty"
                                              alias?: string | null
                                              editorAlias?: string | null
                                              value?:
                                                | {
                                                    __typename?: "BasicBlockGridModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicBlockListModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicContentPicker"
                                                    model: string
                                                    contentList: Array<{
                                                      __typename?: "BasicContentPickerItem"
                                                      id: number
                                                      absoluteUrl: string
                                                      key: any
                                                      name?: string | null
                                                      url: string
                                                      urlSegment?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicDateTimePicker"
                                                    model: string
                                                    dateTime?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicLabel"
                                                    model: string
                                                    label?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicMediaPicker"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicMemberPicker"
                                                    model: string
                                                    members: Array<{
                                                      __typename?: "BasicMemberPickerItem"
                                                      id?: number | null
                                                      name?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicMultiUrlPicker"
                                                    model: string
                                                    links: Array<{
                                                      __typename?: "BasicMultiUrlPickerItem"
                                                      name?: string | null
                                                      target?: string | null
                                                      type: LinkType
                                                      url?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicNestedContent"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicPropertyValue"
                                                    model: string
                                                    value?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicRichText"
                                                    model: string
                                                    richText?: string | null
                                                  }
                                                | {
                                                    __typename?: "BasicUnsupportedPropertyValue"
                                                    model: string
                                                    message: string
                                                  }
                                                | {
                                                    __typename?: "MintMediaPicker"
                                                    model: string
                                                    mediaItems: Array<{
                                                      __typename?: "MintMediaPickerItem"
                                                      id: number
                                                      url: string
                                                      altText?: string | null
                                                    }>
                                                  }
                                                | null
                                            } | null>
                                          }> | null
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          model: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          model: string
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          model: string
                                          message: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          model: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                valueType: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                valueType: string
                                elements?: Array<{
                                  __typename?: "BasicNestedContentElement"
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    alias?: string | null
                                    editorAlias?: string | null
                                    value?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          model: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          model: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          model: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          model: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          model: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          model: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          model: string
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          model: string
                                          message: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          model: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }> | null
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                valueType: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                valueType: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                message: string
                                valueType: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                valueType: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicContentPicker"
                      valueType: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      valueType: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      valueType: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; valueType: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      valueType: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                                elements?: Array<{
                                  __typename?: "BasicNestedContentElement"
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    alias?: string | null
                                    editorAlias?: string | null
                                    value?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          model: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          model: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          model: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          model: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          model: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          model: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          model: string
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          model: string
                                          message: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          model: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }> | null
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      valueType: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicNestedContent"
                      valueType: string
                      elements?: Array<{
                        __typename?: "BasicNestedContentElement"
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicPropertyValue"
                      valueType: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      valueType: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      message: string
                      valueType: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      valueType: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }> | null
          }
        | {
            __typename?: "BasicContentPicker"
            valueType: string
            contentList: Array<{
              __typename?: "BasicContentPickerItem"
              id: number
              absoluteUrl: string
              key: any
              name?: string | null
              url: string
              urlSegment?: string | null
            }>
          }
        | {
            __typename?: "BasicDateTimePicker"
            valueType: string
            dateTime?: any | null
          }
        | { __typename?: "BasicLabel"; valueType: string; label?: any | null }
        | { __typename?: "BasicMediaPicker"; valueType: string }
        | {
            __typename?: "BasicMemberPicker"
            valueType: string
            members: Array<{
              __typename?: "BasicMemberPickerItem"
              id?: number | null
              name?: string | null
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicNestedContent"
                      model: string
                      elements?: Array<{
                        __typename?: "BasicNestedContentElement"
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }>
          }
        | {
            __typename?: "BasicMultiUrlPicker"
            valueType: string
            links: Array<{
              __typename?: "BasicMultiUrlPickerItem"
              name?: string | null
              target?: string | null
              type: LinkType
              url?: string | null
            }>
          }
        | {
            __typename?: "BasicNestedContent"
            valueType: string
            elements?: Array<{
              __typename?: "BasicNestedContentElement"
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | { __typename?: "BasicNestedContent"; model: string }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }> | null
          }
        | {
            __typename?: "BasicPropertyValue"
            valueType: string
            value?: any | null
          }
        | {
            __typename?: "BasicRichText"
            valueType: string
            richText?: string | null
          }
        | {
            __typename?: "BasicUnsupportedPropertyValue"
            message: string
            valueType: string
          }
        | {
            __typename?: "MintMediaPicker"
            valueType: string
            mediaItems: Array<{
              __typename?: "MintMediaPickerItem"
              id: number
              url: string
              altText?: string | null
            }>
          }
        | null
    } | null> | null
  } | null
}

type PropertyEditorsFooter_BasicBlockGridModel_Fragment = {
  __typename?: "BasicBlockGridModel"
  valueType: string
}

type PropertyEditorsFooter_BasicBlockListModel_Fragment = {
  __typename?: "BasicBlockListModel"
  valueType: string
}

type PropertyEditorsFooter_BasicContentPicker_Fragment = {
  __typename?: "BasicContentPicker"
  valueType: string
  contentList: Array<{
    __typename?: "BasicContentPickerItem"
    id: number
    absoluteUrl: string
    key: any
    name?: string | null
    url: string
    urlSegment?: string | null
  }>
}

type PropertyEditorsFooter_BasicDateTimePicker_Fragment = {
  __typename?: "BasicDateTimePicker"
  valueType: string
  dateTime?: any | null
}

type PropertyEditorsFooter_BasicLabel_Fragment = {
  __typename?: "BasicLabel"
  valueType: string
  label?: any | null
}

type PropertyEditorsFooter_BasicMediaPicker_Fragment = {
  __typename?: "BasicMediaPicker"
  valueType: string
}

type PropertyEditorsFooter_BasicMemberPicker_Fragment = {
  __typename?: "BasicMemberPicker"
  valueType: string
  members: Array<{
    __typename?: "BasicMemberPickerItem"
    id?: number | null
    name?: string | null
    properties: Array<{
      __typename?: "BasicProperty"
      alias?: string | null
      editorAlias?: string | null
      value?:
        | { __typename?: "BasicBlockGridModel"; model: string }
        | { __typename?: "BasicBlockListModel"; model: string }
        | {
            __typename?: "BasicContentPicker"
            model: string
            contentList: Array<{
              __typename?: "BasicContentPickerItem"
              id: number
              absoluteUrl: string
              key: any
              name?: string | null
              url: string
              urlSegment?: string | null
            }>
          }
        | {
            __typename?: "BasicDateTimePicker"
            model: string
            dateTime?: any | null
          }
        | { __typename?: "BasicLabel"; model: string; label?: any | null }
        | { __typename?: "BasicMediaPicker"; model: string }
        | {
            __typename?: "BasicMemberPicker"
            model: string
            members: Array<{
              __typename?: "BasicMemberPickerItem"
              id?: number | null
              name?: string | null
            }>
          }
        | {
            __typename?: "BasicMultiUrlPicker"
            model: string
            links: Array<{
              __typename?: "BasicMultiUrlPickerItem"
              name?: string | null
              target?: string | null
              type: LinkType
              url?: string | null
            }>
          }
        | {
            __typename?: "BasicNestedContent"
            model: string
            elements?: Array<{
              __typename?: "BasicNestedContentElement"
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | { __typename?: "BasicNestedContent"; model: string }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }> | null
          }
        | {
            __typename?: "BasicPropertyValue"
            model: string
            value?: any | null
          }
        | {
            __typename?: "BasicRichText"
            model: string
            richText?: string | null
          }
        | {
            __typename?: "BasicUnsupportedPropertyValue"
            model: string
            message: string
          }
        | {
            __typename?: "MintMediaPicker"
            model: string
            mediaItems: Array<{
              __typename?: "MintMediaPickerItem"
              id: number
              url: string
              altText?: string | null
            }>
          }
        | null
    } | null>
  }>
}

type PropertyEditorsFooter_BasicMultiUrlPicker_Fragment = {
  __typename?: "BasicMultiUrlPicker"
  valueType: string
  links: Array<{
    __typename?: "BasicMultiUrlPickerItem"
    name?: string | null
    target?: string | null
    type: LinkType
    url?: string | null
  }>
}

type PropertyEditorsFooter_BasicNestedContent_Fragment = {
  __typename?: "BasicNestedContent"
  valueType: string
  elements?: Array<{
    __typename?: "BasicNestedContentElement"
    properties: Array<{
      __typename?: "BasicProperty"
      alias?: string | null
      editorAlias?: string | null
      value?:
        | { __typename?: "BasicBlockGridModel"; model: string }
        | { __typename?: "BasicBlockListModel"; model: string }
        | {
            __typename?: "BasicContentPicker"
            model: string
            contentList: Array<{
              __typename?: "BasicContentPickerItem"
              id: number
              absoluteUrl: string
              key: any
              name?: string | null
              url: string
              urlSegment?: string | null
            }>
          }
        | {
            __typename?: "BasicDateTimePicker"
            model: string
            dateTime?: any | null
          }
        | { __typename?: "BasicLabel"; model: string; label?: any | null }
        | { __typename?: "BasicMediaPicker"; model: string }
        | {
            __typename?: "BasicMemberPicker"
            model: string
            members: Array<{
              __typename?: "BasicMemberPickerItem"
              id?: number | null
              name?: string | null
            }>
          }
        | {
            __typename?: "BasicMultiUrlPicker"
            model: string
            links: Array<{
              __typename?: "BasicMultiUrlPickerItem"
              name?: string | null
              target?: string | null
              type: LinkType
              url?: string | null
            }>
          }
        | { __typename?: "BasicNestedContent"; model: string }
        | {
            __typename?: "BasicPropertyValue"
            model: string
            value?: any | null
          }
        | {
            __typename?: "BasicRichText"
            model: string
            richText?: string | null
          }
        | {
            __typename?: "BasicUnsupportedPropertyValue"
            model: string
            message: string
          }
        | {
            __typename?: "MintMediaPicker"
            model: string
            mediaItems: Array<{
              __typename?: "MintMediaPickerItem"
              id: number
              url: string
              altText?: string | null
            }>
          }
        | null
    } | null>
  }> | null
}

type PropertyEditorsFooter_BasicPropertyValue_Fragment = {
  __typename?: "BasicPropertyValue"
  valueType: string
  value?: any | null
}

type PropertyEditorsFooter_BasicRichText_Fragment = {
  __typename?: "BasicRichText"
  valueType: string
  richText?: string | null
}

type PropertyEditorsFooter_BasicUnsupportedPropertyValue_Fragment = {
  __typename?: "BasicUnsupportedPropertyValue"
  message: string
  valueType: string
}

type PropertyEditorsFooter_MintMediaPicker_Fragment = {
  __typename?: "MintMediaPicker"
  valueType: string
  mediaItems: Array<{
    __typename?: "MintMediaPickerItem"
    id: number
    url: string
    altText?: string | null
  }>
}

export type PropertyEditorsFooterFragment =
  | PropertyEditorsFooter_BasicBlockGridModel_Fragment
  | PropertyEditorsFooter_BasicBlockListModel_Fragment
  | PropertyEditorsFooter_BasicContentPicker_Fragment
  | PropertyEditorsFooter_BasicDateTimePicker_Fragment
  | PropertyEditorsFooter_BasicLabel_Fragment
  | PropertyEditorsFooter_BasicMediaPicker_Fragment
  | PropertyEditorsFooter_BasicMemberPicker_Fragment
  | PropertyEditorsFooter_BasicMultiUrlPicker_Fragment
  | PropertyEditorsFooter_BasicNestedContent_Fragment
  | PropertyEditorsFooter_BasicPropertyValue_Fragment
  | PropertyEditorsFooter_BasicRichText_Fragment
  | PropertyEditorsFooter_BasicUnsupportedPropertyValue_Fragment
  | PropertyEditorsFooter_MintMediaPicker_Fragment

type MediaPickerFooter_BasicBlockGridModel_Fragment = {
  __typename?: "BasicBlockGridModel"
}

type MediaPickerFooter_BasicBlockListModel_Fragment = {
  __typename?: "BasicBlockListModel"
}

type MediaPickerFooter_BasicContentPicker_Fragment = {
  __typename?: "BasicContentPicker"
}

type MediaPickerFooter_BasicDateTimePicker_Fragment = {
  __typename?: "BasicDateTimePicker"
}

type MediaPickerFooter_BasicLabel_Fragment = { __typename?: "BasicLabel" }

type MediaPickerFooter_BasicMediaPicker_Fragment = {
  __typename?: "BasicMediaPicker"
}

type MediaPickerFooter_BasicMemberPicker_Fragment = {
  __typename?: "BasicMemberPicker"
}

type MediaPickerFooter_BasicMultiUrlPicker_Fragment = {
  __typename?: "BasicMultiUrlPicker"
}

type MediaPickerFooter_BasicNestedContent_Fragment = {
  __typename?: "BasicNestedContent"
}

type MediaPickerFooter_BasicPropertyValue_Fragment = {
  __typename?: "BasicPropertyValue"
}

type MediaPickerFooter_BasicRichText_Fragment = { __typename?: "BasicRichText" }

type MediaPickerFooter_BasicUnsupportedPropertyValue_Fragment = {
  __typename?: "BasicUnsupportedPropertyValue"
}

type MediaPickerFooter_MintMediaPicker_Fragment = {
  __typename?: "MintMediaPicker"
  mediaItems: Array<{
    __typename?: "MintMediaPickerItem"
    id: number
    url: string
    altText?: string | null
  }>
}

export type MediaPickerFooterFragment =
  | MediaPickerFooter_BasicBlockGridModel_Fragment
  | MediaPickerFooter_BasicBlockListModel_Fragment
  | MediaPickerFooter_BasicContentPicker_Fragment
  | MediaPickerFooter_BasicDateTimePicker_Fragment
  | MediaPickerFooter_BasicLabel_Fragment
  | MediaPickerFooter_BasicMediaPicker_Fragment
  | MediaPickerFooter_BasicMemberPicker_Fragment
  | MediaPickerFooter_BasicMultiUrlPicker_Fragment
  | MediaPickerFooter_BasicNestedContent_Fragment
  | MediaPickerFooter_BasicPropertyValue_Fragment
  | MediaPickerFooter_BasicRichText_Fragment
  | MediaPickerFooter_BasicUnsupportedPropertyValue_Fragment
  | MediaPickerFooter_MintMediaPicker_Fragment

type MemberPickerFooter_BasicBlockGridModel_Fragment = {
  __typename?: "BasicBlockGridModel"
}

type MemberPickerFooter_BasicBlockListModel_Fragment = {
  __typename?: "BasicBlockListModel"
}

type MemberPickerFooter_BasicContentPicker_Fragment = {
  __typename?: "BasicContentPicker"
}

type MemberPickerFooter_BasicDateTimePicker_Fragment = {
  __typename?: "BasicDateTimePicker"
}

type MemberPickerFooter_BasicLabel_Fragment = { __typename?: "BasicLabel" }

type MemberPickerFooter_BasicMediaPicker_Fragment = {
  __typename?: "BasicMediaPicker"
}

type MemberPickerFooter_BasicMemberPicker_Fragment = {
  __typename?: "BasicMemberPicker"
  members: Array<{
    __typename?: "BasicMemberPickerItem"
    id?: number | null
    name?: string | null
    properties: Array<{
      __typename?: "BasicProperty"
      alias?: string | null
      editorAlias?: string | null
      value?:
        | { __typename?: "BasicBlockGridModel"; model: string }
        | { __typename?: "BasicBlockListModel"; model: string }
        | {
            __typename?: "BasicContentPicker"
            model: string
            contentList: Array<{
              __typename?: "BasicContentPickerItem"
              id: number
              absoluteUrl: string
              key: any
              name?: string | null
              url: string
              urlSegment?: string | null
            }>
          }
        | {
            __typename?: "BasicDateTimePicker"
            model: string
            dateTime?: any | null
          }
        | { __typename?: "BasicLabel"; model: string; label?: any | null }
        | { __typename?: "BasicMediaPicker"; model: string }
        | {
            __typename?: "BasicMemberPicker"
            model: string
            members: Array<{
              __typename?: "BasicMemberPickerItem"
              id?: number | null
              name?: string | null
            }>
          }
        | {
            __typename?: "BasicMultiUrlPicker"
            model: string
            links: Array<{
              __typename?: "BasicMultiUrlPickerItem"
              name?: string | null
              target?: string | null
              type: LinkType
              url?: string | null
            }>
          }
        | {
            __typename?: "BasicNestedContent"
            model: string
            elements?: Array<{
              __typename?: "BasicNestedContentElement"
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | { __typename?: "BasicNestedContent"; model: string }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }> | null
          }
        | {
            __typename?: "BasicPropertyValue"
            model: string
            value?: any | null
          }
        | {
            __typename?: "BasicRichText"
            model: string
            richText?: string | null
          }
        | {
            __typename?: "BasicUnsupportedPropertyValue"
            model: string
            message: string
          }
        | {
            __typename?: "MintMediaPicker"
            model: string
            mediaItems: Array<{
              __typename?: "MintMediaPickerItem"
              id: number
              url: string
              altText?: string | null
            }>
          }
        | null
    } | null>
  }>
}

type MemberPickerFooter_BasicMultiUrlPicker_Fragment = {
  __typename?: "BasicMultiUrlPicker"
}

type MemberPickerFooter_BasicNestedContent_Fragment = {
  __typename?: "BasicNestedContent"
}

type MemberPickerFooter_BasicPropertyValue_Fragment = {
  __typename?: "BasicPropertyValue"
}

type MemberPickerFooter_BasicRichText_Fragment = {
  __typename?: "BasicRichText"
}

type MemberPickerFooter_BasicUnsupportedPropertyValue_Fragment = {
  __typename?: "BasicUnsupportedPropertyValue"
}

type MemberPickerFooter_MintMediaPicker_Fragment = {
  __typename?: "MintMediaPicker"
}

export type MemberPickerFooterFragment =
  | MemberPickerFooter_BasicBlockGridModel_Fragment
  | MemberPickerFooter_BasicBlockListModel_Fragment
  | MemberPickerFooter_BasicContentPicker_Fragment
  | MemberPickerFooter_BasicDateTimePicker_Fragment
  | MemberPickerFooter_BasicLabel_Fragment
  | MemberPickerFooter_BasicMediaPicker_Fragment
  | MemberPickerFooter_BasicMemberPicker_Fragment
  | MemberPickerFooter_BasicMultiUrlPicker_Fragment
  | MemberPickerFooter_BasicNestedContent_Fragment
  | MemberPickerFooter_BasicPropertyValue_Fragment
  | MemberPickerFooter_BasicRichText_Fragment
  | MemberPickerFooter_BasicUnsupportedPropertyValue_Fragment
  | MemberPickerFooter_MintMediaPicker_Fragment

type MemberPropertyEditorsFooter_BasicBlockGridModel_Fragment = {
  __typename?: "BasicBlockGridModel"
  model: string
}

type MemberPropertyEditorsFooter_BasicBlockListModel_Fragment = {
  __typename?: "BasicBlockListModel"
  model: string
}

type MemberPropertyEditorsFooter_BasicContentPicker_Fragment = {
  __typename?: "BasicContentPicker"
  model: string
  contentList: Array<{
    __typename?: "BasicContentPickerItem"
    id: number
    absoluteUrl: string
    key: any
    name?: string | null
    url: string
    urlSegment?: string | null
  }>
}

type MemberPropertyEditorsFooter_BasicDateTimePicker_Fragment = {
  __typename?: "BasicDateTimePicker"
  model: string
  dateTime?: any | null
}

type MemberPropertyEditorsFooter_BasicLabel_Fragment = {
  __typename?: "BasicLabel"
  model: string
  label?: any | null
}

type MemberPropertyEditorsFooter_BasicMediaPicker_Fragment = {
  __typename?: "BasicMediaPicker"
  model: string
}

type MemberPropertyEditorsFooter_BasicMemberPicker_Fragment = {
  __typename?: "BasicMemberPicker"
  model: string
  members: Array<{
    __typename?: "BasicMemberPickerItem"
    id?: number | null
    name?: string | null
  }>
}

type MemberPropertyEditorsFooter_BasicMultiUrlPicker_Fragment = {
  __typename?: "BasicMultiUrlPicker"
  model: string
  links: Array<{
    __typename?: "BasicMultiUrlPickerItem"
    name?: string | null
    target?: string | null
    type: LinkType
    url?: string | null
  }>
}

type MemberPropertyEditorsFooter_BasicNestedContent_Fragment = {
  __typename?: "BasicNestedContent"
  model: string
  elements?: Array<{
    __typename?: "BasicNestedContentElement"
    properties: Array<{
      __typename?: "BasicProperty"
      alias?: string | null
      editorAlias?: string | null
      value?:
        | { __typename?: "BasicBlockGridModel"; model: string }
        | { __typename?: "BasicBlockListModel"; model: string }
        | {
            __typename?: "BasicContentPicker"
            model: string
            contentList: Array<{
              __typename?: "BasicContentPickerItem"
              id: number
              absoluteUrl: string
              key: any
              name?: string | null
              url: string
              urlSegment?: string | null
            }>
          }
        | {
            __typename?: "BasicDateTimePicker"
            model: string
            dateTime?: any | null
          }
        | { __typename?: "BasicLabel"; model: string; label?: any | null }
        | { __typename?: "BasicMediaPicker"; model: string }
        | {
            __typename?: "BasicMemberPicker"
            model: string
            members: Array<{
              __typename?: "BasicMemberPickerItem"
              id?: number | null
              name?: string | null
            }>
          }
        | {
            __typename?: "BasicMultiUrlPicker"
            model: string
            links: Array<{
              __typename?: "BasicMultiUrlPickerItem"
              name?: string | null
              target?: string | null
              type: LinkType
              url?: string | null
            }>
          }
        | { __typename?: "BasicNestedContent"; model: string }
        | {
            __typename?: "BasicPropertyValue"
            model: string
            value?: any | null
          }
        | {
            __typename?: "BasicRichText"
            model: string
            richText?: string | null
          }
        | {
            __typename?: "BasicUnsupportedPropertyValue"
            model: string
            message: string
          }
        | {
            __typename?: "MintMediaPicker"
            model: string
            mediaItems: Array<{
              __typename?: "MintMediaPickerItem"
              id: number
              url: string
              altText?: string | null
            }>
          }
        | null
    } | null>
  }> | null
}

type MemberPropertyEditorsFooter_BasicPropertyValue_Fragment = {
  __typename?: "BasicPropertyValue"
  model: string
  value?: any | null
}

type MemberPropertyEditorsFooter_BasicRichText_Fragment = {
  __typename?: "BasicRichText"
  model: string
  richText?: string | null
}

type MemberPropertyEditorsFooter_BasicUnsupportedPropertyValue_Fragment = {
  __typename?: "BasicUnsupportedPropertyValue"
  model: string
  message: string
}

type MemberPropertyEditorsFooter_MintMediaPicker_Fragment = {
  __typename?: "MintMediaPicker"
  model: string
  mediaItems: Array<{
    __typename?: "MintMediaPickerItem"
    id: number
    url: string
    altText?: string | null
  }>
}

export type MemberPropertyEditorsFooterFragment =
  | MemberPropertyEditorsFooter_BasicBlockGridModel_Fragment
  | MemberPropertyEditorsFooter_BasicBlockListModel_Fragment
  | MemberPropertyEditorsFooter_BasicContentPicker_Fragment
  | MemberPropertyEditorsFooter_BasicDateTimePicker_Fragment
  | MemberPropertyEditorsFooter_BasicLabel_Fragment
  | MemberPropertyEditorsFooter_BasicMediaPicker_Fragment
  | MemberPropertyEditorsFooter_BasicMemberPicker_Fragment
  | MemberPropertyEditorsFooter_BasicMultiUrlPicker_Fragment
  | MemberPropertyEditorsFooter_BasicNestedContent_Fragment
  | MemberPropertyEditorsFooter_BasicPropertyValue_Fragment
  | MemberPropertyEditorsFooter_BasicRichText_Fragment
  | MemberPropertyEditorsFooter_BasicUnsupportedPropertyValue_Fragment
  | MemberPropertyEditorsFooter_MintMediaPicker_Fragment

type NestedContentFooter_BasicBlockGridModel_Fragment = {
  __typename?: "BasicBlockGridModel"
}

type NestedContentFooter_BasicBlockListModel_Fragment = {
  __typename?: "BasicBlockListModel"
}

type NestedContentFooter_BasicContentPicker_Fragment = {
  __typename?: "BasicContentPicker"
}

type NestedContentFooter_BasicDateTimePicker_Fragment = {
  __typename?: "BasicDateTimePicker"
}

type NestedContentFooter_BasicLabel_Fragment = { __typename?: "BasicLabel" }

type NestedContentFooter_BasicMediaPicker_Fragment = {
  __typename?: "BasicMediaPicker"
}

type NestedContentFooter_BasicMemberPicker_Fragment = {
  __typename?: "BasicMemberPicker"
}

type NestedContentFooter_BasicMultiUrlPicker_Fragment = {
  __typename?: "BasicMultiUrlPicker"
}

type NestedContentFooter_BasicNestedContent_Fragment = {
  __typename?: "BasicNestedContent"
  elements?: Array<{
    __typename?: "BasicNestedContentElement"
    properties: Array<{
      __typename?: "BasicProperty"
      alias?: string | null
      editorAlias?: string | null
      value?:
        | { __typename?: "BasicBlockGridModel"; model: string }
        | { __typename?: "BasicBlockListModel"; model: string }
        | {
            __typename?: "BasicContentPicker"
            model: string
            contentList: Array<{
              __typename?: "BasicContentPickerItem"
              id: number
              absoluteUrl: string
              key: any
              name?: string | null
              url: string
              urlSegment?: string | null
            }>
          }
        | {
            __typename?: "BasicDateTimePicker"
            model: string
            dateTime?: any | null
          }
        | { __typename?: "BasicLabel"; model: string; label?: any | null }
        | { __typename?: "BasicMediaPicker"; model: string }
        | {
            __typename?: "BasicMemberPicker"
            model: string
            members: Array<{
              __typename?: "BasicMemberPickerItem"
              id?: number | null
              name?: string | null
            }>
          }
        | {
            __typename?: "BasicMultiUrlPicker"
            model: string
            links: Array<{
              __typename?: "BasicMultiUrlPickerItem"
              name?: string | null
              target?: string | null
              type: LinkType
              url?: string | null
            }>
          }
        | { __typename?: "BasicNestedContent"; model: string }
        | {
            __typename?: "BasicPropertyValue"
            model: string
            value?: any | null
          }
        | {
            __typename?: "BasicRichText"
            model: string
            richText?: string | null
          }
        | {
            __typename?: "BasicUnsupportedPropertyValue"
            model: string
            message: string
          }
        | {
            __typename?: "MintMediaPicker"
            model: string
            mediaItems: Array<{
              __typename?: "MintMediaPickerItem"
              id: number
              url: string
              altText?: string | null
            }>
          }
        | null
    } | null>
  }> | null
}

type NestedContentFooter_BasicPropertyValue_Fragment = {
  __typename?: "BasicPropertyValue"
}

type NestedContentFooter_BasicRichText_Fragment = {
  __typename?: "BasicRichText"
}

type NestedContentFooter_BasicUnsupportedPropertyValue_Fragment = {
  __typename?: "BasicUnsupportedPropertyValue"
}

type NestedContentFooter_MintMediaPicker_Fragment = {
  __typename?: "MintMediaPicker"
}

export type NestedContentFooterFragment =
  | NestedContentFooter_BasicBlockGridModel_Fragment
  | NestedContentFooter_BasicBlockListModel_Fragment
  | NestedContentFooter_BasicContentPicker_Fragment
  | NestedContentFooter_BasicDateTimePicker_Fragment
  | NestedContentFooter_BasicLabel_Fragment
  | NestedContentFooter_BasicMediaPicker_Fragment
  | NestedContentFooter_BasicMemberPicker_Fragment
  | NestedContentFooter_BasicMultiUrlPicker_Fragment
  | NestedContentFooter_BasicNestedContent_Fragment
  | NestedContentFooter_BasicPropertyValue_Fragment
  | NestedContentFooter_BasicRichText_Fragment
  | NestedContentFooter_BasicUnsupportedPropertyValue_Fragment
  | NestedContentFooter_MintMediaPicker_Fragment

type NestedContentPropertyEditorsFooter_BasicBlockGridModel_Fragment = {
  __typename?: "BasicBlockGridModel"
  model: string
}

type NestedContentPropertyEditorsFooter_BasicBlockListModel_Fragment = {
  __typename?: "BasicBlockListModel"
  model: string
}

type NestedContentPropertyEditorsFooter_BasicContentPicker_Fragment = {
  __typename?: "BasicContentPicker"
  model: string
  contentList: Array<{
    __typename?: "BasicContentPickerItem"
    id: number
    absoluteUrl: string
    key: any
    name?: string | null
    url: string
    urlSegment?: string | null
  }>
}

type NestedContentPropertyEditorsFooter_BasicDateTimePicker_Fragment = {
  __typename?: "BasicDateTimePicker"
  model: string
  dateTime?: any | null
}

type NestedContentPropertyEditorsFooter_BasicLabel_Fragment = {
  __typename?: "BasicLabel"
  model: string
  label?: any | null
}

type NestedContentPropertyEditorsFooter_BasicMediaPicker_Fragment = {
  __typename?: "BasicMediaPicker"
  model: string
}

type NestedContentPropertyEditorsFooter_BasicMemberPicker_Fragment = {
  __typename?: "BasicMemberPicker"
  model: string
  members: Array<{
    __typename?: "BasicMemberPickerItem"
    id?: number | null
    name?: string | null
  }>
}

type NestedContentPropertyEditorsFooter_BasicMultiUrlPicker_Fragment = {
  __typename?: "BasicMultiUrlPicker"
  model: string
  links: Array<{
    __typename?: "BasicMultiUrlPickerItem"
    name?: string | null
    target?: string | null
    type: LinkType
    url?: string | null
  }>
}

type NestedContentPropertyEditorsFooter_BasicNestedContent_Fragment = {
  __typename?: "BasicNestedContent"
  model: string
}

type NestedContentPropertyEditorsFooter_BasicPropertyValue_Fragment = {
  __typename?: "BasicPropertyValue"
  model: string
  value?: any | null
}

type NestedContentPropertyEditorsFooter_BasicRichText_Fragment = {
  __typename?: "BasicRichText"
  model: string
  richText?: string | null
}

type NestedContentPropertyEditorsFooter_BasicUnsupportedPropertyValue_Fragment =
  {
    __typename?: "BasicUnsupportedPropertyValue"
    model: string
    message: string
  }

type NestedContentPropertyEditorsFooter_MintMediaPicker_Fragment = {
  __typename?: "MintMediaPicker"
  model: string
  mediaItems: Array<{
    __typename?: "MintMediaPickerItem"
    id: number
    url: string
    altText?: string | null
  }>
}

export type NestedContentPropertyEditorsFooterFragment =
  | NestedContentPropertyEditorsFooter_BasicBlockGridModel_Fragment
  | NestedContentPropertyEditorsFooter_BasicBlockListModel_Fragment
  | NestedContentPropertyEditorsFooter_BasicContentPicker_Fragment
  | NestedContentPropertyEditorsFooter_BasicDateTimePicker_Fragment
  | NestedContentPropertyEditorsFooter_BasicLabel_Fragment
  | NestedContentPropertyEditorsFooter_BasicMediaPicker_Fragment
  | NestedContentPropertyEditorsFooter_BasicMemberPicker_Fragment
  | NestedContentPropertyEditorsFooter_BasicMultiUrlPicker_Fragment
  | NestedContentPropertyEditorsFooter_BasicNestedContent_Fragment
  | NestedContentPropertyEditorsFooter_BasicPropertyValue_Fragment
  | NestedContentPropertyEditorsFooter_BasicRichText_Fragment
  | NestedContentPropertyEditorsFooter_BasicUnsupportedPropertyValue_Fragment
  | NestedContentPropertyEditorsFooter_MintMediaPicker_Fragment

type RichTextEditor_BasicBlockGridModel_Fragment = {
  __typename?: "BasicBlockGridModel"
}

type RichTextEditor_BasicBlockListModel_Fragment = {
  __typename?: "BasicBlockListModel"
}

type RichTextEditor_BasicContentPicker_Fragment = {
  __typename?: "BasicContentPicker"
}

type RichTextEditor_BasicDateTimePicker_Fragment = {
  __typename?: "BasicDateTimePicker"
}

type RichTextEditor_BasicLabel_Fragment = { __typename?: "BasicLabel" }

type RichTextEditor_BasicMediaPicker_Fragment = {
  __typename?: "BasicMediaPicker"
}

type RichTextEditor_BasicMemberPicker_Fragment = {
  __typename?: "BasicMemberPicker"
}

type RichTextEditor_BasicMultiUrlPicker_Fragment = {
  __typename?: "BasicMultiUrlPicker"
}

type RichTextEditor_BasicNestedContent_Fragment = {
  __typename?: "BasicNestedContent"
}

type RichTextEditor_BasicPropertyValue_Fragment = {
  __typename?: "BasicPropertyValue"
}

type RichTextEditor_BasicRichText_Fragment = {
  __typename?: "BasicRichText"
  richText?: string | null
}

type RichTextEditor_BasicUnsupportedPropertyValue_Fragment = {
  __typename?: "BasicUnsupportedPropertyValue"
}

type RichTextEditor_MintMediaPicker_Fragment = {
  __typename?: "MintMediaPicker"
}

export type RichTextEditorFragment =
  | RichTextEditor_BasicBlockGridModel_Fragment
  | RichTextEditor_BasicBlockListModel_Fragment
  | RichTextEditor_BasicContentPicker_Fragment
  | RichTextEditor_BasicDateTimePicker_Fragment
  | RichTextEditor_BasicLabel_Fragment
  | RichTextEditor_BasicMediaPicker_Fragment
  | RichTextEditor_BasicMemberPicker_Fragment
  | RichTextEditor_BasicMultiUrlPicker_Fragment
  | RichTextEditor_BasicNestedContent_Fragment
  | RichTextEditor_BasicPropertyValue_Fragment
  | RichTextEditor_BasicRichText_Fragment
  | RichTextEditor_BasicUnsupportedPropertyValue_Fragment
  | RichTextEditor_MintMediaPicker_Fragment

type BlockEditorFooter_BasicBlockGridModel_Fragment = {
  __typename?: "BasicBlockGridModel"
}

type BlockEditorFooter_BasicBlockListModel_Fragment = {
  __typename?: "BasicBlockListModel"
  blocks?: Array<{
    __typename?: "BasicBlockListItem"
    blockType?: string | null
    properties: Array<{
      __typename?: "BasicProperty"
      propertyName?: string | null
      propertyValue?:
        | { __typename?: "BasicBlockGridModel"; valueType: string }
        | {
            __typename?: "BasicBlockListModel"
            valueType: string
            blocks?: Array<{
              __typename?: "BasicBlockListItem"
              blockType?: string | null
              properties: Array<{
                __typename?: "BasicProperty"
                propertyName?: string | null
                propertyValue?:
                  | { __typename?: "BasicBlockGridModel"; valueType: string }
                  | {
                      __typename?: "BasicBlockListModel"
                      valueType: string
                      blocks?: Array<{
                        __typename?: "BasicBlockListItem"
                        blockType?: string | null
                        properties: Array<{
                          __typename?: "BasicProperty"
                          propertyName?: string | null
                          propertyValue?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                valueType: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                valueType: string
                                blocks?: Array<{
                                  __typename?: "BasicBlockListItem"
                                  blockType?: string | null
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    propertyName?: string | null
                                    propertyValue?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          valueType: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          valueType: string
                                          blocks?: Array<{
                                            __typename?: "BasicBlockListItem"
                                            blockType?: string | null
                                            properties: Array<{
                                              __typename?: "BasicProperty"
                                              propertyName?: string | null
                                              propertyValue?:
                                                | {
                                                    __typename?: "BasicBlockGridModel"
                                                    valueType: string
                                                  }
                                                | {
                                                    __typename?: "BasicBlockListModel"
                                                    valueType: string
                                                  }
                                                | {
                                                    __typename?: "BasicContentPicker"
                                                    valueType: string
                                                    contentList: Array<{
                                                      __typename?: "BasicContentPickerItem"
                                                      id: number
                                                      absoluteUrl: string
                                                      key: any
                                                      name?: string | null
                                                      url: string
                                                      urlSegment?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicDateTimePicker"
                                                    valueType: string
                                                    dateTime?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicLabel"
                                                    valueType: string
                                                    label?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicMediaPicker"
                                                    valueType: string
                                                  }
                                                | {
                                                    __typename?: "BasicMemberPicker"
                                                    valueType: string
                                                    members: Array<{
                                                      __typename?: "BasicMemberPickerItem"
                                                      id?: number | null
                                                      name?: string | null
                                                      properties: Array<{
                                                        __typename?: "BasicProperty"
                                                        alias?: string | null
                                                        editorAlias?:
                                                          | string
                                                          | null
                                                        value?:
                                                          | {
                                                              __typename?: "BasicBlockGridModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicBlockListModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicContentPicker"
                                                              model: string
                                                              contentList: Array<{
                                                                __typename?: "BasicContentPickerItem"
                                                                id: number
                                                                absoluteUrl: string
                                                                key: any
                                                                name?:
                                                                  | string
                                                                  | null
                                                                url: string
                                                                urlSegment?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicDateTimePicker"
                                                              model: string
                                                              dateTime?:
                                                                | any
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicLabel"
                                                              model: string
                                                              label?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicMediaPicker"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicMemberPicker"
                                                              model: string
                                                              members: Array<{
                                                                __typename?: "BasicMemberPickerItem"
                                                                id?:
                                                                  | number
                                                                  | null
                                                                name?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicMultiUrlPicker"
                                                              model: string
                                                              links: Array<{
                                                                __typename?: "BasicMultiUrlPickerItem"
                                                                name?:
                                                                  | string
                                                                  | null
                                                                target?:
                                                                  | string
                                                                  | null
                                                                type: LinkType
                                                                url?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicNestedContent"
                                                              model: string
                                                              elements?: Array<{
                                                                __typename?: "BasicNestedContentElement"
                                                                properties: Array<{
                                                                  __typename?: "BasicProperty"
                                                                  alias?:
                                                                    | string
                                                                    | null
                                                                  editorAlias?:
                                                                    | string
                                                                    | null
                                                                  value?:
                                                                    | {
                                                                        __typename?: "BasicBlockGridModel"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicBlockListModel"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicContentPicker"
                                                                        model: string
                                                                        contentList: Array<{
                                                                          __typename?: "BasicContentPickerItem"
                                                                          id: number
                                                                          absoluteUrl: string
                                                                          key: any
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                          url: string
                                                                          urlSegment?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicDateTimePicker"
                                                                        model: string
                                                                        dateTime?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicLabel"
                                                                        model: string
                                                                        label?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMediaPicker"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMemberPicker"
                                                                        model: string
                                                                        members: Array<{
                                                                          __typename?: "BasicMemberPickerItem"
                                                                          id?:
                                                                            | number
                                                                            | null
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMultiUrlPicker"
                                                                        model: string
                                                                        links: Array<{
                                                                          __typename?: "BasicMultiUrlPickerItem"
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                          target?:
                                                                            | string
                                                                            | null
                                                                          type: LinkType
                                                                          url?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicNestedContent"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicPropertyValue"
                                                                        model: string
                                                                        value?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicRichText"
                                                                        model: string
                                                                        richText?:
                                                                          | string
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicUnsupportedPropertyValue"
                                                                        model: string
                                                                        message: string
                                                                      }
                                                                    | {
                                                                        __typename?: "MintMediaPicker"
                                                                        model: string
                                                                        mediaItems: Array<{
                                                                          __typename?: "MintMediaPickerItem"
                                                                          id: number
                                                                          url: string
                                                                          altText?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | null
                                                                } | null>
                                                              }> | null
                                                            }
                                                          | {
                                                              __typename?: "BasicPropertyValue"
                                                              model: string
                                                              value?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicRichText"
                                                              model: string
                                                              richText?:
                                                                | string
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicUnsupportedPropertyValue"
                                                              model: string
                                                              message: string
                                                            }
                                                          | {
                                                              __typename?: "MintMediaPicker"
                                                              model: string
                                                              mediaItems: Array<{
                                                                __typename?: "MintMediaPickerItem"
                                                                id: number
                                                                url: string
                                                                altText?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | null
                                                      } | null>
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicMultiUrlPicker"
                                                    valueType: string
                                                    links: Array<{
                                                      __typename?: "BasicMultiUrlPickerItem"
                                                      name?: string | null
                                                      target?: string | null
                                                      type: LinkType
                                                      url?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicNestedContent"
                                                    valueType: string
                                                    elements?: Array<{
                                                      __typename?: "BasicNestedContentElement"
                                                      properties: Array<{
                                                        __typename?: "BasicProperty"
                                                        alias?: string | null
                                                        editorAlias?:
                                                          | string
                                                          | null
                                                        value?:
                                                          | {
                                                              __typename?: "BasicBlockGridModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicBlockListModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicContentPicker"
                                                              model: string
                                                              contentList: Array<{
                                                                __typename?: "BasicContentPickerItem"
                                                                id: number
                                                                absoluteUrl: string
                                                                key: any
                                                                name?:
                                                                  | string
                                                                  | null
                                                                url: string
                                                                urlSegment?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicDateTimePicker"
                                                              model: string
                                                              dateTime?:
                                                                | any
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicLabel"
                                                              model: string
                                                              label?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicMediaPicker"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicMemberPicker"
                                                              model: string
                                                              members: Array<{
                                                                __typename?: "BasicMemberPickerItem"
                                                                id?:
                                                                  | number
                                                                  | null
                                                                name?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicMultiUrlPicker"
                                                              model: string
                                                              links: Array<{
                                                                __typename?: "BasicMultiUrlPickerItem"
                                                                name?:
                                                                  | string
                                                                  | null
                                                                target?:
                                                                  | string
                                                                  | null
                                                                type: LinkType
                                                                url?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicNestedContent"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicPropertyValue"
                                                              model: string
                                                              value?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicRichText"
                                                              model: string
                                                              richText?:
                                                                | string
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicUnsupportedPropertyValue"
                                                              model: string
                                                              message: string
                                                            }
                                                          | {
                                                              __typename?: "MintMediaPicker"
                                                              model: string
                                                              mediaItems: Array<{
                                                                __typename?: "MintMediaPickerItem"
                                                                id: number
                                                                url: string
                                                                altText?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | null
                                                      } | null>
                                                    }> | null
                                                  }
                                                | {
                                                    __typename?: "BasicPropertyValue"
                                                    valueType: string
                                                    value?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicRichText"
                                                    valueType: string
                                                    richText?: string | null
                                                  }
                                                | {
                                                    __typename?: "BasicUnsupportedPropertyValue"
                                                    message: string
                                                    valueType: string
                                                  }
                                                | {
                                                    __typename?: "MintMediaPicker"
                                                    valueType: string
                                                    mediaItems: Array<{
                                                      __typename?: "MintMediaPickerItem"
                                                      id: number
                                                      url: string
                                                      altText?: string | null
                                                    }>
                                                  }
                                                | null
                                            } | null>
                                          }> | null
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          valueType: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          valueType: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          valueType: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          valueType: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          valueType: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                            properties: Array<{
                                              __typename?: "BasicProperty"
                                              alias?: string | null
                                              editorAlias?: string | null
                                              value?:
                                                | {
                                                    __typename?: "BasicBlockGridModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicBlockListModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicContentPicker"
                                                    model: string
                                                    contentList: Array<{
                                                      __typename?: "BasicContentPickerItem"
                                                      id: number
                                                      absoluteUrl: string
                                                      key: any
                                                      name?: string | null
                                                      url: string
                                                      urlSegment?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicDateTimePicker"
                                                    model: string
                                                    dateTime?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicLabel"
                                                    model: string
                                                    label?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicMediaPicker"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicMemberPicker"
                                                    model: string
                                                    members: Array<{
                                                      __typename?: "BasicMemberPickerItem"
                                                      id?: number | null
                                                      name?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicMultiUrlPicker"
                                                    model: string
                                                    links: Array<{
                                                      __typename?: "BasicMultiUrlPickerItem"
                                                      name?: string | null
                                                      target?: string | null
                                                      type: LinkType
                                                      url?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicNestedContent"
                                                    model: string
                                                    elements?: Array<{
                                                      __typename?: "BasicNestedContentElement"
                                                      properties: Array<{
                                                        __typename?: "BasicProperty"
                                                        alias?: string | null
                                                        editorAlias?:
                                                          | string
                                                          | null
                                                        value?:
                                                          | {
                                                              __typename?: "BasicBlockGridModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicBlockListModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicContentPicker"
                                                              model: string
                                                              contentList: Array<{
                                                                __typename?: "BasicContentPickerItem"
                                                                id: number
                                                                absoluteUrl: string
                                                                key: any
                                                                name?:
                                                                  | string
                                                                  | null
                                                                url: string
                                                                urlSegment?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicDateTimePicker"
                                                              model: string
                                                              dateTime?:
                                                                | any
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicLabel"
                                                              model: string
                                                              label?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicMediaPicker"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicMemberPicker"
                                                              model: string
                                                              members: Array<{
                                                                __typename?: "BasicMemberPickerItem"
                                                                id?:
                                                                  | number
                                                                  | null
                                                                name?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicMultiUrlPicker"
                                                              model: string
                                                              links: Array<{
                                                                __typename?: "BasicMultiUrlPickerItem"
                                                                name?:
                                                                  | string
                                                                  | null
                                                                target?:
                                                                  | string
                                                                  | null
                                                                type: LinkType
                                                                url?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicNestedContent"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicPropertyValue"
                                                              model: string
                                                              value?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicRichText"
                                                              model: string
                                                              richText?:
                                                                | string
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicUnsupportedPropertyValue"
                                                              model: string
                                                              message: string
                                                            }
                                                          | {
                                                              __typename?: "MintMediaPicker"
                                                              model: string
                                                              mediaItems: Array<{
                                                                __typename?: "MintMediaPickerItem"
                                                                id: number
                                                                url: string
                                                                altText?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | null
                                                      } | null>
                                                    }> | null
                                                  }
                                                | {
                                                    __typename?: "BasicPropertyValue"
                                                    model: string
                                                    value?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicRichText"
                                                    model: string
                                                    richText?: string | null
                                                  }
                                                | {
                                                    __typename?: "BasicUnsupportedPropertyValue"
                                                    model: string
                                                    message: string
                                                  }
                                                | {
                                                    __typename?: "MintMediaPicker"
                                                    model: string
                                                    mediaItems: Array<{
                                                      __typename?: "MintMediaPickerItem"
                                                      id: number
                                                      url: string
                                                      altText?: string | null
                                                    }>
                                                  }
                                                | null
                                            } | null>
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          valueType: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          valueType: string
                                          elements?: Array<{
                                            __typename?: "BasicNestedContentElement"
                                            properties: Array<{
                                              __typename?: "BasicProperty"
                                              alias?: string | null
                                              editorAlias?: string | null
                                              value?:
                                                | {
                                                    __typename?: "BasicBlockGridModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicBlockListModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicContentPicker"
                                                    model: string
                                                    contentList: Array<{
                                                      __typename?: "BasicContentPickerItem"
                                                      id: number
                                                      absoluteUrl: string
                                                      key: any
                                                      name?: string | null
                                                      url: string
                                                      urlSegment?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicDateTimePicker"
                                                    model: string
                                                    dateTime?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicLabel"
                                                    model: string
                                                    label?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicMediaPicker"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicMemberPicker"
                                                    model: string
                                                    members: Array<{
                                                      __typename?: "BasicMemberPickerItem"
                                                      id?: number | null
                                                      name?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicMultiUrlPicker"
                                                    model: string
                                                    links: Array<{
                                                      __typename?: "BasicMultiUrlPickerItem"
                                                      name?: string | null
                                                      target?: string | null
                                                      type: LinkType
                                                      url?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicNestedContent"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicPropertyValue"
                                                    model: string
                                                    value?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicRichText"
                                                    model: string
                                                    richText?: string | null
                                                  }
                                                | {
                                                    __typename?: "BasicUnsupportedPropertyValue"
                                                    model: string
                                                    message: string
                                                  }
                                                | {
                                                    __typename?: "MintMediaPicker"
                                                    model: string
                                                    mediaItems: Array<{
                                                      __typename?: "MintMediaPickerItem"
                                                      id: number
                                                      url: string
                                                      altText?: string | null
                                                    }>
                                                  }
                                                | null
                                            } | null>
                                          }> | null
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          valueType: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          valueType: string
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          message: string
                                          valueType: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          valueType: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }> | null
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                valueType: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                valueType: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                valueType: string
                                label?: any | null
                              }
                            | {
                                __typename?: "BasicMediaPicker"
                                valueType: string
                              }
                            | {
                                __typename?: "BasicMemberPicker"
                                valueType: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    alias?: string | null
                                    editorAlias?: string | null
                                    value?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          model: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          model: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          model: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          model: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          model: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          model: string
                                          elements?: Array<{
                                            __typename?: "BasicNestedContentElement"
                                            properties: Array<{
                                              __typename?: "BasicProperty"
                                              alias?: string | null
                                              editorAlias?: string | null
                                              value?:
                                                | {
                                                    __typename?: "BasicBlockGridModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicBlockListModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicContentPicker"
                                                    model: string
                                                    contentList: Array<{
                                                      __typename?: "BasicContentPickerItem"
                                                      id: number
                                                      absoluteUrl: string
                                                      key: any
                                                      name?: string | null
                                                      url: string
                                                      urlSegment?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicDateTimePicker"
                                                    model: string
                                                    dateTime?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicLabel"
                                                    model: string
                                                    label?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicMediaPicker"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicMemberPicker"
                                                    model: string
                                                    members: Array<{
                                                      __typename?: "BasicMemberPickerItem"
                                                      id?: number | null
                                                      name?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicMultiUrlPicker"
                                                    model: string
                                                    links: Array<{
                                                      __typename?: "BasicMultiUrlPickerItem"
                                                      name?: string | null
                                                      target?: string | null
                                                      type: LinkType
                                                      url?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicNestedContent"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicPropertyValue"
                                                    model: string
                                                    value?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicRichText"
                                                    model: string
                                                    richText?: string | null
                                                  }
                                                | {
                                                    __typename?: "BasicUnsupportedPropertyValue"
                                                    model: string
                                                    message: string
                                                  }
                                                | {
                                                    __typename?: "MintMediaPicker"
                                                    model: string
                                                    mediaItems: Array<{
                                                      __typename?: "MintMediaPickerItem"
                                                      id: number
                                                      url: string
                                                      altText?: string | null
                                                    }>
                                                  }
                                                | null
                                            } | null>
                                          }> | null
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          model: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          model: string
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          model: string
                                          message: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          model: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                valueType: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                valueType: string
                                elements?: Array<{
                                  __typename?: "BasicNestedContentElement"
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    alias?: string | null
                                    editorAlias?: string | null
                                    value?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          model: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          model: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          model: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          model: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          model: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          model: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          model: string
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          model: string
                                          message: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          model: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }> | null
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                valueType: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                valueType: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                message: string
                                valueType: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                valueType: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicContentPicker"
                      valueType: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      valueType: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      valueType: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; valueType: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      valueType: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                                elements?: Array<{
                                  __typename?: "BasicNestedContentElement"
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    alias?: string | null
                                    editorAlias?: string | null
                                    value?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          model: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          model: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          model: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          model: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          model: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          model: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          model: string
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          model: string
                                          message: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          model: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }> | null
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      valueType: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicNestedContent"
                      valueType: string
                      elements?: Array<{
                        __typename?: "BasicNestedContentElement"
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicPropertyValue"
                      valueType: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      valueType: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      message: string
                      valueType: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      valueType: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }> | null
          }
        | {
            __typename?: "BasicContentPicker"
            valueType: string
            contentList: Array<{
              __typename?: "BasicContentPickerItem"
              id: number
              absoluteUrl: string
              key: any
              name?: string | null
              url: string
              urlSegment?: string | null
            }>
          }
        | {
            __typename?: "BasicDateTimePicker"
            valueType: string
            dateTime?: any | null
          }
        | { __typename?: "BasicLabel"; valueType: string; label?: any | null }
        | { __typename?: "BasicMediaPicker"; valueType: string }
        | {
            __typename?: "BasicMemberPicker"
            valueType: string
            members: Array<{
              __typename?: "BasicMemberPickerItem"
              id?: number | null
              name?: string | null
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicNestedContent"
                      model: string
                      elements?: Array<{
                        __typename?: "BasicNestedContentElement"
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }>
          }
        | {
            __typename?: "BasicMultiUrlPicker"
            valueType: string
            links: Array<{
              __typename?: "BasicMultiUrlPickerItem"
              name?: string | null
              target?: string | null
              type: LinkType
              url?: string | null
            }>
          }
        | {
            __typename?: "BasicNestedContent"
            valueType: string
            elements?: Array<{
              __typename?: "BasicNestedContentElement"
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | { __typename?: "BasicNestedContent"; model: string }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }> | null
          }
        | {
            __typename?: "BasicPropertyValue"
            valueType: string
            value?: any | null
          }
        | {
            __typename?: "BasicRichText"
            valueType: string
            richText?: string | null
          }
        | {
            __typename?: "BasicUnsupportedPropertyValue"
            message: string
            valueType: string
          }
        | {
            __typename?: "MintMediaPicker"
            valueType: string
            mediaItems: Array<{
              __typename?: "MintMediaPickerItem"
              id: number
              url: string
              altText?: string | null
            }>
          }
        | null
    } | null>
  }> | null
}

type BlockEditorFooter_BasicContentPicker_Fragment = {
  __typename?: "BasicContentPicker"
}

type BlockEditorFooter_BasicDateTimePicker_Fragment = {
  __typename?: "BasicDateTimePicker"
}

type BlockEditorFooter_BasicLabel_Fragment = { __typename?: "BasicLabel" }

type BlockEditorFooter_BasicMediaPicker_Fragment = {
  __typename?: "BasicMediaPicker"
}

type BlockEditorFooter_BasicMemberPicker_Fragment = {
  __typename?: "BasicMemberPicker"
}

type BlockEditorFooter_BasicMultiUrlPicker_Fragment = {
  __typename?: "BasicMultiUrlPicker"
}

type BlockEditorFooter_BasicNestedContent_Fragment = {
  __typename?: "BasicNestedContent"
}

type BlockEditorFooter_BasicPropertyValue_Fragment = {
  __typename?: "BasicPropertyValue"
}

type BlockEditorFooter_BasicRichText_Fragment = { __typename?: "BasicRichText" }

type BlockEditorFooter_BasicUnsupportedPropertyValue_Fragment = {
  __typename?: "BasicUnsupportedPropertyValue"
}

type BlockEditorFooter_MintMediaPicker_Fragment = {
  __typename?: "MintMediaPicker"
}

export type BlockEditorFooterFragment =
  | BlockEditorFooter_BasicBlockGridModel_Fragment
  | BlockEditorFooter_BasicBlockListModel_Fragment
  | BlockEditorFooter_BasicContentPicker_Fragment
  | BlockEditorFooter_BasicDateTimePicker_Fragment
  | BlockEditorFooter_BasicLabel_Fragment
  | BlockEditorFooter_BasicMediaPicker_Fragment
  | BlockEditorFooter_BasicMemberPicker_Fragment
  | BlockEditorFooter_BasicMultiUrlPicker_Fragment
  | BlockEditorFooter_BasicNestedContent_Fragment
  | BlockEditorFooter_BasicPropertyValue_Fragment
  | BlockEditorFooter_BasicRichText_Fragment
  | BlockEditorFooter_BasicUnsupportedPropertyValue_Fragment
  | BlockEditorFooter_MintMediaPicker_Fragment

type BlockGridEditorFooter_BasicBlockGridModel_Fragment = {
  __typename?: "BasicBlockGridModel"
  gridColumns?: number | null
  blocks?: Array<{
    __typename?: "BasicBlockGridItem"
    columnSpan: number
    rowSpan: number
    contentProperties: Array<{
      __typename?: "BasicProperty"
      value?:
        | { __typename?: "BasicBlockGridModel"; valueType: string }
        | { __typename?: "BasicBlockListModel"; valueType: string }
        | {
            __typename?: "BasicContentPicker"
            valueType: string
            contentList: Array<{
              __typename?: "BasicContentPickerItem"
              id: number
              absoluteUrl: string
              key: any
              name?: string | null
              url: string
              urlSegment?: string | null
            }>
          }
        | {
            __typename?: "BasicDateTimePicker"
            valueType: string
            dateTime?: any | null
          }
        | { __typename?: "BasicLabel"; valueType: string; label?: any | null }
        | { __typename?: "BasicMediaPicker"; valueType: string }
        | {
            __typename?: "BasicMemberPicker"
            valueType: string
            members: Array<{
              __typename?: "BasicMemberPickerItem"
              id?: number | null
              name?: string | null
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicNestedContent"
                      model: string
                      elements?: Array<{
                        __typename?: "BasicNestedContentElement"
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }>
          }
        | {
            __typename?: "BasicMultiUrlPicker"
            valueType: string
            links: Array<{
              __typename?: "BasicMultiUrlPickerItem"
              name?: string | null
              target?: string | null
              type: LinkType
              url?: string | null
            }>
          }
        | {
            __typename?: "BasicNestedContent"
            valueType: string
            elements?: Array<{
              __typename?: "BasicNestedContentElement"
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | { __typename?: "BasicNestedContent"; model: string }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }> | null
          }
        | {
            __typename?: "BasicPropertyValue"
            valueType: string
            value?: any | null
          }
        | {
            __typename?: "BasicRichText"
            valueType: string
            richText?: string | null
          }
        | {
            __typename?: "BasicUnsupportedPropertyValue"
            message: string
            valueType: string
          }
        | {
            __typename?: "MintMediaPicker"
            valueType: string
            mediaItems: Array<{
              __typename?: "MintMediaPickerItem"
              id: number
              url: string
              altText?: string | null
            }>
          }
        | null
    } | null>
    settingsProperties: Array<{
      __typename?: "BasicProperty"
      value?:
        | { __typename?: "BasicBlockGridModel"; valueType: string }
        | { __typename?: "BasicBlockListModel"; valueType: string }
        | {
            __typename?: "BasicContentPicker"
            valueType: string
            contentList: Array<{
              __typename?: "BasicContentPickerItem"
              id: number
              absoluteUrl: string
              key: any
              name?: string | null
              url: string
              urlSegment?: string | null
            }>
          }
        | {
            __typename?: "BasicDateTimePicker"
            valueType: string
            dateTime?: any | null
          }
        | { __typename?: "BasicLabel"; valueType: string; label?: any | null }
        | { __typename?: "BasicMediaPicker"; valueType: string }
        | {
            __typename?: "BasicMemberPicker"
            valueType: string
            members: Array<{
              __typename?: "BasicMemberPickerItem"
              id?: number | null
              name?: string | null
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicNestedContent"
                      model: string
                      elements?: Array<{
                        __typename?: "BasicNestedContentElement"
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }>
          }
        | {
            __typename?: "BasicMultiUrlPicker"
            valueType: string
            links: Array<{
              __typename?: "BasicMultiUrlPickerItem"
              name?: string | null
              target?: string | null
              type: LinkType
              url?: string | null
            }>
          }
        | {
            __typename?: "BasicNestedContent"
            valueType: string
            elements?: Array<{
              __typename?: "BasicNestedContentElement"
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | { __typename?: "BasicNestedContent"; model: string }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }> | null
          }
        | {
            __typename?: "BasicPropertyValue"
            valueType: string
            value?: any | null
          }
        | {
            __typename?: "BasicRichText"
            valueType: string
            richText?: string | null
          }
        | {
            __typename?: "BasicUnsupportedPropertyValue"
            message: string
            valueType: string
          }
        | {
            __typename?: "MintMediaPicker"
            valueType: string
            mediaItems: Array<{
              __typename?: "MintMediaPickerItem"
              id: number
              url: string
              altText?: string | null
            }>
          }
        | null
    } | null>
    areas: Array<{
      __typename?: "BasicBlockGridArea"
      alias?: string | null
      rowSpan: number
      columnSpan: number
      blocks?: Array<{
        __typename?: "BasicBlockGridItem"
        columnSpan: number
        rowSpan: number
        contentProperties: Array<{
          __typename?: "BasicProperty"
          value?:
            | { __typename?: "BasicBlockGridModel"; valueType: string }
            | { __typename?: "BasicBlockListModel"; valueType: string }
            | {
                __typename?: "BasicContentPicker"
                valueType: string
                contentList: Array<{
                  __typename?: "BasicContentPickerItem"
                  id: number
                  absoluteUrl: string
                  key: any
                  name?: string | null
                  url: string
                  urlSegment?: string | null
                }>
              }
            | {
                __typename?: "BasicDateTimePicker"
                valueType: string
                dateTime?: any | null
              }
            | {
                __typename?: "BasicLabel"
                valueType: string
                label?: any | null
              }
            | { __typename?: "BasicMediaPicker"; valueType: string }
            | {
                __typename?: "BasicMemberPicker"
                valueType: string
                members: Array<{
                  __typename?: "BasicMemberPickerItem"
                  id?: number | null
                  name?: string | null
                  properties: Array<{
                    __typename?: "BasicProperty"
                    alias?: string | null
                    editorAlias?: string | null
                    value?:
                      | { __typename?: "BasicBlockGridModel"; model: string }
                      | { __typename?: "BasicBlockListModel"; model: string }
                      | {
                          __typename?: "BasicContentPicker"
                          model: string
                          contentList: Array<{
                            __typename?: "BasicContentPickerItem"
                            id: number
                            absoluteUrl: string
                            key: any
                            name?: string | null
                            url: string
                            urlSegment?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicDateTimePicker"
                          model: string
                          dateTime?: any | null
                        }
                      | {
                          __typename?: "BasicLabel"
                          model: string
                          label?: any | null
                        }
                      | { __typename?: "BasicMediaPicker"; model: string }
                      | {
                          __typename?: "BasicMemberPicker"
                          model: string
                          members: Array<{
                            __typename?: "BasicMemberPickerItem"
                            id?: number | null
                            name?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicMultiUrlPicker"
                          model: string
                          links: Array<{
                            __typename?: "BasicMultiUrlPickerItem"
                            name?: string | null
                            target?: string | null
                            type: LinkType
                            url?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicNestedContent"
                          model: string
                          elements?: Array<{
                            __typename?: "BasicNestedContentElement"
                            properties: Array<{
                              __typename?: "BasicProperty"
                              alias?: string | null
                              editorAlias?: string | null
                              value?:
                                | {
                                    __typename?: "BasicBlockGridModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicBlockListModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicContentPicker"
                                    model: string
                                    contentList: Array<{
                                      __typename?: "BasicContentPickerItem"
                                      id: number
                                      absoluteUrl: string
                                      key: any
                                      name?: string | null
                                      url: string
                                      urlSegment?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicDateTimePicker"
                                    model: string
                                    dateTime?: any | null
                                  }
                                | {
                                    __typename?: "BasicLabel"
                                    model: string
                                    label?: any | null
                                  }
                                | {
                                    __typename?: "BasicMediaPicker"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicMemberPicker"
                                    model: string
                                    members: Array<{
                                      __typename?: "BasicMemberPickerItem"
                                      id?: number | null
                                      name?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicMultiUrlPicker"
                                    model: string
                                    links: Array<{
                                      __typename?: "BasicMultiUrlPickerItem"
                                      name?: string | null
                                      target?: string | null
                                      type: LinkType
                                      url?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicNestedContent"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicPropertyValue"
                                    model: string
                                    value?: any | null
                                  }
                                | {
                                    __typename?: "BasicRichText"
                                    model: string
                                    richText?: string | null
                                  }
                                | {
                                    __typename?: "BasicUnsupportedPropertyValue"
                                    model: string
                                    message: string
                                  }
                                | {
                                    __typename?: "MintMediaPicker"
                                    model: string
                                    mediaItems: Array<{
                                      __typename?: "MintMediaPickerItem"
                                      id: number
                                      url: string
                                      altText?: string | null
                                    }>
                                  }
                                | null
                            } | null>
                          }> | null
                        }
                      | {
                          __typename?: "BasicPropertyValue"
                          model: string
                          value?: any | null
                        }
                      | {
                          __typename?: "BasicRichText"
                          model: string
                          richText?: string | null
                        }
                      | {
                          __typename?: "BasicUnsupportedPropertyValue"
                          model: string
                          message: string
                        }
                      | {
                          __typename?: "MintMediaPicker"
                          model: string
                          mediaItems: Array<{
                            __typename?: "MintMediaPickerItem"
                            id: number
                            url: string
                            altText?: string | null
                          }>
                        }
                      | null
                  } | null>
                }>
              }
            | {
                __typename?: "BasicMultiUrlPicker"
                valueType: string
                links: Array<{
                  __typename?: "BasicMultiUrlPickerItem"
                  name?: string | null
                  target?: string | null
                  type: LinkType
                  url?: string | null
                }>
              }
            | {
                __typename?: "BasicNestedContent"
                valueType: string
                elements?: Array<{
                  __typename?: "BasicNestedContentElement"
                  properties: Array<{
                    __typename?: "BasicProperty"
                    alias?: string | null
                    editorAlias?: string | null
                    value?:
                      | { __typename?: "BasicBlockGridModel"; model: string }
                      | { __typename?: "BasicBlockListModel"; model: string }
                      | {
                          __typename?: "BasicContentPicker"
                          model: string
                          contentList: Array<{
                            __typename?: "BasicContentPickerItem"
                            id: number
                            absoluteUrl: string
                            key: any
                            name?: string | null
                            url: string
                            urlSegment?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicDateTimePicker"
                          model: string
                          dateTime?: any | null
                        }
                      | {
                          __typename?: "BasicLabel"
                          model: string
                          label?: any | null
                        }
                      | { __typename?: "BasicMediaPicker"; model: string }
                      | {
                          __typename?: "BasicMemberPicker"
                          model: string
                          members: Array<{
                            __typename?: "BasicMemberPickerItem"
                            id?: number | null
                            name?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicMultiUrlPicker"
                          model: string
                          links: Array<{
                            __typename?: "BasicMultiUrlPickerItem"
                            name?: string | null
                            target?: string | null
                            type: LinkType
                            url?: string | null
                          }>
                        }
                      | { __typename?: "BasicNestedContent"; model: string }
                      | {
                          __typename?: "BasicPropertyValue"
                          model: string
                          value?: any | null
                        }
                      | {
                          __typename?: "BasicRichText"
                          model: string
                          richText?: string | null
                        }
                      | {
                          __typename?: "BasicUnsupportedPropertyValue"
                          model: string
                          message: string
                        }
                      | {
                          __typename?: "MintMediaPicker"
                          model: string
                          mediaItems: Array<{
                            __typename?: "MintMediaPickerItem"
                            id: number
                            url: string
                            altText?: string | null
                          }>
                        }
                      | null
                  } | null>
                }> | null
              }
            | {
                __typename?: "BasicPropertyValue"
                valueType: string
                value?: any | null
              }
            | {
                __typename?: "BasicRichText"
                valueType: string
                richText?: string | null
              }
            | {
                __typename?: "BasicUnsupportedPropertyValue"
                message: string
                valueType: string
              }
            | {
                __typename?: "MintMediaPicker"
                valueType: string
                mediaItems: Array<{
                  __typename?: "MintMediaPickerItem"
                  id: number
                  url: string
                  altText?: string | null
                }>
              }
            | null
        } | null>
        settingsProperties: Array<{
          __typename?: "BasicProperty"
          value?:
            | { __typename?: "BasicBlockGridModel"; valueType: string }
            | { __typename?: "BasicBlockListModel"; valueType: string }
            | {
                __typename?: "BasicContentPicker"
                valueType: string
                contentList: Array<{
                  __typename?: "BasicContentPickerItem"
                  id: number
                  absoluteUrl: string
                  key: any
                  name?: string | null
                  url: string
                  urlSegment?: string | null
                }>
              }
            | {
                __typename?: "BasicDateTimePicker"
                valueType: string
                dateTime?: any | null
              }
            | {
                __typename?: "BasicLabel"
                valueType: string
                label?: any | null
              }
            | { __typename?: "BasicMediaPicker"; valueType: string }
            | {
                __typename?: "BasicMemberPicker"
                valueType: string
                members: Array<{
                  __typename?: "BasicMemberPickerItem"
                  id?: number | null
                  name?: string | null
                  properties: Array<{
                    __typename?: "BasicProperty"
                    alias?: string | null
                    editorAlias?: string | null
                    value?:
                      | { __typename?: "BasicBlockGridModel"; model: string }
                      | { __typename?: "BasicBlockListModel"; model: string }
                      | {
                          __typename?: "BasicContentPicker"
                          model: string
                          contentList: Array<{
                            __typename?: "BasicContentPickerItem"
                            id: number
                            absoluteUrl: string
                            key: any
                            name?: string | null
                            url: string
                            urlSegment?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicDateTimePicker"
                          model: string
                          dateTime?: any | null
                        }
                      | {
                          __typename?: "BasicLabel"
                          model: string
                          label?: any | null
                        }
                      | { __typename?: "BasicMediaPicker"; model: string }
                      | {
                          __typename?: "BasicMemberPicker"
                          model: string
                          members: Array<{
                            __typename?: "BasicMemberPickerItem"
                            id?: number | null
                            name?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicMultiUrlPicker"
                          model: string
                          links: Array<{
                            __typename?: "BasicMultiUrlPickerItem"
                            name?: string | null
                            target?: string | null
                            type: LinkType
                            url?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicNestedContent"
                          model: string
                          elements?: Array<{
                            __typename?: "BasicNestedContentElement"
                            properties: Array<{
                              __typename?: "BasicProperty"
                              alias?: string | null
                              editorAlias?: string | null
                              value?:
                                | {
                                    __typename?: "BasicBlockGridModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicBlockListModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicContentPicker"
                                    model: string
                                    contentList: Array<{
                                      __typename?: "BasicContentPickerItem"
                                      id: number
                                      absoluteUrl: string
                                      key: any
                                      name?: string | null
                                      url: string
                                      urlSegment?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicDateTimePicker"
                                    model: string
                                    dateTime?: any | null
                                  }
                                | {
                                    __typename?: "BasicLabel"
                                    model: string
                                    label?: any | null
                                  }
                                | {
                                    __typename?: "BasicMediaPicker"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicMemberPicker"
                                    model: string
                                    members: Array<{
                                      __typename?: "BasicMemberPickerItem"
                                      id?: number | null
                                      name?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicMultiUrlPicker"
                                    model: string
                                    links: Array<{
                                      __typename?: "BasicMultiUrlPickerItem"
                                      name?: string | null
                                      target?: string | null
                                      type: LinkType
                                      url?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicNestedContent"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicPropertyValue"
                                    model: string
                                    value?: any | null
                                  }
                                | {
                                    __typename?: "BasicRichText"
                                    model: string
                                    richText?: string | null
                                  }
                                | {
                                    __typename?: "BasicUnsupportedPropertyValue"
                                    model: string
                                    message: string
                                  }
                                | {
                                    __typename?: "MintMediaPicker"
                                    model: string
                                    mediaItems: Array<{
                                      __typename?: "MintMediaPickerItem"
                                      id: number
                                      url: string
                                      altText?: string | null
                                    }>
                                  }
                                | null
                            } | null>
                          }> | null
                        }
                      | {
                          __typename?: "BasicPropertyValue"
                          model: string
                          value?: any | null
                        }
                      | {
                          __typename?: "BasicRichText"
                          model: string
                          richText?: string | null
                        }
                      | {
                          __typename?: "BasicUnsupportedPropertyValue"
                          model: string
                          message: string
                        }
                      | {
                          __typename?: "MintMediaPicker"
                          model: string
                          mediaItems: Array<{
                            __typename?: "MintMediaPickerItem"
                            id: number
                            url: string
                            altText?: string | null
                          }>
                        }
                      | null
                  } | null>
                }>
              }
            | {
                __typename?: "BasicMultiUrlPicker"
                valueType: string
                links: Array<{
                  __typename?: "BasicMultiUrlPickerItem"
                  name?: string | null
                  target?: string | null
                  type: LinkType
                  url?: string | null
                }>
              }
            | {
                __typename?: "BasicNestedContent"
                valueType: string
                elements?: Array<{
                  __typename?: "BasicNestedContentElement"
                  properties: Array<{
                    __typename?: "BasicProperty"
                    alias?: string | null
                    editorAlias?: string | null
                    value?:
                      | { __typename?: "BasicBlockGridModel"; model: string }
                      | { __typename?: "BasicBlockListModel"; model: string }
                      | {
                          __typename?: "BasicContentPicker"
                          model: string
                          contentList: Array<{
                            __typename?: "BasicContentPickerItem"
                            id: number
                            absoluteUrl: string
                            key: any
                            name?: string | null
                            url: string
                            urlSegment?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicDateTimePicker"
                          model: string
                          dateTime?: any | null
                        }
                      | {
                          __typename?: "BasicLabel"
                          model: string
                          label?: any | null
                        }
                      | { __typename?: "BasicMediaPicker"; model: string }
                      | {
                          __typename?: "BasicMemberPicker"
                          model: string
                          members: Array<{
                            __typename?: "BasicMemberPickerItem"
                            id?: number | null
                            name?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicMultiUrlPicker"
                          model: string
                          links: Array<{
                            __typename?: "BasicMultiUrlPickerItem"
                            name?: string | null
                            target?: string | null
                            type: LinkType
                            url?: string | null
                          }>
                        }
                      | { __typename?: "BasicNestedContent"; model: string }
                      | {
                          __typename?: "BasicPropertyValue"
                          model: string
                          value?: any | null
                        }
                      | {
                          __typename?: "BasicRichText"
                          model: string
                          richText?: string | null
                        }
                      | {
                          __typename?: "BasicUnsupportedPropertyValue"
                          model: string
                          message: string
                        }
                      | {
                          __typename?: "MintMediaPicker"
                          model: string
                          mediaItems: Array<{
                            __typename?: "MintMediaPickerItem"
                            id: number
                            url: string
                            altText?: string | null
                          }>
                        }
                      | null
                  } | null>
                }> | null
              }
            | {
                __typename?: "BasicPropertyValue"
                valueType: string
                value?: any | null
              }
            | {
                __typename?: "BasicRichText"
                valueType: string
                richText?: string | null
              }
            | {
                __typename?: "BasicUnsupportedPropertyValue"
                message: string
                valueType: string
              }
            | {
                __typename?: "MintMediaPicker"
                valueType: string
                mediaItems: Array<{
                  __typename?: "MintMediaPickerItem"
                  id: number
                  url: string
                  altText?: string | null
                }>
              }
            | null
        } | null>
        areas: Array<{
          __typename?: "BasicBlockGridArea"
          alias?: string | null
          rowSpan: number
          columnSpan: number
        } | null>
      }> | null
    } | null>
  }> | null
}

type BlockGridEditorFooter_BasicBlockListModel_Fragment = {
  __typename?: "BasicBlockListModel"
}

type BlockGridEditorFooter_BasicContentPicker_Fragment = {
  __typename?: "BasicContentPicker"
}

type BlockGridEditorFooter_BasicDateTimePicker_Fragment = {
  __typename?: "BasicDateTimePicker"
}

type BlockGridEditorFooter_BasicLabel_Fragment = { __typename?: "BasicLabel" }

type BlockGridEditorFooter_BasicMediaPicker_Fragment = {
  __typename?: "BasicMediaPicker"
}

type BlockGridEditorFooter_BasicMemberPicker_Fragment = {
  __typename?: "BasicMemberPicker"
}

type BlockGridEditorFooter_BasicMultiUrlPicker_Fragment = {
  __typename?: "BasicMultiUrlPicker"
}

type BlockGridEditorFooter_BasicNestedContent_Fragment = {
  __typename?: "BasicNestedContent"
}

type BlockGridEditorFooter_BasicPropertyValue_Fragment = {
  __typename?: "BasicPropertyValue"
}

type BlockGridEditorFooter_BasicRichText_Fragment = {
  __typename?: "BasicRichText"
}

type BlockGridEditorFooter_BasicUnsupportedPropertyValue_Fragment = {
  __typename?: "BasicUnsupportedPropertyValue"
}

type BlockGridEditorFooter_MintMediaPicker_Fragment = {
  __typename?: "MintMediaPicker"
}

export type BlockGridEditorFooterFragment =
  | BlockGridEditorFooter_BasicBlockGridModel_Fragment
  | BlockGridEditorFooter_BasicBlockListModel_Fragment
  | BlockGridEditorFooter_BasicContentPicker_Fragment
  | BlockGridEditorFooter_BasicDateTimePicker_Fragment
  | BlockGridEditorFooter_BasicLabel_Fragment
  | BlockGridEditorFooter_BasicMediaPicker_Fragment
  | BlockGridEditorFooter_BasicMemberPicker_Fragment
  | BlockGridEditorFooter_BasicMultiUrlPicker_Fragment
  | BlockGridEditorFooter_BasicNestedContent_Fragment
  | BlockGridEditorFooter_BasicPropertyValue_Fragment
  | BlockGridEditorFooter_BasicRichText_Fragment
  | BlockGridEditorFooter_BasicUnsupportedPropertyValue_Fragment
  | BlockGridEditorFooter_MintMediaPicker_Fragment

type PropertyValuesFooter_BasicBlockGridModel_Fragment = {
  __typename?: "BasicBlockGridModel"
  gridColumns?: number | null
  valueType: string
  blocks?: Array<{
    __typename?: "BasicBlockGridItem"
    columnSpan: number
    rowSpan: number
    contentProperties: Array<{
      __typename?: "BasicProperty"
      value?:
        | { __typename?: "BasicBlockGridModel"; valueType: string }
        | { __typename?: "BasicBlockListModel"; valueType: string }
        | {
            __typename?: "BasicContentPicker"
            valueType: string
            contentList: Array<{
              __typename?: "BasicContentPickerItem"
              id: number
              absoluteUrl: string
              key: any
              name?: string | null
              url: string
              urlSegment?: string | null
            }>
          }
        | {
            __typename?: "BasicDateTimePicker"
            valueType: string
            dateTime?: any | null
          }
        | { __typename?: "BasicLabel"; valueType: string; label?: any | null }
        | { __typename?: "BasicMediaPicker"; valueType: string }
        | {
            __typename?: "BasicMemberPicker"
            valueType: string
            members: Array<{
              __typename?: "BasicMemberPickerItem"
              id?: number | null
              name?: string | null
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicNestedContent"
                      model: string
                      elements?: Array<{
                        __typename?: "BasicNestedContentElement"
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }>
          }
        | {
            __typename?: "BasicMultiUrlPicker"
            valueType: string
            links: Array<{
              __typename?: "BasicMultiUrlPickerItem"
              name?: string | null
              target?: string | null
              type: LinkType
              url?: string | null
            }>
          }
        | {
            __typename?: "BasicNestedContent"
            valueType: string
            elements?: Array<{
              __typename?: "BasicNestedContentElement"
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | { __typename?: "BasicNestedContent"; model: string }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }> | null
          }
        | {
            __typename?: "BasicPropertyValue"
            valueType: string
            value?: any | null
          }
        | {
            __typename?: "BasicRichText"
            valueType: string
            richText?: string | null
          }
        | {
            __typename?: "BasicUnsupportedPropertyValue"
            message: string
            valueType: string
          }
        | {
            __typename?: "MintMediaPicker"
            valueType: string
            mediaItems: Array<{
              __typename?: "MintMediaPickerItem"
              id: number
              url: string
              altText?: string | null
            }>
          }
        | null
    } | null>
    settingsProperties: Array<{
      __typename?: "BasicProperty"
      value?:
        | { __typename?: "BasicBlockGridModel"; valueType: string }
        | { __typename?: "BasicBlockListModel"; valueType: string }
        | {
            __typename?: "BasicContentPicker"
            valueType: string
            contentList: Array<{
              __typename?: "BasicContentPickerItem"
              id: number
              absoluteUrl: string
              key: any
              name?: string | null
              url: string
              urlSegment?: string | null
            }>
          }
        | {
            __typename?: "BasicDateTimePicker"
            valueType: string
            dateTime?: any | null
          }
        | { __typename?: "BasicLabel"; valueType: string; label?: any | null }
        | { __typename?: "BasicMediaPicker"; valueType: string }
        | {
            __typename?: "BasicMemberPicker"
            valueType: string
            members: Array<{
              __typename?: "BasicMemberPickerItem"
              id?: number | null
              name?: string | null
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicNestedContent"
                      model: string
                      elements?: Array<{
                        __typename?: "BasicNestedContentElement"
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }>
          }
        | {
            __typename?: "BasicMultiUrlPicker"
            valueType: string
            links: Array<{
              __typename?: "BasicMultiUrlPickerItem"
              name?: string | null
              target?: string | null
              type: LinkType
              url?: string | null
            }>
          }
        | {
            __typename?: "BasicNestedContent"
            valueType: string
            elements?: Array<{
              __typename?: "BasicNestedContentElement"
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | { __typename?: "BasicNestedContent"; model: string }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }> | null
          }
        | {
            __typename?: "BasicPropertyValue"
            valueType: string
            value?: any | null
          }
        | {
            __typename?: "BasicRichText"
            valueType: string
            richText?: string | null
          }
        | {
            __typename?: "BasicUnsupportedPropertyValue"
            message: string
            valueType: string
          }
        | {
            __typename?: "MintMediaPicker"
            valueType: string
            mediaItems: Array<{
              __typename?: "MintMediaPickerItem"
              id: number
              url: string
              altText?: string | null
            }>
          }
        | null
    } | null>
    areas: Array<{
      __typename?: "BasicBlockGridArea"
      alias?: string | null
      rowSpan: number
      columnSpan: number
      blocks?: Array<{
        __typename?: "BasicBlockGridItem"
        columnSpan: number
        rowSpan: number
        contentProperties: Array<{
          __typename?: "BasicProperty"
          value?:
            | { __typename?: "BasicBlockGridModel"; valueType: string }
            | { __typename?: "BasicBlockListModel"; valueType: string }
            | {
                __typename?: "BasicContentPicker"
                valueType: string
                contentList: Array<{
                  __typename?: "BasicContentPickerItem"
                  id: number
                  absoluteUrl: string
                  key: any
                  name?: string | null
                  url: string
                  urlSegment?: string | null
                }>
              }
            | {
                __typename?: "BasicDateTimePicker"
                valueType: string
                dateTime?: any | null
              }
            | {
                __typename?: "BasicLabel"
                valueType: string
                label?: any | null
              }
            | { __typename?: "BasicMediaPicker"; valueType: string }
            | {
                __typename?: "BasicMemberPicker"
                valueType: string
                members: Array<{
                  __typename?: "BasicMemberPickerItem"
                  id?: number | null
                  name?: string | null
                  properties: Array<{
                    __typename?: "BasicProperty"
                    alias?: string | null
                    editorAlias?: string | null
                    value?:
                      | { __typename?: "BasicBlockGridModel"; model: string }
                      | { __typename?: "BasicBlockListModel"; model: string }
                      | {
                          __typename?: "BasicContentPicker"
                          model: string
                          contentList: Array<{
                            __typename?: "BasicContentPickerItem"
                            id: number
                            absoluteUrl: string
                            key: any
                            name?: string | null
                            url: string
                            urlSegment?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicDateTimePicker"
                          model: string
                          dateTime?: any | null
                        }
                      | {
                          __typename?: "BasicLabel"
                          model: string
                          label?: any | null
                        }
                      | { __typename?: "BasicMediaPicker"; model: string }
                      | {
                          __typename?: "BasicMemberPicker"
                          model: string
                          members: Array<{
                            __typename?: "BasicMemberPickerItem"
                            id?: number | null
                            name?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicMultiUrlPicker"
                          model: string
                          links: Array<{
                            __typename?: "BasicMultiUrlPickerItem"
                            name?: string | null
                            target?: string | null
                            type: LinkType
                            url?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicNestedContent"
                          model: string
                          elements?: Array<{
                            __typename?: "BasicNestedContentElement"
                            properties: Array<{
                              __typename?: "BasicProperty"
                              alias?: string | null
                              editorAlias?: string | null
                              value?:
                                | {
                                    __typename?: "BasicBlockGridModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicBlockListModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicContentPicker"
                                    model: string
                                    contentList: Array<{
                                      __typename?: "BasicContentPickerItem"
                                      id: number
                                      absoluteUrl: string
                                      key: any
                                      name?: string | null
                                      url: string
                                      urlSegment?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicDateTimePicker"
                                    model: string
                                    dateTime?: any | null
                                  }
                                | {
                                    __typename?: "BasicLabel"
                                    model: string
                                    label?: any | null
                                  }
                                | {
                                    __typename?: "BasicMediaPicker"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicMemberPicker"
                                    model: string
                                    members: Array<{
                                      __typename?: "BasicMemberPickerItem"
                                      id?: number | null
                                      name?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicMultiUrlPicker"
                                    model: string
                                    links: Array<{
                                      __typename?: "BasicMultiUrlPickerItem"
                                      name?: string | null
                                      target?: string | null
                                      type: LinkType
                                      url?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicNestedContent"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicPropertyValue"
                                    model: string
                                    value?: any | null
                                  }
                                | {
                                    __typename?: "BasicRichText"
                                    model: string
                                    richText?: string | null
                                  }
                                | {
                                    __typename?: "BasicUnsupportedPropertyValue"
                                    model: string
                                    message: string
                                  }
                                | {
                                    __typename?: "MintMediaPicker"
                                    model: string
                                    mediaItems: Array<{
                                      __typename?: "MintMediaPickerItem"
                                      id: number
                                      url: string
                                      altText?: string | null
                                    }>
                                  }
                                | null
                            } | null>
                          }> | null
                        }
                      | {
                          __typename?: "BasicPropertyValue"
                          model: string
                          value?: any | null
                        }
                      | {
                          __typename?: "BasicRichText"
                          model: string
                          richText?: string | null
                        }
                      | {
                          __typename?: "BasicUnsupportedPropertyValue"
                          model: string
                          message: string
                        }
                      | {
                          __typename?: "MintMediaPicker"
                          model: string
                          mediaItems: Array<{
                            __typename?: "MintMediaPickerItem"
                            id: number
                            url: string
                            altText?: string | null
                          }>
                        }
                      | null
                  } | null>
                }>
              }
            | {
                __typename?: "BasicMultiUrlPicker"
                valueType: string
                links: Array<{
                  __typename?: "BasicMultiUrlPickerItem"
                  name?: string | null
                  target?: string | null
                  type: LinkType
                  url?: string | null
                }>
              }
            | {
                __typename?: "BasicNestedContent"
                valueType: string
                elements?: Array<{
                  __typename?: "BasicNestedContentElement"
                  properties: Array<{
                    __typename?: "BasicProperty"
                    alias?: string | null
                    editorAlias?: string | null
                    value?:
                      | { __typename?: "BasicBlockGridModel"; model: string }
                      | { __typename?: "BasicBlockListModel"; model: string }
                      | {
                          __typename?: "BasicContentPicker"
                          model: string
                          contentList: Array<{
                            __typename?: "BasicContentPickerItem"
                            id: number
                            absoluteUrl: string
                            key: any
                            name?: string | null
                            url: string
                            urlSegment?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicDateTimePicker"
                          model: string
                          dateTime?: any | null
                        }
                      | {
                          __typename?: "BasicLabel"
                          model: string
                          label?: any | null
                        }
                      | { __typename?: "BasicMediaPicker"; model: string }
                      | {
                          __typename?: "BasicMemberPicker"
                          model: string
                          members: Array<{
                            __typename?: "BasicMemberPickerItem"
                            id?: number | null
                            name?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicMultiUrlPicker"
                          model: string
                          links: Array<{
                            __typename?: "BasicMultiUrlPickerItem"
                            name?: string | null
                            target?: string | null
                            type: LinkType
                            url?: string | null
                          }>
                        }
                      | { __typename?: "BasicNestedContent"; model: string }
                      | {
                          __typename?: "BasicPropertyValue"
                          model: string
                          value?: any | null
                        }
                      | {
                          __typename?: "BasicRichText"
                          model: string
                          richText?: string | null
                        }
                      | {
                          __typename?: "BasicUnsupportedPropertyValue"
                          model: string
                          message: string
                        }
                      | {
                          __typename?: "MintMediaPicker"
                          model: string
                          mediaItems: Array<{
                            __typename?: "MintMediaPickerItem"
                            id: number
                            url: string
                            altText?: string | null
                          }>
                        }
                      | null
                  } | null>
                }> | null
              }
            | {
                __typename?: "BasicPropertyValue"
                valueType: string
                value?: any | null
              }
            | {
                __typename?: "BasicRichText"
                valueType: string
                richText?: string | null
              }
            | {
                __typename?: "BasicUnsupportedPropertyValue"
                message: string
                valueType: string
              }
            | {
                __typename?: "MintMediaPicker"
                valueType: string
                mediaItems: Array<{
                  __typename?: "MintMediaPickerItem"
                  id: number
                  url: string
                  altText?: string | null
                }>
              }
            | null
        } | null>
        settingsProperties: Array<{
          __typename?: "BasicProperty"
          value?:
            | { __typename?: "BasicBlockGridModel"; valueType: string }
            | { __typename?: "BasicBlockListModel"; valueType: string }
            | {
                __typename?: "BasicContentPicker"
                valueType: string
                contentList: Array<{
                  __typename?: "BasicContentPickerItem"
                  id: number
                  absoluteUrl: string
                  key: any
                  name?: string | null
                  url: string
                  urlSegment?: string | null
                }>
              }
            | {
                __typename?: "BasicDateTimePicker"
                valueType: string
                dateTime?: any | null
              }
            | {
                __typename?: "BasicLabel"
                valueType: string
                label?: any | null
              }
            | { __typename?: "BasicMediaPicker"; valueType: string }
            | {
                __typename?: "BasicMemberPicker"
                valueType: string
                members: Array<{
                  __typename?: "BasicMemberPickerItem"
                  id?: number | null
                  name?: string | null
                  properties: Array<{
                    __typename?: "BasicProperty"
                    alias?: string | null
                    editorAlias?: string | null
                    value?:
                      | { __typename?: "BasicBlockGridModel"; model: string }
                      | { __typename?: "BasicBlockListModel"; model: string }
                      | {
                          __typename?: "BasicContentPicker"
                          model: string
                          contentList: Array<{
                            __typename?: "BasicContentPickerItem"
                            id: number
                            absoluteUrl: string
                            key: any
                            name?: string | null
                            url: string
                            urlSegment?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicDateTimePicker"
                          model: string
                          dateTime?: any | null
                        }
                      | {
                          __typename?: "BasicLabel"
                          model: string
                          label?: any | null
                        }
                      | { __typename?: "BasicMediaPicker"; model: string }
                      | {
                          __typename?: "BasicMemberPicker"
                          model: string
                          members: Array<{
                            __typename?: "BasicMemberPickerItem"
                            id?: number | null
                            name?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicMultiUrlPicker"
                          model: string
                          links: Array<{
                            __typename?: "BasicMultiUrlPickerItem"
                            name?: string | null
                            target?: string | null
                            type: LinkType
                            url?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicNestedContent"
                          model: string
                          elements?: Array<{
                            __typename?: "BasicNestedContentElement"
                            properties: Array<{
                              __typename?: "BasicProperty"
                              alias?: string | null
                              editorAlias?: string | null
                              value?:
                                | {
                                    __typename?: "BasicBlockGridModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicBlockListModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicContentPicker"
                                    model: string
                                    contentList: Array<{
                                      __typename?: "BasicContentPickerItem"
                                      id: number
                                      absoluteUrl: string
                                      key: any
                                      name?: string | null
                                      url: string
                                      urlSegment?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicDateTimePicker"
                                    model: string
                                    dateTime?: any | null
                                  }
                                | {
                                    __typename?: "BasicLabel"
                                    model: string
                                    label?: any | null
                                  }
                                | {
                                    __typename?: "BasicMediaPicker"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicMemberPicker"
                                    model: string
                                    members: Array<{
                                      __typename?: "BasicMemberPickerItem"
                                      id?: number | null
                                      name?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicMultiUrlPicker"
                                    model: string
                                    links: Array<{
                                      __typename?: "BasicMultiUrlPickerItem"
                                      name?: string | null
                                      target?: string | null
                                      type: LinkType
                                      url?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicNestedContent"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicPropertyValue"
                                    model: string
                                    value?: any | null
                                  }
                                | {
                                    __typename?: "BasicRichText"
                                    model: string
                                    richText?: string | null
                                  }
                                | {
                                    __typename?: "BasicUnsupportedPropertyValue"
                                    model: string
                                    message: string
                                  }
                                | {
                                    __typename?: "MintMediaPicker"
                                    model: string
                                    mediaItems: Array<{
                                      __typename?: "MintMediaPickerItem"
                                      id: number
                                      url: string
                                      altText?: string | null
                                    }>
                                  }
                                | null
                            } | null>
                          }> | null
                        }
                      | {
                          __typename?: "BasicPropertyValue"
                          model: string
                          value?: any | null
                        }
                      | {
                          __typename?: "BasicRichText"
                          model: string
                          richText?: string | null
                        }
                      | {
                          __typename?: "BasicUnsupportedPropertyValue"
                          model: string
                          message: string
                        }
                      | {
                          __typename?: "MintMediaPicker"
                          model: string
                          mediaItems: Array<{
                            __typename?: "MintMediaPickerItem"
                            id: number
                            url: string
                            altText?: string | null
                          }>
                        }
                      | null
                  } | null>
                }>
              }
            | {
                __typename?: "BasicMultiUrlPicker"
                valueType: string
                links: Array<{
                  __typename?: "BasicMultiUrlPickerItem"
                  name?: string | null
                  target?: string | null
                  type: LinkType
                  url?: string | null
                }>
              }
            | {
                __typename?: "BasicNestedContent"
                valueType: string
                elements?: Array<{
                  __typename?: "BasicNestedContentElement"
                  properties: Array<{
                    __typename?: "BasicProperty"
                    alias?: string | null
                    editorAlias?: string | null
                    value?:
                      | { __typename?: "BasicBlockGridModel"; model: string }
                      | { __typename?: "BasicBlockListModel"; model: string }
                      | {
                          __typename?: "BasicContentPicker"
                          model: string
                          contentList: Array<{
                            __typename?: "BasicContentPickerItem"
                            id: number
                            absoluteUrl: string
                            key: any
                            name?: string | null
                            url: string
                            urlSegment?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicDateTimePicker"
                          model: string
                          dateTime?: any | null
                        }
                      | {
                          __typename?: "BasicLabel"
                          model: string
                          label?: any | null
                        }
                      | { __typename?: "BasicMediaPicker"; model: string }
                      | {
                          __typename?: "BasicMemberPicker"
                          model: string
                          members: Array<{
                            __typename?: "BasicMemberPickerItem"
                            id?: number | null
                            name?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicMultiUrlPicker"
                          model: string
                          links: Array<{
                            __typename?: "BasicMultiUrlPickerItem"
                            name?: string | null
                            target?: string | null
                            type: LinkType
                            url?: string | null
                          }>
                        }
                      | { __typename?: "BasicNestedContent"; model: string }
                      | {
                          __typename?: "BasicPropertyValue"
                          model: string
                          value?: any | null
                        }
                      | {
                          __typename?: "BasicRichText"
                          model: string
                          richText?: string | null
                        }
                      | {
                          __typename?: "BasicUnsupportedPropertyValue"
                          model: string
                          message: string
                        }
                      | {
                          __typename?: "MintMediaPicker"
                          model: string
                          mediaItems: Array<{
                            __typename?: "MintMediaPickerItem"
                            id: number
                            url: string
                            altText?: string | null
                          }>
                        }
                      | null
                  } | null>
                }> | null
              }
            | {
                __typename?: "BasicPropertyValue"
                valueType: string
                value?: any | null
              }
            | {
                __typename?: "BasicRichText"
                valueType: string
                richText?: string | null
              }
            | {
                __typename?: "BasicUnsupportedPropertyValue"
                message: string
                valueType: string
              }
            | {
                __typename?: "MintMediaPicker"
                valueType: string
                mediaItems: Array<{
                  __typename?: "MintMediaPickerItem"
                  id: number
                  url: string
                  altText?: string | null
                }>
              }
            | null
        } | null>
        areas: Array<{
          __typename?: "BasicBlockGridArea"
          alias?: string | null
          rowSpan: number
          columnSpan: number
        } | null>
      }> | null
    } | null>
  }> | null
}

type PropertyValuesFooter_BasicBlockListModel_Fragment = {
  __typename?: "BasicBlockListModel"
  valueType: string
  blocks?: Array<{
    __typename?: "BasicBlockListItem"
    blockType?: string | null
    properties: Array<{
      __typename?: "BasicProperty"
      propertyName?: string | null
      propertyValue?:
        | { __typename?: "BasicBlockGridModel"; valueType: string }
        | {
            __typename?: "BasicBlockListModel"
            valueType: string
            blocks?: Array<{
              __typename?: "BasicBlockListItem"
              blockType?: string | null
              properties: Array<{
                __typename?: "BasicProperty"
                propertyName?: string | null
                propertyValue?:
                  | { __typename?: "BasicBlockGridModel"; valueType: string }
                  | {
                      __typename?: "BasicBlockListModel"
                      valueType: string
                      blocks?: Array<{
                        __typename?: "BasicBlockListItem"
                        blockType?: string | null
                        properties: Array<{
                          __typename?: "BasicProperty"
                          propertyName?: string | null
                          propertyValue?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                valueType: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                valueType: string
                                blocks?: Array<{
                                  __typename?: "BasicBlockListItem"
                                  blockType?: string | null
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    propertyName?: string | null
                                    propertyValue?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          valueType: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          valueType: string
                                          blocks?: Array<{
                                            __typename?: "BasicBlockListItem"
                                            blockType?: string | null
                                            properties: Array<{
                                              __typename?: "BasicProperty"
                                              propertyName?: string | null
                                              propertyValue?:
                                                | {
                                                    __typename?: "BasicBlockGridModel"
                                                    valueType: string
                                                  }
                                                | {
                                                    __typename?: "BasicBlockListModel"
                                                    valueType: string
                                                  }
                                                | {
                                                    __typename?: "BasicContentPicker"
                                                    valueType: string
                                                    contentList: Array<{
                                                      __typename?: "BasicContentPickerItem"
                                                      id: number
                                                      absoluteUrl: string
                                                      key: any
                                                      name?: string | null
                                                      url: string
                                                      urlSegment?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicDateTimePicker"
                                                    valueType: string
                                                    dateTime?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicLabel"
                                                    valueType: string
                                                    label?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicMediaPicker"
                                                    valueType: string
                                                  }
                                                | {
                                                    __typename?: "BasicMemberPicker"
                                                    valueType: string
                                                    members: Array<{
                                                      __typename?: "BasicMemberPickerItem"
                                                      id?: number | null
                                                      name?: string | null
                                                      properties: Array<{
                                                        __typename?: "BasicProperty"
                                                        alias?: string | null
                                                        editorAlias?:
                                                          | string
                                                          | null
                                                        value?:
                                                          | {
                                                              __typename?: "BasicBlockGridModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicBlockListModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicContentPicker"
                                                              model: string
                                                              contentList: Array<{
                                                                __typename?: "BasicContentPickerItem"
                                                                id: number
                                                                absoluteUrl: string
                                                                key: any
                                                                name?:
                                                                  | string
                                                                  | null
                                                                url: string
                                                                urlSegment?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicDateTimePicker"
                                                              model: string
                                                              dateTime?:
                                                                | any
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicLabel"
                                                              model: string
                                                              label?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicMediaPicker"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicMemberPicker"
                                                              model: string
                                                              members: Array<{
                                                                __typename?: "BasicMemberPickerItem"
                                                                id?:
                                                                  | number
                                                                  | null
                                                                name?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicMultiUrlPicker"
                                                              model: string
                                                              links: Array<{
                                                                __typename?: "BasicMultiUrlPickerItem"
                                                                name?:
                                                                  | string
                                                                  | null
                                                                target?:
                                                                  | string
                                                                  | null
                                                                type: LinkType
                                                                url?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicNestedContent"
                                                              model: string
                                                              elements?: Array<{
                                                                __typename?: "BasicNestedContentElement"
                                                                properties: Array<{
                                                                  __typename?: "BasicProperty"
                                                                  alias?:
                                                                    | string
                                                                    | null
                                                                  editorAlias?:
                                                                    | string
                                                                    | null
                                                                  value?:
                                                                    | {
                                                                        __typename?: "BasicBlockGridModel"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicBlockListModel"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicContentPicker"
                                                                        model: string
                                                                        contentList: Array<{
                                                                          __typename?: "BasicContentPickerItem"
                                                                          id: number
                                                                          absoluteUrl: string
                                                                          key: any
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                          url: string
                                                                          urlSegment?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicDateTimePicker"
                                                                        model: string
                                                                        dateTime?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicLabel"
                                                                        model: string
                                                                        label?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMediaPicker"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMemberPicker"
                                                                        model: string
                                                                        members: Array<{
                                                                          __typename?: "BasicMemberPickerItem"
                                                                          id?:
                                                                            | number
                                                                            | null
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMultiUrlPicker"
                                                                        model: string
                                                                        links: Array<{
                                                                          __typename?: "BasicMultiUrlPickerItem"
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                          target?:
                                                                            | string
                                                                            | null
                                                                          type: LinkType
                                                                          url?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicNestedContent"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicPropertyValue"
                                                                        model: string
                                                                        value?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicRichText"
                                                                        model: string
                                                                        richText?:
                                                                          | string
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicUnsupportedPropertyValue"
                                                                        model: string
                                                                        message: string
                                                                      }
                                                                    | {
                                                                        __typename?: "MintMediaPicker"
                                                                        model: string
                                                                        mediaItems: Array<{
                                                                          __typename?: "MintMediaPickerItem"
                                                                          id: number
                                                                          url: string
                                                                          altText?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | null
                                                                } | null>
                                                              }> | null
                                                            }
                                                          | {
                                                              __typename?: "BasicPropertyValue"
                                                              model: string
                                                              value?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicRichText"
                                                              model: string
                                                              richText?:
                                                                | string
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicUnsupportedPropertyValue"
                                                              model: string
                                                              message: string
                                                            }
                                                          | {
                                                              __typename?: "MintMediaPicker"
                                                              model: string
                                                              mediaItems: Array<{
                                                                __typename?: "MintMediaPickerItem"
                                                                id: number
                                                                url: string
                                                                altText?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | null
                                                      } | null>
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicMultiUrlPicker"
                                                    valueType: string
                                                    links: Array<{
                                                      __typename?: "BasicMultiUrlPickerItem"
                                                      name?: string | null
                                                      target?: string | null
                                                      type: LinkType
                                                      url?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicNestedContent"
                                                    valueType: string
                                                    elements?: Array<{
                                                      __typename?: "BasicNestedContentElement"
                                                      properties: Array<{
                                                        __typename?: "BasicProperty"
                                                        alias?: string | null
                                                        editorAlias?:
                                                          | string
                                                          | null
                                                        value?:
                                                          | {
                                                              __typename?: "BasicBlockGridModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicBlockListModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicContentPicker"
                                                              model: string
                                                              contentList: Array<{
                                                                __typename?: "BasicContentPickerItem"
                                                                id: number
                                                                absoluteUrl: string
                                                                key: any
                                                                name?:
                                                                  | string
                                                                  | null
                                                                url: string
                                                                urlSegment?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicDateTimePicker"
                                                              model: string
                                                              dateTime?:
                                                                | any
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicLabel"
                                                              model: string
                                                              label?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicMediaPicker"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicMemberPicker"
                                                              model: string
                                                              members: Array<{
                                                                __typename?: "BasicMemberPickerItem"
                                                                id?:
                                                                  | number
                                                                  | null
                                                                name?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicMultiUrlPicker"
                                                              model: string
                                                              links: Array<{
                                                                __typename?: "BasicMultiUrlPickerItem"
                                                                name?:
                                                                  | string
                                                                  | null
                                                                target?:
                                                                  | string
                                                                  | null
                                                                type: LinkType
                                                                url?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicNestedContent"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicPropertyValue"
                                                              model: string
                                                              value?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicRichText"
                                                              model: string
                                                              richText?:
                                                                | string
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicUnsupportedPropertyValue"
                                                              model: string
                                                              message: string
                                                            }
                                                          | {
                                                              __typename?: "MintMediaPicker"
                                                              model: string
                                                              mediaItems: Array<{
                                                                __typename?: "MintMediaPickerItem"
                                                                id: number
                                                                url: string
                                                                altText?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | null
                                                      } | null>
                                                    }> | null
                                                  }
                                                | {
                                                    __typename?: "BasicPropertyValue"
                                                    valueType: string
                                                    value?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicRichText"
                                                    valueType: string
                                                    richText?: string | null
                                                  }
                                                | {
                                                    __typename?: "BasicUnsupportedPropertyValue"
                                                    message: string
                                                    valueType: string
                                                  }
                                                | {
                                                    __typename?: "MintMediaPicker"
                                                    valueType: string
                                                    mediaItems: Array<{
                                                      __typename?: "MintMediaPickerItem"
                                                      id: number
                                                      url: string
                                                      altText?: string | null
                                                    }>
                                                  }
                                                | null
                                            } | null>
                                          }> | null
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          valueType: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          valueType: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          valueType: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          valueType: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          valueType: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                            properties: Array<{
                                              __typename?: "BasicProperty"
                                              alias?: string | null
                                              editorAlias?: string | null
                                              value?:
                                                | {
                                                    __typename?: "BasicBlockGridModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicBlockListModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicContentPicker"
                                                    model: string
                                                    contentList: Array<{
                                                      __typename?: "BasicContentPickerItem"
                                                      id: number
                                                      absoluteUrl: string
                                                      key: any
                                                      name?: string | null
                                                      url: string
                                                      urlSegment?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicDateTimePicker"
                                                    model: string
                                                    dateTime?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicLabel"
                                                    model: string
                                                    label?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicMediaPicker"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicMemberPicker"
                                                    model: string
                                                    members: Array<{
                                                      __typename?: "BasicMemberPickerItem"
                                                      id?: number | null
                                                      name?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicMultiUrlPicker"
                                                    model: string
                                                    links: Array<{
                                                      __typename?: "BasicMultiUrlPickerItem"
                                                      name?: string | null
                                                      target?: string | null
                                                      type: LinkType
                                                      url?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicNestedContent"
                                                    model: string
                                                    elements?: Array<{
                                                      __typename?: "BasicNestedContentElement"
                                                      properties: Array<{
                                                        __typename?: "BasicProperty"
                                                        alias?: string | null
                                                        editorAlias?:
                                                          | string
                                                          | null
                                                        value?:
                                                          | {
                                                              __typename?: "BasicBlockGridModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicBlockListModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicContentPicker"
                                                              model: string
                                                              contentList: Array<{
                                                                __typename?: "BasicContentPickerItem"
                                                                id: number
                                                                absoluteUrl: string
                                                                key: any
                                                                name?:
                                                                  | string
                                                                  | null
                                                                url: string
                                                                urlSegment?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicDateTimePicker"
                                                              model: string
                                                              dateTime?:
                                                                | any
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicLabel"
                                                              model: string
                                                              label?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicMediaPicker"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicMemberPicker"
                                                              model: string
                                                              members: Array<{
                                                                __typename?: "BasicMemberPickerItem"
                                                                id?:
                                                                  | number
                                                                  | null
                                                                name?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicMultiUrlPicker"
                                                              model: string
                                                              links: Array<{
                                                                __typename?: "BasicMultiUrlPickerItem"
                                                                name?:
                                                                  | string
                                                                  | null
                                                                target?:
                                                                  | string
                                                                  | null
                                                                type: LinkType
                                                                url?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicNestedContent"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicPropertyValue"
                                                              model: string
                                                              value?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicRichText"
                                                              model: string
                                                              richText?:
                                                                | string
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicUnsupportedPropertyValue"
                                                              model: string
                                                              message: string
                                                            }
                                                          | {
                                                              __typename?: "MintMediaPicker"
                                                              model: string
                                                              mediaItems: Array<{
                                                                __typename?: "MintMediaPickerItem"
                                                                id: number
                                                                url: string
                                                                altText?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | null
                                                      } | null>
                                                    }> | null
                                                  }
                                                | {
                                                    __typename?: "BasicPropertyValue"
                                                    model: string
                                                    value?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicRichText"
                                                    model: string
                                                    richText?: string | null
                                                  }
                                                | {
                                                    __typename?: "BasicUnsupportedPropertyValue"
                                                    model: string
                                                    message: string
                                                  }
                                                | {
                                                    __typename?: "MintMediaPicker"
                                                    model: string
                                                    mediaItems: Array<{
                                                      __typename?: "MintMediaPickerItem"
                                                      id: number
                                                      url: string
                                                      altText?: string | null
                                                    }>
                                                  }
                                                | null
                                            } | null>
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          valueType: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          valueType: string
                                          elements?: Array<{
                                            __typename?: "BasicNestedContentElement"
                                            properties: Array<{
                                              __typename?: "BasicProperty"
                                              alias?: string | null
                                              editorAlias?: string | null
                                              value?:
                                                | {
                                                    __typename?: "BasicBlockGridModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicBlockListModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicContentPicker"
                                                    model: string
                                                    contentList: Array<{
                                                      __typename?: "BasicContentPickerItem"
                                                      id: number
                                                      absoluteUrl: string
                                                      key: any
                                                      name?: string | null
                                                      url: string
                                                      urlSegment?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicDateTimePicker"
                                                    model: string
                                                    dateTime?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicLabel"
                                                    model: string
                                                    label?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicMediaPicker"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicMemberPicker"
                                                    model: string
                                                    members: Array<{
                                                      __typename?: "BasicMemberPickerItem"
                                                      id?: number | null
                                                      name?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicMultiUrlPicker"
                                                    model: string
                                                    links: Array<{
                                                      __typename?: "BasicMultiUrlPickerItem"
                                                      name?: string | null
                                                      target?: string | null
                                                      type: LinkType
                                                      url?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicNestedContent"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicPropertyValue"
                                                    model: string
                                                    value?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicRichText"
                                                    model: string
                                                    richText?: string | null
                                                  }
                                                | {
                                                    __typename?: "BasicUnsupportedPropertyValue"
                                                    model: string
                                                    message: string
                                                  }
                                                | {
                                                    __typename?: "MintMediaPicker"
                                                    model: string
                                                    mediaItems: Array<{
                                                      __typename?: "MintMediaPickerItem"
                                                      id: number
                                                      url: string
                                                      altText?: string | null
                                                    }>
                                                  }
                                                | null
                                            } | null>
                                          }> | null
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          valueType: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          valueType: string
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          message: string
                                          valueType: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          valueType: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }> | null
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                valueType: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                valueType: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                valueType: string
                                label?: any | null
                              }
                            | {
                                __typename?: "BasicMediaPicker"
                                valueType: string
                              }
                            | {
                                __typename?: "BasicMemberPicker"
                                valueType: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    alias?: string | null
                                    editorAlias?: string | null
                                    value?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          model: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          model: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          model: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          model: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          model: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          model: string
                                          elements?: Array<{
                                            __typename?: "BasicNestedContentElement"
                                            properties: Array<{
                                              __typename?: "BasicProperty"
                                              alias?: string | null
                                              editorAlias?: string | null
                                              value?:
                                                | {
                                                    __typename?: "BasicBlockGridModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicBlockListModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicContentPicker"
                                                    model: string
                                                    contentList: Array<{
                                                      __typename?: "BasicContentPickerItem"
                                                      id: number
                                                      absoluteUrl: string
                                                      key: any
                                                      name?: string | null
                                                      url: string
                                                      urlSegment?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicDateTimePicker"
                                                    model: string
                                                    dateTime?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicLabel"
                                                    model: string
                                                    label?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicMediaPicker"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicMemberPicker"
                                                    model: string
                                                    members: Array<{
                                                      __typename?: "BasicMemberPickerItem"
                                                      id?: number | null
                                                      name?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicMultiUrlPicker"
                                                    model: string
                                                    links: Array<{
                                                      __typename?: "BasicMultiUrlPickerItem"
                                                      name?: string | null
                                                      target?: string | null
                                                      type: LinkType
                                                      url?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicNestedContent"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicPropertyValue"
                                                    model: string
                                                    value?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicRichText"
                                                    model: string
                                                    richText?: string | null
                                                  }
                                                | {
                                                    __typename?: "BasicUnsupportedPropertyValue"
                                                    model: string
                                                    message: string
                                                  }
                                                | {
                                                    __typename?: "MintMediaPicker"
                                                    model: string
                                                    mediaItems: Array<{
                                                      __typename?: "MintMediaPickerItem"
                                                      id: number
                                                      url: string
                                                      altText?: string | null
                                                    }>
                                                  }
                                                | null
                                            } | null>
                                          }> | null
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          model: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          model: string
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          model: string
                                          message: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          model: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                valueType: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                valueType: string
                                elements?: Array<{
                                  __typename?: "BasicNestedContentElement"
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    alias?: string | null
                                    editorAlias?: string | null
                                    value?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          model: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          model: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          model: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          model: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          model: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          model: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          model: string
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          model: string
                                          message: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          model: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }> | null
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                valueType: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                valueType: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                message: string
                                valueType: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                valueType: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicContentPicker"
                      valueType: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      valueType: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      valueType: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; valueType: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      valueType: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                                elements?: Array<{
                                  __typename?: "BasicNestedContentElement"
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    alias?: string | null
                                    editorAlias?: string | null
                                    value?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          model: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          model: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          model: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          model: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          model: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          model: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          model: string
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          model: string
                                          message: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          model: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }> | null
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      valueType: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicNestedContent"
                      valueType: string
                      elements?: Array<{
                        __typename?: "BasicNestedContentElement"
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicPropertyValue"
                      valueType: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      valueType: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      message: string
                      valueType: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      valueType: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }> | null
          }
        | {
            __typename?: "BasicContentPicker"
            valueType: string
            contentList: Array<{
              __typename?: "BasicContentPickerItem"
              id: number
              absoluteUrl: string
              key: any
              name?: string | null
              url: string
              urlSegment?: string | null
            }>
          }
        | {
            __typename?: "BasicDateTimePicker"
            valueType: string
            dateTime?: any | null
          }
        | { __typename?: "BasicLabel"; valueType: string; label?: any | null }
        | { __typename?: "BasicMediaPicker"; valueType: string }
        | {
            __typename?: "BasicMemberPicker"
            valueType: string
            members: Array<{
              __typename?: "BasicMemberPickerItem"
              id?: number | null
              name?: string | null
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicNestedContent"
                      model: string
                      elements?: Array<{
                        __typename?: "BasicNestedContentElement"
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }>
          }
        | {
            __typename?: "BasicMultiUrlPicker"
            valueType: string
            links: Array<{
              __typename?: "BasicMultiUrlPickerItem"
              name?: string | null
              target?: string | null
              type: LinkType
              url?: string | null
            }>
          }
        | {
            __typename?: "BasicNestedContent"
            valueType: string
            elements?: Array<{
              __typename?: "BasicNestedContentElement"
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | { __typename?: "BasicNestedContent"; model: string }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }> | null
          }
        | {
            __typename?: "BasicPropertyValue"
            valueType: string
            value?: any | null
          }
        | {
            __typename?: "BasicRichText"
            valueType: string
            richText?: string | null
          }
        | {
            __typename?: "BasicUnsupportedPropertyValue"
            message: string
            valueType: string
          }
        | {
            __typename?: "MintMediaPicker"
            valueType: string
            mediaItems: Array<{
              __typename?: "MintMediaPickerItem"
              id: number
              url: string
              altText?: string | null
            }>
          }
        | null
    } | null>
  }> | null
}

type PropertyValuesFooter_BasicContentPicker_Fragment = {
  __typename?: "BasicContentPicker"
  valueType: string
  contentList: Array<{
    __typename?: "BasicContentPickerItem"
    id: number
    absoluteUrl: string
    key: any
    name?: string | null
    url: string
    urlSegment?: string | null
  }>
}

type PropertyValuesFooter_BasicDateTimePicker_Fragment = {
  __typename?: "BasicDateTimePicker"
  valueType: string
  dateTime?: any | null
}

type PropertyValuesFooter_BasicLabel_Fragment = {
  __typename?: "BasicLabel"
  valueType: string
  label?: any | null
}

type PropertyValuesFooter_BasicMediaPicker_Fragment = {
  __typename?: "BasicMediaPicker"
  valueType: string
}

type PropertyValuesFooter_BasicMemberPicker_Fragment = {
  __typename?: "BasicMemberPicker"
  valueType: string
  members: Array<{
    __typename?: "BasicMemberPickerItem"
    id?: number | null
    name?: string | null
    properties: Array<{
      __typename?: "BasicProperty"
      alias?: string | null
      editorAlias?: string | null
      value?:
        | { __typename?: "BasicBlockGridModel"; model: string }
        | { __typename?: "BasicBlockListModel"; model: string }
        | {
            __typename?: "BasicContentPicker"
            model: string
            contentList: Array<{
              __typename?: "BasicContentPickerItem"
              id: number
              absoluteUrl: string
              key: any
              name?: string | null
              url: string
              urlSegment?: string | null
            }>
          }
        | {
            __typename?: "BasicDateTimePicker"
            model: string
            dateTime?: any | null
          }
        | { __typename?: "BasicLabel"; model: string; label?: any | null }
        | { __typename?: "BasicMediaPicker"; model: string }
        | {
            __typename?: "BasicMemberPicker"
            model: string
            members: Array<{
              __typename?: "BasicMemberPickerItem"
              id?: number | null
              name?: string | null
            }>
          }
        | {
            __typename?: "BasicMultiUrlPicker"
            model: string
            links: Array<{
              __typename?: "BasicMultiUrlPickerItem"
              name?: string | null
              target?: string | null
              type: LinkType
              url?: string | null
            }>
          }
        | {
            __typename?: "BasicNestedContent"
            model: string
            elements?: Array<{
              __typename?: "BasicNestedContentElement"
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | { __typename?: "BasicNestedContent"; model: string }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }> | null
          }
        | {
            __typename?: "BasicPropertyValue"
            model: string
            value?: any | null
          }
        | {
            __typename?: "BasicRichText"
            model: string
            richText?: string | null
          }
        | {
            __typename?: "BasicUnsupportedPropertyValue"
            model: string
            message: string
          }
        | {
            __typename?: "MintMediaPicker"
            model: string
            mediaItems: Array<{
              __typename?: "MintMediaPickerItem"
              id: number
              url: string
              altText?: string | null
            }>
          }
        | null
    } | null>
  }>
}

type PropertyValuesFooter_BasicMultiUrlPicker_Fragment = {
  __typename?: "BasicMultiUrlPicker"
  valueType: string
  links: Array<{
    __typename?: "BasicMultiUrlPickerItem"
    name?: string | null
    target?: string | null
    type: LinkType
    url?: string | null
  }>
}

type PropertyValuesFooter_BasicNestedContent_Fragment = {
  __typename?: "BasicNestedContent"
  valueType: string
  elements?: Array<{
    __typename?: "BasicNestedContentElement"
    properties: Array<{
      __typename?: "BasicProperty"
      alias?: string | null
      editorAlias?: string | null
      value?:
        | { __typename?: "BasicBlockGridModel"; model: string }
        | { __typename?: "BasicBlockListModel"; model: string }
        | {
            __typename?: "BasicContentPicker"
            model: string
            contentList: Array<{
              __typename?: "BasicContentPickerItem"
              id: number
              absoluteUrl: string
              key: any
              name?: string | null
              url: string
              urlSegment?: string | null
            }>
          }
        | {
            __typename?: "BasicDateTimePicker"
            model: string
            dateTime?: any | null
          }
        | { __typename?: "BasicLabel"; model: string; label?: any | null }
        | { __typename?: "BasicMediaPicker"; model: string }
        | {
            __typename?: "BasicMemberPicker"
            model: string
            members: Array<{
              __typename?: "BasicMemberPickerItem"
              id?: number | null
              name?: string | null
            }>
          }
        | {
            __typename?: "BasicMultiUrlPicker"
            model: string
            links: Array<{
              __typename?: "BasicMultiUrlPickerItem"
              name?: string | null
              target?: string | null
              type: LinkType
              url?: string | null
            }>
          }
        | { __typename?: "BasicNestedContent"; model: string }
        | {
            __typename?: "BasicPropertyValue"
            model: string
            value?: any | null
          }
        | {
            __typename?: "BasicRichText"
            model: string
            richText?: string | null
          }
        | {
            __typename?: "BasicUnsupportedPropertyValue"
            model: string
            message: string
          }
        | {
            __typename?: "MintMediaPicker"
            model: string
            mediaItems: Array<{
              __typename?: "MintMediaPickerItem"
              id: number
              url: string
              altText?: string | null
            }>
          }
        | null
    } | null>
  }> | null
}

type PropertyValuesFooter_BasicPropertyValue_Fragment = {
  __typename?: "BasicPropertyValue"
  valueType: string
  value?: any | null
}

type PropertyValuesFooter_BasicRichText_Fragment = {
  __typename?: "BasicRichText"
  valueType: string
  richText?: string | null
}

type PropertyValuesFooter_BasicUnsupportedPropertyValue_Fragment = {
  __typename?: "BasicUnsupportedPropertyValue"
  message: string
  valueType: string
}

type PropertyValuesFooter_MintMediaPicker_Fragment = {
  __typename?: "MintMediaPicker"
  valueType: string
  mediaItems: Array<{
    __typename?: "MintMediaPickerItem"
    id: number
    url: string
    altText?: string | null
  }>
}

export type PropertyValuesFooterFragment =
  | PropertyValuesFooter_BasicBlockGridModel_Fragment
  | PropertyValuesFooter_BasicBlockListModel_Fragment
  | PropertyValuesFooter_BasicContentPicker_Fragment
  | PropertyValuesFooter_BasicDateTimePicker_Fragment
  | PropertyValuesFooter_BasicLabel_Fragment
  | PropertyValuesFooter_BasicMediaPicker_Fragment
  | PropertyValuesFooter_BasicMemberPicker_Fragment
  | PropertyValuesFooter_BasicMultiUrlPicker_Fragment
  | PropertyValuesFooter_BasicNestedContent_Fragment
  | PropertyValuesFooter_BasicPropertyValue_Fragment
  | PropertyValuesFooter_BasicRichText_Fragment
  | PropertyValuesFooter_BasicUnsupportedPropertyValue_Fragment
  | PropertyValuesFooter_MintMediaPicker_Fragment

export type FetchMenusQueryVariables = Exact<{
  desktopMenu: Scalars["String"]["input"]
  culture: Scalars["String"]["input"]
}>

export type FetchMenusQuery = {
  __typename?: "Query"
  menu_desktop?: {
    __typename?: "BasicContent"
    children?: Array<{
      __typename?: "BasicContent"
      children?: Array<{
        __typename?: "BasicContent"
        children?: Array<{
          __typename?: "BasicContent"
          properties?: Array<{
            __typename?: "BasicProperty"
            property?:
              | { __typename?: "BasicBlockGridModel" }
              | { __typename?: "BasicBlockListModel" }
              | {
                  __typename?: "BasicContentPicker"
                  menuTarget: Array<{
                    __typename?: "BasicContentPickerItem"
                    id: number
                    absoluteUrl: string
                    key: any
                    name?: string | null
                    url: string
                    urlSegment?: string | null
                  }>
                }
              | { __typename?: "BasicDateTimePicker" }
              | { __typename?: "BasicLabel" }
              | { __typename?: "BasicMediaPicker" }
              | { __typename?: "BasicMemberPicker" }
              | { __typename?: "BasicMultiUrlPicker" }
              | { __typename?: "BasicNestedContent" }
              | { __typename?: "BasicPropertyValue"; menuName?: any | null }
              | { __typename?: "BasicRichText" }
              | { __typename?: "BasicUnsupportedPropertyValue" }
              | { __typename?: "MintMediaPicker" }
              | null
          } | null> | null
        } | null> | null
        properties?: Array<{
          __typename?: "BasicProperty"
          property?:
            | { __typename?: "BasicBlockGridModel" }
            | { __typename?: "BasicBlockListModel" }
            | {
                __typename?: "BasicContentPicker"
                menuTarget: Array<{
                  __typename?: "BasicContentPickerItem"
                  id: number
                  absoluteUrl: string
                  key: any
                  name?: string | null
                  url: string
                  urlSegment?: string | null
                }>
              }
            | { __typename?: "BasicDateTimePicker" }
            | { __typename?: "BasicLabel" }
            | { __typename?: "BasicMediaPicker" }
            | { __typename?: "BasicMemberPicker" }
            | { __typename?: "BasicMultiUrlPicker" }
            | { __typename?: "BasicNestedContent" }
            | { __typename?: "BasicPropertyValue"; menuName?: any | null }
            | { __typename?: "BasicRichText" }
            | { __typename?: "BasicUnsupportedPropertyValue" }
            | { __typename?: "MintMediaPicker" }
            | null
        } | null> | null
      } | null> | null
      properties?: Array<{
        __typename?: "BasicProperty"
        property?:
          | { __typename?: "BasicBlockGridModel" }
          | { __typename?: "BasicBlockListModel" }
          | {
              __typename?: "BasicContentPicker"
              menuTarget: Array<{
                __typename?: "BasicContentPickerItem"
                id: number
                absoluteUrl: string
                key: any
                name?: string | null
                url: string
                urlSegment?: string | null
              }>
            }
          | { __typename?: "BasicDateTimePicker" }
          | { __typename?: "BasicLabel" }
          | { __typename?: "BasicMediaPicker" }
          | { __typename?: "BasicMemberPicker" }
          | { __typename?: "BasicMultiUrlPicker" }
          | { __typename?: "BasicNestedContent" }
          | { __typename?: "BasicPropertyValue"; menuName?: any | null }
          | { __typename?: "BasicRichText" }
          | { __typename?: "BasicUnsupportedPropertyValue" }
          | { __typename?: "MintMediaPicker" }
          | null
      } | null> | null
    } | null> | null
    properties?: Array<{
      __typename?: "BasicProperty"
      property?:
        | { __typename?: "BasicBlockGridModel" }
        | { __typename?: "BasicBlockListModel" }
        | {
            __typename?: "BasicContentPicker"
            menuTarget: Array<{
              __typename?: "BasicContentPickerItem"
              id: number
              absoluteUrl: string
              key: any
              name?: string | null
              url: string
              urlSegment?: string | null
            }>
          }
        | { __typename?: "BasicDateTimePicker" }
        | { __typename?: "BasicLabel" }
        | { __typename?: "BasicMediaPicker" }
        | { __typename?: "BasicMemberPicker" }
        | { __typename?: "BasicMultiUrlPicker" }
        | { __typename?: "BasicNestedContent" }
        | { __typename?: "BasicPropertyValue"; menuName?: any | null }
        | { __typename?: "BasicRichText" }
        | { __typename?: "BasicUnsupportedPropertyValue" }
        | { __typename?: "MintMediaPicker" }
        | null
    } | null> | null
  } | null
}

export type MenuContentNestedFragment = {
  __typename?: "BasicContent"
  children?: Array<{
    __typename?: "BasicContent"
    children?: Array<{
      __typename?: "BasicContent"
      children?: Array<{
        __typename?: "BasicContent"
        properties?: Array<{
          __typename?: "BasicProperty"
          property?:
            | { __typename?: "BasicBlockGridModel" }
            | { __typename?: "BasicBlockListModel" }
            | {
                __typename?: "BasicContentPicker"
                menuTarget: Array<{
                  __typename?: "BasicContentPickerItem"
                  id: number
                  absoluteUrl: string
                  key: any
                  name?: string | null
                  url: string
                  urlSegment?: string | null
                }>
              }
            | { __typename?: "BasicDateTimePicker" }
            | { __typename?: "BasicLabel" }
            | { __typename?: "BasicMediaPicker" }
            | { __typename?: "BasicMemberPicker" }
            | { __typename?: "BasicMultiUrlPicker" }
            | { __typename?: "BasicNestedContent" }
            | { __typename?: "BasicPropertyValue"; menuName?: any | null }
            | { __typename?: "BasicRichText" }
            | { __typename?: "BasicUnsupportedPropertyValue" }
            | { __typename?: "MintMediaPicker" }
            | null
        } | null> | null
      } | null> | null
      properties?: Array<{
        __typename?: "BasicProperty"
        property?:
          | { __typename?: "BasicBlockGridModel" }
          | { __typename?: "BasicBlockListModel" }
          | {
              __typename?: "BasicContentPicker"
              menuTarget: Array<{
                __typename?: "BasicContentPickerItem"
                id: number
                absoluteUrl: string
                key: any
                name?: string | null
                url: string
                urlSegment?: string | null
              }>
            }
          | { __typename?: "BasicDateTimePicker" }
          | { __typename?: "BasicLabel" }
          | { __typename?: "BasicMediaPicker" }
          | { __typename?: "BasicMemberPicker" }
          | { __typename?: "BasicMultiUrlPicker" }
          | { __typename?: "BasicNestedContent" }
          | { __typename?: "BasicPropertyValue"; menuName?: any | null }
          | { __typename?: "BasicRichText" }
          | { __typename?: "BasicUnsupportedPropertyValue" }
          | { __typename?: "MintMediaPicker" }
          | null
      } | null> | null
    } | null> | null
    properties?: Array<{
      __typename?: "BasicProperty"
      property?:
        | { __typename?: "BasicBlockGridModel" }
        | { __typename?: "BasicBlockListModel" }
        | {
            __typename?: "BasicContentPicker"
            menuTarget: Array<{
              __typename?: "BasicContentPickerItem"
              id: number
              absoluteUrl: string
              key: any
              name?: string | null
              url: string
              urlSegment?: string | null
            }>
          }
        | { __typename?: "BasicDateTimePicker" }
        | { __typename?: "BasicLabel" }
        | { __typename?: "BasicMediaPicker" }
        | { __typename?: "BasicMemberPicker" }
        | { __typename?: "BasicMultiUrlPicker" }
        | { __typename?: "BasicNestedContent" }
        | { __typename?: "BasicPropertyValue"; menuName?: any | null }
        | { __typename?: "BasicRichText" }
        | { __typename?: "BasicUnsupportedPropertyValue" }
        | { __typename?: "MintMediaPicker" }
        | null
    } | null> | null
  } | null> | null
  properties?: Array<{
    __typename?: "BasicProperty"
    property?:
      | { __typename?: "BasicBlockGridModel" }
      | { __typename?: "BasicBlockListModel" }
      | {
          __typename?: "BasicContentPicker"
          menuTarget: Array<{
            __typename?: "BasicContentPickerItem"
            id: number
            absoluteUrl: string
            key: any
            name?: string | null
            url: string
            urlSegment?: string | null
          }>
        }
      | { __typename?: "BasicDateTimePicker" }
      | { __typename?: "BasicLabel" }
      | { __typename?: "BasicMediaPicker" }
      | { __typename?: "BasicMemberPicker" }
      | { __typename?: "BasicMultiUrlPicker" }
      | { __typename?: "BasicNestedContent" }
      | { __typename?: "BasicPropertyValue"; menuName?: any | null }
      | { __typename?: "BasicRichText" }
      | { __typename?: "BasicUnsupportedPropertyValue" }
      | { __typename?: "MintMediaPicker" }
      | null
  } | null> | null
}

export type MenuContentFragment = {
  __typename?: "BasicContent"
  properties?: Array<{
    __typename?: "BasicProperty"
    property?:
      | { __typename?: "BasicBlockGridModel" }
      | { __typename?: "BasicBlockListModel" }
      | {
          __typename?: "BasicContentPicker"
          menuTarget: Array<{
            __typename?: "BasicContentPickerItem"
            id: number
            absoluteUrl: string
            key: any
            name?: string | null
            url: string
            urlSegment?: string | null
          }>
        }
      | { __typename?: "BasicDateTimePicker" }
      | { __typename?: "BasicLabel" }
      | { __typename?: "BasicMediaPicker" }
      | { __typename?: "BasicMemberPicker" }
      | { __typename?: "BasicMultiUrlPicker" }
      | { __typename?: "BasicNestedContent" }
      | { __typename?: "BasicPropertyValue"; menuName?: any | null }
      | { __typename?: "BasicRichText" }
      | { __typename?: "BasicUnsupportedPropertyValue" }
      | { __typename?: "MintMediaPicker" }
      | null
  } | null> | null
}

type MenuBasicValue_BasicBlockGridModel_Fragment = {
  __typename?: "BasicBlockGridModel"
}

type MenuBasicValue_BasicBlockListModel_Fragment = {
  __typename?: "BasicBlockListModel"
}

type MenuBasicValue_BasicContentPicker_Fragment = {
  __typename?: "BasicContentPicker"
}

type MenuBasicValue_BasicDateTimePicker_Fragment = {
  __typename?: "BasicDateTimePicker"
}

type MenuBasicValue_BasicLabel_Fragment = { __typename?: "BasicLabel" }

type MenuBasicValue_BasicMediaPicker_Fragment = {
  __typename?: "BasicMediaPicker"
}

type MenuBasicValue_BasicMemberPicker_Fragment = {
  __typename?: "BasicMemberPicker"
}

type MenuBasicValue_BasicMultiUrlPicker_Fragment = {
  __typename?: "BasicMultiUrlPicker"
}

type MenuBasicValue_BasicNestedContent_Fragment = {
  __typename?: "BasicNestedContent"
}

type MenuBasicValue_BasicPropertyValue_Fragment = {
  __typename?: "BasicPropertyValue"
  menuName?: any | null
}

type MenuBasicValue_BasicRichText_Fragment = { __typename?: "BasicRichText" }

type MenuBasicValue_BasicUnsupportedPropertyValue_Fragment = {
  __typename?: "BasicUnsupportedPropertyValue"
}

type MenuBasicValue_MintMediaPicker_Fragment = {
  __typename?: "MintMediaPicker"
}

export type MenuBasicValueFragment =
  | MenuBasicValue_BasicBlockGridModel_Fragment
  | MenuBasicValue_BasicBlockListModel_Fragment
  | MenuBasicValue_BasicContentPicker_Fragment
  | MenuBasicValue_BasicDateTimePicker_Fragment
  | MenuBasicValue_BasicLabel_Fragment
  | MenuBasicValue_BasicMediaPicker_Fragment
  | MenuBasicValue_BasicMemberPicker_Fragment
  | MenuBasicValue_BasicMultiUrlPicker_Fragment
  | MenuBasicValue_BasicNestedContent_Fragment
  | MenuBasicValue_BasicPropertyValue_Fragment
  | MenuBasicValue_BasicRichText_Fragment
  | MenuBasicValue_BasicUnsupportedPropertyValue_Fragment
  | MenuBasicValue_MintMediaPicker_Fragment

type MenuContentPicker_BasicBlockGridModel_Fragment = {
  __typename?: "BasicBlockGridModel"
}

type MenuContentPicker_BasicBlockListModel_Fragment = {
  __typename?: "BasicBlockListModel"
}

type MenuContentPicker_BasicContentPicker_Fragment = {
  __typename?: "BasicContentPicker"
  menuTarget: Array<{
    __typename?: "BasicContentPickerItem"
    id: number
    absoluteUrl: string
    key: any
    name?: string | null
    url: string
    urlSegment?: string | null
  }>
}

type MenuContentPicker_BasicDateTimePicker_Fragment = {
  __typename?: "BasicDateTimePicker"
}

type MenuContentPicker_BasicLabel_Fragment = { __typename?: "BasicLabel" }

type MenuContentPicker_BasicMediaPicker_Fragment = {
  __typename?: "BasicMediaPicker"
}

type MenuContentPicker_BasicMemberPicker_Fragment = {
  __typename?: "BasicMemberPicker"
}

type MenuContentPicker_BasicMultiUrlPicker_Fragment = {
  __typename?: "BasicMultiUrlPicker"
}

type MenuContentPicker_BasicNestedContent_Fragment = {
  __typename?: "BasicNestedContent"
}

type MenuContentPicker_BasicPropertyValue_Fragment = {
  __typename?: "BasicPropertyValue"
}

type MenuContentPicker_BasicRichText_Fragment = { __typename?: "BasicRichText" }

type MenuContentPicker_BasicUnsupportedPropertyValue_Fragment = {
  __typename?: "BasicUnsupportedPropertyValue"
}

type MenuContentPicker_MintMediaPicker_Fragment = {
  __typename?: "MintMediaPicker"
}

export type MenuContentPickerFragment =
  | MenuContentPicker_BasicBlockGridModel_Fragment
  | MenuContentPicker_BasicBlockListModel_Fragment
  | MenuContentPicker_BasicContentPicker_Fragment
  | MenuContentPicker_BasicDateTimePicker_Fragment
  | MenuContentPicker_BasicLabel_Fragment
  | MenuContentPicker_BasicMediaPicker_Fragment
  | MenuContentPicker_BasicMemberPicker_Fragment
  | MenuContentPicker_BasicMultiUrlPicker_Fragment
  | MenuContentPicker_BasicNestedContent_Fragment
  | MenuContentPicker_BasicPropertyValue_Fragment
  | MenuContentPicker_BasicRichText_Fragment
  | MenuContentPicker_BasicUnsupportedPropertyValue_Fragment
  | MenuContentPicker_MintMediaPicker_Fragment

export type GetPageQueryVariables = Exact<{
  id: Scalars["Int"]["input"]
  culture: Scalars["String"]["input"]
}>

export type GetPageQuery = {
  __typename?: "Query"
  page?: {
    __typename?: "BasicContent"
    url?: string | null
    absoluteUrl?: string | null
    level?: number | null
    parent?: {
      __typename?: "BasicContent"
      id?: number | null
      url?: string | null
      properties?: Array<{
        __typename?: "BasicProperty"
        propertyName?: string | null
        propertyValue?:
          | {
              __typename?: "BasicBlockGridModel"
              gridColumns?: number | null
              valueType: string
              blocks?: Array<{
                __typename?: "BasicBlockGridItem"
                columnSpan: number
                rowSpan: number
                contentProperties: Array<{
                  __typename?: "BasicProperty"
                  value?:
                    | { __typename?: "BasicBlockGridModel"; valueType: string }
                    | { __typename?: "BasicBlockListModel"; valueType: string }
                    | {
                        __typename?: "BasicContentPicker"
                        valueType: string
                        contentList: Array<{
                          __typename?: "BasicContentPickerItem"
                          id: number
                          absoluteUrl: string
                          key: any
                          name?: string | null
                          url: string
                          urlSegment?: string | null
                        }>
                      }
                    | {
                        __typename?: "BasicDateTimePicker"
                        valueType: string
                        dateTime?: any | null
                      }
                    | {
                        __typename?: "BasicLabel"
                        valueType: string
                        label?: any | null
                      }
                    | { __typename?: "BasicMediaPicker"; valueType: string }
                    | {
                        __typename?: "BasicMemberPicker"
                        valueType: string
                        members: Array<{
                          __typename?: "BasicMemberPickerItem"
                          id?: number | null
                          name?: string | null
                          properties: Array<{
                            __typename?: "BasicProperty"
                            alias?: string | null
                            editorAlias?: string | null
                            value?:
                              | {
                                  __typename?: "BasicBlockGridModel"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicBlockListModel"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicContentPicker"
                                  model: string
                                  contentList: Array<{
                                    __typename?: "BasicContentPickerItem"
                                    id: number
                                    absoluteUrl: string
                                    key: any
                                    name?: string | null
                                    url: string
                                    urlSegment?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicDateTimePicker"
                                  model: string
                                  dateTime?: any | null
                                }
                              | {
                                  __typename?: "BasicLabel"
                                  model: string
                                  label?: any | null
                                }
                              | {
                                  __typename?: "BasicMediaPicker"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicMemberPicker"
                                  model: string
                                  members: Array<{
                                    __typename?: "BasicMemberPickerItem"
                                    id?: number | null
                                    name?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicMultiUrlPicker"
                                  model: string
                                  links: Array<{
                                    __typename?: "BasicMultiUrlPickerItem"
                                    name?: string | null
                                    target?: string | null
                                    type: LinkType
                                    url?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicNestedContent"
                                  model: string
                                  elements?: Array<{
                                    __typename?: "BasicNestedContentElement"
                                    properties: Array<{
                                      __typename?: "BasicProperty"
                                      alias?: string | null
                                      editorAlias?: string | null
                                      value?:
                                        | {
                                            __typename?: "BasicBlockGridModel"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicBlockListModel"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicContentPicker"
                                            model: string
                                            contentList: Array<{
                                              __typename?: "BasicContentPickerItem"
                                              id: number
                                              absoluteUrl: string
                                              key: any
                                              name?: string | null
                                              url: string
                                              urlSegment?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicDateTimePicker"
                                            model: string
                                            dateTime?: any | null
                                          }
                                        | {
                                            __typename?: "BasicLabel"
                                            model: string
                                            label?: any | null
                                          }
                                        | {
                                            __typename?: "BasicMediaPicker"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicMemberPicker"
                                            model: string
                                            members: Array<{
                                              __typename?: "BasicMemberPickerItem"
                                              id?: number | null
                                              name?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicMultiUrlPicker"
                                            model: string
                                            links: Array<{
                                              __typename?: "BasicMultiUrlPickerItem"
                                              name?: string | null
                                              target?: string | null
                                              type: LinkType
                                              url?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicNestedContent"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicPropertyValue"
                                            model: string
                                            value?: any | null
                                          }
                                        | {
                                            __typename?: "BasicRichText"
                                            model: string
                                            richText?: string | null
                                          }
                                        | {
                                            __typename?: "BasicUnsupportedPropertyValue"
                                            model: string
                                            message: string
                                          }
                                        | {
                                            __typename?: "MintMediaPicker"
                                            model: string
                                            mediaItems: Array<{
                                              __typename?: "MintMediaPickerItem"
                                              id: number
                                              url: string
                                              altText?: string | null
                                            }>
                                          }
                                        | null
                                    } | null>
                                  }> | null
                                }
                              | {
                                  __typename?: "BasicPropertyValue"
                                  model: string
                                  value?: any | null
                                }
                              | {
                                  __typename?: "BasicRichText"
                                  model: string
                                  richText?: string | null
                                }
                              | {
                                  __typename?: "BasicUnsupportedPropertyValue"
                                  model: string
                                  message: string
                                }
                              | {
                                  __typename?: "MintMediaPicker"
                                  model: string
                                  mediaItems: Array<{
                                    __typename?: "MintMediaPickerItem"
                                    id: number
                                    url: string
                                    altText?: string | null
                                  }>
                                }
                              | null
                          } | null>
                        }>
                      }
                    | {
                        __typename?: "BasicMultiUrlPicker"
                        valueType: string
                        links: Array<{
                          __typename?: "BasicMultiUrlPickerItem"
                          name?: string | null
                          target?: string | null
                          type: LinkType
                          url?: string | null
                        }>
                      }
                    | {
                        __typename?: "BasicNestedContent"
                        valueType: string
                        elements?: Array<{
                          __typename?: "BasicNestedContentElement"
                          properties: Array<{
                            __typename?: "BasicProperty"
                            alias?: string | null
                            editorAlias?: string | null
                            value?:
                              | {
                                  __typename?: "BasicBlockGridModel"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicBlockListModel"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicContentPicker"
                                  model: string
                                  contentList: Array<{
                                    __typename?: "BasicContentPickerItem"
                                    id: number
                                    absoluteUrl: string
                                    key: any
                                    name?: string | null
                                    url: string
                                    urlSegment?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicDateTimePicker"
                                  model: string
                                  dateTime?: any | null
                                }
                              | {
                                  __typename?: "BasicLabel"
                                  model: string
                                  label?: any | null
                                }
                              | {
                                  __typename?: "BasicMediaPicker"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicMemberPicker"
                                  model: string
                                  members: Array<{
                                    __typename?: "BasicMemberPickerItem"
                                    id?: number | null
                                    name?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicMultiUrlPicker"
                                  model: string
                                  links: Array<{
                                    __typename?: "BasicMultiUrlPickerItem"
                                    name?: string | null
                                    target?: string | null
                                    type: LinkType
                                    url?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicNestedContent"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicPropertyValue"
                                  model: string
                                  value?: any | null
                                }
                              | {
                                  __typename?: "BasicRichText"
                                  model: string
                                  richText?: string | null
                                }
                              | {
                                  __typename?: "BasicUnsupportedPropertyValue"
                                  model: string
                                  message: string
                                }
                              | {
                                  __typename?: "MintMediaPicker"
                                  model: string
                                  mediaItems: Array<{
                                    __typename?: "MintMediaPickerItem"
                                    id: number
                                    url: string
                                    altText?: string | null
                                  }>
                                }
                              | null
                          } | null>
                        }> | null
                      }
                    | {
                        __typename?: "BasicPropertyValue"
                        valueType: string
                        value?: any | null
                      }
                    | {
                        __typename?: "BasicRichText"
                        valueType: string
                        richText?: string | null
                      }
                    | {
                        __typename?: "BasicUnsupportedPropertyValue"
                        message: string
                        valueType: string
                      }
                    | {
                        __typename?: "MintMediaPicker"
                        valueType: string
                        mediaItems: Array<{
                          __typename?: "MintMediaPickerItem"
                          id: number
                          url: string
                          altText?: string | null
                        }>
                      }
                    | null
                } | null>
                settingsProperties: Array<{
                  __typename?: "BasicProperty"
                  value?:
                    | { __typename?: "BasicBlockGridModel"; valueType: string }
                    | { __typename?: "BasicBlockListModel"; valueType: string }
                    | {
                        __typename?: "BasicContentPicker"
                        valueType: string
                        contentList: Array<{
                          __typename?: "BasicContentPickerItem"
                          id: number
                          absoluteUrl: string
                          key: any
                          name?: string | null
                          url: string
                          urlSegment?: string | null
                        }>
                      }
                    | {
                        __typename?: "BasicDateTimePicker"
                        valueType: string
                        dateTime?: any | null
                      }
                    | {
                        __typename?: "BasicLabel"
                        valueType: string
                        label?: any | null
                      }
                    | { __typename?: "BasicMediaPicker"; valueType: string }
                    | {
                        __typename?: "BasicMemberPicker"
                        valueType: string
                        members: Array<{
                          __typename?: "BasicMemberPickerItem"
                          id?: number | null
                          name?: string | null
                          properties: Array<{
                            __typename?: "BasicProperty"
                            alias?: string | null
                            editorAlias?: string | null
                            value?:
                              | {
                                  __typename?: "BasicBlockGridModel"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicBlockListModel"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicContentPicker"
                                  model: string
                                  contentList: Array<{
                                    __typename?: "BasicContentPickerItem"
                                    id: number
                                    absoluteUrl: string
                                    key: any
                                    name?: string | null
                                    url: string
                                    urlSegment?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicDateTimePicker"
                                  model: string
                                  dateTime?: any | null
                                }
                              | {
                                  __typename?: "BasicLabel"
                                  model: string
                                  label?: any | null
                                }
                              | {
                                  __typename?: "BasicMediaPicker"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicMemberPicker"
                                  model: string
                                  members: Array<{
                                    __typename?: "BasicMemberPickerItem"
                                    id?: number | null
                                    name?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicMultiUrlPicker"
                                  model: string
                                  links: Array<{
                                    __typename?: "BasicMultiUrlPickerItem"
                                    name?: string | null
                                    target?: string | null
                                    type: LinkType
                                    url?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicNestedContent"
                                  model: string
                                  elements?: Array<{
                                    __typename?: "BasicNestedContentElement"
                                    properties: Array<{
                                      __typename?: "BasicProperty"
                                      alias?: string | null
                                      editorAlias?: string | null
                                      value?:
                                        | {
                                            __typename?: "BasicBlockGridModel"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicBlockListModel"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicContentPicker"
                                            model: string
                                            contentList: Array<{
                                              __typename?: "BasicContentPickerItem"
                                              id: number
                                              absoluteUrl: string
                                              key: any
                                              name?: string | null
                                              url: string
                                              urlSegment?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicDateTimePicker"
                                            model: string
                                            dateTime?: any | null
                                          }
                                        | {
                                            __typename?: "BasicLabel"
                                            model: string
                                            label?: any | null
                                          }
                                        | {
                                            __typename?: "BasicMediaPicker"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicMemberPicker"
                                            model: string
                                            members: Array<{
                                              __typename?: "BasicMemberPickerItem"
                                              id?: number | null
                                              name?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicMultiUrlPicker"
                                            model: string
                                            links: Array<{
                                              __typename?: "BasicMultiUrlPickerItem"
                                              name?: string | null
                                              target?: string | null
                                              type: LinkType
                                              url?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicNestedContent"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicPropertyValue"
                                            model: string
                                            value?: any | null
                                          }
                                        | {
                                            __typename?: "BasicRichText"
                                            model: string
                                            richText?: string | null
                                          }
                                        | {
                                            __typename?: "BasicUnsupportedPropertyValue"
                                            model: string
                                            message: string
                                          }
                                        | {
                                            __typename?: "MintMediaPicker"
                                            model: string
                                            mediaItems: Array<{
                                              __typename?: "MintMediaPickerItem"
                                              id: number
                                              url: string
                                              altText?: string | null
                                            }>
                                          }
                                        | null
                                    } | null>
                                  }> | null
                                }
                              | {
                                  __typename?: "BasicPropertyValue"
                                  model: string
                                  value?: any | null
                                }
                              | {
                                  __typename?: "BasicRichText"
                                  model: string
                                  richText?: string | null
                                }
                              | {
                                  __typename?: "BasicUnsupportedPropertyValue"
                                  model: string
                                  message: string
                                }
                              | {
                                  __typename?: "MintMediaPicker"
                                  model: string
                                  mediaItems: Array<{
                                    __typename?: "MintMediaPickerItem"
                                    id: number
                                    url: string
                                    altText?: string | null
                                  }>
                                }
                              | null
                          } | null>
                        }>
                      }
                    | {
                        __typename?: "BasicMultiUrlPicker"
                        valueType: string
                        links: Array<{
                          __typename?: "BasicMultiUrlPickerItem"
                          name?: string | null
                          target?: string | null
                          type: LinkType
                          url?: string | null
                        }>
                      }
                    | {
                        __typename?: "BasicNestedContent"
                        valueType: string
                        elements?: Array<{
                          __typename?: "BasicNestedContentElement"
                          properties: Array<{
                            __typename?: "BasicProperty"
                            alias?: string | null
                            editorAlias?: string | null
                            value?:
                              | {
                                  __typename?: "BasicBlockGridModel"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicBlockListModel"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicContentPicker"
                                  model: string
                                  contentList: Array<{
                                    __typename?: "BasicContentPickerItem"
                                    id: number
                                    absoluteUrl: string
                                    key: any
                                    name?: string | null
                                    url: string
                                    urlSegment?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicDateTimePicker"
                                  model: string
                                  dateTime?: any | null
                                }
                              | {
                                  __typename?: "BasicLabel"
                                  model: string
                                  label?: any | null
                                }
                              | {
                                  __typename?: "BasicMediaPicker"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicMemberPicker"
                                  model: string
                                  members: Array<{
                                    __typename?: "BasicMemberPickerItem"
                                    id?: number | null
                                    name?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicMultiUrlPicker"
                                  model: string
                                  links: Array<{
                                    __typename?: "BasicMultiUrlPickerItem"
                                    name?: string | null
                                    target?: string | null
                                    type: LinkType
                                    url?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicNestedContent"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicPropertyValue"
                                  model: string
                                  value?: any | null
                                }
                              | {
                                  __typename?: "BasicRichText"
                                  model: string
                                  richText?: string | null
                                }
                              | {
                                  __typename?: "BasicUnsupportedPropertyValue"
                                  model: string
                                  message: string
                                }
                              | {
                                  __typename?: "MintMediaPicker"
                                  model: string
                                  mediaItems: Array<{
                                    __typename?: "MintMediaPickerItem"
                                    id: number
                                    url: string
                                    altText?: string | null
                                  }>
                                }
                              | null
                          } | null>
                        }> | null
                      }
                    | {
                        __typename?: "BasicPropertyValue"
                        valueType: string
                        value?: any | null
                      }
                    | {
                        __typename?: "BasicRichText"
                        valueType: string
                        richText?: string | null
                      }
                    | {
                        __typename?: "BasicUnsupportedPropertyValue"
                        message: string
                        valueType: string
                      }
                    | {
                        __typename?: "MintMediaPicker"
                        valueType: string
                        mediaItems: Array<{
                          __typename?: "MintMediaPickerItem"
                          id: number
                          url: string
                          altText?: string | null
                        }>
                      }
                    | null
                } | null>
                areas: Array<{
                  __typename?: "BasicBlockGridArea"
                  alias?: string | null
                  rowSpan: number
                  columnSpan: number
                  blocks?: Array<{
                    __typename?: "BasicBlockGridItem"
                    columnSpan: number
                    rowSpan: number
                    contentProperties: Array<{
                      __typename?: "BasicProperty"
                      value?:
                        | {
                            __typename?: "BasicBlockGridModel"
                            valueType: string
                          }
                        | {
                            __typename?: "BasicBlockListModel"
                            valueType: string
                          }
                        | {
                            __typename?: "BasicContentPicker"
                            valueType: string
                            contentList: Array<{
                              __typename?: "BasicContentPickerItem"
                              id: number
                              absoluteUrl: string
                              key: any
                              name?: string | null
                              url: string
                              urlSegment?: string | null
                            }>
                          }
                        | {
                            __typename?: "BasicDateTimePicker"
                            valueType: string
                            dateTime?: any | null
                          }
                        | {
                            __typename?: "BasicLabel"
                            valueType: string
                            label?: any | null
                          }
                        | { __typename?: "BasicMediaPicker"; valueType: string }
                        | {
                            __typename?: "BasicMemberPicker"
                            valueType: string
                            members: Array<{
                              __typename?: "BasicMemberPickerItem"
                              id?: number | null
                              name?: string | null
                              properties: Array<{
                                __typename?: "BasicProperty"
                                alias?: string | null
                                editorAlias?: string | null
                                value?:
                                  | {
                                      __typename?: "BasicBlockGridModel"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicBlockListModel"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicContentPicker"
                                      model: string
                                      contentList: Array<{
                                        __typename?: "BasicContentPickerItem"
                                        id: number
                                        absoluteUrl: string
                                        key: any
                                        name?: string | null
                                        url: string
                                        urlSegment?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicDateTimePicker"
                                      model: string
                                      dateTime?: any | null
                                    }
                                  | {
                                      __typename?: "BasicLabel"
                                      model: string
                                      label?: any | null
                                    }
                                  | {
                                      __typename?: "BasicMediaPicker"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicMemberPicker"
                                      model: string
                                      members: Array<{
                                        __typename?: "BasicMemberPickerItem"
                                        id?: number | null
                                        name?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicMultiUrlPicker"
                                      model: string
                                      links: Array<{
                                        __typename?: "BasicMultiUrlPickerItem"
                                        name?: string | null
                                        target?: string | null
                                        type: LinkType
                                        url?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicNestedContent"
                                      model: string
                                      elements?: Array<{
                                        __typename?: "BasicNestedContentElement"
                                        properties: Array<{
                                          __typename?: "BasicProperty"
                                          alias?: string | null
                                          editorAlias?: string | null
                                          value?:
                                            | {
                                                __typename?: "BasicBlockGridModel"
                                                model: string
                                              }
                                            | {
                                                __typename?: "BasicBlockListModel"
                                                model: string
                                              }
                                            | {
                                                __typename?: "BasicContentPicker"
                                                model: string
                                                contentList: Array<{
                                                  __typename?: "BasicContentPickerItem"
                                                  id: number
                                                  absoluteUrl: string
                                                  key: any
                                                  name?: string | null
                                                  url: string
                                                  urlSegment?: string | null
                                                }>
                                              }
                                            | {
                                                __typename?: "BasicDateTimePicker"
                                                model: string
                                                dateTime?: any | null
                                              }
                                            | {
                                                __typename?: "BasicLabel"
                                                model: string
                                                label?: any | null
                                              }
                                            | {
                                                __typename?: "BasicMediaPicker"
                                                model: string
                                              }
                                            | {
                                                __typename?: "BasicMemberPicker"
                                                model: string
                                                members: Array<{
                                                  __typename?: "BasicMemberPickerItem"
                                                  id?: number | null
                                                  name?: string | null
                                                }>
                                              }
                                            | {
                                                __typename?: "BasicMultiUrlPicker"
                                                model: string
                                                links: Array<{
                                                  __typename?: "BasicMultiUrlPickerItem"
                                                  name?: string | null
                                                  target?: string | null
                                                  type: LinkType
                                                  url?: string | null
                                                }>
                                              }
                                            | {
                                                __typename?: "BasicNestedContent"
                                                model: string
                                              }
                                            | {
                                                __typename?: "BasicPropertyValue"
                                                model: string
                                                value?: any | null
                                              }
                                            | {
                                                __typename?: "BasicRichText"
                                                model: string
                                                richText?: string | null
                                              }
                                            | {
                                                __typename?: "BasicUnsupportedPropertyValue"
                                                model: string
                                                message: string
                                              }
                                            | {
                                                __typename?: "MintMediaPicker"
                                                model: string
                                                mediaItems: Array<{
                                                  __typename?: "MintMediaPickerItem"
                                                  id: number
                                                  url: string
                                                  altText?: string | null
                                                }>
                                              }
                                            | null
                                        } | null>
                                      }> | null
                                    }
                                  | {
                                      __typename?: "BasicPropertyValue"
                                      model: string
                                      value?: any | null
                                    }
                                  | {
                                      __typename?: "BasicRichText"
                                      model: string
                                      richText?: string | null
                                    }
                                  | {
                                      __typename?: "BasicUnsupportedPropertyValue"
                                      model: string
                                      message: string
                                    }
                                  | {
                                      __typename?: "MintMediaPicker"
                                      model: string
                                      mediaItems: Array<{
                                        __typename?: "MintMediaPickerItem"
                                        id: number
                                        url: string
                                        altText?: string | null
                                      }>
                                    }
                                  | null
                              } | null>
                            }>
                          }
                        | {
                            __typename?: "BasicMultiUrlPicker"
                            valueType: string
                            links: Array<{
                              __typename?: "BasicMultiUrlPickerItem"
                              name?: string | null
                              target?: string | null
                              type: LinkType
                              url?: string | null
                            }>
                          }
                        | {
                            __typename?: "BasicNestedContent"
                            valueType: string
                            elements?: Array<{
                              __typename?: "BasicNestedContentElement"
                              properties: Array<{
                                __typename?: "BasicProperty"
                                alias?: string | null
                                editorAlias?: string | null
                                value?:
                                  | {
                                      __typename?: "BasicBlockGridModel"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicBlockListModel"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicContentPicker"
                                      model: string
                                      contentList: Array<{
                                        __typename?: "BasicContentPickerItem"
                                        id: number
                                        absoluteUrl: string
                                        key: any
                                        name?: string | null
                                        url: string
                                        urlSegment?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicDateTimePicker"
                                      model: string
                                      dateTime?: any | null
                                    }
                                  | {
                                      __typename?: "BasicLabel"
                                      model: string
                                      label?: any | null
                                    }
                                  | {
                                      __typename?: "BasicMediaPicker"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicMemberPicker"
                                      model: string
                                      members: Array<{
                                        __typename?: "BasicMemberPickerItem"
                                        id?: number | null
                                        name?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicMultiUrlPicker"
                                      model: string
                                      links: Array<{
                                        __typename?: "BasicMultiUrlPickerItem"
                                        name?: string | null
                                        target?: string | null
                                        type: LinkType
                                        url?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicNestedContent"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicPropertyValue"
                                      model: string
                                      value?: any | null
                                    }
                                  | {
                                      __typename?: "BasicRichText"
                                      model: string
                                      richText?: string | null
                                    }
                                  | {
                                      __typename?: "BasicUnsupportedPropertyValue"
                                      model: string
                                      message: string
                                    }
                                  | {
                                      __typename?: "MintMediaPicker"
                                      model: string
                                      mediaItems: Array<{
                                        __typename?: "MintMediaPickerItem"
                                        id: number
                                        url: string
                                        altText?: string | null
                                      }>
                                    }
                                  | null
                              } | null>
                            }> | null
                          }
                        | {
                            __typename?: "BasicPropertyValue"
                            valueType: string
                            value?: any | null
                          }
                        | {
                            __typename?: "BasicRichText"
                            valueType: string
                            richText?: string | null
                          }
                        | {
                            __typename?: "BasicUnsupportedPropertyValue"
                            message: string
                            valueType: string
                          }
                        | {
                            __typename?: "MintMediaPicker"
                            valueType: string
                            mediaItems: Array<{
                              __typename?: "MintMediaPickerItem"
                              id: number
                              url: string
                              altText?: string | null
                            }>
                          }
                        | null
                    } | null>
                    settingsProperties: Array<{
                      __typename?: "BasicProperty"
                      value?:
                        | {
                            __typename?: "BasicBlockGridModel"
                            valueType: string
                          }
                        | {
                            __typename?: "BasicBlockListModel"
                            valueType: string
                          }
                        | {
                            __typename?: "BasicContentPicker"
                            valueType: string
                            contentList: Array<{
                              __typename?: "BasicContentPickerItem"
                              id: number
                              absoluteUrl: string
                              key: any
                              name?: string | null
                              url: string
                              urlSegment?: string | null
                            }>
                          }
                        | {
                            __typename?: "BasicDateTimePicker"
                            valueType: string
                            dateTime?: any | null
                          }
                        | {
                            __typename?: "BasicLabel"
                            valueType: string
                            label?: any | null
                          }
                        | { __typename?: "BasicMediaPicker"; valueType: string }
                        | {
                            __typename?: "BasicMemberPicker"
                            valueType: string
                            members: Array<{
                              __typename?: "BasicMemberPickerItem"
                              id?: number | null
                              name?: string | null
                              properties: Array<{
                                __typename?: "BasicProperty"
                                alias?: string | null
                                editorAlias?: string | null
                                value?:
                                  | {
                                      __typename?: "BasicBlockGridModel"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicBlockListModel"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicContentPicker"
                                      model: string
                                      contentList: Array<{
                                        __typename?: "BasicContentPickerItem"
                                        id: number
                                        absoluteUrl: string
                                        key: any
                                        name?: string | null
                                        url: string
                                        urlSegment?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicDateTimePicker"
                                      model: string
                                      dateTime?: any | null
                                    }
                                  | {
                                      __typename?: "BasicLabel"
                                      model: string
                                      label?: any | null
                                    }
                                  | {
                                      __typename?: "BasicMediaPicker"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicMemberPicker"
                                      model: string
                                      members: Array<{
                                        __typename?: "BasicMemberPickerItem"
                                        id?: number | null
                                        name?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicMultiUrlPicker"
                                      model: string
                                      links: Array<{
                                        __typename?: "BasicMultiUrlPickerItem"
                                        name?: string | null
                                        target?: string | null
                                        type: LinkType
                                        url?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicNestedContent"
                                      model: string
                                      elements?: Array<{
                                        __typename?: "BasicNestedContentElement"
                                        properties: Array<{
                                          __typename?: "BasicProperty"
                                          alias?: string | null
                                          editorAlias?: string | null
                                          value?:
                                            | {
                                                __typename?: "BasicBlockGridModel"
                                                model: string
                                              }
                                            | {
                                                __typename?: "BasicBlockListModel"
                                                model: string
                                              }
                                            | {
                                                __typename?: "BasicContentPicker"
                                                model: string
                                                contentList: Array<{
                                                  __typename?: "BasicContentPickerItem"
                                                  id: number
                                                  absoluteUrl: string
                                                  key: any
                                                  name?: string | null
                                                  url: string
                                                  urlSegment?: string | null
                                                }>
                                              }
                                            | {
                                                __typename?: "BasicDateTimePicker"
                                                model: string
                                                dateTime?: any | null
                                              }
                                            | {
                                                __typename?: "BasicLabel"
                                                model: string
                                                label?: any | null
                                              }
                                            | {
                                                __typename?: "BasicMediaPicker"
                                                model: string
                                              }
                                            | {
                                                __typename?: "BasicMemberPicker"
                                                model: string
                                                members: Array<{
                                                  __typename?: "BasicMemberPickerItem"
                                                  id?: number | null
                                                  name?: string | null
                                                }>
                                              }
                                            | {
                                                __typename?: "BasicMultiUrlPicker"
                                                model: string
                                                links: Array<{
                                                  __typename?: "BasicMultiUrlPickerItem"
                                                  name?: string | null
                                                  target?: string | null
                                                  type: LinkType
                                                  url?: string | null
                                                }>
                                              }
                                            | {
                                                __typename?: "BasicNestedContent"
                                                model: string
                                              }
                                            | {
                                                __typename?: "BasicPropertyValue"
                                                model: string
                                                value?: any | null
                                              }
                                            | {
                                                __typename?: "BasicRichText"
                                                model: string
                                                richText?: string | null
                                              }
                                            | {
                                                __typename?: "BasicUnsupportedPropertyValue"
                                                model: string
                                                message: string
                                              }
                                            | {
                                                __typename?: "MintMediaPicker"
                                                model: string
                                                mediaItems: Array<{
                                                  __typename?: "MintMediaPickerItem"
                                                  id: number
                                                  url: string
                                                  altText?: string | null
                                                }>
                                              }
                                            | null
                                        } | null>
                                      }> | null
                                    }
                                  | {
                                      __typename?: "BasicPropertyValue"
                                      model: string
                                      value?: any | null
                                    }
                                  | {
                                      __typename?: "BasicRichText"
                                      model: string
                                      richText?: string | null
                                    }
                                  | {
                                      __typename?: "BasicUnsupportedPropertyValue"
                                      model: string
                                      message: string
                                    }
                                  | {
                                      __typename?: "MintMediaPicker"
                                      model: string
                                      mediaItems: Array<{
                                        __typename?: "MintMediaPickerItem"
                                        id: number
                                        url: string
                                        altText?: string | null
                                      }>
                                    }
                                  | null
                              } | null>
                            }>
                          }
                        | {
                            __typename?: "BasicMultiUrlPicker"
                            valueType: string
                            links: Array<{
                              __typename?: "BasicMultiUrlPickerItem"
                              name?: string | null
                              target?: string | null
                              type: LinkType
                              url?: string | null
                            }>
                          }
                        | {
                            __typename?: "BasicNestedContent"
                            valueType: string
                            elements?: Array<{
                              __typename?: "BasicNestedContentElement"
                              properties: Array<{
                                __typename?: "BasicProperty"
                                alias?: string | null
                                editorAlias?: string | null
                                value?:
                                  | {
                                      __typename?: "BasicBlockGridModel"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicBlockListModel"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicContentPicker"
                                      model: string
                                      contentList: Array<{
                                        __typename?: "BasicContentPickerItem"
                                        id: number
                                        absoluteUrl: string
                                        key: any
                                        name?: string | null
                                        url: string
                                        urlSegment?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicDateTimePicker"
                                      model: string
                                      dateTime?: any | null
                                    }
                                  | {
                                      __typename?: "BasicLabel"
                                      model: string
                                      label?: any | null
                                    }
                                  | {
                                      __typename?: "BasicMediaPicker"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicMemberPicker"
                                      model: string
                                      members: Array<{
                                        __typename?: "BasicMemberPickerItem"
                                        id?: number | null
                                        name?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicMultiUrlPicker"
                                      model: string
                                      links: Array<{
                                        __typename?: "BasicMultiUrlPickerItem"
                                        name?: string | null
                                        target?: string | null
                                        type: LinkType
                                        url?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicNestedContent"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicPropertyValue"
                                      model: string
                                      value?: any | null
                                    }
                                  | {
                                      __typename?: "BasicRichText"
                                      model: string
                                      richText?: string | null
                                    }
                                  | {
                                      __typename?: "BasicUnsupportedPropertyValue"
                                      model: string
                                      message: string
                                    }
                                  | {
                                      __typename?: "MintMediaPicker"
                                      model: string
                                      mediaItems: Array<{
                                        __typename?: "MintMediaPickerItem"
                                        id: number
                                        url: string
                                        altText?: string | null
                                      }>
                                    }
                                  | null
                              } | null>
                            }> | null
                          }
                        | {
                            __typename?: "BasicPropertyValue"
                            valueType: string
                            value?: any | null
                          }
                        | {
                            __typename?: "BasicRichText"
                            valueType: string
                            richText?: string | null
                          }
                        | {
                            __typename?: "BasicUnsupportedPropertyValue"
                            message: string
                            valueType: string
                          }
                        | {
                            __typename?: "MintMediaPicker"
                            valueType: string
                            mediaItems: Array<{
                              __typename?: "MintMediaPickerItem"
                              id: number
                              url: string
                              altText?: string | null
                            }>
                          }
                        | null
                    } | null>
                    areas: Array<{
                      __typename?: "BasicBlockGridArea"
                      alias?: string | null
                      rowSpan: number
                      columnSpan: number
                    } | null>
                  }> | null
                } | null>
              }> | null
            }
          | {
              __typename?: "BasicBlockListModel"
              valueType: string
              blocks?: Array<{
                __typename?: "BasicBlockListItem"
                blockType?: string | null
                properties: Array<{
                  __typename?: "BasicProperty"
                  propertyName?: string | null
                  propertyValue?:
                    | { __typename?: "BasicBlockGridModel"; valueType: string }
                    | {
                        __typename?: "BasicBlockListModel"
                        valueType: string
                        blocks?: Array<{
                          __typename?: "BasicBlockListItem"
                          blockType?: string | null
                          properties: Array<{
                            __typename?: "BasicProperty"
                            propertyName?: string | null
                            propertyValue?:
                              | {
                                  __typename?: "BasicBlockGridModel"
                                  valueType: string
                                }
                              | {
                                  __typename?: "BasicBlockListModel"
                                  valueType: string
                                  blocks?: Array<{
                                    __typename?: "BasicBlockListItem"
                                    blockType?: string | null
                                    properties: Array<{
                                      __typename?: "BasicProperty"
                                      propertyName?: string | null
                                      propertyValue?:
                                        | {
                                            __typename?: "BasicBlockGridModel"
                                            valueType: string
                                          }
                                        | {
                                            __typename?: "BasicBlockListModel"
                                            valueType: string
                                            blocks?: Array<{
                                              __typename?: "BasicBlockListItem"
                                              blockType?: string | null
                                              properties: Array<{
                                                __typename?: "BasicProperty"
                                                propertyName?: string | null
                                                propertyValue?:
                                                  | {
                                                      __typename?: "BasicBlockGridModel"
                                                      valueType: string
                                                    }
                                                  | {
                                                      __typename?: "BasicBlockListModel"
                                                      valueType: string
                                                      blocks?: Array<{
                                                        __typename?: "BasicBlockListItem"
                                                        blockType?:
                                                          | string
                                                          | null
                                                        properties: Array<{
                                                          __typename?: "BasicProperty"
                                                          propertyName?:
                                                            | string
                                                            | null
                                                          propertyValue?:
                                                            | {
                                                                __typename?: "BasicBlockGridModel"
                                                                valueType: string
                                                              }
                                                            | {
                                                                __typename?: "BasicBlockListModel"
                                                                valueType: string
                                                              }
                                                            | {
                                                                __typename?: "BasicContentPicker"
                                                                valueType: string
                                                                contentList: Array<{
                                                                  __typename?: "BasicContentPickerItem"
                                                                  id: number
                                                                  absoluteUrl: string
                                                                  key: any
                                                                  name?:
                                                                    | string
                                                                    | null
                                                                  url: string
                                                                  urlSegment?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | {
                                                                __typename?: "BasicDateTimePicker"
                                                                valueType: string
                                                                dateTime?:
                                                                  | any
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicLabel"
                                                                valueType: string
                                                                label?:
                                                                  | any
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicMediaPicker"
                                                                valueType: string
                                                              }
                                                            | {
                                                                __typename?: "BasicMemberPicker"
                                                                valueType: string
                                                                members: Array<{
                                                                  __typename?: "BasicMemberPickerItem"
                                                                  id?:
                                                                    | number
                                                                    | null
                                                                  name?:
                                                                    | string
                                                                    | null
                                                                  properties: Array<{
                                                                    __typename?: "BasicProperty"
                                                                    alias?:
                                                                      | string
                                                                      | null
                                                                    editorAlias?:
                                                                      | string
                                                                      | null
                                                                    value?:
                                                                      | {
                                                                          __typename?: "BasicBlockGridModel"
                                                                          model: string
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicBlockListModel"
                                                                          model: string
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicContentPicker"
                                                                          model: string
                                                                          contentList: Array<{
                                                                            __typename?: "BasicContentPickerItem"
                                                                            id: number
                                                                            absoluteUrl: string
                                                                            key: any
                                                                            name?:
                                                                              | string
                                                                              | null
                                                                            url: string
                                                                            urlSegment?:
                                                                              | string
                                                                              | null
                                                                          }>
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicDateTimePicker"
                                                                          model: string
                                                                          dateTime?:
                                                                            | any
                                                                            | null
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicLabel"
                                                                          model: string
                                                                          label?:
                                                                            | any
                                                                            | null
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicMediaPicker"
                                                                          model: string
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicMemberPicker"
                                                                          model: string
                                                                          members: Array<{
                                                                            __typename?: "BasicMemberPickerItem"
                                                                            id?:
                                                                              | number
                                                                              | null
                                                                            name?:
                                                                              | string
                                                                              | null
                                                                          }>
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicMultiUrlPicker"
                                                                          model: string
                                                                          links: Array<{
                                                                            __typename?: "BasicMultiUrlPickerItem"
                                                                            name?:
                                                                              | string
                                                                              | null
                                                                            target?:
                                                                              | string
                                                                              | null
                                                                            type: LinkType
                                                                            url?:
                                                                              | string
                                                                              | null
                                                                          }>
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicNestedContent"
                                                                          model: string
                                                                          elements?: Array<{
                                                                            __typename?: "BasicNestedContentElement"
                                                                            properties: Array<{
                                                                              __typename?: "BasicProperty"
                                                                              alias?:
                                                                                | string
                                                                                | null
                                                                              editorAlias?:
                                                                                | string
                                                                                | null
                                                                              value?:
                                                                                | {
                                                                                    __typename?: "BasicBlockGridModel"
                                                                                    model: string
                                                                                  }
                                                                                | {
                                                                                    __typename?: "BasicBlockListModel"
                                                                                    model: string
                                                                                  }
                                                                                | {
                                                                                    __typename?: "BasicContentPicker"
                                                                                    model: string
                                                                                    contentList: Array<{
                                                                                      __typename?: "BasicContentPickerItem"
                                                                                      id: number
                                                                                      absoluteUrl: string
                                                                                      key: any
                                                                                      name?:
                                                                                        | string
                                                                                        | null
                                                                                      url: string
                                                                                      urlSegment?:
                                                                                        | string
                                                                                        | null
                                                                                    }>
                                                                                  }
                                                                                | {
                                                                                    __typename?: "BasicDateTimePicker"
                                                                                    model: string
                                                                                    dateTime?:
                                                                                      | any
                                                                                      | null
                                                                                  }
                                                                                | {
                                                                                    __typename?: "BasicLabel"
                                                                                    model: string
                                                                                    label?:
                                                                                      | any
                                                                                      | null
                                                                                  }
                                                                                | {
                                                                                    __typename?: "BasicMediaPicker"
                                                                                    model: string
                                                                                  }
                                                                                | {
                                                                                    __typename?: "BasicMemberPicker"
                                                                                    model: string
                                                                                    members: Array<{
                                                                                      __typename?: "BasicMemberPickerItem"
                                                                                      id?:
                                                                                        | number
                                                                                        | null
                                                                                      name?:
                                                                                        | string
                                                                                        | null
                                                                                    }>
                                                                                  }
                                                                                | {
                                                                                    __typename?: "BasicMultiUrlPicker"
                                                                                    model: string
                                                                                    links: Array<{
                                                                                      __typename?: "BasicMultiUrlPickerItem"
                                                                                      name?:
                                                                                        | string
                                                                                        | null
                                                                                      target?:
                                                                                        | string
                                                                                        | null
                                                                                      type: LinkType
                                                                                      url?:
                                                                                        | string
                                                                                        | null
                                                                                    }>
                                                                                  }
                                                                                | {
                                                                                    __typename?: "BasicNestedContent"
                                                                                    model: string
                                                                                  }
                                                                                | {
                                                                                    __typename?: "BasicPropertyValue"
                                                                                    model: string
                                                                                    value?:
                                                                                      | any
                                                                                      | null
                                                                                  }
                                                                                | {
                                                                                    __typename?: "BasicRichText"
                                                                                    model: string
                                                                                    richText?:
                                                                                      | string
                                                                                      | null
                                                                                  }
                                                                                | {
                                                                                    __typename?: "BasicUnsupportedPropertyValue"
                                                                                    model: string
                                                                                    message: string
                                                                                  }
                                                                                | {
                                                                                    __typename?: "MintMediaPicker"
                                                                                    model: string
                                                                                    mediaItems: Array<{
                                                                                      __typename?: "MintMediaPickerItem"
                                                                                      id: number
                                                                                      url: string
                                                                                      altText?:
                                                                                        | string
                                                                                        | null
                                                                                    }>
                                                                                  }
                                                                                | null
                                                                            } | null>
                                                                          }> | null
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicPropertyValue"
                                                                          model: string
                                                                          value?:
                                                                            | any
                                                                            | null
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicRichText"
                                                                          model: string
                                                                          richText?:
                                                                            | string
                                                                            | null
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicUnsupportedPropertyValue"
                                                                          model: string
                                                                          message: string
                                                                        }
                                                                      | {
                                                                          __typename?: "MintMediaPicker"
                                                                          model: string
                                                                          mediaItems: Array<{
                                                                            __typename?: "MintMediaPickerItem"
                                                                            id: number
                                                                            url: string
                                                                            altText?:
                                                                              | string
                                                                              | null
                                                                          }>
                                                                        }
                                                                      | null
                                                                  } | null>
                                                                }>
                                                              }
                                                            | {
                                                                __typename?: "BasicMultiUrlPicker"
                                                                valueType: string
                                                                links: Array<{
                                                                  __typename?: "BasicMultiUrlPickerItem"
                                                                  name?:
                                                                    | string
                                                                    | null
                                                                  target?:
                                                                    | string
                                                                    | null
                                                                  type: LinkType
                                                                  url?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | {
                                                                __typename?: "BasicNestedContent"
                                                                valueType: string
                                                                elements?: Array<{
                                                                  __typename?: "BasicNestedContentElement"
                                                                  properties: Array<{
                                                                    __typename?: "BasicProperty"
                                                                    alias?:
                                                                      | string
                                                                      | null
                                                                    editorAlias?:
                                                                      | string
                                                                      | null
                                                                    value?:
                                                                      | {
                                                                          __typename?: "BasicBlockGridModel"
                                                                          model: string
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicBlockListModel"
                                                                          model: string
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicContentPicker"
                                                                          model: string
                                                                          contentList: Array<{
                                                                            __typename?: "BasicContentPickerItem"
                                                                            id: number
                                                                            absoluteUrl: string
                                                                            key: any
                                                                            name?:
                                                                              | string
                                                                              | null
                                                                            url: string
                                                                            urlSegment?:
                                                                              | string
                                                                              | null
                                                                          }>
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicDateTimePicker"
                                                                          model: string
                                                                          dateTime?:
                                                                            | any
                                                                            | null
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicLabel"
                                                                          model: string
                                                                          label?:
                                                                            | any
                                                                            | null
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicMediaPicker"
                                                                          model: string
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicMemberPicker"
                                                                          model: string
                                                                          members: Array<{
                                                                            __typename?: "BasicMemberPickerItem"
                                                                            id?:
                                                                              | number
                                                                              | null
                                                                            name?:
                                                                              | string
                                                                              | null
                                                                          }>
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicMultiUrlPicker"
                                                                          model: string
                                                                          links: Array<{
                                                                            __typename?: "BasicMultiUrlPickerItem"
                                                                            name?:
                                                                              | string
                                                                              | null
                                                                            target?:
                                                                              | string
                                                                              | null
                                                                            type: LinkType
                                                                            url?:
                                                                              | string
                                                                              | null
                                                                          }>
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicNestedContent"
                                                                          model: string
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicPropertyValue"
                                                                          model: string
                                                                          value?:
                                                                            | any
                                                                            | null
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicRichText"
                                                                          model: string
                                                                          richText?:
                                                                            | string
                                                                            | null
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicUnsupportedPropertyValue"
                                                                          model: string
                                                                          message: string
                                                                        }
                                                                      | {
                                                                          __typename?: "MintMediaPicker"
                                                                          model: string
                                                                          mediaItems: Array<{
                                                                            __typename?: "MintMediaPickerItem"
                                                                            id: number
                                                                            url: string
                                                                            altText?:
                                                                              | string
                                                                              | null
                                                                          }>
                                                                        }
                                                                      | null
                                                                  } | null>
                                                                }> | null
                                                              }
                                                            | {
                                                                __typename?: "BasicPropertyValue"
                                                                valueType: string
                                                                value?:
                                                                  | any
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicRichText"
                                                                valueType: string
                                                                richText?:
                                                                  | string
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicUnsupportedPropertyValue"
                                                                message: string
                                                                valueType: string
                                                              }
                                                            | {
                                                                __typename?: "MintMediaPicker"
                                                                valueType: string
                                                                mediaItems: Array<{
                                                                  __typename?: "MintMediaPickerItem"
                                                                  id: number
                                                                  url: string
                                                                  altText?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | null
                                                        } | null>
                                                      }> | null
                                                    }
                                                  | {
                                                      __typename?: "BasicContentPicker"
                                                      valueType: string
                                                      contentList: Array<{
                                                        __typename?: "BasicContentPickerItem"
                                                        id: number
                                                        absoluteUrl: string
                                                        key: any
                                                        name?: string | null
                                                        url: string
                                                        urlSegment?:
                                                          | string
                                                          | null
                                                      }>
                                                    }
                                                  | {
                                                      __typename?: "BasicDateTimePicker"
                                                      valueType: string
                                                      dateTime?: any | null
                                                    }
                                                  | {
                                                      __typename?: "BasicLabel"
                                                      valueType: string
                                                      label?: any | null
                                                    }
                                                  | {
                                                      __typename?: "BasicMediaPicker"
                                                      valueType: string
                                                    }
                                                  | {
                                                      __typename?: "BasicMemberPicker"
                                                      valueType: string
                                                      members: Array<{
                                                        __typename?: "BasicMemberPickerItem"
                                                        id?: number | null
                                                        name?: string | null
                                                        properties: Array<{
                                                          __typename?: "BasicProperty"
                                                          alias?: string | null
                                                          editorAlias?:
                                                            | string
                                                            | null
                                                          value?:
                                                            | {
                                                                __typename?: "BasicBlockGridModel"
                                                                model: string
                                                              }
                                                            | {
                                                                __typename?: "BasicBlockListModel"
                                                                model: string
                                                              }
                                                            | {
                                                                __typename?: "BasicContentPicker"
                                                                model: string
                                                                contentList: Array<{
                                                                  __typename?: "BasicContentPickerItem"
                                                                  id: number
                                                                  absoluteUrl: string
                                                                  key: any
                                                                  name?:
                                                                    | string
                                                                    | null
                                                                  url: string
                                                                  urlSegment?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | {
                                                                __typename?: "BasicDateTimePicker"
                                                                model: string
                                                                dateTime?:
                                                                  | any
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicLabel"
                                                                model: string
                                                                label?:
                                                                  | any
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicMediaPicker"
                                                                model: string
                                                              }
                                                            | {
                                                                __typename?: "BasicMemberPicker"
                                                                model: string
                                                                members: Array<{
                                                                  __typename?: "BasicMemberPickerItem"
                                                                  id?:
                                                                    | number
                                                                    | null
                                                                  name?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | {
                                                                __typename?: "BasicMultiUrlPicker"
                                                                model: string
                                                                links: Array<{
                                                                  __typename?: "BasicMultiUrlPickerItem"
                                                                  name?:
                                                                    | string
                                                                    | null
                                                                  target?:
                                                                    | string
                                                                    | null
                                                                  type: LinkType
                                                                  url?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | {
                                                                __typename?: "BasicNestedContent"
                                                                model: string
                                                                elements?: Array<{
                                                                  __typename?: "BasicNestedContentElement"
                                                                  properties: Array<{
                                                                    __typename?: "BasicProperty"
                                                                    alias?:
                                                                      | string
                                                                      | null
                                                                    editorAlias?:
                                                                      | string
                                                                      | null
                                                                    value?:
                                                                      | {
                                                                          __typename?: "BasicBlockGridModel"
                                                                          model: string
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicBlockListModel"
                                                                          model: string
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicContentPicker"
                                                                          model: string
                                                                          contentList: Array<{
                                                                            __typename?: "BasicContentPickerItem"
                                                                            id: number
                                                                            absoluteUrl: string
                                                                            key: any
                                                                            name?:
                                                                              | string
                                                                              | null
                                                                            url: string
                                                                            urlSegment?:
                                                                              | string
                                                                              | null
                                                                          }>
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicDateTimePicker"
                                                                          model: string
                                                                          dateTime?:
                                                                            | any
                                                                            | null
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicLabel"
                                                                          model: string
                                                                          label?:
                                                                            | any
                                                                            | null
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicMediaPicker"
                                                                          model: string
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicMemberPicker"
                                                                          model: string
                                                                          members: Array<{
                                                                            __typename?: "BasicMemberPickerItem"
                                                                            id?:
                                                                              | number
                                                                              | null
                                                                            name?:
                                                                              | string
                                                                              | null
                                                                          }>
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicMultiUrlPicker"
                                                                          model: string
                                                                          links: Array<{
                                                                            __typename?: "BasicMultiUrlPickerItem"
                                                                            name?:
                                                                              | string
                                                                              | null
                                                                            target?:
                                                                              | string
                                                                              | null
                                                                            type: LinkType
                                                                            url?:
                                                                              | string
                                                                              | null
                                                                          }>
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicNestedContent"
                                                                          model: string
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicPropertyValue"
                                                                          model: string
                                                                          value?:
                                                                            | any
                                                                            | null
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicRichText"
                                                                          model: string
                                                                          richText?:
                                                                            | string
                                                                            | null
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicUnsupportedPropertyValue"
                                                                          model: string
                                                                          message: string
                                                                        }
                                                                      | {
                                                                          __typename?: "MintMediaPicker"
                                                                          model: string
                                                                          mediaItems: Array<{
                                                                            __typename?: "MintMediaPickerItem"
                                                                            id: number
                                                                            url: string
                                                                            altText?:
                                                                              | string
                                                                              | null
                                                                          }>
                                                                        }
                                                                      | null
                                                                  } | null>
                                                                }> | null
                                                              }
                                                            | {
                                                                __typename?: "BasicPropertyValue"
                                                                model: string
                                                                value?:
                                                                  | any
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicRichText"
                                                                model: string
                                                                richText?:
                                                                  | string
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicUnsupportedPropertyValue"
                                                                model: string
                                                                message: string
                                                              }
                                                            | {
                                                                __typename?: "MintMediaPicker"
                                                                model: string
                                                                mediaItems: Array<{
                                                                  __typename?: "MintMediaPickerItem"
                                                                  id: number
                                                                  url: string
                                                                  altText?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | null
                                                        } | null>
                                                      }>
                                                    }
                                                  | {
                                                      __typename?: "BasicMultiUrlPicker"
                                                      valueType: string
                                                      links: Array<{
                                                        __typename?: "BasicMultiUrlPickerItem"
                                                        name?: string | null
                                                        target?: string | null
                                                        type: LinkType
                                                        url?: string | null
                                                      }>
                                                    }
                                                  | {
                                                      __typename?: "BasicNestedContent"
                                                      valueType: string
                                                      elements?: Array<{
                                                        __typename?: "BasicNestedContentElement"
                                                        properties: Array<{
                                                          __typename?: "BasicProperty"
                                                          alias?: string | null
                                                          editorAlias?:
                                                            | string
                                                            | null
                                                          value?:
                                                            | {
                                                                __typename?: "BasicBlockGridModel"
                                                                model: string
                                                              }
                                                            | {
                                                                __typename?: "BasicBlockListModel"
                                                                model: string
                                                              }
                                                            | {
                                                                __typename?: "BasicContentPicker"
                                                                model: string
                                                                contentList: Array<{
                                                                  __typename?: "BasicContentPickerItem"
                                                                  id: number
                                                                  absoluteUrl: string
                                                                  key: any
                                                                  name?:
                                                                    | string
                                                                    | null
                                                                  url: string
                                                                  urlSegment?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | {
                                                                __typename?: "BasicDateTimePicker"
                                                                model: string
                                                                dateTime?:
                                                                  | any
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicLabel"
                                                                model: string
                                                                label?:
                                                                  | any
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicMediaPicker"
                                                                model: string
                                                              }
                                                            | {
                                                                __typename?: "BasicMemberPicker"
                                                                model: string
                                                                members: Array<{
                                                                  __typename?: "BasicMemberPickerItem"
                                                                  id?:
                                                                    | number
                                                                    | null
                                                                  name?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | {
                                                                __typename?: "BasicMultiUrlPicker"
                                                                model: string
                                                                links: Array<{
                                                                  __typename?: "BasicMultiUrlPickerItem"
                                                                  name?:
                                                                    | string
                                                                    | null
                                                                  target?:
                                                                    | string
                                                                    | null
                                                                  type: LinkType
                                                                  url?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | {
                                                                __typename?: "BasicNestedContent"
                                                                model: string
                                                              }
                                                            | {
                                                                __typename?: "BasicPropertyValue"
                                                                model: string
                                                                value?:
                                                                  | any
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicRichText"
                                                                model: string
                                                                richText?:
                                                                  | string
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicUnsupportedPropertyValue"
                                                                model: string
                                                                message: string
                                                              }
                                                            | {
                                                                __typename?: "MintMediaPicker"
                                                                model: string
                                                                mediaItems: Array<{
                                                                  __typename?: "MintMediaPickerItem"
                                                                  id: number
                                                                  url: string
                                                                  altText?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | null
                                                        } | null>
                                                      }> | null
                                                    }
                                                  | {
                                                      __typename?: "BasicPropertyValue"
                                                      valueType: string
                                                      value?: any | null
                                                    }
                                                  | {
                                                      __typename?: "BasicRichText"
                                                      valueType: string
                                                      richText?: string | null
                                                    }
                                                  | {
                                                      __typename?: "BasicUnsupportedPropertyValue"
                                                      message: string
                                                      valueType: string
                                                    }
                                                  | {
                                                      __typename?: "MintMediaPicker"
                                                      valueType: string
                                                      mediaItems: Array<{
                                                        __typename?: "MintMediaPickerItem"
                                                        id: number
                                                        url: string
                                                        altText?: string | null
                                                      }>
                                                    }
                                                  | null
                                              } | null>
                                            }> | null
                                          }
                                        | {
                                            __typename?: "BasicContentPicker"
                                            valueType: string
                                            contentList: Array<{
                                              __typename?: "BasicContentPickerItem"
                                              id: number
                                              absoluteUrl: string
                                              key: any
                                              name?: string | null
                                              url: string
                                              urlSegment?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicDateTimePicker"
                                            valueType: string
                                            dateTime?: any | null
                                          }
                                        | {
                                            __typename?: "BasicLabel"
                                            valueType: string
                                            label?: any | null
                                          }
                                        | {
                                            __typename?: "BasicMediaPicker"
                                            valueType: string
                                          }
                                        | {
                                            __typename?: "BasicMemberPicker"
                                            valueType: string
                                            members: Array<{
                                              __typename?: "BasicMemberPickerItem"
                                              id?: number | null
                                              name?: string | null
                                              properties: Array<{
                                                __typename?: "BasicProperty"
                                                alias?: string | null
                                                editorAlias?: string | null
                                                value?:
                                                  | {
                                                      __typename?: "BasicBlockGridModel"
                                                      model: string
                                                    }
                                                  | {
                                                      __typename?: "BasicBlockListModel"
                                                      model: string
                                                    }
                                                  | {
                                                      __typename?: "BasicContentPicker"
                                                      model: string
                                                      contentList: Array<{
                                                        __typename?: "BasicContentPickerItem"
                                                        id: number
                                                        absoluteUrl: string
                                                        key: any
                                                        name?: string | null
                                                        url: string
                                                        urlSegment?:
                                                          | string
                                                          | null
                                                      }>
                                                    }
                                                  | {
                                                      __typename?: "BasicDateTimePicker"
                                                      model: string
                                                      dateTime?: any | null
                                                    }
                                                  | {
                                                      __typename?: "BasicLabel"
                                                      model: string
                                                      label?: any | null
                                                    }
                                                  | {
                                                      __typename?: "BasicMediaPicker"
                                                      model: string
                                                    }
                                                  | {
                                                      __typename?: "BasicMemberPicker"
                                                      model: string
                                                      members: Array<{
                                                        __typename?: "BasicMemberPickerItem"
                                                        id?: number | null
                                                        name?: string | null
                                                      }>
                                                    }
                                                  | {
                                                      __typename?: "BasicMultiUrlPicker"
                                                      model: string
                                                      links: Array<{
                                                        __typename?: "BasicMultiUrlPickerItem"
                                                        name?: string | null
                                                        target?: string | null
                                                        type: LinkType
                                                        url?: string | null
                                                      }>
                                                    }
                                                  | {
                                                      __typename?: "BasicNestedContent"
                                                      model: string
                                                      elements?: Array<{
                                                        __typename?: "BasicNestedContentElement"
                                                        properties: Array<{
                                                          __typename?: "BasicProperty"
                                                          alias?: string | null
                                                          editorAlias?:
                                                            | string
                                                            | null
                                                          value?:
                                                            | {
                                                                __typename?: "BasicBlockGridModel"
                                                                model: string
                                                              }
                                                            | {
                                                                __typename?: "BasicBlockListModel"
                                                                model: string
                                                              }
                                                            | {
                                                                __typename?: "BasicContentPicker"
                                                                model: string
                                                                contentList: Array<{
                                                                  __typename?: "BasicContentPickerItem"
                                                                  id: number
                                                                  absoluteUrl: string
                                                                  key: any
                                                                  name?:
                                                                    | string
                                                                    | null
                                                                  url: string
                                                                  urlSegment?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | {
                                                                __typename?: "BasicDateTimePicker"
                                                                model: string
                                                                dateTime?:
                                                                  | any
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicLabel"
                                                                model: string
                                                                label?:
                                                                  | any
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicMediaPicker"
                                                                model: string
                                                              }
                                                            | {
                                                                __typename?: "BasicMemberPicker"
                                                                model: string
                                                                members: Array<{
                                                                  __typename?: "BasicMemberPickerItem"
                                                                  id?:
                                                                    | number
                                                                    | null
                                                                  name?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | {
                                                                __typename?: "BasicMultiUrlPicker"
                                                                model: string
                                                                links: Array<{
                                                                  __typename?: "BasicMultiUrlPickerItem"
                                                                  name?:
                                                                    | string
                                                                    | null
                                                                  target?:
                                                                    | string
                                                                    | null
                                                                  type: LinkType
                                                                  url?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | {
                                                                __typename?: "BasicNestedContent"
                                                                model: string
                                                              }
                                                            | {
                                                                __typename?: "BasicPropertyValue"
                                                                model: string
                                                                value?:
                                                                  | any
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicRichText"
                                                                model: string
                                                                richText?:
                                                                  | string
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicUnsupportedPropertyValue"
                                                                model: string
                                                                message: string
                                                              }
                                                            | {
                                                                __typename?: "MintMediaPicker"
                                                                model: string
                                                                mediaItems: Array<{
                                                                  __typename?: "MintMediaPickerItem"
                                                                  id: number
                                                                  url: string
                                                                  altText?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | null
                                                        } | null>
                                                      }> | null
                                                    }
                                                  | {
                                                      __typename?: "BasicPropertyValue"
                                                      model: string
                                                      value?: any | null
                                                    }
                                                  | {
                                                      __typename?: "BasicRichText"
                                                      model: string
                                                      richText?: string | null
                                                    }
                                                  | {
                                                      __typename?: "BasicUnsupportedPropertyValue"
                                                      model: string
                                                      message: string
                                                    }
                                                  | {
                                                      __typename?: "MintMediaPicker"
                                                      model: string
                                                      mediaItems: Array<{
                                                        __typename?: "MintMediaPickerItem"
                                                        id: number
                                                        url: string
                                                        altText?: string | null
                                                      }>
                                                    }
                                                  | null
                                              } | null>
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicMultiUrlPicker"
                                            valueType: string
                                            links: Array<{
                                              __typename?: "BasicMultiUrlPickerItem"
                                              name?: string | null
                                              target?: string | null
                                              type: LinkType
                                              url?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicNestedContent"
                                            valueType: string
                                            elements?: Array<{
                                              __typename?: "BasicNestedContentElement"
                                              properties: Array<{
                                                __typename?: "BasicProperty"
                                                alias?: string | null
                                                editorAlias?: string | null
                                                value?:
                                                  | {
                                                      __typename?: "BasicBlockGridModel"
                                                      model: string
                                                    }
                                                  | {
                                                      __typename?: "BasicBlockListModel"
                                                      model: string
                                                    }
                                                  | {
                                                      __typename?: "BasicContentPicker"
                                                      model: string
                                                      contentList: Array<{
                                                        __typename?: "BasicContentPickerItem"
                                                        id: number
                                                        absoluteUrl: string
                                                        key: any
                                                        name?: string | null
                                                        url: string
                                                        urlSegment?:
                                                          | string
                                                          | null
                                                      }>
                                                    }
                                                  | {
                                                      __typename?: "BasicDateTimePicker"
                                                      model: string
                                                      dateTime?: any | null
                                                    }
                                                  | {
                                                      __typename?: "BasicLabel"
                                                      model: string
                                                      label?: any | null
                                                    }
                                                  | {
                                                      __typename?: "BasicMediaPicker"
                                                      model: string
                                                    }
                                                  | {
                                                      __typename?: "BasicMemberPicker"
                                                      model: string
                                                      members: Array<{
                                                        __typename?: "BasicMemberPickerItem"
                                                        id?: number | null
                                                        name?: string | null
                                                      }>
                                                    }
                                                  | {
                                                      __typename?: "BasicMultiUrlPicker"
                                                      model: string
                                                      links: Array<{
                                                        __typename?: "BasicMultiUrlPickerItem"
                                                        name?: string | null
                                                        target?: string | null
                                                        type: LinkType
                                                        url?: string | null
                                                      }>
                                                    }
                                                  | {
                                                      __typename?: "BasicNestedContent"
                                                      model: string
                                                    }
                                                  | {
                                                      __typename?: "BasicPropertyValue"
                                                      model: string
                                                      value?: any | null
                                                    }
                                                  | {
                                                      __typename?: "BasicRichText"
                                                      model: string
                                                      richText?: string | null
                                                    }
                                                  | {
                                                      __typename?: "BasicUnsupportedPropertyValue"
                                                      model: string
                                                      message: string
                                                    }
                                                  | {
                                                      __typename?: "MintMediaPicker"
                                                      model: string
                                                      mediaItems: Array<{
                                                        __typename?: "MintMediaPickerItem"
                                                        id: number
                                                        url: string
                                                        altText?: string | null
                                                      }>
                                                    }
                                                  | null
                                              } | null>
                                            }> | null
                                          }
                                        | {
                                            __typename?: "BasicPropertyValue"
                                            valueType: string
                                            value?: any | null
                                          }
                                        | {
                                            __typename?: "BasicRichText"
                                            valueType: string
                                            richText?: string | null
                                          }
                                        | {
                                            __typename?: "BasicUnsupportedPropertyValue"
                                            message: string
                                            valueType: string
                                          }
                                        | {
                                            __typename?: "MintMediaPicker"
                                            valueType: string
                                            mediaItems: Array<{
                                              __typename?: "MintMediaPickerItem"
                                              id: number
                                              url: string
                                              altText?: string | null
                                            }>
                                          }
                                        | null
                                    } | null>
                                  }> | null
                                }
                              | {
                                  __typename?: "BasicContentPicker"
                                  valueType: string
                                  contentList: Array<{
                                    __typename?: "BasicContentPickerItem"
                                    id: number
                                    absoluteUrl: string
                                    key: any
                                    name?: string | null
                                    url: string
                                    urlSegment?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicDateTimePicker"
                                  valueType: string
                                  dateTime?: any | null
                                }
                              | {
                                  __typename?: "BasicLabel"
                                  valueType: string
                                  label?: any | null
                                }
                              | {
                                  __typename?: "BasicMediaPicker"
                                  valueType: string
                                }
                              | {
                                  __typename?: "BasicMemberPicker"
                                  valueType: string
                                  members: Array<{
                                    __typename?: "BasicMemberPickerItem"
                                    id?: number | null
                                    name?: string | null
                                    properties: Array<{
                                      __typename?: "BasicProperty"
                                      alias?: string | null
                                      editorAlias?: string | null
                                      value?:
                                        | {
                                            __typename?: "BasicBlockGridModel"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicBlockListModel"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicContentPicker"
                                            model: string
                                            contentList: Array<{
                                              __typename?: "BasicContentPickerItem"
                                              id: number
                                              absoluteUrl: string
                                              key: any
                                              name?: string | null
                                              url: string
                                              urlSegment?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicDateTimePicker"
                                            model: string
                                            dateTime?: any | null
                                          }
                                        | {
                                            __typename?: "BasicLabel"
                                            model: string
                                            label?: any | null
                                          }
                                        | {
                                            __typename?: "BasicMediaPicker"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicMemberPicker"
                                            model: string
                                            members: Array<{
                                              __typename?: "BasicMemberPickerItem"
                                              id?: number | null
                                              name?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicMultiUrlPicker"
                                            model: string
                                            links: Array<{
                                              __typename?: "BasicMultiUrlPickerItem"
                                              name?: string | null
                                              target?: string | null
                                              type: LinkType
                                              url?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicNestedContent"
                                            model: string
                                            elements?: Array<{
                                              __typename?: "BasicNestedContentElement"
                                              properties: Array<{
                                                __typename?: "BasicProperty"
                                                alias?: string | null
                                                editorAlias?: string | null
                                                value?:
                                                  | {
                                                      __typename?: "BasicBlockGridModel"
                                                      model: string
                                                    }
                                                  | {
                                                      __typename?: "BasicBlockListModel"
                                                      model: string
                                                    }
                                                  | {
                                                      __typename?: "BasicContentPicker"
                                                      model: string
                                                      contentList: Array<{
                                                        __typename?: "BasicContentPickerItem"
                                                        id: number
                                                        absoluteUrl: string
                                                        key: any
                                                        name?: string | null
                                                        url: string
                                                        urlSegment?:
                                                          | string
                                                          | null
                                                      }>
                                                    }
                                                  | {
                                                      __typename?: "BasicDateTimePicker"
                                                      model: string
                                                      dateTime?: any | null
                                                    }
                                                  | {
                                                      __typename?: "BasicLabel"
                                                      model: string
                                                      label?: any | null
                                                    }
                                                  | {
                                                      __typename?: "BasicMediaPicker"
                                                      model: string
                                                    }
                                                  | {
                                                      __typename?: "BasicMemberPicker"
                                                      model: string
                                                      members: Array<{
                                                        __typename?: "BasicMemberPickerItem"
                                                        id?: number | null
                                                        name?: string | null
                                                      }>
                                                    }
                                                  | {
                                                      __typename?: "BasicMultiUrlPicker"
                                                      model: string
                                                      links: Array<{
                                                        __typename?: "BasicMultiUrlPickerItem"
                                                        name?: string | null
                                                        target?: string | null
                                                        type: LinkType
                                                        url?: string | null
                                                      }>
                                                    }
                                                  | {
                                                      __typename?: "BasicNestedContent"
                                                      model: string
                                                    }
                                                  | {
                                                      __typename?: "BasicPropertyValue"
                                                      model: string
                                                      value?: any | null
                                                    }
                                                  | {
                                                      __typename?: "BasicRichText"
                                                      model: string
                                                      richText?: string | null
                                                    }
                                                  | {
                                                      __typename?: "BasicUnsupportedPropertyValue"
                                                      model: string
                                                      message: string
                                                    }
                                                  | {
                                                      __typename?: "MintMediaPicker"
                                                      model: string
                                                      mediaItems: Array<{
                                                        __typename?: "MintMediaPickerItem"
                                                        id: number
                                                        url: string
                                                        altText?: string | null
                                                      }>
                                                    }
                                                  | null
                                              } | null>
                                            }> | null
                                          }
                                        | {
                                            __typename?: "BasicPropertyValue"
                                            model: string
                                            value?: any | null
                                          }
                                        | {
                                            __typename?: "BasicRichText"
                                            model: string
                                            richText?: string | null
                                          }
                                        | {
                                            __typename?: "BasicUnsupportedPropertyValue"
                                            model: string
                                            message: string
                                          }
                                        | {
                                            __typename?: "MintMediaPicker"
                                            model: string
                                            mediaItems: Array<{
                                              __typename?: "MintMediaPickerItem"
                                              id: number
                                              url: string
                                              altText?: string | null
                                            }>
                                          }
                                        | null
                                    } | null>
                                  }>
                                }
                              | {
                                  __typename?: "BasicMultiUrlPicker"
                                  valueType: string
                                  links: Array<{
                                    __typename?: "BasicMultiUrlPickerItem"
                                    name?: string | null
                                    target?: string | null
                                    type: LinkType
                                    url?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicNestedContent"
                                  valueType: string
                                  elements?: Array<{
                                    __typename?: "BasicNestedContentElement"
                                    properties: Array<{
                                      __typename?: "BasicProperty"
                                      alias?: string | null
                                      editorAlias?: string | null
                                      value?:
                                        | {
                                            __typename?: "BasicBlockGridModel"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicBlockListModel"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicContentPicker"
                                            model: string
                                            contentList: Array<{
                                              __typename?: "BasicContentPickerItem"
                                              id: number
                                              absoluteUrl: string
                                              key: any
                                              name?: string | null
                                              url: string
                                              urlSegment?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicDateTimePicker"
                                            model: string
                                            dateTime?: any | null
                                          }
                                        | {
                                            __typename?: "BasicLabel"
                                            model: string
                                            label?: any | null
                                          }
                                        | {
                                            __typename?: "BasicMediaPicker"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicMemberPicker"
                                            model: string
                                            members: Array<{
                                              __typename?: "BasicMemberPickerItem"
                                              id?: number | null
                                              name?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicMultiUrlPicker"
                                            model: string
                                            links: Array<{
                                              __typename?: "BasicMultiUrlPickerItem"
                                              name?: string | null
                                              target?: string | null
                                              type: LinkType
                                              url?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicNestedContent"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicPropertyValue"
                                            model: string
                                            value?: any | null
                                          }
                                        | {
                                            __typename?: "BasicRichText"
                                            model: string
                                            richText?: string | null
                                          }
                                        | {
                                            __typename?: "BasicUnsupportedPropertyValue"
                                            model: string
                                            message: string
                                          }
                                        | {
                                            __typename?: "MintMediaPicker"
                                            model: string
                                            mediaItems: Array<{
                                              __typename?: "MintMediaPickerItem"
                                              id: number
                                              url: string
                                              altText?: string | null
                                            }>
                                          }
                                        | null
                                    } | null>
                                  }> | null
                                }
                              | {
                                  __typename?: "BasicPropertyValue"
                                  valueType: string
                                  value?: any | null
                                }
                              | {
                                  __typename?: "BasicRichText"
                                  valueType: string
                                  richText?: string | null
                                }
                              | {
                                  __typename?: "BasicUnsupportedPropertyValue"
                                  message: string
                                  valueType: string
                                }
                              | {
                                  __typename?: "MintMediaPicker"
                                  valueType: string
                                  mediaItems: Array<{
                                    __typename?: "MintMediaPickerItem"
                                    id: number
                                    url: string
                                    altText?: string | null
                                  }>
                                }
                              | null
                          } | null>
                        }> | null
                      }
                    | {
                        __typename?: "BasicContentPicker"
                        valueType: string
                        contentList: Array<{
                          __typename?: "BasicContentPickerItem"
                          id: number
                          absoluteUrl: string
                          key: any
                          name?: string | null
                          url: string
                          urlSegment?: string | null
                        }>
                      }
                    | {
                        __typename?: "BasicDateTimePicker"
                        valueType: string
                        dateTime?: any | null
                      }
                    | {
                        __typename?: "BasicLabel"
                        valueType: string
                        label?: any | null
                      }
                    | { __typename?: "BasicMediaPicker"; valueType: string }
                    | {
                        __typename?: "BasicMemberPicker"
                        valueType: string
                        members: Array<{
                          __typename?: "BasicMemberPickerItem"
                          id?: number | null
                          name?: string | null
                          properties: Array<{
                            __typename?: "BasicProperty"
                            alias?: string | null
                            editorAlias?: string | null
                            value?:
                              | {
                                  __typename?: "BasicBlockGridModel"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicBlockListModel"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicContentPicker"
                                  model: string
                                  contentList: Array<{
                                    __typename?: "BasicContentPickerItem"
                                    id: number
                                    absoluteUrl: string
                                    key: any
                                    name?: string | null
                                    url: string
                                    urlSegment?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicDateTimePicker"
                                  model: string
                                  dateTime?: any | null
                                }
                              | {
                                  __typename?: "BasicLabel"
                                  model: string
                                  label?: any | null
                                }
                              | {
                                  __typename?: "BasicMediaPicker"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicMemberPicker"
                                  model: string
                                  members: Array<{
                                    __typename?: "BasicMemberPickerItem"
                                    id?: number | null
                                    name?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicMultiUrlPicker"
                                  model: string
                                  links: Array<{
                                    __typename?: "BasicMultiUrlPickerItem"
                                    name?: string | null
                                    target?: string | null
                                    type: LinkType
                                    url?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicNestedContent"
                                  model: string
                                  elements?: Array<{
                                    __typename?: "BasicNestedContentElement"
                                    properties: Array<{
                                      __typename?: "BasicProperty"
                                      alias?: string | null
                                      editorAlias?: string | null
                                      value?:
                                        | {
                                            __typename?: "BasicBlockGridModel"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicBlockListModel"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicContentPicker"
                                            model: string
                                            contentList: Array<{
                                              __typename?: "BasicContentPickerItem"
                                              id: number
                                              absoluteUrl: string
                                              key: any
                                              name?: string | null
                                              url: string
                                              urlSegment?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicDateTimePicker"
                                            model: string
                                            dateTime?: any | null
                                          }
                                        | {
                                            __typename?: "BasicLabel"
                                            model: string
                                            label?: any | null
                                          }
                                        | {
                                            __typename?: "BasicMediaPicker"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicMemberPicker"
                                            model: string
                                            members: Array<{
                                              __typename?: "BasicMemberPickerItem"
                                              id?: number | null
                                              name?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicMultiUrlPicker"
                                            model: string
                                            links: Array<{
                                              __typename?: "BasicMultiUrlPickerItem"
                                              name?: string | null
                                              target?: string | null
                                              type: LinkType
                                              url?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicNestedContent"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicPropertyValue"
                                            model: string
                                            value?: any | null
                                          }
                                        | {
                                            __typename?: "BasicRichText"
                                            model: string
                                            richText?: string | null
                                          }
                                        | {
                                            __typename?: "BasicUnsupportedPropertyValue"
                                            model: string
                                            message: string
                                          }
                                        | {
                                            __typename?: "MintMediaPicker"
                                            model: string
                                            mediaItems: Array<{
                                              __typename?: "MintMediaPickerItem"
                                              id: number
                                              url: string
                                              altText?: string | null
                                            }>
                                          }
                                        | null
                                    } | null>
                                  }> | null
                                }
                              | {
                                  __typename?: "BasicPropertyValue"
                                  model: string
                                  value?: any | null
                                }
                              | {
                                  __typename?: "BasicRichText"
                                  model: string
                                  richText?: string | null
                                }
                              | {
                                  __typename?: "BasicUnsupportedPropertyValue"
                                  model: string
                                  message: string
                                }
                              | {
                                  __typename?: "MintMediaPicker"
                                  model: string
                                  mediaItems: Array<{
                                    __typename?: "MintMediaPickerItem"
                                    id: number
                                    url: string
                                    altText?: string | null
                                  }>
                                }
                              | null
                          } | null>
                        }>
                      }
                    | {
                        __typename?: "BasicMultiUrlPicker"
                        valueType: string
                        links: Array<{
                          __typename?: "BasicMultiUrlPickerItem"
                          name?: string | null
                          target?: string | null
                          type: LinkType
                          url?: string | null
                        }>
                      }
                    | {
                        __typename?: "BasicNestedContent"
                        valueType: string
                        elements?: Array<{
                          __typename?: "BasicNestedContentElement"
                          properties: Array<{
                            __typename?: "BasicProperty"
                            alias?: string | null
                            editorAlias?: string | null
                            value?:
                              | {
                                  __typename?: "BasicBlockGridModel"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicBlockListModel"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicContentPicker"
                                  model: string
                                  contentList: Array<{
                                    __typename?: "BasicContentPickerItem"
                                    id: number
                                    absoluteUrl: string
                                    key: any
                                    name?: string | null
                                    url: string
                                    urlSegment?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicDateTimePicker"
                                  model: string
                                  dateTime?: any | null
                                }
                              | {
                                  __typename?: "BasicLabel"
                                  model: string
                                  label?: any | null
                                }
                              | {
                                  __typename?: "BasicMediaPicker"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicMemberPicker"
                                  model: string
                                  members: Array<{
                                    __typename?: "BasicMemberPickerItem"
                                    id?: number | null
                                    name?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicMultiUrlPicker"
                                  model: string
                                  links: Array<{
                                    __typename?: "BasicMultiUrlPickerItem"
                                    name?: string | null
                                    target?: string | null
                                    type: LinkType
                                    url?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicNestedContent"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicPropertyValue"
                                  model: string
                                  value?: any | null
                                }
                              | {
                                  __typename?: "BasicRichText"
                                  model: string
                                  richText?: string | null
                                }
                              | {
                                  __typename?: "BasicUnsupportedPropertyValue"
                                  model: string
                                  message: string
                                }
                              | {
                                  __typename?: "MintMediaPicker"
                                  model: string
                                  mediaItems: Array<{
                                    __typename?: "MintMediaPickerItem"
                                    id: number
                                    url: string
                                    altText?: string | null
                                  }>
                                }
                              | null
                          } | null>
                        }> | null
                      }
                    | {
                        __typename?: "BasicPropertyValue"
                        valueType: string
                        value?: any | null
                      }
                    | {
                        __typename?: "BasicRichText"
                        valueType: string
                        richText?: string | null
                      }
                    | {
                        __typename?: "BasicUnsupportedPropertyValue"
                        message: string
                        valueType: string
                      }
                    | {
                        __typename?: "MintMediaPicker"
                        valueType: string
                        mediaItems: Array<{
                          __typename?: "MintMediaPickerItem"
                          id: number
                          url: string
                          altText?: string | null
                        }>
                      }
                    | null
                } | null>
              }> | null
            }
          | {
              __typename?: "BasicContentPicker"
              valueType: string
              contentList: Array<{
                __typename?: "BasicContentPickerItem"
                id: number
                absoluteUrl: string
                key: any
                name?: string | null
                url: string
                urlSegment?: string | null
              }>
            }
          | {
              __typename?: "BasicDateTimePicker"
              valueType: string
              dateTime?: any | null
            }
          | { __typename?: "BasicLabel"; valueType: string; label?: any | null }
          | { __typename?: "BasicMediaPicker"; valueType: string }
          | {
              __typename?: "BasicMemberPicker"
              valueType: string
              members: Array<{
                __typename?: "BasicMemberPickerItem"
                id?: number | null
                name?: string | null
                properties: Array<{
                  __typename?: "BasicProperty"
                  alias?: string | null
                  editorAlias?: string | null
                  value?:
                    | { __typename?: "BasicBlockGridModel"; model: string }
                    | { __typename?: "BasicBlockListModel"; model: string }
                    | {
                        __typename?: "BasicContentPicker"
                        model: string
                        contentList: Array<{
                          __typename?: "BasicContentPickerItem"
                          id: number
                          absoluteUrl: string
                          key: any
                          name?: string | null
                          url: string
                          urlSegment?: string | null
                        }>
                      }
                    | {
                        __typename?: "BasicDateTimePicker"
                        model: string
                        dateTime?: any | null
                      }
                    | {
                        __typename?: "BasicLabel"
                        model: string
                        label?: any | null
                      }
                    | { __typename?: "BasicMediaPicker"; model: string }
                    | {
                        __typename?: "BasicMemberPicker"
                        model: string
                        members: Array<{
                          __typename?: "BasicMemberPickerItem"
                          id?: number | null
                          name?: string | null
                        }>
                      }
                    | {
                        __typename?: "BasicMultiUrlPicker"
                        model: string
                        links: Array<{
                          __typename?: "BasicMultiUrlPickerItem"
                          name?: string | null
                          target?: string | null
                          type: LinkType
                          url?: string | null
                        }>
                      }
                    | {
                        __typename?: "BasicNestedContent"
                        model: string
                        elements?: Array<{
                          __typename?: "BasicNestedContentElement"
                          properties: Array<{
                            __typename?: "BasicProperty"
                            alias?: string | null
                            editorAlias?: string | null
                            value?:
                              | {
                                  __typename?: "BasicBlockGridModel"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicBlockListModel"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicContentPicker"
                                  model: string
                                  contentList: Array<{
                                    __typename?: "BasicContentPickerItem"
                                    id: number
                                    absoluteUrl: string
                                    key: any
                                    name?: string | null
                                    url: string
                                    urlSegment?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicDateTimePicker"
                                  model: string
                                  dateTime?: any | null
                                }
                              | {
                                  __typename?: "BasicLabel"
                                  model: string
                                  label?: any | null
                                }
                              | {
                                  __typename?: "BasicMediaPicker"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicMemberPicker"
                                  model: string
                                  members: Array<{
                                    __typename?: "BasicMemberPickerItem"
                                    id?: number | null
                                    name?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicMultiUrlPicker"
                                  model: string
                                  links: Array<{
                                    __typename?: "BasicMultiUrlPickerItem"
                                    name?: string | null
                                    target?: string | null
                                    type: LinkType
                                    url?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicNestedContent"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicPropertyValue"
                                  model: string
                                  value?: any | null
                                }
                              | {
                                  __typename?: "BasicRichText"
                                  model: string
                                  richText?: string | null
                                }
                              | {
                                  __typename?: "BasicUnsupportedPropertyValue"
                                  model: string
                                  message: string
                                }
                              | {
                                  __typename?: "MintMediaPicker"
                                  model: string
                                  mediaItems: Array<{
                                    __typename?: "MintMediaPickerItem"
                                    id: number
                                    url: string
                                    altText?: string | null
                                  }>
                                }
                              | null
                          } | null>
                        }> | null
                      }
                    | {
                        __typename?: "BasicPropertyValue"
                        model: string
                        value?: any | null
                      }
                    | {
                        __typename?: "BasicRichText"
                        model: string
                        richText?: string | null
                      }
                    | {
                        __typename?: "BasicUnsupportedPropertyValue"
                        model: string
                        message: string
                      }
                    | {
                        __typename?: "MintMediaPicker"
                        model: string
                        mediaItems: Array<{
                          __typename?: "MintMediaPickerItem"
                          id: number
                          url: string
                          altText?: string | null
                        }>
                      }
                    | null
                } | null>
              }>
            }
          | {
              __typename?: "BasicMultiUrlPicker"
              valueType: string
              links: Array<{
                __typename?: "BasicMultiUrlPickerItem"
                name?: string | null
                target?: string | null
                type: LinkType
                url?: string | null
              }>
            }
          | {
              __typename?: "BasicNestedContent"
              valueType: string
              elements?: Array<{
                __typename?: "BasicNestedContentElement"
                properties: Array<{
                  __typename?: "BasicProperty"
                  alias?: string | null
                  editorAlias?: string | null
                  value?:
                    | { __typename?: "BasicBlockGridModel"; model: string }
                    | { __typename?: "BasicBlockListModel"; model: string }
                    | {
                        __typename?: "BasicContentPicker"
                        model: string
                        contentList: Array<{
                          __typename?: "BasicContentPickerItem"
                          id: number
                          absoluteUrl: string
                          key: any
                          name?: string | null
                          url: string
                          urlSegment?: string | null
                        }>
                      }
                    | {
                        __typename?: "BasicDateTimePicker"
                        model: string
                        dateTime?: any | null
                      }
                    | {
                        __typename?: "BasicLabel"
                        model: string
                        label?: any | null
                      }
                    | { __typename?: "BasicMediaPicker"; model: string }
                    | {
                        __typename?: "BasicMemberPicker"
                        model: string
                        members: Array<{
                          __typename?: "BasicMemberPickerItem"
                          id?: number | null
                          name?: string | null
                        }>
                      }
                    | {
                        __typename?: "BasicMultiUrlPicker"
                        model: string
                        links: Array<{
                          __typename?: "BasicMultiUrlPickerItem"
                          name?: string | null
                          target?: string | null
                          type: LinkType
                          url?: string | null
                        }>
                      }
                    | { __typename?: "BasicNestedContent"; model: string }
                    | {
                        __typename?: "BasicPropertyValue"
                        model: string
                        value?: any | null
                      }
                    | {
                        __typename?: "BasicRichText"
                        model: string
                        richText?: string | null
                      }
                    | {
                        __typename?: "BasicUnsupportedPropertyValue"
                        model: string
                        message: string
                      }
                    | {
                        __typename?: "MintMediaPicker"
                        model: string
                        mediaItems: Array<{
                          __typename?: "MintMediaPickerItem"
                          id: number
                          url: string
                          altText?: string | null
                        }>
                      }
                    | null
                } | null>
              }> | null
            }
          | {
              __typename?: "BasicPropertyValue"
              valueType: string
              value?: any | null
            }
          | {
              __typename?: "BasicRichText"
              valueType: string
              richText?: string | null
            }
          | {
              __typename?: "BasicUnsupportedPropertyValue"
              message: string
              valueType: string
            }
          | {
              __typename?: "MintMediaPicker"
              valueType: string
              mediaItems: Array<{
                __typename?: "MintMediaPickerItem"
                id: number
                url: string
                altText?: string | null
              }>
            }
          | null
      } | null> | null
    } | null
    contentType?: {
      __typename?: "BasicContentType"
      alias?: string | null
    } | null
    children?: Array<{
      __typename?: "BasicContent"
      name?: string | null
      url?: string | null
      id?: number | null
      contentType?: {
        __typename?: "BasicContentType"
        alias?: string | null
      } | null
      properties?: Array<{
        __typename?: "BasicProperty"
        propertyName?: string | null
        propertyValue?:
          | {
              __typename?: "BasicBlockGridModel"
              gridColumns?: number | null
              valueType: string
              blocks?: Array<{
                __typename?: "BasicBlockGridItem"
                columnSpan: number
                rowSpan: number
                contentProperties: Array<{
                  __typename?: "BasicProperty"
                  value?:
                    | { __typename?: "BasicBlockGridModel"; valueType: string }
                    | { __typename?: "BasicBlockListModel"; valueType: string }
                    | {
                        __typename?: "BasicContentPicker"
                        valueType: string
                        contentList: Array<{
                          __typename?: "BasicContentPickerItem"
                          id: number
                          absoluteUrl: string
                          key: any
                          name?: string | null
                          url: string
                          urlSegment?: string | null
                        }>
                      }
                    | {
                        __typename?: "BasicDateTimePicker"
                        valueType: string
                        dateTime?: any | null
                      }
                    | {
                        __typename?: "BasicLabel"
                        valueType: string
                        label?: any | null
                      }
                    | { __typename?: "BasicMediaPicker"; valueType: string }
                    | {
                        __typename?: "BasicMemberPicker"
                        valueType: string
                        members: Array<{
                          __typename?: "BasicMemberPickerItem"
                          id?: number | null
                          name?: string | null
                          properties: Array<{
                            __typename?: "BasicProperty"
                            alias?: string | null
                            editorAlias?: string | null
                            value?:
                              | {
                                  __typename?: "BasicBlockGridModel"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicBlockListModel"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicContentPicker"
                                  model: string
                                  contentList: Array<{
                                    __typename?: "BasicContentPickerItem"
                                    id: number
                                    absoluteUrl: string
                                    key: any
                                    name?: string | null
                                    url: string
                                    urlSegment?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicDateTimePicker"
                                  model: string
                                  dateTime?: any | null
                                }
                              | {
                                  __typename?: "BasicLabel"
                                  model: string
                                  label?: any | null
                                }
                              | {
                                  __typename?: "BasicMediaPicker"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicMemberPicker"
                                  model: string
                                  members: Array<{
                                    __typename?: "BasicMemberPickerItem"
                                    id?: number | null
                                    name?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicMultiUrlPicker"
                                  model: string
                                  links: Array<{
                                    __typename?: "BasicMultiUrlPickerItem"
                                    name?: string | null
                                    target?: string | null
                                    type: LinkType
                                    url?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicNestedContent"
                                  model: string
                                  elements?: Array<{
                                    __typename?: "BasicNestedContentElement"
                                    properties: Array<{
                                      __typename?: "BasicProperty"
                                      alias?: string | null
                                      editorAlias?: string | null
                                      value?:
                                        | {
                                            __typename?: "BasicBlockGridModel"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicBlockListModel"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicContentPicker"
                                            model: string
                                            contentList: Array<{
                                              __typename?: "BasicContentPickerItem"
                                              id: number
                                              absoluteUrl: string
                                              key: any
                                              name?: string | null
                                              url: string
                                              urlSegment?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicDateTimePicker"
                                            model: string
                                            dateTime?: any | null
                                          }
                                        | {
                                            __typename?: "BasicLabel"
                                            model: string
                                            label?: any | null
                                          }
                                        | {
                                            __typename?: "BasicMediaPicker"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicMemberPicker"
                                            model: string
                                            members: Array<{
                                              __typename?: "BasicMemberPickerItem"
                                              id?: number | null
                                              name?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicMultiUrlPicker"
                                            model: string
                                            links: Array<{
                                              __typename?: "BasicMultiUrlPickerItem"
                                              name?: string | null
                                              target?: string | null
                                              type: LinkType
                                              url?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicNestedContent"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicPropertyValue"
                                            model: string
                                            value?: any | null
                                          }
                                        | {
                                            __typename?: "BasicRichText"
                                            model: string
                                            richText?: string | null
                                          }
                                        | {
                                            __typename?: "BasicUnsupportedPropertyValue"
                                            model: string
                                            message: string
                                          }
                                        | {
                                            __typename?: "MintMediaPicker"
                                            model: string
                                            mediaItems: Array<{
                                              __typename?: "MintMediaPickerItem"
                                              id: number
                                              url: string
                                              altText?: string | null
                                            }>
                                          }
                                        | null
                                    } | null>
                                  }> | null
                                }
                              | {
                                  __typename?: "BasicPropertyValue"
                                  model: string
                                  value?: any | null
                                }
                              | {
                                  __typename?: "BasicRichText"
                                  model: string
                                  richText?: string | null
                                }
                              | {
                                  __typename?: "BasicUnsupportedPropertyValue"
                                  model: string
                                  message: string
                                }
                              | {
                                  __typename?: "MintMediaPicker"
                                  model: string
                                  mediaItems: Array<{
                                    __typename?: "MintMediaPickerItem"
                                    id: number
                                    url: string
                                    altText?: string | null
                                  }>
                                }
                              | null
                          } | null>
                        }>
                      }
                    | {
                        __typename?: "BasicMultiUrlPicker"
                        valueType: string
                        links: Array<{
                          __typename?: "BasicMultiUrlPickerItem"
                          name?: string | null
                          target?: string | null
                          type: LinkType
                          url?: string | null
                        }>
                      }
                    | {
                        __typename?: "BasicNestedContent"
                        valueType: string
                        elements?: Array<{
                          __typename?: "BasicNestedContentElement"
                          properties: Array<{
                            __typename?: "BasicProperty"
                            alias?: string | null
                            editorAlias?: string | null
                            value?:
                              | {
                                  __typename?: "BasicBlockGridModel"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicBlockListModel"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicContentPicker"
                                  model: string
                                  contentList: Array<{
                                    __typename?: "BasicContentPickerItem"
                                    id: number
                                    absoluteUrl: string
                                    key: any
                                    name?: string | null
                                    url: string
                                    urlSegment?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicDateTimePicker"
                                  model: string
                                  dateTime?: any | null
                                }
                              | {
                                  __typename?: "BasicLabel"
                                  model: string
                                  label?: any | null
                                }
                              | {
                                  __typename?: "BasicMediaPicker"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicMemberPicker"
                                  model: string
                                  members: Array<{
                                    __typename?: "BasicMemberPickerItem"
                                    id?: number | null
                                    name?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicMultiUrlPicker"
                                  model: string
                                  links: Array<{
                                    __typename?: "BasicMultiUrlPickerItem"
                                    name?: string | null
                                    target?: string | null
                                    type: LinkType
                                    url?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicNestedContent"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicPropertyValue"
                                  model: string
                                  value?: any | null
                                }
                              | {
                                  __typename?: "BasicRichText"
                                  model: string
                                  richText?: string | null
                                }
                              | {
                                  __typename?: "BasicUnsupportedPropertyValue"
                                  model: string
                                  message: string
                                }
                              | {
                                  __typename?: "MintMediaPicker"
                                  model: string
                                  mediaItems: Array<{
                                    __typename?: "MintMediaPickerItem"
                                    id: number
                                    url: string
                                    altText?: string | null
                                  }>
                                }
                              | null
                          } | null>
                        }> | null
                      }
                    | {
                        __typename?: "BasicPropertyValue"
                        valueType: string
                        value?: any | null
                      }
                    | {
                        __typename?: "BasicRichText"
                        valueType: string
                        richText?: string | null
                      }
                    | {
                        __typename?: "BasicUnsupportedPropertyValue"
                        message: string
                        valueType: string
                      }
                    | {
                        __typename?: "MintMediaPicker"
                        valueType: string
                        mediaItems: Array<{
                          __typename?: "MintMediaPickerItem"
                          id: number
                          url: string
                          altText?: string | null
                        }>
                      }
                    | null
                } | null>
                settingsProperties: Array<{
                  __typename?: "BasicProperty"
                  value?:
                    | { __typename?: "BasicBlockGridModel"; valueType: string }
                    | { __typename?: "BasicBlockListModel"; valueType: string }
                    | {
                        __typename?: "BasicContentPicker"
                        valueType: string
                        contentList: Array<{
                          __typename?: "BasicContentPickerItem"
                          id: number
                          absoluteUrl: string
                          key: any
                          name?: string | null
                          url: string
                          urlSegment?: string | null
                        }>
                      }
                    | {
                        __typename?: "BasicDateTimePicker"
                        valueType: string
                        dateTime?: any | null
                      }
                    | {
                        __typename?: "BasicLabel"
                        valueType: string
                        label?: any | null
                      }
                    | { __typename?: "BasicMediaPicker"; valueType: string }
                    | {
                        __typename?: "BasicMemberPicker"
                        valueType: string
                        members: Array<{
                          __typename?: "BasicMemberPickerItem"
                          id?: number | null
                          name?: string | null
                          properties: Array<{
                            __typename?: "BasicProperty"
                            alias?: string | null
                            editorAlias?: string | null
                            value?:
                              | {
                                  __typename?: "BasicBlockGridModel"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicBlockListModel"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicContentPicker"
                                  model: string
                                  contentList: Array<{
                                    __typename?: "BasicContentPickerItem"
                                    id: number
                                    absoluteUrl: string
                                    key: any
                                    name?: string | null
                                    url: string
                                    urlSegment?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicDateTimePicker"
                                  model: string
                                  dateTime?: any | null
                                }
                              | {
                                  __typename?: "BasicLabel"
                                  model: string
                                  label?: any | null
                                }
                              | {
                                  __typename?: "BasicMediaPicker"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicMemberPicker"
                                  model: string
                                  members: Array<{
                                    __typename?: "BasicMemberPickerItem"
                                    id?: number | null
                                    name?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicMultiUrlPicker"
                                  model: string
                                  links: Array<{
                                    __typename?: "BasicMultiUrlPickerItem"
                                    name?: string | null
                                    target?: string | null
                                    type: LinkType
                                    url?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicNestedContent"
                                  model: string
                                  elements?: Array<{
                                    __typename?: "BasicNestedContentElement"
                                    properties: Array<{
                                      __typename?: "BasicProperty"
                                      alias?: string | null
                                      editorAlias?: string | null
                                      value?:
                                        | {
                                            __typename?: "BasicBlockGridModel"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicBlockListModel"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicContentPicker"
                                            model: string
                                            contentList: Array<{
                                              __typename?: "BasicContentPickerItem"
                                              id: number
                                              absoluteUrl: string
                                              key: any
                                              name?: string | null
                                              url: string
                                              urlSegment?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicDateTimePicker"
                                            model: string
                                            dateTime?: any | null
                                          }
                                        | {
                                            __typename?: "BasicLabel"
                                            model: string
                                            label?: any | null
                                          }
                                        | {
                                            __typename?: "BasicMediaPicker"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicMemberPicker"
                                            model: string
                                            members: Array<{
                                              __typename?: "BasicMemberPickerItem"
                                              id?: number | null
                                              name?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicMultiUrlPicker"
                                            model: string
                                            links: Array<{
                                              __typename?: "BasicMultiUrlPickerItem"
                                              name?: string | null
                                              target?: string | null
                                              type: LinkType
                                              url?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicNestedContent"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicPropertyValue"
                                            model: string
                                            value?: any | null
                                          }
                                        | {
                                            __typename?: "BasicRichText"
                                            model: string
                                            richText?: string | null
                                          }
                                        | {
                                            __typename?: "BasicUnsupportedPropertyValue"
                                            model: string
                                            message: string
                                          }
                                        | {
                                            __typename?: "MintMediaPicker"
                                            model: string
                                            mediaItems: Array<{
                                              __typename?: "MintMediaPickerItem"
                                              id: number
                                              url: string
                                              altText?: string | null
                                            }>
                                          }
                                        | null
                                    } | null>
                                  }> | null
                                }
                              | {
                                  __typename?: "BasicPropertyValue"
                                  model: string
                                  value?: any | null
                                }
                              | {
                                  __typename?: "BasicRichText"
                                  model: string
                                  richText?: string | null
                                }
                              | {
                                  __typename?: "BasicUnsupportedPropertyValue"
                                  model: string
                                  message: string
                                }
                              | {
                                  __typename?: "MintMediaPicker"
                                  model: string
                                  mediaItems: Array<{
                                    __typename?: "MintMediaPickerItem"
                                    id: number
                                    url: string
                                    altText?: string | null
                                  }>
                                }
                              | null
                          } | null>
                        }>
                      }
                    | {
                        __typename?: "BasicMultiUrlPicker"
                        valueType: string
                        links: Array<{
                          __typename?: "BasicMultiUrlPickerItem"
                          name?: string | null
                          target?: string | null
                          type: LinkType
                          url?: string | null
                        }>
                      }
                    | {
                        __typename?: "BasicNestedContent"
                        valueType: string
                        elements?: Array<{
                          __typename?: "BasicNestedContentElement"
                          properties: Array<{
                            __typename?: "BasicProperty"
                            alias?: string | null
                            editorAlias?: string | null
                            value?:
                              | {
                                  __typename?: "BasicBlockGridModel"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicBlockListModel"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicContentPicker"
                                  model: string
                                  contentList: Array<{
                                    __typename?: "BasicContentPickerItem"
                                    id: number
                                    absoluteUrl: string
                                    key: any
                                    name?: string | null
                                    url: string
                                    urlSegment?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicDateTimePicker"
                                  model: string
                                  dateTime?: any | null
                                }
                              | {
                                  __typename?: "BasicLabel"
                                  model: string
                                  label?: any | null
                                }
                              | {
                                  __typename?: "BasicMediaPicker"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicMemberPicker"
                                  model: string
                                  members: Array<{
                                    __typename?: "BasicMemberPickerItem"
                                    id?: number | null
                                    name?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicMultiUrlPicker"
                                  model: string
                                  links: Array<{
                                    __typename?: "BasicMultiUrlPickerItem"
                                    name?: string | null
                                    target?: string | null
                                    type: LinkType
                                    url?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicNestedContent"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicPropertyValue"
                                  model: string
                                  value?: any | null
                                }
                              | {
                                  __typename?: "BasicRichText"
                                  model: string
                                  richText?: string | null
                                }
                              | {
                                  __typename?: "BasicUnsupportedPropertyValue"
                                  model: string
                                  message: string
                                }
                              | {
                                  __typename?: "MintMediaPicker"
                                  model: string
                                  mediaItems: Array<{
                                    __typename?: "MintMediaPickerItem"
                                    id: number
                                    url: string
                                    altText?: string | null
                                  }>
                                }
                              | null
                          } | null>
                        }> | null
                      }
                    | {
                        __typename?: "BasicPropertyValue"
                        valueType: string
                        value?: any | null
                      }
                    | {
                        __typename?: "BasicRichText"
                        valueType: string
                        richText?: string | null
                      }
                    | {
                        __typename?: "BasicUnsupportedPropertyValue"
                        message: string
                        valueType: string
                      }
                    | {
                        __typename?: "MintMediaPicker"
                        valueType: string
                        mediaItems: Array<{
                          __typename?: "MintMediaPickerItem"
                          id: number
                          url: string
                          altText?: string | null
                        }>
                      }
                    | null
                } | null>
                areas: Array<{
                  __typename?: "BasicBlockGridArea"
                  alias?: string | null
                  rowSpan: number
                  columnSpan: number
                  blocks?: Array<{
                    __typename?: "BasicBlockGridItem"
                    columnSpan: number
                    rowSpan: number
                    contentProperties: Array<{
                      __typename?: "BasicProperty"
                      value?:
                        | {
                            __typename?: "BasicBlockGridModel"
                            valueType: string
                          }
                        | {
                            __typename?: "BasicBlockListModel"
                            valueType: string
                          }
                        | {
                            __typename?: "BasicContentPicker"
                            valueType: string
                            contentList: Array<{
                              __typename?: "BasicContentPickerItem"
                              id: number
                              absoluteUrl: string
                              key: any
                              name?: string | null
                              url: string
                              urlSegment?: string | null
                            }>
                          }
                        | {
                            __typename?: "BasicDateTimePicker"
                            valueType: string
                            dateTime?: any | null
                          }
                        | {
                            __typename?: "BasicLabel"
                            valueType: string
                            label?: any | null
                          }
                        | { __typename?: "BasicMediaPicker"; valueType: string }
                        | {
                            __typename?: "BasicMemberPicker"
                            valueType: string
                            members: Array<{
                              __typename?: "BasicMemberPickerItem"
                              id?: number | null
                              name?: string | null
                              properties: Array<{
                                __typename?: "BasicProperty"
                                alias?: string | null
                                editorAlias?: string | null
                                value?:
                                  | {
                                      __typename?: "BasicBlockGridModel"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicBlockListModel"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicContentPicker"
                                      model: string
                                      contentList: Array<{
                                        __typename?: "BasicContentPickerItem"
                                        id: number
                                        absoluteUrl: string
                                        key: any
                                        name?: string | null
                                        url: string
                                        urlSegment?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicDateTimePicker"
                                      model: string
                                      dateTime?: any | null
                                    }
                                  | {
                                      __typename?: "BasicLabel"
                                      model: string
                                      label?: any | null
                                    }
                                  | {
                                      __typename?: "BasicMediaPicker"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicMemberPicker"
                                      model: string
                                      members: Array<{
                                        __typename?: "BasicMemberPickerItem"
                                        id?: number | null
                                        name?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicMultiUrlPicker"
                                      model: string
                                      links: Array<{
                                        __typename?: "BasicMultiUrlPickerItem"
                                        name?: string | null
                                        target?: string | null
                                        type: LinkType
                                        url?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicNestedContent"
                                      model: string
                                      elements?: Array<{
                                        __typename?: "BasicNestedContentElement"
                                        properties: Array<{
                                          __typename?: "BasicProperty"
                                          alias?: string | null
                                          editorAlias?: string | null
                                          value?:
                                            | {
                                                __typename?: "BasicBlockGridModel"
                                                model: string
                                              }
                                            | {
                                                __typename?: "BasicBlockListModel"
                                                model: string
                                              }
                                            | {
                                                __typename?: "BasicContentPicker"
                                                model: string
                                                contentList: Array<{
                                                  __typename?: "BasicContentPickerItem"
                                                  id: number
                                                  absoluteUrl: string
                                                  key: any
                                                  name?: string | null
                                                  url: string
                                                  urlSegment?: string | null
                                                }>
                                              }
                                            | {
                                                __typename?: "BasicDateTimePicker"
                                                model: string
                                                dateTime?: any | null
                                              }
                                            | {
                                                __typename?: "BasicLabel"
                                                model: string
                                                label?: any | null
                                              }
                                            | {
                                                __typename?: "BasicMediaPicker"
                                                model: string
                                              }
                                            | {
                                                __typename?: "BasicMemberPicker"
                                                model: string
                                                members: Array<{
                                                  __typename?: "BasicMemberPickerItem"
                                                  id?: number | null
                                                  name?: string | null
                                                }>
                                              }
                                            | {
                                                __typename?: "BasicMultiUrlPicker"
                                                model: string
                                                links: Array<{
                                                  __typename?: "BasicMultiUrlPickerItem"
                                                  name?: string | null
                                                  target?: string | null
                                                  type: LinkType
                                                  url?: string | null
                                                }>
                                              }
                                            | {
                                                __typename?: "BasicNestedContent"
                                                model: string
                                              }
                                            | {
                                                __typename?: "BasicPropertyValue"
                                                model: string
                                                value?: any | null
                                              }
                                            | {
                                                __typename?: "BasicRichText"
                                                model: string
                                                richText?: string | null
                                              }
                                            | {
                                                __typename?: "BasicUnsupportedPropertyValue"
                                                model: string
                                                message: string
                                              }
                                            | {
                                                __typename?: "MintMediaPicker"
                                                model: string
                                                mediaItems: Array<{
                                                  __typename?: "MintMediaPickerItem"
                                                  id: number
                                                  url: string
                                                  altText?: string | null
                                                }>
                                              }
                                            | null
                                        } | null>
                                      }> | null
                                    }
                                  | {
                                      __typename?: "BasicPropertyValue"
                                      model: string
                                      value?: any | null
                                    }
                                  | {
                                      __typename?: "BasicRichText"
                                      model: string
                                      richText?: string | null
                                    }
                                  | {
                                      __typename?: "BasicUnsupportedPropertyValue"
                                      model: string
                                      message: string
                                    }
                                  | {
                                      __typename?: "MintMediaPicker"
                                      model: string
                                      mediaItems: Array<{
                                        __typename?: "MintMediaPickerItem"
                                        id: number
                                        url: string
                                        altText?: string | null
                                      }>
                                    }
                                  | null
                              } | null>
                            }>
                          }
                        | {
                            __typename?: "BasicMultiUrlPicker"
                            valueType: string
                            links: Array<{
                              __typename?: "BasicMultiUrlPickerItem"
                              name?: string | null
                              target?: string | null
                              type: LinkType
                              url?: string | null
                            }>
                          }
                        | {
                            __typename?: "BasicNestedContent"
                            valueType: string
                            elements?: Array<{
                              __typename?: "BasicNestedContentElement"
                              properties: Array<{
                                __typename?: "BasicProperty"
                                alias?: string | null
                                editorAlias?: string | null
                                value?:
                                  | {
                                      __typename?: "BasicBlockGridModel"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicBlockListModel"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicContentPicker"
                                      model: string
                                      contentList: Array<{
                                        __typename?: "BasicContentPickerItem"
                                        id: number
                                        absoluteUrl: string
                                        key: any
                                        name?: string | null
                                        url: string
                                        urlSegment?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicDateTimePicker"
                                      model: string
                                      dateTime?: any | null
                                    }
                                  | {
                                      __typename?: "BasicLabel"
                                      model: string
                                      label?: any | null
                                    }
                                  | {
                                      __typename?: "BasicMediaPicker"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicMemberPicker"
                                      model: string
                                      members: Array<{
                                        __typename?: "BasicMemberPickerItem"
                                        id?: number | null
                                        name?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicMultiUrlPicker"
                                      model: string
                                      links: Array<{
                                        __typename?: "BasicMultiUrlPickerItem"
                                        name?: string | null
                                        target?: string | null
                                        type: LinkType
                                        url?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicNestedContent"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicPropertyValue"
                                      model: string
                                      value?: any | null
                                    }
                                  | {
                                      __typename?: "BasicRichText"
                                      model: string
                                      richText?: string | null
                                    }
                                  | {
                                      __typename?: "BasicUnsupportedPropertyValue"
                                      model: string
                                      message: string
                                    }
                                  | {
                                      __typename?: "MintMediaPicker"
                                      model: string
                                      mediaItems: Array<{
                                        __typename?: "MintMediaPickerItem"
                                        id: number
                                        url: string
                                        altText?: string | null
                                      }>
                                    }
                                  | null
                              } | null>
                            }> | null
                          }
                        | {
                            __typename?: "BasicPropertyValue"
                            valueType: string
                            value?: any | null
                          }
                        | {
                            __typename?: "BasicRichText"
                            valueType: string
                            richText?: string | null
                          }
                        | {
                            __typename?: "BasicUnsupportedPropertyValue"
                            message: string
                            valueType: string
                          }
                        | {
                            __typename?: "MintMediaPicker"
                            valueType: string
                            mediaItems: Array<{
                              __typename?: "MintMediaPickerItem"
                              id: number
                              url: string
                              altText?: string | null
                            }>
                          }
                        | null
                    } | null>
                    settingsProperties: Array<{
                      __typename?: "BasicProperty"
                      value?:
                        | {
                            __typename?: "BasicBlockGridModel"
                            valueType: string
                          }
                        | {
                            __typename?: "BasicBlockListModel"
                            valueType: string
                          }
                        | {
                            __typename?: "BasicContentPicker"
                            valueType: string
                            contentList: Array<{
                              __typename?: "BasicContentPickerItem"
                              id: number
                              absoluteUrl: string
                              key: any
                              name?: string | null
                              url: string
                              urlSegment?: string | null
                            }>
                          }
                        | {
                            __typename?: "BasicDateTimePicker"
                            valueType: string
                            dateTime?: any | null
                          }
                        | {
                            __typename?: "BasicLabel"
                            valueType: string
                            label?: any | null
                          }
                        | { __typename?: "BasicMediaPicker"; valueType: string }
                        | {
                            __typename?: "BasicMemberPicker"
                            valueType: string
                            members: Array<{
                              __typename?: "BasicMemberPickerItem"
                              id?: number | null
                              name?: string | null
                              properties: Array<{
                                __typename?: "BasicProperty"
                                alias?: string | null
                                editorAlias?: string | null
                                value?:
                                  | {
                                      __typename?: "BasicBlockGridModel"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicBlockListModel"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicContentPicker"
                                      model: string
                                      contentList: Array<{
                                        __typename?: "BasicContentPickerItem"
                                        id: number
                                        absoluteUrl: string
                                        key: any
                                        name?: string | null
                                        url: string
                                        urlSegment?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicDateTimePicker"
                                      model: string
                                      dateTime?: any | null
                                    }
                                  | {
                                      __typename?: "BasicLabel"
                                      model: string
                                      label?: any | null
                                    }
                                  | {
                                      __typename?: "BasicMediaPicker"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicMemberPicker"
                                      model: string
                                      members: Array<{
                                        __typename?: "BasicMemberPickerItem"
                                        id?: number | null
                                        name?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicMultiUrlPicker"
                                      model: string
                                      links: Array<{
                                        __typename?: "BasicMultiUrlPickerItem"
                                        name?: string | null
                                        target?: string | null
                                        type: LinkType
                                        url?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicNestedContent"
                                      model: string
                                      elements?: Array<{
                                        __typename?: "BasicNestedContentElement"
                                        properties: Array<{
                                          __typename?: "BasicProperty"
                                          alias?: string | null
                                          editorAlias?: string | null
                                          value?:
                                            | {
                                                __typename?: "BasicBlockGridModel"
                                                model: string
                                              }
                                            | {
                                                __typename?: "BasicBlockListModel"
                                                model: string
                                              }
                                            | {
                                                __typename?: "BasicContentPicker"
                                                model: string
                                                contentList: Array<{
                                                  __typename?: "BasicContentPickerItem"
                                                  id: number
                                                  absoluteUrl: string
                                                  key: any
                                                  name?: string | null
                                                  url: string
                                                  urlSegment?: string | null
                                                }>
                                              }
                                            | {
                                                __typename?: "BasicDateTimePicker"
                                                model: string
                                                dateTime?: any | null
                                              }
                                            | {
                                                __typename?: "BasicLabel"
                                                model: string
                                                label?: any | null
                                              }
                                            | {
                                                __typename?: "BasicMediaPicker"
                                                model: string
                                              }
                                            | {
                                                __typename?: "BasicMemberPicker"
                                                model: string
                                                members: Array<{
                                                  __typename?: "BasicMemberPickerItem"
                                                  id?: number | null
                                                  name?: string | null
                                                }>
                                              }
                                            | {
                                                __typename?: "BasicMultiUrlPicker"
                                                model: string
                                                links: Array<{
                                                  __typename?: "BasicMultiUrlPickerItem"
                                                  name?: string | null
                                                  target?: string | null
                                                  type: LinkType
                                                  url?: string | null
                                                }>
                                              }
                                            | {
                                                __typename?: "BasicNestedContent"
                                                model: string
                                              }
                                            | {
                                                __typename?: "BasicPropertyValue"
                                                model: string
                                                value?: any | null
                                              }
                                            | {
                                                __typename?: "BasicRichText"
                                                model: string
                                                richText?: string | null
                                              }
                                            | {
                                                __typename?: "BasicUnsupportedPropertyValue"
                                                model: string
                                                message: string
                                              }
                                            | {
                                                __typename?: "MintMediaPicker"
                                                model: string
                                                mediaItems: Array<{
                                                  __typename?: "MintMediaPickerItem"
                                                  id: number
                                                  url: string
                                                  altText?: string | null
                                                }>
                                              }
                                            | null
                                        } | null>
                                      }> | null
                                    }
                                  | {
                                      __typename?: "BasicPropertyValue"
                                      model: string
                                      value?: any | null
                                    }
                                  | {
                                      __typename?: "BasicRichText"
                                      model: string
                                      richText?: string | null
                                    }
                                  | {
                                      __typename?: "BasicUnsupportedPropertyValue"
                                      model: string
                                      message: string
                                    }
                                  | {
                                      __typename?: "MintMediaPicker"
                                      model: string
                                      mediaItems: Array<{
                                        __typename?: "MintMediaPickerItem"
                                        id: number
                                        url: string
                                        altText?: string | null
                                      }>
                                    }
                                  | null
                              } | null>
                            }>
                          }
                        | {
                            __typename?: "BasicMultiUrlPicker"
                            valueType: string
                            links: Array<{
                              __typename?: "BasicMultiUrlPickerItem"
                              name?: string | null
                              target?: string | null
                              type: LinkType
                              url?: string | null
                            }>
                          }
                        | {
                            __typename?: "BasicNestedContent"
                            valueType: string
                            elements?: Array<{
                              __typename?: "BasicNestedContentElement"
                              properties: Array<{
                                __typename?: "BasicProperty"
                                alias?: string | null
                                editorAlias?: string | null
                                value?:
                                  | {
                                      __typename?: "BasicBlockGridModel"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicBlockListModel"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicContentPicker"
                                      model: string
                                      contentList: Array<{
                                        __typename?: "BasicContentPickerItem"
                                        id: number
                                        absoluteUrl: string
                                        key: any
                                        name?: string | null
                                        url: string
                                        urlSegment?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicDateTimePicker"
                                      model: string
                                      dateTime?: any | null
                                    }
                                  | {
                                      __typename?: "BasicLabel"
                                      model: string
                                      label?: any | null
                                    }
                                  | {
                                      __typename?: "BasicMediaPicker"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicMemberPicker"
                                      model: string
                                      members: Array<{
                                        __typename?: "BasicMemberPickerItem"
                                        id?: number | null
                                        name?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicMultiUrlPicker"
                                      model: string
                                      links: Array<{
                                        __typename?: "BasicMultiUrlPickerItem"
                                        name?: string | null
                                        target?: string | null
                                        type: LinkType
                                        url?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicNestedContent"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicPropertyValue"
                                      model: string
                                      value?: any | null
                                    }
                                  | {
                                      __typename?: "BasicRichText"
                                      model: string
                                      richText?: string | null
                                    }
                                  | {
                                      __typename?: "BasicUnsupportedPropertyValue"
                                      model: string
                                      message: string
                                    }
                                  | {
                                      __typename?: "MintMediaPicker"
                                      model: string
                                      mediaItems: Array<{
                                        __typename?: "MintMediaPickerItem"
                                        id: number
                                        url: string
                                        altText?: string | null
                                      }>
                                    }
                                  | null
                              } | null>
                            }> | null
                          }
                        | {
                            __typename?: "BasicPropertyValue"
                            valueType: string
                            value?: any | null
                          }
                        | {
                            __typename?: "BasicRichText"
                            valueType: string
                            richText?: string | null
                          }
                        | {
                            __typename?: "BasicUnsupportedPropertyValue"
                            message: string
                            valueType: string
                          }
                        | {
                            __typename?: "MintMediaPicker"
                            valueType: string
                            mediaItems: Array<{
                              __typename?: "MintMediaPickerItem"
                              id: number
                              url: string
                              altText?: string | null
                            }>
                          }
                        | null
                    } | null>
                    areas: Array<{
                      __typename?: "BasicBlockGridArea"
                      alias?: string | null
                      rowSpan: number
                      columnSpan: number
                    } | null>
                  }> | null
                } | null>
              }> | null
            }
          | {
              __typename?: "BasicBlockListModel"
              valueType: string
              blocks?: Array<{
                __typename?: "BasicBlockListItem"
                blockType?: string | null
                properties: Array<{
                  __typename?: "BasicProperty"
                  propertyName?: string | null
                  propertyValue?:
                    | { __typename?: "BasicBlockGridModel"; valueType: string }
                    | {
                        __typename?: "BasicBlockListModel"
                        valueType: string
                        blocks?: Array<{
                          __typename?: "BasicBlockListItem"
                          blockType?: string | null
                          properties: Array<{
                            __typename?: "BasicProperty"
                            propertyName?: string | null
                            propertyValue?:
                              | {
                                  __typename?: "BasicBlockGridModel"
                                  valueType: string
                                }
                              | {
                                  __typename?: "BasicBlockListModel"
                                  valueType: string
                                  blocks?: Array<{
                                    __typename?: "BasicBlockListItem"
                                    blockType?: string | null
                                    properties: Array<{
                                      __typename?: "BasicProperty"
                                      propertyName?: string | null
                                      propertyValue?:
                                        | {
                                            __typename?: "BasicBlockGridModel"
                                            valueType: string
                                          }
                                        | {
                                            __typename?: "BasicBlockListModel"
                                            valueType: string
                                            blocks?: Array<{
                                              __typename?: "BasicBlockListItem"
                                              blockType?: string | null
                                              properties: Array<{
                                                __typename?: "BasicProperty"
                                                propertyName?: string | null
                                                propertyValue?:
                                                  | {
                                                      __typename?: "BasicBlockGridModel"
                                                      valueType: string
                                                    }
                                                  | {
                                                      __typename?: "BasicBlockListModel"
                                                      valueType: string
                                                      blocks?: Array<{
                                                        __typename?: "BasicBlockListItem"
                                                        blockType?:
                                                          | string
                                                          | null
                                                        properties: Array<{
                                                          __typename?: "BasicProperty"
                                                          propertyName?:
                                                            | string
                                                            | null
                                                          propertyValue?:
                                                            | {
                                                                __typename?: "BasicBlockGridModel"
                                                                valueType: string
                                                              }
                                                            | {
                                                                __typename?: "BasicBlockListModel"
                                                                valueType: string
                                                              }
                                                            | {
                                                                __typename?: "BasicContentPicker"
                                                                valueType: string
                                                                contentList: Array<{
                                                                  __typename?: "BasicContentPickerItem"
                                                                  id: number
                                                                  absoluteUrl: string
                                                                  key: any
                                                                  name?:
                                                                    | string
                                                                    | null
                                                                  url: string
                                                                  urlSegment?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | {
                                                                __typename?: "BasicDateTimePicker"
                                                                valueType: string
                                                                dateTime?:
                                                                  | any
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicLabel"
                                                                valueType: string
                                                                label?:
                                                                  | any
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicMediaPicker"
                                                                valueType: string
                                                              }
                                                            | {
                                                                __typename?: "BasicMemberPicker"
                                                                valueType: string
                                                                members: Array<{
                                                                  __typename?: "BasicMemberPickerItem"
                                                                  id?:
                                                                    | number
                                                                    | null
                                                                  name?:
                                                                    | string
                                                                    | null
                                                                  properties: Array<{
                                                                    __typename?: "BasicProperty"
                                                                    alias?:
                                                                      | string
                                                                      | null
                                                                    editorAlias?:
                                                                      | string
                                                                      | null
                                                                    value?:
                                                                      | {
                                                                          __typename?: "BasicBlockGridModel"
                                                                          model: string
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicBlockListModel"
                                                                          model: string
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicContentPicker"
                                                                          model: string
                                                                          contentList: Array<{
                                                                            __typename?: "BasicContentPickerItem"
                                                                            id: number
                                                                            absoluteUrl: string
                                                                            key: any
                                                                            name?:
                                                                              | string
                                                                              | null
                                                                            url: string
                                                                            urlSegment?:
                                                                              | string
                                                                              | null
                                                                          }>
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicDateTimePicker"
                                                                          model: string
                                                                          dateTime?:
                                                                            | any
                                                                            | null
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicLabel"
                                                                          model: string
                                                                          label?:
                                                                            | any
                                                                            | null
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicMediaPicker"
                                                                          model: string
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicMemberPicker"
                                                                          model: string
                                                                          members: Array<{
                                                                            __typename?: "BasicMemberPickerItem"
                                                                            id?:
                                                                              | number
                                                                              | null
                                                                            name?:
                                                                              | string
                                                                              | null
                                                                          }>
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicMultiUrlPicker"
                                                                          model: string
                                                                          links: Array<{
                                                                            __typename?: "BasicMultiUrlPickerItem"
                                                                            name?:
                                                                              | string
                                                                              | null
                                                                            target?:
                                                                              | string
                                                                              | null
                                                                            type: LinkType
                                                                            url?:
                                                                              | string
                                                                              | null
                                                                          }>
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicNestedContent"
                                                                          model: string
                                                                          elements?: Array<{
                                                                            __typename?: "BasicNestedContentElement"
                                                                            properties: Array<{
                                                                              __typename?: "BasicProperty"
                                                                              alias?:
                                                                                | string
                                                                                | null
                                                                              editorAlias?:
                                                                                | string
                                                                                | null
                                                                              value?:
                                                                                | {
                                                                                    __typename?: "BasicBlockGridModel"
                                                                                    model: string
                                                                                  }
                                                                                | {
                                                                                    __typename?: "BasicBlockListModel"
                                                                                    model: string
                                                                                  }
                                                                                | {
                                                                                    __typename?: "BasicContentPicker"
                                                                                    model: string
                                                                                    contentList: Array<{
                                                                                      __typename?: "BasicContentPickerItem"
                                                                                      id: number
                                                                                      absoluteUrl: string
                                                                                      key: any
                                                                                      name?:
                                                                                        | string
                                                                                        | null
                                                                                      url: string
                                                                                      urlSegment?:
                                                                                        | string
                                                                                        | null
                                                                                    }>
                                                                                  }
                                                                                | {
                                                                                    __typename?: "BasicDateTimePicker"
                                                                                    model: string
                                                                                    dateTime?:
                                                                                      | any
                                                                                      | null
                                                                                  }
                                                                                | {
                                                                                    __typename?: "BasicLabel"
                                                                                    model: string
                                                                                    label?:
                                                                                      | any
                                                                                      | null
                                                                                  }
                                                                                | {
                                                                                    __typename?: "BasicMediaPicker"
                                                                                    model: string
                                                                                  }
                                                                                | {
                                                                                    __typename?: "BasicMemberPicker"
                                                                                    model: string
                                                                                    members: Array<{
                                                                                      __typename?: "BasicMemberPickerItem"
                                                                                      id?:
                                                                                        | number
                                                                                        | null
                                                                                      name?:
                                                                                        | string
                                                                                        | null
                                                                                    }>
                                                                                  }
                                                                                | {
                                                                                    __typename?: "BasicMultiUrlPicker"
                                                                                    model: string
                                                                                    links: Array<{
                                                                                      __typename?: "BasicMultiUrlPickerItem"
                                                                                      name?:
                                                                                        | string
                                                                                        | null
                                                                                      target?:
                                                                                        | string
                                                                                        | null
                                                                                      type: LinkType
                                                                                      url?:
                                                                                        | string
                                                                                        | null
                                                                                    }>
                                                                                  }
                                                                                | {
                                                                                    __typename?: "BasicNestedContent"
                                                                                    model: string
                                                                                  }
                                                                                | {
                                                                                    __typename?: "BasicPropertyValue"
                                                                                    model: string
                                                                                    value?:
                                                                                      | any
                                                                                      | null
                                                                                  }
                                                                                | {
                                                                                    __typename?: "BasicRichText"
                                                                                    model: string
                                                                                    richText?:
                                                                                      | string
                                                                                      | null
                                                                                  }
                                                                                | {
                                                                                    __typename?: "BasicUnsupportedPropertyValue"
                                                                                    model: string
                                                                                    message: string
                                                                                  }
                                                                                | {
                                                                                    __typename?: "MintMediaPicker"
                                                                                    model: string
                                                                                    mediaItems: Array<{
                                                                                      __typename?: "MintMediaPickerItem"
                                                                                      id: number
                                                                                      url: string
                                                                                      altText?:
                                                                                        | string
                                                                                        | null
                                                                                    }>
                                                                                  }
                                                                                | null
                                                                            } | null>
                                                                          }> | null
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicPropertyValue"
                                                                          model: string
                                                                          value?:
                                                                            | any
                                                                            | null
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicRichText"
                                                                          model: string
                                                                          richText?:
                                                                            | string
                                                                            | null
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicUnsupportedPropertyValue"
                                                                          model: string
                                                                          message: string
                                                                        }
                                                                      | {
                                                                          __typename?: "MintMediaPicker"
                                                                          model: string
                                                                          mediaItems: Array<{
                                                                            __typename?: "MintMediaPickerItem"
                                                                            id: number
                                                                            url: string
                                                                            altText?:
                                                                              | string
                                                                              | null
                                                                          }>
                                                                        }
                                                                      | null
                                                                  } | null>
                                                                }>
                                                              }
                                                            | {
                                                                __typename?: "BasicMultiUrlPicker"
                                                                valueType: string
                                                                links: Array<{
                                                                  __typename?: "BasicMultiUrlPickerItem"
                                                                  name?:
                                                                    | string
                                                                    | null
                                                                  target?:
                                                                    | string
                                                                    | null
                                                                  type: LinkType
                                                                  url?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | {
                                                                __typename?: "BasicNestedContent"
                                                                valueType: string
                                                                elements?: Array<{
                                                                  __typename?: "BasicNestedContentElement"
                                                                  properties: Array<{
                                                                    __typename?: "BasicProperty"
                                                                    alias?:
                                                                      | string
                                                                      | null
                                                                    editorAlias?:
                                                                      | string
                                                                      | null
                                                                    value?:
                                                                      | {
                                                                          __typename?: "BasicBlockGridModel"
                                                                          model: string
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicBlockListModel"
                                                                          model: string
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicContentPicker"
                                                                          model: string
                                                                          contentList: Array<{
                                                                            __typename?: "BasicContentPickerItem"
                                                                            id: number
                                                                            absoluteUrl: string
                                                                            key: any
                                                                            name?:
                                                                              | string
                                                                              | null
                                                                            url: string
                                                                            urlSegment?:
                                                                              | string
                                                                              | null
                                                                          }>
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicDateTimePicker"
                                                                          model: string
                                                                          dateTime?:
                                                                            | any
                                                                            | null
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicLabel"
                                                                          model: string
                                                                          label?:
                                                                            | any
                                                                            | null
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicMediaPicker"
                                                                          model: string
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicMemberPicker"
                                                                          model: string
                                                                          members: Array<{
                                                                            __typename?: "BasicMemberPickerItem"
                                                                            id?:
                                                                              | number
                                                                              | null
                                                                            name?:
                                                                              | string
                                                                              | null
                                                                          }>
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicMultiUrlPicker"
                                                                          model: string
                                                                          links: Array<{
                                                                            __typename?: "BasicMultiUrlPickerItem"
                                                                            name?:
                                                                              | string
                                                                              | null
                                                                            target?:
                                                                              | string
                                                                              | null
                                                                            type: LinkType
                                                                            url?:
                                                                              | string
                                                                              | null
                                                                          }>
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicNestedContent"
                                                                          model: string
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicPropertyValue"
                                                                          model: string
                                                                          value?:
                                                                            | any
                                                                            | null
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicRichText"
                                                                          model: string
                                                                          richText?:
                                                                            | string
                                                                            | null
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicUnsupportedPropertyValue"
                                                                          model: string
                                                                          message: string
                                                                        }
                                                                      | {
                                                                          __typename?: "MintMediaPicker"
                                                                          model: string
                                                                          mediaItems: Array<{
                                                                            __typename?: "MintMediaPickerItem"
                                                                            id: number
                                                                            url: string
                                                                            altText?:
                                                                              | string
                                                                              | null
                                                                          }>
                                                                        }
                                                                      | null
                                                                  } | null>
                                                                }> | null
                                                              }
                                                            | {
                                                                __typename?: "BasicPropertyValue"
                                                                valueType: string
                                                                value?:
                                                                  | any
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicRichText"
                                                                valueType: string
                                                                richText?:
                                                                  | string
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicUnsupportedPropertyValue"
                                                                message: string
                                                                valueType: string
                                                              }
                                                            | {
                                                                __typename?: "MintMediaPicker"
                                                                valueType: string
                                                                mediaItems: Array<{
                                                                  __typename?: "MintMediaPickerItem"
                                                                  id: number
                                                                  url: string
                                                                  altText?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | null
                                                        } | null>
                                                      }> | null
                                                    }
                                                  | {
                                                      __typename?: "BasicContentPicker"
                                                      valueType: string
                                                      contentList: Array<{
                                                        __typename?: "BasicContentPickerItem"
                                                        id: number
                                                        absoluteUrl: string
                                                        key: any
                                                        name?: string | null
                                                        url: string
                                                        urlSegment?:
                                                          | string
                                                          | null
                                                      }>
                                                    }
                                                  | {
                                                      __typename?: "BasicDateTimePicker"
                                                      valueType: string
                                                      dateTime?: any | null
                                                    }
                                                  | {
                                                      __typename?: "BasicLabel"
                                                      valueType: string
                                                      label?: any | null
                                                    }
                                                  | {
                                                      __typename?: "BasicMediaPicker"
                                                      valueType: string
                                                    }
                                                  | {
                                                      __typename?: "BasicMemberPicker"
                                                      valueType: string
                                                      members: Array<{
                                                        __typename?: "BasicMemberPickerItem"
                                                        id?: number | null
                                                        name?: string | null
                                                        properties: Array<{
                                                          __typename?: "BasicProperty"
                                                          alias?: string | null
                                                          editorAlias?:
                                                            | string
                                                            | null
                                                          value?:
                                                            | {
                                                                __typename?: "BasicBlockGridModel"
                                                                model: string
                                                              }
                                                            | {
                                                                __typename?: "BasicBlockListModel"
                                                                model: string
                                                              }
                                                            | {
                                                                __typename?: "BasicContentPicker"
                                                                model: string
                                                                contentList: Array<{
                                                                  __typename?: "BasicContentPickerItem"
                                                                  id: number
                                                                  absoluteUrl: string
                                                                  key: any
                                                                  name?:
                                                                    | string
                                                                    | null
                                                                  url: string
                                                                  urlSegment?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | {
                                                                __typename?: "BasicDateTimePicker"
                                                                model: string
                                                                dateTime?:
                                                                  | any
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicLabel"
                                                                model: string
                                                                label?:
                                                                  | any
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicMediaPicker"
                                                                model: string
                                                              }
                                                            | {
                                                                __typename?: "BasicMemberPicker"
                                                                model: string
                                                                members: Array<{
                                                                  __typename?: "BasicMemberPickerItem"
                                                                  id?:
                                                                    | number
                                                                    | null
                                                                  name?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | {
                                                                __typename?: "BasicMultiUrlPicker"
                                                                model: string
                                                                links: Array<{
                                                                  __typename?: "BasicMultiUrlPickerItem"
                                                                  name?:
                                                                    | string
                                                                    | null
                                                                  target?:
                                                                    | string
                                                                    | null
                                                                  type: LinkType
                                                                  url?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | {
                                                                __typename?: "BasicNestedContent"
                                                                model: string
                                                                elements?: Array<{
                                                                  __typename?: "BasicNestedContentElement"
                                                                  properties: Array<{
                                                                    __typename?: "BasicProperty"
                                                                    alias?:
                                                                      | string
                                                                      | null
                                                                    editorAlias?:
                                                                      | string
                                                                      | null
                                                                    value?:
                                                                      | {
                                                                          __typename?: "BasicBlockGridModel"
                                                                          model: string
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicBlockListModel"
                                                                          model: string
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicContentPicker"
                                                                          model: string
                                                                          contentList: Array<{
                                                                            __typename?: "BasicContentPickerItem"
                                                                            id: number
                                                                            absoluteUrl: string
                                                                            key: any
                                                                            name?:
                                                                              | string
                                                                              | null
                                                                            url: string
                                                                            urlSegment?:
                                                                              | string
                                                                              | null
                                                                          }>
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicDateTimePicker"
                                                                          model: string
                                                                          dateTime?:
                                                                            | any
                                                                            | null
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicLabel"
                                                                          model: string
                                                                          label?:
                                                                            | any
                                                                            | null
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicMediaPicker"
                                                                          model: string
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicMemberPicker"
                                                                          model: string
                                                                          members: Array<{
                                                                            __typename?: "BasicMemberPickerItem"
                                                                            id?:
                                                                              | number
                                                                              | null
                                                                            name?:
                                                                              | string
                                                                              | null
                                                                          }>
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicMultiUrlPicker"
                                                                          model: string
                                                                          links: Array<{
                                                                            __typename?: "BasicMultiUrlPickerItem"
                                                                            name?:
                                                                              | string
                                                                              | null
                                                                            target?:
                                                                              | string
                                                                              | null
                                                                            type: LinkType
                                                                            url?:
                                                                              | string
                                                                              | null
                                                                          }>
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicNestedContent"
                                                                          model: string
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicPropertyValue"
                                                                          model: string
                                                                          value?:
                                                                            | any
                                                                            | null
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicRichText"
                                                                          model: string
                                                                          richText?:
                                                                            | string
                                                                            | null
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicUnsupportedPropertyValue"
                                                                          model: string
                                                                          message: string
                                                                        }
                                                                      | {
                                                                          __typename?: "MintMediaPicker"
                                                                          model: string
                                                                          mediaItems: Array<{
                                                                            __typename?: "MintMediaPickerItem"
                                                                            id: number
                                                                            url: string
                                                                            altText?:
                                                                              | string
                                                                              | null
                                                                          }>
                                                                        }
                                                                      | null
                                                                  } | null>
                                                                }> | null
                                                              }
                                                            | {
                                                                __typename?: "BasicPropertyValue"
                                                                model: string
                                                                value?:
                                                                  | any
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicRichText"
                                                                model: string
                                                                richText?:
                                                                  | string
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicUnsupportedPropertyValue"
                                                                model: string
                                                                message: string
                                                              }
                                                            | {
                                                                __typename?: "MintMediaPicker"
                                                                model: string
                                                                mediaItems: Array<{
                                                                  __typename?: "MintMediaPickerItem"
                                                                  id: number
                                                                  url: string
                                                                  altText?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | null
                                                        } | null>
                                                      }>
                                                    }
                                                  | {
                                                      __typename?: "BasicMultiUrlPicker"
                                                      valueType: string
                                                      links: Array<{
                                                        __typename?: "BasicMultiUrlPickerItem"
                                                        name?: string | null
                                                        target?: string | null
                                                        type: LinkType
                                                        url?: string | null
                                                      }>
                                                    }
                                                  | {
                                                      __typename?: "BasicNestedContent"
                                                      valueType: string
                                                      elements?: Array<{
                                                        __typename?: "BasicNestedContentElement"
                                                        properties: Array<{
                                                          __typename?: "BasicProperty"
                                                          alias?: string | null
                                                          editorAlias?:
                                                            | string
                                                            | null
                                                          value?:
                                                            | {
                                                                __typename?: "BasicBlockGridModel"
                                                                model: string
                                                              }
                                                            | {
                                                                __typename?: "BasicBlockListModel"
                                                                model: string
                                                              }
                                                            | {
                                                                __typename?: "BasicContentPicker"
                                                                model: string
                                                                contentList: Array<{
                                                                  __typename?: "BasicContentPickerItem"
                                                                  id: number
                                                                  absoluteUrl: string
                                                                  key: any
                                                                  name?:
                                                                    | string
                                                                    | null
                                                                  url: string
                                                                  urlSegment?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | {
                                                                __typename?: "BasicDateTimePicker"
                                                                model: string
                                                                dateTime?:
                                                                  | any
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicLabel"
                                                                model: string
                                                                label?:
                                                                  | any
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicMediaPicker"
                                                                model: string
                                                              }
                                                            | {
                                                                __typename?: "BasicMemberPicker"
                                                                model: string
                                                                members: Array<{
                                                                  __typename?: "BasicMemberPickerItem"
                                                                  id?:
                                                                    | number
                                                                    | null
                                                                  name?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | {
                                                                __typename?: "BasicMultiUrlPicker"
                                                                model: string
                                                                links: Array<{
                                                                  __typename?: "BasicMultiUrlPickerItem"
                                                                  name?:
                                                                    | string
                                                                    | null
                                                                  target?:
                                                                    | string
                                                                    | null
                                                                  type: LinkType
                                                                  url?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | {
                                                                __typename?: "BasicNestedContent"
                                                                model: string
                                                              }
                                                            | {
                                                                __typename?: "BasicPropertyValue"
                                                                model: string
                                                                value?:
                                                                  | any
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicRichText"
                                                                model: string
                                                                richText?:
                                                                  | string
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicUnsupportedPropertyValue"
                                                                model: string
                                                                message: string
                                                              }
                                                            | {
                                                                __typename?: "MintMediaPicker"
                                                                model: string
                                                                mediaItems: Array<{
                                                                  __typename?: "MintMediaPickerItem"
                                                                  id: number
                                                                  url: string
                                                                  altText?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | null
                                                        } | null>
                                                      }> | null
                                                    }
                                                  | {
                                                      __typename?: "BasicPropertyValue"
                                                      valueType: string
                                                      value?: any | null
                                                    }
                                                  | {
                                                      __typename?: "BasicRichText"
                                                      valueType: string
                                                      richText?: string | null
                                                    }
                                                  | {
                                                      __typename?: "BasicUnsupportedPropertyValue"
                                                      message: string
                                                      valueType: string
                                                    }
                                                  | {
                                                      __typename?: "MintMediaPicker"
                                                      valueType: string
                                                      mediaItems: Array<{
                                                        __typename?: "MintMediaPickerItem"
                                                        id: number
                                                        url: string
                                                        altText?: string | null
                                                      }>
                                                    }
                                                  | null
                                              } | null>
                                            }> | null
                                          }
                                        | {
                                            __typename?: "BasicContentPicker"
                                            valueType: string
                                            contentList: Array<{
                                              __typename?: "BasicContentPickerItem"
                                              id: number
                                              absoluteUrl: string
                                              key: any
                                              name?: string | null
                                              url: string
                                              urlSegment?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicDateTimePicker"
                                            valueType: string
                                            dateTime?: any | null
                                          }
                                        | {
                                            __typename?: "BasicLabel"
                                            valueType: string
                                            label?: any | null
                                          }
                                        | {
                                            __typename?: "BasicMediaPicker"
                                            valueType: string
                                          }
                                        | {
                                            __typename?: "BasicMemberPicker"
                                            valueType: string
                                            members: Array<{
                                              __typename?: "BasicMemberPickerItem"
                                              id?: number | null
                                              name?: string | null
                                              properties: Array<{
                                                __typename?: "BasicProperty"
                                                alias?: string | null
                                                editorAlias?: string | null
                                                value?:
                                                  | {
                                                      __typename?: "BasicBlockGridModel"
                                                      model: string
                                                    }
                                                  | {
                                                      __typename?: "BasicBlockListModel"
                                                      model: string
                                                    }
                                                  | {
                                                      __typename?: "BasicContentPicker"
                                                      model: string
                                                      contentList: Array<{
                                                        __typename?: "BasicContentPickerItem"
                                                        id: number
                                                        absoluteUrl: string
                                                        key: any
                                                        name?: string | null
                                                        url: string
                                                        urlSegment?:
                                                          | string
                                                          | null
                                                      }>
                                                    }
                                                  | {
                                                      __typename?: "BasicDateTimePicker"
                                                      model: string
                                                      dateTime?: any | null
                                                    }
                                                  | {
                                                      __typename?: "BasicLabel"
                                                      model: string
                                                      label?: any | null
                                                    }
                                                  | {
                                                      __typename?: "BasicMediaPicker"
                                                      model: string
                                                    }
                                                  | {
                                                      __typename?: "BasicMemberPicker"
                                                      model: string
                                                      members: Array<{
                                                        __typename?: "BasicMemberPickerItem"
                                                        id?: number | null
                                                        name?: string | null
                                                      }>
                                                    }
                                                  | {
                                                      __typename?: "BasicMultiUrlPicker"
                                                      model: string
                                                      links: Array<{
                                                        __typename?: "BasicMultiUrlPickerItem"
                                                        name?: string | null
                                                        target?: string | null
                                                        type: LinkType
                                                        url?: string | null
                                                      }>
                                                    }
                                                  | {
                                                      __typename?: "BasicNestedContent"
                                                      model: string
                                                      elements?: Array<{
                                                        __typename?: "BasicNestedContentElement"
                                                        properties: Array<{
                                                          __typename?: "BasicProperty"
                                                          alias?: string | null
                                                          editorAlias?:
                                                            | string
                                                            | null
                                                          value?:
                                                            | {
                                                                __typename?: "BasicBlockGridModel"
                                                                model: string
                                                              }
                                                            | {
                                                                __typename?: "BasicBlockListModel"
                                                                model: string
                                                              }
                                                            | {
                                                                __typename?: "BasicContentPicker"
                                                                model: string
                                                                contentList: Array<{
                                                                  __typename?: "BasicContentPickerItem"
                                                                  id: number
                                                                  absoluteUrl: string
                                                                  key: any
                                                                  name?:
                                                                    | string
                                                                    | null
                                                                  url: string
                                                                  urlSegment?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | {
                                                                __typename?: "BasicDateTimePicker"
                                                                model: string
                                                                dateTime?:
                                                                  | any
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicLabel"
                                                                model: string
                                                                label?:
                                                                  | any
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicMediaPicker"
                                                                model: string
                                                              }
                                                            | {
                                                                __typename?: "BasicMemberPicker"
                                                                model: string
                                                                members: Array<{
                                                                  __typename?: "BasicMemberPickerItem"
                                                                  id?:
                                                                    | number
                                                                    | null
                                                                  name?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | {
                                                                __typename?: "BasicMultiUrlPicker"
                                                                model: string
                                                                links: Array<{
                                                                  __typename?: "BasicMultiUrlPickerItem"
                                                                  name?:
                                                                    | string
                                                                    | null
                                                                  target?:
                                                                    | string
                                                                    | null
                                                                  type: LinkType
                                                                  url?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | {
                                                                __typename?: "BasicNestedContent"
                                                                model: string
                                                              }
                                                            | {
                                                                __typename?: "BasicPropertyValue"
                                                                model: string
                                                                value?:
                                                                  | any
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicRichText"
                                                                model: string
                                                                richText?:
                                                                  | string
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicUnsupportedPropertyValue"
                                                                model: string
                                                                message: string
                                                              }
                                                            | {
                                                                __typename?: "MintMediaPicker"
                                                                model: string
                                                                mediaItems: Array<{
                                                                  __typename?: "MintMediaPickerItem"
                                                                  id: number
                                                                  url: string
                                                                  altText?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | null
                                                        } | null>
                                                      }> | null
                                                    }
                                                  | {
                                                      __typename?: "BasicPropertyValue"
                                                      model: string
                                                      value?: any | null
                                                    }
                                                  | {
                                                      __typename?: "BasicRichText"
                                                      model: string
                                                      richText?: string | null
                                                    }
                                                  | {
                                                      __typename?: "BasicUnsupportedPropertyValue"
                                                      model: string
                                                      message: string
                                                    }
                                                  | {
                                                      __typename?: "MintMediaPicker"
                                                      model: string
                                                      mediaItems: Array<{
                                                        __typename?: "MintMediaPickerItem"
                                                        id: number
                                                        url: string
                                                        altText?: string | null
                                                      }>
                                                    }
                                                  | null
                                              } | null>
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicMultiUrlPicker"
                                            valueType: string
                                            links: Array<{
                                              __typename?: "BasicMultiUrlPickerItem"
                                              name?: string | null
                                              target?: string | null
                                              type: LinkType
                                              url?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicNestedContent"
                                            valueType: string
                                            elements?: Array<{
                                              __typename?: "BasicNestedContentElement"
                                              properties: Array<{
                                                __typename?: "BasicProperty"
                                                alias?: string | null
                                                editorAlias?: string | null
                                                value?:
                                                  | {
                                                      __typename?: "BasicBlockGridModel"
                                                      model: string
                                                    }
                                                  | {
                                                      __typename?: "BasicBlockListModel"
                                                      model: string
                                                    }
                                                  | {
                                                      __typename?: "BasicContentPicker"
                                                      model: string
                                                      contentList: Array<{
                                                        __typename?: "BasicContentPickerItem"
                                                        id: number
                                                        absoluteUrl: string
                                                        key: any
                                                        name?: string | null
                                                        url: string
                                                        urlSegment?:
                                                          | string
                                                          | null
                                                      }>
                                                    }
                                                  | {
                                                      __typename?: "BasicDateTimePicker"
                                                      model: string
                                                      dateTime?: any | null
                                                    }
                                                  | {
                                                      __typename?: "BasicLabel"
                                                      model: string
                                                      label?: any | null
                                                    }
                                                  | {
                                                      __typename?: "BasicMediaPicker"
                                                      model: string
                                                    }
                                                  | {
                                                      __typename?: "BasicMemberPicker"
                                                      model: string
                                                      members: Array<{
                                                        __typename?: "BasicMemberPickerItem"
                                                        id?: number | null
                                                        name?: string | null
                                                      }>
                                                    }
                                                  | {
                                                      __typename?: "BasicMultiUrlPicker"
                                                      model: string
                                                      links: Array<{
                                                        __typename?: "BasicMultiUrlPickerItem"
                                                        name?: string | null
                                                        target?: string | null
                                                        type: LinkType
                                                        url?: string | null
                                                      }>
                                                    }
                                                  | {
                                                      __typename?: "BasicNestedContent"
                                                      model: string
                                                    }
                                                  | {
                                                      __typename?: "BasicPropertyValue"
                                                      model: string
                                                      value?: any | null
                                                    }
                                                  | {
                                                      __typename?: "BasicRichText"
                                                      model: string
                                                      richText?: string | null
                                                    }
                                                  | {
                                                      __typename?: "BasicUnsupportedPropertyValue"
                                                      model: string
                                                      message: string
                                                    }
                                                  | {
                                                      __typename?: "MintMediaPicker"
                                                      model: string
                                                      mediaItems: Array<{
                                                        __typename?: "MintMediaPickerItem"
                                                        id: number
                                                        url: string
                                                        altText?: string | null
                                                      }>
                                                    }
                                                  | null
                                              } | null>
                                            }> | null
                                          }
                                        | {
                                            __typename?: "BasicPropertyValue"
                                            valueType: string
                                            value?: any | null
                                          }
                                        | {
                                            __typename?: "BasicRichText"
                                            valueType: string
                                            richText?: string | null
                                          }
                                        | {
                                            __typename?: "BasicUnsupportedPropertyValue"
                                            message: string
                                            valueType: string
                                          }
                                        | {
                                            __typename?: "MintMediaPicker"
                                            valueType: string
                                            mediaItems: Array<{
                                              __typename?: "MintMediaPickerItem"
                                              id: number
                                              url: string
                                              altText?: string | null
                                            }>
                                          }
                                        | null
                                    } | null>
                                  }> | null
                                }
                              | {
                                  __typename?: "BasicContentPicker"
                                  valueType: string
                                  contentList: Array<{
                                    __typename?: "BasicContentPickerItem"
                                    id: number
                                    absoluteUrl: string
                                    key: any
                                    name?: string | null
                                    url: string
                                    urlSegment?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicDateTimePicker"
                                  valueType: string
                                  dateTime?: any | null
                                }
                              | {
                                  __typename?: "BasicLabel"
                                  valueType: string
                                  label?: any | null
                                }
                              | {
                                  __typename?: "BasicMediaPicker"
                                  valueType: string
                                }
                              | {
                                  __typename?: "BasicMemberPicker"
                                  valueType: string
                                  members: Array<{
                                    __typename?: "BasicMemberPickerItem"
                                    id?: number | null
                                    name?: string | null
                                    properties: Array<{
                                      __typename?: "BasicProperty"
                                      alias?: string | null
                                      editorAlias?: string | null
                                      value?:
                                        | {
                                            __typename?: "BasicBlockGridModel"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicBlockListModel"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicContentPicker"
                                            model: string
                                            contentList: Array<{
                                              __typename?: "BasicContentPickerItem"
                                              id: number
                                              absoluteUrl: string
                                              key: any
                                              name?: string | null
                                              url: string
                                              urlSegment?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicDateTimePicker"
                                            model: string
                                            dateTime?: any | null
                                          }
                                        | {
                                            __typename?: "BasicLabel"
                                            model: string
                                            label?: any | null
                                          }
                                        | {
                                            __typename?: "BasicMediaPicker"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicMemberPicker"
                                            model: string
                                            members: Array<{
                                              __typename?: "BasicMemberPickerItem"
                                              id?: number | null
                                              name?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicMultiUrlPicker"
                                            model: string
                                            links: Array<{
                                              __typename?: "BasicMultiUrlPickerItem"
                                              name?: string | null
                                              target?: string | null
                                              type: LinkType
                                              url?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicNestedContent"
                                            model: string
                                            elements?: Array<{
                                              __typename?: "BasicNestedContentElement"
                                              properties: Array<{
                                                __typename?: "BasicProperty"
                                                alias?: string | null
                                                editorAlias?: string | null
                                                value?:
                                                  | {
                                                      __typename?: "BasicBlockGridModel"
                                                      model: string
                                                    }
                                                  | {
                                                      __typename?: "BasicBlockListModel"
                                                      model: string
                                                    }
                                                  | {
                                                      __typename?: "BasicContentPicker"
                                                      model: string
                                                      contentList: Array<{
                                                        __typename?: "BasicContentPickerItem"
                                                        id: number
                                                        absoluteUrl: string
                                                        key: any
                                                        name?: string | null
                                                        url: string
                                                        urlSegment?:
                                                          | string
                                                          | null
                                                      }>
                                                    }
                                                  | {
                                                      __typename?: "BasicDateTimePicker"
                                                      model: string
                                                      dateTime?: any | null
                                                    }
                                                  | {
                                                      __typename?: "BasicLabel"
                                                      model: string
                                                      label?: any | null
                                                    }
                                                  | {
                                                      __typename?: "BasicMediaPicker"
                                                      model: string
                                                    }
                                                  | {
                                                      __typename?: "BasicMemberPicker"
                                                      model: string
                                                      members: Array<{
                                                        __typename?: "BasicMemberPickerItem"
                                                        id?: number | null
                                                        name?: string | null
                                                      }>
                                                    }
                                                  | {
                                                      __typename?: "BasicMultiUrlPicker"
                                                      model: string
                                                      links: Array<{
                                                        __typename?: "BasicMultiUrlPickerItem"
                                                        name?: string | null
                                                        target?: string | null
                                                        type: LinkType
                                                        url?: string | null
                                                      }>
                                                    }
                                                  | {
                                                      __typename?: "BasicNestedContent"
                                                      model: string
                                                    }
                                                  | {
                                                      __typename?: "BasicPropertyValue"
                                                      model: string
                                                      value?: any | null
                                                    }
                                                  | {
                                                      __typename?: "BasicRichText"
                                                      model: string
                                                      richText?: string | null
                                                    }
                                                  | {
                                                      __typename?: "BasicUnsupportedPropertyValue"
                                                      model: string
                                                      message: string
                                                    }
                                                  | {
                                                      __typename?: "MintMediaPicker"
                                                      model: string
                                                      mediaItems: Array<{
                                                        __typename?: "MintMediaPickerItem"
                                                        id: number
                                                        url: string
                                                        altText?: string | null
                                                      }>
                                                    }
                                                  | null
                                              } | null>
                                            }> | null
                                          }
                                        | {
                                            __typename?: "BasicPropertyValue"
                                            model: string
                                            value?: any | null
                                          }
                                        | {
                                            __typename?: "BasicRichText"
                                            model: string
                                            richText?: string | null
                                          }
                                        | {
                                            __typename?: "BasicUnsupportedPropertyValue"
                                            model: string
                                            message: string
                                          }
                                        | {
                                            __typename?: "MintMediaPicker"
                                            model: string
                                            mediaItems: Array<{
                                              __typename?: "MintMediaPickerItem"
                                              id: number
                                              url: string
                                              altText?: string | null
                                            }>
                                          }
                                        | null
                                    } | null>
                                  }>
                                }
                              | {
                                  __typename?: "BasicMultiUrlPicker"
                                  valueType: string
                                  links: Array<{
                                    __typename?: "BasicMultiUrlPickerItem"
                                    name?: string | null
                                    target?: string | null
                                    type: LinkType
                                    url?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicNestedContent"
                                  valueType: string
                                  elements?: Array<{
                                    __typename?: "BasicNestedContentElement"
                                    properties: Array<{
                                      __typename?: "BasicProperty"
                                      alias?: string | null
                                      editorAlias?: string | null
                                      value?:
                                        | {
                                            __typename?: "BasicBlockGridModel"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicBlockListModel"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicContentPicker"
                                            model: string
                                            contentList: Array<{
                                              __typename?: "BasicContentPickerItem"
                                              id: number
                                              absoluteUrl: string
                                              key: any
                                              name?: string | null
                                              url: string
                                              urlSegment?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicDateTimePicker"
                                            model: string
                                            dateTime?: any | null
                                          }
                                        | {
                                            __typename?: "BasicLabel"
                                            model: string
                                            label?: any | null
                                          }
                                        | {
                                            __typename?: "BasicMediaPicker"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicMemberPicker"
                                            model: string
                                            members: Array<{
                                              __typename?: "BasicMemberPickerItem"
                                              id?: number | null
                                              name?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicMultiUrlPicker"
                                            model: string
                                            links: Array<{
                                              __typename?: "BasicMultiUrlPickerItem"
                                              name?: string | null
                                              target?: string | null
                                              type: LinkType
                                              url?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicNestedContent"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicPropertyValue"
                                            model: string
                                            value?: any | null
                                          }
                                        | {
                                            __typename?: "BasicRichText"
                                            model: string
                                            richText?: string | null
                                          }
                                        | {
                                            __typename?: "BasicUnsupportedPropertyValue"
                                            model: string
                                            message: string
                                          }
                                        | {
                                            __typename?: "MintMediaPicker"
                                            model: string
                                            mediaItems: Array<{
                                              __typename?: "MintMediaPickerItem"
                                              id: number
                                              url: string
                                              altText?: string | null
                                            }>
                                          }
                                        | null
                                    } | null>
                                  }> | null
                                }
                              | {
                                  __typename?: "BasicPropertyValue"
                                  valueType: string
                                  value?: any | null
                                }
                              | {
                                  __typename?: "BasicRichText"
                                  valueType: string
                                  richText?: string | null
                                }
                              | {
                                  __typename?: "BasicUnsupportedPropertyValue"
                                  message: string
                                  valueType: string
                                }
                              | {
                                  __typename?: "MintMediaPicker"
                                  valueType: string
                                  mediaItems: Array<{
                                    __typename?: "MintMediaPickerItem"
                                    id: number
                                    url: string
                                    altText?: string | null
                                  }>
                                }
                              | null
                          } | null>
                        }> | null
                      }
                    | {
                        __typename?: "BasicContentPicker"
                        valueType: string
                        contentList: Array<{
                          __typename?: "BasicContentPickerItem"
                          id: number
                          absoluteUrl: string
                          key: any
                          name?: string | null
                          url: string
                          urlSegment?: string | null
                        }>
                      }
                    | {
                        __typename?: "BasicDateTimePicker"
                        valueType: string
                        dateTime?: any | null
                      }
                    | {
                        __typename?: "BasicLabel"
                        valueType: string
                        label?: any | null
                      }
                    | { __typename?: "BasicMediaPicker"; valueType: string }
                    | {
                        __typename?: "BasicMemberPicker"
                        valueType: string
                        members: Array<{
                          __typename?: "BasicMemberPickerItem"
                          id?: number | null
                          name?: string | null
                          properties: Array<{
                            __typename?: "BasicProperty"
                            alias?: string | null
                            editorAlias?: string | null
                            value?:
                              | {
                                  __typename?: "BasicBlockGridModel"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicBlockListModel"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicContentPicker"
                                  model: string
                                  contentList: Array<{
                                    __typename?: "BasicContentPickerItem"
                                    id: number
                                    absoluteUrl: string
                                    key: any
                                    name?: string | null
                                    url: string
                                    urlSegment?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicDateTimePicker"
                                  model: string
                                  dateTime?: any | null
                                }
                              | {
                                  __typename?: "BasicLabel"
                                  model: string
                                  label?: any | null
                                }
                              | {
                                  __typename?: "BasicMediaPicker"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicMemberPicker"
                                  model: string
                                  members: Array<{
                                    __typename?: "BasicMemberPickerItem"
                                    id?: number | null
                                    name?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicMultiUrlPicker"
                                  model: string
                                  links: Array<{
                                    __typename?: "BasicMultiUrlPickerItem"
                                    name?: string | null
                                    target?: string | null
                                    type: LinkType
                                    url?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicNestedContent"
                                  model: string
                                  elements?: Array<{
                                    __typename?: "BasicNestedContentElement"
                                    properties: Array<{
                                      __typename?: "BasicProperty"
                                      alias?: string | null
                                      editorAlias?: string | null
                                      value?:
                                        | {
                                            __typename?: "BasicBlockGridModel"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicBlockListModel"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicContentPicker"
                                            model: string
                                            contentList: Array<{
                                              __typename?: "BasicContentPickerItem"
                                              id: number
                                              absoluteUrl: string
                                              key: any
                                              name?: string | null
                                              url: string
                                              urlSegment?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicDateTimePicker"
                                            model: string
                                            dateTime?: any | null
                                          }
                                        | {
                                            __typename?: "BasicLabel"
                                            model: string
                                            label?: any | null
                                          }
                                        | {
                                            __typename?: "BasicMediaPicker"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicMemberPicker"
                                            model: string
                                            members: Array<{
                                              __typename?: "BasicMemberPickerItem"
                                              id?: number | null
                                              name?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicMultiUrlPicker"
                                            model: string
                                            links: Array<{
                                              __typename?: "BasicMultiUrlPickerItem"
                                              name?: string | null
                                              target?: string | null
                                              type: LinkType
                                              url?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicNestedContent"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicPropertyValue"
                                            model: string
                                            value?: any | null
                                          }
                                        | {
                                            __typename?: "BasicRichText"
                                            model: string
                                            richText?: string | null
                                          }
                                        | {
                                            __typename?: "BasicUnsupportedPropertyValue"
                                            model: string
                                            message: string
                                          }
                                        | {
                                            __typename?: "MintMediaPicker"
                                            model: string
                                            mediaItems: Array<{
                                              __typename?: "MintMediaPickerItem"
                                              id: number
                                              url: string
                                              altText?: string | null
                                            }>
                                          }
                                        | null
                                    } | null>
                                  }> | null
                                }
                              | {
                                  __typename?: "BasicPropertyValue"
                                  model: string
                                  value?: any | null
                                }
                              | {
                                  __typename?: "BasicRichText"
                                  model: string
                                  richText?: string | null
                                }
                              | {
                                  __typename?: "BasicUnsupportedPropertyValue"
                                  model: string
                                  message: string
                                }
                              | {
                                  __typename?: "MintMediaPicker"
                                  model: string
                                  mediaItems: Array<{
                                    __typename?: "MintMediaPickerItem"
                                    id: number
                                    url: string
                                    altText?: string | null
                                  }>
                                }
                              | null
                          } | null>
                        }>
                      }
                    | {
                        __typename?: "BasicMultiUrlPicker"
                        valueType: string
                        links: Array<{
                          __typename?: "BasicMultiUrlPickerItem"
                          name?: string | null
                          target?: string | null
                          type: LinkType
                          url?: string | null
                        }>
                      }
                    | {
                        __typename?: "BasicNestedContent"
                        valueType: string
                        elements?: Array<{
                          __typename?: "BasicNestedContentElement"
                          properties: Array<{
                            __typename?: "BasicProperty"
                            alias?: string | null
                            editorAlias?: string | null
                            value?:
                              | {
                                  __typename?: "BasicBlockGridModel"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicBlockListModel"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicContentPicker"
                                  model: string
                                  contentList: Array<{
                                    __typename?: "BasicContentPickerItem"
                                    id: number
                                    absoluteUrl: string
                                    key: any
                                    name?: string | null
                                    url: string
                                    urlSegment?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicDateTimePicker"
                                  model: string
                                  dateTime?: any | null
                                }
                              | {
                                  __typename?: "BasicLabel"
                                  model: string
                                  label?: any | null
                                }
                              | {
                                  __typename?: "BasicMediaPicker"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicMemberPicker"
                                  model: string
                                  members: Array<{
                                    __typename?: "BasicMemberPickerItem"
                                    id?: number | null
                                    name?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicMultiUrlPicker"
                                  model: string
                                  links: Array<{
                                    __typename?: "BasicMultiUrlPickerItem"
                                    name?: string | null
                                    target?: string | null
                                    type: LinkType
                                    url?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicNestedContent"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicPropertyValue"
                                  model: string
                                  value?: any | null
                                }
                              | {
                                  __typename?: "BasicRichText"
                                  model: string
                                  richText?: string | null
                                }
                              | {
                                  __typename?: "BasicUnsupportedPropertyValue"
                                  model: string
                                  message: string
                                }
                              | {
                                  __typename?: "MintMediaPicker"
                                  model: string
                                  mediaItems: Array<{
                                    __typename?: "MintMediaPickerItem"
                                    id: number
                                    url: string
                                    altText?: string | null
                                  }>
                                }
                              | null
                          } | null>
                        }> | null
                      }
                    | {
                        __typename?: "BasicPropertyValue"
                        valueType: string
                        value?: any | null
                      }
                    | {
                        __typename?: "BasicRichText"
                        valueType: string
                        richText?: string | null
                      }
                    | {
                        __typename?: "BasicUnsupportedPropertyValue"
                        message: string
                        valueType: string
                      }
                    | {
                        __typename?: "MintMediaPicker"
                        valueType: string
                        mediaItems: Array<{
                          __typename?: "MintMediaPickerItem"
                          id: number
                          url: string
                          altText?: string | null
                        }>
                      }
                    | null
                } | null>
              }> | null
            }
          | {
              __typename?: "BasicContentPicker"
              valueType: string
              contentList: Array<{
                __typename?: "BasicContentPickerItem"
                id: number
                absoluteUrl: string
                key: any
                name?: string | null
                url: string
                urlSegment?: string | null
              }>
            }
          | {
              __typename?: "BasicDateTimePicker"
              valueType: string
              dateTime?: any | null
            }
          | { __typename?: "BasicLabel"; valueType: string; label?: any | null }
          | { __typename?: "BasicMediaPicker"; valueType: string }
          | {
              __typename?: "BasicMemberPicker"
              valueType: string
              members: Array<{
                __typename?: "BasicMemberPickerItem"
                id?: number | null
                name?: string | null
                properties: Array<{
                  __typename?: "BasicProperty"
                  alias?: string | null
                  editorAlias?: string | null
                  value?:
                    | { __typename?: "BasicBlockGridModel"; model: string }
                    | { __typename?: "BasicBlockListModel"; model: string }
                    | {
                        __typename?: "BasicContentPicker"
                        model: string
                        contentList: Array<{
                          __typename?: "BasicContentPickerItem"
                          id: number
                          absoluteUrl: string
                          key: any
                          name?: string | null
                          url: string
                          urlSegment?: string | null
                        }>
                      }
                    | {
                        __typename?: "BasicDateTimePicker"
                        model: string
                        dateTime?: any | null
                      }
                    | {
                        __typename?: "BasicLabel"
                        model: string
                        label?: any | null
                      }
                    | { __typename?: "BasicMediaPicker"; model: string }
                    | {
                        __typename?: "BasicMemberPicker"
                        model: string
                        members: Array<{
                          __typename?: "BasicMemberPickerItem"
                          id?: number | null
                          name?: string | null
                        }>
                      }
                    | {
                        __typename?: "BasicMultiUrlPicker"
                        model: string
                        links: Array<{
                          __typename?: "BasicMultiUrlPickerItem"
                          name?: string | null
                          target?: string | null
                          type: LinkType
                          url?: string | null
                        }>
                      }
                    | {
                        __typename?: "BasicNestedContent"
                        model: string
                        elements?: Array<{
                          __typename?: "BasicNestedContentElement"
                          properties: Array<{
                            __typename?: "BasicProperty"
                            alias?: string | null
                            editorAlias?: string | null
                            value?:
                              | {
                                  __typename?: "BasicBlockGridModel"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicBlockListModel"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicContentPicker"
                                  model: string
                                  contentList: Array<{
                                    __typename?: "BasicContentPickerItem"
                                    id: number
                                    absoluteUrl: string
                                    key: any
                                    name?: string | null
                                    url: string
                                    urlSegment?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicDateTimePicker"
                                  model: string
                                  dateTime?: any | null
                                }
                              | {
                                  __typename?: "BasicLabel"
                                  model: string
                                  label?: any | null
                                }
                              | {
                                  __typename?: "BasicMediaPicker"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicMemberPicker"
                                  model: string
                                  members: Array<{
                                    __typename?: "BasicMemberPickerItem"
                                    id?: number | null
                                    name?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicMultiUrlPicker"
                                  model: string
                                  links: Array<{
                                    __typename?: "BasicMultiUrlPickerItem"
                                    name?: string | null
                                    target?: string | null
                                    type: LinkType
                                    url?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicNestedContent"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicPropertyValue"
                                  model: string
                                  value?: any | null
                                }
                              | {
                                  __typename?: "BasicRichText"
                                  model: string
                                  richText?: string | null
                                }
                              | {
                                  __typename?: "BasicUnsupportedPropertyValue"
                                  model: string
                                  message: string
                                }
                              | {
                                  __typename?: "MintMediaPicker"
                                  model: string
                                  mediaItems: Array<{
                                    __typename?: "MintMediaPickerItem"
                                    id: number
                                    url: string
                                    altText?: string | null
                                  }>
                                }
                              | null
                          } | null>
                        }> | null
                      }
                    | {
                        __typename?: "BasicPropertyValue"
                        model: string
                        value?: any | null
                      }
                    | {
                        __typename?: "BasicRichText"
                        model: string
                        richText?: string | null
                      }
                    | {
                        __typename?: "BasicUnsupportedPropertyValue"
                        model: string
                        message: string
                      }
                    | {
                        __typename?: "MintMediaPicker"
                        model: string
                        mediaItems: Array<{
                          __typename?: "MintMediaPickerItem"
                          id: number
                          url: string
                          altText?: string | null
                        }>
                      }
                    | null
                } | null>
              }>
            }
          | {
              __typename?: "BasicMultiUrlPicker"
              valueType: string
              links: Array<{
                __typename?: "BasicMultiUrlPickerItem"
                name?: string | null
                target?: string | null
                type: LinkType
                url?: string | null
              }>
            }
          | {
              __typename?: "BasicNestedContent"
              valueType: string
              elements?: Array<{
                __typename?: "BasicNestedContentElement"
                properties: Array<{
                  __typename?: "BasicProperty"
                  alias?: string | null
                  editorAlias?: string | null
                  value?:
                    | { __typename?: "BasicBlockGridModel"; model: string }
                    | { __typename?: "BasicBlockListModel"; model: string }
                    | {
                        __typename?: "BasicContentPicker"
                        model: string
                        contentList: Array<{
                          __typename?: "BasicContentPickerItem"
                          id: number
                          absoluteUrl: string
                          key: any
                          name?: string | null
                          url: string
                          urlSegment?: string | null
                        }>
                      }
                    | {
                        __typename?: "BasicDateTimePicker"
                        model: string
                        dateTime?: any | null
                      }
                    | {
                        __typename?: "BasicLabel"
                        model: string
                        label?: any | null
                      }
                    | { __typename?: "BasicMediaPicker"; model: string }
                    | {
                        __typename?: "BasicMemberPicker"
                        model: string
                        members: Array<{
                          __typename?: "BasicMemberPickerItem"
                          id?: number | null
                          name?: string | null
                        }>
                      }
                    | {
                        __typename?: "BasicMultiUrlPicker"
                        model: string
                        links: Array<{
                          __typename?: "BasicMultiUrlPickerItem"
                          name?: string | null
                          target?: string | null
                          type: LinkType
                          url?: string | null
                        }>
                      }
                    | { __typename?: "BasicNestedContent"; model: string }
                    | {
                        __typename?: "BasicPropertyValue"
                        model: string
                        value?: any | null
                      }
                    | {
                        __typename?: "BasicRichText"
                        model: string
                        richText?: string | null
                      }
                    | {
                        __typename?: "BasicUnsupportedPropertyValue"
                        model: string
                        message: string
                      }
                    | {
                        __typename?: "MintMediaPicker"
                        model: string
                        mediaItems: Array<{
                          __typename?: "MintMediaPickerItem"
                          id: number
                          url: string
                          altText?: string | null
                        }>
                      }
                    | null
                } | null>
              }> | null
            }
          | {
              __typename?: "BasicPropertyValue"
              valueType: string
              value?: any | null
            }
          | {
              __typename?: "BasicRichText"
              valueType: string
              richText?: string | null
            }
          | {
              __typename?: "BasicUnsupportedPropertyValue"
              message: string
              valueType: string
            }
          | {
              __typename?: "MintMediaPicker"
              valueType: string
              mediaItems: Array<{
                __typename?: "MintMediaPickerItem"
                id: number
                url: string
                altText?: string | null
              }>
            }
          | null
      } | null> | null
    } | null> | null
    properties?: Array<{
      __typename?: "BasicProperty"
      propertyName?: string | null
      propertyValue?:
        | {
            __typename?: "BasicBlockGridModel"
            gridColumns?: number | null
            valueType: string
            blocks?: Array<{
              __typename?: "BasicBlockGridItem"
              columnSpan: number
              rowSpan: number
              contentProperties: Array<{
                __typename?: "BasicProperty"
                value?:
                  | { __typename?: "BasicBlockGridModel"; valueType: string }
                  | { __typename?: "BasicBlockListModel"; valueType: string }
                  | {
                      __typename?: "BasicContentPicker"
                      valueType: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      valueType: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      valueType: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; valueType: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      valueType: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                                elements?: Array<{
                                  __typename?: "BasicNestedContentElement"
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    alias?: string | null
                                    editorAlias?: string | null
                                    value?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          model: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          model: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          model: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          model: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          model: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          model: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          model: string
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          model: string
                                          message: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          model: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }> | null
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      valueType: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicNestedContent"
                      valueType: string
                      elements?: Array<{
                        __typename?: "BasicNestedContentElement"
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicPropertyValue"
                      valueType: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      valueType: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      message: string
                      valueType: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      valueType: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
              settingsProperties: Array<{
                __typename?: "BasicProperty"
                value?:
                  | { __typename?: "BasicBlockGridModel"; valueType: string }
                  | { __typename?: "BasicBlockListModel"; valueType: string }
                  | {
                      __typename?: "BasicContentPicker"
                      valueType: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      valueType: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      valueType: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; valueType: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      valueType: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                                elements?: Array<{
                                  __typename?: "BasicNestedContentElement"
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    alias?: string | null
                                    editorAlias?: string | null
                                    value?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          model: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          model: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          model: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          model: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          model: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          model: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          model: string
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          model: string
                                          message: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          model: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }> | null
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      valueType: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicNestedContent"
                      valueType: string
                      elements?: Array<{
                        __typename?: "BasicNestedContentElement"
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicPropertyValue"
                      valueType: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      valueType: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      message: string
                      valueType: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      valueType: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
              areas: Array<{
                __typename?: "BasicBlockGridArea"
                alias?: string | null
                rowSpan: number
                columnSpan: number
                blocks?: Array<{
                  __typename?: "BasicBlockGridItem"
                  columnSpan: number
                  rowSpan: number
                  contentProperties: Array<{
                    __typename?: "BasicProperty"
                    value?:
                      | {
                          __typename?: "BasicBlockGridModel"
                          valueType: string
                        }
                      | {
                          __typename?: "BasicBlockListModel"
                          valueType: string
                        }
                      | {
                          __typename?: "BasicContentPicker"
                          valueType: string
                          contentList: Array<{
                            __typename?: "BasicContentPickerItem"
                            id: number
                            absoluteUrl: string
                            key: any
                            name?: string | null
                            url: string
                            urlSegment?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicDateTimePicker"
                          valueType: string
                          dateTime?: any | null
                        }
                      | {
                          __typename?: "BasicLabel"
                          valueType: string
                          label?: any | null
                        }
                      | { __typename?: "BasicMediaPicker"; valueType: string }
                      | {
                          __typename?: "BasicMemberPicker"
                          valueType: string
                          members: Array<{
                            __typename?: "BasicMemberPickerItem"
                            id?: number | null
                            name?: string | null
                            properties: Array<{
                              __typename?: "BasicProperty"
                              alias?: string | null
                              editorAlias?: string | null
                              value?:
                                | {
                                    __typename?: "BasicBlockGridModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicBlockListModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicContentPicker"
                                    model: string
                                    contentList: Array<{
                                      __typename?: "BasicContentPickerItem"
                                      id: number
                                      absoluteUrl: string
                                      key: any
                                      name?: string | null
                                      url: string
                                      urlSegment?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicDateTimePicker"
                                    model: string
                                    dateTime?: any | null
                                  }
                                | {
                                    __typename?: "BasicLabel"
                                    model: string
                                    label?: any | null
                                  }
                                | {
                                    __typename?: "BasicMediaPicker"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicMemberPicker"
                                    model: string
                                    members: Array<{
                                      __typename?: "BasicMemberPickerItem"
                                      id?: number | null
                                      name?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicMultiUrlPicker"
                                    model: string
                                    links: Array<{
                                      __typename?: "BasicMultiUrlPickerItem"
                                      name?: string | null
                                      target?: string | null
                                      type: LinkType
                                      url?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicNestedContent"
                                    model: string
                                    elements?: Array<{
                                      __typename?: "BasicNestedContentElement"
                                      properties: Array<{
                                        __typename?: "BasicProperty"
                                        alias?: string | null
                                        editorAlias?: string | null
                                        value?:
                                          | {
                                              __typename?: "BasicBlockGridModel"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicBlockListModel"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicContentPicker"
                                              model: string
                                              contentList: Array<{
                                                __typename?: "BasicContentPickerItem"
                                                id: number
                                                absoluteUrl: string
                                                key: any
                                                name?: string | null
                                                url: string
                                                urlSegment?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicDateTimePicker"
                                              model: string
                                              dateTime?: any | null
                                            }
                                          | {
                                              __typename?: "BasicLabel"
                                              model: string
                                              label?: any | null
                                            }
                                          | {
                                              __typename?: "BasicMediaPicker"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicMemberPicker"
                                              model: string
                                              members: Array<{
                                                __typename?: "BasicMemberPickerItem"
                                                id?: number | null
                                                name?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicMultiUrlPicker"
                                              model: string
                                              links: Array<{
                                                __typename?: "BasicMultiUrlPickerItem"
                                                name?: string | null
                                                target?: string | null
                                                type: LinkType
                                                url?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicNestedContent"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicPropertyValue"
                                              model: string
                                              value?: any | null
                                            }
                                          | {
                                              __typename?: "BasicRichText"
                                              model: string
                                              richText?: string | null
                                            }
                                          | {
                                              __typename?: "BasicUnsupportedPropertyValue"
                                              model: string
                                              message: string
                                            }
                                          | {
                                              __typename?: "MintMediaPicker"
                                              model: string
                                              mediaItems: Array<{
                                                __typename?: "MintMediaPickerItem"
                                                id: number
                                                url: string
                                                altText?: string | null
                                              }>
                                            }
                                          | null
                                      } | null>
                                    }> | null
                                  }
                                | {
                                    __typename?: "BasicPropertyValue"
                                    model: string
                                    value?: any | null
                                  }
                                | {
                                    __typename?: "BasicRichText"
                                    model: string
                                    richText?: string | null
                                  }
                                | {
                                    __typename?: "BasicUnsupportedPropertyValue"
                                    model: string
                                    message: string
                                  }
                                | {
                                    __typename?: "MintMediaPicker"
                                    model: string
                                    mediaItems: Array<{
                                      __typename?: "MintMediaPickerItem"
                                      id: number
                                      url: string
                                      altText?: string | null
                                    }>
                                  }
                                | null
                            } | null>
                          }>
                        }
                      | {
                          __typename?: "BasicMultiUrlPicker"
                          valueType: string
                          links: Array<{
                            __typename?: "BasicMultiUrlPickerItem"
                            name?: string | null
                            target?: string | null
                            type: LinkType
                            url?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicNestedContent"
                          valueType: string
                          elements?: Array<{
                            __typename?: "BasicNestedContentElement"
                            properties: Array<{
                              __typename?: "BasicProperty"
                              alias?: string | null
                              editorAlias?: string | null
                              value?:
                                | {
                                    __typename?: "BasicBlockGridModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicBlockListModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicContentPicker"
                                    model: string
                                    contentList: Array<{
                                      __typename?: "BasicContentPickerItem"
                                      id: number
                                      absoluteUrl: string
                                      key: any
                                      name?: string | null
                                      url: string
                                      urlSegment?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicDateTimePicker"
                                    model: string
                                    dateTime?: any | null
                                  }
                                | {
                                    __typename?: "BasicLabel"
                                    model: string
                                    label?: any | null
                                  }
                                | {
                                    __typename?: "BasicMediaPicker"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicMemberPicker"
                                    model: string
                                    members: Array<{
                                      __typename?: "BasicMemberPickerItem"
                                      id?: number | null
                                      name?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicMultiUrlPicker"
                                    model: string
                                    links: Array<{
                                      __typename?: "BasicMultiUrlPickerItem"
                                      name?: string | null
                                      target?: string | null
                                      type: LinkType
                                      url?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicNestedContent"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicPropertyValue"
                                    model: string
                                    value?: any | null
                                  }
                                | {
                                    __typename?: "BasicRichText"
                                    model: string
                                    richText?: string | null
                                  }
                                | {
                                    __typename?: "BasicUnsupportedPropertyValue"
                                    model: string
                                    message: string
                                  }
                                | {
                                    __typename?: "MintMediaPicker"
                                    model: string
                                    mediaItems: Array<{
                                      __typename?: "MintMediaPickerItem"
                                      id: number
                                      url: string
                                      altText?: string | null
                                    }>
                                  }
                                | null
                            } | null>
                          }> | null
                        }
                      | {
                          __typename?: "BasicPropertyValue"
                          valueType: string
                          value?: any | null
                        }
                      | {
                          __typename?: "BasicRichText"
                          valueType: string
                          richText?: string | null
                        }
                      | {
                          __typename?: "BasicUnsupportedPropertyValue"
                          message: string
                          valueType: string
                        }
                      | {
                          __typename?: "MintMediaPicker"
                          valueType: string
                          mediaItems: Array<{
                            __typename?: "MintMediaPickerItem"
                            id: number
                            url: string
                            altText?: string | null
                          }>
                        }
                      | null
                  } | null>
                  settingsProperties: Array<{
                    __typename?: "BasicProperty"
                    value?:
                      | {
                          __typename?: "BasicBlockGridModel"
                          valueType: string
                        }
                      | {
                          __typename?: "BasicBlockListModel"
                          valueType: string
                        }
                      | {
                          __typename?: "BasicContentPicker"
                          valueType: string
                          contentList: Array<{
                            __typename?: "BasicContentPickerItem"
                            id: number
                            absoluteUrl: string
                            key: any
                            name?: string | null
                            url: string
                            urlSegment?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicDateTimePicker"
                          valueType: string
                          dateTime?: any | null
                        }
                      | {
                          __typename?: "BasicLabel"
                          valueType: string
                          label?: any | null
                        }
                      | { __typename?: "BasicMediaPicker"; valueType: string }
                      | {
                          __typename?: "BasicMemberPicker"
                          valueType: string
                          members: Array<{
                            __typename?: "BasicMemberPickerItem"
                            id?: number | null
                            name?: string | null
                            properties: Array<{
                              __typename?: "BasicProperty"
                              alias?: string | null
                              editorAlias?: string | null
                              value?:
                                | {
                                    __typename?: "BasicBlockGridModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicBlockListModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicContentPicker"
                                    model: string
                                    contentList: Array<{
                                      __typename?: "BasicContentPickerItem"
                                      id: number
                                      absoluteUrl: string
                                      key: any
                                      name?: string | null
                                      url: string
                                      urlSegment?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicDateTimePicker"
                                    model: string
                                    dateTime?: any | null
                                  }
                                | {
                                    __typename?: "BasicLabel"
                                    model: string
                                    label?: any | null
                                  }
                                | {
                                    __typename?: "BasicMediaPicker"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicMemberPicker"
                                    model: string
                                    members: Array<{
                                      __typename?: "BasicMemberPickerItem"
                                      id?: number | null
                                      name?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicMultiUrlPicker"
                                    model: string
                                    links: Array<{
                                      __typename?: "BasicMultiUrlPickerItem"
                                      name?: string | null
                                      target?: string | null
                                      type: LinkType
                                      url?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicNestedContent"
                                    model: string
                                    elements?: Array<{
                                      __typename?: "BasicNestedContentElement"
                                      properties: Array<{
                                        __typename?: "BasicProperty"
                                        alias?: string | null
                                        editorAlias?: string | null
                                        value?:
                                          | {
                                              __typename?: "BasicBlockGridModel"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicBlockListModel"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicContentPicker"
                                              model: string
                                              contentList: Array<{
                                                __typename?: "BasicContentPickerItem"
                                                id: number
                                                absoluteUrl: string
                                                key: any
                                                name?: string | null
                                                url: string
                                                urlSegment?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicDateTimePicker"
                                              model: string
                                              dateTime?: any | null
                                            }
                                          | {
                                              __typename?: "BasicLabel"
                                              model: string
                                              label?: any | null
                                            }
                                          | {
                                              __typename?: "BasicMediaPicker"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicMemberPicker"
                                              model: string
                                              members: Array<{
                                                __typename?: "BasicMemberPickerItem"
                                                id?: number | null
                                                name?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicMultiUrlPicker"
                                              model: string
                                              links: Array<{
                                                __typename?: "BasicMultiUrlPickerItem"
                                                name?: string | null
                                                target?: string | null
                                                type: LinkType
                                                url?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicNestedContent"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicPropertyValue"
                                              model: string
                                              value?: any | null
                                            }
                                          | {
                                              __typename?: "BasicRichText"
                                              model: string
                                              richText?: string | null
                                            }
                                          | {
                                              __typename?: "BasicUnsupportedPropertyValue"
                                              model: string
                                              message: string
                                            }
                                          | {
                                              __typename?: "MintMediaPicker"
                                              model: string
                                              mediaItems: Array<{
                                                __typename?: "MintMediaPickerItem"
                                                id: number
                                                url: string
                                                altText?: string | null
                                              }>
                                            }
                                          | null
                                      } | null>
                                    }> | null
                                  }
                                | {
                                    __typename?: "BasicPropertyValue"
                                    model: string
                                    value?: any | null
                                  }
                                | {
                                    __typename?: "BasicRichText"
                                    model: string
                                    richText?: string | null
                                  }
                                | {
                                    __typename?: "BasicUnsupportedPropertyValue"
                                    model: string
                                    message: string
                                  }
                                | {
                                    __typename?: "MintMediaPicker"
                                    model: string
                                    mediaItems: Array<{
                                      __typename?: "MintMediaPickerItem"
                                      id: number
                                      url: string
                                      altText?: string | null
                                    }>
                                  }
                                | null
                            } | null>
                          }>
                        }
                      | {
                          __typename?: "BasicMultiUrlPicker"
                          valueType: string
                          links: Array<{
                            __typename?: "BasicMultiUrlPickerItem"
                            name?: string | null
                            target?: string | null
                            type: LinkType
                            url?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicNestedContent"
                          valueType: string
                          elements?: Array<{
                            __typename?: "BasicNestedContentElement"
                            properties: Array<{
                              __typename?: "BasicProperty"
                              alias?: string | null
                              editorAlias?: string | null
                              value?:
                                | {
                                    __typename?: "BasicBlockGridModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicBlockListModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicContentPicker"
                                    model: string
                                    contentList: Array<{
                                      __typename?: "BasicContentPickerItem"
                                      id: number
                                      absoluteUrl: string
                                      key: any
                                      name?: string | null
                                      url: string
                                      urlSegment?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicDateTimePicker"
                                    model: string
                                    dateTime?: any | null
                                  }
                                | {
                                    __typename?: "BasicLabel"
                                    model: string
                                    label?: any | null
                                  }
                                | {
                                    __typename?: "BasicMediaPicker"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicMemberPicker"
                                    model: string
                                    members: Array<{
                                      __typename?: "BasicMemberPickerItem"
                                      id?: number | null
                                      name?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicMultiUrlPicker"
                                    model: string
                                    links: Array<{
                                      __typename?: "BasicMultiUrlPickerItem"
                                      name?: string | null
                                      target?: string | null
                                      type: LinkType
                                      url?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicNestedContent"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicPropertyValue"
                                    model: string
                                    value?: any | null
                                  }
                                | {
                                    __typename?: "BasicRichText"
                                    model: string
                                    richText?: string | null
                                  }
                                | {
                                    __typename?: "BasicUnsupportedPropertyValue"
                                    model: string
                                    message: string
                                  }
                                | {
                                    __typename?: "MintMediaPicker"
                                    model: string
                                    mediaItems: Array<{
                                      __typename?: "MintMediaPickerItem"
                                      id: number
                                      url: string
                                      altText?: string | null
                                    }>
                                  }
                                | null
                            } | null>
                          }> | null
                        }
                      | {
                          __typename?: "BasicPropertyValue"
                          valueType: string
                          value?: any | null
                        }
                      | {
                          __typename?: "BasicRichText"
                          valueType: string
                          richText?: string | null
                        }
                      | {
                          __typename?: "BasicUnsupportedPropertyValue"
                          message: string
                          valueType: string
                        }
                      | {
                          __typename?: "MintMediaPicker"
                          valueType: string
                          mediaItems: Array<{
                            __typename?: "MintMediaPickerItem"
                            id: number
                            url: string
                            altText?: string | null
                          }>
                        }
                      | null
                  } | null>
                  areas: Array<{
                    __typename?: "BasicBlockGridArea"
                    alias?: string | null
                    rowSpan: number
                    columnSpan: number
                  } | null>
                }> | null
              } | null>
            }> | null
          }
        | {
            __typename?: "BasicBlockListModel"
            valueType: string
            blocks?: Array<{
              __typename?: "BasicBlockListItem"
              blockType?: string | null
              properties: Array<{
                __typename?: "BasicProperty"
                propertyName?: string | null
                propertyValue?:
                  | { __typename?: "BasicBlockGridModel"; valueType: string }
                  | {
                      __typename?: "BasicBlockListModel"
                      valueType: string
                      blocks?: Array<{
                        __typename?: "BasicBlockListItem"
                        blockType?: string | null
                        properties: Array<{
                          __typename?: "BasicProperty"
                          propertyName?: string | null
                          propertyValue?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                valueType: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                valueType: string
                                blocks?: Array<{
                                  __typename?: "BasicBlockListItem"
                                  blockType?: string | null
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    propertyName?: string | null
                                    propertyValue?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          valueType: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          valueType: string
                                          blocks?: Array<{
                                            __typename?: "BasicBlockListItem"
                                            blockType?: string | null
                                            properties: Array<{
                                              __typename?: "BasicProperty"
                                              propertyName?: string | null
                                              propertyValue?:
                                                | {
                                                    __typename?: "BasicBlockGridModel"
                                                    valueType: string
                                                  }
                                                | {
                                                    __typename?: "BasicBlockListModel"
                                                    valueType: string
                                                    blocks?: Array<{
                                                      __typename?: "BasicBlockListItem"
                                                      blockType?: string | null
                                                      properties: Array<{
                                                        __typename?: "BasicProperty"
                                                        propertyName?:
                                                          | string
                                                          | null
                                                        propertyValue?:
                                                          | {
                                                              __typename?: "BasicBlockGridModel"
                                                              valueType: string
                                                            }
                                                          | {
                                                              __typename?: "BasicBlockListModel"
                                                              valueType: string
                                                            }
                                                          | {
                                                              __typename?: "BasicContentPicker"
                                                              valueType: string
                                                              contentList: Array<{
                                                                __typename?: "BasicContentPickerItem"
                                                                id: number
                                                                absoluteUrl: string
                                                                key: any
                                                                name?:
                                                                  | string
                                                                  | null
                                                                url: string
                                                                urlSegment?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicDateTimePicker"
                                                              valueType: string
                                                              dateTime?:
                                                                | any
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicLabel"
                                                              valueType: string
                                                              label?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicMediaPicker"
                                                              valueType: string
                                                            }
                                                          | {
                                                              __typename?: "BasicMemberPicker"
                                                              valueType: string
                                                              members: Array<{
                                                                __typename?: "BasicMemberPickerItem"
                                                                id?:
                                                                  | number
                                                                  | null
                                                                name?:
                                                                  | string
                                                                  | null
                                                                properties: Array<{
                                                                  __typename?: "BasicProperty"
                                                                  alias?:
                                                                    | string
                                                                    | null
                                                                  editorAlias?:
                                                                    | string
                                                                    | null
                                                                  value?:
                                                                    | {
                                                                        __typename?: "BasicBlockGridModel"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicBlockListModel"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicContentPicker"
                                                                        model: string
                                                                        contentList: Array<{
                                                                          __typename?: "BasicContentPickerItem"
                                                                          id: number
                                                                          absoluteUrl: string
                                                                          key: any
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                          url: string
                                                                          urlSegment?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicDateTimePicker"
                                                                        model: string
                                                                        dateTime?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicLabel"
                                                                        model: string
                                                                        label?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMediaPicker"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMemberPicker"
                                                                        model: string
                                                                        members: Array<{
                                                                          __typename?: "BasicMemberPickerItem"
                                                                          id?:
                                                                            | number
                                                                            | null
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMultiUrlPicker"
                                                                        model: string
                                                                        links: Array<{
                                                                          __typename?: "BasicMultiUrlPickerItem"
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                          target?:
                                                                            | string
                                                                            | null
                                                                          type: LinkType
                                                                          url?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicNestedContent"
                                                                        model: string
                                                                        elements?: Array<{
                                                                          __typename?: "BasicNestedContentElement"
                                                                          properties: Array<{
                                                                            __typename?: "BasicProperty"
                                                                            alias?:
                                                                              | string
                                                                              | null
                                                                            editorAlias?:
                                                                              | string
                                                                              | null
                                                                            value?:
                                                                              | {
                                                                                  __typename?: "BasicBlockGridModel"
                                                                                  model: string
                                                                                }
                                                                              | {
                                                                                  __typename?: "BasicBlockListModel"
                                                                                  model: string
                                                                                }
                                                                              | {
                                                                                  __typename?: "BasicContentPicker"
                                                                                  model: string
                                                                                  contentList: Array<{
                                                                                    __typename?: "BasicContentPickerItem"
                                                                                    id: number
                                                                                    absoluteUrl: string
                                                                                    key: any
                                                                                    name?:
                                                                                      | string
                                                                                      | null
                                                                                    url: string
                                                                                    urlSegment?:
                                                                                      | string
                                                                                      | null
                                                                                  }>
                                                                                }
                                                                              | {
                                                                                  __typename?: "BasicDateTimePicker"
                                                                                  model: string
                                                                                  dateTime?:
                                                                                    | any
                                                                                    | null
                                                                                }
                                                                              | {
                                                                                  __typename?: "BasicLabel"
                                                                                  model: string
                                                                                  label?:
                                                                                    | any
                                                                                    | null
                                                                                }
                                                                              | {
                                                                                  __typename?: "BasicMediaPicker"
                                                                                  model: string
                                                                                }
                                                                              | {
                                                                                  __typename?: "BasicMemberPicker"
                                                                                  model: string
                                                                                  members: Array<{
                                                                                    __typename?: "BasicMemberPickerItem"
                                                                                    id?:
                                                                                      | number
                                                                                      | null
                                                                                    name?:
                                                                                      | string
                                                                                      | null
                                                                                  }>
                                                                                }
                                                                              | {
                                                                                  __typename?: "BasicMultiUrlPicker"
                                                                                  model: string
                                                                                  links: Array<{
                                                                                    __typename?: "BasicMultiUrlPickerItem"
                                                                                    name?:
                                                                                      | string
                                                                                      | null
                                                                                    target?:
                                                                                      | string
                                                                                      | null
                                                                                    type: LinkType
                                                                                    url?:
                                                                                      | string
                                                                                      | null
                                                                                  }>
                                                                                }
                                                                              | {
                                                                                  __typename?: "BasicNestedContent"
                                                                                  model: string
                                                                                }
                                                                              | {
                                                                                  __typename?: "BasicPropertyValue"
                                                                                  model: string
                                                                                  value?:
                                                                                    | any
                                                                                    | null
                                                                                }
                                                                              | {
                                                                                  __typename?: "BasicRichText"
                                                                                  model: string
                                                                                  richText?:
                                                                                    | string
                                                                                    | null
                                                                                }
                                                                              | {
                                                                                  __typename?: "BasicUnsupportedPropertyValue"
                                                                                  model: string
                                                                                  message: string
                                                                                }
                                                                              | {
                                                                                  __typename?: "MintMediaPicker"
                                                                                  model: string
                                                                                  mediaItems: Array<{
                                                                                    __typename?: "MintMediaPickerItem"
                                                                                    id: number
                                                                                    url: string
                                                                                    altText?:
                                                                                      | string
                                                                                      | null
                                                                                  }>
                                                                                }
                                                                              | null
                                                                          } | null>
                                                                        }> | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicPropertyValue"
                                                                        model: string
                                                                        value?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicRichText"
                                                                        model: string
                                                                        richText?:
                                                                          | string
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicUnsupportedPropertyValue"
                                                                        model: string
                                                                        message: string
                                                                      }
                                                                    | {
                                                                        __typename?: "MintMediaPicker"
                                                                        model: string
                                                                        mediaItems: Array<{
                                                                          __typename?: "MintMediaPickerItem"
                                                                          id: number
                                                                          url: string
                                                                          altText?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | null
                                                                } | null>
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicMultiUrlPicker"
                                                              valueType: string
                                                              links: Array<{
                                                                __typename?: "BasicMultiUrlPickerItem"
                                                                name?:
                                                                  | string
                                                                  | null
                                                                target?:
                                                                  | string
                                                                  | null
                                                                type: LinkType
                                                                url?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicNestedContent"
                                                              valueType: string
                                                              elements?: Array<{
                                                                __typename?: "BasicNestedContentElement"
                                                                properties: Array<{
                                                                  __typename?: "BasicProperty"
                                                                  alias?:
                                                                    | string
                                                                    | null
                                                                  editorAlias?:
                                                                    | string
                                                                    | null
                                                                  value?:
                                                                    | {
                                                                        __typename?: "BasicBlockGridModel"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicBlockListModel"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicContentPicker"
                                                                        model: string
                                                                        contentList: Array<{
                                                                          __typename?: "BasicContentPickerItem"
                                                                          id: number
                                                                          absoluteUrl: string
                                                                          key: any
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                          url: string
                                                                          urlSegment?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicDateTimePicker"
                                                                        model: string
                                                                        dateTime?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicLabel"
                                                                        model: string
                                                                        label?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMediaPicker"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMemberPicker"
                                                                        model: string
                                                                        members: Array<{
                                                                          __typename?: "BasicMemberPickerItem"
                                                                          id?:
                                                                            | number
                                                                            | null
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMultiUrlPicker"
                                                                        model: string
                                                                        links: Array<{
                                                                          __typename?: "BasicMultiUrlPickerItem"
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                          target?:
                                                                            | string
                                                                            | null
                                                                          type: LinkType
                                                                          url?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicNestedContent"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicPropertyValue"
                                                                        model: string
                                                                        value?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicRichText"
                                                                        model: string
                                                                        richText?:
                                                                          | string
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicUnsupportedPropertyValue"
                                                                        model: string
                                                                        message: string
                                                                      }
                                                                    | {
                                                                        __typename?: "MintMediaPicker"
                                                                        model: string
                                                                        mediaItems: Array<{
                                                                          __typename?: "MintMediaPickerItem"
                                                                          id: number
                                                                          url: string
                                                                          altText?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | null
                                                                } | null>
                                                              }> | null
                                                            }
                                                          | {
                                                              __typename?: "BasicPropertyValue"
                                                              valueType: string
                                                              value?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicRichText"
                                                              valueType: string
                                                              richText?:
                                                                | string
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicUnsupportedPropertyValue"
                                                              message: string
                                                              valueType: string
                                                            }
                                                          | {
                                                              __typename?: "MintMediaPicker"
                                                              valueType: string
                                                              mediaItems: Array<{
                                                                __typename?: "MintMediaPickerItem"
                                                                id: number
                                                                url: string
                                                                altText?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | null
                                                      } | null>
                                                    }> | null
                                                  }
                                                | {
                                                    __typename?: "BasicContentPicker"
                                                    valueType: string
                                                    contentList: Array<{
                                                      __typename?: "BasicContentPickerItem"
                                                      id: number
                                                      absoluteUrl: string
                                                      key: any
                                                      name?: string | null
                                                      url: string
                                                      urlSegment?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicDateTimePicker"
                                                    valueType: string
                                                    dateTime?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicLabel"
                                                    valueType: string
                                                    label?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicMediaPicker"
                                                    valueType: string
                                                  }
                                                | {
                                                    __typename?: "BasicMemberPicker"
                                                    valueType: string
                                                    members: Array<{
                                                      __typename?: "BasicMemberPickerItem"
                                                      id?: number | null
                                                      name?: string | null
                                                      properties: Array<{
                                                        __typename?: "BasicProperty"
                                                        alias?: string | null
                                                        editorAlias?:
                                                          | string
                                                          | null
                                                        value?:
                                                          | {
                                                              __typename?: "BasicBlockGridModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicBlockListModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicContentPicker"
                                                              model: string
                                                              contentList: Array<{
                                                                __typename?: "BasicContentPickerItem"
                                                                id: number
                                                                absoluteUrl: string
                                                                key: any
                                                                name?:
                                                                  | string
                                                                  | null
                                                                url: string
                                                                urlSegment?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicDateTimePicker"
                                                              model: string
                                                              dateTime?:
                                                                | any
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicLabel"
                                                              model: string
                                                              label?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicMediaPicker"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicMemberPicker"
                                                              model: string
                                                              members: Array<{
                                                                __typename?: "BasicMemberPickerItem"
                                                                id?:
                                                                  | number
                                                                  | null
                                                                name?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicMultiUrlPicker"
                                                              model: string
                                                              links: Array<{
                                                                __typename?: "BasicMultiUrlPickerItem"
                                                                name?:
                                                                  | string
                                                                  | null
                                                                target?:
                                                                  | string
                                                                  | null
                                                                type: LinkType
                                                                url?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicNestedContent"
                                                              model: string
                                                              elements?: Array<{
                                                                __typename?: "BasicNestedContentElement"
                                                                properties: Array<{
                                                                  __typename?: "BasicProperty"
                                                                  alias?:
                                                                    | string
                                                                    | null
                                                                  editorAlias?:
                                                                    | string
                                                                    | null
                                                                  value?:
                                                                    | {
                                                                        __typename?: "BasicBlockGridModel"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicBlockListModel"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicContentPicker"
                                                                        model: string
                                                                        contentList: Array<{
                                                                          __typename?: "BasicContentPickerItem"
                                                                          id: number
                                                                          absoluteUrl: string
                                                                          key: any
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                          url: string
                                                                          urlSegment?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicDateTimePicker"
                                                                        model: string
                                                                        dateTime?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicLabel"
                                                                        model: string
                                                                        label?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMediaPicker"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMemberPicker"
                                                                        model: string
                                                                        members: Array<{
                                                                          __typename?: "BasicMemberPickerItem"
                                                                          id?:
                                                                            | number
                                                                            | null
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMultiUrlPicker"
                                                                        model: string
                                                                        links: Array<{
                                                                          __typename?: "BasicMultiUrlPickerItem"
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                          target?:
                                                                            | string
                                                                            | null
                                                                          type: LinkType
                                                                          url?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicNestedContent"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicPropertyValue"
                                                                        model: string
                                                                        value?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicRichText"
                                                                        model: string
                                                                        richText?:
                                                                          | string
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicUnsupportedPropertyValue"
                                                                        model: string
                                                                        message: string
                                                                      }
                                                                    | {
                                                                        __typename?: "MintMediaPicker"
                                                                        model: string
                                                                        mediaItems: Array<{
                                                                          __typename?: "MintMediaPickerItem"
                                                                          id: number
                                                                          url: string
                                                                          altText?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | null
                                                                } | null>
                                                              }> | null
                                                            }
                                                          | {
                                                              __typename?: "BasicPropertyValue"
                                                              model: string
                                                              value?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicRichText"
                                                              model: string
                                                              richText?:
                                                                | string
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicUnsupportedPropertyValue"
                                                              model: string
                                                              message: string
                                                            }
                                                          | {
                                                              __typename?: "MintMediaPicker"
                                                              model: string
                                                              mediaItems: Array<{
                                                                __typename?: "MintMediaPickerItem"
                                                                id: number
                                                                url: string
                                                                altText?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | null
                                                      } | null>
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicMultiUrlPicker"
                                                    valueType: string
                                                    links: Array<{
                                                      __typename?: "BasicMultiUrlPickerItem"
                                                      name?: string | null
                                                      target?: string | null
                                                      type: LinkType
                                                      url?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicNestedContent"
                                                    valueType: string
                                                    elements?: Array<{
                                                      __typename?: "BasicNestedContentElement"
                                                      properties: Array<{
                                                        __typename?: "BasicProperty"
                                                        alias?: string | null
                                                        editorAlias?:
                                                          | string
                                                          | null
                                                        value?:
                                                          | {
                                                              __typename?: "BasicBlockGridModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicBlockListModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicContentPicker"
                                                              model: string
                                                              contentList: Array<{
                                                                __typename?: "BasicContentPickerItem"
                                                                id: number
                                                                absoluteUrl: string
                                                                key: any
                                                                name?:
                                                                  | string
                                                                  | null
                                                                url: string
                                                                urlSegment?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicDateTimePicker"
                                                              model: string
                                                              dateTime?:
                                                                | any
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicLabel"
                                                              model: string
                                                              label?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicMediaPicker"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicMemberPicker"
                                                              model: string
                                                              members: Array<{
                                                                __typename?: "BasicMemberPickerItem"
                                                                id?:
                                                                  | number
                                                                  | null
                                                                name?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicMultiUrlPicker"
                                                              model: string
                                                              links: Array<{
                                                                __typename?: "BasicMultiUrlPickerItem"
                                                                name?:
                                                                  | string
                                                                  | null
                                                                target?:
                                                                  | string
                                                                  | null
                                                                type: LinkType
                                                                url?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicNestedContent"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicPropertyValue"
                                                              model: string
                                                              value?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicRichText"
                                                              model: string
                                                              richText?:
                                                                | string
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicUnsupportedPropertyValue"
                                                              model: string
                                                              message: string
                                                            }
                                                          | {
                                                              __typename?: "MintMediaPicker"
                                                              model: string
                                                              mediaItems: Array<{
                                                                __typename?: "MintMediaPickerItem"
                                                                id: number
                                                                url: string
                                                                altText?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | null
                                                      } | null>
                                                    }> | null
                                                  }
                                                | {
                                                    __typename?: "BasicPropertyValue"
                                                    valueType: string
                                                    value?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicRichText"
                                                    valueType: string
                                                    richText?: string | null
                                                  }
                                                | {
                                                    __typename?: "BasicUnsupportedPropertyValue"
                                                    message: string
                                                    valueType: string
                                                  }
                                                | {
                                                    __typename?: "MintMediaPicker"
                                                    valueType: string
                                                    mediaItems: Array<{
                                                      __typename?: "MintMediaPickerItem"
                                                      id: number
                                                      url: string
                                                      altText?: string | null
                                                    }>
                                                  }
                                                | null
                                            } | null>
                                          }> | null
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          valueType: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          valueType: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          valueType: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          valueType: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          valueType: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                            properties: Array<{
                                              __typename?: "BasicProperty"
                                              alias?: string | null
                                              editorAlias?: string | null
                                              value?:
                                                | {
                                                    __typename?: "BasicBlockGridModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicBlockListModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicContentPicker"
                                                    model: string
                                                    contentList: Array<{
                                                      __typename?: "BasicContentPickerItem"
                                                      id: number
                                                      absoluteUrl: string
                                                      key: any
                                                      name?: string | null
                                                      url: string
                                                      urlSegment?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicDateTimePicker"
                                                    model: string
                                                    dateTime?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicLabel"
                                                    model: string
                                                    label?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicMediaPicker"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicMemberPicker"
                                                    model: string
                                                    members: Array<{
                                                      __typename?: "BasicMemberPickerItem"
                                                      id?: number | null
                                                      name?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicMultiUrlPicker"
                                                    model: string
                                                    links: Array<{
                                                      __typename?: "BasicMultiUrlPickerItem"
                                                      name?: string | null
                                                      target?: string | null
                                                      type: LinkType
                                                      url?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicNestedContent"
                                                    model: string
                                                    elements?: Array<{
                                                      __typename?: "BasicNestedContentElement"
                                                      properties: Array<{
                                                        __typename?: "BasicProperty"
                                                        alias?: string | null
                                                        editorAlias?:
                                                          | string
                                                          | null
                                                        value?:
                                                          | {
                                                              __typename?: "BasicBlockGridModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicBlockListModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicContentPicker"
                                                              model: string
                                                              contentList: Array<{
                                                                __typename?: "BasicContentPickerItem"
                                                                id: number
                                                                absoluteUrl: string
                                                                key: any
                                                                name?:
                                                                  | string
                                                                  | null
                                                                url: string
                                                                urlSegment?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicDateTimePicker"
                                                              model: string
                                                              dateTime?:
                                                                | any
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicLabel"
                                                              model: string
                                                              label?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicMediaPicker"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicMemberPicker"
                                                              model: string
                                                              members: Array<{
                                                                __typename?: "BasicMemberPickerItem"
                                                                id?:
                                                                  | number
                                                                  | null
                                                                name?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicMultiUrlPicker"
                                                              model: string
                                                              links: Array<{
                                                                __typename?: "BasicMultiUrlPickerItem"
                                                                name?:
                                                                  | string
                                                                  | null
                                                                target?:
                                                                  | string
                                                                  | null
                                                                type: LinkType
                                                                url?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicNestedContent"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicPropertyValue"
                                                              model: string
                                                              value?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicRichText"
                                                              model: string
                                                              richText?:
                                                                | string
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicUnsupportedPropertyValue"
                                                              model: string
                                                              message: string
                                                            }
                                                          | {
                                                              __typename?: "MintMediaPicker"
                                                              model: string
                                                              mediaItems: Array<{
                                                                __typename?: "MintMediaPickerItem"
                                                                id: number
                                                                url: string
                                                                altText?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | null
                                                      } | null>
                                                    }> | null
                                                  }
                                                | {
                                                    __typename?: "BasicPropertyValue"
                                                    model: string
                                                    value?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicRichText"
                                                    model: string
                                                    richText?: string | null
                                                  }
                                                | {
                                                    __typename?: "BasicUnsupportedPropertyValue"
                                                    model: string
                                                    message: string
                                                  }
                                                | {
                                                    __typename?: "MintMediaPicker"
                                                    model: string
                                                    mediaItems: Array<{
                                                      __typename?: "MintMediaPickerItem"
                                                      id: number
                                                      url: string
                                                      altText?: string | null
                                                    }>
                                                  }
                                                | null
                                            } | null>
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          valueType: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          valueType: string
                                          elements?: Array<{
                                            __typename?: "BasicNestedContentElement"
                                            properties: Array<{
                                              __typename?: "BasicProperty"
                                              alias?: string | null
                                              editorAlias?: string | null
                                              value?:
                                                | {
                                                    __typename?: "BasicBlockGridModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicBlockListModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicContentPicker"
                                                    model: string
                                                    contentList: Array<{
                                                      __typename?: "BasicContentPickerItem"
                                                      id: number
                                                      absoluteUrl: string
                                                      key: any
                                                      name?: string | null
                                                      url: string
                                                      urlSegment?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicDateTimePicker"
                                                    model: string
                                                    dateTime?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicLabel"
                                                    model: string
                                                    label?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicMediaPicker"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicMemberPicker"
                                                    model: string
                                                    members: Array<{
                                                      __typename?: "BasicMemberPickerItem"
                                                      id?: number | null
                                                      name?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicMultiUrlPicker"
                                                    model: string
                                                    links: Array<{
                                                      __typename?: "BasicMultiUrlPickerItem"
                                                      name?: string | null
                                                      target?: string | null
                                                      type: LinkType
                                                      url?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicNestedContent"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicPropertyValue"
                                                    model: string
                                                    value?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicRichText"
                                                    model: string
                                                    richText?: string | null
                                                  }
                                                | {
                                                    __typename?: "BasicUnsupportedPropertyValue"
                                                    model: string
                                                    message: string
                                                  }
                                                | {
                                                    __typename?: "MintMediaPicker"
                                                    model: string
                                                    mediaItems: Array<{
                                                      __typename?: "MintMediaPickerItem"
                                                      id: number
                                                      url: string
                                                      altText?: string | null
                                                    }>
                                                  }
                                                | null
                                            } | null>
                                          }> | null
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          valueType: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          valueType: string
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          message: string
                                          valueType: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          valueType: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }> | null
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                valueType: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                valueType: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                valueType: string
                                label?: any | null
                              }
                            | {
                                __typename?: "BasicMediaPicker"
                                valueType: string
                              }
                            | {
                                __typename?: "BasicMemberPicker"
                                valueType: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    alias?: string | null
                                    editorAlias?: string | null
                                    value?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          model: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          model: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          model: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          model: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          model: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          model: string
                                          elements?: Array<{
                                            __typename?: "BasicNestedContentElement"
                                            properties: Array<{
                                              __typename?: "BasicProperty"
                                              alias?: string | null
                                              editorAlias?: string | null
                                              value?:
                                                | {
                                                    __typename?: "BasicBlockGridModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicBlockListModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicContentPicker"
                                                    model: string
                                                    contentList: Array<{
                                                      __typename?: "BasicContentPickerItem"
                                                      id: number
                                                      absoluteUrl: string
                                                      key: any
                                                      name?: string | null
                                                      url: string
                                                      urlSegment?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicDateTimePicker"
                                                    model: string
                                                    dateTime?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicLabel"
                                                    model: string
                                                    label?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicMediaPicker"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicMemberPicker"
                                                    model: string
                                                    members: Array<{
                                                      __typename?: "BasicMemberPickerItem"
                                                      id?: number | null
                                                      name?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicMultiUrlPicker"
                                                    model: string
                                                    links: Array<{
                                                      __typename?: "BasicMultiUrlPickerItem"
                                                      name?: string | null
                                                      target?: string | null
                                                      type: LinkType
                                                      url?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicNestedContent"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicPropertyValue"
                                                    model: string
                                                    value?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicRichText"
                                                    model: string
                                                    richText?: string | null
                                                  }
                                                | {
                                                    __typename?: "BasicUnsupportedPropertyValue"
                                                    model: string
                                                    message: string
                                                  }
                                                | {
                                                    __typename?: "MintMediaPicker"
                                                    model: string
                                                    mediaItems: Array<{
                                                      __typename?: "MintMediaPickerItem"
                                                      id: number
                                                      url: string
                                                      altText?: string | null
                                                    }>
                                                  }
                                                | null
                                            } | null>
                                          }> | null
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          model: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          model: string
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          model: string
                                          message: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          model: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                valueType: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                valueType: string
                                elements?: Array<{
                                  __typename?: "BasicNestedContentElement"
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    alias?: string | null
                                    editorAlias?: string | null
                                    value?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          model: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          model: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          model: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          model: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          model: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          model: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          model: string
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          model: string
                                          message: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          model: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }> | null
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                valueType: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                valueType: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                message: string
                                valueType: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                valueType: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicContentPicker"
                      valueType: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      valueType: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      valueType: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; valueType: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      valueType: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                                elements?: Array<{
                                  __typename?: "BasicNestedContentElement"
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    alias?: string | null
                                    editorAlias?: string | null
                                    value?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          model: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          model: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          model: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          model: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          model: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          model: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          model: string
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          model: string
                                          message: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          model: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }> | null
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      valueType: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicNestedContent"
                      valueType: string
                      elements?: Array<{
                        __typename?: "BasicNestedContentElement"
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicPropertyValue"
                      valueType: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      valueType: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      message: string
                      valueType: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      valueType: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }> | null
          }
        | {
            __typename?: "BasicContentPicker"
            valueType: string
            contentList: Array<{
              __typename?: "BasicContentPickerItem"
              id: number
              absoluteUrl: string
              key: any
              name?: string | null
              url: string
              urlSegment?: string | null
            }>
          }
        | {
            __typename?: "BasicDateTimePicker"
            valueType: string
            dateTime?: any | null
          }
        | { __typename?: "BasicLabel"; valueType: string; label?: any | null }
        | { __typename?: "BasicMediaPicker"; valueType: string }
        | {
            __typename?: "BasicMemberPicker"
            valueType: string
            members: Array<{
              __typename?: "BasicMemberPickerItem"
              id?: number | null
              name?: string | null
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicNestedContent"
                      model: string
                      elements?: Array<{
                        __typename?: "BasicNestedContentElement"
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }>
          }
        | {
            __typename?: "BasicMultiUrlPicker"
            valueType: string
            links: Array<{
              __typename?: "BasicMultiUrlPickerItem"
              name?: string | null
              target?: string | null
              type: LinkType
              url?: string | null
            }>
          }
        | {
            __typename?: "BasicNestedContent"
            valueType: string
            elements?: Array<{
              __typename?: "BasicNestedContentElement"
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | { __typename?: "BasicNestedContent"; model: string }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }> | null
          }
        | {
            __typename?: "BasicPropertyValue"
            valueType: string
            value?: any | null
          }
        | {
            __typename?: "BasicRichText"
            valueType: string
            richText?: string | null
          }
        | {
            __typename?: "BasicUnsupportedPropertyValue"
            message: string
            valueType: string
          }
        | {
            __typename?: "MintMediaPicker"
            valueType: string
            mediaItems: Array<{
              __typename?: "MintMediaPickerItem"
              id: number
              url: string
              altText?: string | null
            }>
          }
        | null
    } | null> | null
  } | null
}

type PropertyEditors_BasicBlockGridModel_Fragment = {
  __typename?: "BasicBlockGridModel"
  valueType: string
}

type PropertyEditors_BasicBlockListModel_Fragment = {
  __typename?: "BasicBlockListModel"
  valueType: string
}

type PropertyEditors_BasicContentPicker_Fragment = {
  __typename?: "BasicContentPicker"
  valueType: string
  contentList: Array<{
    __typename?: "BasicContentPickerItem"
    id: number
    absoluteUrl: string
    key: any
    name?: string | null
    url: string
    urlSegment?: string | null
  }>
}

type PropertyEditors_BasicDateTimePicker_Fragment = {
  __typename?: "BasicDateTimePicker"
  valueType: string
  dateTime?: any | null
}

type PropertyEditors_BasicLabel_Fragment = {
  __typename?: "BasicLabel"
  valueType: string
  label?: any | null
}

type PropertyEditors_BasicMediaPicker_Fragment = {
  __typename?: "BasicMediaPicker"
  valueType: string
}

type PropertyEditors_BasicMemberPicker_Fragment = {
  __typename?: "BasicMemberPicker"
  valueType: string
  members: Array<{
    __typename?: "BasicMemberPickerItem"
    id?: number | null
    name?: string | null
    properties: Array<{
      __typename?: "BasicProperty"
      alias?: string | null
      editorAlias?: string | null
      value?:
        | { __typename?: "BasicBlockGridModel"; model: string }
        | { __typename?: "BasicBlockListModel"; model: string }
        | {
            __typename?: "BasicContentPicker"
            model: string
            contentList: Array<{
              __typename?: "BasicContentPickerItem"
              id: number
              absoluteUrl: string
              key: any
              name?: string | null
              url: string
              urlSegment?: string | null
            }>
          }
        | {
            __typename?: "BasicDateTimePicker"
            model: string
            dateTime?: any | null
          }
        | { __typename?: "BasicLabel"; model: string; label?: any | null }
        | { __typename?: "BasicMediaPicker"; model: string }
        | {
            __typename?: "BasicMemberPicker"
            model: string
            members: Array<{
              __typename?: "BasicMemberPickerItem"
              id?: number | null
              name?: string | null
            }>
          }
        | {
            __typename?: "BasicMultiUrlPicker"
            model: string
            links: Array<{
              __typename?: "BasicMultiUrlPickerItem"
              name?: string | null
              target?: string | null
              type: LinkType
              url?: string | null
            }>
          }
        | {
            __typename?: "BasicNestedContent"
            model: string
            elements?: Array<{
              __typename?: "BasicNestedContentElement"
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | { __typename?: "BasicNestedContent"; model: string }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }> | null
          }
        | {
            __typename?: "BasicPropertyValue"
            model: string
            value?: any | null
          }
        | {
            __typename?: "BasicRichText"
            model: string
            richText?: string | null
          }
        | {
            __typename?: "BasicUnsupportedPropertyValue"
            model: string
            message: string
          }
        | {
            __typename?: "MintMediaPicker"
            model: string
            mediaItems: Array<{
              __typename?: "MintMediaPickerItem"
              id: number
              url: string
              altText?: string | null
            }>
          }
        | null
    } | null>
  }>
}

type PropertyEditors_BasicMultiUrlPicker_Fragment = {
  __typename?: "BasicMultiUrlPicker"
  valueType: string
  links: Array<{
    __typename?: "BasicMultiUrlPickerItem"
    name?: string | null
    target?: string | null
    type: LinkType
    url?: string | null
  }>
}

type PropertyEditors_BasicNestedContent_Fragment = {
  __typename?: "BasicNestedContent"
  valueType: string
  elements?: Array<{
    __typename?: "BasicNestedContentElement"
    properties: Array<{
      __typename?: "BasicProperty"
      alias?: string | null
      editorAlias?: string | null
      value?:
        | { __typename?: "BasicBlockGridModel"; model: string }
        | { __typename?: "BasicBlockListModel"; model: string }
        | {
            __typename?: "BasicContentPicker"
            model: string
            contentList: Array<{
              __typename?: "BasicContentPickerItem"
              id: number
              absoluteUrl: string
              key: any
              name?: string | null
              url: string
              urlSegment?: string | null
            }>
          }
        | {
            __typename?: "BasicDateTimePicker"
            model: string
            dateTime?: any | null
          }
        | { __typename?: "BasicLabel"; model: string; label?: any | null }
        | { __typename?: "BasicMediaPicker"; model: string }
        | {
            __typename?: "BasicMemberPicker"
            model: string
            members: Array<{
              __typename?: "BasicMemberPickerItem"
              id?: number | null
              name?: string | null
            }>
          }
        | {
            __typename?: "BasicMultiUrlPicker"
            model: string
            links: Array<{
              __typename?: "BasicMultiUrlPickerItem"
              name?: string | null
              target?: string | null
              type: LinkType
              url?: string | null
            }>
          }
        | { __typename?: "BasicNestedContent"; model: string }
        | {
            __typename?: "BasicPropertyValue"
            model: string
            value?: any | null
          }
        | {
            __typename?: "BasicRichText"
            model: string
            richText?: string | null
          }
        | {
            __typename?: "BasicUnsupportedPropertyValue"
            model: string
            message: string
          }
        | {
            __typename?: "MintMediaPicker"
            model: string
            mediaItems: Array<{
              __typename?: "MintMediaPickerItem"
              id: number
              url: string
              altText?: string | null
            }>
          }
        | null
    } | null>
  }> | null
}

type PropertyEditors_BasicPropertyValue_Fragment = {
  __typename?: "BasicPropertyValue"
  valueType: string
  value?: any | null
}

type PropertyEditors_BasicRichText_Fragment = {
  __typename?: "BasicRichText"
  valueType: string
  richText?: string | null
}

type PropertyEditors_BasicUnsupportedPropertyValue_Fragment = {
  __typename?: "BasicUnsupportedPropertyValue"
  message: string
  valueType: string
}

type PropertyEditors_MintMediaPicker_Fragment = {
  __typename?: "MintMediaPicker"
  valueType: string
  mediaItems: Array<{
    __typename?: "MintMediaPickerItem"
    id: number
    url: string
    altText?: string | null
  }>
}

export type PropertyEditorsFragment =
  | PropertyEditors_BasicBlockGridModel_Fragment
  | PropertyEditors_BasicBlockListModel_Fragment
  | PropertyEditors_BasicContentPicker_Fragment
  | PropertyEditors_BasicDateTimePicker_Fragment
  | PropertyEditors_BasicLabel_Fragment
  | PropertyEditors_BasicMediaPicker_Fragment
  | PropertyEditors_BasicMemberPicker_Fragment
  | PropertyEditors_BasicMultiUrlPicker_Fragment
  | PropertyEditors_BasicNestedContent_Fragment
  | PropertyEditors_BasicPropertyValue_Fragment
  | PropertyEditors_BasicRichText_Fragment
  | PropertyEditors_BasicUnsupportedPropertyValue_Fragment
  | PropertyEditors_MintMediaPicker_Fragment

type MediaPicker_BasicBlockGridModel_Fragment = {
  __typename?: "BasicBlockGridModel"
}

type MediaPicker_BasicBlockListModel_Fragment = {
  __typename?: "BasicBlockListModel"
}

type MediaPicker_BasicContentPicker_Fragment = {
  __typename?: "BasicContentPicker"
}

type MediaPicker_BasicDateTimePicker_Fragment = {
  __typename?: "BasicDateTimePicker"
}

type MediaPicker_BasicLabel_Fragment = { __typename?: "BasicLabel" }

type MediaPicker_BasicMediaPicker_Fragment = { __typename?: "BasicMediaPicker" }

type MediaPicker_BasicMemberPicker_Fragment = {
  __typename?: "BasicMemberPicker"
}

type MediaPicker_BasicMultiUrlPicker_Fragment = {
  __typename?: "BasicMultiUrlPicker"
}

type MediaPicker_BasicNestedContent_Fragment = {
  __typename?: "BasicNestedContent"
}

type MediaPicker_BasicPropertyValue_Fragment = {
  __typename?: "BasicPropertyValue"
}

type MediaPicker_BasicRichText_Fragment = { __typename?: "BasicRichText" }

type MediaPicker_BasicUnsupportedPropertyValue_Fragment = {
  __typename?: "BasicUnsupportedPropertyValue"
}

type MediaPicker_MintMediaPicker_Fragment = {
  __typename?: "MintMediaPicker"
  mediaItems: Array<{
    __typename?: "MintMediaPickerItem"
    id: number
    url: string
    altText?: string | null
  }>
}

export type MediaPickerFragment =
  | MediaPicker_BasicBlockGridModel_Fragment
  | MediaPicker_BasicBlockListModel_Fragment
  | MediaPicker_BasicContentPicker_Fragment
  | MediaPicker_BasicDateTimePicker_Fragment
  | MediaPicker_BasicLabel_Fragment
  | MediaPicker_BasicMediaPicker_Fragment
  | MediaPicker_BasicMemberPicker_Fragment
  | MediaPicker_BasicMultiUrlPicker_Fragment
  | MediaPicker_BasicNestedContent_Fragment
  | MediaPicker_BasicPropertyValue_Fragment
  | MediaPicker_BasicRichText_Fragment
  | MediaPicker_BasicUnsupportedPropertyValue_Fragment
  | MediaPicker_MintMediaPicker_Fragment

type MemberPicker_BasicBlockGridModel_Fragment = {
  __typename?: "BasicBlockGridModel"
}

type MemberPicker_BasicBlockListModel_Fragment = {
  __typename?: "BasicBlockListModel"
}

type MemberPicker_BasicContentPicker_Fragment = {
  __typename?: "BasicContentPicker"
}

type MemberPicker_BasicDateTimePicker_Fragment = {
  __typename?: "BasicDateTimePicker"
}

type MemberPicker_BasicLabel_Fragment = { __typename?: "BasicLabel" }

type MemberPicker_BasicMediaPicker_Fragment = {
  __typename?: "BasicMediaPicker"
}

type MemberPicker_BasicMemberPicker_Fragment = {
  __typename?: "BasicMemberPicker"
  members: Array<{
    __typename?: "BasicMemberPickerItem"
    id?: number | null
    name?: string | null
    properties: Array<{
      __typename?: "BasicProperty"
      alias?: string | null
      editorAlias?: string | null
      value?:
        | { __typename?: "BasicBlockGridModel"; model: string }
        | { __typename?: "BasicBlockListModel"; model: string }
        | {
            __typename?: "BasicContentPicker"
            model: string
            contentList: Array<{
              __typename?: "BasicContentPickerItem"
              id: number
              absoluteUrl: string
              key: any
              name?: string | null
              url: string
              urlSegment?: string | null
            }>
          }
        | {
            __typename?: "BasicDateTimePicker"
            model: string
            dateTime?: any | null
          }
        | { __typename?: "BasicLabel"; model: string; label?: any | null }
        | { __typename?: "BasicMediaPicker"; model: string }
        | {
            __typename?: "BasicMemberPicker"
            model: string
            members: Array<{
              __typename?: "BasicMemberPickerItem"
              id?: number | null
              name?: string | null
            }>
          }
        | {
            __typename?: "BasicMultiUrlPicker"
            model: string
            links: Array<{
              __typename?: "BasicMultiUrlPickerItem"
              name?: string | null
              target?: string | null
              type: LinkType
              url?: string | null
            }>
          }
        | {
            __typename?: "BasicNestedContent"
            model: string
            elements?: Array<{
              __typename?: "BasicNestedContentElement"
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | { __typename?: "BasicNestedContent"; model: string }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }> | null
          }
        | {
            __typename?: "BasicPropertyValue"
            model: string
            value?: any | null
          }
        | {
            __typename?: "BasicRichText"
            model: string
            richText?: string | null
          }
        | {
            __typename?: "BasicUnsupportedPropertyValue"
            model: string
            message: string
          }
        | {
            __typename?: "MintMediaPicker"
            model: string
            mediaItems: Array<{
              __typename?: "MintMediaPickerItem"
              id: number
              url: string
              altText?: string | null
            }>
          }
        | null
    } | null>
  }>
}

type MemberPicker_BasicMultiUrlPicker_Fragment = {
  __typename?: "BasicMultiUrlPicker"
}

type MemberPicker_BasicNestedContent_Fragment = {
  __typename?: "BasicNestedContent"
}

type MemberPicker_BasicPropertyValue_Fragment = {
  __typename?: "BasicPropertyValue"
}

type MemberPicker_BasicRichText_Fragment = { __typename?: "BasicRichText" }

type MemberPicker_BasicUnsupportedPropertyValue_Fragment = {
  __typename?: "BasicUnsupportedPropertyValue"
}

type MemberPicker_MintMediaPicker_Fragment = { __typename?: "MintMediaPicker" }

export type MemberPickerFragment =
  | MemberPicker_BasicBlockGridModel_Fragment
  | MemberPicker_BasicBlockListModel_Fragment
  | MemberPicker_BasicContentPicker_Fragment
  | MemberPicker_BasicDateTimePicker_Fragment
  | MemberPicker_BasicLabel_Fragment
  | MemberPicker_BasicMediaPicker_Fragment
  | MemberPicker_BasicMemberPicker_Fragment
  | MemberPicker_BasicMultiUrlPicker_Fragment
  | MemberPicker_BasicNestedContent_Fragment
  | MemberPicker_BasicPropertyValue_Fragment
  | MemberPicker_BasicRichText_Fragment
  | MemberPicker_BasicUnsupportedPropertyValue_Fragment
  | MemberPicker_MintMediaPicker_Fragment

type MemberPropertyEditors_BasicBlockGridModel_Fragment = {
  __typename?: "BasicBlockGridModel"
  model: string
}

type MemberPropertyEditors_BasicBlockListModel_Fragment = {
  __typename?: "BasicBlockListModel"
  model: string
}

type MemberPropertyEditors_BasicContentPicker_Fragment = {
  __typename?: "BasicContentPicker"
  model: string
  contentList: Array<{
    __typename?: "BasicContentPickerItem"
    id: number
    absoluteUrl: string
    key: any
    name?: string | null
    url: string
    urlSegment?: string | null
  }>
}

type MemberPropertyEditors_BasicDateTimePicker_Fragment = {
  __typename?: "BasicDateTimePicker"
  model: string
  dateTime?: any | null
}

type MemberPropertyEditors_BasicLabel_Fragment = {
  __typename?: "BasicLabel"
  model: string
  label?: any | null
}

type MemberPropertyEditors_BasicMediaPicker_Fragment = {
  __typename?: "BasicMediaPicker"
  model: string
}

type MemberPropertyEditors_BasicMemberPicker_Fragment = {
  __typename?: "BasicMemberPicker"
  model: string
  members: Array<{
    __typename?: "BasicMemberPickerItem"
    id?: number | null
    name?: string | null
  }>
}

type MemberPropertyEditors_BasicMultiUrlPicker_Fragment = {
  __typename?: "BasicMultiUrlPicker"
  model: string
  links: Array<{
    __typename?: "BasicMultiUrlPickerItem"
    name?: string | null
    target?: string | null
    type: LinkType
    url?: string | null
  }>
}

type MemberPropertyEditors_BasicNestedContent_Fragment = {
  __typename?: "BasicNestedContent"
  model: string
  elements?: Array<{
    __typename?: "BasicNestedContentElement"
    properties: Array<{
      __typename?: "BasicProperty"
      alias?: string | null
      editorAlias?: string | null
      value?:
        | { __typename?: "BasicBlockGridModel"; model: string }
        | { __typename?: "BasicBlockListModel"; model: string }
        | {
            __typename?: "BasicContentPicker"
            model: string
            contentList: Array<{
              __typename?: "BasicContentPickerItem"
              id: number
              absoluteUrl: string
              key: any
              name?: string | null
              url: string
              urlSegment?: string | null
            }>
          }
        | {
            __typename?: "BasicDateTimePicker"
            model: string
            dateTime?: any | null
          }
        | { __typename?: "BasicLabel"; model: string; label?: any | null }
        | { __typename?: "BasicMediaPicker"; model: string }
        | {
            __typename?: "BasicMemberPicker"
            model: string
            members: Array<{
              __typename?: "BasicMemberPickerItem"
              id?: number | null
              name?: string | null
            }>
          }
        | {
            __typename?: "BasicMultiUrlPicker"
            model: string
            links: Array<{
              __typename?: "BasicMultiUrlPickerItem"
              name?: string | null
              target?: string | null
              type: LinkType
              url?: string | null
            }>
          }
        | { __typename?: "BasicNestedContent"; model: string }
        | {
            __typename?: "BasicPropertyValue"
            model: string
            value?: any | null
          }
        | {
            __typename?: "BasicRichText"
            model: string
            richText?: string | null
          }
        | {
            __typename?: "BasicUnsupportedPropertyValue"
            model: string
            message: string
          }
        | {
            __typename?: "MintMediaPicker"
            model: string
            mediaItems: Array<{
              __typename?: "MintMediaPickerItem"
              id: number
              url: string
              altText?: string | null
            }>
          }
        | null
    } | null>
  }> | null
}

type MemberPropertyEditors_BasicPropertyValue_Fragment = {
  __typename?: "BasicPropertyValue"
  model: string
  value?: any | null
}

type MemberPropertyEditors_BasicRichText_Fragment = {
  __typename?: "BasicRichText"
  model: string
  richText?: string | null
}

type MemberPropertyEditors_BasicUnsupportedPropertyValue_Fragment = {
  __typename?: "BasicUnsupportedPropertyValue"
  model: string
  message: string
}

type MemberPropertyEditors_MintMediaPicker_Fragment = {
  __typename?: "MintMediaPicker"
  model: string
  mediaItems: Array<{
    __typename?: "MintMediaPickerItem"
    id: number
    url: string
    altText?: string | null
  }>
}

export type MemberPropertyEditorsFragment =
  | MemberPropertyEditors_BasicBlockGridModel_Fragment
  | MemberPropertyEditors_BasicBlockListModel_Fragment
  | MemberPropertyEditors_BasicContentPicker_Fragment
  | MemberPropertyEditors_BasicDateTimePicker_Fragment
  | MemberPropertyEditors_BasicLabel_Fragment
  | MemberPropertyEditors_BasicMediaPicker_Fragment
  | MemberPropertyEditors_BasicMemberPicker_Fragment
  | MemberPropertyEditors_BasicMultiUrlPicker_Fragment
  | MemberPropertyEditors_BasicNestedContent_Fragment
  | MemberPropertyEditors_BasicPropertyValue_Fragment
  | MemberPropertyEditors_BasicRichText_Fragment
  | MemberPropertyEditors_BasicUnsupportedPropertyValue_Fragment
  | MemberPropertyEditors_MintMediaPicker_Fragment

type NestedContent_BasicBlockGridModel_Fragment = {
  __typename?: "BasicBlockGridModel"
}

type NestedContent_BasicBlockListModel_Fragment = {
  __typename?: "BasicBlockListModel"
}

type NestedContent_BasicContentPicker_Fragment = {
  __typename?: "BasicContentPicker"
}

type NestedContent_BasicDateTimePicker_Fragment = {
  __typename?: "BasicDateTimePicker"
}

type NestedContent_BasicLabel_Fragment = { __typename?: "BasicLabel" }

type NestedContent_BasicMediaPicker_Fragment = {
  __typename?: "BasicMediaPicker"
}

type NestedContent_BasicMemberPicker_Fragment = {
  __typename?: "BasicMemberPicker"
}

type NestedContent_BasicMultiUrlPicker_Fragment = {
  __typename?: "BasicMultiUrlPicker"
}

type NestedContent_BasicNestedContent_Fragment = {
  __typename?: "BasicNestedContent"
  elements?: Array<{
    __typename?: "BasicNestedContentElement"
    properties: Array<{
      __typename?: "BasicProperty"
      alias?: string | null
      editorAlias?: string | null
      value?:
        | { __typename?: "BasicBlockGridModel"; model: string }
        | { __typename?: "BasicBlockListModel"; model: string }
        | {
            __typename?: "BasicContentPicker"
            model: string
            contentList: Array<{
              __typename?: "BasicContentPickerItem"
              id: number
              absoluteUrl: string
              key: any
              name?: string | null
              url: string
              urlSegment?: string | null
            }>
          }
        | {
            __typename?: "BasicDateTimePicker"
            model: string
            dateTime?: any | null
          }
        | { __typename?: "BasicLabel"; model: string; label?: any | null }
        | { __typename?: "BasicMediaPicker"; model: string }
        | {
            __typename?: "BasicMemberPicker"
            model: string
            members: Array<{
              __typename?: "BasicMemberPickerItem"
              id?: number | null
              name?: string | null
            }>
          }
        | {
            __typename?: "BasicMultiUrlPicker"
            model: string
            links: Array<{
              __typename?: "BasicMultiUrlPickerItem"
              name?: string | null
              target?: string | null
              type: LinkType
              url?: string | null
            }>
          }
        | { __typename?: "BasicNestedContent"; model: string }
        | {
            __typename?: "BasicPropertyValue"
            model: string
            value?: any | null
          }
        | {
            __typename?: "BasicRichText"
            model: string
            richText?: string | null
          }
        | {
            __typename?: "BasicUnsupportedPropertyValue"
            model: string
            message: string
          }
        | {
            __typename?: "MintMediaPicker"
            model: string
            mediaItems: Array<{
              __typename?: "MintMediaPickerItem"
              id: number
              url: string
              altText?: string | null
            }>
          }
        | null
    } | null>
  }> | null
}

type NestedContent_BasicPropertyValue_Fragment = {
  __typename?: "BasicPropertyValue"
}

type NestedContent_BasicRichText_Fragment = { __typename?: "BasicRichText" }

type NestedContent_BasicUnsupportedPropertyValue_Fragment = {
  __typename?: "BasicUnsupportedPropertyValue"
}

type NestedContent_MintMediaPicker_Fragment = { __typename?: "MintMediaPicker" }

export type NestedContentFragment =
  | NestedContent_BasicBlockGridModel_Fragment
  | NestedContent_BasicBlockListModel_Fragment
  | NestedContent_BasicContentPicker_Fragment
  | NestedContent_BasicDateTimePicker_Fragment
  | NestedContent_BasicLabel_Fragment
  | NestedContent_BasicMediaPicker_Fragment
  | NestedContent_BasicMemberPicker_Fragment
  | NestedContent_BasicMultiUrlPicker_Fragment
  | NestedContent_BasicNestedContent_Fragment
  | NestedContent_BasicPropertyValue_Fragment
  | NestedContent_BasicRichText_Fragment
  | NestedContent_BasicUnsupportedPropertyValue_Fragment
  | NestedContent_MintMediaPicker_Fragment

type NestedContentPropertyEditors_BasicBlockGridModel_Fragment = {
  __typename?: "BasicBlockGridModel"
  model: string
}

type NestedContentPropertyEditors_BasicBlockListModel_Fragment = {
  __typename?: "BasicBlockListModel"
  model: string
}

type NestedContentPropertyEditors_BasicContentPicker_Fragment = {
  __typename?: "BasicContentPicker"
  model: string
  contentList: Array<{
    __typename?: "BasicContentPickerItem"
    id: number
    absoluteUrl: string
    key: any
    name?: string | null
    url: string
    urlSegment?: string | null
  }>
}

type NestedContentPropertyEditors_BasicDateTimePicker_Fragment = {
  __typename?: "BasicDateTimePicker"
  model: string
  dateTime?: any | null
}

type NestedContentPropertyEditors_BasicLabel_Fragment = {
  __typename?: "BasicLabel"
  model: string
  label?: any | null
}

type NestedContentPropertyEditors_BasicMediaPicker_Fragment = {
  __typename?: "BasicMediaPicker"
  model: string
}

type NestedContentPropertyEditors_BasicMemberPicker_Fragment = {
  __typename?: "BasicMemberPicker"
  model: string
  members: Array<{
    __typename?: "BasicMemberPickerItem"
    id?: number | null
    name?: string | null
  }>
}

type NestedContentPropertyEditors_BasicMultiUrlPicker_Fragment = {
  __typename?: "BasicMultiUrlPicker"
  model: string
  links: Array<{
    __typename?: "BasicMultiUrlPickerItem"
    name?: string | null
    target?: string | null
    type: LinkType
    url?: string | null
  }>
}

type NestedContentPropertyEditors_BasicNestedContent_Fragment = {
  __typename?: "BasicNestedContent"
  model: string
}

type NestedContentPropertyEditors_BasicPropertyValue_Fragment = {
  __typename?: "BasicPropertyValue"
  model: string
  value?: any | null
}

type NestedContentPropertyEditors_BasicRichText_Fragment = {
  __typename?: "BasicRichText"
  model: string
  richText?: string | null
}

type NestedContentPropertyEditors_BasicUnsupportedPropertyValue_Fragment = {
  __typename?: "BasicUnsupportedPropertyValue"
  model: string
  message: string
}

type NestedContentPropertyEditors_MintMediaPicker_Fragment = {
  __typename?: "MintMediaPicker"
  model: string
  mediaItems: Array<{
    __typename?: "MintMediaPickerItem"
    id: number
    url: string
    altText?: string | null
  }>
}

export type NestedContentPropertyEditorsFragment =
  | NestedContentPropertyEditors_BasicBlockGridModel_Fragment
  | NestedContentPropertyEditors_BasicBlockListModel_Fragment
  | NestedContentPropertyEditors_BasicContentPicker_Fragment
  | NestedContentPropertyEditors_BasicDateTimePicker_Fragment
  | NestedContentPropertyEditors_BasicLabel_Fragment
  | NestedContentPropertyEditors_BasicMediaPicker_Fragment
  | NestedContentPropertyEditors_BasicMemberPicker_Fragment
  | NestedContentPropertyEditors_BasicMultiUrlPicker_Fragment
  | NestedContentPropertyEditors_BasicNestedContent_Fragment
  | NestedContentPropertyEditors_BasicPropertyValue_Fragment
  | NestedContentPropertyEditors_BasicRichText_Fragment
  | NestedContentPropertyEditors_BasicUnsupportedPropertyValue_Fragment
  | NestedContentPropertyEditors_MintMediaPicker_Fragment

type BlockEditor_BasicBlockGridModel_Fragment = {
  __typename?: "BasicBlockGridModel"
}

type BlockEditor_BasicBlockListModel_Fragment = {
  __typename?: "BasicBlockListModel"
  blocks?: Array<{
    __typename?: "BasicBlockListItem"
    blockType?: string | null
    properties: Array<{
      __typename?: "BasicProperty"
      propertyName?: string | null
      propertyValue?:
        | { __typename?: "BasicBlockGridModel"; valueType: string }
        | {
            __typename?: "BasicBlockListModel"
            valueType: string
            blocks?: Array<{
              __typename?: "BasicBlockListItem"
              blockType?: string | null
              properties: Array<{
                __typename?: "BasicProperty"
                propertyName?: string | null
                propertyValue?:
                  | { __typename?: "BasicBlockGridModel"; valueType: string }
                  | {
                      __typename?: "BasicBlockListModel"
                      valueType: string
                      blocks?: Array<{
                        __typename?: "BasicBlockListItem"
                        blockType?: string | null
                        properties: Array<{
                          __typename?: "BasicProperty"
                          propertyName?: string | null
                          propertyValue?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                valueType: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                valueType: string
                                blocks?: Array<{
                                  __typename?: "BasicBlockListItem"
                                  blockType?: string | null
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    propertyName?: string | null
                                    propertyValue?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          valueType: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          valueType: string
                                          blocks?: Array<{
                                            __typename?: "BasicBlockListItem"
                                            blockType?: string | null
                                            properties: Array<{
                                              __typename?: "BasicProperty"
                                              propertyName?: string | null
                                              propertyValue?:
                                                | {
                                                    __typename?: "BasicBlockGridModel"
                                                    valueType: string
                                                  }
                                                | {
                                                    __typename?: "BasicBlockListModel"
                                                    valueType: string
                                                  }
                                                | {
                                                    __typename?: "BasicContentPicker"
                                                    valueType: string
                                                    contentList: Array<{
                                                      __typename?: "BasicContentPickerItem"
                                                      id: number
                                                      absoluteUrl: string
                                                      key: any
                                                      name?: string | null
                                                      url: string
                                                      urlSegment?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicDateTimePicker"
                                                    valueType: string
                                                    dateTime?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicLabel"
                                                    valueType: string
                                                    label?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicMediaPicker"
                                                    valueType: string
                                                  }
                                                | {
                                                    __typename?: "BasicMemberPicker"
                                                    valueType: string
                                                    members: Array<{
                                                      __typename?: "BasicMemberPickerItem"
                                                      id?: number | null
                                                      name?: string | null
                                                      properties: Array<{
                                                        __typename?: "BasicProperty"
                                                        alias?: string | null
                                                        editorAlias?:
                                                          | string
                                                          | null
                                                        value?:
                                                          | {
                                                              __typename?: "BasicBlockGridModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicBlockListModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicContentPicker"
                                                              model: string
                                                              contentList: Array<{
                                                                __typename?: "BasicContentPickerItem"
                                                                id: number
                                                                absoluteUrl: string
                                                                key: any
                                                                name?:
                                                                  | string
                                                                  | null
                                                                url: string
                                                                urlSegment?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicDateTimePicker"
                                                              model: string
                                                              dateTime?:
                                                                | any
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicLabel"
                                                              model: string
                                                              label?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicMediaPicker"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicMemberPicker"
                                                              model: string
                                                              members: Array<{
                                                                __typename?: "BasicMemberPickerItem"
                                                                id?:
                                                                  | number
                                                                  | null
                                                                name?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicMultiUrlPicker"
                                                              model: string
                                                              links: Array<{
                                                                __typename?: "BasicMultiUrlPickerItem"
                                                                name?:
                                                                  | string
                                                                  | null
                                                                target?:
                                                                  | string
                                                                  | null
                                                                type: LinkType
                                                                url?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicNestedContent"
                                                              model: string
                                                              elements?: Array<{
                                                                __typename?: "BasicNestedContentElement"
                                                                properties: Array<{
                                                                  __typename?: "BasicProperty"
                                                                  alias?:
                                                                    | string
                                                                    | null
                                                                  editorAlias?:
                                                                    | string
                                                                    | null
                                                                  value?:
                                                                    | {
                                                                        __typename?: "BasicBlockGridModel"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicBlockListModel"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicContentPicker"
                                                                        model: string
                                                                        contentList: Array<{
                                                                          __typename?: "BasicContentPickerItem"
                                                                          id: number
                                                                          absoluteUrl: string
                                                                          key: any
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                          url: string
                                                                          urlSegment?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicDateTimePicker"
                                                                        model: string
                                                                        dateTime?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicLabel"
                                                                        model: string
                                                                        label?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMediaPicker"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMemberPicker"
                                                                        model: string
                                                                        members: Array<{
                                                                          __typename?: "BasicMemberPickerItem"
                                                                          id?:
                                                                            | number
                                                                            | null
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMultiUrlPicker"
                                                                        model: string
                                                                        links: Array<{
                                                                          __typename?: "BasicMultiUrlPickerItem"
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                          target?:
                                                                            | string
                                                                            | null
                                                                          type: LinkType
                                                                          url?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicNestedContent"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicPropertyValue"
                                                                        model: string
                                                                        value?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicRichText"
                                                                        model: string
                                                                        richText?:
                                                                          | string
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicUnsupportedPropertyValue"
                                                                        model: string
                                                                        message: string
                                                                      }
                                                                    | {
                                                                        __typename?: "MintMediaPicker"
                                                                        model: string
                                                                        mediaItems: Array<{
                                                                          __typename?: "MintMediaPickerItem"
                                                                          id: number
                                                                          url: string
                                                                          altText?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | null
                                                                } | null>
                                                              }> | null
                                                            }
                                                          | {
                                                              __typename?: "BasicPropertyValue"
                                                              model: string
                                                              value?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicRichText"
                                                              model: string
                                                              richText?:
                                                                | string
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicUnsupportedPropertyValue"
                                                              model: string
                                                              message: string
                                                            }
                                                          | {
                                                              __typename?: "MintMediaPicker"
                                                              model: string
                                                              mediaItems: Array<{
                                                                __typename?: "MintMediaPickerItem"
                                                                id: number
                                                                url: string
                                                                altText?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | null
                                                      } | null>
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicMultiUrlPicker"
                                                    valueType: string
                                                    links: Array<{
                                                      __typename?: "BasicMultiUrlPickerItem"
                                                      name?: string | null
                                                      target?: string | null
                                                      type: LinkType
                                                      url?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicNestedContent"
                                                    valueType: string
                                                    elements?: Array<{
                                                      __typename?: "BasicNestedContentElement"
                                                      properties: Array<{
                                                        __typename?: "BasicProperty"
                                                        alias?: string | null
                                                        editorAlias?:
                                                          | string
                                                          | null
                                                        value?:
                                                          | {
                                                              __typename?: "BasicBlockGridModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicBlockListModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicContentPicker"
                                                              model: string
                                                              contentList: Array<{
                                                                __typename?: "BasicContentPickerItem"
                                                                id: number
                                                                absoluteUrl: string
                                                                key: any
                                                                name?:
                                                                  | string
                                                                  | null
                                                                url: string
                                                                urlSegment?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicDateTimePicker"
                                                              model: string
                                                              dateTime?:
                                                                | any
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicLabel"
                                                              model: string
                                                              label?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicMediaPicker"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicMemberPicker"
                                                              model: string
                                                              members: Array<{
                                                                __typename?: "BasicMemberPickerItem"
                                                                id?:
                                                                  | number
                                                                  | null
                                                                name?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicMultiUrlPicker"
                                                              model: string
                                                              links: Array<{
                                                                __typename?: "BasicMultiUrlPickerItem"
                                                                name?:
                                                                  | string
                                                                  | null
                                                                target?:
                                                                  | string
                                                                  | null
                                                                type: LinkType
                                                                url?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicNestedContent"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicPropertyValue"
                                                              model: string
                                                              value?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicRichText"
                                                              model: string
                                                              richText?:
                                                                | string
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicUnsupportedPropertyValue"
                                                              model: string
                                                              message: string
                                                            }
                                                          | {
                                                              __typename?: "MintMediaPicker"
                                                              model: string
                                                              mediaItems: Array<{
                                                                __typename?: "MintMediaPickerItem"
                                                                id: number
                                                                url: string
                                                                altText?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | null
                                                      } | null>
                                                    }> | null
                                                  }
                                                | {
                                                    __typename?: "BasicPropertyValue"
                                                    valueType: string
                                                    value?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicRichText"
                                                    valueType: string
                                                    richText?: string | null
                                                  }
                                                | {
                                                    __typename?: "BasicUnsupportedPropertyValue"
                                                    message: string
                                                    valueType: string
                                                  }
                                                | {
                                                    __typename?: "MintMediaPicker"
                                                    valueType: string
                                                    mediaItems: Array<{
                                                      __typename?: "MintMediaPickerItem"
                                                      id: number
                                                      url: string
                                                      altText?: string | null
                                                    }>
                                                  }
                                                | null
                                            } | null>
                                          }> | null
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          valueType: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          valueType: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          valueType: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          valueType: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          valueType: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                            properties: Array<{
                                              __typename?: "BasicProperty"
                                              alias?: string | null
                                              editorAlias?: string | null
                                              value?:
                                                | {
                                                    __typename?: "BasicBlockGridModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicBlockListModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicContentPicker"
                                                    model: string
                                                    contentList: Array<{
                                                      __typename?: "BasicContentPickerItem"
                                                      id: number
                                                      absoluteUrl: string
                                                      key: any
                                                      name?: string | null
                                                      url: string
                                                      urlSegment?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicDateTimePicker"
                                                    model: string
                                                    dateTime?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicLabel"
                                                    model: string
                                                    label?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicMediaPicker"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicMemberPicker"
                                                    model: string
                                                    members: Array<{
                                                      __typename?: "BasicMemberPickerItem"
                                                      id?: number | null
                                                      name?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicMultiUrlPicker"
                                                    model: string
                                                    links: Array<{
                                                      __typename?: "BasicMultiUrlPickerItem"
                                                      name?: string | null
                                                      target?: string | null
                                                      type: LinkType
                                                      url?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicNestedContent"
                                                    model: string
                                                    elements?: Array<{
                                                      __typename?: "BasicNestedContentElement"
                                                      properties: Array<{
                                                        __typename?: "BasicProperty"
                                                        alias?: string | null
                                                        editorAlias?:
                                                          | string
                                                          | null
                                                        value?:
                                                          | {
                                                              __typename?: "BasicBlockGridModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicBlockListModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicContentPicker"
                                                              model: string
                                                              contentList: Array<{
                                                                __typename?: "BasicContentPickerItem"
                                                                id: number
                                                                absoluteUrl: string
                                                                key: any
                                                                name?:
                                                                  | string
                                                                  | null
                                                                url: string
                                                                urlSegment?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicDateTimePicker"
                                                              model: string
                                                              dateTime?:
                                                                | any
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicLabel"
                                                              model: string
                                                              label?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicMediaPicker"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicMemberPicker"
                                                              model: string
                                                              members: Array<{
                                                                __typename?: "BasicMemberPickerItem"
                                                                id?:
                                                                  | number
                                                                  | null
                                                                name?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicMultiUrlPicker"
                                                              model: string
                                                              links: Array<{
                                                                __typename?: "BasicMultiUrlPickerItem"
                                                                name?:
                                                                  | string
                                                                  | null
                                                                target?:
                                                                  | string
                                                                  | null
                                                                type: LinkType
                                                                url?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicNestedContent"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicPropertyValue"
                                                              model: string
                                                              value?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicRichText"
                                                              model: string
                                                              richText?:
                                                                | string
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicUnsupportedPropertyValue"
                                                              model: string
                                                              message: string
                                                            }
                                                          | {
                                                              __typename?: "MintMediaPicker"
                                                              model: string
                                                              mediaItems: Array<{
                                                                __typename?: "MintMediaPickerItem"
                                                                id: number
                                                                url: string
                                                                altText?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | null
                                                      } | null>
                                                    }> | null
                                                  }
                                                | {
                                                    __typename?: "BasicPropertyValue"
                                                    model: string
                                                    value?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicRichText"
                                                    model: string
                                                    richText?: string | null
                                                  }
                                                | {
                                                    __typename?: "BasicUnsupportedPropertyValue"
                                                    model: string
                                                    message: string
                                                  }
                                                | {
                                                    __typename?: "MintMediaPicker"
                                                    model: string
                                                    mediaItems: Array<{
                                                      __typename?: "MintMediaPickerItem"
                                                      id: number
                                                      url: string
                                                      altText?: string | null
                                                    }>
                                                  }
                                                | null
                                            } | null>
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          valueType: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          valueType: string
                                          elements?: Array<{
                                            __typename?: "BasicNestedContentElement"
                                            properties: Array<{
                                              __typename?: "BasicProperty"
                                              alias?: string | null
                                              editorAlias?: string | null
                                              value?:
                                                | {
                                                    __typename?: "BasicBlockGridModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicBlockListModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicContentPicker"
                                                    model: string
                                                    contentList: Array<{
                                                      __typename?: "BasicContentPickerItem"
                                                      id: number
                                                      absoluteUrl: string
                                                      key: any
                                                      name?: string | null
                                                      url: string
                                                      urlSegment?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicDateTimePicker"
                                                    model: string
                                                    dateTime?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicLabel"
                                                    model: string
                                                    label?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicMediaPicker"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicMemberPicker"
                                                    model: string
                                                    members: Array<{
                                                      __typename?: "BasicMemberPickerItem"
                                                      id?: number | null
                                                      name?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicMultiUrlPicker"
                                                    model: string
                                                    links: Array<{
                                                      __typename?: "BasicMultiUrlPickerItem"
                                                      name?: string | null
                                                      target?: string | null
                                                      type: LinkType
                                                      url?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicNestedContent"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicPropertyValue"
                                                    model: string
                                                    value?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicRichText"
                                                    model: string
                                                    richText?: string | null
                                                  }
                                                | {
                                                    __typename?: "BasicUnsupportedPropertyValue"
                                                    model: string
                                                    message: string
                                                  }
                                                | {
                                                    __typename?: "MintMediaPicker"
                                                    model: string
                                                    mediaItems: Array<{
                                                      __typename?: "MintMediaPickerItem"
                                                      id: number
                                                      url: string
                                                      altText?: string | null
                                                    }>
                                                  }
                                                | null
                                            } | null>
                                          }> | null
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          valueType: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          valueType: string
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          message: string
                                          valueType: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          valueType: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }> | null
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                valueType: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                valueType: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                valueType: string
                                label?: any | null
                              }
                            | {
                                __typename?: "BasicMediaPicker"
                                valueType: string
                              }
                            | {
                                __typename?: "BasicMemberPicker"
                                valueType: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    alias?: string | null
                                    editorAlias?: string | null
                                    value?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          model: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          model: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          model: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          model: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          model: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          model: string
                                          elements?: Array<{
                                            __typename?: "BasicNestedContentElement"
                                            properties: Array<{
                                              __typename?: "BasicProperty"
                                              alias?: string | null
                                              editorAlias?: string | null
                                              value?:
                                                | {
                                                    __typename?: "BasicBlockGridModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicBlockListModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicContentPicker"
                                                    model: string
                                                    contentList: Array<{
                                                      __typename?: "BasicContentPickerItem"
                                                      id: number
                                                      absoluteUrl: string
                                                      key: any
                                                      name?: string | null
                                                      url: string
                                                      urlSegment?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicDateTimePicker"
                                                    model: string
                                                    dateTime?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicLabel"
                                                    model: string
                                                    label?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicMediaPicker"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicMemberPicker"
                                                    model: string
                                                    members: Array<{
                                                      __typename?: "BasicMemberPickerItem"
                                                      id?: number | null
                                                      name?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicMultiUrlPicker"
                                                    model: string
                                                    links: Array<{
                                                      __typename?: "BasicMultiUrlPickerItem"
                                                      name?: string | null
                                                      target?: string | null
                                                      type: LinkType
                                                      url?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicNestedContent"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicPropertyValue"
                                                    model: string
                                                    value?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicRichText"
                                                    model: string
                                                    richText?: string | null
                                                  }
                                                | {
                                                    __typename?: "BasicUnsupportedPropertyValue"
                                                    model: string
                                                    message: string
                                                  }
                                                | {
                                                    __typename?: "MintMediaPicker"
                                                    model: string
                                                    mediaItems: Array<{
                                                      __typename?: "MintMediaPickerItem"
                                                      id: number
                                                      url: string
                                                      altText?: string | null
                                                    }>
                                                  }
                                                | null
                                            } | null>
                                          }> | null
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          model: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          model: string
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          model: string
                                          message: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          model: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                valueType: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                valueType: string
                                elements?: Array<{
                                  __typename?: "BasicNestedContentElement"
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    alias?: string | null
                                    editorAlias?: string | null
                                    value?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          model: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          model: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          model: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          model: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          model: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          model: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          model: string
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          model: string
                                          message: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          model: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }> | null
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                valueType: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                valueType: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                message: string
                                valueType: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                valueType: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicContentPicker"
                      valueType: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      valueType: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      valueType: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; valueType: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      valueType: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                                elements?: Array<{
                                  __typename?: "BasicNestedContentElement"
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    alias?: string | null
                                    editorAlias?: string | null
                                    value?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          model: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          model: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          model: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          model: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          model: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          model: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          model: string
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          model: string
                                          message: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          model: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }> | null
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      valueType: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicNestedContent"
                      valueType: string
                      elements?: Array<{
                        __typename?: "BasicNestedContentElement"
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicPropertyValue"
                      valueType: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      valueType: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      message: string
                      valueType: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      valueType: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }> | null
          }
        | {
            __typename?: "BasicContentPicker"
            valueType: string
            contentList: Array<{
              __typename?: "BasicContentPickerItem"
              id: number
              absoluteUrl: string
              key: any
              name?: string | null
              url: string
              urlSegment?: string | null
            }>
          }
        | {
            __typename?: "BasicDateTimePicker"
            valueType: string
            dateTime?: any | null
          }
        | { __typename?: "BasicLabel"; valueType: string; label?: any | null }
        | { __typename?: "BasicMediaPicker"; valueType: string }
        | {
            __typename?: "BasicMemberPicker"
            valueType: string
            members: Array<{
              __typename?: "BasicMemberPickerItem"
              id?: number | null
              name?: string | null
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicNestedContent"
                      model: string
                      elements?: Array<{
                        __typename?: "BasicNestedContentElement"
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }>
          }
        | {
            __typename?: "BasicMultiUrlPicker"
            valueType: string
            links: Array<{
              __typename?: "BasicMultiUrlPickerItem"
              name?: string | null
              target?: string | null
              type: LinkType
              url?: string | null
            }>
          }
        | {
            __typename?: "BasicNestedContent"
            valueType: string
            elements?: Array<{
              __typename?: "BasicNestedContentElement"
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | { __typename?: "BasicNestedContent"; model: string }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }> | null
          }
        | {
            __typename?: "BasicPropertyValue"
            valueType: string
            value?: any | null
          }
        | {
            __typename?: "BasicRichText"
            valueType: string
            richText?: string | null
          }
        | {
            __typename?: "BasicUnsupportedPropertyValue"
            message: string
            valueType: string
          }
        | {
            __typename?: "MintMediaPicker"
            valueType: string
            mediaItems: Array<{
              __typename?: "MintMediaPickerItem"
              id: number
              url: string
              altText?: string | null
            }>
          }
        | null
    } | null>
  }> | null
}

type BlockEditor_BasicContentPicker_Fragment = {
  __typename?: "BasicContentPicker"
}

type BlockEditor_BasicDateTimePicker_Fragment = {
  __typename?: "BasicDateTimePicker"
}

type BlockEditor_BasicLabel_Fragment = { __typename?: "BasicLabel" }

type BlockEditor_BasicMediaPicker_Fragment = { __typename?: "BasicMediaPicker" }

type BlockEditor_BasicMemberPicker_Fragment = {
  __typename?: "BasicMemberPicker"
}

type BlockEditor_BasicMultiUrlPicker_Fragment = {
  __typename?: "BasicMultiUrlPicker"
}

type BlockEditor_BasicNestedContent_Fragment = {
  __typename?: "BasicNestedContent"
}

type BlockEditor_BasicPropertyValue_Fragment = {
  __typename?: "BasicPropertyValue"
}

type BlockEditor_BasicRichText_Fragment = { __typename?: "BasicRichText" }

type BlockEditor_BasicUnsupportedPropertyValue_Fragment = {
  __typename?: "BasicUnsupportedPropertyValue"
}

type BlockEditor_MintMediaPicker_Fragment = { __typename?: "MintMediaPicker" }

export type BlockEditorFragment =
  | BlockEditor_BasicBlockGridModel_Fragment
  | BlockEditor_BasicBlockListModel_Fragment
  | BlockEditor_BasicContentPicker_Fragment
  | BlockEditor_BasicDateTimePicker_Fragment
  | BlockEditor_BasicLabel_Fragment
  | BlockEditor_BasicMediaPicker_Fragment
  | BlockEditor_BasicMemberPicker_Fragment
  | BlockEditor_BasicMultiUrlPicker_Fragment
  | BlockEditor_BasicNestedContent_Fragment
  | BlockEditor_BasicPropertyValue_Fragment
  | BlockEditor_BasicRichText_Fragment
  | BlockEditor_BasicUnsupportedPropertyValue_Fragment
  | BlockEditor_MintMediaPicker_Fragment

type BlockGridEditor_BasicBlockGridModel_Fragment = {
  __typename?: "BasicBlockGridModel"
  gridColumns?: number | null
  blocks?: Array<{
    __typename?: "BasicBlockGridItem"
    columnSpan: number
    rowSpan: number
    contentProperties: Array<{
      __typename?: "BasicProperty"
      value?:
        | { __typename?: "BasicBlockGridModel"; valueType: string }
        | { __typename?: "BasicBlockListModel"; valueType: string }
        | {
            __typename?: "BasicContentPicker"
            valueType: string
            contentList: Array<{
              __typename?: "BasicContentPickerItem"
              id: number
              absoluteUrl: string
              key: any
              name?: string | null
              url: string
              urlSegment?: string | null
            }>
          }
        | {
            __typename?: "BasicDateTimePicker"
            valueType: string
            dateTime?: any | null
          }
        | { __typename?: "BasicLabel"; valueType: string; label?: any | null }
        | { __typename?: "BasicMediaPicker"; valueType: string }
        | {
            __typename?: "BasicMemberPicker"
            valueType: string
            members: Array<{
              __typename?: "BasicMemberPickerItem"
              id?: number | null
              name?: string | null
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicNestedContent"
                      model: string
                      elements?: Array<{
                        __typename?: "BasicNestedContentElement"
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }>
          }
        | {
            __typename?: "BasicMultiUrlPicker"
            valueType: string
            links: Array<{
              __typename?: "BasicMultiUrlPickerItem"
              name?: string | null
              target?: string | null
              type: LinkType
              url?: string | null
            }>
          }
        | {
            __typename?: "BasicNestedContent"
            valueType: string
            elements?: Array<{
              __typename?: "BasicNestedContentElement"
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | { __typename?: "BasicNestedContent"; model: string }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }> | null
          }
        | {
            __typename?: "BasicPropertyValue"
            valueType: string
            value?: any | null
          }
        | {
            __typename?: "BasicRichText"
            valueType: string
            richText?: string | null
          }
        | {
            __typename?: "BasicUnsupportedPropertyValue"
            message: string
            valueType: string
          }
        | {
            __typename?: "MintMediaPicker"
            valueType: string
            mediaItems: Array<{
              __typename?: "MintMediaPickerItem"
              id: number
              url: string
              altText?: string | null
            }>
          }
        | null
    } | null>
    settingsProperties: Array<{
      __typename?: "BasicProperty"
      value?:
        | { __typename?: "BasicBlockGridModel"; valueType: string }
        | { __typename?: "BasicBlockListModel"; valueType: string }
        | {
            __typename?: "BasicContentPicker"
            valueType: string
            contentList: Array<{
              __typename?: "BasicContentPickerItem"
              id: number
              absoluteUrl: string
              key: any
              name?: string | null
              url: string
              urlSegment?: string | null
            }>
          }
        | {
            __typename?: "BasicDateTimePicker"
            valueType: string
            dateTime?: any | null
          }
        | { __typename?: "BasicLabel"; valueType: string; label?: any | null }
        | { __typename?: "BasicMediaPicker"; valueType: string }
        | {
            __typename?: "BasicMemberPicker"
            valueType: string
            members: Array<{
              __typename?: "BasicMemberPickerItem"
              id?: number | null
              name?: string | null
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicNestedContent"
                      model: string
                      elements?: Array<{
                        __typename?: "BasicNestedContentElement"
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }>
          }
        | {
            __typename?: "BasicMultiUrlPicker"
            valueType: string
            links: Array<{
              __typename?: "BasicMultiUrlPickerItem"
              name?: string | null
              target?: string | null
              type: LinkType
              url?: string | null
            }>
          }
        | {
            __typename?: "BasicNestedContent"
            valueType: string
            elements?: Array<{
              __typename?: "BasicNestedContentElement"
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | { __typename?: "BasicNestedContent"; model: string }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }> | null
          }
        | {
            __typename?: "BasicPropertyValue"
            valueType: string
            value?: any | null
          }
        | {
            __typename?: "BasicRichText"
            valueType: string
            richText?: string | null
          }
        | {
            __typename?: "BasicUnsupportedPropertyValue"
            message: string
            valueType: string
          }
        | {
            __typename?: "MintMediaPicker"
            valueType: string
            mediaItems: Array<{
              __typename?: "MintMediaPickerItem"
              id: number
              url: string
              altText?: string | null
            }>
          }
        | null
    } | null>
    areas: Array<{
      __typename?: "BasicBlockGridArea"
      alias?: string | null
      rowSpan: number
      columnSpan: number
      blocks?: Array<{
        __typename?: "BasicBlockGridItem"
        columnSpan: number
        rowSpan: number
        contentProperties: Array<{
          __typename?: "BasicProperty"
          value?:
            | { __typename?: "BasicBlockGridModel"; valueType: string }
            | { __typename?: "BasicBlockListModel"; valueType: string }
            | {
                __typename?: "BasicContentPicker"
                valueType: string
                contentList: Array<{
                  __typename?: "BasicContentPickerItem"
                  id: number
                  absoluteUrl: string
                  key: any
                  name?: string | null
                  url: string
                  urlSegment?: string | null
                }>
              }
            | {
                __typename?: "BasicDateTimePicker"
                valueType: string
                dateTime?: any | null
              }
            | {
                __typename?: "BasicLabel"
                valueType: string
                label?: any | null
              }
            | { __typename?: "BasicMediaPicker"; valueType: string }
            | {
                __typename?: "BasicMemberPicker"
                valueType: string
                members: Array<{
                  __typename?: "BasicMemberPickerItem"
                  id?: number | null
                  name?: string | null
                  properties: Array<{
                    __typename?: "BasicProperty"
                    alias?: string | null
                    editorAlias?: string | null
                    value?:
                      | { __typename?: "BasicBlockGridModel"; model: string }
                      | { __typename?: "BasicBlockListModel"; model: string }
                      | {
                          __typename?: "BasicContentPicker"
                          model: string
                          contentList: Array<{
                            __typename?: "BasicContentPickerItem"
                            id: number
                            absoluteUrl: string
                            key: any
                            name?: string | null
                            url: string
                            urlSegment?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicDateTimePicker"
                          model: string
                          dateTime?: any | null
                        }
                      | {
                          __typename?: "BasicLabel"
                          model: string
                          label?: any | null
                        }
                      | { __typename?: "BasicMediaPicker"; model: string }
                      | {
                          __typename?: "BasicMemberPicker"
                          model: string
                          members: Array<{
                            __typename?: "BasicMemberPickerItem"
                            id?: number | null
                            name?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicMultiUrlPicker"
                          model: string
                          links: Array<{
                            __typename?: "BasicMultiUrlPickerItem"
                            name?: string | null
                            target?: string | null
                            type: LinkType
                            url?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicNestedContent"
                          model: string
                          elements?: Array<{
                            __typename?: "BasicNestedContentElement"
                            properties: Array<{
                              __typename?: "BasicProperty"
                              alias?: string | null
                              editorAlias?: string | null
                              value?:
                                | {
                                    __typename?: "BasicBlockGridModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicBlockListModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicContentPicker"
                                    model: string
                                    contentList: Array<{
                                      __typename?: "BasicContentPickerItem"
                                      id: number
                                      absoluteUrl: string
                                      key: any
                                      name?: string | null
                                      url: string
                                      urlSegment?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicDateTimePicker"
                                    model: string
                                    dateTime?: any | null
                                  }
                                | {
                                    __typename?: "BasicLabel"
                                    model: string
                                    label?: any | null
                                  }
                                | {
                                    __typename?: "BasicMediaPicker"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicMemberPicker"
                                    model: string
                                    members: Array<{
                                      __typename?: "BasicMemberPickerItem"
                                      id?: number | null
                                      name?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicMultiUrlPicker"
                                    model: string
                                    links: Array<{
                                      __typename?: "BasicMultiUrlPickerItem"
                                      name?: string | null
                                      target?: string | null
                                      type: LinkType
                                      url?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicNestedContent"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicPropertyValue"
                                    model: string
                                    value?: any | null
                                  }
                                | {
                                    __typename?: "BasicRichText"
                                    model: string
                                    richText?: string | null
                                  }
                                | {
                                    __typename?: "BasicUnsupportedPropertyValue"
                                    model: string
                                    message: string
                                  }
                                | {
                                    __typename?: "MintMediaPicker"
                                    model: string
                                    mediaItems: Array<{
                                      __typename?: "MintMediaPickerItem"
                                      id: number
                                      url: string
                                      altText?: string | null
                                    }>
                                  }
                                | null
                            } | null>
                          }> | null
                        }
                      | {
                          __typename?: "BasicPropertyValue"
                          model: string
                          value?: any | null
                        }
                      | {
                          __typename?: "BasicRichText"
                          model: string
                          richText?: string | null
                        }
                      | {
                          __typename?: "BasicUnsupportedPropertyValue"
                          model: string
                          message: string
                        }
                      | {
                          __typename?: "MintMediaPicker"
                          model: string
                          mediaItems: Array<{
                            __typename?: "MintMediaPickerItem"
                            id: number
                            url: string
                            altText?: string | null
                          }>
                        }
                      | null
                  } | null>
                }>
              }
            | {
                __typename?: "BasicMultiUrlPicker"
                valueType: string
                links: Array<{
                  __typename?: "BasicMultiUrlPickerItem"
                  name?: string | null
                  target?: string | null
                  type: LinkType
                  url?: string | null
                }>
              }
            | {
                __typename?: "BasicNestedContent"
                valueType: string
                elements?: Array<{
                  __typename?: "BasicNestedContentElement"
                  properties: Array<{
                    __typename?: "BasicProperty"
                    alias?: string | null
                    editorAlias?: string | null
                    value?:
                      | { __typename?: "BasicBlockGridModel"; model: string }
                      | { __typename?: "BasicBlockListModel"; model: string }
                      | {
                          __typename?: "BasicContentPicker"
                          model: string
                          contentList: Array<{
                            __typename?: "BasicContentPickerItem"
                            id: number
                            absoluteUrl: string
                            key: any
                            name?: string | null
                            url: string
                            urlSegment?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicDateTimePicker"
                          model: string
                          dateTime?: any | null
                        }
                      | {
                          __typename?: "BasicLabel"
                          model: string
                          label?: any | null
                        }
                      | { __typename?: "BasicMediaPicker"; model: string }
                      | {
                          __typename?: "BasicMemberPicker"
                          model: string
                          members: Array<{
                            __typename?: "BasicMemberPickerItem"
                            id?: number | null
                            name?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicMultiUrlPicker"
                          model: string
                          links: Array<{
                            __typename?: "BasicMultiUrlPickerItem"
                            name?: string | null
                            target?: string | null
                            type: LinkType
                            url?: string | null
                          }>
                        }
                      | { __typename?: "BasicNestedContent"; model: string }
                      | {
                          __typename?: "BasicPropertyValue"
                          model: string
                          value?: any | null
                        }
                      | {
                          __typename?: "BasicRichText"
                          model: string
                          richText?: string | null
                        }
                      | {
                          __typename?: "BasicUnsupportedPropertyValue"
                          model: string
                          message: string
                        }
                      | {
                          __typename?: "MintMediaPicker"
                          model: string
                          mediaItems: Array<{
                            __typename?: "MintMediaPickerItem"
                            id: number
                            url: string
                            altText?: string | null
                          }>
                        }
                      | null
                  } | null>
                }> | null
              }
            | {
                __typename?: "BasicPropertyValue"
                valueType: string
                value?: any | null
              }
            | {
                __typename?: "BasicRichText"
                valueType: string
                richText?: string | null
              }
            | {
                __typename?: "BasicUnsupportedPropertyValue"
                message: string
                valueType: string
              }
            | {
                __typename?: "MintMediaPicker"
                valueType: string
                mediaItems: Array<{
                  __typename?: "MintMediaPickerItem"
                  id: number
                  url: string
                  altText?: string | null
                }>
              }
            | null
        } | null>
        settingsProperties: Array<{
          __typename?: "BasicProperty"
          value?:
            | { __typename?: "BasicBlockGridModel"; valueType: string }
            | { __typename?: "BasicBlockListModel"; valueType: string }
            | {
                __typename?: "BasicContentPicker"
                valueType: string
                contentList: Array<{
                  __typename?: "BasicContentPickerItem"
                  id: number
                  absoluteUrl: string
                  key: any
                  name?: string | null
                  url: string
                  urlSegment?: string | null
                }>
              }
            | {
                __typename?: "BasicDateTimePicker"
                valueType: string
                dateTime?: any | null
              }
            | {
                __typename?: "BasicLabel"
                valueType: string
                label?: any | null
              }
            | { __typename?: "BasicMediaPicker"; valueType: string }
            | {
                __typename?: "BasicMemberPicker"
                valueType: string
                members: Array<{
                  __typename?: "BasicMemberPickerItem"
                  id?: number | null
                  name?: string | null
                  properties: Array<{
                    __typename?: "BasicProperty"
                    alias?: string | null
                    editorAlias?: string | null
                    value?:
                      | { __typename?: "BasicBlockGridModel"; model: string }
                      | { __typename?: "BasicBlockListModel"; model: string }
                      | {
                          __typename?: "BasicContentPicker"
                          model: string
                          contentList: Array<{
                            __typename?: "BasicContentPickerItem"
                            id: number
                            absoluteUrl: string
                            key: any
                            name?: string | null
                            url: string
                            urlSegment?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicDateTimePicker"
                          model: string
                          dateTime?: any | null
                        }
                      | {
                          __typename?: "BasicLabel"
                          model: string
                          label?: any | null
                        }
                      | { __typename?: "BasicMediaPicker"; model: string }
                      | {
                          __typename?: "BasicMemberPicker"
                          model: string
                          members: Array<{
                            __typename?: "BasicMemberPickerItem"
                            id?: number | null
                            name?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicMultiUrlPicker"
                          model: string
                          links: Array<{
                            __typename?: "BasicMultiUrlPickerItem"
                            name?: string | null
                            target?: string | null
                            type: LinkType
                            url?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicNestedContent"
                          model: string
                          elements?: Array<{
                            __typename?: "BasicNestedContentElement"
                            properties: Array<{
                              __typename?: "BasicProperty"
                              alias?: string | null
                              editorAlias?: string | null
                              value?:
                                | {
                                    __typename?: "BasicBlockGridModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicBlockListModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicContentPicker"
                                    model: string
                                    contentList: Array<{
                                      __typename?: "BasicContentPickerItem"
                                      id: number
                                      absoluteUrl: string
                                      key: any
                                      name?: string | null
                                      url: string
                                      urlSegment?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicDateTimePicker"
                                    model: string
                                    dateTime?: any | null
                                  }
                                | {
                                    __typename?: "BasicLabel"
                                    model: string
                                    label?: any | null
                                  }
                                | {
                                    __typename?: "BasicMediaPicker"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicMemberPicker"
                                    model: string
                                    members: Array<{
                                      __typename?: "BasicMemberPickerItem"
                                      id?: number | null
                                      name?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicMultiUrlPicker"
                                    model: string
                                    links: Array<{
                                      __typename?: "BasicMultiUrlPickerItem"
                                      name?: string | null
                                      target?: string | null
                                      type: LinkType
                                      url?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicNestedContent"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicPropertyValue"
                                    model: string
                                    value?: any | null
                                  }
                                | {
                                    __typename?: "BasicRichText"
                                    model: string
                                    richText?: string | null
                                  }
                                | {
                                    __typename?: "BasicUnsupportedPropertyValue"
                                    model: string
                                    message: string
                                  }
                                | {
                                    __typename?: "MintMediaPicker"
                                    model: string
                                    mediaItems: Array<{
                                      __typename?: "MintMediaPickerItem"
                                      id: number
                                      url: string
                                      altText?: string | null
                                    }>
                                  }
                                | null
                            } | null>
                          }> | null
                        }
                      | {
                          __typename?: "BasicPropertyValue"
                          model: string
                          value?: any | null
                        }
                      | {
                          __typename?: "BasicRichText"
                          model: string
                          richText?: string | null
                        }
                      | {
                          __typename?: "BasicUnsupportedPropertyValue"
                          model: string
                          message: string
                        }
                      | {
                          __typename?: "MintMediaPicker"
                          model: string
                          mediaItems: Array<{
                            __typename?: "MintMediaPickerItem"
                            id: number
                            url: string
                            altText?: string | null
                          }>
                        }
                      | null
                  } | null>
                }>
              }
            | {
                __typename?: "BasicMultiUrlPicker"
                valueType: string
                links: Array<{
                  __typename?: "BasicMultiUrlPickerItem"
                  name?: string | null
                  target?: string | null
                  type: LinkType
                  url?: string | null
                }>
              }
            | {
                __typename?: "BasicNestedContent"
                valueType: string
                elements?: Array<{
                  __typename?: "BasicNestedContentElement"
                  properties: Array<{
                    __typename?: "BasicProperty"
                    alias?: string | null
                    editorAlias?: string | null
                    value?:
                      | { __typename?: "BasicBlockGridModel"; model: string }
                      | { __typename?: "BasicBlockListModel"; model: string }
                      | {
                          __typename?: "BasicContentPicker"
                          model: string
                          contentList: Array<{
                            __typename?: "BasicContentPickerItem"
                            id: number
                            absoluteUrl: string
                            key: any
                            name?: string | null
                            url: string
                            urlSegment?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicDateTimePicker"
                          model: string
                          dateTime?: any | null
                        }
                      | {
                          __typename?: "BasicLabel"
                          model: string
                          label?: any | null
                        }
                      | { __typename?: "BasicMediaPicker"; model: string }
                      | {
                          __typename?: "BasicMemberPicker"
                          model: string
                          members: Array<{
                            __typename?: "BasicMemberPickerItem"
                            id?: number | null
                            name?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicMultiUrlPicker"
                          model: string
                          links: Array<{
                            __typename?: "BasicMultiUrlPickerItem"
                            name?: string | null
                            target?: string | null
                            type: LinkType
                            url?: string | null
                          }>
                        }
                      | { __typename?: "BasicNestedContent"; model: string }
                      | {
                          __typename?: "BasicPropertyValue"
                          model: string
                          value?: any | null
                        }
                      | {
                          __typename?: "BasicRichText"
                          model: string
                          richText?: string | null
                        }
                      | {
                          __typename?: "BasicUnsupportedPropertyValue"
                          model: string
                          message: string
                        }
                      | {
                          __typename?: "MintMediaPicker"
                          model: string
                          mediaItems: Array<{
                            __typename?: "MintMediaPickerItem"
                            id: number
                            url: string
                            altText?: string | null
                          }>
                        }
                      | null
                  } | null>
                }> | null
              }
            | {
                __typename?: "BasicPropertyValue"
                valueType: string
                value?: any | null
              }
            | {
                __typename?: "BasicRichText"
                valueType: string
                richText?: string | null
              }
            | {
                __typename?: "BasicUnsupportedPropertyValue"
                message: string
                valueType: string
              }
            | {
                __typename?: "MintMediaPicker"
                valueType: string
                mediaItems: Array<{
                  __typename?: "MintMediaPickerItem"
                  id: number
                  url: string
                  altText?: string | null
                }>
              }
            | null
        } | null>
        areas: Array<{
          __typename?: "BasicBlockGridArea"
          alias?: string | null
          rowSpan: number
          columnSpan: number
        } | null>
      }> | null
    } | null>
  }> | null
}

type BlockGridEditor_BasicBlockListModel_Fragment = {
  __typename?: "BasicBlockListModel"
}

type BlockGridEditor_BasicContentPicker_Fragment = {
  __typename?: "BasicContentPicker"
}

type BlockGridEditor_BasicDateTimePicker_Fragment = {
  __typename?: "BasicDateTimePicker"
}

type BlockGridEditor_BasicLabel_Fragment = { __typename?: "BasicLabel" }

type BlockGridEditor_BasicMediaPicker_Fragment = {
  __typename?: "BasicMediaPicker"
}

type BlockGridEditor_BasicMemberPicker_Fragment = {
  __typename?: "BasicMemberPicker"
}

type BlockGridEditor_BasicMultiUrlPicker_Fragment = {
  __typename?: "BasicMultiUrlPicker"
}

type BlockGridEditor_BasicNestedContent_Fragment = {
  __typename?: "BasicNestedContent"
}

type BlockGridEditor_BasicPropertyValue_Fragment = {
  __typename?: "BasicPropertyValue"
}

type BlockGridEditor_BasicRichText_Fragment = { __typename?: "BasicRichText" }

type BlockGridEditor_BasicUnsupportedPropertyValue_Fragment = {
  __typename?: "BasicUnsupportedPropertyValue"
}

type BlockGridEditor_MintMediaPicker_Fragment = {
  __typename?: "MintMediaPicker"
}

export type BlockGridEditorFragment =
  | BlockGridEditor_BasicBlockGridModel_Fragment
  | BlockGridEditor_BasicBlockListModel_Fragment
  | BlockGridEditor_BasicContentPicker_Fragment
  | BlockGridEditor_BasicDateTimePicker_Fragment
  | BlockGridEditor_BasicLabel_Fragment
  | BlockGridEditor_BasicMediaPicker_Fragment
  | BlockGridEditor_BasicMemberPicker_Fragment
  | BlockGridEditor_BasicMultiUrlPicker_Fragment
  | BlockGridEditor_BasicNestedContent_Fragment
  | BlockGridEditor_BasicPropertyValue_Fragment
  | BlockGridEditor_BasicRichText_Fragment
  | BlockGridEditor_BasicUnsupportedPropertyValue_Fragment
  | BlockGridEditor_MintMediaPicker_Fragment

type PropertyValues_BasicBlockGridModel_Fragment = {
  __typename?: "BasicBlockGridModel"
  gridColumns?: number | null
  valueType: string
  blocks?: Array<{
    __typename?: "BasicBlockGridItem"
    columnSpan: number
    rowSpan: number
    contentProperties: Array<{
      __typename?: "BasicProperty"
      value?:
        | { __typename?: "BasicBlockGridModel"; valueType: string }
        | { __typename?: "BasicBlockListModel"; valueType: string }
        | {
            __typename?: "BasicContentPicker"
            valueType: string
            contentList: Array<{
              __typename?: "BasicContentPickerItem"
              id: number
              absoluteUrl: string
              key: any
              name?: string | null
              url: string
              urlSegment?: string | null
            }>
          }
        | {
            __typename?: "BasicDateTimePicker"
            valueType: string
            dateTime?: any | null
          }
        | { __typename?: "BasicLabel"; valueType: string; label?: any | null }
        | { __typename?: "BasicMediaPicker"; valueType: string }
        | {
            __typename?: "BasicMemberPicker"
            valueType: string
            members: Array<{
              __typename?: "BasicMemberPickerItem"
              id?: number | null
              name?: string | null
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicNestedContent"
                      model: string
                      elements?: Array<{
                        __typename?: "BasicNestedContentElement"
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }>
          }
        | {
            __typename?: "BasicMultiUrlPicker"
            valueType: string
            links: Array<{
              __typename?: "BasicMultiUrlPickerItem"
              name?: string | null
              target?: string | null
              type: LinkType
              url?: string | null
            }>
          }
        | {
            __typename?: "BasicNestedContent"
            valueType: string
            elements?: Array<{
              __typename?: "BasicNestedContentElement"
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | { __typename?: "BasicNestedContent"; model: string }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }> | null
          }
        | {
            __typename?: "BasicPropertyValue"
            valueType: string
            value?: any | null
          }
        | {
            __typename?: "BasicRichText"
            valueType: string
            richText?: string | null
          }
        | {
            __typename?: "BasicUnsupportedPropertyValue"
            message: string
            valueType: string
          }
        | {
            __typename?: "MintMediaPicker"
            valueType: string
            mediaItems: Array<{
              __typename?: "MintMediaPickerItem"
              id: number
              url: string
              altText?: string | null
            }>
          }
        | null
    } | null>
    settingsProperties: Array<{
      __typename?: "BasicProperty"
      value?:
        | { __typename?: "BasicBlockGridModel"; valueType: string }
        | { __typename?: "BasicBlockListModel"; valueType: string }
        | {
            __typename?: "BasicContentPicker"
            valueType: string
            contentList: Array<{
              __typename?: "BasicContentPickerItem"
              id: number
              absoluteUrl: string
              key: any
              name?: string | null
              url: string
              urlSegment?: string | null
            }>
          }
        | {
            __typename?: "BasicDateTimePicker"
            valueType: string
            dateTime?: any | null
          }
        | { __typename?: "BasicLabel"; valueType: string; label?: any | null }
        | { __typename?: "BasicMediaPicker"; valueType: string }
        | {
            __typename?: "BasicMemberPicker"
            valueType: string
            members: Array<{
              __typename?: "BasicMemberPickerItem"
              id?: number | null
              name?: string | null
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicNestedContent"
                      model: string
                      elements?: Array<{
                        __typename?: "BasicNestedContentElement"
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }>
          }
        | {
            __typename?: "BasicMultiUrlPicker"
            valueType: string
            links: Array<{
              __typename?: "BasicMultiUrlPickerItem"
              name?: string | null
              target?: string | null
              type: LinkType
              url?: string | null
            }>
          }
        | {
            __typename?: "BasicNestedContent"
            valueType: string
            elements?: Array<{
              __typename?: "BasicNestedContentElement"
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | { __typename?: "BasicNestedContent"; model: string }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }> | null
          }
        | {
            __typename?: "BasicPropertyValue"
            valueType: string
            value?: any | null
          }
        | {
            __typename?: "BasicRichText"
            valueType: string
            richText?: string | null
          }
        | {
            __typename?: "BasicUnsupportedPropertyValue"
            message: string
            valueType: string
          }
        | {
            __typename?: "MintMediaPicker"
            valueType: string
            mediaItems: Array<{
              __typename?: "MintMediaPickerItem"
              id: number
              url: string
              altText?: string | null
            }>
          }
        | null
    } | null>
    areas: Array<{
      __typename?: "BasicBlockGridArea"
      alias?: string | null
      rowSpan: number
      columnSpan: number
      blocks?: Array<{
        __typename?: "BasicBlockGridItem"
        columnSpan: number
        rowSpan: number
        contentProperties: Array<{
          __typename?: "BasicProperty"
          value?:
            | { __typename?: "BasicBlockGridModel"; valueType: string }
            | { __typename?: "BasicBlockListModel"; valueType: string }
            | {
                __typename?: "BasicContentPicker"
                valueType: string
                contentList: Array<{
                  __typename?: "BasicContentPickerItem"
                  id: number
                  absoluteUrl: string
                  key: any
                  name?: string | null
                  url: string
                  urlSegment?: string | null
                }>
              }
            | {
                __typename?: "BasicDateTimePicker"
                valueType: string
                dateTime?: any | null
              }
            | {
                __typename?: "BasicLabel"
                valueType: string
                label?: any | null
              }
            | { __typename?: "BasicMediaPicker"; valueType: string }
            | {
                __typename?: "BasicMemberPicker"
                valueType: string
                members: Array<{
                  __typename?: "BasicMemberPickerItem"
                  id?: number | null
                  name?: string | null
                  properties: Array<{
                    __typename?: "BasicProperty"
                    alias?: string | null
                    editorAlias?: string | null
                    value?:
                      | { __typename?: "BasicBlockGridModel"; model: string }
                      | { __typename?: "BasicBlockListModel"; model: string }
                      | {
                          __typename?: "BasicContentPicker"
                          model: string
                          contentList: Array<{
                            __typename?: "BasicContentPickerItem"
                            id: number
                            absoluteUrl: string
                            key: any
                            name?: string | null
                            url: string
                            urlSegment?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicDateTimePicker"
                          model: string
                          dateTime?: any | null
                        }
                      | {
                          __typename?: "BasicLabel"
                          model: string
                          label?: any | null
                        }
                      | { __typename?: "BasicMediaPicker"; model: string }
                      | {
                          __typename?: "BasicMemberPicker"
                          model: string
                          members: Array<{
                            __typename?: "BasicMemberPickerItem"
                            id?: number | null
                            name?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicMultiUrlPicker"
                          model: string
                          links: Array<{
                            __typename?: "BasicMultiUrlPickerItem"
                            name?: string | null
                            target?: string | null
                            type: LinkType
                            url?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicNestedContent"
                          model: string
                          elements?: Array<{
                            __typename?: "BasicNestedContentElement"
                            properties: Array<{
                              __typename?: "BasicProperty"
                              alias?: string | null
                              editorAlias?: string | null
                              value?:
                                | {
                                    __typename?: "BasicBlockGridModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicBlockListModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicContentPicker"
                                    model: string
                                    contentList: Array<{
                                      __typename?: "BasicContentPickerItem"
                                      id: number
                                      absoluteUrl: string
                                      key: any
                                      name?: string | null
                                      url: string
                                      urlSegment?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicDateTimePicker"
                                    model: string
                                    dateTime?: any | null
                                  }
                                | {
                                    __typename?: "BasicLabel"
                                    model: string
                                    label?: any | null
                                  }
                                | {
                                    __typename?: "BasicMediaPicker"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicMemberPicker"
                                    model: string
                                    members: Array<{
                                      __typename?: "BasicMemberPickerItem"
                                      id?: number | null
                                      name?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicMultiUrlPicker"
                                    model: string
                                    links: Array<{
                                      __typename?: "BasicMultiUrlPickerItem"
                                      name?: string | null
                                      target?: string | null
                                      type: LinkType
                                      url?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicNestedContent"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicPropertyValue"
                                    model: string
                                    value?: any | null
                                  }
                                | {
                                    __typename?: "BasicRichText"
                                    model: string
                                    richText?: string | null
                                  }
                                | {
                                    __typename?: "BasicUnsupportedPropertyValue"
                                    model: string
                                    message: string
                                  }
                                | {
                                    __typename?: "MintMediaPicker"
                                    model: string
                                    mediaItems: Array<{
                                      __typename?: "MintMediaPickerItem"
                                      id: number
                                      url: string
                                      altText?: string | null
                                    }>
                                  }
                                | null
                            } | null>
                          }> | null
                        }
                      | {
                          __typename?: "BasicPropertyValue"
                          model: string
                          value?: any | null
                        }
                      | {
                          __typename?: "BasicRichText"
                          model: string
                          richText?: string | null
                        }
                      | {
                          __typename?: "BasicUnsupportedPropertyValue"
                          model: string
                          message: string
                        }
                      | {
                          __typename?: "MintMediaPicker"
                          model: string
                          mediaItems: Array<{
                            __typename?: "MintMediaPickerItem"
                            id: number
                            url: string
                            altText?: string | null
                          }>
                        }
                      | null
                  } | null>
                }>
              }
            | {
                __typename?: "BasicMultiUrlPicker"
                valueType: string
                links: Array<{
                  __typename?: "BasicMultiUrlPickerItem"
                  name?: string | null
                  target?: string | null
                  type: LinkType
                  url?: string | null
                }>
              }
            | {
                __typename?: "BasicNestedContent"
                valueType: string
                elements?: Array<{
                  __typename?: "BasicNestedContentElement"
                  properties: Array<{
                    __typename?: "BasicProperty"
                    alias?: string | null
                    editorAlias?: string | null
                    value?:
                      | { __typename?: "BasicBlockGridModel"; model: string }
                      | { __typename?: "BasicBlockListModel"; model: string }
                      | {
                          __typename?: "BasicContentPicker"
                          model: string
                          contentList: Array<{
                            __typename?: "BasicContentPickerItem"
                            id: number
                            absoluteUrl: string
                            key: any
                            name?: string | null
                            url: string
                            urlSegment?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicDateTimePicker"
                          model: string
                          dateTime?: any | null
                        }
                      | {
                          __typename?: "BasicLabel"
                          model: string
                          label?: any | null
                        }
                      | { __typename?: "BasicMediaPicker"; model: string }
                      | {
                          __typename?: "BasicMemberPicker"
                          model: string
                          members: Array<{
                            __typename?: "BasicMemberPickerItem"
                            id?: number | null
                            name?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicMultiUrlPicker"
                          model: string
                          links: Array<{
                            __typename?: "BasicMultiUrlPickerItem"
                            name?: string | null
                            target?: string | null
                            type: LinkType
                            url?: string | null
                          }>
                        }
                      | { __typename?: "BasicNestedContent"; model: string }
                      | {
                          __typename?: "BasicPropertyValue"
                          model: string
                          value?: any | null
                        }
                      | {
                          __typename?: "BasicRichText"
                          model: string
                          richText?: string | null
                        }
                      | {
                          __typename?: "BasicUnsupportedPropertyValue"
                          model: string
                          message: string
                        }
                      | {
                          __typename?: "MintMediaPicker"
                          model: string
                          mediaItems: Array<{
                            __typename?: "MintMediaPickerItem"
                            id: number
                            url: string
                            altText?: string | null
                          }>
                        }
                      | null
                  } | null>
                }> | null
              }
            | {
                __typename?: "BasicPropertyValue"
                valueType: string
                value?: any | null
              }
            | {
                __typename?: "BasicRichText"
                valueType: string
                richText?: string | null
              }
            | {
                __typename?: "BasicUnsupportedPropertyValue"
                message: string
                valueType: string
              }
            | {
                __typename?: "MintMediaPicker"
                valueType: string
                mediaItems: Array<{
                  __typename?: "MintMediaPickerItem"
                  id: number
                  url: string
                  altText?: string | null
                }>
              }
            | null
        } | null>
        settingsProperties: Array<{
          __typename?: "BasicProperty"
          value?:
            | { __typename?: "BasicBlockGridModel"; valueType: string }
            | { __typename?: "BasicBlockListModel"; valueType: string }
            | {
                __typename?: "BasicContentPicker"
                valueType: string
                contentList: Array<{
                  __typename?: "BasicContentPickerItem"
                  id: number
                  absoluteUrl: string
                  key: any
                  name?: string | null
                  url: string
                  urlSegment?: string | null
                }>
              }
            | {
                __typename?: "BasicDateTimePicker"
                valueType: string
                dateTime?: any | null
              }
            | {
                __typename?: "BasicLabel"
                valueType: string
                label?: any | null
              }
            | { __typename?: "BasicMediaPicker"; valueType: string }
            | {
                __typename?: "BasicMemberPicker"
                valueType: string
                members: Array<{
                  __typename?: "BasicMemberPickerItem"
                  id?: number | null
                  name?: string | null
                  properties: Array<{
                    __typename?: "BasicProperty"
                    alias?: string | null
                    editorAlias?: string | null
                    value?:
                      | { __typename?: "BasicBlockGridModel"; model: string }
                      | { __typename?: "BasicBlockListModel"; model: string }
                      | {
                          __typename?: "BasicContentPicker"
                          model: string
                          contentList: Array<{
                            __typename?: "BasicContentPickerItem"
                            id: number
                            absoluteUrl: string
                            key: any
                            name?: string | null
                            url: string
                            urlSegment?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicDateTimePicker"
                          model: string
                          dateTime?: any | null
                        }
                      | {
                          __typename?: "BasicLabel"
                          model: string
                          label?: any | null
                        }
                      | { __typename?: "BasicMediaPicker"; model: string }
                      | {
                          __typename?: "BasicMemberPicker"
                          model: string
                          members: Array<{
                            __typename?: "BasicMemberPickerItem"
                            id?: number | null
                            name?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicMultiUrlPicker"
                          model: string
                          links: Array<{
                            __typename?: "BasicMultiUrlPickerItem"
                            name?: string | null
                            target?: string | null
                            type: LinkType
                            url?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicNestedContent"
                          model: string
                          elements?: Array<{
                            __typename?: "BasicNestedContentElement"
                            properties: Array<{
                              __typename?: "BasicProperty"
                              alias?: string | null
                              editorAlias?: string | null
                              value?:
                                | {
                                    __typename?: "BasicBlockGridModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicBlockListModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicContentPicker"
                                    model: string
                                    contentList: Array<{
                                      __typename?: "BasicContentPickerItem"
                                      id: number
                                      absoluteUrl: string
                                      key: any
                                      name?: string | null
                                      url: string
                                      urlSegment?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicDateTimePicker"
                                    model: string
                                    dateTime?: any | null
                                  }
                                | {
                                    __typename?: "BasicLabel"
                                    model: string
                                    label?: any | null
                                  }
                                | {
                                    __typename?: "BasicMediaPicker"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicMemberPicker"
                                    model: string
                                    members: Array<{
                                      __typename?: "BasicMemberPickerItem"
                                      id?: number | null
                                      name?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicMultiUrlPicker"
                                    model: string
                                    links: Array<{
                                      __typename?: "BasicMultiUrlPickerItem"
                                      name?: string | null
                                      target?: string | null
                                      type: LinkType
                                      url?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicNestedContent"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicPropertyValue"
                                    model: string
                                    value?: any | null
                                  }
                                | {
                                    __typename?: "BasicRichText"
                                    model: string
                                    richText?: string | null
                                  }
                                | {
                                    __typename?: "BasicUnsupportedPropertyValue"
                                    model: string
                                    message: string
                                  }
                                | {
                                    __typename?: "MintMediaPicker"
                                    model: string
                                    mediaItems: Array<{
                                      __typename?: "MintMediaPickerItem"
                                      id: number
                                      url: string
                                      altText?: string | null
                                    }>
                                  }
                                | null
                            } | null>
                          }> | null
                        }
                      | {
                          __typename?: "BasicPropertyValue"
                          model: string
                          value?: any | null
                        }
                      | {
                          __typename?: "BasicRichText"
                          model: string
                          richText?: string | null
                        }
                      | {
                          __typename?: "BasicUnsupportedPropertyValue"
                          model: string
                          message: string
                        }
                      | {
                          __typename?: "MintMediaPicker"
                          model: string
                          mediaItems: Array<{
                            __typename?: "MintMediaPickerItem"
                            id: number
                            url: string
                            altText?: string | null
                          }>
                        }
                      | null
                  } | null>
                }>
              }
            | {
                __typename?: "BasicMultiUrlPicker"
                valueType: string
                links: Array<{
                  __typename?: "BasicMultiUrlPickerItem"
                  name?: string | null
                  target?: string | null
                  type: LinkType
                  url?: string | null
                }>
              }
            | {
                __typename?: "BasicNestedContent"
                valueType: string
                elements?: Array<{
                  __typename?: "BasicNestedContentElement"
                  properties: Array<{
                    __typename?: "BasicProperty"
                    alias?: string | null
                    editorAlias?: string | null
                    value?:
                      | { __typename?: "BasicBlockGridModel"; model: string }
                      | { __typename?: "BasicBlockListModel"; model: string }
                      | {
                          __typename?: "BasicContentPicker"
                          model: string
                          contentList: Array<{
                            __typename?: "BasicContentPickerItem"
                            id: number
                            absoluteUrl: string
                            key: any
                            name?: string | null
                            url: string
                            urlSegment?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicDateTimePicker"
                          model: string
                          dateTime?: any | null
                        }
                      | {
                          __typename?: "BasicLabel"
                          model: string
                          label?: any | null
                        }
                      | { __typename?: "BasicMediaPicker"; model: string }
                      | {
                          __typename?: "BasicMemberPicker"
                          model: string
                          members: Array<{
                            __typename?: "BasicMemberPickerItem"
                            id?: number | null
                            name?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicMultiUrlPicker"
                          model: string
                          links: Array<{
                            __typename?: "BasicMultiUrlPickerItem"
                            name?: string | null
                            target?: string | null
                            type: LinkType
                            url?: string | null
                          }>
                        }
                      | { __typename?: "BasicNestedContent"; model: string }
                      | {
                          __typename?: "BasicPropertyValue"
                          model: string
                          value?: any | null
                        }
                      | {
                          __typename?: "BasicRichText"
                          model: string
                          richText?: string | null
                        }
                      | {
                          __typename?: "BasicUnsupportedPropertyValue"
                          model: string
                          message: string
                        }
                      | {
                          __typename?: "MintMediaPicker"
                          model: string
                          mediaItems: Array<{
                            __typename?: "MintMediaPickerItem"
                            id: number
                            url: string
                            altText?: string | null
                          }>
                        }
                      | null
                  } | null>
                }> | null
              }
            | {
                __typename?: "BasicPropertyValue"
                valueType: string
                value?: any | null
              }
            | {
                __typename?: "BasicRichText"
                valueType: string
                richText?: string | null
              }
            | {
                __typename?: "BasicUnsupportedPropertyValue"
                message: string
                valueType: string
              }
            | {
                __typename?: "MintMediaPicker"
                valueType: string
                mediaItems: Array<{
                  __typename?: "MintMediaPickerItem"
                  id: number
                  url: string
                  altText?: string | null
                }>
              }
            | null
        } | null>
        areas: Array<{
          __typename?: "BasicBlockGridArea"
          alias?: string | null
          rowSpan: number
          columnSpan: number
        } | null>
      }> | null
    } | null>
  }> | null
}

type PropertyValues_BasicBlockListModel_Fragment = {
  __typename?: "BasicBlockListModel"
  valueType: string
  blocks?: Array<{
    __typename?: "BasicBlockListItem"
    blockType?: string | null
    properties: Array<{
      __typename?: "BasicProperty"
      propertyName?: string | null
      propertyValue?:
        | { __typename?: "BasicBlockGridModel"; valueType: string }
        | {
            __typename?: "BasicBlockListModel"
            valueType: string
            blocks?: Array<{
              __typename?: "BasicBlockListItem"
              blockType?: string | null
              properties: Array<{
                __typename?: "BasicProperty"
                propertyName?: string | null
                propertyValue?:
                  | { __typename?: "BasicBlockGridModel"; valueType: string }
                  | {
                      __typename?: "BasicBlockListModel"
                      valueType: string
                      blocks?: Array<{
                        __typename?: "BasicBlockListItem"
                        blockType?: string | null
                        properties: Array<{
                          __typename?: "BasicProperty"
                          propertyName?: string | null
                          propertyValue?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                valueType: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                valueType: string
                                blocks?: Array<{
                                  __typename?: "BasicBlockListItem"
                                  blockType?: string | null
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    propertyName?: string | null
                                    propertyValue?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          valueType: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          valueType: string
                                          blocks?: Array<{
                                            __typename?: "BasicBlockListItem"
                                            blockType?: string | null
                                            properties: Array<{
                                              __typename?: "BasicProperty"
                                              propertyName?: string | null
                                              propertyValue?:
                                                | {
                                                    __typename?: "BasicBlockGridModel"
                                                    valueType: string
                                                  }
                                                | {
                                                    __typename?: "BasicBlockListModel"
                                                    valueType: string
                                                  }
                                                | {
                                                    __typename?: "BasicContentPicker"
                                                    valueType: string
                                                    contentList: Array<{
                                                      __typename?: "BasicContentPickerItem"
                                                      id: number
                                                      absoluteUrl: string
                                                      key: any
                                                      name?: string | null
                                                      url: string
                                                      urlSegment?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicDateTimePicker"
                                                    valueType: string
                                                    dateTime?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicLabel"
                                                    valueType: string
                                                    label?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicMediaPicker"
                                                    valueType: string
                                                  }
                                                | {
                                                    __typename?: "BasicMemberPicker"
                                                    valueType: string
                                                    members: Array<{
                                                      __typename?: "BasicMemberPickerItem"
                                                      id?: number | null
                                                      name?: string | null
                                                      properties: Array<{
                                                        __typename?: "BasicProperty"
                                                        alias?: string | null
                                                        editorAlias?:
                                                          | string
                                                          | null
                                                        value?:
                                                          | {
                                                              __typename?: "BasicBlockGridModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicBlockListModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicContentPicker"
                                                              model: string
                                                              contentList: Array<{
                                                                __typename?: "BasicContentPickerItem"
                                                                id: number
                                                                absoluteUrl: string
                                                                key: any
                                                                name?:
                                                                  | string
                                                                  | null
                                                                url: string
                                                                urlSegment?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicDateTimePicker"
                                                              model: string
                                                              dateTime?:
                                                                | any
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicLabel"
                                                              model: string
                                                              label?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicMediaPicker"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicMemberPicker"
                                                              model: string
                                                              members: Array<{
                                                                __typename?: "BasicMemberPickerItem"
                                                                id?:
                                                                  | number
                                                                  | null
                                                                name?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicMultiUrlPicker"
                                                              model: string
                                                              links: Array<{
                                                                __typename?: "BasicMultiUrlPickerItem"
                                                                name?:
                                                                  | string
                                                                  | null
                                                                target?:
                                                                  | string
                                                                  | null
                                                                type: LinkType
                                                                url?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicNestedContent"
                                                              model: string
                                                              elements?: Array<{
                                                                __typename?: "BasicNestedContentElement"
                                                                properties: Array<{
                                                                  __typename?: "BasicProperty"
                                                                  alias?:
                                                                    | string
                                                                    | null
                                                                  editorAlias?:
                                                                    | string
                                                                    | null
                                                                  value?:
                                                                    | {
                                                                        __typename?: "BasicBlockGridModel"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicBlockListModel"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicContentPicker"
                                                                        model: string
                                                                        contentList: Array<{
                                                                          __typename?: "BasicContentPickerItem"
                                                                          id: number
                                                                          absoluteUrl: string
                                                                          key: any
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                          url: string
                                                                          urlSegment?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicDateTimePicker"
                                                                        model: string
                                                                        dateTime?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicLabel"
                                                                        model: string
                                                                        label?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMediaPicker"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMemberPicker"
                                                                        model: string
                                                                        members: Array<{
                                                                          __typename?: "BasicMemberPickerItem"
                                                                          id?:
                                                                            | number
                                                                            | null
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMultiUrlPicker"
                                                                        model: string
                                                                        links: Array<{
                                                                          __typename?: "BasicMultiUrlPickerItem"
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                          target?:
                                                                            | string
                                                                            | null
                                                                          type: LinkType
                                                                          url?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicNestedContent"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicPropertyValue"
                                                                        model: string
                                                                        value?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicRichText"
                                                                        model: string
                                                                        richText?:
                                                                          | string
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicUnsupportedPropertyValue"
                                                                        model: string
                                                                        message: string
                                                                      }
                                                                    | {
                                                                        __typename?: "MintMediaPicker"
                                                                        model: string
                                                                        mediaItems: Array<{
                                                                          __typename?: "MintMediaPickerItem"
                                                                          id: number
                                                                          url: string
                                                                          altText?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | null
                                                                } | null>
                                                              }> | null
                                                            }
                                                          | {
                                                              __typename?: "BasicPropertyValue"
                                                              model: string
                                                              value?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicRichText"
                                                              model: string
                                                              richText?:
                                                                | string
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicUnsupportedPropertyValue"
                                                              model: string
                                                              message: string
                                                            }
                                                          | {
                                                              __typename?: "MintMediaPicker"
                                                              model: string
                                                              mediaItems: Array<{
                                                                __typename?: "MintMediaPickerItem"
                                                                id: number
                                                                url: string
                                                                altText?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | null
                                                      } | null>
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicMultiUrlPicker"
                                                    valueType: string
                                                    links: Array<{
                                                      __typename?: "BasicMultiUrlPickerItem"
                                                      name?: string | null
                                                      target?: string | null
                                                      type: LinkType
                                                      url?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicNestedContent"
                                                    valueType: string
                                                    elements?: Array<{
                                                      __typename?: "BasicNestedContentElement"
                                                      properties: Array<{
                                                        __typename?: "BasicProperty"
                                                        alias?: string | null
                                                        editorAlias?:
                                                          | string
                                                          | null
                                                        value?:
                                                          | {
                                                              __typename?: "BasicBlockGridModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicBlockListModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicContentPicker"
                                                              model: string
                                                              contentList: Array<{
                                                                __typename?: "BasicContentPickerItem"
                                                                id: number
                                                                absoluteUrl: string
                                                                key: any
                                                                name?:
                                                                  | string
                                                                  | null
                                                                url: string
                                                                urlSegment?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicDateTimePicker"
                                                              model: string
                                                              dateTime?:
                                                                | any
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicLabel"
                                                              model: string
                                                              label?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicMediaPicker"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicMemberPicker"
                                                              model: string
                                                              members: Array<{
                                                                __typename?: "BasicMemberPickerItem"
                                                                id?:
                                                                  | number
                                                                  | null
                                                                name?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicMultiUrlPicker"
                                                              model: string
                                                              links: Array<{
                                                                __typename?: "BasicMultiUrlPickerItem"
                                                                name?:
                                                                  | string
                                                                  | null
                                                                target?:
                                                                  | string
                                                                  | null
                                                                type: LinkType
                                                                url?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicNestedContent"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicPropertyValue"
                                                              model: string
                                                              value?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicRichText"
                                                              model: string
                                                              richText?:
                                                                | string
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicUnsupportedPropertyValue"
                                                              model: string
                                                              message: string
                                                            }
                                                          | {
                                                              __typename?: "MintMediaPicker"
                                                              model: string
                                                              mediaItems: Array<{
                                                                __typename?: "MintMediaPickerItem"
                                                                id: number
                                                                url: string
                                                                altText?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | null
                                                      } | null>
                                                    }> | null
                                                  }
                                                | {
                                                    __typename?: "BasicPropertyValue"
                                                    valueType: string
                                                    value?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicRichText"
                                                    valueType: string
                                                    richText?: string | null
                                                  }
                                                | {
                                                    __typename?: "BasicUnsupportedPropertyValue"
                                                    message: string
                                                    valueType: string
                                                  }
                                                | {
                                                    __typename?: "MintMediaPicker"
                                                    valueType: string
                                                    mediaItems: Array<{
                                                      __typename?: "MintMediaPickerItem"
                                                      id: number
                                                      url: string
                                                      altText?: string | null
                                                    }>
                                                  }
                                                | null
                                            } | null>
                                          }> | null
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          valueType: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          valueType: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          valueType: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          valueType: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          valueType: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                            properties: Array<{
                                              __typename?: "BasicProperty"
                                              alias?: string | null
                                              editorAlias?: string | null
                                              value?:
                                                | {
                                                    __typename?: "BasicBlockGridModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicBlockListModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicContentPicker"
                                                    model: string
                                                    contentList: Array<{
                                                      __typename?: "BasicContentPickerItem"
                                                      id: number
                                                      absoluteUrl: string
                                                      key: any
                                                      name?: string | null
                                                      url: string
                                                      urlSegment?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicDateTimePicker"
                                                    model: string
                                                    dateTime?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicLabel"
                                                    model: string
                                                    label?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicMediaPicker"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicMemberPicker"
                                                    model: string
                                                    members: Array<{
                                                      __typename?: "BasicMemberPickerItem"
                                                      id?: number | null
                                                      name?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicMultiUrlPicker"
                                                    model: string
                                                    links: Array<{
                                                      __typename?: "BasicMultiUrlPickerItem"
                                                      name?: string | null
                                                      target?: string | null
                                                      type: LinkType
                                                      url?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicNestedContent"
                                                    model: string
                                                    elements?: Array<{
                                                      __typename?: "BasicNestedContentElement"
                                                      properties: Array<{
                                                        __typename?: "BasicProperty"
                                                        alias?: string | null
                                                        editorAlias?:
                                                          | string
                                                          | null
                                                        value?:
                                                          | {
                                                              __typename?: "BasicBlockGridModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicBlockListModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicContentPicker"
                                                              model: string
                                                              contentList: Array<{
                                                                __typename?: "BasicContentPickerItem"
                                                                id: number
                                                                absoluteUrl: string
                                                                key: any
                                                                name?:
                                                                  | string
                                                                  | null
                                                                url: string
                                                                urlSegment?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicDateTimePicker"
                                                              model: string
                                                              dateTime?:
                                                                | any
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicLabel"
                                                              model: string
                                                              label?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicMediaPicker"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicMemberPicker"
                                                              model: string
                                                              members: Array<{
                                                                __typename?: "BasicMemberPickerItem"
                                                                id?:
                                                                  | number
                                                                  | null
                                                                name?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicMultiUrlPicker"
                                                              model: string
                                                              links: Array<{
                                                                __typename?: "BasicMultiUrlPickerItem"
                                                                name?:
                                                                  | string
                                                                  | null
                                                                target?:
                                                                  | string
                                                                  | null
                                                                type: LinkType
                                                                url?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicNestedContent"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicPropertyValue"
                                                              model: string
                                                              value?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicRichText"
                                                              model: string
                                                              richText?:
                                                                | string
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicUnsupportedPropertyValue"
                                                              model: string
                                                              message: string
                                                            }
                                                          | {
                                                              __typename?: "MintMediaPicker"
                                                              model: string
                                                              mediaItems: Array<{
                                                                __typename?: "MintMediaPickerItem"
                                                                id: number
                                                                url: string
                                                                altText?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | null
                                                      } | null>
                                                    }> | null
                                                  }
                                                | {
                                                    __typename?: "BasicPropertyValue"
                                                    model: string
                                                    value?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicRichText"
                                                    model: string
                                                    richText?: string | null
                                                  }
                                                | {
                                                    __typename?: "BasicUnsupportedPropertyValue"
                                                    model: string
                                                    message: string
                                                  }
                                                | {
                                                    __typename?: "MintMediaPicker"
                                                    model: string
                                                    mediaItems: Array<{
                                                      __typename?: "MintMediaPickerItem"
                                                      id: number
                                                      url: string
                                                      altText?: string | null
                                                    }>
                                                  }
                                                | null
                                            } | null>
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          valueType: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          valueType: string
                                          elements?: Array<{
                                            __typename?: "BasicNestedContentElement"
                                            properties: Array<{
                                              __typename?: "BasicProperty"
                                              alias?: string | null
                                              editorAlias?: string | null
                                              value?:
                                                | {
                                                    __typename?: "BasicBlockGridModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicBlockListModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicContentPicker"
                                                    model: string
                                                    contentList: Array<{
                                                      __typename?: "BasicContentPickerItem"
                                                      id: number
                                                      absoluteUrl: string
                                                      key: any
                                                      name?: string | null
                                                      url: string
                                                      urlSegment?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicDateTimePicker"
                                                    model: string
                                                    dateTime?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicLabel"
                                                    model: string
                                                    label?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicMediaPicker"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicMemberPicker"
                                                    model: string
                                                    members: Array<{
                                                      __typename?: "BasicMemberPickerItem"
                                                      id?: number | null
                                                      name?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicMultiUrlPicker"
                                                    model: string
                                                    links: Array<{
                                                      __typename?: "BasicMultiUrlPickerItem"
                                                      name?: string | null
                                                      target?: string | null
                                                      type: LinkType
                                                      url?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicNestedContent"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicPropertyValue"
                                                    model: string
                                                    value?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicRichText"
                                                    model: string
                                                    richText?: string | null
                                                  }
                                                | {
                                                    __typename?: "BasicUnsupportedPropertyValue"
                                                    model: string
                                                    message: string
                                                  }
                                                | {
                                                    __typename?: "MintMediaPicker"
                                                    model: string
                                                    mediaItems: Array<{
                                                      __typename?: "MintMediaPickerItem"
                                                      id: number
                                                      url: string
                                                      altText?: string | null
                                                    }>
                                                  }
                                                | null
                                            } | null>
                                          }> | null
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          valueType: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          valueType: string
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          message: string
                                          valueType: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          valueType: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }> | null
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                valueType: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                valueType: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                valueType: string
                                label?: any | null
                              }
                            | {
                                __typename?: "BasicMediaPicker"
                                valueType: string
                              }
                            | {
                                __typename?: "BasicMemberPicker"
                                valueType: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    alias?: string | null
                                    editorAlias?: string | null
                                    value?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          model: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          model: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          model: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          model: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          model: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          model: string
                                          elements?: Array<{
                                            __typename?: "BasicNestedContentElement"
                                            properties: Array<{
                                              __typename?: "BasicProperty"
                                              alias?: string | null
                                              editorAlias?: string | null
                                              value?:
                                                | {
                                                    __typename?: "BasicBlockGridModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicBlockListModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicContentPicker"
                                                    model: string
                                                    contentList: Array<{
                                                      __typename?: "BasicContentPickerItem"
                                                      id: number
                                                      absoluteUrl: string
                                                      key: any
                                                      name?: string | null
                                                      url: string
                                                      urlSegment?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicDateTimePicker"
                                                    model: string
                                                    dateTime?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicLabel"
                                                    model: string
                                                    label?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicMediaPicker"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicMemberPicker"
                                                    model: string
                                                    members: Array<{
                                                      __typename?: "BasicMemberPickerItem"
                                                      id?: number | null
                                                      name?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicMultiUrlPicker"
                                                    model: string
                                                    links: Array<{
                                                      __typename?: "BasicMultiUrlPickerItem"
                                                      name?: string | null
                                                      target?: string | null
                                                      type: LinkType
                                                      url?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicNestedContent"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicPropertyValue"
                                                    model: string
                                                    value?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicRichText"
                                                    model: string
                                                    richText?: string | null
                                                  }
                                                | {
                                                    __typename?: "BasicUnsupportedPropertyValue"
                                                    model: string
                                                    message: string
                                                  }
                                                | {
                                                    __typename?: "MintMediaPicker"
                                                    model: string
                                                    mediaItems: Array<{
                                                      __typename?: "MintMediaPickerItem"
                                                      id: number
                                                      url: string
                                                      altText?: string | null
                                                    }>
                                                  }
                                                | null
                                            } | null>
                                          }> | null
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          model: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          model: string
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          model: string
                                          message: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          model: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                valueType: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                valueType: string
                                elements?: Array<{
                                  __typename?: "BasicNestedContentElement"
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    alias?: string | null
                                    editorAlias?: string | null
                                    value?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          model: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          model: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          model: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          model: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          model: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          model: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          model: string
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          model: string
                                          message: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          model: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }> | null
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                valueType: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                valueType: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                message: string
                                valueType: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                valueType: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicContentPicker"
                      valueType: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      valueType: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      valueType: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; valueType: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      valueType: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                                elements?: Array<{
                                  __typename?: "BasicNestedContentElement"
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    alias?: string | null
                                    editorAlias?: string | null
                                    value?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          model: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          model: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          model: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          model: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          model: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          model: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          model: string
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          model: string
                                          message: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          model: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }> | null
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      valueType: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicNestedContent"
                      valueType: string
                      elements?: Array<{
                        __typename?: "BasicNestedContentElement"
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicPropertyValue"
                      valueType: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      valueType: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      message: string
                      valueType: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      valueType: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }> | null
          }
        | {
            __typename?: "BasicContentPicker"
            valueType: string
            contentList: Array<{
              __typename?: "BasicContentPickerItem"
              id: number
              absoluteUrl: string
              key: any
              name?: string | null
              url: string
              urlSegment?: string | null
            }>
          }
        | {
            __typename?: "BasicDateTimePicker"
            valueType: string
            dateTime?: any | null
          }
        | { __typename?: "BasicLabel"; valueType: string; label?: any | null }
        | { __typename?: "BasicMediaPicker"; valueType: string }
        | {
            __typename?: "BasicMemberPicker"
            valueType: string
            members: Array<{
              __typename?: "BasicMemberPickerItem"
              id?: number | null
              name?: string | null
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicNestedContent"
                      model: string
                      elements?: Array<{
                        __typename?: "BasicNestedContentElement"
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }>
          }
        | {
            __typename?: "BasicMultiUrlPicker"
            valueType: string
            links: Array<{
              __typename?: "BasicMultiUrlPickerItem"
              name?: string | null
              target?: string | null
              type: LinkType
              url?: string | null
            }>
          }
        | {
            __typename?: "BasicNestedContent"
            valueType: string
            elements?: Array<{
              __typename?: "BasicNestedContentElement"
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | { __typename?: "BasicNestedContent"; model: string }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }> | null
          }
        | {
            __typename?: "BasicPropertyValue"
            valueType: string
            value?: any | null
          }
        | {
            __typename?: "BasicRichText"
            valueType: string
            richText?: string | null
          }
        | {
            __typename?: "BasicUnsupportedPropertyValue"
            message: string
            valueType: string
          }
        | {
            __typename?: "MintMediaPicker"
            valueType: string
            mediaItems: Array<{
              __typename?: "MintMediaPickerItem"
              id: number
              url: string
              altText?: string | null
            }>
          }
        | null
    } | null>
  }> | null
}

type PropertyValues_BasicContentPicker_Fragment = {
  __typename?: "BasicContentPicker"
  valueType: string
  contentList: Array<{
    __typename?: "BasicContentPickerItem"
    id: number
    absoluteUrl: string
    key: any
    name?: string | null
    url: string
    urlSegment?: string | null
  }>
}

type PropertyValues_BasicDateTimePicker_Fragment = {
  __typename?: "BasicDateTimePicker"
  valueType: string
  dateTime?: any | null
}

type PropertyValues_BasicLabel_Fragment = {
  __typename?: "BasicLabel"
  valueType: string
  label?: any | null
}

type PropertyValues_BasicMediaPicker_Fragment = {
  __typename?: "BasicMediaPicker"
  valueType: string
}

type PropertyValues_BasicMemberPicker_Fragment = {
  __typename?: "BasicMemberPicker"
  valueType: string
  members: Array<{
    __typename?: "BasicMemberPickerItem"
    id?: number | null
    name?: string | null
    properties: Array<{
      __typename?: "BasicProperty"
      alias?: string | null
      editorAlias?: string | null
      value?:
        | { __typename?: "BasicBlockGridModel"; model: string }
        | { __typename?: "BasicBlockListModel"; model: string }
        | {
            __typename?: "BasicContentPicker"
            model: string
            contentList: Array<{
              __typename?: "BasicContentPickerItem"
              id: number
              absoluteUrl: string
              key: any
              name?: string | null
              url: string
              urlSegment?: string | null
            }>
          }
        | {
            __typename?: "BasicDateTimePicker"
            model: string
            dateTime?: any | null
          }
        | { __typename?: "BasicLabel"; model: string; label?: any | null }
        | { __typename?: "BasicMediaPicker"; model: string }
        | {
            __typename?: "BasicMemberPicker"
            model: string
            members: Array<{
              __typename?: "BasicMemberPickerItem"
              id?: number | null
              name?: string | null
            }>
          }
        | {
            __typename?: "BasicMultiUrlPicker"
            model: string
            links: Array<{
              __typename?: "BasicMultiUrlPickerItem"
              name?: string | null
              target?: string | null
              type: LinkType
              url?: string | null
            }>
          }
        | {
            __typename?: "BasicNestedContent"
            model: string
            elements?: Array<{
              __typename?: "BasicNestedContentElement"
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | { __typename?: "BasicNestedContent"; model: string }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }> | null
          }
        | {
            __typename?: "BasicPropertyValue"
            model: string
            value?: any | null
          }
        | {
            __typename?: "BasicRichText"
            model: string
            richText?: string | null
          }
        | {
            __typename?: "BasicUnsupportedPropertyValue"
            model: string
            message: string
          }
        | {
            __typename?: "MintMediaPicker"
            model: string
            mediaItems: Array<{
              __typename?: "MintMediaPickerItem"
              id: number
              url: string
              altText?: string | null
            }>
          }
        | null
    } | null>
  }>
}

type PropertyValues_BasicMultiUrlPicker_Fragment = {
  __typename?: "BasicMultiUrlPicker"
  valueType: string
  links: Array<{
    __typename?: "BasicMultiUrlPickerItem"
    name?: string | null
    target?: string | null
    type: LinkType
    url?: string | null
  }>
}

type PropertyValues_BasicNestedContent_Fragment = {
  __typename?: "BasicNestedContent"
  valueType: string
  elements?: Array<{
    __typename?: "BasicNestedContentElement"
    properties: Array<{
      __typename?: "BasicProperty"
      alias?: string | null
      editorAlias?: string | null
      value?:
        | { __typename?: "BasicBlockGridModel"; model: string }
        | { __typename?: "BasicBlockListModel"; model: string }
        | {
            __typename?: "BasicContentPicker"
            model: string
            contentList: Array<{
              __typename?: "BasicContentPickerItem"
              id: number
              absoluteUrl: string
              key: any
              name?: string | null
              url: string
              urlSegment?: string | null
            }>
          }
        | {
            __typename?: "BasicDateTimePicker"
            model: string
            dateTime?: any | null
          }
        | { __typename?: "BasicLabel"; model: string; label?: any | null }
        | { __typename?: "BasicMediaPicker"; model: string }
        | {
            __typename?: "BasicMemberPicker"
            model: string
            members: Array<{
              __typename?: "BasicMemberPickerItem"
              id?: number | null
              name?: string | null
            }>
          }
        | {
            __typename?: "BasicMultiUrlPicker"
            model: string
            links: Array<{
              __typename?: "BasicMultiUrlPickerItem"
              name?: string | null
              target?: string | null
              type: LinkType
              url?: string | null
            }>
          }
        | { __typename?: "BasicNestedContent"; model: string }
        | {
            __typename?: "BasicPropertyValue"
            model: string
            value?: any | null
          }
        | {
            __typename?: "BasicRichText"
            model: string
            richText?: string | null
          }
        | {
            __typename?: "BasicUnsupportedPropertyValue"
            model: string
            message: string
          }
        | {
            __typename?: "MintMediaPicker"
            model: string
            mediaItems: Array<{
              __typename?: "MintMediaPickerItem"
              id: number
              url: string
              altText?: string | null
            }>
          }
        | null
    } | null>
  }> | null
}

type PropertyValues_BasicPropertyValue_Fragment = {
  __typename?: "BasicPropertyValue"
  valueType: string
  value?: any | null
}

type PropertyValues_BasicRichText_Fragment = {
  __typename?: "BasicRichText"
  valueType: string
  richText?: string | null
}

type PropertyValues_BasicUnsupportedPropertyValue_Fragment = {
  __typename?: "BasicUnsupportedPropertyValue"
  message: string
  valueType: string
}

type PropertyValues_MintMediaPicker_Fragment = {
  __typename?: "MintMediaPicker"
  valueType: string
  mediaItems: Array<{
    __typename?: "MintMediaPickerItem"
    id: number
    url: string
    altText?: string | null
  }>
}

export type PropertyValuesFragment =
  | PropertyValues_BasicBlockGridModel_Fragment
  | PropertyValues_BasicBlockListModel_Fragment
  | PropertyValues_BasicContentPicker_Fragment
  | PropertyValues_BasicDateTimePicker_Fragment
  | PropertyValues_BasicLabel_Fragment
  | PropertyValues_BasicMediaPicker_Fragment
  | PropertyValues_BasicMemberPicker_Fragment
  | PropertyValues_BasicMultiUrlPicker_Fragment
  | PropertyValues_BasicNestedContent_Fragment
  | PropertyValues_BasicPropertyValue_Fragment
  | PropertyValues_BasicRichText_Fragment
  | PropertyValues_BasicUnsupportedPropertyValue_Fragment
  | PropertyValues_MintMediaPicker_Fragment

export type GetPagesWithOldUrLsQueryVariables = Exact<{
  route: Scalars["String"]["input"]
  culture: Scalars["String"]["input"]
}>

export type GetPagesWithOldUrLsQuery = {
  __typename?: "Query"
  components?: {
    __typename?: "ContentDescendantsByAbsoluteRouteConnection"
    edges?: Array<{
      __typename?: "ContentDescendantsByAbsoluteRouteEdge"
      node?: {
        __typename?: "BasicContent"
        url?: string | null
        properties?: Array<{
          __typename?: "BasicProperty"
          propertyName?: string | null
          propertyValue?:
            | { __typename?: "BasicBlockGridModel" }
            | { __typename?: "BasicBlockListModel" }
            | { __typename?: "BasicContentPicker" }
            | { __typename?: "BasicDateTimePicker" }
            | { __typename?: "BasicLabel" }
            | { __typename?: "BasicMediaPicker" }
            | { __typename?: "BasicMemberPicker" }
            | {
                __typename?: "BasicMultiUrlPicker"
                links: Array<{
                  __typename?: "BasicMultiUrlPickerItem"
                  url?: string | null
                }>
              }
            | { __typename?: "BasicNestedContent" }
            | { __typename?: "BasicPropertyValue" }
            | { __typename?: "BasicRichText" }
            | { __typename?: "BasicUnsupportedPropertyValue" }
            | { __typename?: "MintMediaPicker" }
            | null
        } | null> | null
        children?: Array<{
          __typename?: "BasicContent"
          url?: string | null
          properties?: Array<{
            __typename?: "BasicProperty"
            propertyName?: string | null
            propertyValue?:
              | { __typename?: "BasicBlockGridModel" }
              | { __typename?: "BasicBlockListModel" }
              | { __typename?: "BasicContentPicker" }
              | { __typename?: "BasicDateTimePicker" }
              | { __typename?: "BasicLabel" }
              | { __typename?: "BasicMediaPicker" }
              | { __typename?: "BasicMemberPicker" }
              | {
                  __typename?: "BasicMultiUrlPicker"
                  links: Array<{
                    __typename?: "BasicMultiUrlPickerItem"
                    url?: string | null
                  }>
                }
              | { __typename?: "BasicNestedContent" }
              | { __typename?: "BasicPropertyValue" }
              | { __typename?: "BasicRichText" }
              | { __typename?: "BasicUnsupportedPropertyValue" }
              | { __typename?: "MintMediaPicker" }
              | null
          } | null> | null
        } | null> | null
      } | null
    }> | null
  } | null
}

export type GetPageByRouteQueryVariables = Exact<{
  route: Scalars["String"]["input"]
  culture?: InputMaybe<Scalars["String"]["input"]>
}>

export type GetPageByRouteQuery = {
  __typename?: "Query"
  page?: {
    __typename?: "BasicContent"
    url?: string | null
    absoluteUrl?: string | null
    level?: number | null
    parent?: {
      __typename?: "BasicContent"
      id?: number | null
      url?: string | null
      level?: number | null
      properties?: Array<{
        __typename?: "BasicProperty"
        propertyName?: string | null
        propertyValue?:
          | {
              __typename?: "BasicBlockGridModel"
              gridColumns?: number | null
              valueType: string
              blocks?: Array<{
                __typename?: "BasicBlockGridItem"
                columnSpan: number
                rowSpan: number
                contentProperties: Array<{
                  __typename?: "BasicProperty"
                  value?:
                    | { __typename?: "BasicBlockGridModel"; valueType: string }
                    | { __typename?: "BasicBlockListModel"; valueType: string }
                    | {
                        __typename?: "BasicContentPicker"
                        valueType: string
                        contentList: Array<{
                          __typename?: "BasicContentPickerItem"
                          id: number
                          absoluteUrl: string
                          key: any
                          name?: string | null
                          url: string
                          urlSegment?: string | null
                        }>
                      }
                    | {
                        __typename?: "BasicDateTimePicker"
                        valueType: string
                        dateTime?: any | null
                      }
                    | {
                        __typename?: "BasicLabel"
                        valueType: string
                        label?: any | null
                      }
                    | { __typename?: "BasicMediaPicker"; valueType: string }
                    | {
                        __typename?: "BasicMemberPicker"
                        valueType: string
                        members: Array<{
                          __typename?: "BasicMemberPickerItem"
                          id?: number | null
                          name?: string | null
                          properties: Array<{
                            __typename?: "BasicProperty"
                            alias?: string | null
                            editorAlias?: string | null
                            value?:
                              | {
                                  __typename?: "BasicBlockGridModel"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicBlockListModel"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicContentPicker"
                                  model: string
                                  contentList: Array<{
                                    __typename?: "BasicContentPickerItem"
                                    id: number
                                    absoluteUrl: string
                                    key: any
                                    name?: string | null
                                    url: string
                                    urlSegment?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicDateTimePicker"
                                  model: string
                                  dateTime?: any | null
                                }
                              | {
                                  __typename?: "BasicLabel"
                                  model: string
                                  label?: any | null
                                }
                              | {
                                  __typename?: "BasicMediaPicker"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicMemberPicker"
                                  model: string
                                  members: Array<{
                                    __typename?: "BasicMemberPickerItem"
                                    id?: number | null
                                    name?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicMultiUrlPicker"
                                  model: string
                                  links: Array<{
                                    __typename?: "BasicMultiUrlPickerItem"
                                    name?: string | null
                                    target?: string | null
                                    type: LinkType
                                    url?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicNestedContent"
                                  model: string
                                  elements?: Array<{
                                    __typename?: "BasicNestedContentElement"
                                    properties: Array<{
                                      __typename?: "BasicProperty"
                                      alias?: string | null
                                      editorAlias?: string | null
                                      value?:
                                        | {
                                            __typename?: "BasicBlockGridModel"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicBlockListModel"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicContentPicker"
                                            model: string
                                            contentList: Array<{
                                              __typename?: "BasicContentPickerItem"
                                              id: number
                                              absoluteUrl: string
                                              key: any
                                              name?: string | null
                                              url: string
                                              urlSegment?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicDateTimePicker"
                                            model: string
                                            dateTime?: any | null
                                          }
                                        | {
                                            __typename?: "BasicLabel"
                                            model: string
                                            label?: any | null
                                          }
                                        | {
                                            __typename?: "BasicMediaPicker"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicMemberPicker"
                                            model: string
                                            members: Array<{
                                              __typename?: "BasicMemberPickerItem"
                                              id?: number | null
                                              name?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicMultiUrlPicker"
                                            model: string
                                            links: Array<{
                                              __typename?: "BasicMultiUrlPickerItem"
                                              name?: string | null
                                              target?: string | null
                                              type: LinkType
                                              url?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicNestedContent"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicPropertyValue"
                                            model: string
                                            value?: any | null
                                          }
                                        | {
                                            __typename?: "BasicRichText"
                                            model: string
                                            richText?: string | null
                                          }
                                        | {
                                            __typename?: "BasicUnsupportedPropertyValue"
                                            model: string
                                            message: string
                                          }
                                        | {
                                            __typename?: "MintMediaPicker"
                                            model: string
                                            mediaItems: Array<{
                                              __typename?: "MintMediaPickerItem"
                                              id: number
                                              url: string
                                              altText?: string | null
                                            }>
                                          }
                                        | null
                                    } | null>
                                  }> | null
                                }
                              | {
                                  __typename?: "BasicPropertyValue"
                                  model: string
                                  value?: any | null
                                }
                              | {
                                  __typename?: "BasicRichText"
                                  model: string
                                  richText?: string | null
                                }
                              | {
                                  __typename?: "BasicUnsupportedPropertyValue"
                                  model: string
                                  message: string
                                }
                              | {
                                  __typename?: "MintMediaPicker"
                                  model: string
                                  mediaItems: Array<{
                                    __typename?: "MintMediaPickerItem"
                                    id: number
                                    url: string
                                    altText?: string | null
                                  }>
                                }
                              | null
                          } | null>
                        }>
                      }
                    | {
                        __typename?: "BasicMultiUrlPicker"
                        valueType: string
                        links: Array<{
                          __typename?: "BasicMultiUrlPickerItem"
                          name?: string | null
                          target?: string | null
                          type: LinkType
                          url?: string | null
                        }>
                      }
                    | {
                        __typename?: "BasicNestedContent"
                        valueType: string
                        elements?: Array<{
                          __typename?: "BasicNestedContentElement"
                          properties: Array<{
                            __typename?: "BasicProperty"
                            alias?: string | null
                            editorAlias?: string | null
                            value?:
                              | {
                                  __typename?: "BasicBlockGridModel"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicBlockListModel"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicContentPicker"
                                  model: string
                                  contentList: Array<{
                                    __typename?: "BasicContentPickerItem"
                                    id: number
                                    absoluteUrl: string
                                    key: any
                                    name?: string | null
                                    url: string
                                    urlSegment?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicDateTimePicker"
                                  model: string
                                  dateTime?: any | null
                                }
                              | {
                                  __typename?: "BasicLabel"
                                  model: string
                                  label?: any | null
                                }
                              | {
                                  __typename?: "BasicMediaPicker"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicMemberPicker"
                                  model: string
                                  members: Array<{
                                    __typename?: "BasicMemberPickerItem"
                                    id?: number | null
                                    name?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicMultiUrlPicker"
                                  model: string
                                  links: Array<{
                                    __typename?: "BasicMultiUrlPickerItem"
                                    name?: string | null
                                    target?: string | null
                                    type: LinkType
                                    url?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicNestedContent"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicPropertyValue"
                                  model: string
                                  value?: any | null
                                }
                              | {
                                  __typename?: "BasicRichText"
                                  model: string
                                  richText?: string | null
                                }
                              | {
                                  __typename?: "BasicUnsupportedPropertyValue"
                                  model: string
                                  message: string
                                }
                              | {
                                  __typename?: "MintMediaPicker"
                                  model: string
                                  mediaItems: Array<{
                                    __typename?: "MintMediaPickerItem"
                                    id: number
                                    url: string
                                    altText?: string | null
                                  }>
                                }
                              | null
                          } | null>
                        }> | null
                      }
                    | {
                        __typename?: "BasicPropertyValue"
                        valueType: string
                        value?: any | null
                      }
                    | {
                        __typename?: "BasicRichText"
                        valueType: string
                        richText?: string | null
                      }
                    | {
                        __typename?: "BasicUnsupportedPropertyValue"
                        message: string
                        valueType: string
                      }
                    | {
                        __typename?: "MintMediaPicker"
                        valueType: string
                        mediaItems: Array<{
                          __typename?: "MintMediaPickerItem"
                          id: number
                          url: string
                          altText?: string | null
                        }>
                      }
                    | null
                } | null>
                settingsProperties: Array<{
                  __typename?: "BasicProperty"
                  value?:
                    | { __typename?: "BasicBlockGridModel"; valueType: string }
                    | { __typename?: "BasicBlockListModel"; valueType: string }
                    | {
                        __typename?: "BasicContentPicker"
                        valueType: string
                        contentList: Array<{
                          __typename?: "BasicContentPickerItem"
                          id: number
                          absoluteUrl: string
                          key: any
                          name?: string | null
                          url: string
                          urlSegment?: string | null
                        }>
                      }
                    | {
                        __typename?: "BasicDateTimePicker"
                        valueType: string
                        dateTime?: any | null
                      }
                    | {
                        __typename?: "BasicLabel"
                        valueType: string
                        label?: any | null
                      }
                    | { __typename?: "BasicMediaPicker"; valueType: string }
                    | {
                        __typename?: "BasicMemberPicker"
                        valueType: string
                        members: Array<{
                          __typename?: "BasicMemberPickerItem"
                          id?: number | null
                          name?: string | null
                          properties: Array<{
                            __typename?: "BasicProperty"
                            alias?: string | null
                            editorAlias?: string | null
                            value?:
                              | {
                                  __typename?: "BasicBlockGridModel"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicBlockListModel"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicContentPicker"
                                  model: string
                                  contentList: Array<{
                                    __typename?: "BasicContentPickerItem"
                                    id: number
                                    absoluteUrl: string
                                    key: any
                                    name?: string | null
                                    url: string
                                    urlSegment?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicDateTimePicker"
                                  model: string
                                  dateTime?: any | null
                                }
                              | {
                                  __typename?: "BasicLabel"
                                  model: string
                                  label?: any | null
                                }
                              | {
                                  __typename?: "BasicMediaPicker"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicMemberPicker"
                                  model: string
                                  members: Array<{
                                    __typename?: "BasicMemberPickerItem"
                                    id?: number | null
                                    name?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicMultiUrlPicker"
                                  model: string
                                  links: Array<{
                                    __typename?: "BasicMultiUrlPickerItem"
                                    name?: string | null
                                    target?: string | null
                                    type: LinkType
                                    url?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicNestedContent"
                                  model: string
                                  elements?: Array<{
                                    __typename?: "BasicNestedContentElement"
                                    properties: Array<{
                                      __typename?: "BasicProperty"
                                      alias?: string | null
                                      editorAlias?: string | null
                                      value?:
                                        | {
                                            __typename?: "BasicBlockGridModel"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicBlockListModel"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicContentPicker"
                                            model: string
                                            contentList: Array<{
                                              __typename?: "BasicContentPickerItem"
                                              id: number
                                              absoluteUrl: string
                                              key: any
                                              name?: string | null
                                              url: string
                                              urlSegment?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicDateTimePicker"
                                            model: string
                                            dateTime?: any | null
                                          }
                                        | {
                                            __typename?: "BasicLabel"
                                            model: string
                                            label?: any | null
                                          }
                                        | {
                                            __typename?: "BasicMediaPicker"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicMemberPicker"
                                            model: string
                                            members: Array<{
                                              __typename?: "BasicMemberPickerItem"
                                              id?: number | null
                                              name?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicMultiUrlPicker"
                                            model: string
                                            links: Array<{
                                              __typename?: "BasicMultiUrlPickerItem"
                                              name?: string | null
                                              target?: string | null
                                              type: LinkType
                                              url?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicNestedContent"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicPropertyValue"
                                            model: string
                                            value?: any | null
                                          }
                                        | {
                                            __typename?: "BasicRichText"
                                            model: string
                                            richText?: string | null
                                          }
                                        | {
                                            __typename?: "BasicUnsupportedPropertyValue"
                                            model: string
                                            message: string
                                          }
                                        | {
                                            __typename?: "MintMediaPicker"
                                            model: string
                                            mediaItems: Array<{
                                              __typename?: "MintMediaPickerItem"
                                              id: number
                                              url: string
                                              altText?: string | null
                                            }>
                                          }
                                        | null
                                    } | null>
                                  }> | null
                                }
                              | {
                                  __typename?: "BasicPropertyValue"
                                  model: string
                                  value?: any | null
                                }
                              | {
                                  __typename?: "BasicRichText"
                                  model: string
                                  richText?: string | null
                                }
                              | {
                                  __typename?: "BasicUnsupportedPropertyValue"
                                  model: string
                                  message: string
                                }
                              | {
                                  __typename?: "MintMediaPicker"
                                  model: string
                                  mediaItems: Array<{
                                    __typename?: "MintMediaPickerItem"
                                    id: number
                                    url: string
                                    altText?: string | null
                                  }>
                                }
                              | null
                          } | null>
                        }>
                      }
                    | {
                        __typename?: "BasicMultiUrlPicker"
                        valueType: string
                        links: Array<{
                          __typename?: "BasicMultiUrlPickerItem"
                          name?: string | null
                          target?: string | null
                          type: LinkType
                          url?: string | null
                        }>
                      }
                    | {
                        __typename?: "BasicNestedContent"
                        valueType: string
                        elements?: Array<{
                          __typename?: "BasicNestedContentElement"
                          properties: Array<{
                            __typename?: "BasicProperty"
                            alias?: string | null
                            editorAlias?: string | null
                            value?:
                              | {
                                  __typename?: "BasicBlockGridModel"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicBlockListModel"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicContentPicker"
                                  model: string
                                  contentList: Array<{
                                    __typename?: "BasicContentPickerItem"
                                    id: number
                                    absoluteUrl: string
                                    key: any
                                    name?: string | null
                                    url: string
                                    urlSegment?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicDateTimePicker"
                                  model: string
                                  dateTime?: any | null
                                }
                              | {
                                  __typename?: "BasicLabel"
                                  model: string
                                  label?: any | null
                                }
                              | {
                                  __typename?: "BasicMediaPicker"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicMemberPicker"
                                  model: string
                                  members: Array<{
                                    __typename?: "BasicMemberPickerItem"
                                    id?: number | null
                                    name?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicMultiUrlPicker"
                                  model: string
                                  links: Array<{
                                    __typename?: "BasicMultiUrlPickerItem"
                                    name?: string | null
                                    target?: string | null
                                    type: LinkType
                                    url?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicNestedContent"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicPropertyValue"
                                  model: string
                                  value?: any | null
                                }
                              | {
                                  __typename?: "BasicRichText"
                                  model: string
                                  richText?: string | null
                                }
                              | {
                                  __typename?: "BasicUnsupportedPropertyValue"
                                  model: string
                                  message: string
                                }
                              | {
                                  __typename?: "MintMediaPicker"
                                  model: string
                                  mediaItems: Array<{
                                    __typename?: "MintMediaPickerItem"
                                    id: number
                                    url: string
                                    altText?: string | null
                                  }>
                                }
                              | null
                          } | null>
                        }> | null
                      }
                    | {
                        __typename?: "BasicPropertyValue"
                        valueType: string
                        value?: any | null
                      }
                    | {
                        __typename?: "BasicRichText"
                        valueType: string
                        richText?: string | null
                      }
                    | {
                        __typename?: "BasicUnsupportedPropertyValue"
                        message: string
                        valueType: string
                      }
                    | {
                        __typename?: "MintMediaPicker"
                        valueType: string
                        mediaItems: Array<{
                          __typename?: "MintMediaPickerItem"
                          id: number
                          url: string
                          altText?: string | null
                        }>
                      }
                    | null
                } | null>
                areas: Array<{
                  __typename?: "BasicBlockGridArea"
                  alias?: string | null
                  rowSpan: number
                  columnSpan: number
                  blocks?: Array<{
                    __typename?: "BasicBlockGridItem"
                    columnSpan: number
                    rowSpan: number
                    contentProperties: Array<{
                      __typename?: "BasicProperty"
                      value?:
                        | {
                            __typename?: "BasicBlockGridModel"
                            valueType: string
                          }
                        | {
                            __typename?: "BasicBlockListModel"
                            valueType: string
                          }
                        | {
                            __typename?: "BasicContentPicker"
                            valueType: string
                            contentList: Array<{
                              __typename?: "BasicContentPickerItem"
                              id: number
                              absoluteUrl: string
                              key: any
                              name?: string | null
                              url: string
                              urlSegment?: string | null
                            }>
                          }
                        | {
                            __typename?: "BasicDateTimePicker"
                            valueType: string
                            dateTime?: any | null
                          }
                        | {
                            __typename?: "BasicLabel"
                            valueType: string
                            label?: any | null
                          }
                        | { __typename?: "BasicMediaPicker"; valueType: string }
                        | {
                            __typename?: "BasicMemberPicker"
                            valueType: string
                            members: Array<{
                              __typename?: "BasicMemberPickerItem"
                              id?: number | null
                              name?: string | null
                              properties: Array<{
                                __typename?: "BasicProperty"
                                alias?: string | null
                                editorAlias?: string | null
                                value?:
                                  | {
                                      __typename?: "BasicBlockGridModel"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicBlockListModel"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicContentPicker"
                                      model: string
                                      contentList: Array<{
                                        __typename?: "BasicContentPickerItem"
                                        id: number
                                        absoluteUrl: string
                                        key: any
                                        name?: string | null
                                        url: string
                                        urlSegment?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicDateTimePicker"
                                      model: string
                                      dateTime?: any | null
                                    }
                                  | {
                                      __typename?: "BasicLabel"
                                      model: string
                                      label?: any | null
                                    }
                                  | {
                                      __typename?: "BasicMediaPicker"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicMemberPicker"
                                      model: string
                                      members: Array<{
                                        __typename?: "BasicMemberPickerItem"
                                        id?: number | null
                                        name?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicMultiUrlPicker"
                                      model: string
                                      links: Array<{
                                        __typename?: "BasicMultiUrlPickerItem"
                                        name?: string | null
                                        target?: string | null
                                        type: LinkType
                                        url?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicNestedContent"
                                      model: string
                                      elements?: Array<{
                                        __typename?: "BasicNestedContentElement"
                                        properties: Array<{
                                          __typename?: "BasicProperty"
                                          alias?: string | null
                                          editorAlias?: string | null
                                          value?:
                                            | {
                                                __typename?: "BasicBlockGridModel"
                                                model: string
                                              }
                                            | {
                                                __typename?: "BasicBlockListModel"
                                                model: string
                                              }
                                            | {
                                                __typename?: "BasicContentPicker"
                                                model: string
                                                contentList: Array<{
                                                  __typename?: "BasicContentPickerItem"
                                                  id: number
                                                  absoluteUrl: string
                                                  key: any
                                                  name?: string | null
                                                  url: string
                                                  urlSegment?: string | null
                                                }>
                                              }
                                            | {
                                                __typename?: "BasicDateTimePicker"
                                                model: string
                                                dateTime?: any | null
                                              }
                                            | {
                                                __typename?: "BasicLabel"
                                                model: string
                                                label?: any | null
                                              }
                                            | {
                                                __typename?: "BasicMediaPicker"
                                                model: string
                                              }
                                            | {
                                                __typename?: "BasicMemberPicker"
                                                model: string
                                                members: Array<{
                                                  __typename?: "BasicMemberPickerItem"
                                                  id?: number | null
                                                  name?: string | null
                                                }>
                                              }
                                            | {
                                                __typename?: "BasicMultiUrlPicker"
                                                model: string
                                                links: Array<{
                                                  __typename?: "BasicMultiUrlPickerItem"
                                                  name?: string | null
                                                  target?: string | null
                                                  type: LinkType
                                                  url?: string | null
                                                }>
                                              }
                                            | {
                                                __typename?: "BasicNestedContent"
                                                model: string
                                              }
                                            | {
                                                __typename?: "BasicPropertyValue"
                                                model: string
                                                value?: any | null
                                              }
                                            | {
                                                __typename?: "BasicRichText"
                                                model: string
                                                richText?: string | null
                                              }
                                            | {
                                                __typename?: "BasicUnsupportedPropertyValue"
                                                model: string
                                                message: string
                                              }
                                            | {
                                                __typename?: "MintMediaPicker"
                                                model: string
                                                mediaItems: Array<{
                                                  __typename?: "MintMediaPickerItem"
                                                  id: number
                                                  url: string
                                                  altText?: string | null
                                                }>
                                              }
                                            | null
                                        } | null>
                                      }> | null
                                    }
                                  | {
                                      __typename?: "BasicPropertyValue"
                                      model: string
                                      value?: any | null
                                    }
                                  | {
                                      __typename?: "BasicRichText"
                                      model: string
                                      richText?: string | null
                                    }
                                  | {
                                      __typename?: "BasicUnsupportedPropertyValue"
                                      model: string
                                      message: string
                                    }
                                  | {
                                      __typename?: "MintMediaPicker"
                                      model: string
                                      mediaItems: Array<{
                                        __typename?: "MintMediaPickerItem"
                                        id: number
                                        url: string
                                        altText?: string | null
                                      }>
                                    }
                                  | null
                              } | null>
                            }>
                          }
                        | {
                            __typename?: "BasicMultiUrlPicker"
                            valueType: string
                            links: Array<{
                              __typename?: "BasicMultiUrlPickerItem"
                              name?: string | null
                              target?: string | null
                              type: LinkType
                              url?: string | null
                            }>
                          }
                        | {
                            __typename?: "BasicNestedContent"
                            valueType: string
                            elements?: Array<{
                              __typename?: "BasicNestedContentElement"
                              properties: Array<{
                                __typename?: "BasicProperty"
                                alias?: string | null
                                editorAlias?: string | null
                                value?:
                                  | {
                                      __typename?: "BasicBlockGridModel"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicBlockListModel"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicContentPicker"
                                      model: string
                                      contentList: Array<{
                                        __typename?: "BasicContentPickerItem"
                                        id: number
                                        absoluteUrl: string
                                        key: any
                                        name?: string | null
                                        url: string
                                        urlSegment?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicDateTimePicker"
                                      model: string
                                      dateTime?: any | null
                                    }
                                  | {
                                      __typename?: "BasicLabel"
                                      model: string
                                      label?: any | null
                                    }
                                  | {
                                      __typename?: "BasicMediaPicker"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicMemberPicker"
                                      model: string
                                      members: Array<{
                                        __typename?: "BasicMemberPickerItem"
                                        id?: number | null
                                        name?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicMultiUrlPicker"
                                      model: string
                                      links: Array<{
                                        __typename?: "BasicMultiUrlPickerItem"
                                        name?: string | null
                                        target?: string | null
                                        type: LinkType
                                        url?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicNestedContent"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicPropertyValue"
                                      model: string
                                      value?: any | null
                                    }
                                  | {
                                      __typename?: "BasicRichText"
                                      model: string
                                      richText?: string | null
                                    }
                                  | {
                                      __typename?: "BasicUnsupportedPropertyValue"
                                      model: string
                                      message: string
                                    }
                                  | {
                                      __typename?: "MintMediaPicker"
                                      model: string
                                      mediaItems: Array<{
                                        __typename?: "MintMediaPickerItem"
                                        id: number
                                        url: string
                                        altText?: string | null
                                      }>
                                    }
                                  | null
                              } | null>
                            }> | null
                          }
                        | {
                            __typename?: "BasicPropertyValue"
                            valueType: string
                            value?: any | null
                          }
                        | {
                            __typename?: "BasicRichText"
                            valueType: string
                            richText?: string | null
                          }
                        | {
                            __typename?: "BasicUnsupportedPropertyValue"
                            message: string
                            valueType: string
                          }
                        | {
                            __typename?: "MintMediaPicker"
                            valueType: string
                            mediaItems: Array<{
                              __typename?: "MintMediaPickerItem"
                              id: number
                              url: string
                              altText?: string | null
                            }>
                          }
                        | null
                    } | null>
                    settingsProperties: Array<{
                      __typename?: "BasicProperty"
                      value?:
                        | {
                            __typename?: "BasicBlockGridModel"
                            valueType: string
                          }
                        | {
                            __typename?: "BasicBlockListModel"
                            valueType: string
                          }
                        | {
                            __typename?: "BasicContentPicker"
                            valueType: string
                            contentList: Array<{
                              __typename?: "BasicContentPickerItem"
                              id: number
                              absoluteUrl: string
                              key: any
                              name?: string | null
                              url: string
                              urlSegment?: string | null
                            }>
                          }
                        | {
                            __typename?: "BasicDateTimePicker"
                            valueType: string
                            dateTime?: any | null
                          }
                        | {
                            __typename?: "BasicLabel"
                            valueType: string
                            label?: any | null
                          }
                        | { __typename?: "BasicMediaPicker"; valueType: string }
                        | {
                            __typename?: "BasicMemberPicker"
                            valueType: string
                            members: Array<{
                              __typename?: "BasicMemberPickerItem"
                              id?: number | null
                              name?: string | null
                              properties: Array<{
                                __typename?: "BasicProperty"
                                alias?: string | null
                                editorAlias?: string | null
                                value?:
                                  | {
                                      __typename?: "BasicBlockGridModel"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicBlockListModel"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicContentPicker"
                                      model: string
                                      contentList: Array<{
                                        __typename?: "BasicContentPickerItem"
                                        id: number
                                        absoluteUrl: string
                                        key: any
                                        name?: string | null
                                        url: string
                                        urlSegment?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicDateTimePicker"
                                      model: string
                                      dateTime?: any | null
                                    }
                                  | {
                                      __typename?: "BasicLabel"
                                      model: string
                                      label?: any | null
                                    }
                                  | {
                                      __typename?: "BasicMediaPicker"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicMemberPicker"
                                      model: string
                                      members: Array<{
                                        __typename?: "BasicMemberPickerItem"
                                        id?: number | null
                                        name?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicMultiUrlPicker"
                                      model: string
                                      links: Array<{
                                        __typename?: "BasicMultiUrlPickerItem"
                                        name?: string | null
                                        target?: string | null
                                        type: LinkType
                                        url?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicNestedContent"
                                      model: string
                                      elements?: Array<{
                                        __typename?: "BasicNestedContentElement"
                                        properties: Array<{
                                          __typename?: "BasicProperty"
                                          alias?: string | null
                                          editorAlias?: string | null
                                          value?:
                                            | {
                                                __typename?: "BasicBlockGridModel"
                                                model: string
                                              }
                                            | {
                                                __typename?: "BasicBlockListModel"
                                                model: string
                                              }
                                            | {
                                                __typename?: "BasicContentPicker"
                                                model: string
                                                contentList: Array<{
                                                  __typename?: "BasicContentPickerItem"
                                                  id: number
                                                  absoluteUrl: string
                                                  key: any
                                                  name?: string | null
                                                  url: string
                                                  urlSegment?: string | null
                                                }>
                                              }
                                            | {
                                                __typename?: "BasicDateTimePicker"
                                                model: string
                                                dateTime?: any | null
                                              }
                                            | {
                                                __typename?: "BasicLabel"
                                                model: string
                                                label?: any | null
                                              }
                                            | {
                                                __typename?: "BasicMediaPicker"
                                                model: string
                                              }
                                            | {
                                                __typename?: "BasicMemberPicker"
                                                model: string
                                                members: Array<{
                                                  __typename?: "BasicMemberPickerItem"
                                                  id?: number | null
                                                  name?: string | null
                                                }>
                                              }
                                            | {
                                                __typename?: "BasicMultiUrlPicker"
                                                model: string
                                                links: Array<{
                                                  __typename?: "BasicMultiUrlPickerItem"
                                                  name?: string | null
                                                  target?: string | null
                                                  type: LinkType
                                                  url?: string | null
                                                }>
                                              }
                                            | {
                                                __typename?: "BasicNestedContent"
                                                model: string
                                              }
                                            | {
                                                __typename?: "BasicPropertyValue"
                                                model: string
                                                value?: any | null
                                              }
                                            | {
                                                __typename?: "BasicRichText"
                                                model: string
                                                richText?: string | null
                                              }
                                            | {
                                                __typename?: "BasicUnsupportedPropertyValue"
                                                model: string
                                                message: string
                                              }
                                            | {
                                                __typename?: "MintMediaPicker"
                                                model: string
                                                mediaItems: Array<{
                                                  __typename?: "MintMediaPickerItem"
                                                  id: number
                                                  url: string
                                                  altText?: string | null
                                                }>
                                              }
                                            | null
                                        } | null>
                                      }> | null
                                    }
                                  | {
                                      __typename?: "BasicPropertyValue"
                                      model: string
                                      value?: any | null
                                    }
                                  | {
                                      __typename?: "BasicRichText"
                                      model: string
                                      richText?: string | null
                                    }
                                  | {
                                      __typename?: "BasicUnsupportedPropertyValue"
                                      model: string
                                      message: string
                                    }
                                  | {
                                      __typename?: "MintMediaPicker"
                                      model: string
                                      mediaItems: Array<{
                                        __typename?: "MintMediaPickerItem"
                                        id: number
                                        url: string
                                        altText?: string | null
                                      }>
                                    }
                                  | null
                              } | null>
                            }>
                          }
                        | {
                            __typename?: "BasicMultiUrlPicker"
                            valueType: string
                            links: Array<{
                              __typename?: "BasicMultiUrlPickerItem"
                              name?: string | null
                              target?: string | null
                              type: LinkType
                              url?: string | null
                            }>
                          }
                        | {
                            __typename?: "BasicNestedContent"
                            valueType: string
                            elements?: Array<{
                              __typename?: "BasicNestedContentElement"
                              properties: Array<{
                                __typename?: "BasicProperty"
                                alias?: string | null
                                editorAlias?: string | null
                                value?:
                                  | {
                                      __typename?: "BasicBlockGridModel"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicBlockListModel"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicContentPicker"
                                      model: string
                                      contentList: Array<{
                                        __typename?: "BasicContentPickerItem"
                                        id: number
                                        absoluteUrl: string
                                        key: any
                                        name?: string | null
                                        url: string
                                        urlSegment?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicDateTimePicker"
                                      model: string
                                      dateTime?: any | null
                                    }
                                  | {
                                      __typename?: "BasicLabel"
                                      model: string
                                      label?: any | null
                                    }
                                  | {
                                      __typename?: "BasicMediaPicker"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicMemberPicker"
                                      model: string
                                      members: Array<{
                                        __typename?: "BasicMemberPickerItem"
                                        id?: number | null
                                        name?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicMultiUrlPicker"
                                      model: string
                                      links: Array<{
                                        __typename?: "BasicMultiUrlPickerItem"
                                        name?: string | null
                                        target?: string | null
                                        type: LinkType
                                        url?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicNestedContent"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicPropertyValue"
                                      model: string
                                      value?: any | null
                                    }
                                  | {
                                      __typename?: "BasicRichText"
                                      model: string
                                      richText?: string | null
                                    }
                                  | {
                                      __typename?: "BasicUnsupportedPropertyValue"
                                      model: string
                                      message: string
                                    }
                                  | {
                                      __typename?: "MintMediaPicker"
                                      model: string
                                      mediaItems: Array<{
                                        __typename?: "MintMediaPickerItem"
                                        id: number
                                        url: string
                                        altText?: string | null
                                      }>
                                    }
                                  | null
                              } | null>
                            }> | null
                          }
                        | {
                            __typename?: "BasicPropertyValue"
                            valueType: string
                            value?: any | null
                          }
                        | {
                            __typename?: "BasicRichText"
                            valueType: string
                            richText?: string | null
                          }
                        | {
                            __typename?: "BasicUnsupportedPropertyValue"
                            message: string
                            valueType: string
                          }
                        | {
                            __typename?: "MintMediaPicker"
                            valueType: string
                            mediaItems: Array<{
                              __typename?: "MintMediaPickerItem"
                              id: number
                              url: string
                              altText?: string | null
                            }>
                          }
                        | null
                    } | null>
                    areas: Array<{
                      __typename?: "BasicBlockGridArea"
                      alias?: string | null
                      rowSpan: number
                      columnSpan: number
                    } | null>
                  }> | null
                } | null>
              }> | null
            }
          | {
              __typename?: "BasicBlockListModel"
              valueType: string
              blocks?: Array<{
                __typename?: "BasicBlockListItem"
                blockType?: string | null
                properties: Array<{
                  __typename?: "BasicProperty"
                  propertyName?: string | null
                  propertyValue?:
                    | { __typename?: "BasicBlockGridModel"; valueType: string }
                    | {
                        __typename?: "BasicBlockListModel"
                        valueType: string
                        blocks?: Array<{
                          __typename?: "BasicBlockListItem"
                          blockType?: string | null
                          properties: Array<{
                            __typename?: "BasicProperty"
                            propertyName?: string | null
                            propertyValue?:
                              | {
                                  __typename?: "BasicBlockGridModel"
                                  valueType: string
                                }
                              | {
                                  __typename?: "BasicBlockListModel"
                                  valueType: string
                                  blocks?: Array<{
                                    __typename?: "BasicBlockListItem"
                                    blockType?: string | null
                                    properties: Array<{
                                      __typename?: "BasicProperty"
                                      propertyName?: string | null
                                      propertyValue?:
                                        | {
                                            __typename?: "BasicBlockGridModel"
                                            valueType: string
                                          }
                                        | {
                                            __typename?: "BasicBlockListModel"
                                            valueType: string
                                            blocks?: Array<{
                                              __typename?: "BasicBlockListItem"
                                              blockType?: string | null
                                              properties: Array<{
                                                __typename?: "BasicProperty"
                                                propertyName?: string | null
                                                propertyValue?:
                                                  | {
                                                      __typename?: "BasicBlockGridModel"
                                                      valueType: string
                                                    }
                                                  | {
                                                      __typename?: "BasicBlockListModel"
                                                      valueType: string
                                                      blocks?: Array<{
                                                        __typename?: "BasicBlockListItem"
                                                        blockType?:
                                                          | string
                                                          | null
                                                        properties: Array<{
                                                          __typename?: "BasicProperty"
                                                          propertyName?:
                                                            | string
                                                            | null
                                                          propertyValue?:
                                                            | {
                                                                __typename?: "BasicBlockGridModel"
                                                                valueType: string
                                                              }
                                                            | {
                                                                __typename?: "BasicBlockListModel"
                                                                valueType: string
                                                              }
                                                            | {
                                                                __typename?: "BasicContentPicker"
                                                                valueType: string
                                                                contentList: Array<{
                                                                  __typename?: "BasicContentPickerItem"
                                                                  id: number
                                                                  absoluteUrl: string
                                                                  key: any
                                                                  name?:
                                                                    | string
                                                                    | null
                                                                  url: string
                                                                  urlSegment?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | {
                                                                __typename?: "BasicDateTimePicker"
                                                                valueType: string
                                                                dateTime?:
                                                                  | any
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicLabel"
                                                                valueType: string
                                                                label?:
                                                                  | any
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicMediaPicker"
                                                                valueType: string
                                                              }
                                                            | {
                                                                __typename?: "BasicMemberPicker"
                                                                valueType: string
                                                                members: Array<{
                                                                  __typename?: "BasicMemberPickerItem"
                                                                  id?:
                                                                    | number
                                                                    | null
                                                                  name?:
                                                                    | string
                                                                    | null
                                                                  properties: Array<{
                                                                    __typename?: "BasicProperty"
                                                                    alias?:
                                                                      | string
                                                                      | null
                                                                    editorAlias?:
                                                                      | string
                                                                      | null
                                                                    value?:
                                                                      | {
                                                                          __typename?: "BasicBlockGridModel"
                                                                          model: string
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicBlockListModel"
                                                                          model: string
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicContentPicker"
                                                                          model: string
                                                                          contentList: Array<{
                                                                            __typename?: "BasicContentPickerItem"
                                                                            id: number
                                                                            absoluteUrl: string
                                                                            key: any
                                                                            name?:
                                                                              | string
                                                                              | null
                                                                            url: string
                                                                            urlSegment?:
                                                                              | string
                                                                              | null
                                                                          }>
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicDateTimePicker"
                                                                          model: string
                                                                          dateTime?:
                                                                            | any
                                                                            | null
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicLabel"
                                                                          model: string
                                                                          label?:
                                                                            | any
                                                                            | null
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicMediaPicker"
                                                                          model: string
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicMemberPicker"
                                                                          model: string
                                                                          members: Array<{
                                                                            __typename?: "BasicMemberPickerItem"
                                                                            id?:
                                                                              | number
                                                                              | null
                                                                            name?:
                                                                              | string
                                                                              | null
                                                                          }>
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicMultiUrlPicker"
                                                                          model: string
                                                                          links: Array<{
                                                                            __typename?: "BasicMultiUrlPickerItem"
                                                                            name?:
                                                                              | string
                                                                              | null
                                                                            target?:
                                                                              | string
                                                                              | null
                                                                            type: LinkType
                                                                            url?:
                                                                              | string
                                                                              | null
                                                                          }>
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicNestedContent"
                                                                          model: string
                                                                          elements?: Array<{
                                                                            __typename?: "BasicNestedContentElement"
                                                                            properties: Array<{
                                                                              __typename?: "BasicProperty"
                                                                              alias?:
                                                                                | string
                                                                                | null
                                                                              editorAlias?:
                                                                                | string
                                                                                | null
                                                                              value?:
                                                                                | {
                                                                                    __typename?: "BasicBlockGridModel"
                                                                                    model: string
                                                                                  }
                                                                                | {
                                                                                    __typename?: "BasicBlockListModel"
                                                                                    model: string
                                                                                  }
                                                                                | {
                                                                                    __typename?: "BasicContentPicker"
                                                                                    model: string
                                                                                    contentList: Array<{
                                                                                      __typename?: "BasicContentPickerItem"
                                                                                      id: number
                                                                                      absoluteUrl: string
                                                                                      key: any
                                                                                      name?:
                                                                                        | string
                                                                                        | null
                                                                                      url: string
                                                                                      urlSegment?:
                                                                                        | string
                                                                                        | null
                                                                                    }>
                                                                                  }
                                                                                | {
                                                                                    __typename?: "BasicDateTimePicker"
                                                                                    model: string
                                                                                    dateTime?:
                                                                                      | any
                                                                                      | null
                                                                                  }
                                                                                | {
                                                                                    __typename?: "BasicLabel"
                                                                                    model: string
                                                                                    label?:
                                                                                      | any
                                                                                      | null
                                                                                  }
                                                                                | {
                                                                                    __typename?: "BasicMediaPicker"
                                                                                    model: string
                                                                                  }
                                                                                | {
                                                                                    __typename?: "BasicMemberPicker"
                                                                                    model: string
                                                                                    members: Array<{
                                                                                      __typename?: "BasicMemberPickerItem"
                                                                                      id?:
                                                                                        | number
                                                                                        | null
                                                                                      name?:
                                                                                        | string
                                                                                        | null
                                                                                    }>
                                                                                  }
                                                                                | {
                                                                                    __typename?: "BasicMultiUrlPicker"
                                                                                    model: string
                                                                                    links: Array<{
                                                                                      __typename?: "BasicMultiUrlPickerItem"
                                                                                      name?:
                                                                                        | string
                                                                                        | null
                                                                                      target?:
                                                                                        | string
                                                                                        | null
                                                                                      type: LinkType
                                                                                      url?:
                                                                                        | string
                                                                                        | null
                                                                                    }>
                                                                                  }
                                                                                | {
                                                                                    __typename?: "BasicNestedContent"
                                                                                    model: string
                                                                                  }
                                                                                | {
                                                                                    __typename?: "BasicPropertyValue"
                                                                                    model: string
                                                                                    value?:
                                                                                      | any
                                                                                      | null
                                                                                  }
                                                                                | {
                                                                                    __typename?: "BasicRichText"
                                                                                    model: string
                                                                                    richText?:
                                                                                      | string
                                                                                      | null
                                                                                  }
                                                                                | {
                                                                                    __typename?: "BasicUnsupportedPropertyValue"
                                                                                    model: string
                                                                                    message: string
                                                                                  }
                                                                                | {
                                                                                    __typename?: "MintMediaPicker"
                                                                                    model: string
                                                                                    mediaItems: Array<{
                                                                                      __typename?: "MintMediaPickerItem"
                                                                                      id: number
                                                                                      url: string
                                                                                      altText?:
                                                                                        | string
                                                                                        | null
                                                                                    }>
                                                                                  }
                                                                                | null
                                                                            } | null>
                                                                          }> | null
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicPropertyValue"
                                                                          model: string
                                                                          value?:
                                                                            | any
                                                                            | null
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicRichText"
                                                                          model: string
                                                                          richText?:
                                                                            | string
                                                                            | null
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicUnsupportedPropertyValue"
                                                                          model: string
                                                                          message: string
                                                                        }
                                                                      | {
                                                                          __typename?: "MintMediaPicker"
                                                                          model: string
                                                                          mediaItems: Array<{
                                                                            __typename?: "MintMediaPickerItem"
                                                                            id: number
                                                                            url: string
                                                                            altText?:
                                                                              | string
                                                                              | null
                                                                          }>
                                                                        }
                                                                      | null
                                                                  } | null>
                                                                }>
                                                              }
                                                            | {
                                                                __typename?: "BasicMultiUrlPicker"
                                                                valueType: string
                                                                links: Array<{
                                                                  __typename?: "BasicMultiUrlPickerItem"
                                                                  name?:
                                                                    | string
                                                                    | null
                                                                  target?:
                                                                    | string
                                                                    | null
                                                                  type: LinkType
                                                                  url?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | {
                                                                __typename?: "BasicNestedContent"
                                                                valueType: string
                                                                elements?: Array<{
                                                                  __typename?: "BasicNestedContentElement"
                                                                  properties: Array<{
                                                                    __typename?: "BasicProperty"
                                                                    alias?:
                                                                      | string
                                                                      | null
                                                                    editorAlias?:
                                                                      | string
                                                                      | null
                                                                    value?:
                                                                      | {
                                                                          __typename?: "BasicBlockGridModel"
                                                                          model: string
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicBlockListModel"
                                                                          model: string
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicContentPicker"
                                                                          model: string
                                                                          contentList: Array<{
                                                                            __typename?: "BasicContentPickerItem"
                                                                            id: number
                                                                            absoluteUrl: string
                                                                            key: any
                                                                            name?:
                                                                              | string
                                                                              | null
                                                                            url: string
                                                                            urlSegment?:
                                                                              | string
                                                                              | null
                                                                          }>
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicDateTimePicker"
                                                                          model: string
                                                                          dateTime?:
                                                                            | any
                                                                            | null
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicLabel"
                                                                          model: string
                                                                          label?:
                                                                            | any
                                                                            | null
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicMediaPicker"
                                                                          model: string
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicMemberPicker"
                                                                          model: string
                                                                          members: Array<{
                                                                            __typename?: "BasicMemberPickerItem"
                                                                            id?:
                                                                              | number
                                                                              | null
                                                                            name?:
                                                                              | string
                                                                              | null
                                                                          }>
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicMultiUrlPicker"
                                                                          model: string
                                                                          links: Array<{
                                                                            __typename?: "BasicMultiUrlPickerItem"
                                                                            name?:
                                                                              | string
                                                                              | null
                                                                            target?:
                                                                              | string
                                                                              | null
                                                                            type: LinkType
                                                                            url?:
                                                                              | string
                                                                              | null
                                                                          }>
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicNestedContent"
                                                                          model: string
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicPropertyValue"
                                                                          model: string
                                                                          value?:
                                                                            | any
                                                                            | null
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicRichText"
                                                                          model: string
                                                                          richText?:
                                                                            | string
                                                                            | null
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicUnsupportedPropertyValue"
                                                                          model: string
                                                                          message: string
                                                                        }
                                                                      | {
                                                                          __typename?: "MintMediaPicker"
                                                                          model: string
                                                                          mediaItems: Array<{
                                                                            __typename?: "MintMediaPickerItem"
                                                                            id: number
                                                                            url: string
                                                                            altText?:
                                                                              | string
                                                                              | null
                                                                          }>
                                                                        }
                                                                      | null
                                                                  } | null>
                                                                }> | null
                                                              }
                                                            | {
                                                                __typename?: "BasicPropertyValue"
                                                                valueType: string
                                                                value?:
                                                                  | any
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicRichText"
                                                                valueType: string
                                                                richText?:
                                                                  | string
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicUnsupportedPropertyValue"
                                                                message: string
                                                                valueType: string
                                                              }
                                                            | {
                                                                __typename?: "MintMediaPicker"
                                                                valueType: string
                                                                mediaItems: Array<{
                                                                  __typename?: "MintMediaPickerItem"
                                                                  id: number
                                                                  url: string
                                                                  altText?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | null
                                                        } | null>
                                                      }> | null
                                                    }
                                                  | {
                                                      __typename?: "BasicContentPicker"
                                                      valueType: string
                                                      contentList: Array<{
                                                        __typename?: "BasicContentPickerItem"
                                                        id: number
                                                        absoluteUrl: string
                                                        key: any
                                                        name?: string | null
                                                        url: string
                                                        urlSegment?:
                                                          | string
                                                          | null
                                                      }>
                                                    }
                                                  | {
                                                      __typename?: "BasicDateTimePicker"
                                                      valueType: string
                                                      dateTime?: any | null
                                                    }
                                                  | {
                                                      __typename?: "BasicLabel"
                                                      valueType: string
                                                      label?: any | null
                                                    }
                                                  | {
                                                      __typename?: "BasicMediaPicker"
                                                      valueType: string
                                                    }
                                                  | {
                                                      __typename?: "BasicMemberPicker"
                                                      valueType: string
                                                      members: Array<{
                                                        __typename?: "BasicMemberPickerItem"
                                                        id?: number | null
                                                        name?: string | null
                                                        properties: Array<{
                                                          __typename?: "BasicProperty"
                                                          alias?: string | null
                                                          editorAlias?:
                                                            | string
                                                            | null
                                                          value?:
                                                            | {
                                                                __typename?: "BasicBlockGridModel"
                                                                model: string
                                                              }
                                                            | {
                                                                __typename?: "BasicBlockListModel"
                                                                model: string
                                                              }
                                                            | {
                                                                __typename?: "BasicContentPicker"
                                                                model: string
                                                                contentList: Array<{
                                                                  __typename?: "BasicContentPickerItem"
                                                                  id: number
                                                                  absoluteUrl: string
                                                                  key: any
                                                                  name?:
                                                                    | string
                                                                    | null
                                                                  url: string
                                                                  urlSegment?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | {
                                                                __typename?: "BasicDateTimePicker"
                                                                model: string
                                                                dateTime?:
                                                                  | any
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicLabel"
                                                                model: string
                                                                label?:
                                                                  | any
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicMediaPicker"
                                                                model: string
                                                              }
                                                            | {
                                                                __typename?: "BasicMemberPicker"
                                                                model: string
                                                                members: Array<{
                                                                  __typename?: "BasicMemberPickerItem"
                                                                  id?:
                                                                    | number
                                                                    | null
                                                                  name?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | {
                                                                __typename?: "BasicMultiUrlPicker"
                                                                model: string
                                                                links: Array<{
                                                                  __typename?: "BasicMultiUrlPickerItem"
                                                                  name?:
                                                                    | string
                                                                    | null
                                                                  target?:
                                                                    | string
                                                                    | null
                                                                  type: LinkType
                                                                  url?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | {
                                                                __typename?: "BasicNestedContent"
                                                                model: string
                                                                elements?: Array<{
                                                                  __typename?: "BasicNestedContentElement"
                                                                  properties: Array<{
                                                                    __typename?: "BasicProperty"
                                                                    alias?:
                                                                      | string
                                                                      | null
                                                                    editorAlias?:
                                                                      | string
                                                                      | null
                                                                    value?:
                                                                      | {
                                                                          __typename?: "BasicBlockGridModel"
                                                                          model: string
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicBlockListModel"
                                                                          model: string
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicContentPicker"
                                                                          model: string
                                                                          contentList: Array<{
                                                                            __typename?: "BasicContentPickerItem"
                                                                            id: number
                                                                            absoluteUrl: string
                                                                            key: any
                                                                            name?:
                                                                              | string
                                                                              | null
                                                                            url: string
                                                                            urlSegment?:
                                                                              | string
                                                                              | null
                                                                          }>
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicDateTimePicker"
                                                                          model: string
                                                                          dateTime?:
                                                                            | any
                                                                            | null
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicLabel"
                                                                          model: string
                                                                          label?:
                                                                            | any
                                                                            | null
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicMediaPicker"
                                                                          model: string
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicMemberPicker"
                                                                          model: string
                                                                          members: Array<{
                                                                            __typename?: "BasicMemberPickerItem"
                                                                            id?:
                                                                              | number
                                                                              | null
                                                                            name?:
                                                                              | string
                                                                              | null
                                                                          }>
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicMultiUrlPicker"
                                                                          model: string
                                                                          links: Array<{
                                                                            __typename?: "BasicMultiUrlPickerItem"
                                                                            name?:
                                                                              | string
                                                                              | null
                                                                            target?:
                                                                              | string
                                                                              | null
                                                                            type: LinkType
                                                                            url?:
                                                                              | string
                                                                              | null
                                                                          }>
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicNestedContent"
                                                                          model: string
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicPropertyValue"
                                                                          model: string
                                                                          value?:
                                                                            | any
                                                                            | null
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicRichText"
                                                                          model: string
                                                                          richText?:
                                                                            | string
                                                                            | null
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicUnsupportedPropertyValue"
                                                                          model: string
                                                                          message: string
                                                                        }
                                                                      | {
                                                                          __typename?: "MintMediaPicker"
                                                                          model: string
                                                                          mediaItems: Array<{
                                                                            __typename?: "MintMediaPickerItem"
                                                                            id: number
                                                                            url: string
                                                                            altText?:
                                                                              | string
                                                                              | null
                                                                          }>
                                                                        }
                                                                      | null
                                                                  } | null>
                                                                }> | null
                                                              }
                                                            | {
                                                                __typename?: "BasicPropertyValue"
                                                                model: string
                                                                value?:
                                                                  | any
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicRichText"
                                                                model: string
                                                                richText?:
                                                                  | string
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicUnsupportedPropertyValue"
                                                                model: string
                                                                message: string
                                                              }
                                                            | {
                                                                __typename?: "MintMediaPicker"
                                                                model: string
                                                                mediaItems: Array<{
                                                                  __typename?: "MintMediaPickerItem"
                                                                  id: number
                                                                  url: string
                                                                  altText?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | null
                                                        } | null>
                                                      }>
                                                    }
                                                  | {
                                                      __typename?: "BasicMultiUrlPicker"
                                                      valueType: string
                                                      links: Array<{
                                                        __typename?: "BasicMultiUrlPickerItem"
                                                        name?: string | null
                                                        target?: string | null
                                                        type: LinkType
                                                        url?: string | null
                                                      }>
                                                    }
                                                  | {
                                                      __typename?: "BasicNestedContent"
                                                      valueType: string
                                                      elements?: Array<{
                                                        __typename?: "BasicNestedContentElement"
                                                        properties: Array<{
                                                          __typename?: "BasicProperty"
                                                          alias?: string | null
                                                          editorAlias?:
                                                            | string
                                                            | null
                                                          value?:
                                                            | {
                                                                __typename?: "BasicBlockGridModel"
                                                                model: string
                                                              }
                                                            | {
                                                                __typename?: "BasicBlockListModel"
                                                                model: string
                                                              }
                                                            | {
                                                                __typename?: "BasicContentPicker"
                                                                model: string
                                                                contentList: Array<{
                                                                  __typename?: "BasicContentPickerItem"
                                                                  id: number
                                                                  absoluteUrl: string
                                                                  key: any
                                                                  name?:
                                                                    | string
                                                                    | null
                                                                  url: string
                                                                  urlSegment?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | {
                                                                __typename?: "BasicDateTimePicker"
                                                                model: string
                                                                dateTime?:
                                                                  | any
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicLabel"
                                                                model: string
                                                                label?:
                                                                  | any
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicMediaPicker"
                                                                model: string
                                                              }
                                                            | {
                                                                __typename?: "BasicMemberPicker"
                                                                model: string
                                                                members: Array<{
                                                                  __typename?: "BasicMemberPickerItem"
                                                                  id?:
                                                                    | number
                                                                    | null
                                                                  name?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | {
                                                                __typename?: "BasicMultiUrlPicker"
                                                                model: string
                                                                links: Array<{
                                                                  __typename?: "BasicMultiUrlPickerItem"
                                                                  name?:
                                                                    | string
                                                                    | null
                                                                  target?:
                                                                    | string
                                                                    | null
                                                                  type: LinkType
                                                                  url?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | {
                                                                __typename?: "BasicNestedContent"
                                                                model: string
                                                              }
                                                            | {
                                                                __typename?: "BasicPropertyValue"
                                                                model: string
                                                                value?:
                                                                  | any
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicRichText"
                                                                model: string
                                                                richText?:
                                                                  | string
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicUnsupportedPropertyValue"
                                                                model: string
                                                                message: string
                                                              }
                                                            | {
                                                                __typename?: "MintMediaPicker"
                                                                model: string
                                                                mediaItems: Array<{
                                                                  __typename?: "MintMediaPickerItem"
                                                                  id: number
                                                                  url: string
                                                                  altText?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | null
                                                        } | null>
                                                      }> | null
                                                    }
                                                  | {
                                                      __typename?: "BasicPropertyValue"
                                                      valueType: string
                                                      value?: any | null
                                                    }
                                                  | {
                                                      __typename?: "BasicRichText"
                                                      valueType: string
                                                      richText?: string | null
                                                    }
                                                  | {
                                                      __typename?: "BasicUnsupportedPropertyValue"
                                                      message: string
                                                      valueType: string
                                                    }
                                                  | {
                                                      __typename?: "MintMediaPicker"
                                                      valueType: string
                                                      mediaItems: Array<{
                                                        __typename?: "MintMediaPickerItem"
                                                        id: number
                                                        url: string
                                                        altText?: string | null
                                                      }>
                                                    }
                                                  | null
                                              } | null>
                                            }> | null
                                          }
                                        | {
                                            __typename?: "BasicContentPicker"
                                            valueType: string
                                            contentList: Array<{
                                              __typename?: "BasicContentPickerItem"
                                              id: number
                                              absoluteUrl: string
                                              key: any
                                              name?: string | null
                                              url: string
                                              urlSegment?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicDateTimePicker"
                                            valueType: string
                                            dateTime?: any | null
                                          }
                                        | {
                                            __typename?: "BasicLabel"
                                            valueType: string
                                            label?: any | null
                                          }
                                        | {
                                            __typename?: "BasicMediaPicker"
                                            valueType: string
                                          }
                                        | {
                                            __typename?: "BasicMemberPicker"
                                            valueType: string
                                            members: Array<{
                                              __typename?: "BasicMemberPickerItem"
                                              id?: number | null
                                              name?: string | null
                                              properties: Array<{
                                                __typename?: "BasicProperty"
                                                alias?: string | null
                                                editorAlias?: string | null
                                                value?:
                                                  | {
                                                      __typename?: "BasicBlockGridModel"
                                                      model: string
                                                    }
                                                  | {
                                                      __typename?: "BasicBlockListModel"
                                                      model: string
                                                    }
                                                  | {
                                                      __typename?: "BasicContentPicker"
                                                      model: string
                                                      contentList: Array<{
                                                        __typename?: "BasicContentPickerItem"
                                                        id: number
                                                        absoluteUrl: string
                                                        key: any
                                                        name?: string | null
                                                        url: string
                                                        urlSegment?:
                                                          | string
                                                          | null
                                                      }>
                                                    }
                                                  | {
                                                      __typename?: "BasicDateTimePicker"
                                                      model: string
                                                      dateTime?: any | null
                                                    }
                                                  | {
                                                      __typename?: "BasicLabel"
                                                      model: string
                                                      label?: any | null
                                                    }
                                                  | {
                                                      __typename?: "BasicMediaPicker"
                                                      model: string
                                                    }
                                                  | {
                                                      __typename?: "BasicMemberPicker"
                                                      model: string
                                                      members: Array<{
                                                        __typename?: "BasicMemberPickerItem"
                                                        id?: number | null
                                                        name?: string | null
                                                      }>
                                                    }
                                                  | {
                                                      __typename?: "BasicMultiUrlPicker"
                                                      model: string
                                                      links: Array<{
                                                        __typename?: "BasicMultiUrlPickerItem"
                                                        name?: string | null
                                                        target?: string | null
                                                        type: LinkType
                                                        url?: string | null
                                                      }>
                                                    }
                                                  | {
                                                      __typename?: "BasicNestedContent"
                                                      model: string
                                                      elements?: Array<{
                                                        __typename?: "BasicNestedContentElement"
                                                        properties: Array<{
                                                          __typename?: "BasicProperty"
                                                          alias?: string | null
                                                          editorAlias?:
                                                            | string
                                                            | null
                                                          value?:
                                                            | {
                                                                __typename?: "BasicBlockGridModel"
                                                                model: string
                                                              }
                                                            | {
                                                                __typename?: "BasicBlockListModel"
                                                                model: string
                                                              }
                                                            | {
                                                                __typename?: "BasicContentPicker"
                                                                model: string
                                                                contentList: Array<{
                                                                  __typename?: "BasicContentPickerItem"
                                                                  id: number
                                                                  absoluteUrl: string
                                                                  key: any
                                                                  name?:
                                                                    | string
                                                                    | null
                                                                  url: string
                                                                  urlSegment?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | {
                                                                __typename?: "BasicDateTimePicker"
                                                                model: string
                                                                dateTime?:
                                                                  | any
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicLabel"
                                                                model: string
                                                                label?:
                                                                  | any
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicMediaPicker"
                                                                model: string
                                                              }
                                                            | {
                                                                __typename?: "BasicMemberPicker"
                                                                model: string
                                                                members: Array<{
                                                                  __typename?: "BasicMemberPickerItem"
                                                                  id?:
                                                                    | number
                                                                    | null
                                                                  name?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | {
                                                                __typename?: "BasicMultiUrlPicker"
                                                                model: string
                                                                links: Array<{
                                                                  __typename?: "BasicMultiUrlPickerItem"
                                                                  name?:
                                                                    | string
                                                                    | null
                                                                  target?:
                                                                    | string
                                                                    | null
                                                                  type: LinkType
                                                                  url?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | {
                                                                __typename?: "BasicNestedContent"
                                                                model: string
                                                              }
                                                            | {
                                                                __typename?: "BasicPropertyValue"
                                                                model: string
                                                                value?:
                                                                  | any
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicRichText"
                                                                model: string
                                                                richText?:
                                                                  | string
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicUnsupportedPropertyValue"
                                                                model: string
                                                                message: string
                                                              }
                                                            | {
                                                                __typename?: "MintMediaPicker"
                                                                model: string
                                                                mediaItems: Array<{
                                                                  __typename?: "MintMediaPickerItem"
                                                                  id: number
                                                                  url: string
                                                                  altText?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | null
                                                        } | null>
                                                      }> | null
                                                    }
                                                  | {
                                                      __typename?: "BasicPropertyValue"
                                                      model: string
                                                      value?: any | null
                                                    }
                                                  | {
                                                      __typename?: "BasicRichText"
                                                      model: string
                                                      richText?: string | null
                                                    }
                                                  | {
                                                      __typename?: "BasicUnsupportedPropertyValue"
                                                      model: string
                                                      message: string
                                                    }
                                                  | {
                                                      __typename?: "MintMediaPicker"
                                                      model: string
                                                      mediaItems: Array<{
                                                        __typename?: "MintMediaPickerItem"
                                                        id: number
                                                        url: string
                                                        altText?: string | null
                                                      }>
                                                    }
                                                  | null
                                              } | null>
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicMultiUrlPicker"
                                            valueType: string
                                            links: Array<{
                                              __typename?: "BasicMultiUrlPickerItem"
                                              name?: string | null
                                              target?: string | null
                                              type: LinkType
                                              url?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicNestedContent"
                                            valueType: string
                                            elements?: Array<{
                                              __typename?: "BasicNestedContentElement"
                                              properties: Array<{
                                                __typename?: "BasicProperty"
                                                alias?: string | null
                                                editorAlias?: string | null
                                                value?:
                                                  | {
                                                      __typename?: "BasicBlockGridModel"
                                                      model: string
                                                    }
                                                  | {
                                                      __typename?: "BasicBlockListModel"
                                                      model: string
                                                    }
                                                  | {
                                                      __typename?: "BasicContentPicker"
                                                      model: string
                                                      contentList: Array<{
                                                        __typename?: "BasicContentPickerItem"
                                                        id: number
                                                        absoluteUrl: string
                                                        key: any
                                                        name?: string | null
                                                        url: string
                                                        urlSegment?:
                                                          | string
                                                          | null
                                                      }>
                                                    }
                                                  | {
                                                      __typename?: "BasicDateTimePicker"
                                                      model: string
                                                      dateTime?: any | null
                                                    }
                                                  | {
                                                      __typename?: "BasicLabel"
                                                      model: string
                                                      label?: any | null
                                                    }
                                                  | {
                                                      __typename?: "BasicMediaPicker"
                                                      model: string
                                                    }
                                                  | {
                                                      __typename?: "BasicMemberPicker"
                                                      model: string
                                                      members: Array<{
                                                        __typename?: "BasicMemberPickerItem"
                                                        id?: number | null
                                                        name?: string | null
                                                      }>
                                                    }
                                                  | {
                                                      __typename?: "BasicMultiUrlPicker"
                                                      model: string
                                                      links: Array<{
                                                        __typename?: "BasicMultiUrlPickerItem"
                                                        name?: string | null
                                                        target?: string | null
                                                        type: LinkType
                                                        url?: string | null
                                                      }>
                                                    }
                                                  | {
                                                      __typename?: "BasicNestedContent"
                                                      model: string
                                                    }
                                                  | {
                                                      __typename?: "BasicPropertyValue"
                                                      model: string
                                                      value?: any | null
                                                    }
                                                  | {
                                                      __typename?: "BasicRichText"
                                                      model: string
                                                      richText?: string | null
                                                    }
                                                  | {
                                                      __typename?: "BasicUnsupportedPropertyValue"
                                                      model: string
                                                      message: string
                                                    }
                                                  | {
                                                      __typename?: "MintMediaPicker"
                                                      model: string
                                                      mediaItems: Array<{
                                                        __typename?: "MintMediaPickerItem"
                                                        id: number
                                                        url: string
                                                        altText?: string | null
                                                      }>
                                                    }
                                                  | null
                                              } | null>
                                            }> | null
                                          }
                                        | {
                                            __typename?: "BasicPropertyValue"
                                            valueType: string
                                            value?: any | null
                                          }
                                        | {
                                            __typename?: "BasicRichText"
                                            valueType: string
                                            richText?: string | null
                                          }
                                        | {
                                            __typename?: "BasicUnsupportedPropertyValue"
                                            message: string
                                            valueType: string
                                          }
                                        | {
                                            __typename?: "MintMediaPicker"
                                            valueType: string
                                            mediaItems: Array<{
                                              __typename?: "MintMediaPickerItem"
                                              id: number
                                              url: string
                                              altText?: string | null
                                            }>
                                          }
                                        | null
                                    } | null>
                                  }> | null
                                }
                              | {
                                  __typename?: "BasicContentPicker"
                                  valueType: string
                                  contentList: Array<{
                                    __typename?: "BasicContentPickerItem"
                                    id: number
                                    absoluteUrl: string
                                    key: any
                                    name?: string | null
                                    url: string
                                    urlSegment?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicDateTimePicker"
                                  valueType: string
                                  dateTime?: any | null
                                }
                              | {
                                  __typename?: "BasicLabel"
                                  valueType: string
                                  label?: any | null
                                }
                              | {
                                  __typename?: "BasicMediaPicker"
                                  valueType: string
                                }
                              | {
                                  __typename?: "BasicMemberPicker"
                                  valueType: string
                                  members: Array<{
                                    __typename?: "BasicMemberPickerItem"
                                    id?: number | null
                                    name?: string | null
                                    properties: Array<{
                                      __typename?: "BasicProperty"
                                      alias?: string | null
                                      editorAlias?: string | null
                                      value?:
                                        | {
                                            __typename?: "BasicBlockGridModel"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicBlockListModel"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicContentPicker"
                                            model: string
                                            contentList: Array<{
                                              __typename?: "BasicContentPickerItem"
                                              id: number
                                              absoluteUrl: string
                                              key: any
                                              name?: string | null
                                              url: string
                                              urlSegment?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicDateTimePicker"
                                            model: string
                                            dateTime?: any | null
                                          }
                                        | {
                                            __typename?: "BasicLabel"
                                            model: string
                                            label?: any | null
                                          }
                                        | {
                                            __typename?: "BasicMediaPicker"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicMemberPicker"
                                            model: string
                                            members: Array<{
                                              __typename?: "BasicMemberPickerItem"
                                              id?: number | null
                                              name?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicMultiUrlPicker"
                                            model: string
                                            links: Array<{
                                              __typename?: "BasicMultiUrlPickerItem"
                                              name?: string | null
                                              target?: string | null
                                              type: LinkType
                                              url?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicNestedContent"
                                            model: string
                                            elements?: Array<{
                                              __typename?: "BasicNestedContentElement"
                                              properties: Array<{
                                                __typename?: "BasicProperty"
                                                alias?: string | null
                                                editorAlias?: string | null
                                                value?:
                                                  | {
                                                      __typename?: "BasicBlockGridModel"
                                                      model: string
                                                    }
                                                  | {
                                                      __typename?: "BasicBlockListModel"
                                                      model: string
                                                    }
                                                  | {
                                                      __typename?: "BasicContentPicker"
                                                      model: string
                                                      contentList: Array<{
                                                        __typename?: "BasicContentPickerItem"
                                                        id: number
                                                        absoluteUrl: string
                                                        key: any
                                                        name?: string | null
                                                        url: string
                                                        urlSegment?:
                                                          | string
                                                          | null
                                                      }>
                                                    }
                                                  | {
                                                      __typename?: "BasicDateTimePicker"
                                                      model: string
                                                      dateTime?: any | null
                                                    }
                                                  | {
                                                      __typename?: "BasicLabel"
                                                      model: string
                                                      label?: any | null
                                                    }
                                                  | {
                                                      __typename?: "BasicMediaPicker"
                                                      model: string
                                                    }
                                                  | {
                                                      __typename?: "BasicMemberPicker"
                                                      model: string
                                                      members: Array<{
                                                        __typename?: "BasicMemberPickerItem"
                                                        id?: number | null
                                                        name?: string | null
                                                      }>
                                                    }
                                                  | {
                                                      __typename?: "BasicMultiUrlPicker"
                                                      model: string
                                                      links: Array<{
                                                        __typename?: "BasicMultiUrlPickerItem"
                                                        name?: string | null
                                                        target?: string | null
                                                        type: LinkType
                                                        url?: string | null
                                                      }>
                                                    }
                                                  | {
                                                      __typename?: "BasicNestedContent"
                                                      model: string
                                                    }
                                                  | {
                                                      __typename?: "BasicPropertyValue"
                                                      model: string
                                                      value?: any | null
                                                    }
                                                  | {
                                                      __typename?: "BasicRichText"
                                                      model: string
                                                      richText?: string | null
                                                    }
                                                  | {
                                                      __typename?: "BasicUnsupportedPropertyValue"
                                                      model: string
                                                      message: string
                                                    }
                                                  | {
                                                      __typename?: "MintMediaPicker"
                                                      model: string
                                                      mediaItems: Array<{
                                                        __typename?: "MintMediaPickerItem"
                                                        id: number
                                                        url: string
                                                        altText?: string | null
                                                      }>
                                                    }
                                                  | null
                                              } | null>
                                            }> | null
                                          }
                                        | {
                                            __typename?: "BasicPropertyValue"
                                            model: string
                                            value?: any | null
                                          }
                                        | {
                                            __typename?: "BasicRichText"
                                            model: string
                                            richText?: string | null
                                          }
                                        | {
                                            __typename?: "BasicUnsupportedPropertyValue"
                                            model: string
                                            message: string
                                          }
                                        | {
                                            __typename?: "MintMediaPicker"
                                            model: string
                                            mediaItems: Array<{
                                              __typename?: "MintMediaPickerItem"
                                              id: number
                                              url: string
                                              altText?: string | null
                                            }>
                                          }
                                        | null
                                    } | null>
                                  }>
                                }
                              | {
                                  __typename?: "BasicMultiUrlPicker"
                                  valueType: string
                                  links: Array<{
                                    __typename?: "BasicMultiUrlPickerItem"
                                    name?: string | null
                                    target?: string | null
                                    type: LinkType
                                    url?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicNestedContent"
                                  valueType: string
                                  elements?: Array<{
                                    __typename?: "BasicNestedContentElement"
                                    properties: Array<{
                                      __typename?: "BasicProperty"
                                      alias?: string | null
                                      editorAlias?: string | null
                                      value?:
                                        | {
                                            __typename?: "BasicBlockGridModel"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicBlockListModel"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicContentPicker"
                                            model: string
                                            contentList: Array<{
                                              __typename?: "BasicContentPickerItem"
                                              id: number
                                              absoluteUrl: string
                                              key: any
                                              name?: string | null
                                              url: string
                                              urlSegment?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicDateTimePicker"
                                            model: string
                                            dateTime?: any | null
                                          }
                                        | {
                                            __typename?: "BasicLabel"
                                            model: string
                                            label?: any | null
                                          }
                                        | {
                                            __typename?: "BasicMediaPicker"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicMemberPicker"
                                            model: string
                                            members: Array<{
                                              __typename?: "BasicMemberPickerItem"
                                              id?: number | null
                                              name?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicMultiUrlPicker"
                                            model: string
                                            links: Array<{
                                              __typename?: "BasicMultiUrlPickerItem"
                                              name?: string | null
                                              target?: string | null
                                              type: LinkType
                                              url?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicNestedContent"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicPropertyValue"
                                            model: string
                                            value?: any | null
                                          }
                                        | {
                                            __typename?: "BasicRichText"
                                            model: string
                                            richText?: string | null
                                          }
                                        | {
                                            __typename?: "BasicUnsupportedPropertyValue"
                                            model: string
                                            message: string
                                          }
                                        | {
                                            __typename?: "MintMediaPicker"
                                            model: string
                                            mediaItems: Array<{
                                              __typename?: "MintMediaPickerItem"
                                              id: number
                                              url: string
                                              altText?: string | null
                                            }>
                                          }
                                        | null
                                    } | null>
                                  }> | null
                                }
                              | {
                                  __typename?: "BasicPropertyValue"
                                  valueType: string
                                  value?: any | null
                                }
                              | {
                                  __typename?: "BasicRichText"
                                  valueType: string
                                  richText?: string | null
                                }
                              | {
                                  __typename?: "BasicUnsupportedPropertyValue"
                                  message: string
                                  valueType: string
                                }
                              | {
                                  __typename?: "MintMediaPicker"
                                  valueType: string
                                  mediaItems: Array<{
                                    __typename?: "MintMediaPickerItem"
                                    id: number
                                    url: string
                                    altText?: string | null
                                  }>
                                }
                              | null
                          } | null>
                        }> | null
                      }
                    | {
                        __typename?: "BasicContentPicker"
                        valueType: string
                        contentList: Array<{
                          __typename?: "BasicContentPickerItem"
                          id: number
                          absoluteUrl: string
                          key: any
                          name?: string | null
                          url: string
                          urlSegment?: string | null
                        }>
                      }
                    | {
                        __typename?: "BasicDateTimePicker"
                        valueType: string
                        dateTime?: any | null
                      }
                    | {
                        __typename?: "BasicLabel"
                        valueType: string
                        label?: any | null
                      }
                    | { __typename?: "BasicMediaPicker"; valueType: string }
                    | {
                        __typename?: "BasicMemberPicker"
                        valueType: string
                        members: Array<{
                          __typename?: "BasicMemberPickerItem"
                          id?: number | null
                          name?: string | null
                          properties: Array<{
                            __typename?: "BasicProperty"
                            alias?: string | null
                            editorAlias?: string | null
                            value?:
                              | {
                                  __typename?: "BasicBlockGridModel"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicBlockListModel"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicContentPicker"
                                  model: string
                                  contentList: Array<{
                                    __typename?: "BasicContentPickerItem"
                                    id: number
                                    absoluteUrl: string
                                    key: any
                                    name?: string | null
                                    url: string
                                    urlSegment?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicDateTimePicker"
                                  model: string
                                  dateTime?: any | null
                                }
                              | {
                                  __typename?: "BasicLabel"
                                  model: string
                                  label?: any | null
                                }
                              | {
                                  __typename?: "BasicMediaPicker"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicMemberPicker"
                                  model: string
                                  members: Array<{
                                    __typename?: "BasicMemberPickerItem"
                                    id?: number | null
                                    name?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicMultiUrlPicker"
                                  model: string
                                  links: Array<{
                                    __typename?: "BasicMultiUrlPickerItem"
                                    name?: string | null
                                    target?: string | null
                                    type: LinkType
                                    url?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicNestedContent"
                                  model: string
                                  elements?: Array<{
                                    __typename?: "BasicNestedContentElement"
                                    properties: Array<{
                                      __typename?: "BasicProperty"
                                      alias?: string | null
                                      editorAlias?: string | null
                                      value?:
                                        | {
                                            __typename?: "BasicBlockGridModel"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicBlockListModel"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicContentPicker"
                                            model: string
                                            contentList: Array<{
                                              __typename?: "BasicContentPickerItem"
                                              id: number
                                              absoluteUrl: string
                                              key: any
                                              name?: string | null
                                              url: string
                                              urlSegment?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicDateTimePicker"
                                            model: string
                                            dateTime?: any | null
                                          }
                                        | {
                                            __typename?: "BasicLabel"
                                            model: string
                                            label?: any | null
                                          }
                                        | {
                                            __typename?: "BasicMediaPicker"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicMemberPicker"
                                            model: string
                                            members: Array<{
                                              __typename?: "BasicMemberPickerItem"
                                              id?: number | null
                                              name?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicMultiUrlPicker"
                                            model: string
                                            links: Array<{
                                              __typename?: "BasicMultiUrlPickerItem"
                                              name?: string | null
                                              target?: string | null
                                              type: LinkType
                                              url?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicNestedContent"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicPropertyValue"
                                            model: string
                                            value?: any | null
                                          }
                                        | {
                                            __typename?: "BasicRichText"
                                            model: string
                                            richText?: string | null
                                          }
                                        | {
                                            __typename?: "BasicUnsupportedPropertyValue"
                                            model: string
                                            message: string
                                          }
                                        | {
                                            __typename?: "MintMediaPicker"
                                            model: string
                                            mediaItems: Array<{
                                              __typename?: "MintMediaPickerItem"
                                              id: number
                                              url: string
                                              altText?: string | null
                                            }>
                                          }
                                        | null
                                    } | null>
                                  }> | null
                                }
                              | {
                                  __typename?: "BasicPropertyValue"
                                  model: string
                                  value?: any | null
                                }
                              | {
                                  __typename?: "BasicRichText"
                                  model: string
                                  richText?: string | null
                                }
                              | {
                                  __typename?: "BasicUnsupportedPropertyValue"
                                  model: string
                                  message: string
                                }
                              | {
                                  __typename?: "MintMediaPicker"
                                  model: string
                                  mediaItems: Array<{
                                    __typename?: "MintMediaPickerItem"
                                    id: number
                                    url: string
                                    altText?: string | null
                                  }>
                                }
                              | null
                          } | null>
                        }>
                      }
                    | {
                        __typename?: "BasicMultiUrlPicker"
                        valueType: string
                        links: Array<{
                          __typename?: "BasicMultiUrlPickerItem"
                          name?: string | null
                          target?: string | null
                          type: LinkType
                          url?: string | null
                        }>
                      }
                    | {
                        __typename?: "BasicNestedContent"
                        valueType: string
                        elements?: Array<{
                          __typename?: "BasicNestedContentElement"
                          properties: Array<{
                            __typename?: "BasicProperty"
                            alias?: string | null
                            editorAlias?: string | null
                            value?:
                              | {
                                  __typename?: "BasicBlockGridModel"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicBlockListModel"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicContentPicker"
                                  model: string
                                  contentList: Array<{
                                    __typename?: "BasicContentPickerItem"
                                    id: number
                                    absoluteUrl: string
                                    key: any
                                    name?: string | null
                                    url: string
                                    urlSegment?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicDateTimePicker"
                                  model: string
                                  dateTime?: any | null
                                }
                              | {
                                  __typename?: "BasicLabel"
                                  model: string
                                  label?: any | null
                                }
                              | {
                                  __typename?: "BasicMediaPicker"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicMemberPicker"
                                  model: string
                                  members: Array<{
                                    __typename?: "BasicMemberPickerItem"
                                    id?: number | null
                                    name?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicMultiUrlPicker"
                                  model: string
                                  links: Array<{
                                    __typename?: "BasicMultiUrlPickerItem"
                                    name?: string | null
                                    target?: string | null
                                    type: LinkType
                                    url?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicNestedContent"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicPropertyValue"
                                  model: string
                                  value?: any | null
                                }
                              | {
                                  __typename?: "BasicRichText"
                                  model: string
                                  richText?: string | null
                                }
                              | {
                                  __typename?: "BasicUnsupportedPropertyValue"
                                  model: string
                                  message: string
                                }
                              | {
                                  __typename?: "MintMediaPicker"
                                  model: string
                                  mediaItems: Array<{
                                    __typename?: "MintMediaPickerItem"
                                    id: number
                                    url: string
                                    altText?: string | null
                                  }>
                                }
                              | null
                          } | null>
                        }> | null
                      }
                    | {
                        __typename?: "BasicPropertyValue"
                        valueType: string
                        value?: any | null
                      }
                    | {
                        __typename?: "BasicRichText"
                        valueType: string
                        richText?: string | null
                      }
                    | {
                        __typename?: "BasicUnsupportedPropertyValue"
                        message: string
                        valueType: string
                      }
                    | {
                        __typename?: "MintMediaPicker"
                        valueType: string
                        mediaItems: Array<{
                          __typename?: "MintMediaPickerItem"
                          id: number
                          url: string
                          altText?: string | null
                        }>
                      }
                    | null
                } | null>
              }> | null
            }
          | {
              __typename?: "BasicContentPicker"
              valueType: string
              contentList: Array<{
                __typename?: "BasicContentPickerItem"
                id: number
                absoluteUrl: string
                key: any
                name?: string | null
                url: string
                urlSegment?: string | null
              }>
            }
          | {
              __typename?: "BasicDateTimePicker"
              valueType: string
              dateTime?: any | null
            }
          | { __typename?: "BasicLabel"; valueType: string; label?: any | null }
          | { __typename?: "BasicMediaPicker"; valueType: string }
          | {
              __typename?: "BasicMemberPicker"
              valueType: string
              members: Array<{
                __typename?: "BasicMemberPickerItem"
                id?: number | null
                name?: string | null
                properties: Array<{
                  __typename?: "BasicProperty"
                  alias?: string | null
                  editorAlias?: string | null
                  value?:
                    | { __typename?: "BasicBlockGridModel"; model: string }
                    | { __typename?: "BasicBlockListModel"; model: string }
                    | {
                        __typename?: "BasicContentPicker"
                        model: string
                        contentList: Array<{
                          __typename?: "BasicContentPickerItem"
                          id: number
                          absoluteUrl: string
                          key: any
                          name?: string | null
                          url: string
                          urlSegment?: string | null
                        }>
                      }
                    | {
                        __typename?: "BasicDateTimePicker"
                        model: string
                        dateTime?: any | null
                      }
                    | {
                        __typename?: "BasicLabel"
                        model: string
                        label?: any | null
                      }
                    | { __typename?: "BasicMediaPicker"; model: string }
                    | {
                        __typename?: "BasicMemberPicker"
                        model: string
                        members: Array<{
                          __typename?: "BasicMemberPickerItem"
                          id?: number | null
                          name?: string | null
                        }>
                      }
                    | {
                        __typename?: "BasicMultiUrlPicker"
                        model: string
                        links: Array<{
                          __typename?: "BasicMultiUrlPickerItem"
                          name?: string | null
                          target?: string | null
                          type: LinkType
                          url?: string | null
                        }>
                      }
                    | {
                        __typename?: "BasicNestedContent"
                        model: string
                        elements?: Array<{
                          __typename?: "BasicNestedContentElement"
                          properties: Array<{
                            __typename?: "BasicProperty"
                            alias?: string | null
                            editorAlias?: string | null
                            value?:
                              | {
                                  __typename?: "BasicBlockGridModel"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicBlockListModel"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicContentPicker"
                                  model: string
                                  contentList: Array<{
                                    __typename?: "BasicContentPickerItem"
                                    id: number
                                    absoluteUrl: string
                                    key: any
                                    name?: string | null
                                    url: string
                                    urlSegment?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicDateTimePicker"
                                  model: string
                                  dateTime?: any | null
                                }
                              | {
                                  __typename?: "BasicLabel"
                                  model: string
                                  label?: any | null
                                }
                              | {
                                  __typename?: "BasicMediaPicker"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicMemberPicker"
                                  model: string
                                  members: Array<{
                                    __typename?: "BasicMemberPickerItem"
                                    id?: number | null
                                    name?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicMultiUrlPicker"
                                  model: string
                                  links: Array<{
                                    __typename?: "BasicMultiUrlPickerItem"
                                    name?: string | null
                                    target?: string | null
                                    type: LinkType
                                    url?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicNestedContent"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicPropertyValue"
                                  model: string
                                  value?: any | null
                                }
                              | {
                                  __typename?: "BasicRichText"
                                  model: string
                                  richText?: string | null
                                }
                              | {
                                  __typename?: "BasicUnsupportedPropertyValue"
                                  model: string
                                  message: string
                                }
                              | {
                                  __typename?: "MintMediaPicker"
                                  model: string
                                  mediaItems: Array<{
                                    __typename?: "MintMediaPickerItem"
                                    id: number
                                    url: string
                                    altText?: string | null
                                  }>
                                }
                              | null
                          } | null>
                        }> | null
                      }
                    | {
                        __typename?: "BasicPropertyValue"
                        model: string
                        value?: any | null
                      }
                    | {
                        __typename?: "BasicRichText"
                        model: string
                        richText?: string | null
                      }
                    | {
                        __typename?: "BasicUnsupportedPropertyValue"
                        model: string
                        message: string
                      }
                    | {
                        __typename?: "MintMediaPicker"
                        model: string
                        mediaItems: Array<{
                          __typename?: "MintMediaPickerItem"
                          id: number
                          url: string
                          altText?: string | null
                        }>
                      }
                    | null
                } | null>
              }>
            }
          | {
              __typename?: "BasicMultiUrlPicker"
              valueType: string
              links: Array<{
                __typename?: "BasicMultiUrlPickerItem"
                name?: string | null
                target?: string | null
                type: LinkType
                url?: string | null
              }>
            }
          | {
              __typename?: "BasicNestedContent"
              valueType: string
              elements?: Array<{
                __typename?: "BasicNestedContentElement"
                properties: Array<{
                  __typename?: "BasicProperty"
                  alias?: string | null
                  editorAlias?: string | null
                  value?:
                    | { __typename?: "BasicBlockGridModel"; model: string }
                    | { __typename?: "BasicBlockListModel"; model: string }
                    | {
                        __typename?: "BasicContentPicker"
                        model: string
                        contentList: Array<{
                          __typename?: "BasicContentPickerItem"
                          id: number
                          absoluteUrl: string
                          key: any
                          name?: string | null
                          url: string
                          urlSegment?: string | null
                        }>
                      }
                    | {
                        __typename?: "BasicDateTimePicker"
                        model: string
                        dateTime?: any | null
                      }
                    | {
                        __typename?: "BasicLabel"
                        model: string
                        label?: any | null
                      }
                    | { __typename?: "BasicMediaPicker"; model: string }
                    | {
                        __typename?: "BasicMemberPicker"
                        model: string
                        members: Array<{
                          __typename?: "BasicMemberPickerItem"
                          id?: number | null
                          name?: string | null
                        }>
                      }
                    | {
                        __typename?: "BasicMultiUrlPicker"
                        model: string
                        links: Array<{
                          __typename?: "BasicMultiUrlPickerItem"
                          name?: string | null
                          target?: string | null
                          type: LinkType
                          url?: string | null
                        }>
                      }
                    | { __typename?: "BasicNestedContent"; model: string }
                    | {
                        __typename?: "BasicPropertyValue"
                        model: string
                        value?: any | null
                      }
                    | {
                        __typename?: "BasicRichText"
                        model: string
                        richText?: string | null
                      }
                    | {
                        __typename?: "BasicUnsupportedPropertyValue"
                        model: string
                        message: string
                      }
                    | {
                        __typename?: "MintMediaPicker"
                        model: string
                        mediaItems: Array<{
                          __typename?: "MintMediaPickerItem"
                          id: number
                          url: string
                          altText?: string | null
                        }>
                      }
                    | null
                } | null>
              }> | null
            }
          | {
              __typename?: "BasicPropertyValue"
              valueType: string
              value?: any | null
            }
          | {
              __typename?: "BasicRichText"
              valueType: string
              richText?: string | null
            }
          | {
              __typename?: "BasicUnsupportedPropertyValue"
              message: string
              valueType: string
            }
          | {
              __typename?: "MintMediaPicker"
              valueType: string
              mediaItems: Array<{
                __typename?: "MintMediaPickerItem"
                id: number
                url: string
                altText?: string | null
              }>
            }
          | null
      } | null> | null
      parent?: {
        __typename?: "BasicContent"
        id?: number | null
        url?: string | null
        level?: number | null
        properties?: Array<{
          __typename?: "BasicProperty"
          propertyName?: string | null
          propertyValue?:
            | {
                __typename?: "BasicBlockGridModel"
                gridColumns?: number | null
                valueType: string
                blocks?: Array<{
                  __typename?: "BasicBlockGridItem"
                  columnSpan: number
                  rowSpan: number
                  contentProperties: Array<{
                    __typename?: "BasicProperty"
                    value?:
                      | {
                          __typename?: "BasicBlockGridModel"
                          valueType: string
                        }
                      | {
                          __typename?: "BasicBlockListModel"
                          valueType: string
                        }
                      | {
                          __typename?: "BasicContentPicker"
                          valueType: string
                          contentList: Array<{
                            __typename?: "BasicContentPickerItem"
                            id: number
                            absoluteUrl: string
                            key: any
                            name?: string | null
                            url: string
                            urlSegment?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicDateTimePicker"
                          valueType: string
                          dateTime?: any | null
                        }
                      | {
                          __typename?: "BasicLabel"
                          valueType: string
                          label?: any | null
                        }
                      | { __typename?: "BasicMediaPicker"; valueType: string }
                      | {
                          __typename?: "BasicMemberPicker"
                          valueType: string
                          members: Array<{
                            __typename?: "BasicMemberPickerItem"
                            id?: number | null
                            name?: string | null
                            properties: Array<{
                              __typename?: "BasicProperty"
                              alias?: string | null
                              editorAlias?: string | null
                              value?:
                                | {
                                    __typename?: "BasicBlockGridModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicBlockListModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicContentPicker"
                                    model: string
                                    contentList: Array<{
                                      __typename?: "BasicContentPickerItem"
                                      id: number
                                      absoluteUrl: string
                                      key: any
                                      name?: string | null
                                      url: string
                                      urlSegment?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicDateTimePicker"
                                    model: string
                                    dateTime?: any | null
                                  }
                                | {
                                    __typename?: "BasicLabel"
                                    model: string
                                    label?: any | null
                                  }
                                | {
                                    __typename?: "BasicMediaPicker"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicMemberPicker"
                                    model: string
                                    members: Array<{
                                      __typename?: "BasicMemberPickerItem"
                                      id?: number | null
                                      name?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicMultiUrlPicker"
                                    model: string
                                    links: Array<{
                                      __typename?: "BasicMultiUrlPickerItem"
                                      name?: string | null
                                      target?: string | null
                                      type: LinkType
                                      url?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicNestedContent"
                                    model: string
                                    elements?: Array<{
                                      __typename?: "BasicNestedContentElement"
                                      properties: Array<{
                                        __typename?: "BasicProperty"
                                        alias?: string | null
                                        editorAlias?: string | null
                                        value?:
                                          | {
                                              __typename?: "BasicBlockGridModel"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicBlockListModel"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicContentPicker"
                                              model: string
                                              contentList: Array<{
                                                __typename?: "BasicContentPickerItem"
                                                id: number
                                                absoluteUrl: string
                                                key: any
                                                name?: string | null
                                                url: string
                                                urlSegment?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicDateTimePicker"
                                              model: string
                                              dateTime?: any | null
                                            }
                                          | {
                                              __typename?: "BasicLabel"
                                              model: string
                                              label?: any | null
                                            }
                                          | {
                                              __typename?: "BasicMediaPicker"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicMemberPicker"
                                              model: string
                                              members: Array<{
                                                __typename?: "BasicMemberPickerItem"
                                                id?: number | null
                                                name?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicMultiUrlPicker"
                                              model: string
                                              links: Array<{
                                                __typename?: "BasicMultiUrlPickerItem"
                                                name?: string | null
                                                target?: string | null
                                                type: LinkType
                                                url?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicNestedContent"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicPropertyValue"
                                              model: string
                                              value?: any | null
                                            }
                                          | {
                                              __typename?: "BasicRichText"
                                              model: string
                                              richText?: string | null
                                            }
                                          | {
                                              __typename?: "BasicUnsupportedPropertyValue"
                                              model: string
                                              message: string
                                            }
                                          | {
                                              __typename?: "MintMediaPicker"
                                              model: string
                                              mediaItems: Array<{
                                                __typename?: "MintMediaPickerItem"
                                                id: number
                                                url: string
                                                altText?: string | null
                                              }>
                                            }
                                          | null
                                      } | null>
                                    }> | null
                                  }
                                | {
                                    __typename?: "BasicPropertyValue"
                                    model: string
                                    value?: any | null
                                  }
                                | {
                                    __typename?: "BasicRichText"
                                    model: string
                                    richText?: string | null
                                  }
                                | {
                                    __typename?: "BasicUnsupportedPropertyValue"
                                    model: string
                                    message: string
                                  }
                                | {
                                    __typename?: "MintMediaPicker"
                                    model: string
                                    mediaItems: Array<{
                                      __typename?: "MintMediaPickerItem"
                                      id: number
                                      url: string
                                      altText?: string | null
                                    }>
                                  }
                                | null
                            } | null>
                          }>
                        }
                      | {
                          __typename?: "BasicMultiUrlPicker"
                          valueType: string
                          links: Array<{
                            __typename?: "BasicMultiUrlPickerItem"
                            name?: string | null
                            target?: string | null
                            type: LinkType
                            url?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicNestedContent"
                          valueType: string
                          elements?: Array<{
                            __typename?: "BasicNestedContentElement"
                            properties: Array<{
                              __typename?: "BasicProperty"
                              alias?: string | null
                              editorAlias?: string | null
                              value?:
                                | {
                                    __typename?: "BasicBlockGridModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicBlockListModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicContentPicker"
                                    model: string
                                    contentList: Array<{
                                      __typename?: "BasicContentPickerItem"
                                      id: number
                                      absoluteUrl: string
                                      key: any
                                      name?: string | null
                                      url: string
                                      urlSegment?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicDateTimePicker"
                                    model: string
                                    dateTime?: any | null
                                  }
                                | {
                                    __typename?: "BasicLabel"
                                    model: string
                                    label?: any | null
                                  }
                                | {
                                    __typename?: "BasicMediaPicker"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicMemberPicker"
                                    model: string
                                    members: Array<{
                                      __typename?: "BasicMemberPickerItem"
                                      id?: number | null
                                      name?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicMultiUrlPicker"
                                    model: string
                                    links: Array<{
                                      __typename?: "BasicMultiUrlPickerItem"
                                      name?: string | null
                                      target?: string | null
                                      type: LinkType
                                      url?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicNestedContent"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicPropertyValue"
                                    model: string
                                    value?: any | null
                                  }
                                | {
                                    __typename?: "BasicRichText"
                                    model: string
                                    richText?: string | null
                                  }
                                | {
                                    __typename?: "BasicUnsupportedPropertyValue"
                                    model: string
                                    message: string
                                  }
                                | {
                                    __typename?: "MintMediaPicker"
                                    model: string
                                    mediaItems: Array<{
                                      __typename?: "MintMediaPickerItem"
                                      id: number
                                      url: string
                                      altText?: string | null
                                    }>
                                  }
                                | null
                            } | null>
                          }> | null
                        }
                      | {
                          __typename?: "BasicPropertyValue"
                          valueType: string
                          value?: any | null
                        }
                      | {
                          __typename?: "BasicRichText"
                          valueType: string
                          richText?: string | null
                        }
                      | {
                          __typename?: "BasicUnsupportedPropertyValue"
                          message: string
                          valueType: string
                        }
                      | {
                          __typename?: "MintMediaPicker"
                          valueType: string
                          mediaItems: Array<{
                            __typename?: "MintMediaPickerItem"
                            id: number
                            url: string
                            altText?: string | null
                          }>
                        }
                      | null
                  } | null>
                  settingsProperties: Array<{
                    __typename?: "BasicProperty"
                    value?:
                      | {
                          __typename?: "BasicBlockGridModel"
                          valueType: string
                        }
                      | {
                          __typename?: "BasicBlockListModel"
                          valueType: string
                        }
                      | {
                          __typename?: "BasicContentPicker"
                          valueType: string
                          contentList: Array<{
                            __typename?: "BasicContentPickerItem"
                            id: number
                            absoluteUrl: string
                            key: any
                            name?: string | null
                            url: string
                            urlSegment?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicDateTimePicker"
                          valueType: string
                          dateTime?: any | null
                        }
                      | {
                          __typename?: "BasicLabel"
                          valueType: string
                          label?: any | null
                        }
                      | { __typename?: "BasicMediaPicker"; valueType: string }
                      | {
                          __typename?: "BasicMemberPicker"
                          valueType: string
                          members: Array<{
                            __typename?: "BasicMemberPickerItem"
                            id?: number | null
                            name?: string | null
                            properties: Array<{
                              __typename?: "BasicProperty"
                              alias?: string | null
                              editorAlias?: string | null
                              value?:
                                | {
                                    __typename?: "BasicBlockGridModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicBlockListModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicContentPicker"
                                    model: string
                                    contentList: Array<{
                                      __typename?: "BasicContentPickerItem"
                                      id: number
                                      absoluteUrl: string
                                      key: any
                                      name?: string | null
                                      url: string
                                      urlSegment?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicDateTimePicker"
                                    model: string
                                    dateTime?: any | null
                                  }
                                | {
                                    __typename?: "BasicLabel"
                                    model: string
                                    label?: any | null
                                  }
                                | {
                                    __typename?: "BasicMediaPicker"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicMemberPicker"
                                    model: string
                                    members: Array<{
                                      __typename?: "BasicMemberPickerItem"
                                      id?: number | null
                                      name?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicMultiUrlPicker"
                                    model: string
                                    links: Array<{
                                      __typename?: "BasicMultiUrlPickerItem"
                                      name?: string | null
                                      target?: string | null
                                      type: LinkType
                                      url?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicNestedContent"
                                    model: string
                                    elements?: Array<{
                                      __typename?: "BasicNestedContentElement"
                                      properties: Array<{
                                        __typename?: "BasicProperty"
                                        alias?: string | null
                                        editorAlias?: string | null
                                        value?:
                                          | {
                                              __typename?: "BasicBlockGridModel"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicBlockListModel"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicContentPicker"
                                              model: string
                                              contentList: Array<{
                                                __typename?: "BasicContentPickerItem"
                                                id: number
                                                absoluteUrl: string
                                                key: any
                                                name?: string | null
                                                url: string
                                                urlSegment?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicDateTimePicker"
                                              model: string
                                              dateTime?: any | null
                                            }
                                          | {
                                              __typename?: "BasicLabel"
                                              model: string
                                              label?: any | null
                                            }
                                          | {
                                              __typename?: "BasicMediaPicker"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicMemberPicker"
                                              model: string
                                              members: Array<{
                                                __typename?: "BasicMemberPickerItem"
                                                id?: number | null
                                                name?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicMultiUrlPicker"
                                              model: string
                                              links: Array<{
                                                __typename?: "BasicMultiUrlPickerItem"
                                                name?: string | null
                                                target?: string | null
                                                type: LinkType
                                                url?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicNestedContent"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicPropertyValue"
                                              model: string
                                              value?: any | null
                                            }
                                          | {
                                              __typename?: "BasicRichText"
                                              model: string
                                              richText?: string | null
                                            }
                                          | {
                                              __typename?: "BasicUnsupportedPropertyValue"
                                              model: string
                                              message: string
                                            }
                                          | {
                                              __typename?: "MintMediaPicker"
                                              model: string
                                              mediaItems: Array<{
                                                __typename?: "MintMediaPickerItem"
                                                id: number
                                                url: string
                                                altText?: string | null
                                              }>
                                            }
                                          | null
                                      } | null>
                                    }> | null
                                  }
                                | {
                                    __typename?: "BasicPropertyValue"
                                    model: string
                                    value?: any | null
                                  }
                                | {
                                    __typename?: "BasicRichText"
                                    model: string
                                    richText?: string | null
                                  }
                                | {
                                    __typename?: "BasicUnsupportedPropertyValue"
                                    model: string
                                    message: string
                                  }
                                | {
                                    __typename?: "MintMediaPicker"
                                    model: string
                                    mediaItems: Array<{
                                      __typename?: "MintMediaPickerItem"
                                      id: number
                                      url: string
                                      altText?: string | null
                                    }>
                                  }
                                | null
                            } | null>
                          }>
                        }
                      | {
                          __typename?: "BasicMultiUrlPicker"
                          valueType: string
                          links: Array<{
                            __typename?: "BasicMultiUrlPickerItem"
                            name?: string | null
                            target?: string | null
                            type: LinkType
                            url?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicNestedContent"
                          valueType: string
                          elements?: Array<{
                            __typename?: "BasicNestedContentElement"
                            properties: Array<{
                              __typename?: "BasicProperty"
                              alias?: string | null
                              editorAlias?: string | null
                              value?:
                                | {
                                    __typename?: "BasicBlockGridModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicBlockListModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicContentPicker"
                                    model: string
                                    contentList: Array<{
                                      __typename?: "BasicContentPickerItem"
                                      id: number
                                      absoluteUrl: string
                                      key: any
                                      name?: string | null
                                      url: string
                                      urlSegment?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicDateTimePicker"
                                    model: string
                                    dateTime?: any | null
                                  }
                                | {
                                    __typename?: "BasicLabel"
                                    model: string
                                    label?: any | null
                                  }
                                | {
                                    __typename?: "BasicMediaPicker"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicMemberPicker"
                                    model: string
                                    members: Array<{
                                      __typename?: "BasicMemberPickerItem"
                                      id?: number | null
                                      name?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicMultiUrlPicker"
                                    model: string
                                    links: Array<{
                                      __typename?: "BasicMultiUrlPickerItem"
                                      name?: string | null
                                      target?: string | null
                                      type: LinkType
                                      url?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicNestedContent"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicPropertyValue"
                                    model: string
                                    value?: any | null
                                  }
                                | {
                                    __typename?: "BasicRichText"
                                    model: string
                                    richText?: string | null
                                  }
                                | {
                                    __typename?: "BasicUnsupportedPropertyValue"
                                    model: string
                                    message: string
                                  }
                                | {
                                    __typename?: "MintMediaPicker"
                                    model: string
                                    mediaItems: Array<{
                                      __typename?: "MintMediaPickerItem"
                                      id: number
                                      url: string
                                      altText?: string | null
                                    }>
                                  }
                                | null
                            } | null>
                          }> | null
                        }
                      | {
                          __typename?: "BasicPropertyValue"
                          valueType: string
                          value?: any | null
                        }
                      | {
                          __typename?: "BasicRichText"
                          valueType: string
                          richText?: string | null
                        }
                      | {
                          __typename?: "BasicUnsupportedPropertyValue"
                          message: string
                          valueType: string
                        }
                      | {
                          __typename?: "MintMediaPicker"
                          valueType: string
                          mediaItems: Array<{
                            __typename?: "MintMediaPickerItem"
                            id: number
                            url: string
                            altText?: string | null
                          }>
                        }
                      | null
                  } | null>
                  areas: Array<{
                    __typename?: "BasicBlockGridArea"
                    alias?: string | null
                    rowSpan: number
                    columnSpan: number
                    blocks?: Array<{
                      __typename?: "BasicBlockGridItem"
                      columnSpan: number
                      rowSpan: number
                      contentProperties: Array<{
                        __typename?: "BasicProperty"
                        value?:
                          | {
                              __typename?: "BasicBlockGridModel"
                              valueType: string
                            }
                          | {
                              __typename?: "BasicBlockListModel"
                              valueType: string
                            }
                          | {
                              __typename?: "BasicContentPicker"
                              valueType: string
                              contentList: Array<{
                                __typename?: "BasicContentPickerItem"
                                id: number
                                absoluteUrl: string
                                key: any
                                name?: string | null
                                url: string
                                urlSegment?: string | null
                              }>
                            }
                          | {
                              __typename?: "BasicDateTimePicker"
                              valueType: string
                              dateTime?: any | null
                            }
                          | {
                              __typename?: "BasicLabel"
                              valueType: string
                              label?: any | null
                            }
                          | {
                              __typename?: "BasicMediaPicker"
                              valueType: string
                            }
                          | {
                              __typename?: "BasicMemberPicker"
                              valueType: string
                              members: Array<{
                                __typename?: "BasicMemberPickerItem"
                                id?: number | null
                                name?: string | null
                                properties: Array<{
                                  __typename?: "BasicProperty"
                                  alias?: string | null
                                  editorAlias?: string | null
                                  value?:
                                    | {
                                        __typename?: "BasicBlockGridModel"
                                        model: string
                                      }
                                    | {
                                        __typename?: "BasicBlockListModel"
                                        model: string
                                      }
                                    | {
                                        __typename?: "BasicContentPicker"
                                        model: string
                                        contentList: Array<{
                                          __typename?: "BasicContentPickerItem"
                                          id: number
                                          absoluteUrl: string
                                          key: any
                                          name?: string | null
                                          url: string
                                          urlSegment?: string | null
                                        }>
                                      }
                                    | {
                                        __typename?: "BasicDateTimePicker"
                                        model: string
                                        dateTime?: any | null
                                      }
                                    | {
                                        __typename?: "BasicLabel"
                                        model: string
                                        label?: any | null
                                      }
                                    | {
                                        __typename?: "BasicMediaPicker"
                                        model: string
                                      }
                                    | {
                                        __typename?: "BasicMemberPicker"
                                        model: string
                                        members: Array<{
                                          __typename?: "BasicMemberPickerItem"
                                          id?: number | null
                                          name?: string | null
                                        }>
                                      }
                                    | {
                                        __typename?: "BasicMultiUrlPicker"
                                        model: string
                                        links: Array<{
                                          __typename?: "BasicMultiUrlPickerItem"
                                          name?: string | null
                                          target?: string | null
                                          type: LinkType
                                          url?: string | null
                                        }>
                                      }
                                    | {
                                        __typename?: "BasicNestedContent"
                                        model: string
                                        elements?: Array<{
                                          __typename?: "BasicNestedContentElement"
                                          properties: Array<{
                                            __typename?: "BasicProperty"
                                            alias?: string | null
                                            editorAlias?: string | null
                                            value?:
                                              | {
                                                  __typename?: "BasicBlockGridModel"
                                                  model: string
                                                }
                                              | {
                                                  __typename?: "BasicBlockListModel"
                                                  model: string
                                                }
                                              | {
                                                  __typename?: "BasicContentPicker"
                                                  model: string
                                                  contentList: Array<{
                                                    __typename?: "BasicContentPickerItem"
                                                    id: number
                                                    absoluteUrl: string
                                                    key: any
                                                    name?: string | null
                                                    url: string
                                                    urlSegment?: string | null
                                                  }>
                                                }
                                              | {
                                                  __typename?: "BasicDateTimePicker"
                                                  model: string
                                                  dateTime?: any | null
                                                }
                                              | {
                                                  __typename?: "BasicLabel"
                                                  model: string
                                                  label?: any | null
                                                }
                                              | {
                                                  __typename?: "BasicMediaPicker"
                                                  model: string
                                                }
                                              | {
                                                  __typename?: "BasicMemberPicker"
                                                  model: string
                                                  members: Array<{
                                                    __typename?: "BasicMemberPickerItem"
                                                    id?: number | null
                                                    name?: string | null
                                                  }>
                                                }
                                              | {
                                                  __typename?: "BasicMultiUrlPicker"
                                                  model: string
                                                  links: Array<{
                                                    __typename?: "BasicMultiUrlPickerItem"
                                                    name?: string | null
                                                    target?: string | null
                                                    type: LinkType
                                                    url?: string | null
                                                  }>
                                                }
                                              | {
                                                  __typename?: "BasicNestedContent"
                                                  model: string
                                                }
                                              | {
                                                  __typename?: "BasicPropertyValue"
                                                  model: string
                                                  value?: any | null
                                                }
                                              | {
                                                  __typename?: "BasicRichText"
                                                  model: string
                                                  richText?: string | null
                                                }
                                              | {
                                                  __typename?: "BasicUnsupportedPropertyValue"
                                                  model: string
                                                  message: string
                                                }
                                              | {
                                                  __typename?: "MintMediaPicker"
                                                  model: string
                                                  mediaItems: Array<{
                                                    __typename?: "MintMediaPickerItem"
                                                    id: number
                                                    url: string
                                                    altText?: string | null
                                                  }>
                                                }
                                              | null
                                          } | null>
                                        }> | null
                                      }
                                    | {
                                        __typename?: "BasicPropertyValue"
                                        model: string
                                        value?: any | null
                                      }
                                    | {
                                        __typename?: "BasicRichText"
                                        model: string
                                        richText?: string | null
                                      }
                                    | {
                                        __typename?: "BasicUnsupportedPropertyValue"
                                        model: string
                                        message: string
                                      }
                                    | {
                                        __typename?: "MintMediaPicker"
                                        model: string
                                        mediaItems: Array<{
                                          __typename?: "MintMediaPickerItem"
                                          id: number
                                          url: string
                                          altText?: string | null
                                        }>
                                      }
                                    | null
                                } | null>
                              }>
                            }
                          | {
                              __typename?: "BasicMultiUrlPicker"
                              valueType: string
                              links: Array<{
                                __typename?: "BasicMultiUrlPickerItem"
                                name?: string | null
                                target?: string | null
                                type: LinkType
                                url?: string | null
                              }>
                            }
                          | {
                              __typename?: "BasicNestedContent"
                              valueType: string
                              elements?: Array<{
                                __typename?: "BasicNestedContentElement"
                                properties: Array<{
                                  __typename?: "BasicProperty"
                                  alias?: string | null
                                  editorAlias?: string | null
                                  value?:
                                    | {
                                        __typename?: "BasicBlockGridModel"
                                        model: string
                                      }
                                    | {
                                        __typename?: "BasicBlockListModel"
                                        model: string
                                      }
                                    | {
                                        __typename?: "BasicContentPicker"
                                        model: string
                                        contentList: Array<{
                                          __typename?: "BasicContentPickerItem"
                                          id: number
                                          absoluteUrl: string
                                          key: any
                                          name?: string | null
                                          url: string
                                          urlSegment?: string | null
                                        }>
                                      }
                                    | {
                                        __typename?: "BasicDateTimePicker"
                                        model: string
                                        dateTime?: any | null
                                      }
                                    | {
                                        __typename?: "BasicLabel"
                                        model: string
                                        label?: any | null
                                      }
                                    | {
                                        __typename?: "BasicMediaPicker"
                                        model: string
                                      }
                                    | {
                                        __typename?: "BasicMemberPicker"
                                        model: string
                                        members: Array<{
                                          __typename?: "BasicMemberPickerItem"
                                          id?: number | null
                                          name?: string | null
                                        }>
                                      }
                                    | {
                                        __typename?: "BasicMultiUrlPicker"
                                        model: string
                                        links: Array<{
                                          __typename?: "BasicMultiUrlPickerItem"
                                          name?: string | null
                                          target?: string | null
                                          type: LinkType
                                          url?: string | null
                                        }>
                                      }
                                    | {
                                        __typename?: "BasicNestedContent"
                                        model: string
                                      }
                                    | {
                                        __typename?: "BasicPropertyValue"
                                        model: string
                                        value?: any | null
                                      }
                                    | {
                                        __typename?: "BasicRichText"
                                        model: string
                                        richText?: string | null
                                      }
                                    | {
                                        __typename?: "BasicUnsupportedPropertyValue"
                                        model: string
                                        message: string
                                      }
                                    | {
                                        __typename?: "MintMediaPicker"
                                        model: string
                                        mediaItems: Array<{
                                          __typename?: "MintMediaPickerItem"
                                          id: number
                                          url: string
                                          altText?: string | null
                                        }>
                                      }
                                    | null
                                } | null>
                              }> | null
                            }
                          | {
                              __typename?: "BasicPropertyValue"
                              valueType: string
                              value?: any | null
                            }
                          | {
                              __typename?: "BasicRichText"
                              valueType: string
                              richText?: string | null
                            }
                          | {
                              __typename?: "BasicUnsupportedPropertyValue"
                              message: string
                              valueType: string
                            }
                          | {
                              __typename?: "MintMediaPicker"
                              valueType: string
                              mediaItems: Array<{
                                __typename?: "MintMediaPickerItem"
                                id: number
                                url: string
                                altText?: string | null
                              }>
                            }
                          | null
                      } | null>
                      settingsProperties: Array<{
                        __typename?: "BasicProperty"
                        value?:
                          | {
                              __typename?: "BasicBlockGridModel"
                              valueType: string
                            }
                          | {
                              __typename?: "BasicBlockListModel"
                              valueType: string
                            }
                          | {
                              __typename?: "BasicContentPicker"
                              valueType: string
                              contentList: Array<{
                                __typename?: "BasicContentPickerItem"
                                id: number
                                absoluteUrl: string
                                key: any
                                name?: string | null
                                url: string
                                urlSegment?: string | null
                              }>
                            }
                          | {
                              __typename?: "BasicDateTimePicker"
                              valueType: string
                              dateTime?: any | null
                            }
                          | {
                              __typename?: "BasicLabel"
                              valueType: string
                              label?: any | null
                            }
                          | {
                              __typename?: "BasicMediaPicker"
                              valueType: string
                            }
                          | {
                              __typename?: "BasicMemberPicker"
                              valueType: string
                              members: Array<{
                                __typename?: "BasicMemberPickerItem"
                                id?: number | null
                                name?: string | null
                                properties: Array<{
                                  __typename?: "BasicProperty"
                                  alias?: string | null
                                  editorAlias?: string | null
                                  value?:
                                    | {
                                        __typename?: "BasicBlockGridModel"
                                        model: string
                                      }
                                    | {
                                        __typename?: "BasicBlockListModel"
                                        model: string
                                      }
                                    | {
                                        __typename?: "BasicContentPicker"
                                        model: string
                                        contentList: Array<{
                                          __typename?: "BasicContentPickerItem"
                                          id: number
                                          absoluteUrl: string
                                          key: any
                                          name?: string | null
                                          url: string
                                          urlSegment?: string | null
                                        }>
                                      }
                                    | {
                                        __typename?: "BasicDateTimePicker"
                                        model: string
                                        dateTime?: any | null
                                      }
                                    | {
                                        __typename?: "BasicLabel"
                                        model: string
                                        label?: any | null
                                      }
                                    | {
                                        __typename?: "BasicMediaPicker"
                                        model: string
                                      }
                                    | {
                                        __typename?: "BasicMemberPicker"
                                        model: string
                                        members: Array<{
                                          __typename?: "BasicMemberPickerItem"
                                          id?: number | null
                                          name?: string | null
                                        }>
                                      }
                                    | {
                                        __typename?: "BasicMultiUrlPicker"
                                        model: string
                                        links: Array<{
                                          __typename?: "BasicMultiUrlPickerItem"
                                          name?: string | null
                                          target?: string | null
                                          type: LinkType
                                          url?: string | null
                                        }>
                                      }
                                    | {
                                        __typename?: "BasicNestedContent"
                                        model: string
                                        elements?: Array<{
                                          __typename?: "BasicNestedContentElement"
                                          properties: Array<{
                                            __typename?: "BasicProperty"
                                            alias?: string | null
                                            editorAlias?: string | null
                                            value?:
                                              | {
                                                  __typename?: "BasicBlockGridModel"
                                                  model: string
                                                }
                                              | {
                                                  __typename?: "BasicBlockListModel"
                                                  model: string
                                                }
                                              | {
                                                  __typename?: "BasicContentPicker"
                                                  model: string
                                                  contentList: Array<{
                                                    __typename?: "BasicContentPickerItem"
                                                    id: number
                                                    absoluteUrl: string
                                                    key: any
                                                    name?: string | null
                                                    url: string
                                                    urlSegment?: string | null
                                                  }>
                                                }
                                              | {
                                                  __typename?: "BasicDateTimePicker"
                                                  model: string
                                                  dateTime?: any | null
                                                }
                                              | {
                                                  __typename?: "BasicLabel"
                                                  model: string
                                                  label?: any | null
                                                }
                                              | {
                                                  __typename?: "BasicMediaPicker"
                                                  model: string
                                                }
                                              | {
                                                  __typename?: "BasicMemberPicker"
                                                  model: string
                                                  members: Array<{
                                                    __typename?: "BasicMemberPickerItem"
                                                    id?: number | null
                                                    name?: string | null
                                                  }>
                                                }
                                              | {
                                                  __typename?: "BasicMultiUrlPicker"
                                                  model: string
                                                  links: Array<{
                                                    __typename?: "BasicMultiUrlPickerItem"
                                                    name?: string | null
                                                    target?: string | null
                                                    type: LinkType
                                                    url?: string | null
                                                  }>
                                                }
                                              | {
                                                  __typename?: "BasicNestedContent"
                                                  model: string
                                                }
                                              | {
                                                  __typename?: "BasicPropertyValue"
                                                  model: string
                                                  value?: any | null
                                                }
                                              | {
                                                  __typename?: "BasicRichText"
                                                  model: string
                                                  richText?: string | null
                                                }
                                              | {
                                                  __typename?: "BasicUnsupportedPropertyValue"
                                                  model: string
                                                  message: string
                                                }
                                              | {
                                                  __typename?: "MintMediaPicker"
                                                  model: string
                                                  mediaItems: Array<{
                                                    __typename?: "MintMediaPickerItem"
                                                    id: number
                                                    url: string
                                                    altText?: string | null
                                                  }>
                                                }
                                              | null
                                          } | null>
                                        }> | null
                                      }
                                    | {
                                        __typename?: "BasicPropertyValue"
                                        model: string
                                        value?: any | null
                                      }
                                    | {
                                        __typename?: "BasicRichText"
                                        model: string
                                        richText?: string | null
                                      }
                                    | {
                                        __typename?: "BasicUnsupportedPropertyValue"
                                        model: string
                                        message: string
                                      }
                                    | {
                                        __typename?: "MintMediaPicker"
                                        model: string
                                        mediaItems: Array<{
                                          __typename?: "MintMediaPickerItem"
                                          id: number
                                          url: string
                                          altText?: string | null
                                        }>
                                      }
                                    | null
                                } | null>
                              }>
                            }
                          | {
                              __typename?: "BasicMultiUrlPicker"
                              valueType: string
                              links: Array<{
                                __typename?: "BasicMultiUrlPickerItem"
                                name?: string | null
                                target?: string | null
                                type: LinkType
                                url?: string | null
                              }>
                            }
                          | {
                              __typename?: "BasicNestedContent"
                              valueType: string
                              elements?: Array<{
                                __typename?: "BasicNestedContentElement"
                                properties: Array<{
                                  __typename?: "BasicProperty"
                                  alias?: string | null
                                  editorAlias?: string | null
                                  value?:
                                    | {
                                        __typename?: "BasicBlockGridModel"
                                        model: string
                                      }
                                    | {
                                        __typename?: "BasicBlockListModel"
                                        model: string
                                      }
                                    | {
                                        __typename?: "BasicContentPicker"
                                        model: string
                                        contentList: Array<{
                                          __typename?: "BasicContentPickerItem"
                                          id: number
                                          absoluteUrl: string
                                          key: any
                                          name?: string | null
                                          url: string
                                          urlSegment?: string | null
                                        }>
                                      }
                                    | {
                                        __typename?: "BasicDateTimePicker"
                                        model: string
                                        dateTime?: any | null
                                      }
                                    | {
                                        __typename?: "BasicLabel"
                                        model: string
                                        label?: any | null
                                      }
                                    | {
                                        __typename?: "BasicMediaPicker"
                                        model: string
                                      }
                                    | {
                                        __typename?: "BasicMemberPicker"
                                        model: string
                                        members: Array<{
                                          __typename?: "BasicMemberPickerItem"
                                          id?: number | null
                                          name?: string | null
                                        }>
                                      }
                                    | {
                                        __typename?: "BasicMultiUrlPicker"
                                        model: string
                                        links: Array<{
                                          __typename?: "BasicMultiUrlPickerItem"
                                          name?: string | null
                                          target?: string | null
                                          type: LinkType
                                          url?: string | null
                                        }>
                                      }
                                    | {
                                        __typename?: "BasicNestedContent"
                                        model: string
                                      }
                                    | {
                                        __typename?: "BasicPropertyValue"
                                        model: string
                                        value?: any | null
                                      }
                                    | {
                                        __typename?: "BasicRichText"
                                        model: string
                                        richText?: string | null
                                      }
                                    | {
                                        __typename?: "BasicUnsupportedPropertyValue"
                                        model: string
                                        message: string
                                      }
                                    | {
                                        __typename?: "MintMediaPicker"
                                        model: string
                                        mediaItems: Array<{
                                          __typename?: "MintMediaPickerItem"
                                          id: number
                                          url: string
                                          altText?: string | null
                                        }>
                                      }
                                    | null
                                } | null>
                              }> | null
                            }
                          | {
                              __typename?: "BasicPropertyValue"
                              valueType: string
                              value?: any | null
                            }
                          | {
                              __typename?: "BasicRichText"
                              valueType: string
                              richText?: string | null
                            }
                          | {
                              __typename?: "BasicUnsupportedPropertyValue"
                              message: string
                              valueType: string
                            }
                          | {
                              __typename?: "MintMediaPicker"
                              valueType: string
                              mediaItems: Array<{
                                __typename?: "MintMediaPickerItem"
                                id: number
                                url: string
                                altText?: string | null
                              }>
                            }
                          | null
                      } | null>
                      areas: Array<{
                        __typename?: "BasicBlockGridArea"
                        alias?: string | null
                        rowSpan: number
                        columnSpan: number
                      } | null>
                    }> | null
                  } | null>
                }> | null
              }
            | {
                __typename?: "BasicBlockListModel"
                valueType: string
                blocks?: Array<{
                  __typename?: "BasicBlockListItem"
                  blockType?: string | null
                  properties: Array<{
                    __typename?: "BasicProperty"
                    propertyName?: string | null
                    propertyValue?:
                      | {
                          __typename?: "BasicBlockGridModel"
                          valueType: string
                        }
                      | {
                          __typename?: "BasicBlockListModel"
                          valueType: string
                          blocks?: Array<{
                            __typename?: "BasicBlockListItem"
                            blockType?: string | null
                            properties: Array<{
                              __typename?: "BasicProperty"
                              propertyName?: string | null
                              propertyValue?:
                                | {
                                    __typename?: "BasicBlockGridModel"
                                    valueType: string
                                  }
                                | {
                                    __typename?: "BasicBlockListModel"
                                    valueType: string
                                    blocks?: Array<{
                                      __typename?: "BasicBlockListItem"
                                      blockType?: string | null
                                      properties: Array<{
                                        __typename?: "BasicProperty"
                                        propertyName?: string | null
                                        propertyValue?:
                                          | {
                                              __typename?: "BasicBlockGridModel"
                                              valueType: string
                                            }
                                          | {
                                              __typename?: "BasicBlockListModel"
                                              valueType: string
                                              blocks?: Array<{
                                                __typename?: "BasicBlockListItem"
                                                blockType?: string | null
                                                properties: Array<{
                                                  __typename?: "BasicProperty"
                                                  propertyName?: string | null
                                                  propertyValue?:
                                                    | {
                                                        __typename?: "BasicBlockGridModel"
                                                        valueType: string
                                                      }
                                                    | {
                                                        __typename?: "BasicBlockListModel"
                                                        valueType: string
                                                        blocks?: Array<{
                                                          __typename?: "BasicBlockListItem"
                                                          blockType?:
                                                            | string
                                                            | null
                                                          properties: Array<{
                                                            __typename?: "BasicProperty"
                                                            propertyName?:
                                                              | string
                                                              | null
                                                            propertyValue?:
                                                              | {
                                                                  __typename?: "BasicBlockGridModel"
                                                                  valueType: string
                                                                }
                                                              | {
                                                                  __typename?: "BasicBlockListModel"
                                                                  valueType: string
                                                                }
                                                              | {
                                                                  __typename?: "BasicContentPicker"
                                                                  valueType: string
                                                                  contentList: Array<{
                                                                    __typename?: "BasicContentPickerItem"
                                                                    id: number
                                                                    absoluteUrl: string
                                                                    key: any
                                                                    name?:
                                                                      | string
                                                                      | null
                                                                    url: string
                                                                    urlSegment?:
                                                                      | string
                                                                      | null
                                                                  }>
                                                                }
                                                              | {
                                                                  __typename?: "BasicDateTimePicker"
                                                                  valueType: string
                                                                  dateTime?:
                                                                    | any
                                                                    | null
                                                                }
                                                              | {
                                                                  __typename?: "BasicLabel"
                                                                  valueType: string
                                                                  label?:
                                                                    | any
                                                                    | null
                                                                }
                                                              | {
                                                                  __typename?: "BasicMediaPicker"
                                                                  valueType: string
                                                                }
                                                              | {
                                                                  __typename?: "BasicMemberPicker"
                                                                  valueType: string
                                                                  members: Array<{
                                                                    __typename?: "BasicMemberPickerItem"
                                                                    id?:
                                                                      | number
                                                                      | null
                                                                    name?:
                                                                      | string
                                                                      | null
                                                                    properties: Array<{
                                                                      __typename?: "BasicProperty"
                                                                      alias?:
                                                                        | string
                                                                        | null
                                                                      editorAlias?:
                                                                        | string
                                                                        | null
                                                                      value?:
                                                                        | {
                                                                            __typename?: "BasicBlockGridModel"
                                                                            model: string
                                                                          }
                                                                        | {
                                                                            __typename?: "BasicBlockListModel"
                                                                            model: string
                                                                          }
                                                                        | {
                                                                            __typename?: "BasicContentPicker"
                                                                            model: string
                                                                            contentList: Array<{
                                                                              __typename?: "BasicContentPickerItem"
                                                                              id: number
                                                                              absoluteUrl: string
                                                                              key: any
                                                                              name?:
                                                                                | string
                                                                                | null
                                                                              url: string
                                                                              urlSegment?:
                                                                                | string
                                                                                | null
                                                                            }>
                                                                          }
                                                                        | {
                                                                            __typename?: "BasicDateTimePicker"
                                                                            model: string
                                                                            dateTime?:
                                                                              | any
                                                                              | null
                                                                          }
                                                                        | {
                                                                            __typename?: "BasicLabel"
                                                                            model: string
                                                                            label?:
                                                                              | any
                                                                              | null
                                                                          }
                                                                        | {
                                                                            __typename?: "BasicMediaPicker"
                                                                            model: string
                                                                          }
                                                                        | {
                                                                            __typename?: "BasicMemberPicker"
                                                                            model: string
                                                                            members: Array<{
                                                                              __typename?: "BasicMemberPickerItem"
                                                                              id?:
                                                                                | number
                                                                                | null
                                                                              name?:
                                                                                | string
                                                                                | null
                                                                            }>
                                                                          }
                                                                        | {
                                                                            __typename?: "BasicMultiUrlPicker"
                                                                            model: string
                                                                            links: Array<{
                                                                              __typename?: "BasicMultiUrlPickerItem"
                                                                              name?:
                                                                                | string
                                                                                | null
                                                                              target?:
                                                                                | string
                                                                                | null
                                                                              type: LinkType
                                                                              url?:
                                                                                | string
                                                                                | null
                                                                            }>
                                                                          }
                                                                        | {
                                                                            __typename?: "BasicNestedContent"
                                                                            model: string
                                                                            elements?: Array<{
                                                                              __typename?: "BasicNestedContentElement"
                                                                              properties: Array<{
                                                                                __typename?: "BasicProperty"
                                                                                alias?:
                                                                                  | string
                                                                                  | null
                                                                                editorAlias?:
                                                                                  | string
                                                                                  | null
                                                                                value?:
                                                                                  | {
                                                                                      __typename?: "BasicBlockGridModel"
                                                                                      model: string
                                                                                    }
                                                                                  | {
                                                                                      __typename?: "BasicBlockListModel"
                                                                                      model: string
                                                                                    }
                                                                                  | {
                                                                                      __typename?: "BasicContentPicker"
                                                                                      model: string
                                                                                      contentList: Array<{
                                                                                        __typename?: "BasicContentPickerItem"
                                                                                        id: number
                                                                                        absoluteUrl: string
                                                                                        key: any
                                                                                        name?:
                                                                                          | string
                                                                                          | null
                                                                                        url: string
                                                                                        urlSegment?:
                                                                                          | string
                                                                                          | null
                                                                                      }>
                                                                                    }
                                                                                  | {
                                                                                      __typename?: "BasicDateTimePicker"
                                                                                      model: string
                                                                                      dateTime?:
                                                                                        | any
                                                                                        | null
                                                                                    }
                                                                                  | {
                                                                                      __typename?: "BasicLabel"
                                                                                      model: string
                                                                                      label?:
                                                                                        | any
                                                                                        | null
                                                                                    }
                                                                                  | {
                                                                                      __typename?: "BasicMediaPicker"
                                                                                      model: string
                                                                                    }
                                                                                  | {
                                                                                      __typename?: "BasicMemberPicker"
                                                                                      model: string
                                                                                      members: Array<{
                                                                                        __typename?: "BasicMemberPickerItem"
                                                                                        id?:
                                                                                          | number
                                                                                          | null
                                                                                        name?:
                                                                                          | string
                                                                                          | null
                                                                                      }>
                                                                                    }
                                                                                  | {
                                                                                      __typename?: "BasicMultiUrlPicker"
                                                                                      model: string
                                                                                      links: Array<{
                                                                                        __typename?: "BasicMultiUrlPickerItem"
                                                                                        name?:
                                                                                          | string
                                                                                          | null
                                                                                        target?:
                                                                                          | string
                                                                                          | null
                                                                                        type: LinkType
                                                                                        url?:
                                                                                          | string
                                                                                          | null
                                                                                      }>
                                                                                    }
                                                                                  | {
                                                                                      __typename?: "BasicNestedContent"
                                                                                      model: string
                                                                                    }
                                                                                  | {
                                                                                      __typename?: "BasicPropertyValue"
                                                                                      model: string
                                                                                      value?:
                                                                                        | any
                                                                                        | null
                                                                                    }
                                                                                  | {
                                                                                      __typename?: "BasicRichText"
                                                                                      model: string
                                                                                      richText?:
                                                                                        | string
                                                                                        | null
                                                                                    }
                                                                                  | {
                                                                                      __typename?: "BasicUnsupportedPropertyValue"
                                                                                      model: string
                                                                                      message: string
                                                                                    }
                                                                                  | {
                                                                                      __typename?: "MintMediaPicker"
                                                                                      model: string
                                                                                      mediaItems: Array<{
                                                                                        __typename?: "MintMediaPickerItem"
                                                                                        id: number
                                                                                        url: string
                                                                                        altText?:
                                                                                          | string
                                                                                          | null
                                                                                      }>
                                                                                    }
                                                                                  | null
                                                                              } | null>
                                                                            }> | null
                                                                          }
                                                                        | {
                                                                            __typename?: "BasicPropertyValue"
                                                                            model: string
                                                                            value?:
                                                                              | any
                                                                              | null
                                                                          }
                                                                        | {
                                                                            __typename?: "BasicRichText"
                                                                            model: string
                                                                            richText?:
                                                                              | string
                                                                              | null
                                                                          }
                                                                        | {
                                                                            __typename?: "BasicUnsupportedPropertyValue"
                                                                            model: string
                                                                            message: string
                                                                          }
                                                                        | {
                                                                            __typename?: "MintMediaPicker"
                                                                            model: string
                                                                            mediaItems: Array<{
                                                                              __typename?: "MintMediaPickerItem"
                                                                              id: number
                                                                              url: string
                                                                              altText?:
                                                                                | string
                                                                                | null
                                                                            }>
                                                                          }
                                                                        | null
                                                                    } | null>
                                                                  }>
                                                                }
                                                              | {
                                                                  __typename?: "BasicMultiUrlPicker"
                                                                  valueType: string
                                                                  links: Array<{
                                                                    __typename?: "BasicMultiUrlPickerItem"
                                                                    name?:
                                                                      | string
                                                                      | null
                                                                    target?:
                                                                      | string
                                                                      | null
                                                                    type: LinkType
                                                                    url?:
                                                                      | string
                                                                      | null
                                                                  }>
                                                                }
                                                              | {
                                                                  __typename?: "BasicNestedContent"
                                                                  valueType: string
                                                                  elements?: Array<{
                                                                    __typename?: "BasicNestedContentElement"
                                                                    properties: Array<{
                                                                      __typename?: "BasicProperty"
                                                                      alias?:
                                                                        | string
                                                                        | null
                                                                      editorAlias?:
                                                                        | string
                                                                        | null
                                                                      value?:
                                                                        | {
                                                                            __typename?: "BasicBlockGridModel"
                                                                            model: string
                                                                          }
                                                                        | {
                                                                            __typename?: "BasicBlockListModel"
                                                                            model: string
                                                                          }
                                                                        | {
                                                                            __typename?: "BasicContentPicker"
                                                                            model: string
                                                                            contentList: Array<{
                                                                              __typename?: "BasicContentPickerItem"
                                                                              id: number
                                                                              absoluteUrl: string
                                                                              key: any
                                                                              name?:
                                                                                | string
                                                                                | null
                                                                              url: string
                                                                              urlSegment?:
                                                                                | string
                                                                                | null
                                                                            }>
                                                                          }
                                                                        | {
                                                                            __typename?: "BasicDateTimePicker"
                                                                            model: string
                                                                            dateTime?:
                                                                              | any
                                                                              | null
                                                                          }
                                                                        | {
                                                                            __typename?: "BasicLabel"
                                                                            model: string
                                                                            label?:
                                                                              | any
                                                                              | null
                                                                          }
                                                                        | {
                                                                            __typename?: "BasicMediaPicker"
                                                                            model: string
                                                                          }
                                                                        | {
                                                                            __typename?: "BasicMemberPicker"
                                                                            model: string
                                                                            members: Array<{
                                                                              __typename?: "BasicMemberPickerItem"
                                                                              id?:
                                                                                | number
                                                                                | null
                                                                              name?:
                                                                                | string
                                                                                | null
                                                                            }>
                                                                          }
                                                                        | {
                                                                            __typename?: "BasicMultiUrlPicker"
                                                                            model: string
                                                                            links: Array<{
                                                                              __typename?: "BasicMultiUrlPickerItem"
                                                                              name?:
                                                                                | string
                                                                                | null
                                                                              target?:
                                                                                | string
                                                                                | null
                                                                              type: LinkType
                                                                              url?:
                                                                                | string
                                                                                | null
                                                                            }>
                                                                          }
                                                                        | {
                                                                            __typename?: "BasicNestedContent"
                                                                            model: string
                                                                          }
                                                                        | {
                                                                            __typename?: "BasicPropertyValue"
                                                                            model: string
                                                                            value?:
                                                                              | any
                                                                              | null
                                                                          }
                                                                        | {
                                                                            __typename?: "BasicRichText"
                                                                            model: string
                                                                            richText?:
                                                                              | string
                                                                              | null
                                                                          }
                                                                        | {
                                                                            __typename?: "BasicUnsupportedPropertyValue"
                                                                            model: string
                                                                            message: string
                                                                          }
                                                                        | {
                                                                            __typename?: "MintMediaPicker"
                                                                            model: string
                                                                            mediaItems: Array<{
                                                                              __typename?: "MintMediaPickerItem"
                                                                              id: number
                                                                              url: string
                                                                              altText?:
                                                                                | string
                                                                                | null
                                                                            }>
                                                                          }
                                                                        | null
                                                                    } | null>
                                                                  }> | null
                                                                }
                                                              | {
                                                                  __typename?: "BasicPropertyValue"
                                                                  valueType: string
                                                                  value?:
                                                                    | any
                                                                    | null
                                                                }
                                                              | {
                                                                  __typename?: "BasicRichText"
                                                                  valueType: string
                                                                  richText?:
                                                                    | string
                                                                    | null
                                                                }
                                                              | {
                                                                  __typename?: "BasicUnsupportedPropertyValue"
                                                                  message: string
                                                                  valueType: string
                                                                }
                                                              | {
                                                                  __typename?: "MintMediaPicker"
                                                                  valueType: string
                                                                  mediaItems: Array<{
                                                                    __typename?: "MintMediaPickerItem"
                                                                    id: number
                                                                    url: string
                                                                    altText?:
                                                                      | string
                                                                      | null
                                                                  }>
                                                                }
                                                              | null
                                                          } | null>
                                                        }> | null
                                                      }
                                                    | {
                                                        __typename?: "BasicContentPicker"
                                                        valueType: string
                                                        contentList: Array<{
                                                          __typename?: "BasicContentPickerItem"
                                                          id: number
                                                          absoluteUrl: string
                                                          key: any
                                                          name?: string | null
                                                          url: string
                                                          urlSegment?:
                                                            | string
                                                            | null
                                                        }>
                                                      }
                                                    | {
                                                        __typename?: "BasicDateTimePicker"
                                                        valueType: string
                                                        dateTime?: any | null
                                                      }
                                                    | {
                                                        __typename?: "BasicLabel"
                                                        valueType: string
                                                        label?: any | null
                                                      }
                                                    | {
                                                        __typename?: "BasicMediaPicker"
                                                        valueType: string
                                                      }
                                                    | {
                                                        __typename?: "BasicMemberPicker"
                                                        valueType: string
                                                        members: Array<{
                                                          __typename?: "BasicMemberPickerItem"
                                                          id?: number | null
                                                          name?: string | null
                                                          properties: Array<{
                                                            __typename?: "BasicProperty"
                                                            alias?:
                                                              | string
                                                              | null
                                                            editorAlias?:
                                                              | string
                                                              | null
                                                            value?:
                                                              | {
                                                                  __typename?: "BasicBlockGridModel"
                                                                  model: string
                                                                }
                                                              | {
                                                                  __typename?: "BasicBlockListModel"
                                                                  model: string
                                                                }
                                                              | {
                                                                  __typename?: "BasicContentPicker"
                                                                  model: string
                                                                  contentList: Array<{
                                                                    __typename?: "BasicContentPickerItem"
                                                                    id: number
                                                                    absoluteUrl: string
                                                                    key: any
                                                                    name?:
                                                                      | string
                                                                      | null
                                                                    url: string
                                                                    urlSegment?:
                                                                      | string
                                                                      | null
                                                                  }>
                                                                }
                                                              | {
                                                                  __typename?: "BasicDateTimePicker"
                                                                  model: string
                                                                  dateTime?:
                                                                    | any
                                                                    | null
                                                                }
                                                              | {
                                                                  __typename?: "BasicLabel"
                                                                  model: string
                                                                  label?:
                                                                    | any
                                                                    | null
                                                                }
                                                              | {
                                                                  __typename?: "BasicMediaPicker"
                                                                  model: string
                                                                }
                                                              | {
                                                                  __typename?: "BasicMemberPicker"
                                                                  model: string
                                                                  members: Array<{
                                                                    __typename?: "BasicMemberPickerItem"
                                                                    id?:
                                                                      | number
                                                                      | null
                                                                    name?:
                                                                      | string
                                                                      | null
                                                                  }>
                                                                }
                                                              | {
                                                                  __typename?: "BasicMultiUrlPicker"
                                                                  model: string
                                                                  links: Array<{
                                                                    __typename?: "BasicMultiUrlPickerItem"
                                                                    name?:
                                                                      | string
                                                                      | null
                                                                    target?:
                                                                      | string
                                                                      | null
                                                                    type: LinkType
                                                                    url?:
                                                                      | string
                                                                      | null
                                                                  }>
                                                                }
                                                              | {
                                                                  __typename?: "BasicNestedContent"
                                                                  model: string
                                                                  elements?: Array<{
                                                                    __typename?: "BasicNestedContentElement"
                                                                    properties: Array<{
                                                                      __typename?: "BasicProperty"
                                                                      alias?:
                                                                        | string
                                                                        | null
                                                                      editorAlias?:
                                                                        | string
                                                                        | null
                                                                      value?:
                                                                        | {
                                                                            __typename?: "BasicBlockGridModel"
                                                                            model: string
                                                                          }
                                                                        | {
                                                                            __typename?: "BasicBlockListModel"
                                                                            model: string
                                                                          }
                                                                        | {
                                                                            __typename?: "BasicContentPicker"
                                                                            model: string
                                                                            contentList: Array<{
                                                                              __typename?: "BasicContentPickerItem"
                                                                              id: number
                                                                              absoluteUrl: string
                                                                              key: any
                                                                              name?:
                                                                                | string
                                                                                | null
                                                                              url: string
                                                                              urlSegment?:
                                                                                | string
                                                                                | null
                                                                            }>
                                                                          }
                                                                        | {
                                                                            __typename?: "BasicDateTimePicker"
                                                                            model: string
                                                                            dateTime?:
                                                                              | any
                                                                              | null
                                                                          }
                                                                        | {
                                                                            __typename?: "BasicLabel"
                                                                            model: string
                                                                            label?:
                                                                              | any
                                                                              | null
                                                                          }
                                                                        | {
                                                                            __typename?: "BasicMediaPicker"
                                                                            model: string
                                                                          }
                                                                        | {
                                                                            __typename?: "BasicMemberPicker"
                                                                            model: string
                                                                            members: Array<{
                                                                              __typename?: "BasicMemberPickerItem"
                                                                              id?:
                                                                                | number
                                                                                | null
                                                                              name?:
                                                                                | string
                                                                                | null
                                                                            }>
                                                                          }
                                                                        | {
                                                                            __typename?: "BasicMultiUrlPicker"
                                                                            model: string
                                                                            links: Array<{
                                                                              __typename?: "BasicMultiUrlPickerItem"
                                                                              name?:
                                                                                | string
                                                                                | null
                                                                              target?:
                                                                                | string
                                                                                | null
                                                                              type: LinkType
                                                                              url?:
                                                                                | string
                                                                                | null
                                                                            }>
                                                                          }
                                                                        | {
                                                                            __typename?: "BasicNestedContent"
                                                                            model: string
                                                                          }
                                                                        | {
                                                                            __typename?: "BasicPropertyValue"
                                                                            model: string
                                                                            value?:
                                                                              | any
                                                                              | null
                                                                          }
                                                                        | {
                                                                            __typename?: "BasicRichText"
                                                                            model: string
                                                                            richText?:
                                                                              | string
                                                                              | null
                                                                          }
                                                                        | {
                                                                            __typename?: "BasicUnsupportedPropertyValue"
                                                                            model: string
                                                                            message: string
                                                                          }
                                                                        | {
                                                                            __typename?: "MintMediaPicker"
                                                                            model: string
                                                                            mediaItems: Array<{
                                                                              __typename?: "MintMediaPickerItem"
                                                                              id: number
                                                                              url: string
                                                                              altText?:
                                                                                | string
                                                                                | null
                                                                            }>
                                                                          }
                                                                        | null
                                                                    } | null>
                                                                  }> | null
                                                                }
                                                              | {
                                                                  __typename?: "BasicPropertyValue"
                                                                  model: string
                                                                  value?:
                                                                    | any
                                                                    | null
                                                                }
                                                              | {
                                                                  __typename?: "BasicRichText"
                                                                  model: string
                                                                  richText?:
                                                                    | string
                                                                    | null
                                                                }
                                                              | {
                                                                  __typename?: "BasicUnsupportedPropertyValue"
                                                                  model: string
                                                                  message: string
                                                                }
                                                              | {
                                                                  __typename?: "MintMediaPicker"
                                                                  model: string
                                                                  mediaItems: Array<{
                                                                    __typename?: "MintMediaPickerItem"
                                                                    id: number
                                                                    url: string
                                                                    altText?:
                                                                      | string
                                                                      | null
                                                                  }>
                                                                }
                                                              | null
                                                          } | null>
                                                        }>
                                                      }
                                                    | {
                                                        __typename?: "BasicMultiUrlPicker"
                                                        valueType: string
                                                        links: Array<{
                                                          __typename?: "BasicMultiUrlPickerItem"
                                                          name?: string | null
                                                          target?: string | null
                                                          type: LinkType
                                                          url?: string | null
                                                        }>
                                                      }
                                                    | {
                                                        __typename?: "BasicNestedContent"
                                                        valueType: string
                                                        elements?: Array<{
                                                          __typename?: "BasicNestedContentElement"
                                                          properties: Array<{
                                                            __typename?: "BasicProperty"
                                                            alias?:
                                                              | string
                                                              | null
                                                            editorAlias?:
                                                              | string
                                                              | null
                                                            value?:
                                                              | {
                                                                  __typename?: "BasicBlockGridModel"
                                                                  model: string
                                                                }
                                                              | {
                                                                  __typename?: "BasicBlockListModel"
                                                                  model: string
                                                                }
                                                              | {
                                                                  __typename?: "BasicContentPicker"
                                                                  model: string
                                                                  contentList: Array<{
                                                                    __typename?: "BasicContentPickerItem"
                                                                    id: number
                                                                    absoluteUrl: string
                                                                    key: any
                                                                    name?:
                                                                      | string
                                                                      | null
                                                                    url: string
                                                                    urlSegment?:
                                                                      | string
                                                                      | null
                                                                  }>
                                                                }
                                                              | {
                                                                  __typename?: "BasicDateTimePicker"
                                                                  model: string
                                                                  dateTime?:
                                                                    | any
                                                                    | null
                                                                }
                                                              | {
                                                                  __typename?: "BasicLabel"
                                                                  model: string
                                                                  label?:
                                                                    | any
                                                                    | null
                                                                }
                                                              | {
                                                                  __typename?: "BasicMediaPicker"
                                                                  model: string
                                                                }
                                                              | {
                                                                  __typename?: "BasicMemberPicker"
                                                                  model: string
                                                                  members: Array<{
                                                                    __typename?: "BasicMemberPickerItem"
                                                                    id?:
                                                                      | number
                                                                      | null
                                                                    name?:
                                                                      | string
                                                                      | null
                                                                  }>
                                                                }
                                                              | {
                                                                  __typename?: "BasicMultiUrlPicker"
                                                                  model: string
                                                                  links: Array<{
                                                                    __typename?: "BasicMultiUrlPickerItem"
                                                                    name?:
                                                                      | string
                                                                      | null
                                                                    target?:
                                                                      | string
                                                                      | null
                                                                    type: LinkType
                                                                    url?:
                                                                      | string
                                                                      | null
                                                                  }>
                                                                }
                                                              | {
                                                                  __typename?: "BasicNestedContent"
                                                                  model: string
                                                                }
                                                              | {
                                                                  __typename?: "BasicPropertyValue"
                                                                  model: string
                                                                  value?:
                                                                    | any
                                                                    | null
                                                                }
                                                              | {
                                                                  __typename?: "BasicRichText"
                                                                  model: string
                                                                  richText?:
                                                                    | string
                                                                    | null
                                                                }
                                                              | {
                                                                  __typename?: "BasicUnsupportedPropertyValue"
                                                                  model: string
                                                                  message: string
                                                                }
                                                              | {
                                                                  __typename?: "MintMediaPicker"
                                                                  model: string
                                                                  mediaItems: Array<{
                                                                    __typename?: "MintMediaPickerItem"
                                                                    id: number
                                                                    url: string
                                                                    altText?:
                                                                      | string
                                                                      | null
                                                                  }>
                                                                }
                                                              | null
                                                          } | null>
                                                        }> | null
                                                      }
                                                    | {
                                                        __typename?: "BasicPropertyValue"
                                                        valueType: string
                                                        value?: any | null
                                                      }
                                                    | {
                                                        __typename?: "BasicRichText"
                                                        valueType: string
                                                        richText?: string | null
                                                      }
                                                    | {
                                                        __typename?: "BasicUnsupportedPropertyValue"
                                                        message: string
                                                        valueType: string
                                                      }
                                                    | {
                                                        __typename?: "MintMediaPicker"
                                                        valueType: string
                                                        mediaItems: Array<{
                                                          __typename?: "MintMediaPickerItem"
                                                          id: number
                                                          url: string
                                                          altText?:
                                                            | string
                                                            | null
                                                        }>
                                                      }
                                                    | null
                                                } | null>
                                              }> | null
                                            }
                                          | {
                                              __typename?: "BasicContentPicker"
                                              valueType: string
                                              contentList: Array<{
                                                __typename?: "BasicContentPickerItem"
                                                id: number
                                                absoluteUrl: string
                                                key: any
                                                name?: string | null
                                                url: string
                                                urlSegment?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicDateTimePicker"
                                              valueType: string
                                              dateTime?: any | null
                                            }
                                          | {
                                              __typename?: "BasicLabel"
                                              valueType: string
                                              label?: any | null
                                            }
                                          | {
                                              __typename?: "BasicMediaPicker"
                                              valueType: string
                                            }
                                          | {
                                              __typename?: "BasicMemberPicker"
                                              valueType: string
                                              members: Array<{
                                                __typename?: "BasicMemberPickerItem"
                                                id?: number | null
                                                name?: string | null
                                                properties: Array<{
                                                  __typename?: "BasicProperty"
                                                  alias?: string | null
                                                  editorAlias?: string | null
                                                  value?:
                                                    | {
                                                        __typename?: "BasicBlockGridModel"
                                                        model: string
                                                      }
                                                    | {
                                                        __typename?: "BasicBlockListModel"
                                                        model: string
                                                      }
                                                    | {
                                                        __typename?: "BasicContentPicker"
                                                        model: string
                                                        contentList: Array<{
                                                          __typename?: "BasicContentPickerItem"
                                                          id: number
                                                          absoluteUrl: string
                                                          key: any
                                                          name?: string | null
                                                          url: string
                                                          urlSegment?:
                                                            | string
                                                            | null
                                                        }>
                                                      }
                                                    | {
                                                        __typename?: "BasicDateTimePicker"
                                                        model: string
                                                        dateTime?: any | null
                                                      }
                                                    | {
                                                        __typename?: "BasicLabel"
                                                        model: string
                                                        label?: any | null
                                                      }
                                                    | {
                                                        __typename?: "BasicMediaPicker"
                                                        model: string
                                                      }
                                                    | {
                                                        __typename?: "BasicMemberPicker"
                                                        model: string
                                                        members: Array<{
                                                          __typename?: "BasicMemberPickerItem"
                                                          id?: number | null
                                                          name?: string | null
                                                        }>
                                                      }
                                                    | {
                                                        __typename?: "BasicMultiUrlPicker"
                                                        model: string
                                                        links: Array<{
                                                          __typename?: "BasicMultiUrlPickerItem"
                                                          name?: string | null
                                                          target?: string | null
                                                          type: LinkType
                                                          url?: string | null
                                                        }>
                                                      }
                                                    | {
                                                        __typename?: "BasicNestedContent"
                                                        model: string
                                                        elements?: Array<{
                                                          __typename?: "BasicNestedContentElement"
                                                          properties: Array<{
                                                            __typename?: "BasicProperty"
                                                            alias?:
                                                              | string
                                                              | null
                                                            editorAlias?:
                                                              | string
                                                              | null
                                                            value?:
                                                              | {
                                                                  __typename?: "BasicBlockGridModel"
                                                                  model: string
                                                                }
                                                              | {
                                                                  __typename?: "BasicBlockListModel"
                                                                  model: string
                                                                }
                                                              | {
                                                                  __typename?: "BasicContentPicker"
                                                                  model: string
                                                                  contentList: Array<{
                                                                    __typename?: "BasicContentPickerItem"
                                                                    id: number
                                                                    absoluteUrl: string
                                                                    key: any
                                                                    name?:
                                                                      | string
                                                                      | null
                                                                    url: string
                                                                    urlSegment?:
                                                                      | string
                                                                      | null
                                                                  }>
                                                                }
                                                              | {
                                                                  __typename?: "BasicDateTimePicker"
                                                                  model: string
                                                                  dateTime?:
                                                                    | any
                                                                    | null
                                                                }
                                                              | {
                                                                  __typename?: "BasicLabel"
                                                                  model: string
                                                                  label?:
                                                                    | any
                                                                    | null
                                                                }
                                                              | {
                                                                  __typename?: "BasicMediaPicker"
                                                                  model: string
                                                                }
                                                              | {
                                                                  __typename?: "BasicMemberPicker"
                                                                  model: string
                                                                  members: Array<{
                                                                    __typename?: "BasicMemberPickerItem"
                                                                    id?:
                                                                      | number
                                                                      | null
                                                                    name?:
                                                                      | string
                                                                      | null
                                                                  }>
                                                                }
                                                              | {
                                                                  __typename?: "BasicMultiUrlPicker"
                                                                  model: string
                                                                  links: Array<{
                                                                    __typename?: "BasicMultiUrlPickerItem"
                                                                    name?:
                                                                      | string
                                                                      | null
                                                                    target?:
                                                                      | string
                                                                      | null
                                                                    type: LinkType
                                                                    url?:
                                                                      | string
                                                                      | null
                                                                  }>
                                                                }
                                                              | {
                                                                  __typename?: "BasicNestedContent"
                                                                  model: string
                                                                }
                                                              | {
                                                                  __typename?: "BasicPropertyValue"
                                                                  model: string
                                                                  value?:
                                                                    | any
                                                                    | null
                                                                }
                                                              | {
                                                                  __typename?: "BasicRichText"
                                                                  model: string
                                                                  richText?:
                                                                    | string
                                                                    | null
                                                                }
                                                              | {
                                                                  __typename?: "BasicUnsupportedPropertyValue"
                                                                  model: string
                                                                  message: string
                                                                }
                                                              | {
                                                                  __typename?: "MintMediaPicker"
                                                                  model: string
                                                                  mediaItems: Array<{
                                                                    __typename?: "MintMediaPickerItem"
                                                                    id: number
                                                                    url: string
                                                                    altText?:
                                                                      | string
                                                                      | null
                                                                  }>
                                                                }
                                                              | null
                                                          } | null>
                                                        }> | null
                                                      }
                                                    | {
                                                        __typename?: "BasicPropertyValue"
                                                        model: string
                                                        value?: any | null
                                                      }
                                                    | {
                                                        __typename?: "BasicRichText"
                                                        model: string
                                                        richText?: string | null
                                                      }
                                                    | {
                                                        __typename?: "BasicUnsupportedPropertyValue"
                                                        model: string
                                                        message: string
                                                      }
                                                    | {
                                                        __typename?: "MintMediaPicker"
                                                        model: string
                                                        mediaItems: Array<{
                                                          __typename?: "MintMediaPickerItem"
                                                          id: number
                                                          url: string
                                                          altText?:
                                                            | string
                                                            | null
                                                        }>
                                                      }
                                                    | null
                                                } | null>
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicMultiUrlPicker"
                                              valueType: string
                                              links: Array<{
                                                __typename?: "BasicMultiUrlPickerItem"
                                                name?: string | null
                                                target?: string | null
                                                type: LinkType
                                                url?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicNestedContent"
                                              valueType: string
                                              elements?: Array<{
                                                __typename?: "BasicNestedContentElement"
                                                properties: Array<{
                                                  __typename?: "BasicProperty"
                                                  alias?: string | null
                                                  editorAlias?: string | null
                                                  value?:
                                                    | {
                                                        __typename?: "BasicBlockGridModel"
                                                        model: string
                                                      }
                                                    | {
                                                        __typename?: "BasicBlockListModel"
                                                        model: string
                                                      }
                                                    | {
                                                        __typename?: "BasicContentPicker"
                                                        model: string
                                                        contentList: Array<{
                                                          __typename?: "BasicContentPickerItem"
                                                          id: number
                                                          absoluteUrl: string
                                                          key: any
                                                          name?: string | null
                                                          url: string
                                                          urlSegment?:
                                                            | string
                                                            | null
                                                        }>
                                                      }
                                                    | {
                                                        __typename?: "BasicDateTimePicker"
                                                        model: string
                                                        dateTime?: any | null
                                                      }
                                                    | {
                                                        __typename?: "BasicLabel"
                                                        model: string
                                                        label?: any | null
                                                      }
                                                    | {
                                                        __typename?: "BasicMediaPicker"
                                                        model: string
                                                      }
                                                    | {
                                                        __typename?: "BasicMemberPicker"
                                                        model: string
                                                        members: Array<{
                                                          __typename?: "BasicMemberPickerItem"
                                                          id?: number | null
                                                          name?: string | null
                                                        }>
                                                      }
                                                    | {
                                                        __typename?: "BasicMultiUrlPicker"
                                                        model: string
                                                        links: Array<{
                                                          __typename?: "BasicMultiUrlPickerItem"
                                                          name?: string | null
                                                          target?: string | null
                                                          type: LinkType
                                                          url?: string | null
                                                        }>
                                                      }
                                                    | {
                                                        __typename?: "BasicNestedContent"
                                                        model: string
                                                      }
                                                    | {
                                                        __typename?: "BasicPropertyValue"
                                                        model: string
                                                        value?: any | null
                                                      }
                                                    | {
                                                        __typename?: "BasicRichText"
                                                        model: string
                                                        richText?: string | null
                                                      }
                                                    | {
                                                        __typename?: "BasicUnsupportedPropertyValue"
                                                        model: string
                                                        message: string
                                                      }
                                                    | {
                                                        __typename?: "MintMediaPicker"
                                                        model: string
                                                        mediaItems: Array<{
                                                          __typename?: "MintMediaPickerItem"
                                                          id: number
                                                          url: string
                                                          altText?:
                                                            | string
                                                            | null
                                                        }>
                                                      }
                                                    | null
                                                } | null>
                                              }> | null
                                            }
                                          | {
                                              __typename?: "BasicPropertyValue"
                                              valueType: string
                                              value?: any | null
                                            }
                                          | {
                                              __typename?: "BasicRichText"
                                              valueType: string
                                              richText?: string | null
                                            }
                                          | {
                                              __typename?: "BasicUnsupportedPropertyValue"
                                              message: string
                                              valueType: string
                                            }
                                          | {
                                              __typename?: "MintMediaPicker"
                                              valueType: string
                                              mediaItems: Array<{
                                                __typename?: "MintMediaPickerItem"
                                                id: number
                                                url: string
                                                altText?: string | null
                                              }>
                                            }
                                          | null
                                      } | null>
                                    }> | null
                                  }
                                | {
                                    __typename?: "BasicContentPicker"
                                    valueType: string
                                    contentList: Array<{
                                      __typename?: "BasicContentPickerItem"
                                      id: number
                                      absoluteUrl: string
                                      key: any
                                      name?: string | null
                                      url: string
                                      urlSegment?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicDateTimePicker"
                                    valueType: string
                                    dateTime?: any | null
                                  }
                                | {
                                    __typename?: "BasicLabel"
                                    valueType: string
                                    label?: any | null
                                  }
                                | {
                                    __typename?: "BasicMediaPicker"
                                    valueType: string
                                  }
                                | {
                                    __typename?: "BasicMemberPicker"
                                    valueType: string
                                    members: Array<{
                                      __typename?: "BasicMemberPickerItem"
                                      id?: number | null
                                      name?: string | null
                                      properties: Array<{
                                        __typename?: "BasicProperty"
                                        alias?: string | null
                                        editorAlias?: string | null
                                        value?:
                                          | {
                                              __typename?: "BasicBlockGridModel"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicBlockListModel"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicContentPicker"
                                              model: string
                                              contentList: Array<{
                                                __typename?: "BasicContentPickerItem"
                                                id: number
                                                absoluteUrl: string
                                                key: any
                                                name?: string | null
                                                url: string
                                                urlSegment?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicDateTimePicker"
                                              model: string
                                              dateTime?: any | null
                                            }
                                          | {
                                              __typename?: "BasicLabel"
                                              model: string
                                              label?: any | null
                                            }
                                          | {
                                              __typename?: "BasicMediaPicker"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicMemberPicker"
                                              model: string
                                              members: Array<{
                                                __typename?: "BasicMemberPickerItem"
                                                id?: number | null
                                                name?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicMultiUrlPicker"
                                              model: string
                                              links: Array<{
                                                __typename?: "BasicMultiUrlPickerItem"
                                                name?: string | null
                                                target?: string | null
                                                type: LinkType
                                                url?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicNestedContent"
                                              model: string
                                              elements?: Array<{
                                                __typename?: "BasicNestedContentElement"
                                                properties: Array<{
                                                  __typename?: "BasicProperty"
                                                  alias?: string | null
                                                  editorAlias?: string | null
                                                  value?:
                                                    | {
                                                        __typename?: "BasicBlockGridModel"
                                                        model: string
                                                      }
                                                    | {
                                                        __typename?: "BasicBlockListModel"
                                                        model: string
                                                      }
                                                    | {
                                                        __typename?: "BasicContentPicker"
                                                        model: string
                                                        contentList: Array<{
                                                          __typename?: "BasicContentPickerItem"
                                                          id: number
                                                          absoluteUrl: string
                                                          key: any
                                                          name?: string | null
                                                          url: string
                                                          urlSegment?:
                                                            | string
                                                            | null
                                                        }>
                                                      }
                                                    | {
                                                        __typename?: "BasicDateTimePicker"
                                                        model: string
                                                        dateTime?: any | null
                                                      }
                                                    | {
                                                        __typename?: "BasicLabel"
                                                        model: string
                                                        label?: any | null
                                                      }
                                                    | {
                                                        __typename?: "BasicMediaPicker"
                                                        model: string
                                                      }
                                                    | {
                                                        __typename?: "BasicMemberPicker"
                                                        model: string
                                                        members: Array<{
                                                          __typename?: "BasicMemberPickerItem"
                                                          id?: number | null
                                                          name?: string | null
                                                        }>
                                                      }
                                                    | {
                                                        __typename?: "BasicMultiUrlPicker"
                                                        model: string
                                                        links: Array<{
                                                          __typename?: "BasicMultiUrlPickerItem"
                                                          name?: string | null
                                                          target?: string | null
                                                          type: LinkType
                                                          url?: string | null
                                                        }>
                                                      }
                                                    | {
                                                        __typename?: "BasicNestedContent"
                                                        model: string
                                                      }
                                                    | {
                                                        __typename?: "BasicPropertyValue"
                                                        model: string
                                                        value?: any | null
                                                      }
                                                    | {
                                                        __typename?: "BasicRichText"
                                                        model: string
                                                        richText?: string | null
                                                      }
                                                    | {
                                                        __typename?: "BasicUnsupportedPropertyValue"
                                                        model: string
                                                        message: string
                                                      }
                                                    | {
                                                        __typename?: "MintMediaPicker"
                                                        model: string
                                                        mediaItems: Array<{
                                                          __typename?: "MintMediaPickerItem"
                                                          id: number
                                                          url: string
                                                          altText?:
                                                            | string
                                                            | null
                                                        }>
                                                      }
                                                    | null
                                                } | null>
                                              }> | null
                                            }
                                          | {
                                              __typename?: "BasicPropertyValue"
                                              model: string
                                              value?: any | null
                                            }
                                          | {
                                              __typename?: "BasicRichText"
                                              model: string
                                              richText?: string | null
                                            }
                                          | {
                                              __typename?: "BasicUnsupportedPropertyValue"
                                              model: string
                                              message: string
                                            }
                                          | {
                                              __typename?: "MintMediaPicker"
                                              model: string
                                              mediaItems: Array<{
                                                __typename?: "MintMediaPickerItem"
                                                id: number
                                                url: string
                                                altText?: string | null
                                              }>
                                            }
                                          | null
                                      } | null>
                                    }>
                                  }
                                | {
                                    __typename?: "BasicMultiUrlPicker"
                                    valueType: string
                                    links: Array<{
                                      __typename?: "BasicMultiUrlPickerItem"
                                      name?: string | null
                                      target?: string | null
                                      type: LinkType
                                      url?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicNestedContent"
                                    valueType: string
                                    elements?: Array<{
                                      __typename?: "BasicNestedContentElement"
                                      properties: Array<{
                                        __typename?: "BasicProperty"
                                        alias?: string | null
                                        editorAlias?: string | null
                                        value?:
                                          | {
                                              __typename?: "BasicBlockGridModel"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicBlockListModel"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicContentPicker"
                                              model: string
                                              contentList: Array<{
                                                __typename?: "BasicContentPickerItem"
                                                id: number
                                                absoluteUrl: string
                                                key: any
                                                name?: string | null
                                                url: string
                                                urlSegment?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicDateTimePicker"
                                              model: string
                                              dateTime?: any | null
                                            }
                                          | {
                                              __typename?: "BasicLabel"
                                              model: string
                                              label?: any | null
                                            }
                                          | {
                                              __typename?: "BasicMediaPicker"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicMemberPicker"
                                              model: string
                                              members: Array<{
                                                __typename?: "BasicMemberPickerItem"
                                                id?: number | null
                                                name?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicMultiUrlPicker"
                                              model: string
                                              links: Array<{
                                                __typename?: "BasicMultiUrlPickerItem"
                                                name?: string | null
                                                target?: string | null
                                                type: LinkType
                                                url?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicNestedContent"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicPropertyValue"
                                              model: string
                                              value?: any | null
                                            }
                                          | {
                                              __typename?: "BasicRichText"
                                              model: string
                                              richText?: string | null
                                            }
                                          | {
                                              __typename?: "BasicUnsupportedPropertyValue"
                                              model: string
                                              message: string
                                            }
                                          | {
                                              __typename?: "MintMediaPicker"
                                              model: string
                                              mediaItems: Array<{
                                                __typename?: "MintMediaPickerItem"
                                                id: number
                                                url: string
                                                altText?: string | null
                                              }>
                                            }
                                          | null
                                      } | null>
                                    }> | null
                                  }
                                | {
                                    __typename?: "BasicPropertyValue"
                                    valueType: string
                                    value?: any | null
                                  }
                                | {
                                    __typename?: "BasicRichText"
                                    valueType: string
                                    richText?: string | null
                                  }
                                | {
                                    __typename?: "BasicUnsupportedPropertyValue"
                                    message: string
                                    valueType: string
                                  }
                                | {
                                    __typename?: "MintMediaPicker"
                                    valueType: string
                                    mediaItems: Array<{
                                      __typename?: "MintMediaPickerItem"
                                      id: number
                                      url: string
                                      altText?: string | null
                                    }>
                                  }
                                | null
                            } | null>
                          }> | null
                        }
                      | {
                          __typename?: "BasicContentPicker"
                          valueType: string
                          contentList: Array<{
                            __typename?: "BasicContentPickerItem"
                            id: number
                            absoluteUrl: string
                            key: any
                            name?: string | null
                            url: string
                            urlSegment?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicDateTimePicker"
                          valueType: string
                          dateTime?: any | null
                        }
                      | {
                          __typename?: "BasicLabel"
                          valueType: string
                          label?: any | null
                        }
                      | { __typename?: "BasicMediaPicker"; valueType: string }
                      | {
                          __typename?: "BasicMemberPicker"
                          valueType: string
                          members: Array<{
                            __typename?: "BasicMemberPickerItem"
                            id?: number | null
                            name?: string | null
                            properties: Array<{
                              __typename?: "BasicProperty"
                              alias?: string | null
                              editorAlias?: string | null
                              value?:
                                | {
                                    __typename?: "BasicBlockGridModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicBlockListModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicContentPicker"
                                    model: string
                                    contentList: Array<{
                                      __typename?: "BasicContentPickerItem"
                                      id: number
                                      absoluteUrl: string
                                      key: any
                                      name?: string | null
                                      url: string
                                      urlSegment?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicDateTimePicker"
                                    model: string
                                    dateTime?: any | null
                                  }
                                | {
                                    __typename?: "BasicLabel"
                                    model: string
                                    label?: any | null
                                  }
                                | {
                                    __typename?: "BasicMediaPicker"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicMemberPicker"
                                    model: string
                                    members: Array<{
                                      __typename?: "BasicMemberPickerItem"
                                      id?: number | null
                                      name?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicMultiUrlPicker"
                                    model: string
                                    links: Array<{
                                      __typename?: "BasicMultiUrlPickerItem"
                                      name?: string | null
                                      target?: string | null
                                      type: LinkType
                                      url?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicNestedContent"
                                    model: string
                                    elements?: Array<{
                                      __typename?: "BasicNestedContentElement"
                                      properties: Array<{
                                        __typename?: "BasicProperty"
                                        alias?: string | null
                                        editorAlias?: string | null
                                        value?:
                                          | {
                                              __typename?: "BasicBlockGridModel"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicBlockListModel"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicContentPicker"
                                              model: string
                                              contentList: Array<{
                                                __typename?: "BasicContentPickerItem"
                                                id: number
                                                absoluteUrl: string
                                                key: any
                                                name?: string | null
                                                url: string
                                                urlSegment?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicDateTimePicker"
                                              model: string
                                              dateTime?: any | null
                                            }
                                          | {
                                              __typename?: "BasicLabel"
                                              model: string
                                              label?: any | null
                                            }
                                          | {
                                              __typename?: "BasicMediaPicker"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicMemberPicker"
                                              model: string
                                              members: Array<{
                                                __typename?: "BasicMemberPickerItem"
                                                id?: number | null
                                                name?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicMultiUrlPicker"
                                              model: string
                                              links: Array<{
                                                __typename?: "BasicMultiUrlPickerItem"
                                                name?: string | null
                                                target?: string | null
                                                type: LinkType
                                                url?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicNestedContent"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicPropertyValue"
                                              model: string
                                              value?: any | null
                                            }
                                          | {
                                              __typename?: "BasicRichText"
                                              model: string
                                              richText?: string | null
                                            }
                                          | {
                                              __typename?: "BasicUnsupportedPropertyValue"
                                              model: string
                                              message: string
                                            }
                                          | {
                                              __typename?: "MintMediaPicker"
                                              model: string
                                              mediaItems: Array<{
                                                __typename?: "MintMediaPickerItem"
                                                id: number
                                                url: string
                                                altText?: string | null
                                              }>
                                            }
                                          | null
                                      } | null>
                                    }> | null
                                  }
                                | {
                                    __typename?: "BasicPropertyValue"
                                    model: string
                                    value?: any | null
                                  }
                                | {
                                    __typename?: "BasicRichText"
                                    model: string
                                    richText?: string | null
                                  }
                                | {
                                    __typename?: "BasicUnsupportedPropertyValue"
                                    model: string
                                    message: string
                                  }
                                | {
                                    __typename?: "MintMediaPicker"
                                    model: string
                                    mediaItems: Array<{
                                      __typename?: "MintMediaPickerItem"
                                      id: number
                                      url: string
                                      altText?: string | null
                                    }>
                                  }
                                | null
                            } | null>
                          }>
                        }
                      | {
                          __typename?: "BasicMultiUrlPicker"
                          valueType: string
                          links: Array<{
                            __typename?: "BasicMultiUrlPickerItem"
                            name?: string | null
                            target?: string | null
                            type: LinkType
                            url?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicNestedContent"
                          valueType: string
                          elements?: Array<{
                            __typename?: "BasicNestedContentElement"
                            properties: Array<{
                              __typename?: "BasicProperty"
                              alias?: string | null
                              editorAlias?: string | null
                              value?:
                                | {
                                    __typename?: "BasicBlockGridModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicBlockListModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicContentPicker"
                                    model: string
                                    contentList: Array<{
                                      __typename?: "BasicContentPickerItem"
                                      id: number
                                      absoluteUrl: string
                                      key: any
                                      name?: string | null
                                      url: string
                                      urlSegment?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicDateTimePicker"
                                    model: string
                                    dateTime?: any | null
                                  }
                                | {
                                    __typename?: "BasicLabel"
                                    model: string
                                    label?: any | null
                                  }
                                | {
                                    __typename?: "BasicMediaPicker"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicMemberPicker"
                                    model: string
                                    members: Array<{
                                      __typename?: "BasicMemberPickerItem"
                                      id?: number | null
                                      name?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicMultiUrlPicker"
                                    model: string
                                    links: Array<{
                                      __typename?: "BasicMultiUrlPickerItem"
                                      name?: string | null
                                      target?: string | null
                                      type: LinkType
                                      url?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicNestedContent"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicPropertyValue"
                                    model: string
                                    value?: any | null
                                  }
                                | {
                                    __typename?: "BasicRichText"
                                    model: string
                                    richText?: string | null
                                  }
                                | {
                                    __typename?: "BasicUnsupportedPropertyValue"
                                    model: string
                                    message: string
                                  }
                                | {
                                    __typename?: "MintMediaPicker"
                                    model: string
                                    mediaItems: Array<{
                                      __typename?: "MintMediaPickerItem"
                                      id: number
                                      url: string
                                      altText?: string | null
                                    }>
                                  }
                                | null
                            } | null>
                          }> | null
                        }
                      | {
                          __typename?: "BasicPropertyValue"
                          valueType: string
                          value?: any | null
                        }
                      | {
                          __typename?: "BasicRichText"
                          valueType: string
                          richText?: string | null
                        }
                      | {
                          __typename?: "BasicUnsupportedPropertyValue"
                          message: string
                          valueType: string
                        }
                      | {
                          __typename?: "MintMediaPicker"
                          valueType: string
                          mediaItems: Array<{
                            __typename?: "MintMediaPickerItem"
                            id: number
                            url: string
                            altText?: string | null
                          }>
                        }
                      | null
                  } | null>
                }> | null
              }
            | {
                __typename?: "BasicContentPicker"
                valueType: string
                contentList: Array<{
                  __typename?: "BasicContentPickerItem"
                  id: number
                  absoluteUrl: string
                  key: any
                  name?: string | null
                  url: string
                  urlSegment?: string | null
                }>
              }
            | {
                __typename?: "BasicDateTimePicker"
                valueType: string
                dateTime?: any | null
              }
            | {
                __typename?: "BasicLabel"
                valueType: string
                label?: any | null
              }
            | { __typename?: "BasicMediaPicker"; valueType: string }
            | {
                __typename?: "BasicMemberPicker"
                valueType: string
                members: Array<{
                  __typename?: "BasicMemberPickerItem"
                  id?: number | null
                  name?: string | null
                  properties: Array<{
                    __typename?: "BasicProperty"
                    alias?: string | null
                    editorAlias?: string | null
                    value?:
                      | { __typename?: "BasicBlockGridModel"; model: string }
                      | { __typename?: "BasicBlockListModel"; model: string }
                      | {
                          __typename?: "BasicContentPicker"
                          model: string
                          contentList: Array<{
                            __typename?: "BasicContentPickerItem"
                            id: number
                            absoluteUrl: string
                            key: any
                            name?: string | null
                            url: string
                            urlSegment?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicDateTimePicker"
                          model: string
                          dateTime?: any | null
                        }
                      | {
                          __typename?: "BasicLabel"
                          model: string
                          label?: any | null
                        }
                      | { __typename?: "BasicMediaPicker"; model: string }
                      | {
                          __typename?: "BasicMemberPicker"
                          model: string
                          members: Array<{
                            __typename?: "BasicMemberPickerItem"
                            id?: number | null
                            name?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicMultiUrlPicker"
                          model: string
                          links: Array<{
                            __typename?: "BasicMultiUrlPickerItem"
                            name?: string | null
                            target?: string | null
                            type: LinkType
                            url?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicNestedContent"
                          model: string
                          elements?: Array<{
                            __typename?: "BasicNestedContentElement"
                            properties: Array<{
                              __typename?: "BasicProperty"
                              alias?: string | null
                              editorAlias?: string | null
                              value?:
                                | {
                                    __typename?: "BasicBlockGridModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicBlockListModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicContentPicker"
                                    model: string
                                    contentList: Array<{
                                      __typename?: "BasicContentPickerItem"
                                      id: number
                                      absoluteUrl: string
                                      key: any
                                      name?: string | null
                                      url: string
                                      urlSegment?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicDateTimePicker"
                                    model: string
                                    dateTime?: any | null
                                  }
                                | {
                                    __typename?: "BasicLabel"
                                    model: string
                                    label?: any | null
                                  }
                                | {
                                    __typename?: "BasicMediaPicker"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicMemberPicker"
                                    model: string
                                    members: Array<{
                                      __typename?: "BasicMemberPickerItem"
                                      id?: number | null
                                      name?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicMultiUrlPicker"
                                    model: string
                                    links: Array<{
                                      __typename?: "BasicMultiUrlPickerItem"
                                      name?: string | null
                                      target?: string | null
                                      type: LinkType
                                      url?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicNestedContent"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicPropertyValue"
                                    model: string
                                    value?: any | null
                                  }
                                | {
                                    __typename?: "BasicRichText"
                                    model: string
                                    richText?: string | null
                                  }
                                | {
                                    __typename?: "BasicUnsupportedPropertyValue"
                                    model: string
                                    message: string
                                  }
                                | {
                                    __typename?: "MintMediaPicker"
                                    model: string
                                    mediaItems: Array<{
                                      __typename?: "MintMediaPickerItem"
                                      id: number
                                      url: string
                                      altText?: string | null
                                    }>
                                  }
                                | null
                            } | null>
                          }> | null
                        }
                      | {
                          __typename?: "BasicPropertyValue"
                          model: string
                          value?: any | null
                        }
                      | {
                          __typename?: "BasicRichText"
                          model: string
                          richText?: string | null
                        }
                      | {
                          __typename?: "BasicUnsupportedPropertyValue"
                          model: string
                          message: string
                        }
                      | {
                          __typename?: "MintMediaPicker"
                          model: string
                          mediaItems: Array<{
                            __typename?: "MintMediaPickerItem"
                            id: number
                            url: string
                            altText?: string | null
                          }>
                        }
                      | null
                  } | null>
                }>
              }
            | {
                __typename?: "BasicMultiUrlPicker"
                valueType: string
                links: Array<{
                  __typename?: "BasicMultiUrlPickerItem"
                  name?: string | null
                  target?: string | null
                  type: LinkType
                  url?: string | null
                }>
              }
            | {
                __typename?: "BasicNestedContent"
                valueType: string
                elements?: Array<{
                  __typename?: "BasicNestedContentElement"
                  properties: Array<{
                    __typename?: "BasicProperty"
                    alias?: string | null
                    editorAlias?: string | null
                    value?:
                      | { __typename?: "BasicBlockGridModel"; model: string }
                      | { __typename?: "BasicBlockListModel"; model: string }
                      | {
                          __typename?: "BasicContentPicker"
                          model: string
                          contentList: Array<{
                            __typename?: "BasicContentPickerItem"
                            id: number
                            absoluteUrl: string
                            key: any
                            name?: string | null
                            url: string
                            urlSegment?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicDateTimePicker"
                          model: string
                          dateTime?: any | null
                        }
                      | {
                          __typename?: "BasicLabel"
                          model: string
                          label?: any | null
                        }
                      | { __typename?: "BasicMediaPicker"; model: string }
                      | {
                          __typename?: "BasicMemberPicker"
                          model: string
                          members: Array<{
                            __typename?: "BasicMemberPickerItem"
                            id?: number | null
                            name?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicMultiUrlPicker"
                          model: string
                          links: Array<{
                            __typename?: "BasicMultiUrlPickerItem"
                            name?: string | null
                            target?: string | null
                            type: LinkType
                            url?: string | null
                          }>
                        }
                      | { __typename?: "BasicNestedContent"; model: string }
                      | {
                          __typename?: "BasicPropertyValue"
                          model: string
                          value?: any | null
                        }
                      | {
                          __typename?: "BasicRichText"
                          model: string
                          richText?: string | null
                        }
                      | {
                          __typename?: "BasicUnsupportedPropertyValue"
                          model: string
                          message: string
                        }
                      | {
                          __typename?: "MintMediaPicker"
                          model: string
                          mediaItems: Array<{
                            __typename?: "MintMediaPickerItem"
                            id: number
                            url: string
                            altText?: string | null
                          }>
                        }
                      | null
                  } | null>
                }> | null
              }
            | {
                __typename?: "BasicPropertyValue"
                valueType: string
                value?: any | null
              }
            | {
                __typename?: "BasicRichText"
                valueType: string
                richText?: string | null
              }
            | {
                __typename?: "BasicUnsupportedPropertyValue"
                message: string
                valueType: string
              }
            | {
                __typename?: "MintMediaPicker"
                valueType: string
                mediaItems: Array<{
                  __typename?: "MintMediaPickerItem"
                  id: number
                  url: string
                  altText?: string | null
                }>
              }
            | null
        } | null> | null
        parent?: {
          __typename?: "BasicContent"
          id?: number | null
          url?: string | null
          level?: number | null
          properties?: Array<{
            __typename?: "BasicProperty"
            propertyName?: string | null
            propertyValue?:
              | {
                  __typename?: "BasicBlockGridModel"
                  gridColumns?: number | null
                  valueType: string
                  blocks?: Array<{
                    __typename?: "BasicBlockGridItem"
                    columnSpan: number
                    rowSpan: number
                    contentProperties: Array<{
                      __typename?: "BasicProperty"
                      value?:
                        | {
                            __typename?: "BasicBlockGridModel"
                            valueType: string
                          }
                        | {
                            __typename?: "BasicBlockListModel"
                            valueType: string
                          }
                        | {
                            __typename?: "BasicContentPicker"
                            valueType: string
                            contentList: Array<{
                              __typename?: "BasicContentPickerItem"
                              id: number
                              absoluteUrl: string
                              key: any
                              name?: string | null
                              url: string
                              urlSegment?: string | null
                            }>
                          }
                        | {
                            __typename?: "BasicDateTimePicker"
                            valueType: string
                            dateTime?: any | null
                          }
                        | {
                            __typename?: "BasicLabel"
                            valueType: string
                            label?: any | null
                          }
                        | { __typename?: "BasicMediaPicker"; valueType: string }
                        | {
                            __typename?: "BasicMemberPicker"
                            valueType: string
                            members: Array<{
                              __typename?: "BasicMemberPickerItem"
                              id?: number | null
                              name?: string | null
                              properties: Array<{
                                __typename?: "BasicProperty"
                                alias?: string | null
                                editorAlias?: string | null
                                value?:
                                  | {
                                      __typename?: "BasicBlockGridModel"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicBlockListModel"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicContentPicker"
                                      model: string
                                      contentList: Array<{
                                        __typename?: "BasicContentPickerItem"
                                        id: number
                                        absoluteUrl: string
                                        key: any
                                        name?: string | null
                                        url: string
                                        urlSegment?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicDateTimePicker"
                                      model: string
                                      dateTime?: any | null
                                    }
                                  | {
                                      __typename?: "BasicLabel"
                                      model: string
                                      label?: any | null
                                    }
                                  | {
                                      __typename?: "BasicMediaPicker"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicMemberPicker"
                                      model: string
                                      members: Array<{
                                        __typename?: "BasicMemberPickerItem"
                                        id?: number | null
                                        name?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicMultiUrlPicker"
                                      model: string
                                      links: Array<{
                                        __typename?: "BasicMultiUrlPickerItem"
                                        name?: string | null
                                        target?: string | null
                                        type: LinkType
                                        url?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicNestedContent"
                                      model: string
                                      elements?: Array<{
                                        __typename?: "BasicNestedContentElement"
                                        properties: Array<{
                                          __typename?: "BasicProperty"
                                          alias?: string | null
                                          editorAlias?: string | null
                                          value?:
                                            | {
                                                __typename?: "BasicBlockGridModel"
                                                model: string
                                              }
                                            | {
                                                __typename?: "BasicBlockListModel"
                                                model: string
                                              }
                                            | {
                                                __typename?: "BasicContentPicker"
                                                model: string
                                                contentList: Array<{
                                                  __typename?: "BasicContentPickerItem"
                                                  id: number
                                                  absoluteUrl: string
                                                  key: any
                                                  name?: string | null
                                                  url: string
                                                  urlSegment?: string | null
                                                }>
                                              }
                                            | {
                                                __typename?: "BasicDateTimePicker"
                                                model: string
                                                dateTime?: any | null
                                              }
                                            | {
                                                __typename?: "BasicLabel"
                                                model: string
                                                label?: any | null
                                              }
                                            | {
                                                __typename?: "BasicMediaPicker"
                                                model: string
                                              }
                                            | {
                                                __typename?: "BasicMemberPicker"
                                                model: string
                                                members: Array<{
                                                  __typename?: "BasicMemberPickerItem"
                                                  id?: number | null
                                                  name?: string | null
                                                }>
                                              }
                                            | {
                                                __typename?: "BasicMultiUrlPicker"
                                                model: string
                                                links: Array<{
                                                  __typename?: "BasicMultiUrlPickerItem"
                                                  name?: string | null
                                                  target?: string | null
                                                  type: LinkType
                                                  url?: string | null
                                                }>
                                              }
                                            | {
                                                __typename?: "BasicNestedContent"
                                                model: string
                                              }
                                            | {
                                                __typename?: "BasicPropertyValue"
                                                model: string
                                                value?: any | null
                                              }
                                            | {
                                                __typename?: "BasicRichText"
                                                model: string
                                                richText?: string | null
                                              }
                                            | {
                                                __typename?: "BasicUnsupportedPropertyValue"
                                                model: string
                                                message: string
                                              }
                                            | {
                                                __typename?: "MintMediaPicker"
                                                model: string
                                                mediaItems: Array<{
                                                  __typename?: "MintMediaPickerItem"
                                                  id: number
                                                  url: string
                                                  altText?: string | null
                                                }>
                                              }
                                            | null
                                        } | null>
                                      }> | null
                                    }
                                  | {
                                      __typename?: "BasicPropertyValue"
                                      model: string
                                      value?: any | null
                                    }
                                  | {
                                      __typename?: "BasicRichText"
                                      model: string
                                      richText?: string | null
                                    }
                                  | {
                                      __typename?: "BasicUnsupportedPropertyValue"
                                      model: string
                                      message: string
                                    }
                                  | {
                                      __typename?: "MintMediaPicker"
                                      model: string
                                      mediaItems: Array<{
                                        __typename?: "MintMediaPickerItem"
                                        id: number
                                        url: string
                                        altText?: string | null
                                      }>
                                    }
                                  | null
                              } | null>
                            }>
                          }
                        | {
                            __typename?: "BasicMultiUrlPicker"
                            valueType: string
                            links: Array<{
                              __typename?: "BasicMultiUrlPickerItem"
                              name?: string | null
                              target?: string | null
                              type: LinkType
                              url?: string | null
                            }>
                          }
                        | {
                            __typename?: "BasicNestedContent"
                            valueType: string
                            elements?: Array<{
                              __typename?: "BasicNestedContentElement"
                              properties: Array<{
                                __typename?: "BasicProperty"
                                alias?: string | null
                                editorAlias?: string | null
                                value?:
                                  | {
                                      __typename?: "BasicBlockGridModel"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicBlockListModel"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicContentPicker"
                                      model: string
                                      contentList: Array<{
                                        __typename?: "BasicContentPickerItem"
                                        id: number
                                        absoluteUrl: string
                                        key: any
                                        name?: string | null
                                        url: string
                                        urlSegment?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicDateTimePicker"
                                      model: string
                                      dateTime?: any | null
                                    }
                                  | {
                                      __typename?: "BasicLabel"
                                      model: string
                                      label?: any | null
                                    }
                                  | {
                                      __typename?: "BasicMediaPicker"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicMemberPicker"
                                      model: string
                                      members: Array<{
                                        __typename?: "BasicMemberPickerItem"
                                        id?: number | null
                                        name?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicMultiUrlPicker"
                                      model: string
                                      links: Array<{
                                        __typename?: "BasicMultiUrlPickerItem"
                                        name?: string | null
                                        target?: string | null
                                        type: LinkType
                                        url?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicNestedContent"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicPropertyValue"
                                      model: string
                                      value?: any | null
                                    }
                                  | {
                                      __typename?: "BasicRichText"
                                      model: string
                                      richText?: string | null
                                    }
                                  | {
                                      __typename?: "BasicUnsupportedPropertyValue"
                                      model: string
                                      message: string
                                    }
                                  | {
                                      __typename?: "MintMediaPicker"
                                      model: string
                                      mediaItems: Array<{
                                        __typename?: "MintMediaPickerItem"
                                        id: number
                                        url: string
                                        altText?: string | null
                                      }>
                                    }
                                  | null
                              } | null>
                            }> | null
                          }
                        | {
                            __typename?: "BasicPropertyValue"
                            valueType: string
                            value?: any | null
                          }
                        | {
                            __typename?: "BasicRichText"
                            valueType: string
                            richText?: string | null
                          }
                        | {
                            __typename?: "BasicUnsupportedPropertyValue"
                            message: string
                            valueType: string
                          }
                        | {
                            __typename?: "MintMediaPicker"
                            valueType: string
                            mediaItems: Array<{
                              __typename?: "MintMediaPickerItem"
                              id: number
                              url: string
                              altText?: string | null
                            }>
                          }
                        | null
                    } | null>
                    settingsProperties: Array<{
                      __typename?: "BasicProperty"
                      value?:
                        | {
                            __typename?: "BasicBlockGridModel"
                            valueType: string
                          }
                        | {
                            __typename?: "BasicBlockListModel"
                            valueType: string
                          }
                        | {
                            __typename?: "BasicContentPicker"
                            valueType: string
                            contentList: Array<{
                              __typename?: "BasicContentPickerItem"
                              id: number
                              absoluteUrl: string
                              key: any
                              name?: string | null
                              url: string
                              urlSegment?: string | null
                            }>
                          }
                        | {
                            __typename?: "BasicDateTimePicker"
                            valueType: string
                            dateTime?: any | null
                          }
                        | {
                            __typename?: "BasicLabel"
                            valueType: string
                            label?: any | null
                          }
                        | { __typename?: "BasicMediaPicker"; valueType: string }
                        | {
                            __typename?: "BasicMemberPicker"
                            valueType: string
                            members: Array<{
                              __typename?: "BasicMemberPickerItem"
                              id?: number | null
                              name?: string | null
                              properties: Array<{
                                __typename?: "BasicProperty"
                                alias?: string | null
                                editorAlias?: string | null
                                value?:
                                  | {
                                      __typename?: "BasicBlockGridModel"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicBlockListModel"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicContentPicker"
                                      model: string
                                      contentList: Array<{
                                        __typename?: "BasicContentPickerItem"
                                        id: number
                                        absoluteUrl: string
                                        key: any
                                        name?: string | null
                                        url: string
                                        urlSegment?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicDateTimePicker"
                                      model: string
                                      dateTime?: any | null
                                    }
                                  | {
                                      __typename?: "BasicLabel"
                                      model: string
                                      label?: any | null
                                    }
                                  | {
                                      __typename?: "BasicMediaPicker"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicMemberPicker"
                                      model: string
                                      members: Array<{
                                        __typename?: "BasicMemberPickerItem"
                                        id?: number | null
                                        name?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicMultiUrlPicker"
                                      model: string
                                      links: Array<{
                                        __typename?: "BasicMultiUrlPickerItem"
                                        name?: string | null
                                        target?: string | null
                                        type: LinkType
                                        url?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicNestedContent"
                                      model: string
                                      elements?: Array<{
                                        __typename?: "BasicNestedContentElement"
                                        properties: Array<{
                                          __typename?: "BasicProperty"
                                          alias?: string | null
                                          editorAlias?: string | null
                                          value?:
                                            | {
                                                __typename?: "BasicBlockGridModel"
                                                model: string
                                              }
                                            | {
                                                __typename?: "BasicBlockListModel"
                                                model: string
                                              }
                                            | {
                                                __typename?: "BasicContentPicker"
                                                model: string
                                                contentList: Array<{
                                                  __typename?: "BasicContentPickerItem"
                                                  id: number
                                                  absoluteUrl: string
                                                  key: any
                                                  name?: string | null
                                                  url: string
                                                  urlSegment?: string | null
                                                }>
                                              }
                                            | {
                                                __typename?: "BasicDateTimePicker"
                                                model: string
                                                dateTime?: any | null
                                              }
                                            | {
                                                __typename?: "BasicLabel"
                                                model: string
                                                label?: any | null
                                              }
                                            | {
                                                __typename?: "BasicMediaPicker"
                                                model: string
                                              }
                                            | {
                                                __typename?: "BasicMemberPicker"
                                                model: string
                                                members: Array<{
                                                  __typename?: "BasicMemberPickerItem"
                                                  id?: number | null
                                                  name?: string | null
                                                }>
                                              }
                                            | {
                                                __typename?: "BasicMultiUrlPicker"
                                                model: string
                                                links: Array<{
                                                  __typename?: "BasicMultiUrlPickerItem"
                                                  name?: string | null
                                                  target?: string | null
                                                  type: LinkType
                                                  url?: string | null
                                                }>
                                              }
                                            | {
                                                __typename?: "BasicNestedContent"
                                                model: string
                                              }
                                            | {
                                                __typename?: "BasicPropertyValue"
                                                model: string
                                                value?: any | null
                                              }
                                            | {
                                                __typename?: "BasicRichText"
                                                model: string
                                                richText?: string | null
                                              }
                                            | {
                                                __typename?: "BasicUnsupportedPropertyValue"
                                                model: string
                                                message: string
                                              }
                                            | {
                                                __typename?: "MintMediaPicker"
                                                model: string
                                                mediaItems: Array<{
                                                  __typename?: "MintMediaPickerItem"
                                                  id: number
                                                  url: string
                                                  altText?: string | null
                                                }>
                                              }
                                            | null
                                        } | null>
                                      }> | null
                                    }
                                  | {
                                      __typename?: "BasicPropertyValue"
                                      model: string
                                      value?: any | null
                                    }
                                  | {
                                      __typename?: "BasicRichText"
                                      model: string
                                      richText?: string | null
                                    }
                                  | {
                                      __typename?: "BasicUnsupportedPropertyValue"
                                      model: string
                                      message: string
                                    }
                                  | {
                                      __typename?: "MintMediaPicker"
                                      model: string
                                      mediaItems: Array<{
                                        __typename?: "MintMediaPickerItem"
                                        id: number
                                        url: string
                                        altText?: string | null
                                      }>
                                    }
                                  | null
                              } | null>
                            }>
                          }
                        | {
                            __typename?: "BasicMultiUrlPicker"
                            valueType: string
                            links: Array<{
                              __typename?: "BasicMultiUrlPickerItem"
                              name?: string | null
                              target?: string | null
                              type: LinkType
                              url?: string | null
                            }>
                          }
                        | {
                            __typename?: "BasicNestedContent"
                            valueType: string
                            elements?: Array<{
                              __typename?: "BasicNestedContentElement"
                              properties: Array<{
                                __typename?: "BasicProperty"
                                alias?: string | null
                                editorAlias?: string | null
                                value?:
                                  | {
                                      __typename?: "BasicBlockGridModel"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicBlockListModel"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicContentPicker"
                                      model: string
                                      contentList: Array<{
                                        __typename?: "BasicContentPickerItem"
                                        id: number
                                        absoluteUrl: string
                                        key: any
                                        name?: string | null
                                        url: string
                                        urlSegment?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicDateTimePicker"
                                      model: string
                                      dateTime?: any | null
                                    }
                                  | {
                                      __typename?: "BasicLabel"
                                      model: string
                                      label?: any | null
                                    }
                                  | {
                                      __typename?: "BasicMediaPicker"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicMemberPicker"
                                      model: string
                                      members: Array<{
                                        __typename?: "BasicMemberPickerItem"
                                        id?: number | null
                                        name?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicMultiUrlPicker"
                                      model: string
                                      links: Array<{
                                        __typename?: "BasicMultiUrlPickerItem"
                                        name?: string | null
                                        target?: string | null
                                        type: LinkType
                                        url?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicNestedContent"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicPropertyValue"
                                      model: string
                                      value?: any | null
                                    }
                                  | {
                                      __typename?: "BasicRichText"
                                      model: string
                                      richText?: string | null
                                    }
                                  | {
                                      __typename?: "BasicUnsupportedPropertyValue"
                                      model: string
                                      message: string
                                    }
                                  | {
                                      __typename?: "MintMediaPicker"
                                      model: string
                                      mediaItems: Array<{
                                        __typename?: "MintMediaPickerItem"
                                        id: number
                                        url: string
                                        altText?: string | null
                                      }>
                                    }
                                  | null
                              } | null>
                            }> | null
                          }
                        | {
                            __typename?: "BasicPropertyValue"
                            valueType: string
                            value?: any | null
                          }
                        | {
                            __typename?: "BasicRichText"
                            valueType: string
                            richText?: string | null
                          }
                        | {
                            __typename?: "BasicUnsupportedPropertyValue"
                            message: string
                            valueType: string
                          }
                        | {
                            __typename?: "MintMediaPicker"
                            valueType: string
                            mediaItems: Array<{
                              __typename?: "MintMediaPickerItem"
                              id: number
                              url: string
                              altText?: string | null
                            }>
                          }
                        | null
                    } | null>
                    areas: Array<{
                      __typename?: "BasicBlockGridArea"
                      alias?: string | null
                      rowSpan: number
                      columnSpan: number
                      blocks?: Array<{
                        __typename?: "BasicBlockGridItem"
                        columnSpan: number
                        rowSpan: number
                        contentProperties: Array<{
                          __typename?: "BasicProperty"
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                valueType: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                valueType: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                valueType: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                valueType: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                valueType: string
                                label?: any | null
                              }
                            | {
                                __typename?: "BasicMediaPicker"
                                valueType: string
                              }
                            | {
                                __typename?: "BasicMemberPicker"
                                valueType: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    alias?: string | null
                                    editorAlias?: string | null
                                    value?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          model: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          model: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          model: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          model: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          model: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          model: string
                                          elements?: Array<{
                                            __typename?: "BasicNestedContentElement"
                                            properties: Array<{
                                              __typename?: "BasicProperty"
                                              alias?: string | null
                                              editorAlias?: string | null
                                              value?:
                                                | {
                                                    __typename?: "BasicBlockGridModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicBlockListModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicContentPicker"
                                                    model: string
                                                    contentList: Array<{
                                                      __typename?: "BasicContentPickerItem"
                                                      id: number
                                                      absoluteUrl: string
                                                      key: any
                                                      name?: string | null
                                                      url: string
                                                      urlSegment?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicDateTimePicker"
                                                    model: string
                                                    dateTime?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicLabel"
                                                    model: string
                                                    label?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicMediaPicker"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicMemberPicker"
                                                    model: string
                                                    members: Array<{
                                                      __typename?: "BasicMemberPickerItem"
                                                      id?: number | null
                                                      name?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicMultiUrlPicker"
                                                    model: string
                                                    links: Array<{
                                                      __typename?: "BasicMultiUrlPickerItem"
                                                      name?: string | null
                                                      target?: string | null
                                                      type: LinkType
                                                      url?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicNestedContent"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicPropertyValue"
                                                    model: string
                                                    value?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicRichText"
                                                    model: string
                                                    richText?: string | null
                                                  }
                                                | {
                                                    __typename?: "BasicUnsupportedPropertyValue"
                                                    model: string
                                                    message: string
                                                  }
                                                | {
                                                    __typename?: "MintMediaPicker"
                                                    model: string
                                                    mediaItems: Array<{
                                                      __typename?: "MintMediaPickerItem"
                                                      id: number
                                                      url: string
                                                      altText?: string | null
                                                    }>
                                                  }
                                                | null
                                            } | null>
                                          }> | null
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          model: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          model: string
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          model: string
                                          message: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          model: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                valueType: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                valueType: string
                                elements?: Array<{
                                  __typename?: "BasicNestedContentElement"
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    alias?: string | null
                                    editorAlias?: string | null
                                    value?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          model: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          model: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          model: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          model: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          model: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          model: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          model: string
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          model: string
                                          message: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          model: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }> | null
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                valueType: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                valueType: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                message: string
                                valueType: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                valueType: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                        settingsProperties: Array<{
                          __typename?: "BasicProperty"
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                valueType: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                valueType: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                valueType: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                valueType: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                valueType: string
                                label?: any | null
                              }
                            | {
                                __typename?: "BasicMediaPicker"
                                valueType: string
                              }
                            | {
                                __typename?: "BasicMemberPicker"
                                valueType: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    alias?: string | null
                                    editorAlias?: string | null
                                    value?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          model: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          model: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          model: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          model: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          model: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          model: string
                                          elements?: Array<{
                                            __typename?: "BasicNestedContentElement"
                                            properties: Array<{
                                              __typename?: "BasicProperty"
                                              alias?: string | null
                                              editorAlias?: string | null
                                              value?:
                                                | {
                                                    __typename?: "BasicBlockGridModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicBlockListModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicContentPicker"
                                                    model: string
                                                    contentList: Array<{
                                                      __typename?: "BasicContentPickerItem"
                                                      id: number
                                                      absoluteUrl: string
                                                      key: any
                                                      name?: string | null
                                                      url: string
                                                      urlSegment?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicDateTimePicker"
                                                    model: string
                                                    dateTime?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicLabel"
                                                    model: string
                                                    label?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicMediaPicker"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicMemberPicker"
                                                    model: string
                                                    members: Array<{
                                                      __typename?: "BasicMemberPickerItem"
                                                      id?: number | null
                                                      name?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicMultiUrlPicker"
                                                    model: string
                                                    links: Array<{
                                                      __typename?: "BasicMultiUrlPickerItem"
                                                      name?: string | null
                                                      target?: string | null
                                                      type: LinkType
                                                      url?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicNestedContent"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicPropertyValue"
                                                    model: string
                                                    value?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicRichText"
                                                    model: string
                                                    richText?: string | null
                                                  }
                                                | {
                                                    __typename?: "BasicUnsupportedPropertyValue"
                                                    model: string
                                                    message: string
                                                  }
                                                | {
                                                    __typename?: "MintMediaPicker"
                                                    model: string
                                                    mediaItems: Array<{
                                                      __typename?: "MintMediaPickerItem"
                                                      id: number
                                                      url: string
                                                      altText?: string | null
                                                    }>
                                                  }
                                                | null
                                            } | null>
                                          }> | null
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          model: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          model: string
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          model: string
                                          message: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          model: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                valueType: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                valueType: string
                                elements?: Array<{
                                  __typename?: "BasicNestedContentElement"
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    alias?: string | null
                                    editorAlias?: string | null
                                    value?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          model: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          model: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          model: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          model: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          model: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          model: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          model: string
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          model: string
                                          message: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          model: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }> | null
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                valueType: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                valueType: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                message: string
                                valueType: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                valueType: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                        areas: Array<{
                          __typename?: "BasicBlockGridArea"
                          alias?: string | null
                          rowSpan: number
                          columnSpan: number
                        } | null>
                      }> | null
                    } | null>
                  }> | null
                }
              | {
                  __typename?: "BasicBlockListModel"
                  valueType: string
                  blocks?: Array<{
                    __typename?: "BasicBlockListItem"
                    blockType?: string | null
                    properties: Array<{
                      __typename?: "BasicProperty"
                      propertyName?: string | null
                      propertyValue?:
                        | {
                            __typename?: "BasicBlockGridModel"
                            valueType: string
                          }
                        | {
                            __typename?: "BasicBlockListModel"
                            valueType: string
                            blocks?: Array<{
                              __typename?: "BasicBlockListItem"
                              blockType?: string | null
                              properties: Array<{
                                __typename?: "BasicProperty"
                                propertyName?: string | null
                                propertyValue?:
                                  | {
                                      __typename?: "BasicBlockGridModel"
                                      valueType: string
                                    }
                                  | {
                                      __typename?: "BasicBlockListModel"
                                      valueType: string
                                      blocks?: Array<{
                                        __typename?: "BasicBlockListItem"
                                        blockType?: string | null
                                        properties: Array<{
                                          __typename?: "BasicProperty"
                                          propertyName?: string | null
                                          propertyValue?:
                                            | {
                                                __typename?: "BasicBlockGridModel"
                                                valueType: string
                                              }
                                            | {
                                                __typename?: "BasicBlockListModel"
                                                valueType: string
                                                blocks?: Array<{
                                                  __typename?: "BasicBlockListItem"
                                                  blockType?: string | null
                                                  properties: Array<{
                                                    __typename?: "BasicProperty"
                                                    propertyName?: string | null
                                                    propertyValue?:
                                                      | {
                                                          __typename?: "BasicBlockGridModel"
                                                          valueType: string
                                                        }
                                                      | {
                                                          __typename?: "BasicBlockListModel"
                                                          valueType: string
                                                          blocks?: Array<{
                                                            __typename?: "BasicBlockListItem"
                                                            blockType?:
                                                              | string
                                                              | null
                                                            properties: Array<{
                                                              __typename?: "BasicProperty"
                                                              propertyName?:
                                                                | string
                                                                | null
                                                              propertyValue?:
                                                                | {
                                                                    __typename?: "BasicBlockGridModel"
                                                                    valueType: string
                                                                  }
                                                                | {
                                                                    __typename?: "BasicBlockListModel"
                                                                    valueType: string
                                                                  }
                                                                | {
                                                                    __typename?: "BasicContentPicker"
                                                                    valueType: string
                                                                    contentList: Array<{
                                                                      __typename?: "BasicContentPickerItem"
                                                                      id: number
                                                                      absoluteUrl: string
                                                                      key: any
                                                                      name?:
                                                                        | string
                                                                        | null
                                                                      url: string
                                                                      urlSegment?:
                                                                        | string
                                                                        | null
                                                                    }>
                                                                  }
                                                                | {
                                                                    __typename?: "BasicDateTimePicker"
                                                                    valueType: string
                                                                    dateTime?:
                                                                      | any
                                                                      | null
                                                                  }
                                                                | {
                                                                    __typename?: "BasicLabel"
                                                                    valueType: string
                                                                    label?:
                                                                      | any
                                                                      | null
                                                                  }
                                                                | {
                                                                    __typename?: "BasicMediaPicker"
                                                                    valueType: string
                                                                  }
                                                                | {
                                                                    __typename?: "BasicMemberPicker"
                                                                    valueType: string
                                                                    members: Array<{
                                                                      __typename?: "BasicMemberPickerItem"
                                                                      id?:
                                                                        | number
                                                                        | null
                                                                      name?:
                                                                        | string
                                                                        | null
                                                                      properties: Array<{
                                                                        __typename?: "BasicProperty"
                                                                        alias?:
                                                                          | string
                                                                          | null
                                                                        editorAlias?:
                                                                          | string
                                                                          | null
                                                                        value?:
                                                                          | {
                                                                              __typename?: "BasicBlockGridModel"
                                                                              model: string
                                                                            }
                                                                          | {
                                                                              __typename?: "BasicBlockListModel"
                                                                              model: string
                                                                            }
                                                                          | {
                                                                              __typename?: "BasicContentPicker"
                                                                              model: string
                                                                              contentList: Array<{
                                                                                __typename?: "BasicContentPickerItem"
                                                                                id: number
                                                                                absoluteUrl: string
                                                                                key: any
                                                                                name?:
                                                                                  | string
                                                                                  | null
                                                                                url: string
                                                                                urlSegment?:
                                                                                  | string
                                                                                  | null
                                                                              }>
                                                                            }
                                                                          | {
                                                                              __typename?: "BasicDateTimePicker"
                                                                              model: string
                                                                              dateTime?:
                                                                                | any
                                                                                | null
                                                                            }
                                                                          | {
                                                                              __typename?: "BasicLabel"
                                                                              model: string
                                                                              label?:
                                                                                | any
                                                                                | null
                                                                            }
                                                                          | {
                                                                              __typename?: "BasicMediaPicker"
                                                                              model: string
                                                                            }
                                                                          | {
                                                                              __typename?: "BasicMemberPicker"
                                                                              model: string
                                                                              members: Array<{
                                                                                __typename?: "BasicMemberPickerItem"
                                                                                id?:
                                                                                  | number
                                                                                  | null
                                                                                name?:
                                                                                  | string
                                                                                  | null
                                                                              }>
                                                                            }
                                                                          | {
                                                                              __typename?: "BasicMultiUrlPicker"
                                                                              model: string
                                                                              links: Array<{
                                                                                __typename?: "BasicMultiUrlPickerItem"
                                                                                name?:
                                                                                  | string
                                                                                  | null
                                                                                target?:
                                                                                  | string
                                                                                  | null
                                                                                type: LinkType
                                                                                url?:
                                                                                  | string
                                                                                  | null
                                                                              }>
                                                                            }
                                                                          | {
                                                                              __typename?: "BasicNestedContent"
                                                                              model: string
                                                                              elements?: Array<{
                                                                                __typename?: "BasicNestedContentElement"
                                                                                properties: Array<{
                                                                                  __typename?: "BasicProperty"
                                                                                  alias?:
                                                                                    | string
                                                                                    | null
                                                                                  editorAlias?:
                                                                                    | string
                                                                                    | null
                                                                                  value?:
                                                                                    | {
                                                                                        __typename?: "BasicBlockGridModel"
                                                                                        model: string
                                                                                      }
                                                                                    | {
                                                                                        __typename?: "BasicBlockListModel"
                                                                                        model: string
                                                                                      }
                                                                                    | {
                                                                                        __typename?: "BasicContentPicker"
                                                                                        model: string
                                                                                        contentList: Array<{
                                                                                          __typename?: "BasicContentPickerItem"
                                                                                          id: number
                                                                                          absoluteUrl: string
                                                                                          key: any
                                                                                          name?:
                                                                                            | string
                                                                                            | null
                                                                                          url: string
                                                                                          urlSegment?:
                                                                                            | string
                                                                                            | null
                                                                                        }>
                                                                                      }
                                                                                    | {
                                                                                        __typename?: "BasicDateTimePicker"
                                                                                        model: string
                                                                                        dateTime?:
                                                                                          | any
                                                                                          | null
                                                                                      }
                                                                                    | {
                                                                                        __typename?: "BasicLabel"
                                                                                        model: string
                                                                                        label?:
                                                                                          | any
                                                                                          | null
                                                                                      }
                                                                                    | {
                                                                                        __typename?: "BasicMediaPicker"
                                                                                        model: string
                                                                                      }
                                                                                    | {
                                                                                        __typename?: "BasicMemberPicker"
                                                                                        model: string
                                                                                        members: Array<{
                                                                                          __typename?: "BasicMemberPickerItem"
                                                                                          id?:
                                                                                            | number
                                                                                            | null
                                                                                          name?:
                                                                                            | string
                                                                                            | null
                                                                                        }>
                                                                                      }
                                                                                    | {
                                                                                        __typename?: "BasicMultiUrlPicker"
                                                                                        model: string
                                                                                        links: Array<{
                                                                                          __typename?: "BasicMultiUrlPickerItem"
                                                                                          name?:
                                                                                            | string
                                                                                            | null
                                                                                          target?:
                                                                                            | string
                                                                                            | null
                                                                                          type: LinkType
                                                                                          url?:
                                                                                            | string
                                                                                            | null
                                                                                        }>
                                                                                      }
                                                                                    | {
                                                                                        __typename?: "BasicNestedContent"
                                                                                        model: string
                                                                                      }
                                                                                    | {
                                                                                        __typename?: "BasicPropertyValue"
                                                                                        model: string
                                                                                        value?:
                                                                                          | any
                                                                                          | null
                                                                                      }
                                                                                    | {
                                                                                        __typename?: "BasicRichText"
                                                                                        model: string
                                                                                        richText?:
                                                                                          | string
                                                                                          | null
                                                                                      }
                                                                                    | {
                                                                                        __typename?: "BasicUnsupportedPropertyValue"
                                                                                        model: string
                                                                                        message: string
                                                                                      }
                                                                                    | {
                                                                                        __typename?: "MintMediaPicker"
                                                                                        model: string
                                                                                        mediaItems: Array<{
                                                                                          __typename?: "MintMediaPickerItem"
                                                                                          id: number
                                                                                          url: string
                                                                                          altText?:
                                                                                            | string
                                                                                            | null
                                                                                        }>
                                                                                      }
                                                                                    | null
                                                                                } | null>
                                                                              }> | null
                                                                            }
                                                                          | {
                                                                              __typename?: "BasicPropertyValue"
                                                                              model: string
                                                                              value?:
                                                                                | any
                                                                                | null
                                                                            }
                                                                          | {
                                                                              __typename?: "BasicRichText"
                                                                              model: string
                                                                              richText?:
                                                                                | string
                                                                                | null
                                                                            }
                                                                          | {
                                                                              __typename?: "BasicUnsupportedPropertyValue"
                                                                              model: string
                                                                              message: string
                                                                            }
                                                                          | {
                                                                              __typename?: "MintMediaPicker"
                                                                              model: string
                                                                              mediaItems: Array<{
                                                                                __typename?: "MintMediaPickerItem"
                                                                                id: number
                                                                                url: string
                                                                                altText?:
                                                                                  | string
                                                                                  | null
                                                                              }>
                                                                            }
                                                                          | null
                                                                      } | null>
                                                                    }>
                                                                  }
                                                                | {
                                                                    __typename?: "BasicMultiUrlPicker"
                                                                    valueType: string
                                                                    links: Array<{
                                                                      __typename?: "BasicMultiUrlPickerItem"
                                                                      name?:
                                                                        | string
                                                                        | null
                                                                      target?:
                                                                        | string
                                                                        | null
                                                                      type: LinkType
                                                                      url?:
                                                                        | string
                                                                        | null
                                                                    }>
                                                                  }
                                                                | {
                                                                    __typename?: "BasicNestedContent"
                                                                    valueType: string
                                                                    elements?: Array<{
                                                                      __typename?: "BasicNestedContentElement"
                                                                      properties: Array<{
                                                                        __typename?: "BasicProperty"
                                                                        alias?:
                                                                          | string
                                                                          | null
                                                                        editorAlias?:
                                                                          | string
                                                                          | null
                                                                        value?:
                                                                          | {
                                                                              __typename?: "BasicBlockGridModel"
                                                                              model: string
                                                                            }
                                                                          | {
                                                                              __typename?: "BasicBlockListModel"
                                                                              model: string
                                                                            }
                                                                          | {
                                                                              __typename?: "BasicContentPicker"
                                                                              model: string
                                                                              contentList: Array<{
                                                                                __typename?: "BasicContentPickerItem"
                                                                                id: number
                                                                                absoluteUrl: string
                                                                                key: any
                                                                                name?:
                                                                                  | string
                                                                                  | null
                                                                                url: string
                                                                                urlSegment?:
                                                                                  | string
                                                                                  | null
                                                                              }>
                                                                            }
                                                                          | {
                                                                              __typename?: "BasicDateTimePicker"
                                                                              model: string
                                                                              dateTime?:
                                                                                | any
                                                                                | null
                                                                            }
                                                                          | {
                                                                              __typename?: "BasicLabel"
                                                                              model: string
                                                                              label?:
                                                                                | any
                                                                                | null
                                                                            }
                                                                          | {
                                                                              __typename?: "BasicMediaPicker"
                                                                              model: string
                                                                            }
                                                                          | {
                                                                              __typename?: "BasicMemberPicker"
                                                                              model: string
                                                                              members: Array<{
                                                                                __typename?: "BasicMemberPickerItem"
                                                                                id?:
                                                                                  | number
                                                                                  | null
                                                                                name?:
                                                                                  | string
                                                                                  | null
                                                                              }>
                                                                            }
                                                                          | {
                                                                              __typename?: "BasicMultiUrlPicker"
                                                                              model: string
                                                                              links: Array<{
                                                                                __typename?: "BasicMultiUrlPickerItem"
                                                                                name?:
                                                                                  | string
                                                                                  | null
                                                                                target?:
                                                                                  | string
                                                                                  | null
                                                                                type: LinkType
                                                                                url?:
                                                                                  | string
                                                                                  | null
                                                                              }>
                                                                            }
                                                                          | {
                                                                              __typename?: "BasicNestedContent"
                                                                              model: string
                                                                            }
                                                                          | {
                                                                              __typename?: "BasicPropertyValue"
                                                                              model: string
                                                                              value?:
                                                                                | any
                                                                                | null
                                                                            }
                                                                          | {
                                                                              __typename?: "BasicRichText"
                                                                              model: string
                                                                              richText?:
                                                                                | string
                                                                                | null
                                                                            }
                                                                          | {
                                                                              __typename?: "BasicUnsupportedPropertyValue"
                                                                              model: string
                                                                              message: string
                                                                            }
                                                                          | {
                                                                              __typename?: "MintMediaPicker"
                                                                              model: string
                                                                              mediaItems: Array<{
                                                                                __typename?: "MintMediaPickerItem"
                                                                                id: number
                                                                                url: string
                                                                                altText?:
                                                                                  | string
                                                                                  | null
                                                                              }>
                                                                            }
                                                                          | null
                                                                      } | null>
                                                                    }> | null
                                                                  }
                                                                | {
                                                                    __typename?: "BasicPropertyValue"
                                                                    valueType: string
                                                                    value?:
                                                                      | any
                                                                      | null
                                                                  }
                                                                | {
                                                                    __typename?: "BasicRichText"
                                                                    valueType: string
                                                                    richText?:
                                                                      | string
                                                                      | null
                                                                  }
                                                                | {
                                                                    __typename?: "BasicUnsupportedPropertyValue"
                                                                    message: string
                                                                    valueType: string
                                                                  }
                                                                | {
                                                                    __typename?: "MintMediaPicker"
                                                                    valueType: string
                                                                    mediaItems: Array<{
                                                                      __typename?: "MintMediaPickerItem"
                                                                      id: number
                                                                      url: string
                                                                      altText?:
                                                                        | string
                                                                        | null
                                                                    }>
                                                                  }
                                                                | null
                                                            } | null>
                                                          }> | null
                                                        }
                                                      | {
                                                          __typename?: "BasicContentPicker"
                                                          valueType: string
                                                          contentList: Array<{
                                                            __typename?: "BasicContentPickerItem"
                                                            id: number
                                                            absoluteUrl: string
                                                            key: any
                                                            name?: string | null
                                                            url: string
                                                            urlSegment?:
                                                              | string
                                                              | null
                                                          }>
                                                        }
                                                      | {
                                                          __typename?: "BasicDateTimePicker"
                                                          valueType: string
                                                          dateTime?: any | null
                                                        }
                                                      | {
                                                          __typename?: "BasicLabel"
                                                          valueType: string
                                                          label?: any | null
                                                        }
                                                      | {
                                                          __typename?: "BasicMediaPicker"
                                                          valueType: string
                                                        }
                                                      | {
                                                          __typename?: "BasicMemberPicker"
                                                          valueType: string
                                                          members: Array<{
                                                            __typename?: "BasicMemberPickerItem"
                                                            id?: number | null
                                                            name?: string | null
                                                            properties: Array<{
                                                              __typename?: "BasicProperty"
                                                              alias?:
                                                                | string
                                                                | null
                                                              editorAlias?:
                                                                | string
                                                                | null
                                                              value?:
                                                                | {
                                                                    __typename?: "BasicBlockGridModel"
                                                                    model: string
                                                                  }
                                                                | {
                                                                    __typename?: "BasicBlockListModel"
                                                                    model: string
                                                                  }
                                                                | {
                                                                    __typename?: "BasicContentPicker"
                                                                    model: string
                                                                    contentList: Array<{
                                                                      __typename?: "BasicContentPickerItem"
                                                                      id: number
                                                                      absoluteUrl: string
                                                                      key: any
                                                                      name?:
                                                                        | string
                                                                        | null
                                                                      url: string
                                                                      urlSegment?:
                                                                        | string
                                                                        | null
                                                                    }>
                                                                  }
                                                                | {
                                                                    __typename?: "BasicDateTimePicker"
                                                                    model: string
                                                                    dateTime?:
                                                                      | any
                                                                      | null
                                                                  }
                                                                | {
                                                                    __typename?: "BasicLabel"
                                                                    model: string
                                                                    label?:
                                                                      | any
                                                                      | null
                                                                  }
                                                                | {
                                                                    __typename?: "BasicMediaPicker"
                                                                    model: string
                                                                  }
                                                                | {
                                                                    __typename?: "BasicMemberPicker"
                                                                    model: string
                                                                    members: Array<{
                                                                      __typename?: "BasicMemberPickerItem"
                                                                      id?:
                                                                        | number
                                                                        | null
                                                                      name?:
                                                                        | string
                                                                        | null
                                                                    }>
                                                                  }
                                                                | {
                                                                    __typename?: "BasicMultiUrlPicker"
                                                                    model: string
                                                                    links: Array<{
                                                                      __typename?: "BasicMultiUrlPickerItem"
                                                                      name?:
                                                                        | string
                                                                        | null
                                                                      target?:
                                                                        | string
                                                                        | null
                                                                      type: LinkType
                                                                      url?:
                                                                        | string
                                                                        | null
                                                                    }>
                                                                  }
                                                                | {
                                                                    __typename?: "BasicNestedContent"
                                                                    model: string
                                                                    elements?: Array<{
                                                                      __typename?: "BasicNestedContentElement"
                                                                      properties: Array<{
                                                                        __typename?: "BasicProperty"
                                                                        alias?:
                                                                          | string
                                                                          | null
                                                                        editorAlias?:
                                                                          | string
                                                                          | null
                                                                        value?:
                                                                          | {
                                                                              __typename?: "BasicBlockGridModel"
                                                                              model: string
                                                                            }
                                                                          | {
                                                                              __typename?: "BasicBlockListModel"
                                                                              model: string
                                                                            }
                                                                          | {
                                                                              __typename?: "BasicContentPicker"
                                                                              model: string
                                                                              contentList: Array<{
                                                                                __typename?: "BasicContentPickerItem"
                                                                                id: number
                                                                                absoluteUrl: string
                                                                                key: any
                                                                                name?:
                                                                                  | string
                                                                                  | null
                                                                                url: string
                                                                                urlSegment?:
                                                                                  | string
                                                                                  | null
                                                                              }>
                                                                            }
                                                                          | {
                                                                              __typename?: "BasicDateTimePicker"
                                                                              model: string
                                                                              dateTime?:
                                                                                | any
                                                                                | null
                                                                            }
                                                                          | {
                                                                              __typename?: "BasicLabel"
                                                                              model: string
                                                                              label?:
                                                                                | any
                                                                                | null
                                                                            }
                                                                          | {
                                                                              __typename?: "BasicMediaPicker"
                                                                              model: string
                                                                            }
                                                                          | {
                                                                              __typename?: "BasicMemberPicker"
                                                                              model: string
                                                                              members: Array<{
                                                                                __typename?: "BasicMemberPickerItem"
                                                                                id?:
                                                                                  | number
                                                                                  | null
                                                                                name?:
                                                                                  | string
                                                                                  | null
                                                                              }>
                                                                            }
                                                                          | {
                                                                              __typename?: "BasicMultiUrlPicker"
                                                                              model: string
                                                                              links: Array<{
                                                                                __typename?: "BasicMultiUrlPickerItem"
                                                                                name?:
                                                                                  | string
                                                                                  | null
                                                                                target?:
                                                                                  | string
                                                                                  | null
                                                                                type: LinkType
                                                                                url?:
                                                                                  | string
                                                                                  | null
                                                                              }>
                                                                            }
                                                                          | {
                                                                              __typename?: "BasicNestedContent"
                                                                              model: string
                                                                            }
                                                                          | {
                                                                              __typename?: "BasicPropertyValue"
                                                                              model: string
                                                                              value?:
                                                                                | any
                                                                                | null
                                                                            }
                                                                          | {
                                                                              __typename?: "BasicRichText"
                                                                              model: string
                                                                              richText?:
                                                                                | string
                                                                                | null
                                                                            }
                                                                          | {
                                                                              __typename?: "BasicUnsupportedPropertyValue"
                                                                              model: string
                                                                              message: string
                                                                            }
                                                                          | {
                                                                              __typename?: "MintMediaPicker"
                                                                              model: string
                                                                              mediaItems: Array<{
                                                                                __typename?: "MintMediaPickerItem"
                                                                                id: number
                                                                                url: string
                                                                                altText?:
                                                                                  | string
                                                                                  | null
                                                                              }>
                                                                            }
                                                                          | null
                                                                      } | null>
                                                                    }> | null
                                                                  }
                                                                | {
                                                                    __typename?: "BasicPropertyValue"
                                                                    model: string
                                                                    value?:
                                                                      | any
                                                                      | null
                                                                  }
                                                                | {
                                                                    __typename?: "BasicRichText"
                                                                    model: string
                                                                    richText?:
                                                                      | string
                                                                      | null
                                                                  }
                                                                | {
                                                                    __typename?: "BasicUnsupportedPropertyValue"
                                                                    model: string
                                                                    message: string
                                                                  }
                                                                | {
                                                                    __typename?: "MintMediaPicker"
                                                                    model: string
                                                                    mediaItems: Array<{
                                                                      __typename?: "MintMediaPickerItem"
                                                                      id: number
                                                                      url: string
                                                                      altText?:
                                                                        | string
                                                                        | null
                                                                    }>
                                                                  }
                                                                | null
                                                            } | null>
                                                          }>
                                                        }
                                                      | {
                                                          __typename?: "BasicMultiUrlPicker"
                                                          valueType: string
                                                          links: Array<{
                                                            __typename?: "BasicMultiUrlPickerItem"
                                                            name?: string | null
                                                            target?:
                                                              | string
                                                              | null
                                                            type: LinkType
                                                            url?: string | null
                                                          }>
                                                        }
                                                      | {
                                                          __typename?: "BasicNestedContent"
                                                          valueType: string
                                                          elements?: Array<{
                                                            __typename?: "BasicNestedContentElement"
                                                            properties: Array<{
                                                              __typename?: "BasicProperty"
                                                              alias?:
                                                                | string
                                                                | null
                                                              editorAlias?:
                                                                | string
                                                                | null
                                                              value?:
                                                                | {
                                                                    __typename?: "BasicBlockGridModel"
                                                                    model: string
                                                                  }
                                                                | {
                                                                    __typename?: "BasicBlockListModel"
                                                                    model: string
                                                                  }
                                                                | {
                                                                    __typename?: "BasicContentPicker"
                                                                    model: string
                                                                    contentList: Array<{
                                                                      __typename?: "BasicContentPickerItem"
                                                                      id: number
                                                                      absoluteUrl: string
                                                                      key: any
                                                                      name?:
                                                                        | string
                                                                        | null
                                                                      url: string
                                                                      urlSegment?:
                                                                        | string
                                                                        | null
                                                                    }>
                                                                  }
                                                                | {
                                                                    __typename?: "BasicDateTimePicker"
                                                                    model: string
                                                                    dateTime?:
                                                                      | any
                                                                      | null
                                                                  }
                                                                | {
                                                                    __typename?: "BasicLabel"
                                                                    model: string
                                                                    label?:
                                                                      | any
                                                                      | null
                                                                  }
                                                                | {
                                                                    __typename?: "BasicMediaPicker"
                                                                    model: string
                                                                  }
                                                                | {
                                                                    __typename?: "BasicMemberPicker"
                                                                    model: string
                                                                    members: Array<{
                                                                      __typename?: "BasicMemberPickerItem"
                                                                      id?:
                                                                        | number
                                                                        | null
                                                                      name?:
                                                                        | string
                                                                        | null
                                                                    }>
                                                                  }
                                                                | {
                                                                    __typename?: "BasicMultiUrlPicker"
                                                                    model: string
                                                                    links: Array<{
                                                                      __typename?: "BasicMultiUrlPickerItem"
                                                                      name?:
                                                                        | string
                                                                        | null
                                                                      target?:
                                                                        | string
                                                                        | null
                                                                      type: LinkType
                                                                      url?:
                                                                        | string
                                                                        | null
                                                                    }>
                                                                  }
                                                                | {
                                                                    __typename?: "BasicNestedContent"
                                                                    model: string
                                                                  }
                                                                | {
                                                                    __typename?: "BasicPropertyValue"
                                                                    model: string
                                                                    value?:
                                                                      | any
                                                                      | null
                                                                  }
                                                                | {
                                                                    __typename?: "BasicRichText"
                                                                    model: string
                                                                    richText?:
                                                                      | string
                                                                      | null
                                                                  }
                                                                | {
                                                                    __typename?: "BasicUnsupportedPropertyValue"
                                                                    model: string
                                                                    message: string
                                                                  }
                                                                | {
                                                                    __typename?: "MintMediaPicker"
                                                                    model: string
                                                                    mediaItems: Array<{
                                                                      __typename?: "MintMediaPickerItem"
                                                                      id: number
                                                                      url: string
                                                                      altText?:
                                                                        | string
                                                                        | null
                                                                    }>
                                                                  }
                                                                | null
                                                            } | null>
                                                          }> | null
                                                        }
                                                      | {
                                                          __typename?: "BasicPropertyValue"
                                                          valueType: string
                                                          value?: any | null
                                                        }
                                                      | {
                                                          __typename?: "BasicRichText"
                                                          valueType: string
                                                          richText?:
                                                            | string
                                                            | null
                                                        }
                                                      | {
                                                          __typename?: "BasicUnsupportedPropertyValue"
                                                          message: string
                                                          valueType: string
                                                        }
                                                      | {
                                                          __typename?: "MintMediaPicker"
                                                          valueType: string
                                                          mediaItems: Array<{
                                                            __typename?: "MintMediaPickerItem"
                                                            id: number
                                                            url: string
                                                            altText?:
                                                              | string
                                                              | null
                                                          }>
                                                        }
                                                      | null
                                                  } | null>
                                                }> | null
                                              }
                                            | {
                                                __typename?: "BasicContentPicker"
                                                valueType: string
                                                contentList: Array<{
                                                  __typename?: "BasicContentPickerItem"
                                                  id: number
                                                  absoluteUrl: string
                                                  key: any
                                                  name?: string | null
                                                  url: string
                                                  urlSegment?: string | null
                                                }>
                                              }
                                            | {
                                                __typename?: "BasicDateTimePicker"
                                                valueType: string
                                                dateTime?: any | null
                                              }
                                            | {
                                                __typename?: "BasicLabel"
                                                valueType: string
                                                label?: any | null
                                              }
                                            | {
                                                __typename?: "BasicMediaPicker"
                                                valueType: string
                                              }
                                            | {
                                                __typename?: "BasicMemberPicker"
                                                valueType: string
                                                members: Array<{
                                                  __typename?: "BasicMemberPickerItem"
                                                  id?: number | null
                                                  name?: string | null
                                                  properties: Array<{
                                                    __typename?: "BasicProperty"
                                                    alias?: string | null
                                                    editorAlias?: string | null
                                                    value?:
                                                      | {
                                                          __typename?: "BasicBlockGridModel"
                                                          model: string
                                                        }
                                                      | {
                                                          __typename?: "BasicBlockListModel"
                                                          model: string
                                                        }
                                                      | {
                                                          __typename?: "BasicContentPicker"
                                                          model: string
                                                          contentList: Array<{
                                                            __typename?: "BasicContentPickerItem"
                                                            id: number
                                                            absoluteUrl: string
                                                            key: any
                                                            name?: string | null
                                                            url: string
                                                            urlSegment?:
                                                              | string
                                                              | null
                                                          }>
                                                        }
                                                      | {
                                                          __typename?: "BasicDateTimePicker"
                                                          model: string
                                                          dateTime?: any | null
                                                        }
                                                      | {
                                                          __typename?: "BasicLabel"
                                                          model: string
                                                          label?: any | null
                                                        }
                                                      | {
                                                          __typename?: "BasicMediaPicker"
                                                          model: string
                                                        }
                                                      | {
                                                          __typename?: "BasicMemberPicker"
                                                          model: string
                                                          members: Array<{
                                                            __typename?: "BasicMemberPickerItem"
                                                            id?: number | null
                                                            name?: string | null
                                                          }>
                                                        }
                                                      | {
                                                          __typename?: "BasicMultiUrlPicker"
                                                          model: string
                                                          links: Array<{
                                                            __typename?: "BasicMultiUrlPickerItem"
                                                            name?: string | null
                                                            target?:
                                                              | string
                                                              | null
                                                            type: LinkType
                                                            url?: string | null
                                                          }>
                                                        }
                                                      | {
                                                          __typename?: "BasicNestedContent"
                                                          model: string
                                                          elements?: Array<{
                                                            __typename?: "BasicNestedContentElement"
                                                            properties: Array<{
                                                              __typename?: "BasicProperty"
                                                              alias?:
                                                                | string
                                                                | null
                                                              editorAlias?:
                                                                | string
                                                                | null
                                                              value?:
                                                                | {
                                                                    __typename?: "BasicBlockGridModel"
                                                                    model: string
                                                                  }
                                                                | {
                                                                    __typename?: "BasicBlockListModel"
                                                                    model: string
                                                                  }
                                                                | {
                                                                    __typename?: "BasicContentPicker"
                                                                    model: string
                                                                    contentList: Array<{
                                                                      __typename?: "BasicContentPickerItem"
                                                                      id: number
                                                                      absoluteUrl: string
                                                                      key: any
                                                                      name?:
                                                                        | string
                                                                        | null
                                                                      url: string
                                                                      urlSegment?:
                                                                        | string
                                                                        | null
                                                                    }>
                                                                  }
                                                                | {
                                                                    __typename?: "BasicDateTimePicker"
                                                                    model: string
                                                                    dateTime?:
                                                                      | any
                                                                      | null
                                                                  }
                                                                | {
                                                                    __typename?: "BasicLabel"
                                                                    model: string
                                                                    label?:
                                                                      | any
                                                                      | null
                                                                  }
                                                                | {
                                                                    __typename?: "BasicMediaPicker"
                                                                    model: string
                                                                  }
                                                                | {
                                                                    __typename?: "BasicMemberPicker"
                                                                    model: string
                                                                    members: Array<{
                                                                      __typename?: "BasicMemberPickerItem"
                                                                      id?:
                                                                        | number
                                                                        | null
                                                                      name?:
                                                                        | string
                                                                        | null
                                                                    }>
                                                                  }
                                                                | {
                                                                    __typename?: "BasicMultiUrlPicker"
                                                                    model: string
                                                                    links: Array<{
                                                                      __typename?: "BasicMultiUrlPickerItem"
                                                                      name?:
                                                                        | string
                                                                        | null
                                                                      target?:
                                                                        | string
                                                                        | null
                                                                      type: LinkType
                                                                      url?:
                                                                        | string
                                                                        | null
                                                                    }>
                                                                  }
                                                                | {
                                                                    __typename?: "BasicNestedContent"
                                                                    model: string
                                                                  }
                                                                | {
                                                                    __typename?: "BasicPropertyValue"
                                                                    model: string
                                                                    value?:
                                                                      | any
                                                                      | null
                                                                  }
                                                                | {
                                                                    __typename?: "BasicRichText"
                                                                    model: string
                                                                    richText?:
                                                                      | string
                                                                      | null
                                                                  }
                                                                | {
                                                                    __typename?: "BasicUnsupportedPropertyValue"
                                                                    model: string
                                                                    message: string
                                                                  }
                                                                | {
                                                                    __typename?: "MintMediaPicker"
                                                                    model: string
                                                                    mediaItems: Array<{
                                                                      __typename?: "MintMediaPickerItem"
                                                                      id: number
                                                                      url: string
                                                                      altText?:
                                                                        | string
                                                                        | null
                                                                    }>
                                                                  }
                                                                | null
                                                            } | null>
                                                          }> | null
                                                        }
                                                      | {
                                                          __typename?: "BasicPropertyValue"
                                                          model: string
                                                          value?: any | null
                                                        }
                                                      | {
                                                          __typename?: "BasicRichText"
                                                          model: string
                                                          richText?:
                                                            | string
                                                            | null
                                                        }
                                                      | {
                                                          __typename?: "BasicUnsupportedPropertyValue"
                                                          model: string
                                                          message: string
                                                        }
                                                      | {
                                                          __typename?: "MintMediaPicker"
                                                          model: string
                                                          mediaItems: Array<{
                                                            __typename?: "MintMediaPickerItem"
                                                            id: number
                                                            url: string
                                                            altText?:
                                                              | string
                                                              | null
                                                          }>
                                                        }
                                                      | null
                                                  } | null>
                                                }>
                                              }
                                            | {
                                                __typename?: "BasicMultiUrlPicker"
                                                valueType: string
                                                links: Array<{
                                                  __typename?: "BasicMultiUrlPickerItem"
                                                  name?: string | null
                                                  target?: string | null
                                                  type: LinkType
                                                  url?: string | null
                                                }>
                                              }
                                            | {
                                                __typename?: "BasicNestedContent"
                                                valueType: string
                                                elements?: Array<{
                                                  __typename?: "BasicNestedContentElement"
                                                  properties: Array<{
                                                    __typename?: "BasicProperty"
                                                    alias?: string | null
                                                    editorAlias?: string | null
                                                    value?:
                                                      | {
                                                          __typename?: "BasicBlockGridModel"
                                                          model: string
                                                        }
                                                      | {
                                                          __typename?: "BasicBlockListModel"
                                                          model: string
                                                        }
                                                      | {
                                                          __typename?: "BasicContentPicker"
                                                          model: string
                                                          contentList: Array<{
                                                            __typename?: "BasicContentPickerItem"
                                                            id: number
                                                            absoluteUrl: string
                                                            key: any
                                                            name?: string | null
                                                            url: string
                                                            urlSegment?:
                                                              | string
                                                              | null
                                                          }>
                                                        }
                                                      | {
                                                          __typename?: "BasicDateTimePicker"
                                                          model: string
                                                          dateTime?: any | null
                                                        }
                                                      | {
                                                          __typename?: "BasicLabel"
                                                          model: string
                                                          label?: any | null
                                                        }
                                                      | {
                                                          __typename?: "BasicMediaPicker"
                                                          model: string
                                                        }
                                                      | {
                                                          __typename?: "BasicMemberPicker"
                                                          model: string
                                                          members: Array<{
                                                            __typename?: "BasicMemberPickerItem"
                                                            id?: number | null
                                                            name?: string | null
                                                          }>
                                                        }
                                                      | {
                                                          __typename?: "BasicMultiUrlPicker"
                                                          model: string
                                                          links: Array<{
                                                            __typename?: "BasicMultiUrlPickerItem"
                                                            name?: string | null
                                                            target?:
                                                              | string
                                                              | null
                                                            type: LinkType
                                                            url?: string | null
                                                          }>
                                                        }
                                                      | {
                                                          __typename?: "BasicNestedContent"
                                                          model: string
                                                        }
                                                      | {
                                                          __typename?: "BasicPropertyValue"
                                                          model: string
                                                          value?: any | null
                                                        }
                                                      | {
                                                          __typename?: "BasicRichText"
                                                          model: string
                                                          richText?:
                                                            | string
                                                            | null
                                                        }
                                                      | {
                                                          __typename?: "BasicUnsupportedPropertyValue"
                                                          model: string
                                                          message: string
                                                        }
                                                      | {
                                                          __typename?: "MintMediaPicker"
                                                          model: string
                                                          mediaItems: Array<{
                                                            __typename?: "MintMediaPickerItem"
                                                            id: number
                                                            url: string
                                                            altText?:
                                                              | string
                                                              | null
                                                          }>
                                                        }
                                                      | null
                                                  } | null>
                                                }> | null
                                              }
                                            | {
                                                __typename?: "BasicPropertyValue"
                                                valueType: string
                                                value?: any | null
                                              }
                                            | {
                                                __typename?: "BasicRichText"
                                                valueType: string
                                                richText?: string | null
                                              }
                                            | {
                                                __typename?: "BasicUnsupportedPropertyValue"
                                                message: string
                                                valueType: string
                                              }
                                            | {
                                                __typename?: "MintMediaPicker"
                                                valueType: string
                                                mediaItems: Array<{
                                                  __typename?: "MintMediaPickerItem"
                                                  id: number
                                                  url: string
                                                  altText?: string | null
                                                }>
                                              }
                                            | null
                                        } | null>
                                      }> | null
                                    }
                                  | {
                                      __typename?: "BasicContentPicker"
                                      valueType: string
                                      contentList: Array<{
                                        __typename?: "BasicContentPickerItem"
                                        id: number
                                        absoluteUrl: string
                                        key: any
                                        name?: string | null
                                        url: string
                                        urlSegment?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicDateTimePicker"
                                      valueType: string
                                      dateTime?: any | null
                                    }
                                  | {
                                      __typename?: "BasicLabel"
                                      valueType: string
                                      label?: any | null
                                    }
                                  | {
                                      __typename?: "BasicMediaPicker"
                                      valueType: string
                                    }
                                  | {
                                      __typename?: "BasicMemberPicker"
                                      valueType: string
                                      members: Array<{
                                        __typename?: "BasicMemberPickerItem"
                                        id?: number | null
                                        name?: string | null
                                        properties: Array<{
                                          __typename?: "BasicProperty"
                                          alias?: string | null
                                          editorAlias?: string | null
                                          value?:
                                            | {
                                                __typename?: "BasicBlockGridModel"
                                                model: string
                                              }
                                            | {
                                                __typename?: "BasicBlockListModel"
                                                model: string
                                              }
                                            | {
                                                __typename?: "BasicContentPicker"
                                                model: string
                                                contentList: Array<{
                                                  __typename?: "BasicContentPickerItem"
                                                  id: number
                                                  absoluteUrl: string
                                                  key: any
                                                  name?: string | null
                                                  url: string
                                                  urlSegment?: string | null
                                                }>
                                              }
                                            | {
                                                __typename?: "BasicDateTimePicker"
                                                model: string
                                                dateTime?: any | null
                                              }
                                            | {
                                                __typename?: "BasicLabel"
                                                model: string
                                                label?: any | null
                                              }
                                            | {
                                                __typename?: "BasicMediaPicker"
                                                model: string
                                              }
                                            | {
                                                __typename?: "BasicMemberPicker"
                                                model: string
                                                members: Array<{
                                                  __typename?: "BasicMemberPickerItem"
                                                  id?: number | null
                                                  name?: string | null
                                                }>
                                              }
                                            | {
                                                __typename?: "BasicMultiUrlPicker"
                                                model: string
                                                links: Array<{
                                                  __typename?: "BasicMultiUrlPickerItem"
                                                  name?: string | null
                                                  target?: string | null
                                                  type: LinkType
                                                  url?: string | null
                                                }>
                                              }
                                            | {
                                                __typename?: "BasicNestedContent"
                                                model: string
                                                elements?: Array<{
                                                  __typename?: "BasicNestedContentElement"
                                                  properties: Array<{
                                                    __typename?: "BasicProperty"
                                                    alias?: string | null
                                                    editorAlias?: string | null
                                                    value?:
                                                      | {
                                                          __typename?: "BasicBlockGridModel"
                                                          model: string
                                                        }
                                                      | {
                                                          __typename?: "BasicBlockListModel"
                                                          model: string
                                                        }
                                                      | {
                                                          __typename?: "BasicContentPicker"
                                                          model: string
                                                          contentList: Array<{
                                                            __typename?: "BasicContentPickerItem"
                                                            id: number
                                                            absoluteUrl: string
                                                            key: any
                                                            name?: string | null
                                                            url: string
                                                            urlSegment?:
                                                              | string
                                                              | null
                                                          }>
                                                        }
                                                      | {
                                                          __typename?: "BasicDateTimePicker"
                                                          model: string
                                                          dateTime?: any | null
                                                        }
                                                      | {
                                                          __typename?: "BasicLabel"
                                                          model: string
                                                          label?: any | null
                                                        }
                                                      | {
                                                          __typename?: "BasicMediaPicker"
                                                          model: string
                                                        }
                                                      | {
                                                          __typename?: "BasicMemberPicker"
                                                          model: string
                                                          members: Array<{
                                                            __typename?: "BasicMemberPickerItem"
                                                            id?: number | null
                                                            name?: string | null
                                                          }>
                                                        }
                                                      | {
                                                          __typename?: "BasicMultiUrlPicker"
                                                          model: string
                                                          links: Array<{
                                                            __typename?: "BasicMultiUrlPickerItem"
                                                            name?: string | null
                                                            target?:
                                                              | string
                                                              | null
                                                            type: LinkType
                                                            url?: string | null
                                                          }>
                                                        }
                                                      | {
                                                          __typename?: "BasicNestedContent"
                                                          model: string
                                                        }
                                                      | {
                                                          __typename?: "BasicPropertyValue"
                                                          model: string
                                                          value?: any | null
                                                        }
                                                      | {
                                                          __typename?: "BasicRichText"
                                                          model: string
                                                          richText?:
                                                            | string
                                                            | null
                                                        }
                                                      | {
                                                          __typename?: "BasicUnsupportedPropertyValue"
                                                          model: string
                                                          message: string
                                                        }
                                                      | {
                                                          __typename?: "MintMediaPicker"
                                                          model: string
                                                          mediaItems: Array<{
                                                            __typename?: "MintMediaPickerItem"
                                                            id: number
                                                            url: string
                                                            altText?:
                                                              | string
                                                              | null
                                                          }>
                                                        }
                                                      | null
                                                  } | null>
                                                }> | null
                                              }
                                            | {
                                                __typename?: "BasicPropertyValue"
                                                model: string
                                                value?: any | null
                                              }
                                            | {
                                                __typename?: "BasicRichText"
                                                model: string
                                                richText?: string | null
                                              }
                                            | {
                                                __typename?: "BasicUnsupportedPropertyValue"
                                                model: string
                                                message: string
                                              }
                                            | {
                                                __typename?: "MintMediaPicker"
                                                model: string
                                                mediaItems: Array<{
                                                  __typename?: "MintMediaPickerItem"
                                                  id: number
                                                  url: string
                                                  altText?: string | null
                                                }>
                                              }
                                            | null
                                        } | null>
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicMultiUrlPicker"
                                      valueType: string
                                      links: Array<{
                                        __typename?: "BasicMultiUrlPickerItem"
                                        name?: string | null
                                        target?: string | null
                                        type: LinkType
                                        url?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicNestedContent"
                                      valueType: string
                                      elements?: Array<{
                                        __typename?: "BasicNestedContentElement"
                                        properties: Array<{
                                          __typename?: "BasicProperty"
                                          alias?: string | null
                                          editorAlias?: string | null
                                          value?:
                                            | {
                                                __typename?: "BasicBlockGridModel"
                                                model: string
                                              }
                                            | {
                                                __typename?: "BasicBlockListModel"
                                                model: string
                                              }
                                            | {
                                                __typename?: "BasicContentPicker"
                                                model: string
                                                contentList: Array<{
                                                  __typename?: "BasicContentPickerItem"
                                                  id: number
                                                  absoluteUrl: string
                                                  key: any
                                                  name?: string | null
                                                  url: string
                                                  urlSegment?: string | null
                                                }>
                                              }
                                            | {
                                                __typename?: "BasicDateTimePicker"
                                                model: string
                                                dateTime?: any | null
                                              }
                                            | {
                                                __typename?: "BasicLabel"
                                                model: string
                                                label?: any | null
                                              }
                                            | {
                                                __typename?: "BasicMediaPicker"
                                                model: string
                                              }
                                            | {
                                                __typename?: "BasicMemberPicker"
                                                model: string
                                                members: Array<{
                                                  __typename?: "BasicMemberPickerItem"
                                                  id?: number | null
                                                  name?: string | null
                                                }>
                                              }
                                            | {
                                                __typename?: "BasicMultiUrlPicker"
                                                model: string
                                                links: Array<{
                                                  __typename?: "BasicMultiUrlPickerItem"
                                                  name?: string | null
                                                  target?: string | null
                                                  type: LinkType
                                                  url?: string | null
                                                }>
                                              }
                                            | {
                                                __typename?: "BasicNestedContent"
                                                model: string
                                              }
                                            | {
                                                __typename?: "BasicPropertyValue"
                                                model: string
                                                value?: any | null
                                              }
                                            | {
                                                __typename?: "BasicRichText"
                                                model: string
                                                richText?: string | null
                                              }
                                            | {
                                                __typename?: "BasicUnsupportedPropertyValue"
                                                model: string
                                                message: string
                                              }
                                            | {
                                                __typename?: "MintMediaPicker"
                                                model: string
                                                mediaItems: Array<{
                                                  __typename?: "MintMediaPickerItem"
                                                  id: number
                                                  url: string
                                                  altText?: string | null
                                                }>
                                              }
                                            | null
                                        } | null>
                                      }> | null
                                    }
                                  | {
                                      __typename?: "BasicPropertyValue"
                                      valueType: string
                                      value?: any | null
                                    }
                                  | {
                                      __typename?: "BasicRichText"
                                      valueType: string
                                      richText?: string | null
                                    }
                                  | {
                                      __typename?: "BasicUnsupportedPropertyValue"
                                      message: string
                                      valueType: string
                                    }
                                  | {
                                      __typename?: "MintMediaPicker"
                                      valueType: string
                                      mediaItems: Array<{
                                        __typename?: "MintMediaPickerItem"
                                        id: number
                                        url: string
                                        altText?: string | null
                                      }>
                                    }
                                  | null
                              } | null>
                            }> | null
                          }
                        | {
                            __typename?: "BasicContentPicker"
                            valueType: string
                            contentList: Array<{
                              __typename?: "BasicContentPickerItem"
                              id: number
                              absoluteUrl: string
                              key: any
                              name?: string | null
                              url: string
                              urlSegment?: string | null
                            }>
                          }
                        | {
                            __typename?: "BasicDateTimePicker"
                            valueType: string
                            dateTime?: any | null
                          }
                        | {
                            __typename?: "BasicLabel"
                            valueType: string
                            label?: any | null
                          }
                        | { __typename?: "BasicMediaPicker"; valueType: string }
                        | {
                            __typename?: "BasicMemberPicker"
                            valueType: string
                            members: Array<{
                              __typename?: "BasicMemberPickerItem"
                              id?: number | null
                              name?: string | null
                              properties: Array<{
                                __typename?: "BasicProperty"
                                alias?: string | null
                                editorAlias?: string | null
                                value?:
                                  | {
                                      __typename?: "BasicBlockGridModel"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicBlockListModel"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicContentPicker"
                                      model: string
                                      contentList: Array<{
                                        __typename?: "BasicContentPickerItem"
                                        id: number
                                        absoluteUrl: string
                                        key: any
                                        name?: string | null
                                        url: string
                                        urlSegment?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicDateTimePicker"
                                      model: string
                                      dateTime?: any | null
                                    }
                                  | {
                                      __typename?: "BasicLabel"
                                      model: string
                                      label?: any | null
                                    }
                                  | {
                                      __typename?: "BasicMediaPicker"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicMemberPicker"
                                      model: string
                                      members: Array<{
                                        __typename?: "BasicMemberPickerItem"
                                        id?: number | null
                                        name?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicMultiUrlPicker"
                                      model: string
                                      links: Array<{
                                        __typename?: "BasicMultiUrlPickerItem"
                                        name?: string | null
                                        target?: string | null
                                        type: LinkType
                                        url?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicNestedContent"
                                      model: string
                                      elements?: Array<{
                                        __typename?: "BasicNestedContentElement"
                                        properties: Array<{
                                          __typename?: "BasicProperty"
                                          alias?: string | null
                                          editorAlias?: string | null
                                          value?:
                                            | {
                                                __typename?: "BasicBlockGridModel"
                                                model: string
                                              }
                                            | {
                                                __typename?: "BasicBlockListModel"
                                                model: string
                                              }
                                            | {
                                                __typename?: "BasicContentPicker"
                                                model: string
                                                contentList: Array<{
                                                  __typename?: "BasicContentPickerItem"
                                                  id: number
                                                  absoluteUrl: string
                                                  key: any
                                                  name?: string | null
                                                  url: string
                                                  urlSegment?: string | null
                                                }>
                                              }
                                            | {
                                                __typename?: "BasicDateTimePicker"
                                                model: string
                                                dateTime?: any | null
                                              }
                                            | {
                                                __typename?: "BasicLabel"
                                                model: string
                                                label?: any | null
                                              }
                                            | {
                                                __typename?: "BasicMediaPicker"
                                                model: string
                                              }
                                            | {
                                                __typename?: "BasicMemberPicker"
                                                model: string
                                                members: Array<{
                                                  __typename?: "BasicMemberPickerItem"
                                                  id?: number | null
                                                  name?: string | null
                                                }>
                                              }
                                            | {
                                                __typename?: "BasicMultiUrlPicker"
                                                model: string
                                                links: Array<{
                                                  __typename?: "BasicMultiUrlPickerItem"
                                                  name?: string | null
                                                  target?: string | null
                                                  type: LinkType
                                                  url?: string | null
                                                }>
                                              }
                                            | {
                                                __typename?: "BasicNestedContent"
                                                model: string
                                              }
                                            | {
                                                __typename?: "BasicPropertyValue"
                                                model: string
                                                value?: any | null
                                              }
                                            | {
                                                __typename?: "BasicRichText"
                                                model: string
                                                richText?: string | null
                                              }
                                            | {
                                                __typename?: "BasicUnsupportedPropertyValue"
                                                model: string
                                                message: string
                                              }
                                            | {
                                                __typename?: "MintMediaPicker"
                                                model: string
                                                mediaItems: Array<{
                                                  __typename?: "MintMediaPickerItem"
                                                  id: number
                                                  url: string
                                                  altText?: string | null
                                                }>
                                              }
                                            | null
                                        } | null>
                                      }> | null
                                    }
                                  | {
                                      __typename?: "BasicPropertyValue"
                                      model: string
                                      value?: any | null
                                    }
                                  | {
                                      __typename?: "BasicRichText"
                                      model: string
                                      richText?: string | null
                                    }
                                  | {
                                      __typename?: "BasicUnsupportedPropertyValue"
                                      model: string
                                      message: string
                                    }
                                  | {
                                      __typename?: "MintMediaPicker"
                                      model: string
                                      mediaItems: Array<{
                                        __typename?: "MintMediaPickerItem"
                                        id: number
                                        url: string
                                        altText?: string | null
                                      }>
                                    }
                                  | null
                              } | null>
                            }>
                          }
                        | {
                            __typename?: "BasicMultiUrlPicker"
                            valueType: string
                            links: Array<{
                              __typename?: "BasicMultiUrlPickerItem"
                              name?: string | null
                              target?: string | null
                              type: LinkType
                              url?: string | null
                            }>
                          }
                        | {
                            __typename?: "BasicNestedContent"
                            valueType: string
                            elements?: Array<{
                              __typename?: "BasicNestedContentElement"
                              properties: Array<{
                                __typename?: "BasicProperty"
                                alias?: string | null
                                editorAlias?: string | null
                                value?:
                                  | {
                                      __typename?: "BasicBlockGridModel"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicBlockListModel"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicContentPicker"
                                      model: string
                                      contentList: Array<{
                                        __typename?: "BasicContentPickerItem"
                                        id: number
                                        absoluteUrl: string
                                        key: any
                                        name?: string | null
                                        url: string
                                        urlSegment?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicDateTimePicker"
                                      model: string
                                      dateTime?: any | null
                                    }
                                  | {
                                      __typename?: "BasicLabel"
                                      model: string
                                      label?: any | null
                                    }
                                  | {
                                      __typename?: "BasicMediaPicker"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicMemberPicker"
                                      model: string
                                      members: Array<{
                                        __typename?: "BasicMemberPickerItem"
                                        id?: number | null
                                        name?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicMultiUrlPicker"
                                      model: string
                                      links: Array<{
                                        __typename?: "BasicMultiUrlPickerItem"
                                        name?: string | null
                                        target?: string | null
                                        type: LinkType
                                        url?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicNestedContent"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicPropertyValue"
                                      model: string
                                      value?: any | null
                                    }
                                  | {
                                      __typename?: "BasicRichText"
                                      model: string
                                      richText?: string | null
                                    }
                                  | {
                                      __typename?: "BasicUnsupportedPropertyValue"
                                      model: string
                                      message: string
                                    }
                                  | {
                                      __typename?: "MintMediaPicker"
                                      model: string
                                      mediaItems: Array<{
                                        __typename?: "MintMediaPickerItem"
                                        id: number
                                        url: string
                                        altText?: string | null
                                      }>
                                    }
                                  | null
                              } | null>
                            }> | null
                          }
                        | {
                            __typename?: "BasicPropertyValue"
                            valueType: string
                            value?: any | null
                          }
                        | {
                            __typename?: "BasicRichText"
                            valueType: string
                            richText?: string | null
                          }
                        | {
                            __typename?: "BasicUnsupportedPropertyValue"
                            message: string
                            valueType: string
                          }
                        | {
                            __typename?: "MintMediaPicker"
                            valueType: string
                            mediaItems: Array<{
                              __typename?: "MintMediaPickerItem"
                              id: number
                              url: string
                              altText?: string | null
                            }>
                          }
                        | null
                    } | null>
                  }> | null
                }
              | {
                  __typename?: "BasicContentPicker"
                  valueType: string
                  contentList: Array<{
                    __typename?: "BasicContentPickerItem"
                    id: number
                    absoluteUrl: string
                    key: any
                    name?: string | null
                    url: string
                    urlSegment?: string | null
                  }>
                }
              | {
                  __typename?: "BasicDateTimePicker"
                  valueType: string
                  dateTime?: any | null
                }
              | {
                  __typename?: "BasicLabel"
                  valueType: string
                  label?: any | null
                }
              | { __typename?: "BasicMediaPicker"; valueType: string }
              | {
                  __typename?: "BasicMemberPicker"
                  valueType: string
                  members: Array<{
                    __typename?: "BasicMemberPickerItem"
                    id?: number | null
                    name?: string | null
                    properties: Array<{
                      __typename?: "BasicProperty"
                      alias?: string | null
                      editorAlias?: string | null
                      value?:
                        | { __typename?: "BasicBlockGridModel"; model: string }
                        | { __typename?: "BasicBlockListModel"; model: string }
                        | {
                            __typename?: "BasicContentPicker"
                            model: string
                            contentList: Array<{
                              __typename?: "BasicContentPickerItem"
                              id: number
                              absoluteUrl: string
                              key: any
                              name?: string | null
                              url: string
                              urlSegment?: string | null
                            }>
                          }
                        | {
                            __typename?: "BasicDateTimePicker"
                            model: string
                            dateTime?: any | null
                          }
                        | {
                            __typename?: "BasicLabel"
                            model: string
                            label?: any | null
                          }
                        | { __typename?: "BasicMediaPicker"; model: string }
                        | {
                            __typename?: "BasicMemberPicker"
                            model: string
                            members: Array<{
                              __typename?: "BasicMemberPickerItem"
                              id?: number | null
                              name?: string | null
                            }>
                          }
                        | {
                            __typename?: "BasicMultiUrlPicker"
                            model: string
                            links: Array<{
                              __typename?: "BasicMultiUrlPickerItem"
                              name?: string | null
                              target?: string | null
                              type: LinkType
                              url?: string | null
                            }>
                          }
                        | {
                            __typename?: "BasicNestedContent"
                            model: string
                            elements?: Array<{
                              __typename?: "BasicNestedContentElement"
                              properties: Array<{
                                __typename?: "BasicProperty"
                                alias?: string | null
                                editorAlias?: string | null
                                value?:
                                  | {
                                      __typename?: "BasicBlockGridModel"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicBlockListModel"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicContentPicker"
                                      model: string
                                      contentList: Array<{
                                        __typename?: "BasicContentPickerItem"
                                        id: number
                                        absoluteUrl: string
                                        key: any
                                        name?: string | null
                                        url: string
                                        urlSegment?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicDateTimePicker"
                                      model: string
                                      dateTime?: any | null
                                    }
                                  | {
                                      __typename?: "BasicLabel"
                                      model: string
                                      label?: any | null
                                    }
                                  | {
                                      __typename?: "BasicMediaPicker"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicMemberPicker"
                                      model: string
                                      members: Array<{
                                        __typename?: "BasicMemberPickerItem"
                                        id?: number | null
                                        name?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicMultiUrlPicker"
                                      model: string
                                      links: Array<{
                                        __typename?: "BasicMultiUrlPickerItem"
                                        name?: string | null
                                        target?: string | null
                                        type: LinkType
                                        url?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicNestedContent"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicPropertyValue"
                                      model: string
                                      value?: any | null
                                    }
                                  | {
                                      __typename?: "BasicRichText"
                                      model: string
                                      richText?: string | null
                                    }
                                  | {
                                      __typename?: "BasicUnsupportedPropertyValue"
                                      model: string
                                      message: string
                                    }
                                  | {
                                      __typename?: "MintMediaPicker"
                                      model: string
                                      mediaItems: Array<{
                                        __typename?: "MintMediaPickerItem"
                                        id: number
                                        url: string
                                        altText?: string | null
                                      }>
                                    }
                                  | null
                              } | null>
                            }> | null
                          }
                        | {
                            __typename?: "BasicPropertyValue"
                            model: string
                            value?: any | null
                          }
                        | {
                            __typename?: "BasicRichText"
                            model: string
                            richText?: string | null
                          }
                        | {
                            __typename?: "BasicUnsupportedPropertyValue"
                            model: string
                            message: string
                          }
                        | {
                            __typename?: "MintMediaPicker"
                            model: string
                            mediaItems: Array<{
                              __typename?: "MintMediaPickerItem"
                              id: number
                              url: string
                              altText?: string | null
                            }>
                          }
                        | null
                    } | null>
                  }>
                }
              | {
                  __typename?: "BasicMultiUrlPicker"
                  valueType: string
                  links: Array<{
                    __typename?: "BasicMultiUrlPickerItem"
                    name?: string | null
                    target?: string | null
                    type: LinkType
                    url?: string | null
                  }>
                }
              | {
                  __typename?: "BasicNestedContent"
                  valueType: string
                  elements?: Array<{
                    __typename?: "BasicNestedContentElement"
                    properties: Array<{
                      __typename?: "BasicProperty"
                      alias?: string | null
                      editorAlias?: string | null
                      value?:
                        | { __typename?: "BasicBlockGridModel"; model: string }
                        | { __typename?: "BasicBlockListModel"; model: string }
                        | {
                            __typename?: "BasicContentPicker"
                            model: string
                            contentList: Array<{
                              __typename?: "BasicContentPickerItem"
                              id: number
                              absoluteUrl: string
                              key: any
                              name?: string | null
                              url: string
                              urlSegment?: string | null
                            }>
                          }
                        | {
                            __typename?: "BasicDateTimePicker"
                            model: string
                            dateTime?: any | null
                          }
                        | {
                            __typename?: "BasicLabel"
                            model: string
                            label?: any | null
                          }
                        | { __typename?: "BasicMediaPicker"; model: string }
                        | {
                            __typename?: "BasicMemberPicker"
                            model: string
                            members: Array<{
                              __typename?: "BasicMemberPickerItem"
                              id?: number | null
                              name?: string | null
                            }>
                          }
                        | {
                            __typename?: "BasicMultiUrlPicker"
                            model: string
                            links: Array<{
                              __typename?: "BasicMultiUrlPickerItem"
                              name?: string | null
                              target?: string | null
                              type: LinkType
                              url?: string | null
                            }>
                          }
                        | { __typename?: "BasicNestedContent"; model: string }
                        | {
                            __typename?: "BasicPropertyValue"
                            model: string
                            value?: any | null
                          }
                        | {
                            __typename?: "BasicRichText"
                            model: string
                            richText?: string | null
                          }
                        | {
                            __typename?: "BasicUnsupportedPropertyValue"
                            model: string
                            message: string
                          }
                        | {
                            __typename?: "MintMediaPicker"
                            model: string
                            mediaItems: Array<{
                              __typename?: "MintMediaPickerItem"
                              id: number
                              url: string
                              altText?: string | null
                            }>
                          }
                        | null
                    } | null>
                  }> | null
                }
              | {
                  __typename?: "BasicPropertyValue"
                  valueType: string
                  value?: any | null
                }
              | {
                  __typename?: "BasicRichText"
                  valueType: string
                  richText?: string | null
                }
              | {
                  __typename?: "BasicUnsupportedPropertyValue"
                  message: string
                  valueType: string
                }
              | {
                  __typename?: "MintMediaPicker"
                  valueType: string
                  mediaItems: Array<{
                    __typename?: "MintMediaPickerItem"
                    id: number
                    url: string
                    altText?: string | null
                  }>
                }
              | null
          } | null> | null
          parent?: {
            __typename?: "BasicContent"
            id?: number | null
            url?: string | null
            level?: number | null
            properties?: Array<{
              __typename?: "BasicProperty"
              propertyName?: string | null
              propertyValue?:
                | {
                    __typename?: "BasicBlockGridModel"
                    gridColumns?: number | null
                    valueType: string
                    blocks?: Array<{
                      __typename?: "BasicBlockGridItem"
                      columnSpan: number
                      rowSpan: number
                      contentProperties: Array<{
                        __typename?: "BasicProperty"
                        value?:
                          | {
                              __typename?: "BasicBlockGridModel"
                              valueType: string
                            }
                          | {
                              __typename?: "BasicBlockListModel"
                              valueType: string
                            }
                          | {
                              __typename?: "BasicContentPicker"
                              valueType: string
                              contentList: Array<{
                                __typename?: "BasicContentPickerItem"
                                id: number
                                absoluteUrl: string
                                key: any
                                name?: string | null
                                url: string
                                urlSegment?: string | null
                              }>
                            }
                          | {
                              __typename?: "BasicDateTimePicker"
                              valueType: string
                              dateTime?: any | null
                            }
                          | {
                              __typename?: "BasicLabel"
                              valueType: string
                              label?: any | null
                            }
                          | {
                              __typename?: "BasicMediaPicker"
                              valueType: string
                            }
                          | {
                              __typename?: "BasicMemberPicker"
                              valueType: string
                              members: Array<{
                                __typename?: "BasicMemberPickerItem"
                                id?: number | null
                                name?: string | null
                                properties: Array<{
                                  __typename?: "BasicProperty"
                                  alias?: string | null
                                  editorAlias?: string | null
                                  value?:
                                    | {
                                        __typename?: "BasicBlockGridModel"
                                        model: string
                                      }
                                    | {
                                        __typename?: "BasicBlockListModel"
                                        model: string
                                      }
                                    | {
                                        __typename?: "BasicContentPicker"
                                        model: string
                                        contentList: Array<{
                                          __typename?: "BasicContentPickerItem"
                                          id: number
                                          absoluteUrl: string
                                          key: any
                                          name?: string | null
                                          url: string
                                          urlSegment?: string | null
                                        }>
                                      }
                                    | {
                                        __typename?: "BasicDateTimePicker"
                                        model: string
                                        dateTime?: any | null
                                      }
                                    | {
                                        __typename?: "BasicLabel"
                                        model: string
                                        label?: any | null
                                      }
                                    | {
                                        __typename?: "BasicMediaPicker"
                                        model: string
                                      }
                                    | {
                                        __typename?: "BasicMemberPicker"
                                        model: string
                                        members: Array<{
                                          __typename?: "BasicMemberPickerItem"
                                          id?: number | null
                                          name?: string | null
                                        }>
                                      }
                                    | {
                                        __typename?: "BasicMultiUrlPicker"
                                        model: string
                                        links: Array<{
                                          __typename?: "BasicMultiUrlPickerItem"
                                          name?: string | null
                                          target?: string | null
                                          type: LinkType
                                          url?: string | null
                                        }>
                                      }
                                    | {
                                        __typename?: "BasicNestedContent"
                                        model: string
                                        elements?: Array<{
                                          __typename?: "BasicNestedContentElement"
                                          properties: Array<{
                                            __typename?: "BasicProperty"
                                            alias?: string | null
                                            editorAlias?: string | null
                                            value?:
                                              | {
                                                  __typename?: "BasicBlockGridModel"
                                                  model: string
                                                }
                                              | {
                                                  __typename?: "BasicBlockListModel"
                                                  model: string
                                                }
                                              | {
                                                  __typename?: "BasicContentPicker"
                                                  model: string
                                                  contentList: Array<{
                                                    __typename?: "BasicContentPickerItem"
                                                    id: number
                                                    absoluteUrl: string
                                                    key: any
                                                    name?: string | null
                                                    url: string
                                                    urlSegment?: string | null
                                                  }>
                                                }
                                              | {
                                                  __typename?: "BasicDateTimePicker"
                                                  model: string
                                                  dateTime?: any | null
                                                }
                                              | {
                                                  __typename?: "BasicLabel"
                                                  model: string
                                                  label?: any | null
                                                }
                                              | {
                                                  __typename?: "BasicMediaPicker"
                                                  model: string
                                                }
                                              | {
                                                  __typename?: "BasicMemberPicker"
                                                  model: string
                                                  members: Array<{
                                                    __typename?: "BasicMemberPickerItem"
                                                    id?: number | null
                                                    name?: string | null
                                                  }>
                                                }
                                              | {
                                                  __typename?: "BasicMultiUrlPicker"
                                                  model: string
                                                  links: Array<{
                                                    __typename?: "BasicMultiUrlPickerItem"
                                                    name?: string | null
                                                    target?: string | null
                                                    type: LinkType
                                                    url?: string | null
                                                  }>
                                                }
                                              | {
                                                  __typename?: "BasicNestedContent"
                                                  model: string
                                                }
                                              | {
                                                  __typename?: "BasicPropertyValue"
                                                  model: string
                                                  value?: any | null
                                                }
                                              | {
                                                  __typename?: "BasicRichText"
                                                  model: string
                                                  richText?: string | null
                                                }
                                              | {
                                                  __typename?: "BasicUnsupportedPropertyValue"
                                                  model: string
                                                  message: string
                                                }
                                              | {
                                                  __typename?: "MintMediaPicker"
                                                  model: string
                                                  mediaItems: Array<{
                                                    __typename?: "MintMediaPickerItem"
                                                    id: number
                                                    url: string
                                                    altText?: string | null
                                                  }>
                                                }
                                              | null
                                          } | null>
                                        }> | null
                                      }
                                    | {
                                        __typename?: "BasicPropertyValue"
                                        model: string
                                        value?: any | null
                                      }
                                    | {
                                        __typename?: "BasicRichText"
                                        model: string
                                        richText?: string | null
                                      }
                                    | {
                                        __typename?: "BasicUnsupportedPropertyValue"
                                        model: string
                                        message: string
                                      }
                                    | {
                                        __typename?: "MintMediaPicker"
                                        model: string
                                        mediaItems: Array<{
                                          __typename?: "MintMediaPickerItem"
                                          id: number
                                          url: string
                                          altText?: string | null
                                        }>
                                      }
                                    | null
                                } | null>
                              }>
                            }
                          | {
                              __typename?: "BasicMultiUrlPicker"
                              valueType: string
                              links: Array<{
                                __typename?: "BasicMultiUrlPickerItem"
                                name?: string | null
                                target?: string | null
                                type: LinkType
                                url?: string | null
                              }>
                            }
                          | {
                              __typename?: "BasicNestedContent"
                              valueType: string
                              elements?: Array<{
                                __typename?: "BasicNestedContentElement"
                                properties: Array<{
                                  __typename?: "BasicProperty"
                                  alias?: string | null
                                  editorAlias?: string | null
                                  value?:
                                    | {
                                        __typename?: "BasicBlockGridModel"
                                        model: string
                                      }
                                    | {
                                        __typename?: "BasicBlockListModel"
                                        model: string
                                      }
                                    | {
                                        __typename?: "BasicContentPicker"
                                        model: string
                                        contentList: Array<{
                                          __typename?: "BasicContentPickerItem"
                                          id: number
                                          absoluteUrl: string
                                          key: any
                                          name?: string | null
                                          url: string
                                          urlSegment?: string | null
                                        }>
                                      }
                                    | {
                                        __typename?: "BasicDateTimePicker"
                                        model: string
                                        dateTime?: any | null
                                      }
                                    | {
                                        __typename?: "BasicLabel"
                                        model: string
                                        label?: any | null
                                      }
                                    | {
                                        __typename?: "BasicMediaPicker"
                                        model: string
                                      }
                                    | {
                                        __typename?: "BasicMemberPicker"
                                        model: string
                                        members: Array<{
                                          __typename?: "BasicMemberPickerItem"
                                          id?: number | null
                                          name?: string | null
                                        }>
                                      }
                                    | {
                                        __typename?: "BasicMultiUrlPicker"
                                        model: string
                                        links: Array<{
                                          __typename?: "BasicMultiUrlPickerItem"
                                          name?: string | null
                                          target?: string | null
                                          type: LinkType
                                          url?: string | null
                                        }>
                                      }
                                    | {
                                        __typename?: "BasicNestedContent"
                                        model: string
                                      }
                                    | {
                                        __typename?: "BasicPropertyValue"
                                        model: string
                                        value?: any | null
                                      }
                                    | {
                                        __typename?: "BasicRichText"
                                        model: string
                                        richText?: string | null
                                      }
                                    | {
                                        __typename?: "BasicUnsupportedPropertyValue"
                                        model: string
                                        message: string
                                      }
                                    | {
                                        __typename?: "MintMediaPicker"
                                        model: string
                                        mediaItems: Array<{
                                          __typename?: "MintMediaPickerItem"
                                          id: number
                                          url: string
                                          altText?: string | null
                                        }>
                                      }
                                    | null
                                } | null>
                              }> | null
                            }
                          | {
                              __typename?: "BasicPropertyValue"
                              valueType: string
                              value?: any | null
                            }
                          | {
                              __typename?: "BasicRichText"
                              valueType: string
                              richText?: string | null
                            }
                          | {
                              __typename?: "BasicUnsupportedPropertyValue"
                              message: string
                              valueType: string
                            }
                          | {
                              __typename?: "MintMediaPicker"
                              valueType: string
                              mediaItems: Array<{
                                __typename?: "MintMediaPickerItem"
                                id: number
                                url: string
                                altText?: string | null
                              }>
                            }
                          | null
                      } | null>
                      settingsProperties: Array<{
                        __typename?: "BasicProperty"
                        value?:
                          | {
                              __typename?: "BasicBlockGridModel"
                              valueType: string
                            }
                          | {
                              __typename?: "BasicBlockListModel"
                              valueType: string
                            }
                          | {
                              __typename?: "BasicContentPicker"
                              valueType: string
                              contentList: Array<{
                                __typename?: "BasicContentPickerItem"
                                id: number
                                absoluteUrl: string
                                key: any
                                name?: string | null
                                url: string
                                urlSegment?: string | null
                              }>
                            }
                          | {
                              __typename?: "BasicDateTimePicker"
                              valueType: string
                              dateTime?: any | null
                            }
                          | {
                              __typename?: "BasicLabel"
                              valueType: string
                              label?: any | null
                            }
                          | {
                              __typename?: "BasicMediaPicker"
                              valueType: string
                            }
                          | {
                              __typename?: "BasicMemberPicker"
                              valueType: string
                              members: Array<{
                                __typename?: "BasicMemberPickerItem"
                                id?: number | null
                                name?: string | null
                                properties: Array<{
                                  __typename?: "BasicProperty"
                                  alias?: string | null
                                  editorAlias?: string | null
                                  value?:
                                    | {
                                        __typename?: "BasicBlockGridModel"
                                        model: string
                                      }
                                    | {
                                        __typename?: "BasicBlockListModel"
                                        model: string
                                      }
                                    | {
                                        __typename?: "BasicContentPicker"
                                        model: string
                                        contentList: Array<{
                                          __typename?: "BasicContentPickerItem"
                                          id: number
                                          absoluteUrl: string
                                          key: any
                                          name?: string | null
                                          url: string
                                          urlSegment?: string | null
                                        }>
                                      }
                                    | {
                                        __typename?: "BasicDateTimePicker"
                                        model: string
                                        dateTime?: any | null
                                      }
                                    | {
                                        __typename?: "BasicLabel"
                                        model: string
                                        label?: any | null
                                      }
                                    | {
                                        __typename?: "BasicMediaPicker"
                                        model: string
                                      }
                                    | {
                                        __typename?: "BasicMemberPicker"
                                        model: string
                                        members: Array<{
                                          __typename?: "BasicMemberPickerItem"
                                          id?: number | null
                                          name?: string | null
                                        }>
                                      }
                                    | {
                                        __typename?: "BasicMultiUrlPicker"
                                        model: string
                                        links: Array<{
                                          __typename?: "BasicMultiUrlPickerItem"
                                          name?: string | null
                                          target?: string | null
                                          type: LinkType
                                          url?: string | null
                                        }>
                                      }
                                    | {
                                        __typename?: "BasicNestedContent"
                                        model: string
                                        elements?: Array<{
                                          __typename?: "BasicNestedContentElement"
                                          properties: Array<{
                                            __typename?: "BasicProperty"
                                            alias?: string | null
                                            editorAlias?: string | null
                                            value?:
                                              | {
                                                  __typename?: "BasicBlockGridModel"
                                                  model: string
                                                }
                                              | {
                                                  __typename?: "BasicBlockListModel"
                                                  model: string
                                                }
                                              | {
                                                  __typename?: "BasicContentPicker"
                                                  model: string
                                                  contentList: Array<{
                                                    __typename?: "BasicContentPickerItem"
                                                    id: number
                                                    absoluteUrl: string
                                                    key: any
                                                    name?: string | null
                                                    url: string
                                                    urlSegment?: string | null
                                                  }>
                                                }
                                              | {
                                                  __typename?: "BasicDateTimePicker"
                                                  model: string
                                                  dateTime?: any | null
                                                }
                                              | {
                                                  __typename?: "BasicLabel"
                                                  model: string
                                                  label?: any | null
                                                }
                                              | {
                                                  __typename?: "BasicMediaPicker"
                                                  model: string
                                                }
                                              | {
                                                  __typename?: "BasicMemberPicker"
                                                  model: string
                                                  members: Array<{
                                                    __typename?: "BasicMemberPickerItem"
                                                    id?: number | null
                                                    name?: string | null
                                                  }>
                                                }
                                              | {
                                                  __typename?: "BasicMultiUrlPicker"
                                                  model: string
                                                  links: Array<{
                                                    __typename?: "BasicMultiUrlPickerItem"
                                                    name?: string | null
                                                    target?: string | null
                                                    type: LinkType
                                                    url?: string | null
                                                  }>
                                                }
                                              | {
                                                  __typename?: "BasicNestedContent"
                                                  model: string
                                                }
                                              | {
                                                  __typename?: "BasicPropertyValue"
                                                  model: string
                                                  value?: any | null
                                                }
                                              | {
                                                  __typename?: "BasicRichText"
                                                  model: string
                                                  richText?: string | null
                                                }
                                              | {
                                                  __typename?: "BasicUnsupportedPropertyValue"
                                                  model: string
                                                  message: string
                                                }
                                              | {
                                                  __typename?: "MintMediaPicker"
                                                  model: string
                                                  mediaItems: Array<{
                                                    __typename?: "MintMediaPickerItem"
                                                    id: number
                                                    url: string
                                                    altText?: string | null
                                                  }>
                                                }
                                              | null
                                          } | null>
                                        }> | null
                                      }
                                    | {
                                        __typename?: "BasicPropertyValue"
                                        model: string
                                        value?: any | null
                                      }
                                    | {
                                        __typename?: "BasicRichText"
                                        model: string
                                        richText?: string | null
                                      }
                                    | {
                                        __typename?: "BasicUnsupportedPropertyValue"
                                        model: string
                                        message: string
                                      }
                                    | {
                                        __typename?: "MintMediaPicker"
                                        model: string
                                        mediaItems: Array<{
                                          __typename?: "MintMediaPickerItem"
                                          id: number
                                          url: string
                                          altText?: string | null
                                        }>
                                      }
                                    | null
                                } | null>
                              }>
                            }
                          | {
                              __typename?: "BasicMultiUrlPicker"
                              valueType: string
                              links: Array<{
                                __typename?: "BasicMultiUrlPickerItem"
                                name?: string | null
                                target?: string | null
                                type: LinkType
                                url?: string | null
                              }>
                            }
                          | {
                              __typename?: "BasicNestedContent"
                              valueType: string
                              elements?: Array<{
                                __typename?: "BasicNestedContentElement"
                                properties: Array<{
                                  __typename?: "BasicProperty"
                                  alias?: string | null
                                  editorAlias?: string | null
                                  value?:
                                    | {
                                        __typename?: "BasicBlockGridModel"
                                        model: string
                                      }
                                    | {
                                        __typename?: "BasicBlockListModel"
                                        model: string
                                      }
                                    | {
                                        __typename?: "BasicContentPicker"
                                        model: string
                                        contentList: Array<{
                                          __typename?: "BasicContentPickerItem"
                                          id: number
                                          absoluteUrl: string
                                          key: any
                                          name?: string | null
                                          url: string
                                          urlSegment?: string | null
                                        }>
                                      }
                                    | {
                                        __typename?: "BasicDateTimePicker"
                                        model: string
                                        dateTime?: any | null
                                      }
                                    | {
                                        __typename?: "BasicLabel"
                                        model: string
                                        label?: any | null
                                      }
                                    | {
                                        __typename?: "BasicMediaPicker"
                                        model: string
                                      }
                                    | {
                                        __typename?: "BasicMemberPicker"
                                        model: string
                                        members: Array<{
                                          __typename?: "BasicMemberPickerItem"
                                          id?: number | null
                                          name?: string | null
                                        }>
                                      }
                                    | {
                                        __typename?: "BasicMultiUrlPicker"
                                        model: string
                                        links: Array<{
                                          __typename?: "BasicMultiUrlPickerItem"
                                          name?: string | null
                                          target?: string | null
                                          type: LinkType
                                          url?: string | null
                                        }>
                                      }
                                    | {
                                        __typename?: "BasicNestedContent"
                                        model: string
                                      }
                                    | {
                                        __typename?: "BasicPropertyValue"
                                        model: string
                                        value?: any | null
                                      }
                                    | {
                                        __typename?: "BasicRichText"
                                        model: string
                                        richText?: string | null
                                      }
                                    | {
                                        __typename?: "BasicUnsupportedPropertyValue"
                                        model: string
                                        message: string
                                      }
                                    | {
                                        __typename?: "MintMediaPicker"
                                        model: string
                                        mediaItems: Array<{
                                          __typename?: "MintMediaPickerItem"
                                          id: number
                                          url: string
                                          altText?: string | null
                                        }>
                                      }
                                    | null
                                } | null>
                              }> | null
                            }
                          | {
                              __typename?: "BasicPropertyValue"
                              valueType: string
                              value?: any | null
                            }
                          | {
                              __typename?: "BasicRichText"
                              valueType: string
                              richText?: string | null
                            }
                          | {
                              __typename?: "BasicUnsupportedPropertyValue"
                              message: string
                              valueType: string
                            }
                          | {
                              __typename?: "MintMediaPicker"
                              valueType: string
                              mediaItems: Array<{
                                __typename?: "MintMediaPickerItem"
                                id: number
                                url: string
                                altText?: string | null
                              }>
                            }
                          | null
                      } | null>
                      areas: Array<{
                        __typename?: "BasicBlockGridArea"
                        alias?: string | null
                        rowSpan: number
                        columnSpan: number
                        blocks?: Array<{
                          __typename?: "BasicBlockGridItem"
                          columnSpan: number
                          rowSpan: number
                          contentProperties: Array<{
                            __typename?: "BasicProperty"
                            value?:
                              | {
                                  __typename?: "BasicBlockGridModel"
                                  valueType: string
                                }
                              | {
                                  __typename?: "BasicBlockListModel"
                                  valueType: string
                                }
                              | {
                                  __typename?: "BasicContentPicker"
                                  valueType: string
                                  contentList: Array<{
                                    __typename?: "BasicContentPickerItem"
                                    id: number
                                    absoluteUrl: string
                                    key: any
                                    name?: string | null
                                    url: string
                                    urlSegment?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicDateTimePicker"
                                  valueType: string
                                  dateTime?: any | null
                                }
                              | {
                                  __typename?: "BasicLabel"
                                  valueType: string
                                  label?: any | null
                                }
                              | {
                                  __typename?: "BasicMediaPicker"
                                  valueType: string
                                }
                              | {
                                  __typename?: "BasicMemberPicker"
                                  valueType: string
                                  members: Array<{
                                    __typename?: "BasicMemberPickerItem"
                                    id?: number | null
                                    name?: string | null
                                    properties: Array<{
                                      __typename?: "BasicProperty"
                                      alias?: string | null
                                      editorAlias?: string | null
                                      value?:
                                        | {
                                            __typename?: "BasicBlockGridModel"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicBlockListModel"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicContentPicker"
                                            model: string
                                            contentList: Array<{
                                              __typename?: "BasicContentPickerItem"
                                              id: number
                                              absoluteUrl: string
                                              key: any
                                              name?: string | null
                                              url: string
                                              urlSegment?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicDateTimePicker"
                                            model: string
                                            dateTime?: any | null
                                          }
                                        | {
                                            __typename?: "BasicLabel"
                                            model: string
                                            label?: any | null
                                          }
                                        | {
                                            __typename?: "BasicMediaPicker"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicMemberPicker"
                                            model: string
                                            members: Array<{
                                              __typename?: "BasicMemberPickerItem"
                                              id?: number | null
                                              name?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicMultiUrlPicker"
                                            model: string
                                            links: Array<{
                                              __typename?: "BasicMultiUrlPickerItem"
                                              name?: string | null
                                              target?: string | null
                                              type: LinkType
                                              url?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicNestedContent"
                                            model: string
                                            elements?: Array<{
                                              __typename?: "BasicNestedContentElement"
                                              properties: Array<{
                                                __typename?: "BasicProperty"
                                                alias?: string | null
                                                editorAlias?: string | null
                                                value?:
                                                  | {
                                                      __typename?: "BasicBlockGridModel"
                                                      model: string
                                                    }
                                                  | {
                                                      __typename?: "BasicBlockListModel"
                                                      model: string
                                                    }
                                                  | {
                                                      __typename?: "BasicContentPicker"
                                                      model: string
                                                      contentList: Array<{
                                                        __typename?: "BasicContentPickerItem"
                                                        id: number
                                                        absoluteUrl: string
                                                        key: any
                                                        name?: string | null
                                                        url: string
                                                        urlSegment?:
                                                          | string
                                                          | null
                                                      }>
                                                    }
                                                  | {
                                                      __typename?: "BasicDateTimePicker"
                                                      model: string
                                                      dateTime?: any | null
                                                    }
                                                  | {
                                                      __typename?: "BasicLabel"
                                                      model: string
                                                      label?: any | null
                                                    }
                                                  | {
                                                      __typename?: "BasicMediaPicker"
                                                      model: string
                                                    }
                                                  | {
                                                      __typename?: "BasicMemberPicker"
                                                      model: string
                                                      members: Array<{
                                                        __typename?: "BasicMemberPickerItem"
                                                        id?: number | null
                                                        name?: string | null
                                                      }>
                                                    }
                                                  | {
                                                      __typename?: "BasicMultiUrlPicker"
                                                      model: string
                                                      links: Array<{
                                                        __typename?: "BasicMultiUrlPickerItem"
                                                        name?: string | null
                                                        target?: string | null
                                                        type: LinkType
                                                        url?: string | null
                                                      }>
                                                    }
                                                  | {
                                                      __typename?: "BasicNestedContent"
                                                      model: string
                                                    }
                                                  | {
                                                      __typename?: "BasicPropertyValue"
                                                      model: string
                                                      value?: any | null
                                                    }
                                                  | {
                                                      __typename?: "BasicRichText"
                                                      model: string
                                                      richText?: string | null
                                                    }
                                                  | {
                                                      __typename?: "BasicUnsupportedPropertyValue"
                                                      model: string
                                                      message: string
                                                    }
                                                  | {
                                                      __typename?: "MintMediaPicker"
                                                      model: string
                                                      mediaItems: Array<{
                                                        __typename?: "MintMediaPickerItem"
                                                        id: number
                                                        url: string
                                                        altText?: string | null
                                                      }>
                                                    }
                                                  | null
                                              } | null>
                                            }> | null
                                          }
                                        | {
                                            __typename?: "BasicPropertyValue"
                                            model: string
                                            value?: any | null
                                          }
                                        | {
                                            __typename?: "BasicRichText"
                                            model: string
                                            richText?: string | null
                                          }
                                        | {
                                            __typename?: "BasicUnsupportedPropertyValue"
                                            model: string
                                            message: string
                                          }
                                        | {
                                            __typename?: "MintMediaPicker"
                                            model: string
                                            mediaItems: Array<{
                                              __typename?: "MintMediaPickerItem"
                                              id: number
                                              url: string
                                              altText?: string | null
                                            }>
                                          }
                                        | null
                                    } | null>
                                  }>
                                }
                              | {
                                  __typename?: "BasicMultiUrlPicker"
                                  valueType: string
                                  links: Array<{
                                    __typename?: "BasicMultiUrlPickerItem"
                                    name?: string | null
                                    target?: string | null
                                    type: LinkType
                                    url?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicNestedContent"
                                  valueType: string
                                  elements?: Array<{
                                    __typename?: "BasicNestedContentElement"
                                    properties: Array<{
                                      __typename?: "BasicProperty"
                                      alias?: string | null
                                      editorAlias?: string | null
                                      value?:
                                        | {
                                            __typename?: "BasicBlockGridModel"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicBlockListModel"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicContentPicker"
                                            model: string
                                            contentList: Array<{
                                              __typename?: "BasicContentPickerItem"
                                              id: number
                                              absoluteUrl: string
                                              key: any
                                              name?: string | null
                                              url: string
                                              urlSegment?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicDateTimePicker"
                                            model: string
                                            dateTime?: any | null
                                          }
                                        | {
                                            __typename?: "BasicLabel"
                                            model: string
                                            label?: any | null
                                          }
                                        | {
                                            __typename?: "BasicMediaPicker"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicMemberPicker"
                                            model: string
                                            members: Array<{
                                              __typename?: "BasicMemberPickerItem"
                                              id?: number | null
                                              name?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicMultiUrlPicker"
                                            model: string
                                            links: Array<{
                                              __typename?: "BasicMultiUrlPickerItem"
                                              name?: string | null
                                              target?: string | null
                                              type: LinkType
                                              url?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicNestedContent"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicPropertyValue"
                                            model: string
                                            value?: any | null
                                          }
                                        | {
                                            __typename?: "BasicRichText"
                                            model: string
                                            richText?: string | null
                                          }
                                        | {
                                            __typename?: "BasicUnsupportedPropertyValue"
                                            model: string
                                            message: string
                                          }
                                        | {
                                            __typename?: "MintMediaPicker"
                                            model: string
                                            mediaItems: Array<{
                                              __typename?: "MintMediaPickerItem"
                                              id: number
                                              url: string
                                              altText?: string | null
                                            }>
                                          }
                                        | null
                                    } | null>
                                  }> | null
                                }
                              | {
                                  __typename?: "BasicPropertyValue"
                                  valueType: string
                                  value?: any | null
                                }
                              | {
                                  __typename?: "BasicRichText"
                                  valueType: string
                                  richText?: string | null
                                }
                              | {
                                  __typename?: "BasicUnsupportedPropertyValue"
                                  message: string
                                  valueType: string
                                }
                              | {
                                  __typename?: "MintMediaPicker"
                                  valueType: string
                                  mediaItems: Array<{
                                    __typename?: "MintMediaPickerItem"
                                    id: number
                                    url: string
                                    altText?: string | null
                                  }>
                                }
                              | null
                          } | null>
                          settingsProperties: Array<{
                            __typename?: "BasicProperty"
                            value?:
                              | {
                                  __typename?: "BasicBlockGridModel"
                                  valueType: string
                                }
                              | {
                                  __typename?: "BasicBlockListModel"
                                  valueType: string
                                }
                              | {
                                  __typename?: "BasicContentPicker"
                                  valueType: string
                                  contentList: Array<{
                                    __typename?: "BasicContentPickerItem"
                                    id: number
                                    absoluteUrl: string
                                    key: any
                                    name?: string | null
                                    url: string
                                    urlSegment?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicDateTimePicker"
                                  valueType: string
                                  dateTime?: any | null
                                }
                              | {
                                  __typename?: "BasicLabel"
                                  valueType: string
                                  label?: any | null
                                }
                              | {
                                  __typename?: "BasicMediaPicker"
                                  valueType: string
                                }
                              | {
                                  __typename?: "BasicMemberPicker"
                                  valueType: string
                                  members: Array<{
                                    __typename?: "BasicMemberPickerItem"
                                    id?: number | null
                                    name?: string | null
                                    properties: Array<{
                                      __typename?: "BasicProperty"
                                      alias?: string | null
                                      editorAlias?: string | null
                                      value?:
                                        | {
                                            __typename?: "BasicBlockGridModel"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicBlockListModel"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicContentPicker"
                                            model: string
                                            contentList: Array<{
                                              __typename?: "BasicContentPickerItem"
                                              id: number
                                              absoluteUrl: string
                                              key: any
                                              name?: string | null
                                              url: string
                                              urlSegment?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicDateTimePicker"
                                            model: string
                                            dateTime?: any | null
                                          }
                                        | {
                                            __typename?: "BasicLabel"
                                            model: string
                                            label?: any | null
                                          }
                                        | {
                                            __typename?: "BasicMediaPicker"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicMemberPicker"
                                            model: string
                                            members: Array<{
                                              __typename?: "BasicMemberPickerItem"
                                              id?: number | null
                                              name?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicMultiUrlPicker"
                                            model: string
                                            links: Array<{
                                              __typename?: "BasicMultiUrlPickerItem"
                                              name?: string | null
                                              target?: string | null
                                              type: LinkType
                                              url?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicNestedContent"
                                            model: string
                                            elements?: Array<{
                                              __typename?: "BasicNestedContentElement"
                                              properties: Array<{
                                                __typename?: "BasicProperty"
                                                alias?: string | null
                                                editorAlias?: string | null
                                                value?:
                                                  | {
                                                      __typename?: "BasicBlockGridModel"
                                                      model: string
                                                    }
                                                  | {
                                                      __typename?: "BasicBlockListModel"
                                                      model: string
                                                    }
                                                  | {
                                                      __typename?: "BasicContentPicker"
                                                      model: string
                                                      contentList: Array<{
                                                        __typename?: "BasicContentPickerItem"
                                                        id: number
                                                        absoluteUrl: string
                                                        key: any
                                                        name?: string | null
                                                        url: string
                                                        urlSegment?:
                                                          | string
                                                          | null
                                                      }>
                                                    }
                                                  | {
                                                      __typename?: "BasicDateTimePicker"
                                                      model: string
                                                      dateTime?: any | null
                                                    }
                                                  | {
                                                      __typename?: "BasicLabel"
                                                      model: string
                                                      label?: any | null
                                                    }
                                                  | {
                                                      __typename?: "BasicMediaPicker"
                                                      model: string
                                                    }
                                                  | {
                                                      __typename?: "BasicMemberPicker"
                                                      model: string
                                                      members: Array<{
                                                        __typename?: "BasicMemberPickerItem"
                                                        id?: number | null
                                                        name?: string | null
                                                      }>
                                                    }
                                                  | {
                                                      __typename?: "BasicMultiUrlPicker"
                                                      model: string
                                                      links: Array<{
                                                        __typename?: "BasicMultiUrlPickerItem"
                                                        name?: string | null
                                                        target?: string | null
                                                        type: LinkType
                                                        url?: string | null
                                                      }>
                                                    }
                                                  | {
                                                      __typename?: "BasicNestedContent"
                                                      model: string
                                                    }
                                                  | {
                                                      __typename?: "BasicPropertyValue"
                                                      model: string
                                                      value?: any | null
                                                    }
                                                  | {
                                                      __typename?: "BasicRichText"
                                                      model: string
                                                      richText?: string | null
                                                    }
                                                  | {
                                                      __typename?: "BasicUnsupportedPropertyValue"
                                                      model: string
                                                      message: string
                                                    }
                                                  | {
                                                      __typename?: "MintMediaPicker"
                                                      model: string
                                                      mediaItems: Array<{
                                                        __typename?: "MintMediaPickerItem"
                                                        id: number
                                                        url: string
                                                        altText?: string | null
                                                      }>
                                                    }
                                                  | null
                                              } | null>
                                            }> | null
                                          }
                                        | {
                                            __typename?: "BasicPropertyValue"
                                            model: string
                                            value?: any | null
                                          }
                                        | {
                                            __typename?: "BasicRichText"
                                            model: string
                                            richText?: string | null
                                          }
                                        | {
                                            __typename?: "BasicUnsupportedPropertyValue"
                                            model: string
                                            message: string
                                          }
                                        | {
                                            __typename?: "MintMediaPicker"
                                            model: string
                                            mediaItems: Array<{
                                              __typename?: "MintMediaPickerItem"
                                              id: number
                                              url: string
                                              altText?: string | null
                                            }>
                                          }
                                        | null
                                    } | null>
                                  }>
                                }
                              | {
                                  __typename?: "BasicMultiUrlPicker"
                                  valueType: string
                                  links: Array<{
                                    __typename?: "BasicMultiUrlPickerItem"
                                    name?: string | null
                                    target?: string | null
                                    type: LinkType
                                    url?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicNestedContent"
                                  valueType: string
                                  elements?: Array<{
                                    __typename?: "BasicNestedContentElement"
                                    properties: Array<{
                                      __typename?: "BasicProperty"
                                      alias?: string | null
                                      editorAlias?: string | null
                                      value?:
                                        | {
                                            __typename?: "BasicBlockGridModel"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicBlockListModel"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicContentPicker"
                                            model: string
                                            contentList: Array<{
                                              __typename?: "BasicContentPickerItem"
                                              id: number
                                              absoluteUrl: string
                                              key: any
                                              name?: string | null
                                              url: string
                                              urlSegment?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicDateTimePicker"
                                            model: string
                                            dateTime?: any | null
                                          }
                                        | {
                                            __typename?: "BasicLabel"
                                            model: string
                                            label?: any | null
                                          }
                                        | {
                                            __typename?: "BasicMediaPicker"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicMemberPicker"
                                            model: string
                                            members: Array<{
                                              __typename?: "BasicMemberPickerItem"
                                              id?: number | null
                                              name?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicMultiUrlPicker"
                                            model: string
                                            links: Array<{
                                              __typename?: "BasicMultiUrlPickerItem"
                                              name?: string | null
                                              target?: string | null
                                              type: LinkType
                                              url?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicNestedContent"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicPropertyValue"
                                            model: string
                                            value?: any | null
                                          }
                                        | {
                                            __typename?: "BasicRichText"
                                            model: string
                                            richText?: string | null
                                          }
                                        | {
                                            __typename?: "BasicUnsupportedPropertyValue"
                                            model: string
                                            message: string
                                          }
                                        | {
                                            __typename?: "MintMediaPicker"
                                            model: string
                                            mediaItems: Array<{
                                              __typename?: "MintMediaPickerItem"
                                              id: number
                                              url: string
                                              altText?: string | null
                                            }>
                                          }
                                        | null
                                    } | null>
                                  }> | null
                                }
                              | {
                                  __typename?: "BasicPropertyValue"
                                  valueType: string
                                  value?: any | null
                                }
                              | {
                                  __typename?: "BasicRichText"
                                  valueType: string
                                  richText?: string | null
                                }
                              | {
                                  __typename?: "BasicUnsupportedPropertyValue"
                                  message: string
                                  valueType: string
                                }
                              | {
                                  __typename?: "MintMediaPicker"
                                  valueType: string
                                  mediaItems: Array<{
                                    __typename?: "MintMediaPickerItem"
                                    id: number
                                    url: string
                                    altText?: string | null
                                  }>
                                }
                              | null
                          } | null>
                          areas: Array<{
                            __typename?: "BasicBlockGridArea"
                            alias?: string | null
                            rowSpan: number
                            columnSpan: number
                          } | null>
                        }> | null
                      } | null>
                    }> | null
                  }
                | {
                    __typename?: "BasicBlockListModel"
                    valueType: string
                    blocks?: Array<{
                      __typename?: "BasicBlockListItem"
                      blockType?: string | null
                      properties: Array<{
                        __typename?: "BasicProperty"
                        propertyName?: string | null
                        propertyValue?:
                          | {
                              __typename?: "BasicBlockGridModel"
                              valueType: string
                            }
                          | {
                              __typename?: "BasicBlockListModel"
                              valueType: string
                              blocks?: Array<{
                                __typename?: "BasicBlockListItem"
                                blockType?: string | null
                                properties: Array<{
                                  __typename?: "BasicProperty"
                                  propertyName?: string | null
                                  propertyValue?:
                                    | {
                                        __typename?: "BasicBlockGridModel"
                                        valueType: string
                                      }
                                    | {
                                        __typename?: "BasicBlockListModel"
                                        valueType: string
                                        blocks?: Array<{
                                          __typename?: "BasicBlockListItem"
                                          blockType?: string | null
                                          properties: Array<{
                                            __typename?: "BasicProperty"
                                            propertyName?: string | null
                                            propertyValue?:
                                              | {
                                                  __typename?: "BasicBlockGridModel"
                                                  valueType: string
                                                }
                                              | {
                                                  __typename?: "BasicBlockListModel"
                                                  valueType: string
                                                  blocks?: Array<{
                                                    __typename?: "BasicBlockListItem"
                                                    blockType?: string | null
                                                    properties: Array<{
                                                      __typename?: "BasicProperty"
                                                      propertyName?:
                                                        | string
                                                        | null
                                                      propertyValue?:
                                                        | {
                                                            __typename?: "BasicBlockGridModel"
                                                            valueType: string
                                                          }
                                                        | {
                                                            __typename?: "BasicBlockListModel"
                                                            valueType: string
                                                            blocks?: Array<{
                                                              __typename?: "BasicBlockListItem"
                                                              blockType?:
                                                                | string
                                                                | null
                                                              properties: Array<{
                                                                __typename?: "BasicProperty"
                                                                propertyName?:
                                                                  | string
                                                                  | null
                                                                propertyValue?:
                                                                  | {
                                                                      __typename?: "BasicBlockGridModel"
                                                                      valueType: string
                                                                    }
                                                                  | {
                                                                      __typename?: "BasicBlockListModel"
                                                                      valueType: string
                                                                    }
                                                                  | {
                                                                      __typename?: "BasicContentPicker"
                                                                      valueType: string
                                                                      contentList: Array<{
                                                                        __typename?: "BasicContentPickerItem"
                                                                        id: number
                                                                        absoluteUrl: string
                                                                        key: any
                                                                        name?:
                                                                          | string
                                                                          | null
                                                                        url: string
                                                                        urlSegment?:
                                                                          | string
                                                                          | null
                                                                      }>
                                                                    }
                                                                  | {
                                                                      __typename?: "BasicDateTimePicker"
                                                                      valueType: string
                                                                      dateTime?:
                                                                        | any
                                                                        | null
                                                                    }
                                                                  | {
                                                                      __typename?: "BasicLabel"
                                                                      valueType: string
                                                                      label?:
                                                                        | any
                                                                        | null
                                                                    }
                                                                  | {
                                                                      __typename?: "BasicMediaPicker"
                                                                      valueType: string
                                                                    }
                                                                  | {
                                                                      __typename?: "BasicMemberPicker"
                                                                      valueType: string
                                                                      members: Array<{
                                                                        __typename?: "BasicMemberPickerItem"
                                                                        id?:
                                                                          | number
                                                                          | null
                                                                        name?:
                                                                          | string
                                                                          | null
                                                                        properties: Array<{
                                                                          __typename?: "BasicProperty"
                                                                          alias?:
                                                                            | string
                                                                            | null
                                                                          editorAlias?:
                                                                            | string
                                                                            | null
                                                                          value?:
                                                                            | {
                                                                                __typename?: "BasicBlockGridModel"
                                                                                model: string
                                                                              }
                                                                            | {
                                                                                __typename?: "BasicBlockListModel"
                                                                                model: string
                                                                              }
                                                                            | {
                                                                                __typename?: "BasicContentPicker"
                                                                                model: string
                                                                                contentList: Array<{
                                                                                  __typename?: "BasicContentPickerItem"
                                                                                  id: number
                                                                                  absoluteUrl: string
                                                                                  key: any
                                                                                  name?:
                                                                                    | string
                                                                                    | null
                                                                                  url: string
                                                                                  urlSegment?:
                                                                                    | string
                                                                                    | null
                                                                                }>
                                                                              }
                                                                            | {
                                                                                __typename?: "BasicDateTimePicker"
                                                                                model: string
                                                                                dateTime?:
                                                                                  | any
                                                                                  | null
                                                                              }
                                                                            | {
                                                                                __typename?: "BasicLabel"
                                                                                model: string
                                                                                label?:
                                                                                  | any
                                                                                  | null
                                                                              }
                                                                            | {
                                                                                __typename?: "BasicMediaPicker"
                                                                                model: string
                                                                              }
                                                                            | {
                                                                                __typename?: "BasicMemberPicker"
                                                                                model: string
                                                                                members: Array<{
                                                                                  __typename?: "BasicMemberPickerItem"
                                                                                  id?:
                                                                                    | number
                                                                                    | null
                                                                                  name?:
                                                                                    | string
                                                                                    | null
                                                                                }>
                                                                              }
                                                                            | {
                                                                                __typename?: "BasicMultiUrlPicker"
                                                                                model: string
                                                                                links: Array<{
                                                                                  __typename?: "BasicMultiUrlPickerItem"
                                                                                  name?:
                                                                                    | string
                                                                                    | null
                                                                                  target?:
                                                                                    | string
                                                                                    | null
                                                                                  type: LinkType
                                                                                  url?:
                                                                                    | string
                                                                                    | null
                                                                                }>
                                                                              }
                                                                            | {
                                                                                __typename?: "BasicNestedContent"
                                                                                model: string
                                                                                elements?: Array<{
                                                                                  __typename?: "BasicNestedContentElement"
                                                                                  properties: Array<{
                                                                                    __typename?: "BasicProperty"
                                                                                    alias?:
                                                                                      | string
                                                                                      | null
                                                                                    editorAlias?:
                                                                                      | string
                                                                                      | null
                                                                                    value?:
                                                                                      | {
                                                                                          __typename?: "BasicBlockGridModel"
                                                                                          model: string
                                                                                        }
                                                                                      | {
                                                                                          __typename?: "BasicBlockListModel"
                                                                                          model: string
                                                                                        }
                                                                                      | {
                                                                                          __typename?: "BasicContentPicker"
                                                                                          model: string
                                                                                          contentList: Array<{
                                                                                            __typename?: "BasicContentPickerItem"
                                                                                            id: number
                                                                                            absoluteUrl: string
                                                                                            key: any
                                                                                            name?:
                                                                                              | string
                                                                                              | null
                                                                                            url: string
                                                                                            urlSegment?:
                                                                                              | string
                                                                                              | null
                                                                                          }>
                                                                                        }
                                                                                      | {
                                                                                          __typename?: "BasicDateTimePicker"
                                                                                          model: string
                                                                                          dateTime?:
                                                                                            | any
                                                                                            | null
                                                                                        }
                                                                                      | {
                                                                                          __typename?: "BasicLabel"
                                                                                          model: string
                                                                                          label?:
                                                                                            | any
                                                                                            | null
                                                                                        }
                                                                                      | {
                                                                                          __typename?: "BasicMediaPicker"
                                                                                          model: string
                                                                                        }
                                                                                      | {
                                                                                          __typename?: "BasicMemberPicker"
                                                                                          model: string
                                                                                          members: Array<{
                                                                                            __typename?: "BasicMemberPickerItem"
                                                                                            id?:
                                                                                              | number
                                                                                              | null
                                                                                            name?:
                                                                                              | string
                                                                                              | null
                                                                                          }>
                                                                                        }
                                                                                      | {
                                                                                          __typename?: "BasicMultiUrlPicker"
                                                                                          model: string
                                                                                          links: Array<{
                                                                                            __typename?: "BasicMultiUrlPickerItem"
                                                                                            name?:
                                                                                              | string
                                                                                              | null
                                                                                            target?:
                                                                                              | string
                                                                                              | null
                                                                                            type: LinkType
                                                                                            url?:
                                                                                              | string
                                                                                              | null
                                                                                          }>
                                                                                        }
                                                                                      | {
                                                                                          __typename?: "BasicNestedContent"
                                                                                          model: string
                                                                                        }
                                                                                      | {
                                                                                          __typename?: "BasicPropertyValue"
                                                                                          model: string
                                                                                          value?:
                                                                                            | any
                                                                                            | null
                                                                                        }
                                                                                      | {
                                                                                          __typename?: "BasicRichText"
                                                                                          model: string
                                                                                          richText?:
                                                                                            | string
                                                                                            | null
                                                                                        }
                                                                                      | {
                                                                                          __typename?: "BasicUnsupportedPropertyValue"
                                                                                          model: string
                                                                                          message: string
                                                                                        }
                                                                                      | {
                                                                                          __typename?: "MintMediaPicker"
                                                                                          model: string
                                                                                          mediaItems: Array<{
                                                                                            __typename?: "MintMediaPickerItem"
                                                                                            id: number
                                                                                            url: string
                                                                                            altText?:
                                                                                              | string
                                                                                              | null
                                                                                          }>
                                                                                        }
                                                                                      | null
                                                                                  } | null>
                                                                                }> | null
                                                                              }
                                                                            | {
                                                                                __typename?: "BasicPropertyValue"
                                                                                model: string
                                                                                value?:
                                                                                  | any
                                                                                  | null
                                                                              }
                                                                            | {
                                                                                __typename?: "BasicRichText"
                                                                                model: string
                                                                                richText?:
                                                                                  | string
                                                                                  | null
                                                                              }
                                                                            | {
                                                                                __typename?: "BasicUnsupportedPropertyValue"
                                                                                model: string
                                                                                message: string
                                                                              }
                                                                            | {
                                                                                __typename?: "MintMediaPicker"
                                                                                model: string
                                                                                mediaItems: Array<{
                                                                                  __typename?: "MintMediaPickerItem"
                                                                                  id: number
                                                                                  url: string
                                                                                  altText?:
                                                                                    | string
                                                                                    | null
                                                                                }>
                                                                              }
                                                                            | null
                                                                        } | null>
                                                                      }>
                                                                    }
                                                                  | {
                                                                      __typename?: "BasicMultiUrlPicker"
                                                                      valueType: string
                                                                      links: Array<{
                                                                        __typename?: "BasicMultiUrlPickerItem"
                                                                        name?:
                                                                          | string
                                                                          | null
                                                                        target?:
                                                                          | string
                                                                          | null
                                                                        type: LinkType
                                                                        url?:
                                                                          | string
                                                                          | null
                                                                      }>
                                                                    }
                                                                  | {
                                                                      __typename?: "BasicNestedContent"
                                                                      valueType: string
                                                                      elements?: Array<{
                                                                        __typename?: "BasicNestedContentElement"
                                                                        properties: Array<{
                                                                          __typename?: "BasicProperty"
                                                                          alias?:
                                                                            | string
                                                                            | null
                                                                          editorAlias?:
                                                                            | string
                                                                            | null
                                                                          value?:
                                                                            | {
                                                                                __typename?: "BasicBlockGridModel"
                                                                                model: string
                                                                              }
                                                                            | {
                                                                                __typename?: "BasicBlockListModel"
                                                                                model: string
                                                                              }
                                                                            | {
                                                                                __typename?: "BasicContentPicker"
                                                                                model: string
                                                                                contentList: Array<{
                                                                                  __typename?: "BasicContentPickerItem"
                                                                                  id: number
                                                                                  absoluteUrl: string
                                                                                  key: any
                                                                                  name?:
                                                                                    | string
                                                                                    | null
                                                                                  url: string
                                                                                  urlSegment?:
                                                                                    | string
                                                                                    | null
                                                                                }>
                                                                              }
                                                                            | {
                                                                                __typename?: "BasicDateTimePicker"
                                                                                model: string
                                                                                dateTime?:
                                                                                  | any
                                                                                  | null
                                                                              }
                                                                            | {
                                                                                __typename?: "BasicLabel"
                                                                                model: string
                                                                                label?:
                                                                                  | any
                                                                                  | null
                                                                              }
                                                                            | {
                                                                                __typename?: "BasicMediaPicker"
                                                                                model: string
                                                                              }
                                                                            | {
                                                                                __typename?: "BasicMemberPicker"
                                                                                model: string
                                                                                members: Array<{
                                                                                  __typename?: "BasicMemberPickerItem"
                                                                                  id?:
                                                                                    | number
                                                                                    | null
                                                                                  name?:
                                                                                    | string
                                                                                    | null
                                                                                }>
                                                                              }
                                                                            | {
                                                                                __typename?: "BasicMultiUrlPicker"
                                                                                model: string
                                                                                links: Array<{
                                                                                  __typename?: "BasicMultiUrlPickerItem"
                                                                                  name?:
                                                                                    | string
                                                                                    | null
                                                                                  target?:
                                                                                    | string
                                                                                    | null
                                                                                  type: LinkType
                                                                                  url?:
                                                                                    | string
                                                                                    | null
                                                                                }>
                                                                              }
                                                                            | {
                                                                                __typename?: "BasicNestedContent"
                                                                                model: string
                                                                              }
                                                                            | {
                                                                                __typename?: "BasicPropertyValue"
                                                                                model: string
                                                                                value?:
                                                                                  | any
                                                                                  | null
                                                                              }
                                                                            | {
                                                                                __typename?: "BasicRichText"
                                                                                model: string
                                                                                richText?:
                                                                                  | string
                                                                                  | null
                                                                              }
                                                                            | {
                                                                                __typename?: "BasicUnsupportedPropertyValue"
                                                                                model: string
                                                                                message: string
                                                                              }
                                                                            | {
                                                                                __typename?: "MintMediaPicker"
                                                                                model: string
                                                                                mediaItems: Array<{
                                                                                  __typename?: "MintMediaPickerItem"
                                                                                  id: number
                                                                                  url: string
                                                                                  altText?:
                                                                                    | string
                                                                                    | null
                                                                                }>
                                                                              }
                                                                            | null
                                                                        } | null>
                                                                      }> | null
                                                                    }
                                                                  | {
                                                                      __typename?: "BasicPropertyValue"
                                                                      valueType: string
                                                                      value?:
                                                                        | any
                                                                        | null
                                                                    }
                                                                  | {
                                                                      __typename?: "BasicRichText"
                                                                      valueType: string
                                                                      richText?:
                                                                        | string
                                                                        | null
                                                                    }
                                                                  | {
                                                                      __typename?: "BasicUnsupportedPropertyValue"
                                                                      message: string
                                                                      valueType: string
                                                                    }
                                                                  | {
                                                                      __typename?: "MintMediaPicker"
                                                                      valueType: string
                                                                      mediaItems: Array<{
                                                                        __typename?: "MintMediaPickerItem"
                                                                        id: number
                                                                        url: string
                                                                        altText?:
                                                                          | string
                                                                          | null
                                                                      }>
                                                                    }
                                                                  | null
                                                              } | null>
                                                            }> | null
                                                          }
                                                        | {
                                                            __typename?: "BasicContentPicker"
                                                            valueType: string
                                                            contentList: Array<{
                                                              __typename?: "BasicContentPickerItem"
                                                              id: number
                                                              absoluteUrl: string
                                                              key: any
                                                              name?:
                                                                | string
                                                                | null
                                                              url: string
                                                              urlSegment?:
                                                                | string
                                                                | null
                                                            }>
                                                          }
                                                        | {
                                                            __typename?: "BasicDateTimePicker"
                                                            valueType: string
                                                            dateTime?:
                                                              | any
                                                              | null
                                                          }
                                                        | {
                                                            __typename?: "BasicLabel"
                                                            valueType: string
                                                            label?: any | null
                                                          }
                                                        | {
                                                            __typename?: "BasicMediaPicker"
                                                            valueType: string
                                                          }
                                                        | {
                                                            __typename?: "BasicMemberPicker"
                                                            valueType: string
                                                            members: Array<{
                                                              __typename?: "BasicMemberPickerItem"
                                                              id?: number | null
                                                              name?:
                                                                | string
                                                                | null
                                                              properties: Array<{
                                                                __typename?: "BasicProperty"
                                                                alias?:
                                                                  | string
                                                                  | null
                                                                editorAlias?:
                                                                  | string
                                                                  | null
                                                                value?:
                                                                  | {
                                                                      __typename?: "BasicBlockGridModel"
                                                                      model: string
                                                                    }
                                                                  | {
                                                                      __typename?: "BasicBlockListModel"
                                                                      model: string
                                                                    }
                                                                  | {
                                                                      __typename?: "BasicContentPicker"
                                                                      model: string
                                                                      contentList: Array<{
                                                                        __typename?: "BasicContentPickerItem"
                                                                        id: number
                                                                        absoluteUrl: string
                                                                        key: any
                                                                        name?:
                                                                          | string
                                                                          | null
                                                                        url: string
                                                                        urlSegment?:
                                                                          | string
                                                                          | null
                                                                      }>
                                                                    }
                                                                  | {
                                                                      __typename?: "BasicDateTimePicker"
                                                                      model: string
                                                                      dateTime?:
                                                                        | any
                                                                        | null
                                                                    }
                                                                  | {
                                                                      __typename?: "BasicLabel"
                                                                      model: string
                                                                      label?:
                                                                        | any
                                                                        | null
                                                                    }
                                                                  | {
                                                                      __typename?: "BasicMediaPicker"
                                                                      model: string
                                                                    }
                                                                  | {
                                                                      __typename?: "BasicMemberPicker"
                                                                      model: string
                                                                      members: Array<{
                                                                        __typename?: "BasicMemberPickerItem"
                                                                        id?:
                                                                          | number
                                                                          | null
                                                                        name?:
                                                                          | string
                                                                          | null
                                                                      }>
                                                                    }
                                                                  | {
                                                                      __typename?: "BasicMultiUrlPicker"
                                                                      model: string
                                                                      links: Array<{
                                                                        __typename?: "BasicMultiUrlPickerItem"
                                                                        name?:
                                                                          | string
                                                                          | null
                                                                        target?:
                                                                          | string
                                                                          | null
                                                                        type: LinkType
                                                                        url?:
                                                                          | string
                                                                          | null
                                                                      }>
                                                                    }
                                                                  | {
                                                                      __typename?: "BasicNestedContent"
                                                                      model: string
                                                                      elements?: Array<{
                                                                        __typename?: "BasicNestedContentElement"
                                                                        properties: Array<{
                                                                          __typename?: "BasicProperty"
                                                                          alias?:
                                                                            | string
                                                                            | null
                                                                          editorAlias?:
                                                                            | string
                                                                            | null
                                                                          value?:
                                                                            | {
                                                                                __typename?: "BasicBlockGridModel"
                                                                                model: string
                                                                              }
                                                                            | {
                                                                                __typename?: "BasicBlockListModel"
                                                                                model: string
                                                                              }
                                                                            | {
                                                                                __typename?: "BasicContentPicker"
                                                                                model: string
                                                                                contentList: Array<{
                                                                                  __typename?: "BasicContentPickerItem"
                                                                                  id: number
                                                                                  absoluteUrl: string
                                                                                  key: any
                                                                                  name?:
                                                                                    | string
                                                                                    | null
                                                                                  url: string
                                                                                  urlSegment?:
                                                                                    | string
                                                                                    | null
                                                                                }>
                                                                              }
                                                                            | {
                                                                                __typename?: "BasicDateTimePicker"
                                                                                model: string
                                                                                dateTime?:
                                                                                  | any
                                                                                  | null
                                                                              }
                                                                            | {
                                                                                __typename?: "BasicLabel"
                                                                                model: string
                                                                                label?:
                                                                                  | any
                                                                                  | null
                                                                              }
                                                                            | {
                                                                                __typename?: "BasicMediaPicker"
                                                                                model: string
                                                                              }
                                                                            | {
                                                                                __typename?: "BasicMemberPicker"
                                                                                model: string
                                                                                members: Array<{
                                                                                  __typename?: "BasicMemberPickerItem"
                                                                                  id?:
                                                                                    | number
                                                                                    | null
                                                                                  name?:
                                                                                    | string
                                                                                    | null
                                                                                }>
                                                                              }
                                                                            | {
                                                                                __typename?: "BasicMultiUrlPicker"
                                                                                model: string
                                                                                links: Array<{
                                                                                  __typename?: "BasicMultiUrlPickerItem"
                                                                                  name?:
                                                                                    | string
                                                                                    | null
                                                                                  target?:
                                                                                    | string
                                                                                    | null
                                                                                  type: LinkType
                                                                                  url?:
                                                                                    | string
                                                                                    | null
                                                                                }>
                                                                              }
                                                                            | {
                                                                                __typename?: "BasicNestedContent"
                                                                                model: string
                                                                              }
                                                                            | {
                                                                                __typename?: "BasicPropertyValue"
                                                                                model: string
                                                                                value?:
                                                                                  | any
                                                                                  | null
                                                                              }
                                                                            | {
                                                                                __typename?: "BasicRichText"
                                                                                model: string
                                                                                richText?:
                                                                                  | string
                                                                                  | null
                                                                              }
                                                                            | {
                                                                                __typename?: "BasicUnsupportedPropertyValue"
                                                                                model: string
                                                                                message: string
                                                                              }
                                                                            | {
                                                                                __typename?: "MintMediaPicker"
                                                                                model: string
                                                                                mediaItems: Array<{
                                                                                  __typename?: "MintMediaPickerItem"
                                                                                  id: number
                                                                                  url: string
                                                                                  altText?:
                                                                                    | string
                                                                                    | null
                                                                                }>
                                                                              }
                                                                            | null
                                                                        } | null>
                                                                      }> | null
                                                                    }
                                                                  | {
                                                                      __typename?: "BasicPropertyValue"
                                                                      model: string
                                                                      value?:
                                                                        | any
                                                                        | null
                                                                    }
                                                                  | {
                                                                      __typename?: "BasicRichText"
                                                                      model: string
                                                                      richText?:
                                                                        | string
                                                                        | null
                                                                    }
                                                                  | {
                                                                      __typename?: "BasicUnsupportedPropertyValue"
                                                                      model: string
                                                                      message: string
                                                                    }
                                                                  | {
                                                                      __typename?: "MintMediaPicker"
                                                                      model: string
                                                                      mediaItems: Array<{
                                                                        __typename?: "MintMediaPickerItem"
                                                                        id: number
                                                                        url: string
                                                                        altText?:
                                                                          | string
                                                                          | null
                                                                      }>
                                                                    }
                                                                  | null
                                                              } | null>
                                                            }>
                                                          }
                                                        | {
                                                            __typename?: "BasicMultiUrlPicker"
                                                            valueType: string
                                                            links: Array<{
                                                              __typename?: "BasicMultiUrlPickerItem"
                                                              name?:
                                                                | string
                                                                | null
                                                              target?:
                                                                | string
                                                                | null
                                                              type: LinkType
                                                              url?:
                                                                | string
                                                                | null
                                                            }>
                                                          }
                                                        | {
                                                            __typename?: "BasicNestedContent"
                                                            valueType: string
                                                            elements?: Array<{
                                                              __typename?: "BasicNestedContentElement"
                                                              properties: Array<{
                                                                __typename?: "BasicProperty"
                                                                alias?:
                                                                  | string
                                                                  | null
                                                                editorAlias?:
                                                                  | string
                                                                  | null
                                                                value?:
                                                                  | {
                                                                      __typename?: "BasicBlockGridModel"
                                                                      model: string
                                                                    }
                                                                  | {
                                                                      __typename?: "BasicBlockListModel"
                                                                      model: string
                                                                    }
                                                                  | {
                                                                      __typename?: "BasicContentPicker"
                                                                      model: string
                                                                      contentList: Array<{
                                                                        __typename?: "BasicContentPickerItem"
                                                                        id: number
                                                                        absoluteUrl: string
                                                                        key: any
                                                                        name?:
                                                                          | string
                                                                          | null
                                                                        url: string
                                                                        urlSegment?:
                                                                          | string
                                                                          | null
                                                                      }>
                                                                    }
                                                                  | {
                                                                      __typename?: "BasicDateTimePicker"
                                                                      model: string
                                                                      dateTime?:
                                                                        | any
                                                                        | null
                                                                    }
                                                                  | {
                                                                      __typename?: "BasicLabel"
                                                                      model: string
                                                                      label?:
                                                                        | any
                                                                        | null
                                                                    }
                                                                  | {
                                                                      __typename?: "BasicMediaPicker"
                                                                      model: string
                                                                    }
                                                                  | {
                                                                      __typename?: "BasicMemberPicker"
                                                                      model: string
                                                                      members: Array<{
                                                                        __typename?: "BasicMemberPickerItem"
                                                                        id?:
                                                                          | number
                                                                          | null
                                                                        name?:
                                                                          | string
                                                                          | null
                                                                      }>
                                                                    }
                                                                  | {
                                                                      __typename?: "BasicMultiUrlPicker"
                                                                      model: string
                                                                      links: Array<{
                                                                        __typename?: "BasicMultiUrlPickerItem"
                                                                        name?:
                                                                          | string
                                                                          | null
                                                                        target?:
                                                                          | string
                                                                          | null
                                                                        type: LinkType
                                                                        url?:
                                                                          | string
                                                                          | null
                                                                      }>
                                                                    }
                                                                  | {
                                                                      __typename?: "BasicNestedContent"
                                                                      model: string
                                                                    }
                                                                  | {
                                                                      __typename?: "BasicPropertyValue"
                                                                      model: string
                                                                      value?:
                                                                        | any
                                                                        | null
                                                                    }
                                                                  | {
                                                                      __typename?: "BasicRichText"
                                                                      model: string
                                                                      richText?:
                                                                        | string
                                                                        | null
                                                                    }
                                                                  | {
                                                                      __typename?: "BasicUnsupportedPropertyValue"
                                                                      model: string
                                                                      message: string
                                                                    }
                                                                  | {
                                                                      __typename?: "MintMediaPicker"
                                                                      model: string
                                                                      mediaItems: Array<{
                                                                        __typename?: "MintMediaPickerItem"
                                                                        id: number
                                                                        url: string
                                                                        altText?:
                                                                          | string
                                                                          | null
                                                                      }>
                                                                    }
                                                                  | null
                                                              } | null>
                                                            }> | null
                                                          }
                                                        | {
                                                            __typename?: "BasicPropertyValue"
                                                            valueType: string
                                                            value?: any | null
                                                          }
                                                        | {
                                                            __typename?: "BasicRichText"
                                                            valueType: string
                                                            richText?:
                                                              | string
                                                              | null
                                                          }
                                                        | {
                                                            __typename?: "BasicUnsupportedPropertyValue"
                                                            message: string
                                                            valueType: string
                                                          }
                                                        | {
                                                            __typename?: "MintMediaPicker"
                                                            valueType: string
                                                            mediaItems: Array<{
                                                              __typename?: "MintMediaPickerItem"
                                                              id: number
                                                              url: string
                                                              altText?:
                                                                | string
                                                                | null
                                                            }>
                                                          }
                                                        | null
                                                    } | null>
                                                  }> | null
                                                }
                                              | {
                                                  __typename?: "BasicContentPicker"
                                                  valueType: string
                                                  contentList: Array<{
                                                    __typename?: "BasicContentPickerItem"
                                                    id: number
                                                    absoluteUrl: string
                                                    key: any
                                                    name?: string | null
                                                    url: string
                                                    urlSegment?: string | null
                                                  }>
                                                }
                                              | {
                                                  __typename?: "BasicDateTimePicker"
                                                  valueType: string
                                                  dateTime?: any | null
                                                }
                                              | {
                                                  __typename?: "BasicLabel"
                                                  valueType: string
                                                  label?: any | null
                                                }
                                              | {
                                                  __typename?: "BasicMediaPicker"
                                                  valueType: string
                                                }
                                              | {
                                                  __typename?: "BasicMemberPicker"
                                                  valueType: string
                                                  members: Array<{
                                                    __typename?: "BasicMemberPickerItem"
                                                    id?: number | null
                                                    name?: string | null
                                                    properties: Array<{
                                                      __typename?: "BasicProperty"
                                                      alias?: string | null
                                                      editorAlias?:
                                                        | string
                                                        | null
                                                      value?:
                                                        | {
                                                            __typename?: "BasicBlockGridModel"
                                                            model: string
                                                          }
                                                        | {
                                                            __typename?: "BasicBlockListModel"
                                                            model: string
                                                          }
                                                        | {
                                                            __typename?: "BasicContentPicker"
                                                            model: string
                                                            contentList: Array<{
                                                              __typename?: "BasicContentPickerItem"
                                                              id: number
                                                              absoluteUrl: string
                                                              key: any
                                                              name?:
                                                                | string
                                                                | null
                                                              url: string
                                                              urlSegment?:
                                                                | string
                                                                | null
                                                            }>
                                                          }
                                                        | {
                                                            __typename?: "BasicDateTimePicker"
                                                            model: string
                                                            dateTime?:
                                                              | any
                                                              | null
                                                          }
                                                        | {
                                                            __typename?: "BasicLabel"
                                                            model: string
                                                            label?: any | null
                                                          }
                                                        | {
                                                            __typename?: "BasicMediaPicker"
                                                            model: string
                                                          }
                                                        | {
                                                            __typename?: "BasicMemberPicker"
                                                            model: string
                                                            members: Array<{
                                                              __typename?: "BasicMemberPickerItem"
                                                              id?: number | null
                                                              name?:
                                                                | string
                                                                | null
                                                            }>
                                                          }
                                                        | {
                                                            __typename?: "BasicMultiUrlPicker"
                                                            model: string
                                                            links: Array<{
                                                              __typename?: "BasicMultiUrlPickerItem"
                                                              name?:
                                                                | string
                                                                | null
                                                              target?:
                                                                | string
                                                                | null
                                                              type: LinkType
                                                              url?:
                                                                | string
                                                                | null
                                                            }>
                                                          }
                                                        | {
                                                            __typename?: "BasicNestedContent"
                                                            model: string
                                                            elements?: Array<{
                                                              __typename?: "BasicNestedContentElement"
                                                              properties: Array<{
                                                                __typename?: "BasicProperty"
                                                                alias?:
                                                                  | string
                                                                  | null
                                                                editorAlias?:
                                                                  | string
                                                                  | null
                                                                value?:
                                                                  | {
                                                                      __typename?: "BasicBlockGridModel"
                                                                      model: string
                                                                    }
                                                                  | {
                                                                      __typename?: "BasicBlockListModel"
                                                                      model: string
                                                                    }
                                                                  | {
                                                                      __typename?: "BasicContentPicker"
                                                                      model: string
                                                                      contentList: Array<{
                                                                        __typename?: "BasicContentPickerItem"
                                                                        id: number
                                                                        absoluteUrl: string
                                                                        key: any
                                                                        name?:
                                                                          | string
                                                                          | null
                                                                        url: string
                                                                        urlSegment?:
                                                                          | string
                                                                          | null
                                                                      }>
                                                                    }
                                                                  | {
                                                                      __typename?: "BasicDateTimePicker"
                                                                      model: string
                                                                      dateTime?:
                                                                        | any
                                                                        | null
                                                                    }
                                                                  | {
                                                                      __typename?: "BasicLabel"
                                                                      model: string
                                                                      label?:
                                                                        | any
                                                                        | null
                                                                    }
                                                                  | {
                                                                      __typename?: "BasicMediaPicker"
                                                                      model: string
                                                                    }
                                                                  | {
                                                                      __typename?: "BasicMemberPicker"
                                                                      model: string
                                                                      members: Array<{
                                                                        __typename?: "BasicMemberPickerItem"
                                                                        id?:
                                                                          | number
                                                                          | null
                                                                        name?:
                                                                          | string
                                                                          | null
                                                                      }>
                                                                    }
                                                                  | {
                                                                      __typename?: "BasicMultiUrlPicker"
                                                                      model: string
                                                                      links: Array<{
                                                                        __typename?: "BasicMultiUrlPickerItem"
                                                                        name?:
                                                                          | string
                                                                          | null
                                                                        target?:
                                                                          | string
                                                                          | null
                                                                        type: LinkType
                                                                        url?:
                                                                          | string
                                                                          | null
                                                                      }>
                                                                    }
                                                                  | {
                                                                      __typename?: "BasicNestedContent"
                                                                      model: string
                                                                    }
                                                                  | {
                                                                      __typename?: "BasicPropertyValue"
                                                                      model: string
                                                                      value?:
                                                                        | any
                                                                        | null
                                                                    }
                                                                  | {
                                                                      __typename?: "BasicRichText"
                                                                      model: string
                                                                      richText?:
                                                                        | string
                                                                        | null
                                                                    }
                                                                  | {
                                                                      __typename?: "BasicUnsupportedPropertyValue"
                                                                      model: string
                                                                      message: string
                                                                    }
                                                                  | {
                                                                      __typename?: "MintMediaPicker"
                                                                      model: string
                                                                      mediaItems: Array<{
                                                                        __typename?: "MintMediaPickerItem"
                                                                        id: number
                                                                        url: string
                                                                        altText?:
                                                                          | string
                                                                          | null
                                                                      }>
                                                                    }
                                                                  | null
                                                              } | null>
                                                            }> | null
                                                          }
                                                        | {
                                                            __typename?: "BasicPropertyValue"
                                                            model: string
                                                            value?: any | null
                                                          }
                                                        | {
                                                            __typename?: "BasicRichText"
                                                            model: string
                                                            richText?:
                                                              | string
                                                              | null
                                                          }
                                                        | {
                                                            __typename?: "BasicUnsupportedPropertyValue"
                                                            model: string
                                                            message: string
                                                          }
                                                        | {
                                                            __typename?: "MintMediaPicker"
                                                            model: string
                                                            mediaItems: Array<{
                                                              __typename?: "MintMediaPickerItem"
                                                              id: number
                                                              url: string
                                                              altText?:
                                                                | string
                                                                | null
                                                            }>
                                                          }
                                                        | null
                                                    } | null>
                                                  }>
                                                }
                                              | {
                                                  __typename?: "BasicMultiUrlPicker"
                                                  valueType: string
                                                  links: Array<{
                                                    __typename?: "BasicMultiUrlPickerItem"
                                                    name?: string | null
                                                    target?: string | null
                                                    type: LinkType
                                                    url?: string | null
                                                  }>
                                                }
                                              | {
                                                  __typename?: "BasicNestedContent"
                                                  valueType: string
                                                  elements?: Array<{
                                                    __typename?: "BasicNestedContentElement"
                                                    properties: Array<{
                                                      __typename?: "BasicProperty"
                                                      alias?: string | null
                                                      editorAlias?:
                                                        | string
                                                        | null
                                                      value?:
                                                        | {
                                                            __typename?: "BasicBlockGridModel"
                                                            model: string
                                                          }
                                                        | {
                                                            __typename?: "BasicBlockListModel"
                                                            model: string
                                                          }
                                                        | {
                                                            __typename?: "BasicContentPicker"
                                                            model: string
                                                            contentList: Array<{
                                                              __typename?: "BasicContentPickerItem"
                                                              id: number
                                                              absoluteUrl: string
                                                              key: any
                                                              name?:
                                                                | string
                                                                | null
                                                              url: string
                                                              urlSegment?:
                                                                | string
                                                                | null
                                                            }>
                                                          }
                                                        | {
                                                            __typename?: "BasicDateTimePicker"
                                                            model: string
                                                            dateTime?:
                                                              | any
                                                              | null
                                                          }
                                                        | {
                                                            __typename?: "BasicLabel"
                                                            model: string
                                                            label?: any | null
                                                          }
                                                        | {
                                                            __typename?: "BasicMediaPicker"
                                                            model: string
                                                          }
                                                        | {
                                                            __typename?: "BasicMemberPicker"
                                                            model: string
                                                            members: Array<{
                                                              __typename?: "BasicMemberPickerItem"
                                                              id?: number | null
                                                              name?:
                                                                | string
                                                                | null
                                                            }>
                                                          }
                                                        | {
                                                            __typename?: "BasicMultiUrlPicker"
                                                            model: string
                                                            links: Array<{
                                                              __typename?: "BasicMultiUrlPickerItem"
                                                              name?:
                                                                | string
                                                                | null
                                                              target?:
                                                                | string
                                                                | null
                                                              type: LinkType
                                                              url?:
                                                                | string
                                                                | null
                                                            }>
                                                          }
                                                        | {
                                                            __typename?: "BasicNestedContent"
                                                            model: string
                                                          }
                                                        | {
                                                            __typename?: "BasicPropertyValue"
                                                            model: string
                                                            value?: any | null
                                                          }
                                                        | {
                                                            __typename?: "BasicRichText"
                                                            model: string
                                                            richText?:
                                                              | string
                                                              | null
                                                          }
                                                        | {
                                                            __typename?: "BasicUnsupportedPropertyValue"
                                                            model: string
                                                            message: string
                                                          }
                                                        | {
                                                            __typename?: "MintMediaPicker"
                                                            model: string
                                                            mediaItems: Array<{
                                                              __typename?: "MintMediaPickerItem"
                                                              id: number
                                                              url: string
                                                              altText?:
                                                                | string
                                                                | null
                                                            }>
                                                          }
                                                        | null
                                                    } | null>
                                                  }> | null
                                                }
                                              | {
                                                  __typename?: "BasicPropertyValue"
                                                  valueType: string
                                                  value?: any | null
                                                }
                                              | {
                                                  __typename?: "BasicRichText"
                                                  valueType: string
                                                  richText?: string | null
                                                }
                                              | {
                                                  __typename?: "BasicUnsupportedPropertyValue"
                                                  message: string
                                                  valueType: string
                                                }
                                              | {
                                                  __typename?: "MintMediaPicker"
                                                  valueType: string
                                                  mediaItems: Array<{
                                                    __typename?: "MintMediaPickerItem"
                                                    id: number
                                                    url: string
                                                    altText?: string | null
                                                  }>
                                                }
                                              | null
                                          } | null>
                                        }> | null
                                      }
                                    | {
                                        __typename?: "BasicContentPicker"
                                        valueType: string
                                        contentList: Array<{
                                          __typename?: "BasicContentPickerItem"
                                          id: number
                                          absoluteUrl: string
                                          key: any
                                          name?: string | null
                                          url: string
                                          urlSegment?: string | null
                                        }>
                                      }
                                    | {
                                        __typename?: "BasicDateTimePicker"
                                        valueType: string
                                        dateTime?: any | null
                                      }
                                    | {
                                        __typename?: "BasicLabel"
                                        valueType: string
                                        label?: any | null
                                      }
                                    | {
                                        __typename?: "BasicMediaPicker"
                                        valueType: string
                                      }
                                    | {
                                        __typename?: "BasicMemberPicker"
                                        valueType: string
                                        members: Array<{
                                          __typename?: "BasicMemberPickerItem"
                                          id?: number | null
                                          name?: string | null
                                          properties: Array<{
                                            __typename?: "BasicProperty"
                                            alias?: string | null
                                            editorAlias?: string | null
                                            value?:
                                              | {
                                                  __typename?: "BasicBlockGridModel"
                                                  model: string
                                                }
                                              | {
                                                  __typename?: "BasicBlockListModel"
                                                  model: string
                                                }
                                              | {
                                                  __typename?: "BasicContentPicker"
                                                  model: string
                                                  contentList: Array<{
                                                    __typename?: "BasicContentPickerItem"
                                                    id: number
                                                    absoluteUrl: string
                                                    key: any
                                                    name?: string | null
                                                    url: string
                                                    urlSegment?: string | null
                                                  }>
                                                }
                                              | {
                                                  __typename?: "BasicDateTimePicker"
                                                  model: string
                                                  dateTime?: any | null
                                                }
                                              | {
                                                  __typename?: "BasicLabel"
                                                  model: string
                                                  label?: any | null
                                                }
                                              | {
                                                  __typename?: "BasicMediaPicker"
                                                  model: string
                                                }
                                              | {
                                                  __typename?: "BasicMemberPicker"
                                                  model: string
                                                  members: Array<{
                                                    __typename?: "BasicMemberPickerItem"
                                                    id?: number | null
                                                    name?: string | null
                                                  }>
                                                }
                                              | {
                                                  __typename?: "BasicMultiUrlPicker"
                                                  model: string
                                                  links: Array<{
                                                    __typename?: "BasicMultiUrlPickerItem"
                                                    name?: string | null
                                                    target?: string | null
                                                    type: LinkType
                                                    url?: string | null
                                                  }>
                                                }
                                              | {
                                                  __typename?: "BasicNestedContent"
                                                  model: string
                                                  elements?: Array<{
                                                    __typename?: "BasicNestedContentElement"
                                                    properties: Array<{
                                                      __typename?: "BasicProperty"
                                                      alias?: string | null
                                                      editorAlias?:
                                                        | string
                                                        | null
                                                      value?:
                                                        | {
                                                            __typename?: "BasicBlockGridModel"
                                                            model: string
                                                          }
                                                        | {
                                                            __typename?: "BasicBlockListModel"
                                                            model: string
                                                          }
                                                        | {
                                                            __typename?: "BasicContentPicker"
                                                            model: string
                                                            contentList: Array<{
                                                              __typename?: "BasicContentPickerItem"
                                                              id: number
                                                              absoluteUrl: string
                                                              key: any
                                                              name?:
                                                                | string
                                                                | null
                                                              url: string
                                                              urlSegment?:
                                                                | string
                                                                | null
                                                            }>
                                                          }
                                                        | {
                                                            __typename?: "BasicDateTimePicker"
                                                            model: string
                                                            dateTime?:
                                                              | any
                                                              | null
                                                          }
                                                        | {
                                                            __typename?: "BasicLabel"
                                                            model: string
                                                            label?: any | null
                                                          }
                                                        | {
                                                            __typename?: "BasicMediaPicker"
                                                            model: string
                                                          }
                                                        | {
                                                            __typename?: "BasicMemberPicker"
                                                            model: string
                                                            members: Array<{
                                                              __typename?: "BasicMemberPickerItem"
                                                              id?: number | null
                                                              name?:
                                                                | string
                                                                | null
                                                            }>
                                                          }
                                                        | {
                                                            __typename?: "BasicMultiUrlPicker"
                                                            model: string
                                                            links: Array<{
                                                              __typename?: "BasicMultiUrlPickerItem"
                                                              name?:
                                                                | string
                                                                | null
                                                              target?:
                                                                | string
                                                                | null
                                                              type: LinkType
                                                              url?:
                                                                | string
                                                                | null
                                                            }>
                                                          }
                                                        | {
                                                            __typename?: "BasicNestedContent"
                                                            model: string
                                                          }
                                                        | {
                                                            __typename?: "BasicPropertyValue"
                                                            model: string
                                                            value?: any | null
                                                          }
                                                        | {
                                                            __typename?: "BasicRichText"
                                                            model: string
                                                            richText?:
                                                              | string
                                                              | null
                                                          }
                                                        | {
                                                            __typename?: "BasicUnsupportedPropertyValue"
                                                            model: string
                                                            message: string
                                                          }
                                                        | {
                                                            __typename?: "MintMediaPicker"
                                                            model: string
                                                            mediaItems: Array<{
                                                              __typename?: "MintMediaPickerItem"
                                                              id: number
                                                              url: string
                                                              altText?:
                                                                | string
                                                                | null
                                                            }>
                                                          }
                                                        | null
                                                    } | null>
                                                  }> | null
                                                }
                                              | {
                                                  __typename?: "BasicPropertyValue"
                                                  model: string
                                                  value?: any | null
                                                }
                                              | {
                                                  __typename?: "BasicRichText"
                                                  model: string
                                                  richText?: string | null
                                                }
                                              | {
                                                  __typename?: "BasicUnsupportedPropertyValue"
                                                  model: string
                                                  message: string
                                                }
                                              | {
                                                  __typename?: "MintMediaPicker"
                                                  model: string
                                                  mediaItems: Array<{
                                                    __typename?: "MintMediaPickerItem"
                                                    id: number
                                                    url: string
                                                    altText?: string | null
                                                  }>
                                                }
                                              | null
                                          } | null>
                                        }>
                                      }
                                    | {
                                        __typename?: "BasicMultiUrlPicker"
                                        valueType: string
                                        links: Array<{
                                          __typename?: "BasicMultiUrlPickerItem"
                                          name?: string | null
                                          target?: string | null
                                          type: LinkType
                                          url?: string | null
                                        }>
                                      }
                                    | {
                                        __typename?: "BasicNestedContent"
                                        valueType: string
                                        elements?: Array<{
                                          __typename?: "BasicNestedContentElement"
                                          properties: Array<{
                                            __typename?: "BasicProperty"
                                            alias?: string | null
                                            editorAlias?: string | null
                                            value?:
                                              | {
                                                  __typename?: "BasicBlockGridModel"
                                                  model: string
                                                }
                                              | {
                                                  __typename?: "BasicBlockListModel"
                                                  model: string
                                                }
                                              | {
                                                  __typename?: "BasicContentPicker"
                                                  model: string
                                                  contentList: Array<{
                                                    __typename?: "BasicContentPickerItem"
                                                    id: number
                                                    absoluteUrl: string
                                                    key: any
                                                    name?: string | null
                                                    url: string
                                                    urlSegment?: string | null
                                                  }>
                                                }
                                              | {
                                                  __typename?: "BasicDateTimePicker"
                                                  model: string
                                                  dateTime?: any | null
                                                }
                                              | {
                                                  __typename?: "BasicLabel"
                                                  model: string
                                                  label?: any | null
                                                }
                                              | {
                                                  __typename?: "BasicMediaPicker"
                                                  model: string
                                                }
                                              | {
                                                  __typename?: "BasicMemberPicker"
                                                  model: string
                                                  members: Array<{
                                                    __typename?: "BasicMemberPickerItem"
                                                    id?: number | null
                                                    name?: string | null
                                                  }>
                                                }
                                              | {
                                                  __typename?: "BasicMultiUrlPicker"
                                                  model: string
                                                  links: Array<{
                                                    __typename?: "BasicMultiUrlPickerItem"
                                                    name?: string | null
                                                    target?: string | null
                                                    type: LinkType
                                                    url?: string | null
                                                  }>
                                                }
                                              | {
                                                  __typename?: "BasicNestedContent"
                                                  model: string
                                                }
                                              | {
                                                  __typename?: "BasicPropertyValue"
                                                  model: string
                                                  value?: any | null
                                                }
                                              | {
                                                  __typename?: "BasicRichText"
                                                  model: string
                                                  richText?: string | null
                                                }
                                              | {
                                                  __typename?: "BasicUnsupportedPropertyValue"
                                                  model: string
                                                  message: string
                                                }
                                              | {
                                                  __typename?: "MintMediaPicker"
                                                  model: string
                                                  mediaItems: Array<{
                                                    __typename?: "MintMediaPickerItem"
                                                    id: number
                                                    url: string
                                                    altText?: string | null
                                                  }>
                                                }
                                              | null
                                          } | null>
                                        }> | null
                                      }
                                    | {
                                        __typename?: "BasicPropertyValue"
                                        valueType: string
                                        value?: any | null
                                      }
                                    | {
                                        __typename?: "BasicRichText"
                                        valueType: string
                                        richText?: string | null
                                      }
                                    | {
                                        __typename?: "BasicUnsupportedPropertyValue"
                                        message: string
                                        valueType: string
                                      }
                                    | {
                                        __typename?: "MintMediaPicker"
                                        valueType: string
                                        mediaItems: Array<{
                                          __typename?: "MintMediaPickerItem"
                                          id: number
                                          url: string
                                          altText?: string | null
                                        }>
                                      }
                                    | null
                                } | null>
                              }> | null
                            }
                          | {
                              __typename?: "BasicContentPicker"
                              valueType: string
                              contentList: Array<{
                                __typename?: "BasicContentPickerItem"
                                id: number
                                absoluteUrl: string
                                key: any
                                name?: string | null
                                url: string
                                urlSegment?: string | null
                              }>
                            }
                          | {
                              __typename?: "BasicDateTimePicker"
                              valueType: string
                              dateTime?: any | null
                            }
                          | {
                              __typename?: "BasicLabel"
                              valueType: string
                              label?: any | null
                            }
                          | {
                              __typename?: "BasicMediaPicker"
                              valueType: string
                            }
                          | {
                              __typename?: "BasicMemberPicker"
                              valueType: string
                              members: Array<{
                                __typename?: "BasicMemberPickerItem"
                                id?: number | null
                                name?: string | null
                                properties: Array<{
                                  __typename?: "BasicProperty"
                                  alias?: string | null
                                  editorAlias?: string | null
                                  value?:
                                    | {
                                        __typename?: "BasicBlockGridModel"
                                        model: string
                                      }
                                    | {
                                        __typename?: "BasicBlockListModel"
                                        model: string
                                      }
                                    | {
                                        __typename?: "BasicContentPicker"
                                        model: string
                                        contentList: Array<{
                                          __typename?: "BasicContentPickerItem"
                                          id: number
                                          absoluteUrl: string
                                          key: any
                                          name?: string | null
                                          url: string
                                          urlSegment?: string | null
                                        }>
                                      }
                                    | {
                                        __typename?: "BasicDateTimePicker"
                                        model: string
                                        dateTime?: any | null
                                      }
                                    | {
                                        __typename?: "BasicLabel"
                                        model: string
                                        label?: any | null
                                      }
                                    | {
                                        __typename?: "BasicMediaPicker"
                                        model: string
                                      }
                                    | {
                                        __typename?: "BasicMemberPicker"
                                        model: string
                                        members: Array<{
                                          __typename?: "BasicMemberPickerItem"
                                          id?: number | null
                                          name?: string | null
                                        }>
                                      }
                                    | {
                                        __typename?: "BasicMultiUrlPicker"
                                        model: string
                                        links: Array<{
                                          __typename?: "BasicMultiUrlPickerItem"
                                          name?: string | null
                                          target?: string | null
                                          type: LinkType
                                          url?: string | null
                                        }>
                                      }
                                    | {
                                        __typename?: "BasicNestedContent"
                                        model: string
                                        elements?: Array<{
                                          __typename?: "BasicNestedContentElement"
                                          properties: Array<{
                                            __typename?: "BasicProperty"
                                            alias?: string | null
                                            editorAlias?: string | null
                                            value?:
                                              | {
                                                  __typename?: "BasicBlockGridModel"
                                                  model: string
                                                }
                                              | {
                                                  __typename?: "BasicBlockListModel"
                                                  model: string
                                                }
                                              | {
                                                  __typename?: "BasicContentPicker"
                                                  model: string
                                                  contentList: Array<{
                                                    __typename?: "BasicContentPickerItem"
                                                    id: number
                                                    absoluteUrl: string
                                                    key: any
                                                    name?: string | null
                                                    url: string
                                                    urlSegment?: string | null
                                                  }>
                                                }
                                              | {
                                                  __typename?: "BasicDateTimePicker"
                                                  model: string
                                                  dateTime?: any | null
                                                }
                                              | {
                                                  __typename?: "BasicLabel"
                                                  model: string
                                                  label?: any | null
                                                }
                                              | {
                                                  __typename?: "BasicMediaPicker"
                                                  model: string
                                                }
                                              | {
                                                  __typename?: "BasicMemberPicker"
                                                  model: string
                                                  members: Array<{
                                                    __typename?: "BasicMemberPickerItem"
                                                    id?: number | null
                                                    name?: string | null
                                                  }>
                                                }
                                              | {
                                                  __typename?: "BasicMultiUrlPicker"
                                                  model: string
                                                  links: Array<{
                                                    __typename?: "BasicMultiUrlPickerItem"
                                                    name?: string | null
                                                    target?: string | null
                                                    type: LinkType
                                                    url?: string | null
                                                  }>
                                                }
                                              | {
                                                  __typename?: "BasicNestedContent"
                                                  model: string
                                                }
                                              | {
                                                  __typename?: "BasicPropertyValue"
                                                  model: string
                                                  value?: any | null
                                                }
                                              | {
                                                  __typename?: "BasicRichText"
                                                  model: string
                                                  richText?: string | null
                                                }
                                              | {
                                                  __typename?: "BasicUnsupportedPropertyValue"
                                                  model: string
                                                  message: string
                                                }
                                              | {
                                                  __typename?: "MintMediaPicker"
                                                  model: string
                                                  mediaItems: Array<{
                                                    __typename?: "MintMediaPickerItem"
                                                    id: number
                                                    url: string
                                                    altText?: string | null
                                                  }>
                                                }
                                              | null
                                          } | null>
                                        }> | null
                                      }
                                    | {
                                        __typename?: "BasicPropertyValue"
                                        model: string
                                        value?: any | null
                                      }
                                    | {
                                        __typename?: "BasicRichText"
                                        model: string
                                        richText?: string | null
                                      }
                                    | {
                                        __typename?: "BasicUnsupportedPropertyValue"
                                        model: string
                                        message: string
                                      }
                                    | {
                                        __typename?: "MintMediaPicker"
                                        model: string
                                        mediaItems: Array<{
                                          __typename?: "MintMediaPickerItem"
                                          id: number
                                          url: string
                                          altText?: string | null
                                        }>
                                      }
                                    | null
                                } | null>
                              }>
                            }
                          | {
                              __typename?: "BasicMultiUrlPicker"
                              valueType: string
                              links: Array<{
                                __typename?: "BasicMultiUrlPickerItem"
                                name?: string | null
                                target?: string | null
                                type: LinkType
                                url?: string | null
                              }>
                            }
                          | {
                              __typename?: "BasicNestedContent"
                              valueType: string
                              elements?: Array<{
                                __typename?: "BasicNestedContentElement"
                                properties: Array<{
                                  __typename?: "BasicProperty"
                                  alias?: string | null
                                  editorAlias?: string | null
                                  value?:
                                    | {
                                        __typename?: "BasicBlockGridModel"
                                        model: string
                                      }
                                    | {
                                        __typename?: "BasicBlockListModel"
                                        model: string
                                      }
                                    | {
                                        __typename?: "BasicContentPicker"
                                        model: string
                                        contentList: Array<{
                                          __typename?: "BasicContentPickerItem"
                                          id: number
                                          absoluteUrl: string
                                          key: any
                                          name?: string | null
                                          url: string
                                          urlSegment?: string | null
                                        }>
                                      }
                                    | {
                                        __typename?: "BasicDateTimePicker"
                                        model: string
                                        dateTime?: any | null
                                      }
                                    | {
                                        __typename?: "BasicLabel"
                                        model: string
                                        label?: any | null
                                      }
                                    | {
                                        __typename?: "BasicMediaPicker"
                                        model: string
                                      }
                                    | {
                                        __typename?: "BasicMemberPicker"
                                        model: string
                                        members: Array<{
                                          __typename?: "BasicMemberPickerItem"
                                          id?: number | null
                                          name?: string | null
                                        }>
                                      }
                                    | {
                                        __typename?: "BasicMultiUrlPicker"
                                        model: string
                                        links: Array<{
                                          __typename?: "BasicMultiUrlPickerItem"
                                          name?: string | null
                                          target?: string | null
                                          type: LinkType
                                          url?: string | null
                                        }>
                                      }
                                    | {
                                        __typename?: "BasicNestedContent"
                                        model: string
                                      }
                                    | {
                                        __typename?: "BasicPropertyValue"
                                        model: string
                                        value?: any | null
                                      }
                                    | {
                                        __typename?: "BasicRichText"
                                        model: string
                                        richText?: string | null
                                      }
                                    | {
                                        __typename?: "BasicUnsupportedPropertyValue"
                                        model: string
                                        message: string
                                      }
                                    | {
                                        __typename?: "MintMediaPicker"
                                        model: string
                                        mediaItems: Array<{
                                          __typename?: "MintMediaPickerItem"
                                          id: number
                                          url: string
                                          altText?: string | null
                                        }>
                                      }
                                    | null
                                } | null>
                              }> | null
                            }
                          | {
                              __typename?: "BasicPropertyValue"
                              valueType: string
                              value?: any | null
                            }
                          | {
                              __typename?: "BasicRichText"
                              valueType: string
                              richText?: string | null
                            }
                          | {
                              __typename?: "BasicUnsupportedPropertyValue"
                              message: string
                              valueType: string
                            }
                          | {
                              __typename?: "MintMediaPicker"
                              valueType: string
                              mediaItems: Array<{
                                __typename?: "MintMediaPickerItem"
                                id: number
                                url: string
                                altText?: string | null
                              }>
                            }
                          | null
                      } | null>
                    }> | null
                  }
                | {
                    __typename?: "BasicContentPicker"
                    valueType: string
                    contentList: Array<{
                      __typename?: "BasicContentPickerItem"
                      id: number
                      absoluteUrl: string
                      key: any
                      name?: string | null
                      url: string
                      urlSegment?: string | null
                    }>
                  }
                | {
                    __typename?: "BasicDateTimePicker"
                    valueType: string
                    dateTime?: any | null
                  }
                | {
                    __typename?: "BasicLabel"
                    valueType: string
                    label?: any | null
                  }
                | { __typename?: "BasicMediaPicker"; valueType: string }
                | {
                    __typename?: "BasicMemberPicker"
                    valueType: string
                    members: Array<{
                      __typename?: "BasicMemberPickerItem"
                      id?: number | null
                      name?: string | null
                      properties: Array<{
                        __typename?: "BasicProperty"
                        alias?: string | null
                        editorAlias?: string | null
                        value?:
                          | {
                              __typename?: "BasicBlockGridModel"
                              model: string
                            }
                          | {
                              __typename?: "BasicBlockListModel"
                              model: string
                            }
                          | {
                              __typename?: "BasicContentPicker"
                              model: string
                              contentList: Array<{
                                __typename?: "BasicContentPickerItem"
                                id: number
                                absoluteUrl: string
                                key: any
                                name?: string | null
                                url: string
                                urlSegment?: string | null
                              }>
                            }
                          | {
                              __typename?: "BasicDateTimePicker"
                              model: string
                              dateTime?: any | null
                            }
                          | {
                              __typename?: "BasicLabel"
                              model: string
                              label?: any | null
                            }
                          | { __typename?: "BasicMediaPicker"; model: string }
                          | {
                              __typename?: "BasicMemberPicker"
                              model: string
                              members: Array<{
                                __typename?: "BasicMemberPickerItem"
                                id?: number | null
                                name?: string | null
                              }>
                            }
                          | {
                              __typename?: "BasicMultiUrlPicker"
                              model: string
                              links: Array<{
                                __typename?: "BasicMultiUrlPickerItem"
                                name?: string | null
                                target?: string | null
                                type: LinkType
                                url?: string | null
                              }>
                            }
                          | {
                              __typename?: "BasicNestedContent"
                              model: string
                              elements?: Array<{
                                __typename?: "BasicNestedContentElement"
                                properties: Array<{
                                  __typename?: "BasicProperty"
                                  alias?: string | null
                                  editorAlias?: string | null
                                  value?:
                                    | {
                                        __typename?: "BasicBlockGridModel"
                                        model: string
                                      }
                                    | {
                                        __typename?: "BasicBlockListModel"
                                        model: string
                                      }
                                    | {
                                        __typename?: "BasicContentPicker"
                                        model: string
                                        contentList: Array<{
                                          __typename?: "BasicContentPickerItem"
                                          id: number
                                          absoluteUrl: string
                                          key: any
                                          name?: string | null
                                          url: string
                                          urlSegment?: string | null
                                        }>
                                      }
                                    | {
                                        __typename?: "BasicDateTimePicker"
                                        model: string
                                        dateTime?: any | null
                                      }
                                    | {
                                        __typename?: "BasicLabel"
                                        model: string
                                        label?: any | null
                                      }
                                    | {
                                        __typename?: "BasicMediaPicker"
                                        model: string
                                      }
                                    | {
                                        __typename?: "BasicMemberPicker"
                                        model: string
                                        members: Array<{
                                          __typename?: "BasicMemberPickerItem"
                                          id?: number | null
                                          name?: string | null
                                        }>
                                      }
                                    | {
                                        __typename?: "BasicMultiUrlPicker"
                                        model: string
                                        links: Array<{
                                          __typename?: "BasicMultiUrlPickerItem"
                                          name?: string | null
                                          target?: string | null
                                          type: LinkType
                                          url?: string | null
                                        }>
                                      }
                                    | {
                                        __typename?: "BasicNestedContent"
                                        model: string
                                      }
                                    | {
                                        __typename?: "BasicPropertyValue"
                                        model: string
                                        value?: any | null
                                      }
                                    | {
                                        __typename?: "BasicRichText"
                                        model: string
                                        richText?: string | null
                                      }
                                    | {
                                        __typename?: "BasicUnsupportedPropertyValue"
                                        model: string
                                        message: string
                                      }
                                    | {
                                        __typename?: "MintMediaPicker"
                                        model: string
                                        mediaItems: Array<{
                                          __typename?: "MintMediaPickerItem"
                                          id: number
                                          url: string
                                          altText?: string | null
                                        }>
                                      }
                                    | null
                                } | null>
                              }> | null
                            }
                          | {
                              __typename?: "BasicPropertyValue"
                              model: string
                              value?: any | null
                            }
                          | {
                              __typename?: "BasicRichText"
                              model: string
                              richText?: string | null
                            }
                          | {
                              __typename?: "BasicUnsupportedPropertyValue"
                              model: string
                              message: string
                            }
                          | {
                              __typename?: "MintMediaPicker"
                              model: string
                              mediaItems: Array<{
                                __typename?: "MintMediaPickerItem"
                                id: number
                                url: string
                                altText?: string | null
                              }>
                            }
                          | null
                      } | null>
                    }>
                  }
                | {
                    __typename?: "BasicMultiUrlPicker"
                    valueType: string
                    links: Array<{
                      __typename?: "BasicMultiUrlPickerItem"
                      name?: string | null
                      target?: string | null
                      type: LinkType
                      url?: string | null
                    }>
                  }
                | {
                    __typename?: "BasicNestedContent"
                    valueType: string
                    elements?: Array<{
                      __typename?: "BasicNestedContentElement"
                      properties: Array<{
                        __typename?: "BasicProperty"
                        alias?: string | null
                        editorAlias?: string | null
                        value?:
                          | {
                              __typename?: "BasicBlockGridModel"
                              model: string
                            }
                          | {
                              __typename?: "BasicBlockListModel"
                              model: string
                            }
                          | {
                              __typename?: "BasicContentPicker"
                              model: string
                              contentList: Array<{
                                __typename?: "BasicContentPickerItem"
                                id: number
                                absoluteUrl: string
                                key: any
                                name?: string | null
                                url: string
                                urlSegment?: string | null
                              }>
                            }
                          | {
                              __typename?: "BasicDateTimePicker"
                              model: string
                              dateTime?: any | null
                            }
                          | {
                              __typename?: "BasicLabel"
                              model: string
                              label?: any | null
                            }
                          | { __typename?: "BasicMediaPicker"; model: string }
                          | {
                              __typename?: "BasicMemberPicker"
                              model: string
                              members: Array<{
                                __typename?: "BasicMemberPickerItem"
                                id?: number | null
                                name?: string | null
                              }>
                            }
                          | {
                              __typename?: "BasicMultiUrlPicker"
                              model: string
                              links: Array<{
                                __typename?: "BasicMultiUrlPickerItem"
                                name?: string | null
                                target?: string | null
                                type: LinkType
                                url?: string | null
                              }>
                            }
                          | { __typename?: "BasicNestedContent"; model: string }
                          | {
                              __typename?: "BasicPropertyValue"
                              model: string
                              value?: any | null
                            }
                          | {
                              __typename?: "BasicRichText"
                              model: string
                              richText?: string | null
                            }
                          | {
                              __typename?: "BasicUnsupportedPropertyValue"
                              model: string
                              message: string
                            }
                          | {
                              __typename?: "MintMediaPicker"
                              model: string
                              mediaItems: Array<{
                                __typename?: "MintMediaPickerItem"
                                id: number
                                url: string
                                altText?: string | null
                              }>
                            }
                          | null
                      } | null>
                    }> | null
                  }
                | {
                    __typename?: "BasicPropertyValue"
                    valueType: string
                    value?: any | null
                  }
                | {
                    __typename?: "BasicRichText"
                    valueType: string
                    richText?: string | null
                  }
                | {
                    __typename?: "BasicUnsupportedPropertyValue"
                    message: string
                    valueType: string
                  }
                | {
                    __typename?: "MintMediaPicker"
                    valueType: string
                    mediaItems: Array<{
                      __typename?: "MintMediaPickerItem"
                      id: number
                      url: string
                      altText?: string | null
                    }>
                  }
                | null
            } | null> | null
          } | null
        } | null
      } | null
    } | null
    contentType?: {
      __typename?: "BasicContentType"
      alias?: string | null
    } | null
    children?: Array<{
      __typename?: "BasicContent"
      name?: string | null
      url?: string | null
      id?: number | null
      contentType?: {
        __typename?: "BasicContentType"
        alias?: string | null
      } | null
      properties?: Array<{
        __typename?: "BasicProperty"
        propertyName?: string | null
        propertyValue?:
          | {
              __typename?: "BasicBlockGridModel"
              gridColumns?: number | null
              valueType: string
              blocks?: Array<{
                __typename?: "BasicBlockGridItem"
                columnSpan: number
                rowSpan: number
                contentProperties: Array<{
                  __typename?: "BasicProperty"
                  value?:
                    | { __typename?: "BasicBlockGridModel"; valueType: string }
                    | { __typename?: "BasicBlockListModel"; valueType: string }
                    | {
                        __typename?: "BasicContentPicker"
                        valueType: string
                        contentList: Array<{
                          __typename?: "BasicContentPickerItem"
                          id: number
                          absoluteUrl: string
                          key: any
                          name?: string | null
                          url: string
                          urlSegment?: string | null
                        }>
                      }
                    | {
                        __typename?: "BasicDateTimePicker"
                        valueType: string
                        dateTime?: any | null
                      }
                    | {
                        __typename?: "BasicLabel"
                        valueType: string
                        label?: any | null
                      }
                    | { __typename?: "BasicMediaPicker"; valueType: string }
                    | {
                        __typename?: "BasicMemberPicker"
                        valueType: string
                        members: Array<{
                          __typename?: "BasicMemberPickerItem"
                          id?: number | null
                          name?: string | null
                          properties: Array<{
                            __typename?: "BasicProperty"
                            alias?: string | null
                            editorAlias?: string | null
                            value?:
                              | {
                                  __typename?: "BasicBlockGridModel"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicBlockListModel"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicContentPicker"
                                  model: string
                                  contentList: Array<{
                                    __typename?: "BasicContentPickerItem"
                                    id: number
                                    absoluteUrl: string
                                    key: any
                                    name?: string | null
                                    url: string
                                    urlSegment?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicDateTimePicker"
                                  model: string
                                  dateTime?: any | null
                                }
                              | {
                                  __typename?: "BasicLabel"
                                  model: string
                                  label?: any | null
                                }
                              | {
                                  __typename?: "BasicMediaPicker"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicMemberPicker"
                                  model: string
                                  members: Array<{
                                    __typename?: "BasicMemberPickerItem"
                                    id?: number | null
                                    name?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicMultiUrlPicker"
                                  model: string
                                  links: Array<{
                                    __typename?: "BasicMultiUrlPickerItem"
                                    name?: string | null
                                    target?: string | null
                                    type: LinkType
                                    url?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicNestedContent"
                                  model: string
                                  elements?: Array<{
                                    __typename?: "BasicNestedContentElement"
                                    properties: Array<{
                                      __typename?: "BasicProperty"
                                      alias?: string | null
                                      editorAlias?: string | null
                                      value?:
                                        | {
                                            __typename?: "BasicBlockGridModel"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicBlockListModel"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicContentPicker"
                                            model: string
                                            contentList: Array<{
                                              __typename?: "BasicContentPickerItem"
                                              id: number
                                              absoluteUrl: string
                                              key: any
                                              name?: string | null
                                              url: string
                                              urlSegment?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicDateTimePicker"
                                            model: string
                                            dateTime?: any | null
                                          }
                                        | {
                                            __typename?: "BasicLabel"
                                            model: string
                                            label?: any | null
                                          }
                                        | {
                                            __typename?: "BasicMediaPicker"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicMemberPicker"
                                            model: string
                                            members: Array<{
                                              __typename?: "BasicMemberPickerItem"
                                              id?: number | null
                                              name?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicMultiUrlPicker"
                                            model: string
                                            links: Array<{
                                              __typename?: "BasicMultiUrlPickerItem"
                                              name?: string | null
                                              target?: string | null
                                              type: LinkType
                                              url?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicNestedContent"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicPropertyValue"
                                            model: string
                                            value?: any | null
                                          }
                                        | {
                                            __typename?: "BasicRichText"
                                            model: string
                                            richText?: string | null
                                          }
                                        | {
                                            __typename?: "BasicUnsupportedPropertyValue"
                                            model: string
                                            message: string
                                          }
                                        | {
                                            __typename?: "MintMediaPicker"
                                            model: string
                                            mediaItems: Array<{
                                              __typename?: "MintMediaPickerItem"
                                              id: number
                                              url: string
                                              altText?: string | null
                                            }>
                                          }
                                        | null
                                    } | null>
                                  }> | null
                                }
                              | {
                                  __typename?: "BasicPropertyValue"
                                  model: string
                                  value?: any | null
                                }
                              | {
                                  __typename?: "BasicRichText"
                                  model: string
                                  richText?: string | null
                                }
                              | {
                                  __typename?: "BasicUnsupportedPropertyValue"
                                  model: string
                                  message: string
                                }
                              | {
                                  __typename?: "MintMediaPicker"
                                  model: string
                                  mediaItems: Array<{
                                    __typename?: "MintMediaPickerItem"
                                    id: number
                                    url: string
                                    altText?: string | null
                                  }>
                                }
                              | null
                          } | null>
                        }>
                      }
                    | {
                        __typename?: "BasicMultiUrlPicker"
                        valueType: string
                        links: Array<{
                          __typename?: "BasicMultiUrlPickerItem"
                          name?: string | null
                          target?: string | null
                          type: LinkType
                          url?: string | null
                        }>
                      }
                    | {
                        __typename?: "BasicNestedContent"
                        valueType: string
                        elements?: Array<{
                          __typename?: "BasicNestedContentElement"
                          properties: Array<{
                            __typename?: "BasicProperty"
                            alias?: string | null
                            editorAlias?: string | null
                            value?:
                              | {
                                  __typename?: "BasicBlockGridModel"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicBlockListModel"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicContentPicker"
                                  model: string
                                  contentList: Array<{
                                    __typename?: "BasicContentPickerItem"
                                    id: number
                                    absoluteUrl: string
                                    key: any
                                    name?: string | null
                                    url: string
                                    urlSegment?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicDateTimePicker"
                                  model: string
                                  dateTime?: any | null
                                }
                              | {
                                  __typename?: "BasicLabel"
                                  model: string
                                  label?: any | null
                                }
                              | {
                                  __typename?: "BasicMediaPicker"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicMemberPicker"
                                  model: string
                                  members: Array<{
                                    __typename?: "BasicMemberPickerItem"
                                    id?: number | null
                                    name?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicMultiUrlPicker"
                                  model: string
                                  links: Array<{
                                    __typename?: "BasicMultiUrlPickerItem"
                                    name?: string | null
                                    target?: string | null
                                    type: LinkType
                                    url?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicNestedContent"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicPropertyValue"
                                  model: string
                                  value?: any | null
                                }
                              | {
                                  __typename?: "BasicRichText"
                                  model: string
                                  richText?: string | null
                                }
                              | {
                                  __typename?: "BasicUnsupportedPropertyValue"
                                  model: string
                                  message: string
                                }
                              | {
                                  __typename?: "MintMediaPicker"
                                  model: string
                                  mediaItems: Array<{
                                    __typename?: "MintMediaPickerItem"
                                    id: number
                                    url: string
                                    altText?: string | null
                                  }>
                                }
                              | null
                          } | null>
                        }> | null
                      }
                    | {
                        __typename?: "BasicPropertyValue"
                        valueType: string
                        value?: any | null
                      }
                    | {
                        __typename?: "BasicRichText"
                        valueType: string
                        richText?: string | null
                      }
                    | {
                        __typename?: "BasicUnsupportedPropertyValue"
                        message: string
                        valueType: string
                      }
                    | {
                        __typename?: "MintMediaPicker"
                        valueType: string
                        mediaItems: Array<{
                          __typename?: "MintMediaPickerItem"
                          id: number
                          url: string
                          altText?: string | null
                        }>
                      }
                    | null
                } | null>
                settingsProperties: Array<{
                  __typename?: "BasicProperty"
                  value?:
                    | { __typename?: "BasicBlockGridModel"; valueType: string }
                    | { __typename?: "BasicBlockListModel"; valueType: string }
                    | {
                        __typename?: "BasicContentPicker"
                        valueType: string
                        contentList: Array<{
                          __typename?: "BasicContentPickerItem"
                          id: number
                          absoluteUrl: string
                          key: any
                          name?: string | null
                          url: string
                          urlSegment?: string | null
                        }>
                      }
                    | {
                        __typename?: "BasicDateTimePicker"
                        valueType: string
                        dateTime?: any | null
                      }
                    | {
                        __typename?: "BasicLabel"
                        valueType: string
                        label?: any | null
                      }
                    | { __typename?: "BasicMediaPicker"; valueType: string }
                    | {
                        __typename?: "BasicMemberPicker"
                        valueType: string
                        members: Array<{
                          __typename?: "BasicMemberPickerItem"
                          id?: number | null
                          name?: string | null
                          properties: Array<{
                            __typename?: "BasicProperty"
                            alias?: string | null
                            editorAlias?: string | null
                            value?:
                              | {
                                  __typename?: "BasicBlockGridModel"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicBlockListModel"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicContentPicker"
                                  model: string
                                  contentList: Array<{
                                    __typename?: "BasicContentPickerItem"
                                    id: number
                                    absoluteUrl: string
                                    key: any
                                    name?: string | null
                                    url: string
                                    urlSegment?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicDateTimePicker"
                                  model: string
                                  dateTime?: any | null
                                }
                              | {
                                  __typename?: "BasicLabel"
                                  model: string
                                  label?: any | null
                                }
                              | {
                                  __typename?: "BasicMediaPicker"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicMemberPicker"
                                  model: string
                                  members: Array<{
                                    __typename?: "BasicMemberPickerItem"
                                    id?: number | null
                                    name?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicMultiUrlPicker"
                                  model: string
                                  links: Array<{
                                    __typename?: "BasicMultiUrlPickerItem"
                                    name?: string | null
                                    target?: string | null
                                    type: LinkType
                                    url?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicNestedContent"
                                  model: string
                                  elements?: Array<{
                                    __typename?: "BasicNestedContentElement"
                                    properties: Array<{
                                      __typename?: "BasicProperty"
                                      alias?: string | null
                                      editorAlias?: string | null
                                      value?:
                                        | {
                                            __typename?: "BasicBlockGridModel"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicBlockListModel"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicContentPicker"
                                            model: string
                                            contentList: Array<{
                                              __typename?: "BasicContentPickerItem"
                                              id: number
                                              absoluteUrl: string
                                              key: any
                                              name?: string | null
                                              url: string
                                              urlSegment?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicDateTimePicker"
                                            model: string
                                            dateTime?: any | null
                                          }
                                        | {
                                            __typename?: "BasicLabel"
                                            model: string
                                            label?: any | null
                                          }
                                        | {
                                            __typename?: "BasicMediaPicker"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicMemberPicker"
                                            model: string
                                            members: Array<{
                                              __typename?: "BasicMemberPickerItem"
                                              id?: number | null
                                              name?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicMultiUrlPicker"
                                            model: string
                                            links: Array<{
                                              __typename?: "BasicMultiUrlPickerItem"
                                              name?: string | null
                                              target?: string | null
                                              type: LinkType
                                              url?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicNestedContent"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicPropertyValue"
                                            model: string
                                            value?: any | null
                                          }
                                        | {
                                            __typename?: "BasicRichText"
                                            model: string
                                            richText?: string | null
                                          }
                                        | {
                                            __typename?: "BasicUnsupportedPropertyValue"
                                            model: string
                                            message: string
                                          }
                                        | {
                                            __typename?: "MintMediaPicker"
                                            model: string
                                            mediaItems: Array<{
                                              __typename?: "MintMediaPickerItem"
                                              id: number
                                              url: string
                                              altText?: string | null
                                            }>
                                          }
                                        | null
                                    } | null>
                                  }> | null
                                }
                              | {
                                  __typename?: "BasicPropertyValue"
                                  model: string
                                  value?: any | null
                                }
                              | {
                                  __typename?: "BasicRichText"
                                  model: string
                                  richText?: string | null
                                }
                              | {
                                  __typename?: "BasicUnsupportedPropertyValue"
                                  model: string
                                  message: string
                                }
                              | {
                                  __typename?: "MintMediaPicker"
                                  model: string
                                  mediaItems: Array<{
                                    __typename?: "MintMediaPickerItem"
                                    id: number
                                    url: string
                                    altText?: string | null
                                  }>
                                }
                              | null
                          } | null>
                        }>
                      }
                    | {
                        __typename?: "BasicMultiUrlPicker"
                        valueType: string
                        links: Array<{
                          __typename?: "BasicMultiUrlPickerItem"
                          name?: string | null
                          target?: string | null
                          type: LinkType
                          url?: string | null
                        }>
                      }
                    | {
                        __typename?: "BasicNestedContent"
                        valueType: string
                        elements?: Array<{
                          __typename?: "BasicNestedContentElement"
                          properties: Array<{
                            __typename?: "BasicProperty"
                            alias?: string | null
                            editorAlias?: string | null
                            value?:
                              | {
                                  __typename?: "BasicBlockGridModel"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicBlockListModel"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicContentPicker"
                                  model: string
                                  contentList: Array<{
                                    __typename?: "BasicContentPickerItem"
                                    id: number
                                    absoluteUrl: string
                                    key: any
                                    name?: string | null
                                    url: string
                                    urlSegment?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicDateTimePicker"
                                  model: string
                                  dateTime?: any | null
                                }
                              | {
                                  __typename?: "BasicLabel"
                                  model: string
                                  label?: any | null
                                }
                              | {
                                  __typename?: "BasicMediaPicker"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicMemberPicker"
                                  model: string
                                  members: Array<{
                                    __typename?: "BasicMemberPickerItem"
                                    id?: number | null
                                    name?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicMultiUrlPicker"
                                  model: string
                                  links: Array<{
                                    __typename?: "BasicMultiUrlPickerItem"
                                    name?: string | null
                                    target?: string | null
                                    type: LinkType
                                    url?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicNestedContent"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicPropertyValue"
                                  model: string
                                  value?: any | null
                                }
                              | {
                                  __typename?: "BasicRichText"
                                  model: string
                                  richText?: string | null
                                }
                              | {
                                  __typename?: "BasicUnsupportedPropertyValue"
                                  model: string
                                  message: string
                                }
                              | {
                                  __typename?: "MintMediaPicker"
                                  model: string
                                  mediaItems: Array<{
                                    __typename?: "MintMediaPickerItem"
                                    id: number
                                    url: string
                                    altText?: string | null
                                  }>
                                }
                              | null
                          } | null>
                        }> | null
                      }
                    | {
                        __typename?: "BasicPropertyValue"
                        valueType: string
                        value?: any | null
                      }
                    | {
                        __typename?: "BasicRichText"
                        valueType: string
                        richText?: string | null
                      }
                    | {
                        __typename?: "BasicUnsupportedPropertyValue"
                        message: string
                        valueType: string
                      }
                    | {
                        __typename?: "MintMediaPicker"
                        valueType: string
                        mediaItems: Array<{
                          __typename?: "MintMediaPickerItem"
                          id: number
                          url: string
                          altText?: string | null
                        }>
                      }
                    | null
                } | null>
                areas: Array<{
                  __typename?: "BasicBlockGridArea"
                  alias?: string | null
                  rowSpan: number
                  columnSpan: number
                  blocks?: Array<{
                    __typename?: "BasicBlockGridItem"
                    columnSpan: number
                    rowSpan: number
                    contentProperties: Array<{
                      __typename?: "BasicProperty"
                      value?:
                        | {
                            __typename?: "BasicBlockGridModel"
                            valueType: string
                          }
                        | {
                            __typename?: "BasicBlockListModel"
                            valueType: string
                          }
                        | {
                            __typename?: "BasicContentPicker"
                            valueType: string
                            contentList: Array<{
                              __typename?: "BasicContentPickerItem"
                              id: number
                              absoluteUrl: string
                              key: any
                              name?: string | null
                              url: string
                              urlSegment?: string | null
                            }>
                          }
                        | {
                            __typename?: "BasicDateTimePicker"
                            valueType: string
                            dateTime?: any | null
                          }
                        | {
                            __typename?: "BasicLabel"
                            valueType: string
                            label?: any | null
                          }
                        | { __typename?: "BasicMediaPicker"; valueType: string }
                        | {
                            __typename?: "BasicMemberPicker"
                            valueType: string
                            members: Array<{
                              __typename?: "BasicMemberPickerItem"
                              id?: number | null
                              name?: string | null
                              properties: Array<{
                                __typename?: "BasicProperty"
                                alias?: string | null
                                editorAlias?: string | null
                                value?:
                                  | {
                                      __typename?: "BasicBlockGridModel"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicBlockListModel"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicContentPicker"
                                      model: string
                                      contentList: Array<{
                                        __typename?: "BasicContentPickerItem"
                                        id: number
                                        absoluteUrl: string
                                        key: any
                                        name?: string | null
                                        url: string
                                        urlSegment?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicDateTimePicker"
                                      model: string
                                      dateTime?: any | null
                                    }
                                  | {
                                      __typename?: "BasicLabel"
                                      model: string
                                      label?: any | null
                                    }
                                  | {
                                      __typename?: "BasicMediaPicker"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicMemberPicker"
                                      model: string
                                      members: Array<{
                                        __typename?: "BasicMemberPickerItem"
                                        id?: number | null
                                        name?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicMultiUrlPicker"
                                      model: string
                                      links: Array<{
                                        __typename?: "BasicMultiUrlPickerItem"
                                        name?: string | null
                                        target?: string | null
                                        type: LinkType
                                        url?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicNestedContent"
                                      model: string
                                      elements?: Array<{
                                        __typename?: "BasicNestedContentElement"
                                        properties: Array<{
                                          __typename?: "BasicProperty"
                                          alias?: string | null
                                          editorAlias?: string | null
                                          value?:
                                            | {
                                                __typename?: "BasicBlockGridModel"
                                                model: string
                                              }
                                            | {
                                                __typename?: "BasicBlockListModel"
                                                model: string
                                              }
                                            | {
                                                __typename?: "BasicContentPicker"
                                                model: string
                                                contentList: Array<{
                                                  __typename?: "BasicContentPickerItem"
                                                  id: number
                                                  absoluteUrl: string
                                                  key: any
                                                  name?: string | null
                                                  url: string
                                                  urlSegment?: string | null
                                                }>
                                              }
                                            | {
                                                __typename?: "BasicDateTimePicker"
                                                model: string
                                                dateTime?: any | null
                                              }
                                            | {
                                                __typename?: "BasicLabel"
                                                model: string
                                                label?: any | null
                                              }
                                            | {
                                                __typename?: "BasicMediaPicker"
                                                model: string
                                              }
                                            | {
                                                __typename?: "BasicMemberPicker"
                                                model: string
                                                members: Array<{
                                                  __typename?: "BasicMemberPickerItem"
                                                  id?: number | null
                                                  name?: string | null
                                                }>
                                              }
                                            | {
                                                __typename?: "BasicMultiUrlPicker"
                                                model: string
                                                links: Array<{
                                                  __typename?: "BasicMultiUrlPickerItem"
                                                  name?: string | null
                                                  target?: string | null
                                                  type: LinkType
                                                  url?: string | null
                                                }>
                                              }
                                            | {
                                                __typename?: "BasicNestedContent"
                                                model: string
                                              }
                                            | {
                                                __typename?: "BasicPropertyValue"
                                                model: string
                                                value?: any | null
                                              }
                                            | {
                                                __typename?: "BasicRichText"
                                                model: string
                                                richText?: string | null
                                              }
                                            | {
                                                __typename?: "BasicUnsupportedPropertyValue"
                                                model: string
                                                message: string
                                              }
                                            | {
                                                __typename?: "MintMediaPicker"
                                                model: string
                                                mediaItems: Array<{
                                                  __typename?: "MintMediaPickerItem"
                                                  id: number
                                                  url: string
                                                  altText?: string | null
                                                }>
                                              }
                                            | null
                                        } | null>
                                      }> | null
                                    }
                                  | {
                                      __typename?: "BasicPropertyValue"
                                      model: string
                                      value?: any | null
                                    }
                                  | {
                                      __typename?: "BasicRichText"
                                      model: string
                                      richText?: string | null
                                    }
                                  | {
                                      __typename?: "BasicUnsupportedPropertyValue"
                                      model: string
                                      message: string
                                    }
                                  | {
                                      __typename?: "MintMediaPicker"
                                      model: string
                                      mediaItems: Array<{
                                        __typename?: "MintMediaPickerItem"
                                        id: number
                                        url: string
                                        altText?: string | null
                                      }>
                                    }
                                  | null
                              } | null>
                            }>
                          }
                        | {
                            __typename?: "BasicMultiUrlPicker"
                            valueType: string
                            links: Array<{
                              __typename?: "BasicMultiUrlPickerItem"
                              name?: string | null
                              target?: string | null
                              type: LinkType
                              url?: string | null
                            }>
                          }
                        | {
                            __typename?: "BasicNestedContent"
                            valueType: string
                            elements?: Array<{
                              __typename?: "BasicNestedContentElement"
                              properties: Array<{
                                __typename?: "BasicProperty"
                                alias?: string | null
                                editorAlias?: string | null
                                value?:
                                  | {
                                      __typename?: "BasicBlockGridModel"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicBlockListModel"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicContentPicker"
                                      model: string
                                      contentList: Array<{
                                        __typename?: "BasicContentPickerItem"
                                        id: number
                                        absoluteUrl: string
                                        key: any
                                        name?: string | null
                                        url: string
                                        urlSegment?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicDateTimePicker"
                                      model: string
                                      dateTime?: any | null
                                    }
                                  | {
                                      __typename?: "BasicLabel"
                                      model: string
                                      label?: any | null
                                    }
                                  | {
                                      __typename?: "BasicMediaPicker"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicMemberPicker"
                                      model: string
                                      members: Array<{
                                        __typename?: "BasicMemberPickerItem"
                                        id?: number | null
                                        name?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicMultiUrlPicker"
                                      model: string
                                      links: Array<{
                                        __typename?: "BasicMultiUrlPickerItem"
                                        name?: string | null
                                        target?: string | null
                                        type: LinkType
                                        url?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicNestedContent"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicPropertyValue"
                                      model: string
                                      value?: any | null
                                    }
                                  | {
                                      __typename?: "BasicRichText"
                                      model: string
                                      richText?: string | null
                                    }
                                  | {
                                      __typename?: "BasicUnsupportedPropertyValue"
                                      model: string
                                      message: string
                                    }
                                  | {
                                      __typename?: "MintMediaPicker"
                                      model: string
                                      mediaItems: Array<{
                                        __typename?: "MintMediaPickerItem"
                                        id: number
                                        url: string
                                        altText?: string | null
                                      }>
                                    }
                                  | null
                              } | null>
                            }> | null
                          }
                        | {
                            __typename?: "BasicPropertyValue"
                            valueType: string
                            value?: any | null
                          }
                        | {
                            __typename?: "BasicRichText"
                            valueType: string
                            richText?: string | null
                          }
                        | {
                            __typename?: "BasicUnsupportedPropertyValue"
                            message: string
                            valueType: string
                          }
                        | {
                            __typename?: "MintMediaPicker"
                            valueType: string
                            mediaItems: Array<{
                              __typename?: "MintMediaPickerItem"
                              id: number
                              url: string
                              altText?: string | null
                            }>
                          }
                        | null
                    } | null>
                    settingsProperties: Array<{
                      __typename?: "BasicProperty"
                      value?:
                        | {
                            __typename?: "BasicBlockGridModel"
                            valueType: string
                          }
                        | {
                            __typename?: "BasicBlockListModel"
                            valueType: string
                          }
                        | {
                            __typename?: "BasicContentPicker"
                            valueType: string
                            contentList: Array<{
                              __typename?: "BasicContentPickerItem"
                              id: number
                              absoluteUrl: string
                              key: any
                              name?: string | null
                              url: string
                              urlSegment?: string | null
                            }>
                          }
                        | {
                            __typename?: "BasicDateTimePicker"
                            valueType: string
                            dateTime?: any | null
                          }
                        | {
                            __typename?: "BasicLabel"
                            valueType: string
                            label?: any | null
                          }
                        | { __typename?: "BasicMediaPicker"; valueType: string }
                        | {
                            __typename?: "BasicMemberPicker"
                            valueType: string
                            members: Array<{
                              __typename?: "BasicMemberPickerItem"
                              id?: number | null
                              name?: string | null
                              properties: Array<{
                                __typename?: "BasicProperty"
                                alias?: string | null
                                editorAlias?: string | null
                                value?:
                                  | {
                                      __typename?: "BasicBlockGridModel"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicBlockListModel"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicContentPicker"
                                      model: string
                                      contentList: Array<{
                                        __typename?: "BasicContentPickerItem"
                                        id: number
                                        absoluteUrl: string
                                        key: any
                                        name?: string | null
                                        url: string
                                        urlSegment?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicDateTimePicker"
                                      model: string
                                      dateTime?: any | null
                                    }
                                  | {
                                      __typename?: "BasicLabel"
                                      model: string
                                      label?: any | null
                                    }
                                  | {
                                      __typename?: "BasicMediaPicker"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicMemberPicker"
                                      model: string
                                      members: Array<{
                                        __typename?: "BasicMemberPickerItem"
                                        id?: number | null
                                        name?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicMultiUrlPicker"
                                      model: string
                                      links: Array<{
                                        __typename?: "BasicMultiUrlPickerItem"
                                        name?: string | null
                                        target?: string | null
                                        type: LinkType
                                        url?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicNestedContent"
                                      model: string
                                      elements?: Array<{
                                        __typename?: "BasicNestedContentElement"
                                        properties: Array<{
                                          __typename?: "BasicProperty"
                                          alias?: string | null
                                          editorAlias?: string | null
                                          value?:
                                            | {
                                                __typename?: "BasicBlockGridModel"
                                                model: string
                                              }
                                            | {
                                                __typename?: "BasicBlockListModel"
                                                model: string
                                              }
                                            | {
                                                __typename?: "BasicContentPicker"
                                                model: string
                                                contentList: Array<{
                                                  __typename?: "BasicContentPickerItem"
                                                  id: number
                                                  absoluteUrl: string
                                                  key: any
                                                  name?: string | null
                                                  url: string
                                                  urlSegment?: string | null
                                                }>
                                              }
                                            | {
                                                __typename?: "BasicDateTimePicker"
                                                model: string
                                                dateTime?: any | null
                                              }
                                            | {
                                                __typename?: "BasicLabel"
                                                model: string
                                                label?: any | null
                                              }
                                            | {
                                                __typename?: "BasicMediaPicker"
                                                model: string
                                              }
                                            | {
                                                __typename?: "BasicMemberPicker"
                                                model: string
                                                members: Array<{
                                                  __typename?: "BasicMemberPickerItem"
                                                  id?: number | null
                                                  name?: string | null
                                                }>
                                              }
                                            | {
                                                __typename?: "BasicMultiUrlPicker"
                                                model: string
                                                links: Array<{
                                                  __typename?: "BasicMultiUrlPickerItem"
                                                  name?: string | null
                                                  target?: string | null
                                                  type: LinkType
                                                  url?: string | null
                                                }>
                                              }
                                            | {
                                                __typename?: "BasicNestedContent"
                                                model: string
                                              }
                                            | {
                                                __typename?: "BasicPropertyValue"
                                                model: string
                                                value?: any | null
                                              }
                                            | {
                                                __typename?: "BasicRichText"
                                                model: string
                                                richText?: string | null
                                              }
                                            | {
                                                __typename?: "BasicUnsupportedPropertyValue"
                                                model: string
                                                message: string
                                              }
                                            | {
                                                __typename?: "MintMediaPicker"
                                                model: string
                                                mediaItems: Array<{
                                                  __typename?: "MintMediaPickerItem"
                                                  id: number
                                                  url: string
                                                  altText?: string | null
                                                }>
                                              }
                                            | null
                                        } | null>
                                      }> | null
                                    }
                                  | {
                                      __typename?: "BasicPropertyValue"
                                      model: string
                                      value?: any | null
                                    }
                                  | {
                                      __typename?: "BasicRichText"
                                      model: string
                                      richText?: string | null
                                    }
                                  | {
                                      __typename?: "BasicUnsupportedPropertyValue"
                                      model: string
                                      message: string
                                    }
                                  | {
                                      __typename?: "MintMediaPicker"
                                      model: string
                                      mediaItems: Array<{
                                        __typename?: "MintMediaPickerItem"
                                        id: number
                                        url: string
                                        altText?: string | null
                                      }>
                                    }
                                  | null
                              } | null>
                            }>
                          }
                        | {
                            __typename?: "BasicMultiUrlPicker"
                            valueType: string
                            links: Array<{
                              __typename?: "BasicMultiUrlPickerItem"
                              name?: string | null
                              target?: string | null
                              type: LinkType
                              url?: string | null
                            }>
                          }
                        | {
                            __typename?: "BasicNestedContent"
                            valueType: string
                            elements?: Array<{
                              __typename?: "BasicNestedContentElement"
                              properties: Array<{
                                __typename?: "BasicProperty"
                                alias?: string | null
                                editorAlias?: string | null
                                value?:
                                  | {
                                      __typename?: "BasicBlockGridModel"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicBlockListModel"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicContentPicker"
                                      model: string
                                      contentList: Array<{
                                        __typename?: "BasicContentPickerItem"
                                        id: number
                                        absoluteUrl: string
                                        key: any
                                        name?: string | null
                                        url: string
                                        urlSegment?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicDateTimePicker"
                                      model: string
                                      dateTime?: any | null
                                    }
                                  | {
                                      __typename?: "BasicLabel"
                                      model: string
                                      label?: any | null
                                    }
                                  | {
                                      __typename?: "BasicMediaPicker"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicMemberPicker"
                                      model: string
                                      members: Array<{
                                        __typename?: "BasicMemberPickerItem"
                                        id?: number | null
                                        name?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicMultiUrlPicker"
                                      model: string
                                      links: Array<{
                                        __typename?: "BasicMultiUrlPickerItem"
                                        name?: string | null
                                        target?: string | null
                                        type: LinkType
                                        url?: string | null
                                      }>
                                    }
                                  | {
                                      __typename?: "BasicNestedContent"
                                      model: string
                                    }
                                  | {
                                      __typename?: "BasicPropertyValue"
                                      model: string
                                      value?: any | null
                                    }
                                  | {
                                      __typename?: "BasicRichText"
                                      model: string
                                      richText?: string | null
                                    }
                                  | {
                                      __typename?: "BasicUnsupportedPropertyValue"
                                      model: string
                                      message: string
                                    }
                                  | {
                                      __typename?: "MintMediaPicker"
                                      model: string
                                      mediaItems: Array<{
                                        __typename?: "MintMediaPickerItem"
                                        id: number
                                        url: string
                                        altText?: string | null
                                      }>
                                    }
                                  | null
                              } | null>
                            }> | null
                          }
                        | {
                            __typename?: "BasicPropertyValue"
                            valueType: string
                            value?: any | null
                          }
                        | {
                            __typename?: "BasicRichText"
                            valueType: string
                            richText?: string | null
                          }
                        | {
                            __typename?: "BasicUnsupportedPropertyValue"
                            message: string
                            valueType: string
                          }
                        | {
                            __typename?: "MintMediaPicker"
                            valueType: string
                            mediaItems: Array<{
                              __typename?: "MintMediaPickerItem"
                              id: number
                              url: string
                              altText?: string | null
                            }>
                          }
                        | null
                    } | null>
                    areas: Array<{
                      __typename?: "BasicBlockGridArea"
                      alias?: string | null
                      rowSpan: number
                      columnSpan: number
                    } | null>
                  }> | null
                } | null>
              }> | null
            }
          | {
              __typename?: "BasicBlockListModel"
              valueType: string
              blocks?: Array<{
                __typename?: "BasicBlockListItem"
                blockType?: string | null
                properties: Array<{
                  __typename?: "BasicProperty"
                  propertyName?: string | null
                  propertyValue?:
                    | { __typename?: "BasicBlockGridModel"; valueType: string }
                    | {
                        __typename?: "BasicBlockListModel"
                        valueType: string
                        blocks?: Array<{
                          __typename?: "BasicBlockListItem"
                          blockType?: string | null
                          properties: Array<{
                            __typename?: "BasicProperty"
                            propertyName?: string | null
                            propertyValue?:
                              | {
                                  __typename?: "BasicBlockGridModel"
                                  valueType: string
                                }
                              | {
                                  __typename?: "BasicBlockListModel"
                                  valueType: string
                                  blocks?: Array<{
                                    __typename?: "BasicBlockListItem"
                                    blockType?: string | null
                                    properties: Array<{
                                      __typename?: "BasicProperty"
                                      propertyName?: string | null
                                      propertyValue?:
                                        | {
                                            __typename?: "BasicBlockGridModel"
                                            valueType: string
                                          }
                                        | {
                                            __typename?: "BasicBlockListModel"
                                            valueType: string
                                            blocks?: Array<{
                                              __typename?: "BasicBlockListItem"
                                              blockType?: string | null
                                              properties: Array<{
                                                __typename?: "BasicProperty"
                                                propertyName?: string | null
                                                propertyValue?:
                                                  | {
                                                      __typename?: "BasicBlockGridModel"
                                                      valueType: string
                                                    }
                                                  | {
                                                      __typename?: "BasicBlockListModel"
                                                      valueType: string
                                                      blocks?: Array<{
                                                        __typename?: "BasicBlockListItem"
                                                        blockType?:
                                                          | string
                                                          | null
                                                        properties: Array<{
                                                          __typename?: "BasicProperty"
                                                          propertyName?:
                                                            | string
                                                            | null
                                                          propertyValue?:
                                                            | {
                                                                __typename?: "BasicBlockGridModel"
                                                                valueType: string
                                                              }
                                                            | {
                                                                __typename?: "BasicBlockListModel"
                                                                valueType: string
                                                              }
                                                            | {
                                                                __typename?: "BasicContentPicker"
                                                                valueType: string
                                                                contentList: Array<{
                                                                  __typename?: "BasicContentPickerItem"
                                                                  id: number
                                                                  absoluteUrl: string
                                                                  key: any
                                                                  name?:
                                                                    | string
                                                                    | null
                                                                  url: string
                                                                  urlSegment?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | {
                                                                __typename?: "BasicDateTimePicker"
                                                                valueType: string
                                                                dateTime?:
                                                                  | any
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicLabel"
                                                                valueType: string
                                                                label?:
                                                                  | any
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicMediaPicker"
                                                                valueType: string
                                                              }
                                                            | {
                                                                __typename?: "BasicMemberPicker"
                                                                valueType: string
                                                                members: Array<{
                                                                  __typename?: "BasicMemberPickerItem"
                                                                  id?:
                                                                    | number
                                                                    | null
                                                                  name?:
                                                                    | string
                                                                    | null
                                                                  properties: Array<{
                                                                    __typename?: "BasicProperty"
                                                                    alias?:
                                                                      | string
                                                                      | null
                                                                    editorAlias?:
                                                                      | string
                                                                      | null
                                                                    value?:
                                                                      | {
                                                                          __typename?: "BasicBlockGridModel"
                                                                          model: string
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicBlockListModel"
                                                                          model: string
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicContentPicker"
                                                                          model: string
                                                                          contentList: Array<{
                                                                            __typename?: "BasicContentPickerItem"
                                                                            id: number
                                                                            absoluteUrl: string
                                                                            key: any
                                                                            name?:
                                                                              | string
                                                                              | null
                                                                            url: string
                                                                            urlSegment?:
                                                                              | string
                                                                              | null
                                                                          }>
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicDateTimePicker"
                                                                          model: string
                                                                          dateTime?:
                                                                            | any
                                                                            | null
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicLabel"
                                                                          model: string
                                                                          label?:
                                                                            | any
                                                                            | null
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicMediaPicker"
                                                                          model: string
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicMemberPicker"
                                                                          model: string
                                                                          members: Array<{
                                                                            __typename?: "BasicMemberPickerItem"
                                                                            id?:
                                                                              | number
                                                                              | null
                                                                            name?:
                                                                              | string
                                                                              | null
                                                                          }>
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicMultiUrlPicker"
                                                                          model: string
                                                                          links: Array<{
                                                                            __typename?: "BasicMultiUrlPickerItem"
                                                                            name?:
                                                                              | string
                                                                              | null
                                                                            target?:
                                                                              | string
                                                                              | null
                                                                            type: LinkType
                                                                            url?:
                                                                              | string
                                                                              | null
                                                                          }>
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicNestedContent"
                                                                          model: string
                                                                          elements?: Array<{
                                                                            __typename?: "BasicNestedContentElement"
                                                                            properties: Array<{
                                                                              __typename?: "BasicProperty"
                                                                              alias?:
                                                                                | string
                                                                                | null
                                                                              editorAlias?:
                                                                                | string
                                                                                | null
                                                                              value?:
                                                                                | {
                                                                                    __typename?: "BasicBlockGridModel"
                                                                                    model: string
                                                                                  }
                                                                                | {
                                                                                    __typename?: "BasicBlockListModel"
                                                                                    model: string
                                                                                  }
                                                                                | {
                                                                                    __typename?: "BasicContentPicker"
                                                                                    model: string
                                                                                    contentList: Array<{
                                                                                      __typename?: "BasicContentPickerItem"
                                                                                      id: number
                                                                                      absoluteUrl: string
                                                                                      key: any
                                                                                      name?:
                                                                                        | string
                                                                                        | null
                                                                                      url: string
                                                                                      urlSegment?:
                                                                                        | string
                                                                                        | null
                                                                                    }>
                                                                                  }
                                                                                | {
                                                                                    __typename?: "BasicDateTimePicker"
                                                                                    model: string
                                                                                    dateTime?:
                                                                                      | any
                                                                                      | null
                                                                                  }
                                                                                | {
                                                                                    __typename?: "BasicLabel"
                                                                                    model: string
                                                                                    label?:
                                                                                      | any
                                                                                      | null
                                                                                  }
                                                                                | {
                                                                                    __typename?: "BasicMediaPicker"
                                                                                    model: string
                                                                                  }
                                                                                | {
                                                                                    __typename?: "BasicMemberPicker"
                                                                                    model: string
                                                                                    members: Array<{
                                                                                      __typename?: "BasicMemberPickerItem"
                                                                                      id?:
                                                                                        | number
                                                                                        | null
                                                                                      name?:
                                                                                        | string
                                                                                        | null
                                                                                    }>
                                                                                  }
                                                                                | {
                                                                                    __typename?: "BasicMultiUrlPicker"
                                                                                    model: string
                                                                                    links: Array<{
                                                                                      __typename?: "BasicMultiUrlPickerItem"
                                                                                      name?:
                                                                                        | string
                                                                                        | null
                                                                                      target?:
                                                                                        | string
                                                                                        | null
                                                                                      type: LinkType
                                                                                      url?:
                                                                                        | string
                                                                                        | null
                                                                                    }>
                                                                                  }
                                                                                | {
                                                                                    __typename?: "BasicNestedContent"
                                                                                    model: string
                                                                                  }
                                                                                | {
                                                                                    __typename?: "BasicPropertyValue"
                                                                                    model: string
                                                                                    value?:
                                                                                      | any
                                                                                      | null
                                                                                  }
                                                                                | {
                                                                                    __typename?: "BasicRichText"
                                                                                    model: string
                                                                                    richText?:
                                                                                      | string
                                                                                      | null
                                                                                  }
                                                                                | {
                                                                                    __typename?: "BasicUnsupportedPropertyValue"
                                                                                    model: string
                                                                                    message: string
                                                                                  }
                                                                                | {
                                                                                    __typename?: "MintMediaPicker"
                                                                                    model: string
                                                                                    mediaItems: Array<{
                                                                                      __typename?: "MintMediaPickerItem"
                                                                                      id: number
                                                                                      url: string
                                                                                      altText?:
                                                                                        | string
                                                                                        | null
                                                                                    }>
                                                                                  }
                                                                                | null
                                                                            } | null>
                                                                          }> | null
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicPropertyValue"
                                                                          model: string
                                                                          value?:
                                                                            | any
                                                                            | null
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicRichText"
                                                                          model: string
                                                                          richText?:
                                                                            | string
                                                                            | null
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicUnsupportedPropertyValue"
                                                                          model: string
                                                                          message: string
                                                                        }
                                                                      | {
                                                                          __typename?: "MintMediaPicker"
                                                                          model: string
                                                                          mediaItems: Array<{
                                                                            __typename?: "MintMediaPickerItem"
                                                                            id: number
                                                                            url: string
                                                                            altText?:
                                                                              | string
                                                                              | null
                                                                          }>
                                                                        }
                                                                      | null
                                                                  } | null>
                                                                }>
                                                              }
                                                            | {
                                                                __typename?: "BasicMultiUrlPicker"
                                                                valueType: string
                                                                links: Array<{
                                                                  __typename?: "BasicMultiUrlPickerItem"
                                                                  name?:
                                                                    | string
                                                                    | null
                                                                  target?:
                                                                    | string
                                                                    | null
                                                                  type: LinkType
                                                                  url?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | {
                                                                __typename?: "BasicNestedContent"
                                                                valueType: string
                                                                elements?: Array<{
                                                                  __typename?: "BasicNestedContentElement"
                                                                  properties: Array<{
                                                                    __typename?: "BasicProperty"
                                                                    alias?:
                                                                      | string
                                                                      | null
                                                                    editorAlias?:
                                                                      | string
                                                                      | null
                                                                    value?:
                                                                      | {
                                                                          __typename?: "BasicBlockGridModel"
                                                                          model: string
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicBlockListModel"
                                                                          model: string
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicContentPicker"
                                                                          model: string
                                                                          contentList: Array<{
                                                                            __typename?: "BasicContentPickerItem"
                                                                            id: number
                                                                            absoluteUrl: string
                                                                            key: any
                                                                            name?:
                                                                              | string
                                                                              | null
                                                                            url: string
                                                                            urlSegment?:
                                                                              | string
                                                                              | null
                                                                          }>
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicDateTimePicker"
                                                                          model: string
                                                                          dateTime?:
                                                                            | any
                                                                            | null
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicLabel"
                                                                          model: string
                                                                          label?:
                                                                            | any
                                                                            | null
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicMediaPicker"
                                                                          model: string
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicMemberPicker"
                                                                          model: string
                                                                          members: Array<{
                                                                            __typename?: "BasicMemberPickerItem"
                                                                            id?:
                                                                              | number
                                                                              | null
                                                                            name?:
                                                                              | string
                                                                              | null
                                                                          }>
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicMultiUrlPicker"
                                                                          model: string
                                                                          links: Array<{
                                                                            __typename?: "BasicMultiUrlPickerItem"
                                                                            name?:
                                                                              | string
                                                                              | null
                                                                            target?:
                                                                              | string
                                                                              | null
                                                                            type: LinkType
                                                                            url?:
                                                                              | string
                                                                              | null
                                                                          }>
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicNestedContent"
                                                                          model: string
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicPropertyValue"
                                                                          model: string
                                                                          value?:
                                                                            | any
                                                                            | null
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicRichText"
                                                                          model: string
                                                                          richText?:
                                                                            | string
                                                                            | null
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicUnsupportedPropertyValue"
                                                                          model: string
                                                                          message: string
                                                                        }
                                                                      | {
                                                                          __typename?: "MintMediaPicker"
                                                                          model: string
                                                                          mediaItems: Array<{
                                                                            __typename?: "MintMediaPickerItem"
                                                                            id: number
                                                                            url: string
                                                                            altText?:
                                                                              | string
                                                                              | null
                                                                          }>
                                                                        }
                                                                      | null
                                                                  } | null>
                                                                }> | null
                                                              }
                                                            | {
                                                                __typename?: "BasicPropertyValue"
                                                                valueType: string
                                                                value?:
                                                                  | any
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicRichText"
                                                                valueType: string
                                                                richText?:
                                                                  | string
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicUnsupportedPropertyValue"
                                                                message: string
                                                                valueType: string
                                                              }
                                                            | {
                                                                __typename?: "MintMediaPicker"
                                                                valueType: string
                                                                mediaItems: Array<{
                                                                  __typename?: "MintMediaPickerItem"
                                                                  id: number
                                                                  url: string
                                                                  altText?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | null
                                                        } | null>
                                                      }> | null
                                                    }
                                                  | {
                                                      __typename?: "BasicContentPicker"
                                                      valueType: string
                                                      contentList: Array<{
                                                        __typename?: "BasicContentPickerItem"
                                                        id: number
                                                        absoluteUrl: string
                                                        key: any
                                                        name?: string | null
                                                        url: string
                                                        urlSegment?:
                                                          | string
                                                          | null
                                                      }>
                                                    }
                                                  | {
                                                      __typename?: "BasicDateTimePicker"
                                                      valueType: string
                                                      dateTime?: any | null
                                                    }
                                                  | {
                                                      __typename?: "BasicLabel"
                                                      valueType: string
                                                      label?: any | null
                                                    }
                                                  | {
                                                      __typename?: "BasicMediaPicker"
                                                      valueType: string
                                                    }
                                                  | {
                                                      __typename?: "BasicMemberPicker"
                                                      valueType: string
                                                      members: Array<{
                                                        __typename?: "BasicMemberPickerItem"
                                                        id?: number | null
                                                        name?: string | null
                                                        properties: Array<{
                                                          __typename?: "BasicProperty"
                                                          alias?: string | null
                                                          editorAlias?:
                                                            | string
                                                            | null
                                                          value?:
                                                            | {
                                                                __typename?: "BasicBlockGridModel"
                                                                model: string
                                                              }
                                                            | {
                                                                __typename?: "BasicBlockListModel"
                                                                model: string
                                                              }
                                                            | {
                                                                __typename?: "BasicContentPicker"
                                                                model: string
                                                                contentList: Array<{
                                                                  __typename?: "BasicContentPickerItem"
                                                                  id: number
                                                                  absoluteUrl: string
                                                                  key: any
                                                                  name?:
                                                                    | string
                                                                    | null
                                                                  url: string
                                                                  urlSegment?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | {
                                                                __typename?: "BasicDateTimePicker"
                                                                model: string
                                                                dateTime?:
                                                                  | any
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicLabel"
                                                                model: string
                                                                label?:
                                                                  | any
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicMediaPicker"
                                                                model: string
                                                              }
                                                            | {
                                                                __typename?: "BasicMemberPicker"
                                                                model: string
                                                                members: Array<{
                                                                  __typename?: "BasicMemberPickerItem"
                                                                  id?:
                                                                    | number
                                                                    | null
                                                                  name?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | {
                                                                __typename?: "BasicMultiUrlPicker"
                                                                model: string
                                                                links: Array<{
                                                                  __typename?: "BasicMultiUrlPickerItem"
                                                                  name?:
                                                                    | string
                                                                    | null
                                                                  target?:
                                                                    | string
                                                                    | null
                                                                  type: LinkType
                                                                  url?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | {
                                                                __typename?: "BasicNestedContent"
                                                                model: string
                                                                elements?: Array<{
                                                                  __typename?: "BasicNestedContentElement"
                                                                  properties: Array<{
                                                                    __typename?: "BasicProperty"
                                                                    alias?:
                                                                      | string
                                                                      | null
                                                                    editorAlias?:
                                                                      | string
                                                                      | null
                                                                    value?:
                                                                      | {
                                                                          __typename?: "BasicBlockGridModel"
                                                                          model: string
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicBlockListModel"
                                                                          model: string
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicContentPicker"
                                                                          model: string
                                                                          contentList: Array<{
                                                                            __typename?: "BasicContentPickerItem"
                                                                            id: number
                                                                            absoluteUrl: string
                                                                            key: any
                                                                            name?:
                                                                              | string
                                                                              | null
                                                                            url: string
                                                                            urlSegment?:
                                                                              | string
                                                                              | null
                                                                          }>
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicDateTimePicker"
                                                                          model: string
                                                                          dateTime?:
                                                                            | any
                                                                            | null
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicLabel"
                                                                          model: string
                                                                          label?:
                                                                            | any
                                                                            | null
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicMediaPicker"
                                                                          model: string
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicMemberPicker"
                                                                          model: string
                                                                          members: Array<{
                                                                            __typename?: "BasicMemberPickerItem"
                                                                            id?:
                                                                              | number
                                                                              | null
                                                                            name?:
                                                                              | string
                                                                              | null
                                                                          }>
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicMultiUrlPicker"
                                                                          model: string
                                                                          links: Array<{
                                                                            __typename?: "BasicMultiUrlPickerItem"
                                                                            name?:
                                                                              | string
                                                                              | null
                                                                            target?:
                                                                              | string
                                                                              | null
                                                                            type: LinkType
                                                                            url?:
                                                                              | string
                                                                              | null
                                                                          }>
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicNestedContent"
                                                                          model: string
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicPropertyValue"
                                                                          model: string
                                                                          value?:
                                                                            | any
                                                                            | null
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicRichText"
                                                                          model: string
                                                                          richText?:
                                                                            | string
                                                                            | null
                                                                        }
                                                                      | {
                                                                          __typename?: "BasicUnsupportedPropertyValue"
                                                                          model: string
                                                                          message: string
                                                                        }
                                                                      | {
                                                                          __typename?: "MintMediaPicker"
                                                                          model: string
                                                                          mediaItems: Array<{
                                                                            __typename?: "MintMediaPickerItem"
                                                                            id: number
                                                                            url: string
                                                                            altText?:
                                                                              | string
                                                                              | null
                                                                          }>
                                                                        }
                                                                      | null
                                                                  } | null>
                                                                }> | null
                                                              }
                                                            | {
                                                                __typename?: "BasicPropertyValue"
                                                                model: string
                                                                value?:
                                                                  | any
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicRichText"
                                                                model: string
                                                                richText?:
                                                                  | string
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicUnsupportedPropertyValue"
                                                                model: string
                                                                message: string
                                                              }
                                                            | {
                                                                __typename?: "MintMediaPicker"
                                                                model: string
                                                                mediaItems: Array<{
                                                                  __typename?: "MintMediaPickerItem"
                                                                  id: number
                                                                  url: string
                                                                  altText?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | null
                                                        } | null>
                                                      }>
                                                    }
                                                  | {
                                                      __typename?: "BasicMultiUrlPicker"
                                                      valueType: string
                                                      links: Array<{
                                                        __typename?: "BasicMultiUrlPickerItem"
                                                        name?: string | null
                                                        target?: string | null
                                                        type: LinkType
                                                        url?: string | null
                                                      }>
                                                    }
                                                  | {
                                                      __typename?: "BasicNestedContent"
                                                      valueType: string
                                                      elements?: Array<{
                                                        __typename?: "BasicNestedContentElement"
                                                        properties: Array<{
                                                          __typename?: "BasicProperty"
                                                          alias?: string | null
                                                          editorAlias?:
                                                            | string
                                                            | null
                                                          value?:
                                                            | {
                                                                __typename?: "BasicBlockGridModel"
                                                                model: string
                                                              }
                                                            | {
                                                                __typename?: "BasicBlockListModel"
                                                                model: string
                                                              }
                                                            | {
                                                                __typename?: "BasicContentPicker"
                                                                model: string
                                                                contentList: Array<{
                                                                  __typename?: "BasicContentPickerItem"
                                                                  id: number
                                                                  absoluteUrl: string
                                                                  key: any
                                                                  name?:
                                                                    | string
                                                                    | null
                                                                  url: string
                                                                  urlSegment?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | {
                                                                __typename?: "BasicDateTimePicker"
                                                                model: string
                                                                dateTime?:
                                                                  | any
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicLabel"
                                                                model: string
                                                                label?:
                                                                  | any
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicMediaPicker"
                                                                model: string
                                                              }
                                                            | {
                                                                __typename?: "BasicMemberPicker"
                                                                model: string
                                                                members: Array<{
                                                                  __typename?: "BasicMemberPickerItem"
                                                                  id?:
                                                                    | number
                                                                    | null
                                                                  name?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | {
                                                                __typename?: "BasicMultiUrlPicker"
                                                                model: string
                                                                links: Array<{
                                                                  __typename?: "BasicMultiUrlPickerItem"
                                                                  name?:
                                                                    | string
                                                                    | null
                                                                  target?:
                                                                    | string
                                                                    | null
                                                                  type: LinkType
                                                                  url?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | {
                                                                __typename?: "BasicNestedContent"
                                                                model: string
                                                              }
                                                            | {
                                                                __typename?: "BasicPropertyValue"
                                                                model: string
                                                                value?:
                                                                  | any
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicRichText"
                                                                model: string
                                                                richText?:
                                                                  | string
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicUnsupportedPropertyValue"
                                                                model: string
                                                                message: string
                                                              }
                                                            | {
                                                                __typename?: "MintMediaPicker"
                                                                model: string
                                                                mediaItems: Array<{
                                                                  __typename?: "MintMediaPickerItem"
                                                                  id: number
                                                                  url: string
                                                                  altText?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | null
                                                        } | null>
                                                      }> | null
                                                    }
                                                  | {
                                                      __typename?: "BasicPropertyValue"
                                                      valueType: string
                                                      value?: any | null
                                                    }
                                                  | {
                                                      __typename?: "BasicRichText"
                                                      valueType: string
                                                      richText?: string | null
                                                    }
                                                  | {
                                                      __typename?: "BasicUnsupportedPropertyValue"
                                                      message: string
                                                      valueType: string
                                                    }
                                                  | {
                                                      __typename?: "MintMediaPicker"
                                                      valueType: string
                                                      mediaItems: Array<{
                                                        __typename?: "MintMediaPickerItem"
                                                        id: number
                                                        url: string
                                                        altText?: string | null
                                                      }>
                                                    }
                                                  | null
                                              } | null>
                                            }> | null
                                          }
                                        | {
                                            __typename?: "BasicContentPicker"
                                            valueType: string
                                            contentList: Array<{
                                              __typename?: "BasicContentPickerItem"
                                              id: number
                                              absoluteUrl: string
                                              key: any
                                              name?: string | null
                                              url: string
                                              urlSegment?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicDateTimePicker"
                                            valueType: string
                                            dateTime?: any | null
                                          }
                                        | {
                                            __typename?: "BasicLabel"
                                            valueType: string
                                            label?: any | null
                                          }
                                        | {
                                            __typename?: "BasicMediaPicker"
                                            valueType: string
                                          }
                                        | {
                                            __typename?: "BasicMemberPicker"
                                            valueType: string
                                            members: Array<{
                                              __typename?: "BasicMemberPickerItem"
                                              id?: number | null
                                              name?: string | null
                                              properties: Array<{
                                                __typename?: "BasicProperty"
                                                alias?: string | null
                                                editorAlias?: string | null
                                                value?:
                                                  | {
                                                      __typename?: "BasicBlockGridModel"
                                                      model: string
                                                    }
                                                  | {
                                                      __typename?: "BasicBlockListModel"
                                                      model: string
                                                    }
                                                  | {
                                                      __typename?: "BasicContentPicker"
                                                      model: string
                                                      contentList: Array<{
                                                        __typename?: "BasicContentPickerItem"
                                                        id: number
                                                        absoluteUrl: string
                                                        key: any
                                                        name?: string | null
                                                        url: string
                                                        urlSegment?:
                                                          | string
                                                          | null
                                                      }>
                                                    }
                                                  | {
                                                      __typename?: "BasicDateTimePicker"
                                                      model: string
                                                      dateTime?: any | null
                                                    }
                                                  | {
                                                      __typename?: "BasicLabel"
                                                      model: string
                                                      label?: any | null
                                                    }
                                                  | {
                                                      __typename?: "BasicMediaPicker"
                                                      model: string
                                                    }
                                                  | {
                                                      __typename?: "BasicMemberPicker"
                                                      model: string
                                                      members: Array<{
                                                        __typename?: "BasicMemberPickerItem"
                                                        id?: number | null
                                                        name?: string | null
                                                      }>
                                                    }
                                                  | {
                                                      __typename?: "BasicMultiUrlPicker"
                                                      model: string
                                                      links: Array<{
                                                        __typename?: "BasicMultiUrlPickerItem"
                                                        name?: string | null
                                                        target?: string | null
                                                        type: LinkType
                                                        url?: string | null
                                                      }>
                                                    }
                                                  | {
                                                      __typename?: "BasicNestedContent"
                                                      model: string
                                                      elements?: Array<{
                                                        __typename?: "BasicNestedContentElement"
                                                        properties: Array<{
                                                          __typename?: "BasicProperty"
                                                          alias?: string | null
                                                          editorAlias?:
                                                            | string
                                                            | null
                                                          value?:
                                                            | {
                                                                __typename?: "BasicBlockGridModel"
                                                                model: string
                                                              }
                                                            | {
                                                                __typename?: "BasicBlockListModel"
                                                                model: string
                                                              }
                                                            | {
                                                                __typename?: "BasicContentPicker"
                                                                model: string
                                                                contentList: Array<{
                                                                  __typename?: "BasicContentPickerItem"
                                                                  id: number
                                                                  absoluteUrl: string
                                                                  key: any
                                                                  name?:
                                                                    | string
                                                                    | null
                                                                  url: string
                                                                  urlSegment?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | {
                                                                __typename?: "BasicDateTimePicker"
                                                                model: string
                                                                dateTime?:
                                                                  | any
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicLabel"
                                                                model: string
                                                                label?:
                                                                  | any
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicMediaPicker"
                                                                model: string
                                                              }
                                                            | {
                                                                __typename?: "BasicMemberPicker"
                                                                model: string
                                                                members: Array<{
                                                                  __typename?: "BasicMemberPickerItem"
                                                                  id?:
                                                                    | number
                                                                    | null
                                                                  name?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | {
                                                                __typename?: "BasicMultiUrlPicker"
                                                                model: string
                                                                links: Array<{
                                                                  __typename?: "BasicMultiUrlPickerItem"
                                                                  name?:
                                                                    | string
                                                                    | null
                                                                  target?:
                                                                    | string
                                                                    | null
                                                                  type: LinkType
                                                                  url?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | {
                                                                __typename?: "BasicNestedContent"
                                                                model: string
                                                              }
                                                            | {
                                                                __typename?: "BasicPropertyValue"
                                                                model: string
                                                                value?:
                                                                  | any
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicRichText"
                                                                model: string
                                                                richText?:
                                                                  | string
                                                                  | null
                                                              }
                                                            | {
                                                                __typename?: "BasicUnsupportedPropertyValue"
                                                                model: string
                                                                message: string
                                                              }
                                                            | {
                                                                __typename?: "MintMediaPicker"
                                                                model: string
                                                                mediaItems: Array<{
                                                                  __typename?: "MintMediaPickerItem"
                                                                  id: number
                                                                  url: string
                                                                  altText?:
                                                                    | string
                                                                    | null
                                                                }>
                                                              }
                                                            | null
                                                        } | null>
                                                      }> | null
                                                    }
                                                  | {
                                                      __typename?: "BasicPropertyValue"
                                                      model: string
                                                      value?: any | null
                                                    }
                                                  | {
                                                      __typename?: "BasicRichText"
                                                      model: string
                                                      richText?: string | null
                                                    }
                                                  | {
                                                      __typename?: "BasicUnsupportedPropertyValue"
                                                      model: string
                                                      message: string
                                                    }
                                                  | {
                                                      __typename?: "MintMediaPicker"
                                                      model: string
                                                      mediaItems: Array<{
                                                        __typename?: "MintMediaPickerItem"
                                                        id: number
                                                        url: string
                                                        altText?: string | null
                                                      }>
                                                    }
                                                  | null
                                              } | null>
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicMultiUrlPicker"
                                            valueType: string
                                            links: Array<{
                                              __typename?: "BasicMultiUrlPickerItem"
                                              name?: string | null
                                              target?: string | null
                                              type: LinkType
                                              url?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicNestedContent"
                                            valueType: string
                                            elements?: Array<{
                                              __typename?: "BasicNestedContentElement"
                                              properties: Array<{
                                                __typename?: "BasicProperty"
                                                alias?: string | null
                                                editorAlias?: string | null
                                                value?:
                                                  | {
                                                      __typename?: "BasicBlockGridModel"
                                                      model: string
                                                    }
                                                  | {
                                                      __typename?: "BasicBlockListModel"
                                                      model: string
                                                    }
                                                  | {
                                                      __typename?: "BasicContentPicker"
                                                      model: string
                                                      contentList: Array<{
                                                        __typename?: "BasicContentPickerItem"
                                                        id: number
                                                        absoluteUrl: string
                                                        key: any
                                                        name?: string | null
                                                        url: string
                                                        urlSegment?:
                                                          | string
                                                          | null
                                                      }>
                                                    }
                                                  | {
                                                      __typename?: "BasicDateTimePicker"
                                                      model: string
                                                      dateTime?: any | null
                                                    }
                                                  | {
                                                      __typename?: "BasicLabel"
                                                      model: string
                                                      label?: any | null
                                                    }
                                                  | {
                                                      __typename?: "BasicMediaPicker"
                                                      model: string
                                                    }
                                                  | {
                                                      __typename?: "BasicMemberPicker"
                                                      model: string
                                                      members: Array<{
                                                        __typename?: "BasicMemberPickerItem"
                                                        id?: number | null
                                                        name?: string | null
                                                      }>
                                                    }
                                                  | {
                                                      __typename?: "BasicMultiUrlPicker"
                                                      model: string
                                                      links: Array<{
                                                        __typename?: "BasicMultiUrlPickerItem"
                                                        name?: string | null
                                                        target?: string | null
                                                        type: LinkType
                                                        url?: string | null
                                                      }>
                                                    }
                                                  | {
                                                      __typename?: "BasicNestedContent"
                                                      model: string
                                                    }
                                                  | {
                                                      __typename?: "BasicPropertyValue"
                                                      model: string
                                                      value?: any | null
                                                    }
                                                  | {
                                                      __typename?: "BasicRichText"
                                                      model: string
                                                      richText?: string | null
                                                    }
                                                  | {
                                                      __typename?: "BasicUnsupportedPropertyValue"
                                                      model: string
                                                      message: string
                                                    }
                                                  | {
                                                      __typename?: "MintMediaPicker"
                                                      model: string
                                                      mediaItems: Array<{
                                                        __typename?: "MintMediaPickerItem"
                                                        id: number
                                                        url: string
                                                        altText?: string | null
                                                      }>
                                                    }
                                                  | null
                                              } | null>
                                            }> | null
                                          }
                                        | {
                                            __typename?: "BasicPropertyValue"
                                            valueType: string
                                            value?: any | null
                                          }
                                        | {
                                            __typename?: "BasicRichText"
                                            valueType: string
                                            richText?: string | null
                                          }
                                        | {
                                            __typename?: "BasicUnsupportedPropertyValue"
                                            message: string
                                            valueType: string
                                          }
                                        | {
                                            __typename?: "MintMediaPicker"
                                            valueType: string
                                            mediaItems: Array<{
                                              __typename?: "MintMediaPickerItem"
                                              id: number
                                              url: string
                                              altText?: string | null
                                            }>
                                          }
                                        | null
                                    } | null>
                                  }> | null
                                }
                              | {
                                  __typename?: "BasicContentPicker"
                                  valueType: string
                                  contentList: Array<{
                                    __typename?: "BasicContentPickerItem"
                                    id: number
                                    absoluteUrl: string
                                    key: any
                                    name?: string | null
                                    url: string
                                    urlSegment?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicDateTimePicker"
                                  valueType: string
                                  dateTime?: any | null
                                }
                              | {
                                  __typename?: "BasicLabel"
                                  valueType: string
                                  label?: any | null
                                }
                              | {
                                  __typename?: "BasicMediaPicker"
                                  valueType: string
                                }
                              | {
                                  __typename?: "BasicMemberPicker"
                                  valueType: string
                                  members: Array<{
                                    __typename?: "BasicMemberPickerItem"
                                    id?: number | null
                                    name?: string | null
                                    properties: Array<{
                                      __typename?: "BasicProperty"
                                      alias?: string | null
                                      editorAlias?: string | null
                                      value?:
                                        | {
                                            __typename?: "BasicBlockGridModel"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicBlockListModel"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicContentPicker"
                                            model: string
                                            contentList: Array<{
                                              __typename?: "BasicContentPickerItem"
                                              id: number
                                              absoluteUrl: string
                                              key: any
                                              name?: string | null
                                              url: string
                                              urlSegment?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicDateTimePicker"
                                            model: string
                                            dateTime?: any | null
                                          }
                                        | {
                                            __typename?: "BasicLabel"
                                            model: string
                                            label?: any | null
                                          }
                                        | {
                                            __typename?: "BasicMediaPicker"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicMemberPicker"
                                            model: string
                                            members: Array<{
                                              __typename?: "BasicMemberPickerItem"
                                              id?: number | null
                                              name?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicMultiUrlPicker"
                                            model: string
                                            links: Array<{
                                              __typename?: "BasicMultiUrlPickerItem"
                                              name?: string | null
                                              target?: string | null
                                              type: LinkType
                                              url?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicNestedContent"
                                            model: string
                                            elements?: Array<{
                                              __typename?: "BasicNestedContentElement"
                                              properties: Array<{
                                                __typename?: "BasicProperty"
                                                alias?: string | null
                                                editorAlias?: string | null
                                                value?:
                                                  | {
                                                      __typename?: "BasicBlockGridModel"
                                                      model: string
                                                    }
                                                  | {
                                                      __typename?: "BasicBlockListModel"
                                                      model: string
                                                    }
                                                  | {
                                                      __typename?: "BasicContentPicker"
                                                      model: string
                                                      contentList: Array<{
                                                        __typename?: "BasicContentPickerItem"
                                                        id: number
                                                        absoluteUrl: string
                                                        key: any
                                                        name?: string | null
                                                        url: string
                                                        urlSegment?:
                                                          | string
                                                          | null
                                                      }>
                                                    }
                                                  | {
                                                      __typename?: "BasicDateTimePicker"
                                                      model: string
                                                      dateTime?: any | null
                                                    }
                                                  | {
                                                      __typename?: "BasicLabel"
                                                      model: string
                                                      label?: any | null
                                                    }
                                                  | {
                                                      __typename?: "BasicMediaPicker"
                                                      model: string
                                                    }
                                                  | {
                                                      __typename?: "BasicMemberPicker"
                                                      model: string
                                                      members: Array<{
                                                        __typename?: "BasicMemberPickerItem"
                                                        id?: number | null
                                                        name?: string | null
                                                      }>
                                                    }
                                                  | {
                                                      __typename?: "BasicMultiUrlPicker"
                                                      model: string
                                                      links: Array<{
                                                        __typename?: "BasicMultiUrlPickerItem"
                                                        name?: string | null
                                                        target?: string | null
                                                        type: LinkType
                                                        url?: string | null
                                                      }>
                                                    }
                                                  | {
                                                      __typename?: "BasicNestedContent"
                                                      model: string
                                                    }
                                                  | {
                                                      __typename?: "BasicPropertyValue"
                                                      model: string
                                                      value?: any | null
                                                    }
                                                  | {
                                                      __typename?: "BasicRichText"
                                                      model: string
                                                      richText?: string | null
                                                    }
                                                  | {
                                                      __typename?: "BasicUnsupportedPropertyValue"
                                                      model: string
                                                      message: string
                                                    }
                                                  | {
                                                      __typename?: "MintMediaPicker"
                                                      model: string
                                                      mediaItems: Array<{
                                                        __typename?: "MintMediaPickerItem"
                                                        id: number
                                                        url: string
                                                        altText?: string | null
                                                      }>
                                                    }
                                                  | null
                                              } | null>
                                            }> | null
                                          }
                                        | {
                                            __typename?: "BasicPropertyValue"
                                            model: string
                                            value?: any | null
                                          }
                                        | {
                                            __typename?: "BasicRichText"
                                            model: string
                                            richText?: string | null
                                          }
                                        | {
                                            __typename?: "BasicUnsupportedPropertyValue"
                                            model: string
                                            message: string
                                          }
                                        | {
                                            __typename?: "MintMediaPicker"
                                            model: string
                                            mediaItems: Array<{
                                              __typename?: "MintMediaPickerItem"
                                              id: number
                                              url: string
                                              altText?: string | null
                                            }>
                                          }
                                        | null
                                    } | null>
                                  }>
                                }
                              | {
                                  __typename?: "BasicMultiUrlPicker"
                                  valueType: string
                                  links: Array<{
                                    __typename?: "BasicMultiUrlPickerItem"
                                    name?: string | null
                                    target?: string | null
                                    type: LinkType
                                    url?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicNestedContent"
                                  valueType: string
                                  elements?: Array<{
                                    __typename?: "BasicNestedContentElement"
                                    properties: Array<{
                                      __typename?: "BasicProperty"
                                      alias?: string | null
                                      editorAlias?: string | null
                                      value?:
                                        | {
                                            __typename?: "BasicBlockGridModel"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicBlockListModel"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicContentPicker"
                                            model: string
                                            contentList: Array<{
                                              __typename?: "BasicContentPickerItem"
                                              id: number
                                              absoluteUrl: string
                                              key: any
                                              name?: string | null
                                              url: string
                                              urlSegment?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicDateTimePicker"
                                            model: string
                                            dateTime?: any | null
                                          }
                                        | {
                                            __typename?: "BasicLabel"
                                            model: string
                                            label?: any | null
                                          }
                                        | {
                                            __typename?: "BasicMediaPicker"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicMemberPicker"
                                            model: string
                                            members: Array<{
                                              __typename?: "BasicMemberPickerItem"
                                              id?: number | null
                                              name?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicMultiUrlPicker"
                                            model: string
                                            links: Array<{
                                              __typename?: "BasicMultiUrlPickerItem"
                                              name?: string | null
                                              target?: string | null
                                              type: LinkType
                                              url?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicNestedContent"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicPropertyValue"
                                            model: string
                                            value?: any | null
                                          }
                                        | {
                                            __typename?: "BasicRichText"
                                            model: string
                                            richText?: string | null
                                          }
                                        | {
                                            __typename?: "BasicUnsupportedPropertyValue"
                                            model: string
                                            message: string
                                          }
                                        | {
                                            __typename?: "MintMediaPicker"
                                            model: string
                                            mediaItems: Array<{
                                              __typename?: "MintMediaPickerItem"
                                              id: number
                                              url: string
                                              altText?: string | null
                                            }>
                                          }
                                        | null
                                    } | null>
                                  }> | null
                                }
                              | {
                                  __typename?: "BasicPropertyValue"
                                  valueType: string
                                  value?: any | null
                                }
                              | {
                                  __typename?: "BasicRichText"
                                  valueType: string
                                  richText?: string | null
                                }
                              | {
                                  __typename?: "BasicUnsupportedPropertyValue"
                                  message: string
                                  valueType: string
                                }
                              | {
                                  __typename?: "MintMediaPicker"
                                  valueType: string
                                  mediaItems: Array<{
                                    __typename?: "MintMediaPickerItem"
                                    id: number
                                    url: string
                                    altText?: string | null
                                  }>
                                }
                              | null
                          } | null>
                        }> | null
                      }
                    | {
                        __typename?: "BasicContentPicker"
                        valueType: string
                        contentList: Array<{
                          __typename?: "BasicContentPickerItem"
                          id: number
                          absoluteUrl: string
                          key: any
                          name?: string | null
                          url: string
                          urlSegment?: string | null
                        }>
                      }
                    | {
                        __typename?: "BasicDateTimePicker"
                        valueType: string
                        dateTime?: any | null
                      }
                    | {
                        __typename?: "BasicLabel"
                        valueType: string
                        label?: any | null
                      }
                    | { __typename?: "BasicMediaPicker"; valueType: string }
                    | {
                        __typename?: "BasicMemberPicker"
                        valueType: string
                        members: Array<{
                          __typename?: "BasicMemberPickerItem"
                          id?: number | null
                          name?: string | null
                          properties: Array<{
                            __typename?: "BasicProperty"
                            alias?: string | null
                            editorAlias?: string | null
                            value?:
                              | {
                                  __typename?: "BasicBlockGridModel"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicBlockListModel"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicContentPicker"
                                  model: string
                                  contentList: Array<{
                                    __typename?: "BasicContentPickerItem"
                                    id: number
                                    absoluteUrl: string
                                    key: any
                                    name?: string | null
                                    url: string
                                    urlSegment?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicDateTimePicker"
                                  model: string
                                  dateTime?: any | null
                                }
                              | {
                                  __typename?: "BasicLabel"
                                  model: string
                                  label?: any | null
                                }
                              | {
                                  __typename?: "BasicMediaPicker"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicMemberPicker"
                                  model: string
                                  members: Array<{
                                    __typename?: "BasicMemberPickerItem"
                                    id?: number | null
                                    name?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicMultiUrlPicker"
                                  model: string
                                  links: Array<{
                                    __typename?: "BasicMultiUrlPickerItem"
                                    name?: string | null
                                    target?: string | null
                                    type: LinkType
                                    url?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicNestedContent"
                                  model: string
                                  elements?: Array<{
                                    __typename?: "BasicNestedContentElement"
                                    properties: Array<{
                                      __typename?: "BasicProperty"
                                      alias?: string | null
                                      editorAlias?: string | null
                                      value?:
                                        | {
                                            __typename?: "BasicBlockGridModel"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicBlockListModel"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicContentPicker"
                                            model: string
                                            contentList: Array<{
                                              __typename?: "BasicContentPickerItem"
                                              id: number
                                              absoluteUrl: string
                                              key: any
                                              name?: string | null
                                              url: string
                                              urlSegment?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicDateTimePicker"
                                            model: string
                                            dateTime?: any | null
                                          }
                                        | {
                                            __typename?: "BasicLabel"
                                            model: string
                                            label?: any | null
                                          }
                                        | {
                                            __typename?: "BasicMediaPicker"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicMemberPicker"
                                            model: string
                                            members: Array<{
                                              __typename?: "BasicMemberPickerItem"
                                              id?: number | null
                                              name?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicMultiUrlPicker"
                                            model: string
                                            links: Array<{
                                              __typename?: "BasicMultiUrlPickerItem"
                                              name?: string | null
                                              target?: string | null
                                              type: LinkType
                                              url?: string | null
                                            }>
                                          }
                                        | {
                                            __typename?: "BasicNestedContent"
                                            model: string
                                          }
                                        | {
                                            __typename?: "BasicPropertyValue"
                                            model: string
                                            value?: any | null
                                          }
                                        | {
                                            __typename?: "BasicRichText"
                                            model: string
                                            richText?: string | null
                                          }
                                        | {
                                            __typename?: "BasicUnsupportedPropertyValue"
                                            model: string
                                            message: string
                                          }
                                        | {
                                            __typename?: "MintMediaPicker"
                                            model: string
                                            mediaItems: Array<{
                                              __typename?: "MintMediaPickerItem"
                                              id: number
                                              url: string
                                              altText?: string | null
                                            }>
                                          }
                                        | null
                                    } | null>
                                  }> | null
                                }
                              | {
                                  __typename?: "BasicPropertyValue"
                                  model: string
                                  value?: any | null
                                }
                              | {
                                  __typename?: "BasicRichText"
                                  model: string
                                  richText?: string | null
                                }
                              | {
                                  __typename?: "BasicUnsupportedPropertyValue"
                                  model: string
                                  message: string
                                }
                              | {
                                  __typename?: "MintMediaPicker"
                                  model: string
                                  mediaItems: Array<{
                                    __typename?: "MintMediaPickerItem"
                                    id: number
                                    url: string
                                    altText?: string | null
                                  }>
                                }
                              | null
                          } | null>
                        }>
                      }
                    | {
                        __typename?: "BasicMultiUrlPicker"
                        valueType: string
                        links: Array<{
                          __typename?: "BasicMultiUrlPickerItem"
                          name?: string | null
                          target?: string | null
                          type: LinkType
                          url?: string | null
                        }>
                      }
                    | {
                        __typename?: "BasicNestedContent"
                        valueType: string
                        elements?: Array<{
                          __typename?: "BasicNestedContentElement"
                          properties: Array<{
                            __typename?: "BasicProperty"
                            alias?: string | null
                            editorAlias?: string | null
                            value?:
                              | {
                                  __typename?: "BasicBlockGridModel"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicBlockListModel"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicContentPicker"
                                  model: string
                                  contentList: Array<{
                                    __typename?: "BasicContentPickerItem"
                                    id: number
                                    absoluteUrl: string
                                    key: any
                                    name?: string | null
                                    url: string
                                    urlSegment?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicDateTimePicker"
                                  model: string
                                  dateTime?: any | null
                                }
                              | {
                                  __typename?: "BasicLabel"
                                  model: string
                                  label?: any | null
                                }
                              | {
                                  __typename?: "BasicMediaPicker"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicMemberPicker"
                                  model: string
                                  members: Array<{
                                    __typename?: "BasicMemberPickerItem"
                                    id?: number | null
                                    name?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicMultiUrlPicker"
                                  model: string
                                  links: Array<{
                                    __typename?: "BasicMultiUrlPickerItem"
                                    name?: string | null
                                    target?: string | null
                                    type: LinkType
                                    url?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicNestedContent"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicPropertyValue"
                                  model: string
                                  value?: any | null
                                }
                              | {
                                  __typename?: "BasicRichText"
                                  model: string
                                  richText?: string | null
                                }
                              | {
                                  __typename?: "BasicUnsupportedPropertyValue"
                                  model: string
                                  message: string
                                }
                              | {
                                  __typename?: "MintMediaPicker"
                                  model: string
                                  mediaItems: Array<{
                                    __typename?: "MintMediaPickerItem"
                                    id: number
                                    url: string
                                    altText?: string | null
                                  }>
                                }
                              | null
                          } | null>
                        }> | null
                      }
                    | {
                        __typename?: "BasicPropertyValue"
                        valueType: string
                        value?: any | null
                      }
                    | {
                        __typename?: "BasicRichText"
                        valueType: string
                        richText?: string | null
                      }
                    | {
                        __typename?: "BasicUnsupportedPropertyValue"
                        message: string
                        valueType: string
                      }
                    | {
                        __typename?: "MintMediaPicker"
                        valueType: string
                        mediaItems: Array<{
                          __typename?: "MintMediaPickerItem"
                          id: number
                          url: string
                          altText?: string | null
                        }>
                      }
                    | null
                } | null>
              }> | null
            }
          | {
              __typename?: "BasicContentPicker"
              valueType: string
              contentList: Array<{
                __typename?: "BasicContentPickerItem"
                id: number
                absoluteUrl: string
                key: any
                name?: string | null
                url: string
                urlSegment?: string | null
              }>
            }
          | {
              __typename?: "BasicDateTimePicker"
              valueType: string
              dateTime?: any | null
            }
          | { __typename?: "BasicLabel"; valueType: string; label?: any | null }
          | { __typename?: "BasicMediaPicker"; valueType: string }
          | {
              __typename?: "BasicMemberPicker"
              valueType: string
              members: Array<{
                __typename?: "BasicMemberPickerItem"
                id?: number | null
                name?: string | null
                properties: Array<{
                  __typename?: "BasicProperty"
                  alias?: string | null
                  editorAlias?: string | null
                  value?:
                    | { __typename?: "BasicBlockGridModel"; model: string }
                    | { __typename?: "BasicBlockListModel"; model: string }
                    | {
                        __typename?: "BasicContentPicker"
                        model: string
                        contentList: Array<{
                          __typename?: "BasicContentPickerItem"
                          id: number
                          absoluteUrl: string
                          key: any
                          name?: string | null
                          url: string
                          urlSegment?: string | null
                        }>
                      }
                    | {
                        __typename?: "BasicDateTimePicker"
                        model: string
                        dateTime?: any | null
                      }
                    | {
                        __typename?: "BasicLabel"
                        model: string
                        label?: any | null
                      }
                    | { __typename?: "BasicMediaPicker"; model: string }
                    | {
                        __typename?: "BasicMemberPicker"
                        model: string
                        members: Array<{
                          __typename?: "BasicMemberPickerItem"
                          id?: number | null
                          name?: string | null
                        }>
                      }
                    | {
                        __typename?: "BasicMultiUrlPicker"
                        model: string
                        links: Array<{
                          __typename?: "BasicMultiUrlPickerItem"
                          name?: string | null
                          target?: string | null
                          type: LinkType
                          url?: string | null
                        }>
                      }
                    | {
                        __typename?: "BasicNestedContent"
                        model: string
                        elements?: Array<{
                          __typename?: "BasicNestedContentElement"
                          properties: Array<{
                            __typename?: "BasicProperty"
                            alias?: string | null
                            editorAlias?: string | null
                            value?:
                              | {
                                  __typename?: "BasicBlockGridModel"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicBlockListModel"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicContentPicker"
                                  model: string
                                  contentList: Array<{
                                    __typename?: "BasicContentPickerItem"
                                    id: number
                                    absoluteUrl: string
                                    key: any
                                    name?: string | null
                                    url: string
                                    urlSegment?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicDateTimePicker"
                                  model: string
                                  dateTime?: any | null
                                }
                              | {
                                  __typename?: "BasicLabel"
                                  model: string
                                  label?: any | null
                                }
                              | {
                                  __typename?: "BasicMediaPicker"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicMemberPicker"
                                  model: string
                                  members: Array<{
                                    __typename?: "BasicMemberPickerItem"
                                    id?: number | null
                                    name?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicMultiUrlPicker"
                                  model: string
                                  links: Array<{
                                    __typename?: "BasicMultiUrlPickerItem"
                                    name?: string | null
                                    target?: string | null
                                    type: LinkType
                                    url?: string | null
                                  }>
                                }
                              | {
                                  __typename?: "BasicNestedContent"
                                  model: string
                                }
                              | {
                                  __typename?: "BasicPropertyValue"
                                  model: string
                                  value?: any | null
                                }
                              | {
                                  __typename?: "BasicRichText"
                                  model: string
                                  richText?: string | null
                                }
                              | {
                                  __typename?: "BasicUnsupportedPropertyValue"
                                  model: string
                                  message: string
                                }
                              | {
                                  __typename?: "MintMediaPicker"
                                  model: string
                                  mediaItems: Array<{
                                    __typename?: "MintMediaPickerItem"
                                    id: number
                                    url: string
                                    altText?: string | null
                                  }>
                                }
                              | null
                          } | null>
                        }> | null
                      }
                    | {
                        __typename?: "BasicPropertyValue"
                        model: string
                        value?: any | null
                      }
                    | {
                        __typename?: "BasicRichText"
                        model: string
                        richText?: string | null
                      }
                    | {
                        __typename?: "BasicUnsupportedPropertyValue"
                        model: string
                        message: string
                      }
                    | {
                        __typename?: "MintMediaPicker"
                        model: string
                        mediaItems: Array<{
                          __typename?: "MintMediaPickerItem"
                          id: number
                          url: string
                          altText?: string | null
                        }>
                      }
                    | null
                } | null>
              }>
            }
          | {
              __typename?: "BasicMultiUrlPicker"
              valueType: string
              links: Array<{
                __typename?: "BasicMultiUrlPickerItem"
                name?: string | null
                target?: string | null
                type: LinkType
                url?: string | null
              }>
            }
          | {
              __typename?: "BasicNestedContent"
              valueType: string
              elements?: Array<{
                __typename?: "BasicNestedContentElement"
                properties: Array<{
                  __typename?: "BasicProperty"
                  alias?: string | null
                  editorAlias?: string | null
                  value?:
                    | { __typename?: "BasicBlockGridModel"; model: string }
                    | { __typename?: "BasicBlockListModel"; model: string }
                    | {
                        __typename?: "BasicContentPicker"
                        model: string
                        contentList: Array<{
                          __typename?: "BasicContentPickerItem"
                          id: number
                          absoluteUrl: string
                          key: any
                          name?: string | null
                          url: string
                          urlSegment?: string | null
                        }>
                      }
                    | {
                        __typename?: "BasicDateTimePicker"
                        model: string
                        dateTime?: any | null
                      }
                    | {
                        __typename?: "BasicLabel"
                        model: string
                        label?: any | null
                      }
                    | { __typename?: "BasicMediaPicker"; model: string }
                    | {
                        __typename?: "BasicMemberPicker"
                        model: string
                        members: Array<{
                          __typename?: "BasicMemberPickerItem"
                          id?: number | null
                          name?: string | null
                        }>
                      }
                    | {
                        __typename?: "BasicMultiUrlPicker"
                        model: string
                        links: Array<{
                          __typename?: "BasicMultiUrlPickerItem"
                          name?: string | null
                          target?: string | null
                          type: LinkType
                          url?: string | null
                        }>
                      }
                    | { __typename?: "BasicNestedContent"; model: string }
                    | {
                        __typename?: "BasicPropertyValue"
                        model: string
                        value?: any | null
                      }
                    | {
                        __typename?: "BasicRichText"
                        model: string
                        richText?: string | null
                      }
                    | {
                        __typename?: "BasicUnsupportedPropertyValue"
                        model: string
                        message: string
                      }
                    | {
                        __typename?: "MintMediaPicker"
                        model: string
                        mediaItems: Array<{
                          __typename?: "MintMediaPickerItem"
                          id: number
                          url: string
                          altText?: string | null
                        }>
                      }
                    | null
                } | null>
              }> | null
            }
          | {
              __typename?: "BasicPropertyValue"
              valueType: string
              value?: any | null
            }
          | {
              __typename?: "BasicRichText"
              valueType: string
              richText?: string | null
            }
          | {
              __typename?: "BasicUnsupportedPropertyValue"
              message: string
              valueType: string
            }
          | {
              __typename?: "MintMediaPicker"
              valueType: string
              mediaItems: Array<{
                __typename?: "MintMediaPickerItem"
                id: number
                url: string
                altText?: string | null
              }>
            }
          | null
      } | null> | null
    } | null> | null
    properties?: Array<{
      __typename?: "BasicProperty"
      propertyName?: string | null
      propertyValue?:
        | {
            __typename?: "BasicBlockGridModel"
            gridColumns?: number | null
            valueType: string
            blocks?: Array<{
              __typename?: "BasicBlockGridItem"
              columnSpan: number
              rowSpan: number
              contentProperties: Array<{
                __typename?: "BasicProperty"
                value?:
                  | { __typename?: "BasicBlockGridModel"; valueType: string }
                  | { __typename?: "BasicBlockListModel"; valueType: string }
                  | {
                      __typename?: "BasicContentPicker"
                      valueType: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      valueType: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      valueType: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; valueType: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      valueType: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                                elements?: Array<{
                                  __typename?: "BasicNestedContentElement"
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    alias?: string | null
                                    editorAlias?: string | null
                                    value?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          model: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          model: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          model: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          model: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          model: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          model: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          model: string
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          model: string
                                          message: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          model: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }> | null
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      valueType: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicNestedContent"
                      valueType: string
                      elements?: Array<{
                        __typename?: "BasicNestedContentElement"
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicPropertyValue"
                      valueType: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      valueType: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      message: string
                      valueType: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      valueType: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
              settingsProperties: Array<{
                __typename?: "BasicProperty"
                value?:
                  | { __typename?: "BasicBlockGridModel"; valueType: string }
                  | { __typename?: "BasicBlockListModel"; valueType: string }
                  | {
                      __typename?: "BasicContentPicker"
                      valueType: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      valueType: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      valueType: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; valueType: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      valueType: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                                elements?: Array<{
                                  __typename?: "BasicNestedContentElement"
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    alias?: string | null
                                    editorAlias?: string | null
                                    value?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          model: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          model: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          model: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          model: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          model: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          model: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          model: string
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          model: string
                                          message: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          model: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }> | null
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      valueType: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicNestedContent"
                      valueType: string
                      elements?: Array<{
                        __typename?: "BasicNestedContentElement"
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicPropertyValue"
                      valueType: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      valueType: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      message: string
                      valueType: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      valueType: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
              areas: Array<{
                __typename?: "BasicBlockGridArea"
                alias?: string | null
                rowSpan: number
                columnSpan: number
                blocks?: Array<{
                  __typename?: "BasicBlockGridItem"
                  columnSpan: number
                  rowSpan: number
                  contentProperties: Array<{
                    __typename?: "BasicProperty"
                    value?:
                      | {
                          __typename?: "BasicBlockGridModel"
                          valueType: string
                        }
                      | {
                          __typename?: "BasicBlockListModel"
                          valueType: string
                        }
                      | {
                          __typename?: "BasicContentPicker"
                          valueType: string
                          contentList: Array<{
                            __typename?: "BasicContentPickerItem"
                            id: number
                            absoluteUrl: string
                            key: any
                            name?: string | null
                            url: string
                            urlSegment?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicDateTimePicker"
                          valueType: string
                          dateTime?: any | null
                        }
                      | {
                          __typename?: "BasicLabel"
                          valueType: string
                          label?: any | null
                        }
                      | { __typename?: "BasicMediaPicker"; valueType: string }
                      | {
                          __typename?: "BasicMemberPicker"
                          valueType: string
                          members: Array<{
                            __typename?: "BasicMemberPickerItem"
                            id?: number | null
                            name?: string | null
                            properties: Array<{
                              __typename?: "BasicProperty"
                              alias?: string | null
                              editorAlias?: string | null
                              value?:
                                | {
                                    __typename?: "BasicBlockGridModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicBlockListModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicContentPicker"
                                    model: string
                                    contentList: Array<{
                                      __typename?: "BasicContentPickerItem"
                                      id: number
                                      absoluteUrl: string
                                      key: any
                                      name?: string | null
                                      url: string
                                      urlSegment?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicDateTimePicker"
                                    model: string
                                    dateTime?: any | null
                                  }
                                | {
                                    __typename?: "BasicLabel"
                                    model: string
                                    label?: any | null
                                  }
                                | {
                                    __typename?: "BasicMediaPicker"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicMemberPicker"
                                    model: string
                                    members: Array<{
                                      __typename?: "BasicMemberPickerItem"
                                      id?: number | null
                                      name?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicMultiUrlPicker"
                                    model: string
                                    links: Array<{
                                      __typename?: "BasicMultiUrlPickerItem"
                                      name?: string | null
                                      target?: string | null
                                      type: LinkType
                                      url?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicNestedContent"
                                    model: string
                                    elements?: Array<{
                                      __typename?: "BasicNestedContentElement"
                                      properties: Array<{
                                        __typename?: "BasicProperty"
                                        alias?: string | null
                                        editorAlias?: string | null
                                        value?:
                                          | {
                                              __typename?: "BasicBlockGridModel"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicBlockListModel"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicContentPicker"
                                              model: string
                                              contentList: Array<{
                                                __typename?: "BasicContentPickerItem"
                                                id: number
                                                absoluteUrl: string
                                                key: any
                                                name?: string | null
                                                url: string
                                                urlSegment?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicDateTimePicker"
                                              model: string
                                              dateTime?: any | null
                                            }
                                          | {
                                              __typename?: "BasicLabel"
                                              model: string
                                              label?: any | null
                                            }
                                          | {
                                              __typename?: "BasicMediaPicker"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicMemberPicker"
                                              model: string
                                              members: Array<{
                                                __typename?: "BasicMemberPickerItem"
                                                id?: number | null
                                                name?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicMultiUrlPicker"
                                              model: string
                                              links: Array<{
                                                __typename?: "BasicMultiUrlPickerItem"
                                                name?: string | null
                                                target?: string | null
                                                type: LinkType
                                                url?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicNestedContent"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicPropertyValue"
                                              model: string
                                              value?: any | null
                                            }
                                          | {
                                              __typename?: "BasicRichText"
                                              model: string
                                              richText?: string | null
                                            }
                                          | {
                                              __typename?: "BasicUnsupportedPropertyValue"
                                              model: string
                                              message: string
                                            }
                                          | {
                                              __typename?: "MintMediaPicker"
                                              model: string
                                              mediaItems: Array<{
                                                __typename?: "MintMediaPickerItem"
                                                id: number
                                                url: string
                                                altText?: string | null
                                              }>
                                            }
                                          | null
                                      } | null>
                                    }> | null
                                  }
                                | {
                                    __typename?: "BasicPropertyValue"
                                    model: string
                                    value?: any | null
                                  }
                                | {
                                    __typename?: "BasicRichText"
                                    model: string
                                    richText?: string | null
                                  }
                                | {
                                    __typename?: "BasicUnsupportedPropertyValue"
                                    model: string
                                    message: string
                                  }
                                | {
                                    __typename?: "MintMediaPicker"
                                    model: string
                                    mediaItems: Array<{
                                      __typename?: "MintMediaPickerItem"
                                      id: number
                                      url: string
                                      altText?: string | null
                                    }>
                                  }
                                | null
                            } | null>
                          }>
                        }
                      | {
                          __typename?: "BasicMultiUrlPicker"
                          valueType: string
                          links: Array<{
                            __typename?: "BasicMultiUrlPickerItem"
                            name?: string | null
                            target?: string | null
                            type: LinkType
                            url?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicNestedContent"
                          valueType: string
                          elements?: Array<{
                            __typename?: "BasicNestedContentElement"
                            properties: Array<{
                              __typename?: "BasicProperty"
                              alias?: string | null
                              editorAlias?: string | null
                              value?:
                                | {
                                    __typename?: "BasicBlockGridModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicBlockListModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicContentPicker"
                                    model: string
                                    contentList: Array<{
                                      __typename?: "BasicContentPickerItem"
                                      id: number
                                      absoluteUrl: string
                                      key: any
                                      name?: string | null
                                      url: string
                                      urlSegment?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicDateTimePicker"
                                    model: string
                                    dateTime?: any | null
                                  }
                                | {
                                    __typename?: "BasicLabel"
                                    model: string
                                    label?: any | null
                                  }
                                | {
                                    __typename?: "BasicMediaPicker"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicMemberPicker"
                                    model: string
                                    members: Array<{
                                      __typename?: "BasicMemberPickerItem"
                                      id?: number | null
                                      name?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicMultiUrlPicker"
                                    model: string
                                    links: Array<{
                                      __typename?: "BasicMultiUrlPickerItem"
                                      name?: string | null
                                      target?: string | null
                                      type: LinkType
                                      url?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicNestedContent"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicPropertyValue"
                                    model: string
                                    value?: any | null
                                  }
                                | {
                                    __typename?: "BasicRichText"
                                    model: string
                                    richText?: string | null
                                  }
                                | {
                                    __typename?: "BasicUnsupportedPropertyValue"
                                    model: string
                                    message: string
                                  }
                                | {
                                    __typename?: "MintMediaPicker"
                                    model: string
                                    mediaItems: Array<{
                                      __typename?: "MintMediaPickerItem"
                                      id: number
                                      url: string
                                      altText?: string | null
                                    }>
                                  }
                                | null
                            } | null>
                          }> | null
                        }
                      | {
                          __typename?: "BasicPropertyValue"
                          valueType: string
                          value?: any | null
                        }
                      | {
                          __typename?: "BasicRichText"
                          valueType: string
                          richText?: string | null
                        }
                      | {
                          __typename?: "BasicUnsupportedPropertyValue"
                          message: string
                          valueType: string
                        }
                      | {
                          __typename?: "MintMediaPicker"
                          valueType: string
                          mediaItems: Array<{
                            __typename?: "MintMediaPickerItem"
                            id: number
                            url: string
                            altText?: string | null
                          }>
                        }
                      | null
                  } | null>
                  settingsProperties: Array<{
                    __typename?: "BasicProperty"
                    value?:
                      | {
                          __typename?: "BasicBlockGridModel"
                          valueType: string
                        }
                      | {
                          __typename?: "BasicBlockListModel"
                          valueType: string
                        }
                      | {
                          __typename?: "BasicContentPicker"
                          valueType: string
                          contentList: Array<{
                            __typename?: "BasicContentPickerItem"
                            id: number
                            absoluteUrl: string
                            key: any
                            name?: string | null
                            url: string
                            urlSegment?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicDateTimePicker"
                          valueType: string
                          dateTime?: any | null
                        }
                      | {
                          __typename?: "BasicLabel"
                          valueType: string
                          label?: any | null
                        }
                      | { __typename?: "BasicMediaPicker"; valueType: string }
                      | {
                          __typename?: "BasicMemberPicker"
                          valueType: string
                          members: Array<{
                            __typename?: "BasicMemberPickerItem"
                            id?: number | null
                            name?: string | null
                            properties: Array<{
                              __typename?: "BasicProperty"
                              alias?: string | null
                              editorAlias?: string | null
                              value?:
                                | {
                                    __typename?: "BasicBlockGridModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicBlockListModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicContentPicker"
                                    model: string
                                    contentList: Array<{
                                      __typename?: "BasicContentPickerItem"
                                      id: number
                                      absoluteUrl: string
                                      key: any
                                      name?: string | null
                                      url: string
                                      urlSegment?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicDateTimePicker"
                                    model: string
                                    dateTime?: any | null
                                  }
                                | {
                                    __typename?: "BasicLabel"
                                    model: string
                                    label?: any | null
                                  }
                                | {
                                    __typename?: "BasicMediaPicker"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicMemberPicker"
                                    model: string
                                    members: Array<{
                                      __typename?: "BasicMemberPickerItem"
                                      id?: number | null
                                      name?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicMultiUrlPicker"
                                    model: string
                                    links: Array<{
                                      __typename?: "BasicMultiUrlPickerItem"
                                      name?: string | null
                                      target?: string | null
                                      type: LinkType
                                      url?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicNestedContent"
                                    model: string
                                    elements?: Array<{
                                      __typename?: "BasicNestedContentElement"
                                      properties: Array<{
                                        __typename?: "BasicProperty"
                                        alias?: string | null
                                        editorAlias?: string | null
                                        value?:
                                          | {
                                              __typename?: "BasicBlockGridModel"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicBlockListModel"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicContentPicker"
                                              model: string
                                              contentList: Array<{
                                                __typename?: "BasicContentPickerItem"
                                                id: number
                                                absoluteUrl: string
                                                key: any
                                                name?: string | null
                                                url: string
                                                urlSegment?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicDateTimePicker"
                                              model: string
                                              dateTime?: any | null
                                            }
                                          | {
                                              __typename?: "BasicLabel"
                                              model: string
                                              label?: any | null
                                            }
                                          | {
                                              __typename?: "BasicMediaPicker"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicMemberPicker"
                                              model: string
                                              members: Array<{
                                                __typename?: "BasicMemberPickerItem"
                                                id?: number | null
                                                name?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicMultiUrlPicker"
                                              model: string
                                              links: Array<{
                                                __typename?: "BasicMultiUrlPickerItem"
                                                name?: string | null
                                                target?: string | null
                                                type: LinkType
                                                url?: string | null
                                              }>
                                            }
                                          | {
                                              __typename?: "BasicNestedContent"
                                              model: string
                                            }
                                          | {
                                              __typename?: "BasicPropertyValue"
                                              model: string
                                              value?: any | null
                                            }
                                          | {
                                              __typename?: "BasicRichText"
                                              model: string
                                              richText?: string | null
                                            }
                                          | {
                                              __typename?: "BasicUnsupportedPropertyValue"
                                              model: string
                                              message: string
                                            }
                                          | {
                                              __typename?: "MintMediaPicker"
                                              model: string
                                              mediaItems: Array<{
                                                __typename?: "MintMediaPickerItem"
                                                id: number
                                                url: string
                                                altText?: string | null
                                              }>
                                            }
                                          | null
                                      } | null>
                                    }> | null
                                  }
                                | {
                                    __typename?: "BasicPropertyValue"
                                    model: string
                                    value?: any | null
                                  }
                                | {
                                    __typename?: "BasicRichText"
                                    model: string
                                    richText?: string | null
                                  }
                                | {
                                    __typename?: "BasicUnsupportedPropertyValue"
                                    model: string
                                    message: string
                                  }
                                | {
                                    __typename?: "MintMediaPicker"
                                    model: string
                                    mediaItems: Array<{
                                      __typename?: "MintMediaPickerItem"
                                      id: number
                                      url: string
                                      altText?: string | null
                                    }>
                                  }
                                | null
                            } | null>
                          }>
                        }
                      | {
                          __typename?: "BasicMultiUrlPicker"
                          valueType: string
                          links: Array<{
                            __typename?: "BasicMultiUrlPickerItem"
                            name?: string | null
                            target?: string | null
                            type: LinkType
                            url?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicNestedContent"
                          valueType: string
                          elements?: Array<{
                            __typename?: "BasicNestedContentElement"
                            properties: Array<{
                              __typename?: "BasicProperty"
                              alias?: string | null
                              editorAlias?: string | null
                              value?:
                                | {
                                    __typename?: "BasicBlockGridModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicBlockListModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicContentPicker"
                                    model: string
                                    contentList: Array<{
                                      __typename?: "BasicContentPickerItem"
                                      id: number
                                      absoluteUrl: string
                                      key: any
                                      name?: string | null
                                      url: string
                                      urlSegment?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicDateTimePicker"
                                    model: string
                                    dateTime?: any | null
                                  }
                                | {
                                    __typename?: "BasicLabel"
                                    model: string
                                    label?: any | null
                                  }
                                | {
                                    __typename?: "BasicMediaPicker"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicMemberPicker"
                                    model: string
                                    members: Array<{
                                      __typename?: "BasicMemberPickerItem"
                                      id?: number | null
                                      name?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicMultiUrlPicker"
                                    model: string
                                    links: Array<{
                                      __typename?: "BasicMultiUrlPickerItem"
                                      name?: string | null
                                      target?: string | null
                                      type: LinkType
                                      url?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicNestedContent"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicPropertyValue"
                                    model: string
                                    value?: any | null
                                  }
                                | {
                                    __typename?: "BasicRichText"
                                    model: string
                                    richText?: string | null
                                  }
                                | {
                                    __typename?: "BasicUnsupportedPropertyValue"
                                    model: string
                                    message: string
                                  }
                                | {
                                    __typename?: "MintMediaPicker"
                                    model: string
                                    mediaItems: Array<{
                                      __typename?: "MintMediaPickerItem"
                                      id: number
                                      url: string
                                      altText?: string | null
                                    }>
                                  }
                                | null
                            } | null>
                          }> | null
                        }
                      | {
                          __typename?: "BasicPropertyValue"
                          valueType: string
                          value?: any | null
                        }
                      | {
                          __typename?: "BasicRichText"
                          valueType: string
                          richText?: string | null
                        }
                      | {
                          __typename?: "BasicUnsupportedPropertyValue"
                          message: string
                          valueType: string
                        }
                      | {
                          __typename?: "MintMediaPicker"
                          valueType: string
                          mediaItems: Array<{
                            __typename?: "MintMediaPickerItem"
                            id: number
                            url: string
                            altText?: string | null
                          }>
                        }
                      | null
                  } | null>
                  areas: Array<{
                    __typename?: "BasicBlockGridArea"
                    alias?: string | null
                    rowSpan: number
                    columnSpan: number
                  } | null>
                }> | null
              } | null>
            }> | null
          }
        | {
            __typename?: "BasicBlockListModel"
            valueType: string
            blocks?: Array<{
              __typename?: "BasicBlockListItem"
              blockType?: string | null
              properties: Array<{
                __typename?: "BasicProperty"
                propertyName?: string | null
                propertyValue?:
                  | { __typename?: "BasicBlockGridModel"; valueType: string }
                  | {
                      __typename?: "BasicBlockListModel"
                      valueType: string
                      blocks?: Array<{
                        __typename?: "BasicBlockListItem"
                        blockType?: string | null
                        properties: Array<{
                          __typename?: "BasicProperty"
                          propertyName?: string | null
                          propertyValue?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                valueType: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                valueType: string
                                blocks?: Array<{
                                  __typename?: "BasicBlockListItem"
                                  blockType?: string | null
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    propertyName?: string | null
                                    propertyValue?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          valueType: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          valueType: string
                                          blocks?: Array<{
                                            __typename?: "BasicBlockListItem"
                                            blockType?: string | null
                                            properties: Array<{
                                              __typename?: "BasicProperty"
                                              propertyName?: string | null
                                              propertyValue?:
                                                | {
                                                    __typename?: "BasicBlockGridModel"
                                                    valueType: string
                                                  }
                                                | {
                                                    __typename?: "BasicBlockListModel"
                                                    valueType: string
                                                    blocks?: Array<{
                                                      __typename?: "BasicBlockListItem"
                                                      blockType?: string | null
                                                      properties: Array<{
                                                        __typename?: "BasicProperty"
                                                        propertyName?:
                                                          | string
                                                          | null
                                                        propertyValue?:
                                                          | {
                                                              __typename?: "BasicBlockGridModel"
                                                              valueType: string
                                                            }
                                                          | {
                                                              __typename?: "BasicBlockListModel"
                                                              valueType: string
                                                            }
                                                          | {
                                                              __typename?: "BasicContentPicker"
                                                              valueType: string
                                                              contentList: Array<{
                                                                __typename?: "BasicContentPickerItem"
                                                                id: number
                                                                absoluteUrl: string
                                                                key: any
                                                                name?:
                                                                  | string
                                                                  | null
                                                                url: string
                                                                urlSegment?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicDateTimePicker"
                                                              valueType: string
                                                              dateTime?:
                                                                | any
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicLabel"
                                                              valueType: string
                                                              label?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicMediaPicker"
                                                              valueType: string
                                                            }
                                                          | {
                                                              __typename?: "BasicMemberPicker"
                                                              valueType: string
                                                              members: Array<{
                                                                __typename?: "BasicMemberPickerItem"
                                                                id?:
                                                                  | number
                                                                  | null
                                                                name?:
                                                                  | string
                                                                  | null
                                                                properties: Array<{
                                                                  __typename?: "BasicProperty"
                                                                  alias?:
                                                                    | string
                                                                    | null
                                                                  editorAlias?:
                                                                    | string
                                                                    | null
                                                                  value?:
                                                                    | {
                                                                        __typename?: "BasicBlockGridModel"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicBlockListModel"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicContentPicker"
                                                                        model: string
                                                                        contentList: Array<{
                                                                          __typename?: "BasicContentPickerItem"
                                                                          id: number
                                                                          absoluteUrl: string
                                                                          key: any
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                          url: string
                                                                          urlSegment?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicDateTimePicker"
                                                                        model: string
                                                                        dateTime?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicLabel"
                                                                        model: string
                                                                        label?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMediaPicker"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMemberPicker"
                                                                        model: string
                                                                        members: Array<{
                                                                          __typename?: "BasicMemberPickerItem"
                                                                          id?:
                                                                            | number
                                                                            | null
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMultiUrlPicker"
                                                                        model: string
                                                                        links: Array<{
                                                                          __typename?: "BasicMultiUrlPickerItem"
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                          target?:
                                                                            | string
                                                                            | null
                                                                          type: LinkType
                                                                          url?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicNestedContent"
                                                                        model: string
                                                                        elements?: Array<{
                                                                          __typename?: "BasicNestedContentElement"
                                                                          properties: Array<{
                                                                            __typename?: "BasicProperty"
                                                                            alias?:
                                                                              | string
                                                                              | null
                                                                            editorAlias?:
                                                                              | string
                                                                              | null
                                                                            value?:
                                                                              | {
                                                                                  __typename?: "BasicBlockGridModel"
                                                                                  model: string
                                                                                }
                                                                              | {
                                                                                  __typename?: "BasicBlockListModel"
                                                                                  model: string
                                                                                }
                                                                              | {
                                                                                  __typename?: "BasicContentPicker"
                                                                                  model: string
                                                                                  contentList: Array<{
                                                                                    __typename?: "BasicContentPickerItem"
                                                                                    id: number
                                                                                    absoluteUrl: string
                                                                                    key: any
                                                                                    name?:
                                                                                      | string
                                                                                      | null
                                                                                    url: string
                                                                                    urlSegment?:
                                                                                      | string
                                                                                      | null
                                                                                  }>
                                                                                }
                                                                              | {
                                                                                  __typename?: "BasicDateTimePicker"
                                                                                  model: string
                                                                                  dateTime?:
                                                                                    | any
                                                                                    | null
                                                                                }
                                                                              | {
                                                                                  __typename?: "BasicLabel"
                                                                                  model: string
                                                                                  label?:
                                                                                    | any
                                                                                    | null
                                                                                }
                                                                              | {
                                                                                  __typename?: "BasicMediaPicker"
                                                                                  model: string
                                                                                }
                                                                              | {
                                                                                  __typename?: "BasicMemberPicker"
                                                                                  model: string
                                                                                  members: Array<{
                                                                                    __typename?: "BasicMemberPickerItem"
                                                                                    id?:
                                                                                      | number
                                                                                      | null
                                                                                    name?:
                                                                                      | string
                                                                                      | null
                                                                                  }>
                                                                                }
                                                                              | {
                                                                                  __typename?: "BasicMultiUrlPicker"
                                                                                  model: string
                                                                                  links: Array<{
                                                                                    __typename?: "BasicMultiUrlPickerItem"
                                                                                    name?:
                                                                                      | string
                                                                                      | null
                                                                                    target?:
                                                                                      | string
                                                                                      | null
                                                                                    type: LinkType
                                                                                    url?:
                                                                                      | string
                                                                                      | null
                                                                                  }>
                                                                                }
                                                                              | {
                                                                                  __typename?: "BasicNestedContent"
                                                                                  model: string
                                                                                }
                                                                              | {
                                                                                  __typename?: "BasicPropertyValue"
                                                                                  model: string
                                                                                  value?:
                                                                                    | any
                                                                                    | null
                                                                                }
                                                                              | {
                                                                                  __typename?: "BasicRichText"
                                                                                  model: string
                                                                                  richText?:
                                                                                    | string
                                                                                    | null
                                                                                }
                                                                              | {
                                                                                  __typename?: "BasicUnsupportedPropertyValue"
                                                                                  model: string
                                                                                  message: string
                                                                                }
                                                                              | {
                                                                                  __typename?: "MintMediaPicker"
                                                                                  model: string
                                                                                  mediaItems: Array<{
                                                                                    __typename?: "MintMediaPickerItem"
                                                                                    id: number
                                                                                    url: string
                                                                                    altText?:
                                                                                      | string
                                                                                      | null
                                                                                  }>
                                                                                }
                                                                              | null
                                                                          } | null>
                                                                        }> | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicPropertyValue"
                                                                        model: string
                                                                        value?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicRichText"
                                                                        model: string
                                                                        richText?:
                                                                          | string
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicUnsupportedPropertyValue"
                                                                        model: string
                                                                        message: string
                                                                      }
                                                                    | {
                                                                        __typename?: "MintMediaPicker"
                                                                        model: string
                                                                        mediaItems: Array<{
                                                                          __typename?: "MintMediaPickerItem"
                                                                          id: number
                                                                          url: string
                                                                          altText?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | null
                                                                } | null>
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicMultiUrlPicker"
                                                              valueType: string
                                                              links: Array<{
                                                                __typename?: "BasicMultiUrlPickerItem"
                                                                name?:
                                                                  | string
                                                                  | null
                                                                target?:
                                                                  | string
                                                                  | null
                                                                type: LinkType
                                                                url?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicNestedContent"
                                                              valueType: string
                                                              elements?: Array<{
                                                                __typename?: "BasicNestedContentElement"
                                                                properties: Array<{
                                                                  __typename?: "BasicProperty"
                                                                  alias?:
                                                                    | string
                                                                    | null
                                                                  editorAlias?:
                                                                    | string
                                                                    | null
                                                                  value?:
                                                                    | {
                                                                        __typename?: "BasicBlockGridModel"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicBlockListModel"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicContentPicker"
                                                                        model: string
                                                                        contentList: Array<{
                                                                          __typename?: "BasicContentPickerItem"
                                                                          id: number
                                                                          absoluteUrl: string
                                                                          key: any
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                          url: string
                                                                          urlSegment?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicDateTimePicker"
                                                                        model: string
                                                                        dateTime?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicLabel"
                                                                        model: string
                                                                        label?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMediaPicker"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMemberPicker"
                                                                        model: string
                                                                        members: Array<{
                                                                          __typename?: "BasicMemberPickerItem"
                                                                          id?:
                                                                            | number
                                                                            | null
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMultiUrlPicker"
                                                                        model: string
                                                                        links: Array<{
                                                                          __typename?: "BasicMultiUrlPickerItem"
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                          target?:
                                                                            | string
                                                                            | null
                                                                          type: LinkType
                                                                          url?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicNestedContent"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicPropertyValue"
                                                                        model: string
                                                                        value?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicRichText"
                                                                        model: string
                                                                        richText?:
                                                                          | string
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicUnsupportedPropertyValue"
                                                                        model: string
                                                                        message: string
                                                                      }
                                                                    | {
                                                                        __typename?: "MintMediaPicker"
                                                                        model: string
                                                                        mediaItems: Array<{
                                                                          __typename?: "MintMediaPickerItem"
                                                                          id: number
                                                                          url: string
                                                                          altText?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | null
                                                                } | null>
                                                              }> | null
                                                            }
                                                          | {
                                                              __typename?: "BasicPropertyValue"
                                                              valueType: string
                                                              value?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicRichText"
                                                              valueType: string
                                                              richText?:
                                                                | string
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicUnsupportedPropertyValue"
                                                              message: string
                                                              valueType: string
                                                            }
                                                          | {
                                                              __typename?: "MintMediaPicker"
                                                              valueType: string
                                                              mediaItems: Array<{
                                                                __typename?: "MintMediaPickerItem"
                                                                id: number
                                                                url: string
                                                                altText?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | null
                                                      } | null>
                                                    }> | null
                                                  }
                                                | {
                                                    __typename?: "BasicContentPicker"
                                                    valueType: string
                                                    contentList: Array<{
                                                      __typename?: "BasicContentPickerItem"
                                                      id: number
                                                      absoluteUrl: string
                                                      key: any
                                                      name?: string | null
                                                      url: string
                                                      urlSegment?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicDateTimePicker"
                                                    valueType: string
                                                    dateTime?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicLabel"
                                                    valueType: string
                                                    label?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicMediaPicker"
                                                    valueType: string
                                                  }
                                                | {
                                                    __typename?: "BasicMemberPicker"
                                                    valueType: string
                                                    members: Array<{
                                                      __typename?: "BasicMemberPickerItem"
                                                      id?: number | null
                                                      name?: string | null
                                                      properties: Array<{
                                                        __typename?: "BasicProperty"
                                                        alias?: string | null
                                                        editorAlias?:
                                                          | string
                                                          | null
                                                        value?:
                                                          | {
                                                              __typename?: "BasicBlockGridModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicBlockListModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicContentPicker"
                                                              model: string
                                                              contentList: Array<{
                                                                __typename?: "BasicContentPickerItem"
                                                                id: number
                                                                absoluteUrl: string
                                                                key: any
                                                                name?:
                                                                  | string
                                                                  | null
                                                                url: string
                                                                urlSegment?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicDateTimePicker"
                                                              model: string
                                                              dateTime?:
                                                                | any
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicLabel"
                                                              model: string
                                                              label?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicMediaPicker"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicMemberPicker"
                                                              model: string
                                                              members: Array<{
                                                                __typename?: "BasicMemberPickerItem"
                                                                id?:
                                                                  | number
                                                                  | null
                                                                name?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicMultiUrlPicker"
                                                              model: string
                                                              links: Array<{
                                                                __typename?: "BasicMultiUrlPickerItem"
                                                                name?:
                                                                  | string
                                                                  | null
                                                                target?:
                                                                  | string
                                                                  | null
                                                                type: LinkType
                                                                url?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicNestedContent"
                                                              model: string
                                                              elements?: Array<{
                                                                __typename?: "BasicNestedContentElement"
                                                                properties: Array<{
                                                                  __typename?: "BasicProperty"
                                                                  alias?:
                                                                    | string
                                                                    | null
                                                                  editorAlias?:
                                                                    | string
                                                                    | null
                                                                  value?:
                                                                    | {
                                                                        __typename?: "BasicBlockGridModel"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicBlockListModel"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicContentPicker"
                                                                        model: string
                                                                        contentList: Array<{
                                                                          __typename?: "BasicContentPickerItem"
                                                                          id: number
                                                                          absoluteUrl: string
                                                                          key: any
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                          url: string
                                                                          urlSegment?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicDateTimePicker"
                                                                        model: string
                                                                        dateTime?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicLabel"
                                                                        model: string
                                                                        label?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMediaPicker"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMemberPicker"
                                                                        model: string
                                                                        members: Array<{
                                                                          __typename?: "BasicMemberPickerItem"
                                                                          id?:
                                                                            | number
                                                                            | null
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMultiUrlPicker"
                                                                        model: string
                                                                        links: Array<{
                                                                          __typename?: "BasicMultiUrlPickerItem"
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                          target?:
                                                                            | string
                                                                            | null
                                                                          type: LinkType
                                                                          url?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicNestedContent"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicPropertyValue"
                                                                        model: string
                                                                        value?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicRichText"
                                                                        model: string
                                                                        richText?:
                                                                          | string
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicUnsupportedPropertyValue"
                                                                        model: string
                                                                        message: string
                                                                      }
                                                                    | {
                                                                        __typename?: "MintMediaPicker"
                                                                        model: string
                                                                        mediaItems: Array<{
                                                                          __typename?: "MintMediaPickerItem"
                                                                          id: number
                                                                          url: string
                                                                          altText?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | null
                                                                } | null>
                                                              }> | null
                                                            }
                                                          | {
                                                              __typename?: "BasicPropertyValue"
                                                              model: string
                                                              value?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicRichText"
                                                              model: string
                                                              richText?:
                                                                | string
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicUnsupportedPropertyValue"
                                                              model: string
                                                              message: string
                                                            }
                                                          | {
                                                              __typename?: "MintMediaPicker"
                                                              model: string
                                                              mediaItems: Array<{
                                                                __typename?: "MintMediaPickerItem"
                                                                id: number
                                                                url: string
                                                                altText?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | null
                                                      } | null>
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicMultiUrlPicker"
                                                    valueType: string
                                                    links: Array<{
                                                      __typename?: "BasicMultiUrlPickerItem"
                                                      name?: string | null
                                                      target?: string | null
                                                      type: LinkType
                                                      url?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicNestedContent"
                                                    valueType: string
                                                    elements?: Array<{
                                                      __typename?: "BasicNestedContentElement"
                                                      properties: Array<{
                                                        __typename?: "BasicProperty"
                                                        alias?: string | null
                                                        editorAlias?:
                                                          | string
                                                          | null
                                                        value?:
                                                          | {
                                                              __typename?: "BasicBlockGridModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicBlockListModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicContentPicker"
                                                              model: string
                                                              contentList: Array<{
                                                                __typename?: "BasicContentPickerItem"
                                                                id: number
                                                                absoluteUrl: string
                                                                key: any
                                                                name?:
                                                                  | string
                                                                  | null
                                                                url: string
                                                                urlSegment?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicDateTimePicker"
                                                              model: string
                                                              dateTime?:
                                                                | any
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicLabel"
                                                              model: string
                                                              label?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicMediaPicker"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicMemberPicker"
                                                              model: string
                                                              members: Array<{
                                                                __typename?: "BasicMemberPickerItem"
                                                                id?:
                                                                  | number
                                                                  | null
                                                                name?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicMultiUrlPicker"
                                                              model: string
                                                              links: Array<{
                                                                __typename?: "BasicMultiUrlPickerItem"
                                                                name?:
                                                                  | string
                                                                  | null
                                                                target?:
                                                                  | string
                                                                  | null
                                                                type: LinkType
                                                                url?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicNestedContent"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicPropertyValue"
                                                              model: string
                                                              value?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicRichText"
                                                              model: string
                                                              richText?:
                                                                | string
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicUnsupportedPropertyValue"
                                                              model: string
                                                              message: string
                                                            }
                                                          | {
                                                              __typename?: "MintMediaPicker"
                                                              model: string
                                                              mediaItems: Array<{
                                                                __typename?: "MintMediaPickerItem"
                                                                id: number
                                                                url: string
                                                                altText?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | null
                                                      } | null>
                                                    }> | null
                                                  }
                                                | {
                                                    __typename?: "BasicPropertyValue"
                                                    valueType: string
                                                    value?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicRichText"
                                                    valueType: string
                                                    richText?: string | null
                                                  }
                                                | {
                                                    __typename?: "BasicUnsupportedPropertyValue"
                                                    message: string
                                                    valueType: string
                                                  }
                                                | {
                                                    __typename?: "MintMediaPicker"
                                                    valueType: string
                                                    mediaItems: Array<{
                                                      __typename?: "MintMediaPickerItem"
                                                      id: number
                                                      url: string
                                                      altText?: string | null
                                                    }>
                                                  }
                                                | null
                                            } | null>
                                          }> | null
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          valueType: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          valueType: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          valueType: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          valueType: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          valueType: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                            properties: Array<{
                                              __typename?: "BasicProperty"
                                              alias?: string | null
                                              editorAlias?: string | null
                                              value?:
                                                | {
                                                    __typename?: "BasicBlockGridModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicBlockListModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicContentPicker"
                                                    model: string
                                                    contentList: Array<{
                                                      __typename?: "BasicContentPickerItem"
                                                      id: number
                                                      absoluteUrl: string
                                                      key: any
                                                      name?: string | null
                                                      url: string
                                                      urlSegment?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicDateTimePicker"
                                                    model: string
                                                    dateTime?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicLabel"
                                                    model: string
                                                    label?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicMediaPicker"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicMemberPicker"
                                                    model: string
                                                    members: Array<{
                                                      __typename?: "BasicMemberPickerItem"
                                                      id?: number | null
                                                      name?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicMultiUrlPicker"
                                                    model: string
                                                    links: Array<{
                                                      __typename?: "BasicMultiUrlPickerItem"
                                                      name?: string | null
                                                      target?: string | null
                                                      type: LinkType
                                                      url?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicNestedContent"
                                                    model: string
                                                    elements?: Array<{
                                                      __typename?: "BasicNestedContentElement"
                                                      properties: Array<{
                                                        __typename?: "BasicProperty"
                                                        alias?: string | null
                                                        editorAlias?:
                                                          | string
                                                          | null
                                                        value?:
                                                          | {
                                                              __typename?: "BasicBlockGridModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicBlockListModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicContentPicker"
                                                              model: string
                                                              contentList: Array<{
                                                                __typename?: "BasicContentPickerItem"
                                                                id: number
                                                                absoluteUrl: string
                                                                key: any
                                                                name?:
                                                                  | string
                                                                  | null
                                                                url: string
                                                                urlSegment?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicDateTimePicker"
                                                              model: string
                                                              dateTime?:
                                                                | any
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicLabel"
                                                              model: string
                                                              label?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicMediaPicker"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicMemberPicker"
                                                              model: string
                                                              members: Array<{
                                                                __typename?: "BasicMemberPickerItem"
                                                                id?:
                                                                  | number
                                                                  | null
                                                                name?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicMultiUrlPicker"
                                                              model: string
                                                              links: Array<{
                                                                __typename?: "BasicMultiUrlPickerItem"
                                                                name?:
                                                                  | string
                                                                  | null
                                                                target?:
                                                                  | string
                                                                  | null
                                                                type: LinkType
                                                                url?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicNestedContent"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicPropertyValue"
                                                              model: string
                                                              value?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicRichText"
                                                              model: string
                                                              richText?:
                                                                | string
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicUnsupportedPropertyValue"
                                                              model: string
                                                              message: string
                                                            }
                                                          | {
                                                              __typename?: "MintMediaPicker"
                                                              model: string
                                                              mediaItems: Array<{
                                                                __typename?: "MintMediaPickerItem"
                                                                id: number
                                                                url: string
                                                                altText?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | null
                                                      } | null>
                                                    }> | null
                                                  }
                                                | {
                                                    __typename?: "BasicPropertyValue"
                                                    model: string
                                                    value?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicRichText"
                                                    model: string
                                                    richText?: string | null
                                                  }
                                                | {
                                                    __typename?: "BasicUnsupportedPropertyValue"
                                                    model: string
                                                    message: string
                                                  }
                                                | {
                                                    __typename?: "MintMediaPicker"
                                                    model: string
                                                    mediaItems: Array<{
                                                      __typename?: "MintMediaPickerItem"
                                                      id: number
                                                      url: string
                                                      altText?: string | null
                                                    }>
                                                  }
                                                | null
                                            } | null>
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          valueType: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          valueType: string
                                          elements?: Array<{
                                            __typename?: "BasicNestedContentElement"
                                            properties: Array<{
                                              __typename?: "BasicProperty"
                                              alias?: string | null
                                              editorAlias?: string | null
                                              value?:
                                                | {
                                                    __typename?: "BasicBlockGridModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicBlockListModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicContentPicker"
                                                    model: string
                                                    contentList: Array<{
                                                      __typename?: "BasicContentPickerItem"
                                                      id: number
                                                      absoluteUrl: string
                                                      key: any
                                                      name?: string | null
                                                      url: string
                                                      urlSegment?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicDateTimePicker"
                                                    model: string
                                                    dateTime?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicLabel"
                                                    model: string
                                                    label?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicMediaPicker"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicMemberPicker"
                                                    model: string
                                                    members: Array<{
                                                      __typename?: "BasicMemberPickerItem"
                                                      id?: number | null
                                                      name?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicMultiUrlPicker"
                                                    model: string
                                                    links: Array<{
                                                      __typename?: "BasicMultiUrlPickerItem"
                                                      name?: string | null
                                                      target?: string | null
                                                      type: LinkType
                                                      url?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicNestedContent"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicPropertyValue"
                                                    model: string
                                                    value?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicRichText"
                                                    model: string
                                                    richText?: string | null
                                                  }
                                                | {
                                                    __typename?: "BasicUnsupportedPropertyValue"
                                                    model: string
                                                    message: string
                                                  }
                                                | {
                                                    __typename?: "MintMediaPicker"
                                                    model: string
                                                    mediaItems: Array<{
                                                      __typename?: "MintMediaPickerItem"
                                                      id: number
                                                      url: string
                                                      altText?: string | null
                                                    }>
                                                  }
                                                | null
                                            } | null>
                                          }> | null
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          valueType: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          valueType: string
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          message: string
                                          valueType: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          valueType: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }> | null
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                valueType: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                valueType: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                valueType: string
                                label?: any | null
                              }
                            | {
                                __typename?: "BasicMediaPicker"
                                valueType: string
                              }
                            | {
                                __typename?: "BasicMemberPicker"
                                valueType: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    alias?: string | null
                                    editorAlias?: string | null
                                    value?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          model: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          model: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          model: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          model: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          model: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          model: string
                                          elements?: Array<{
                                            __typename?: "BasicNestedContentElement"
                                            properties: Array<{
                                              __typename?: "BasicProperty"
                                              alias?: string | null
                                              editorAlias?: string | null
                                              value?:
                                                | {
                                                    __typename?: "BasicBlockGridModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicBlockListModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicContentPicker"
                                                    model: string
                                                    contentList: Array<{
                                                      __typename?: "BasicContentPickerItem"
                                                      id: number
                                                      absoluteUrl: string
                                                      key: any
                                                      name?: string | null
                                                      url: string
                                                      urlSegment?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicDateTimePicker"
                                                    model: string
                                                    dateTime?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicLabel"
                                                    model: string
                                                    label?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicMediaPicker"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicMemberPicker"
                                                    model: string
                                                    members: Array<{
                                                      __typename?: "BasicMemberPickerItem"
                                                      id?: number | null
                                                      name?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicMultiUrlPicker"
                                                    model: string
                                                    links: Array<{
                                                      __typename?: "BasicMultiUrlPickerItem"
                                                      name?: string | null
                                                      target?: string | null
                                                      type: LinkType
                                                      url?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicNestedContent"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicPropertyValue"
                                                    model: string
                                                    value?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicRichText"
                                                    model: string
                                                    richText?: string | null
                                                  }
                                                | {
                                                    __typename?: "BasicUnsupportedPropertyValue"
                                                    model: string
                                                    message: string
                                                  }
                                                | {
                                                    __typename?: "MintMediaPicker"
                                                    model: string
                                                    mediaItems: Array<{
                                                      __typename?: "MintMediaPickerItem"
                                                      id: number
                                                      url: string
                                                      altText?: string | null
                                                    }>
                                                  }
                                                | null
                                            } | null>
                                          }> | null
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          model: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          model: string
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          model: string
                                          message: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          model: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                valueType: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                valueType: string
                                elements?: Array<{
                                  __typename?: "BasicNestedContentElement"
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    alias?: string | null
                                    editorAlias?: string | null
                                    value?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          model: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          model: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          model: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          model: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          model: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          model: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          model: string
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          model: string
                                          message: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          model: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }> | null
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                valueType: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                valueType: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                message: string
                                valueType: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                valueType: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicContentPicker"
                      valueType: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      valueType: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      valueType: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; valueType: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      valueType: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                                elements?: Array<{
                                  __typename?: "BasicNestedContentElement"
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    alias?: string | null
                                    editorAlias?: string | null
                                    value?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          model: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          model: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          model: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          model: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          model: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          model: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          model: string
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          model: string
                                          message: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          model: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }> | null
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      valueType: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicNestedContent"
                      valueType: string
                      elements?: Array<{
                        __typename?: "BasicNestedContentElement"
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicPropertyValue"
                      valueType: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      valueType: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      message: string
                      valueType: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      valueType: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }> | null
          }
        | {
            __typename?: "BasicContentPicker"
            valueType: string
            contentList: Array<{
              __typename?: "BasicContentPickerItem"
              id: number
              absoluteUrl: string
              key: any
              name?: string | null
              url: string
              urlSegment?: string | null
            }>
          }
        | {
            __typename?: "BasicDateTimePicker"
            valueType: string
            dateTime?: any | null
          }
        | { __typename?: "BasicLabel"; valueType: string; label?: any | null }
        | { __typename?: "BasicMediaPicker"; valueType: string }
        | {
            __typename?: "BasicMemberPicker"
            valueType: string
            members: Array<{
              __typename?: "BasicMemberPickerItem"
              id?: number | null
              name?: string | null
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicNestedContent"
                      model: string
                      elements?: Array<{
                        __typename?: "BasicNestedContentElement"
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }>
          }
        | {
            __typename?: "BasicMultiUrlPicker"
            valueType: string
            links: Array<{
              __typename?: "BasicMultiUrlPickerItem"
              name?: string | null
              target?: string | null
              type: LinkType
              url?: string | null
            }>
          }
        | {
            __typename?: "BasicNestedContent"
            valueType: string
            elements?: Array<{
              __typename?: "BasicNestedContentElement"
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | { __typename?: "BasicNestedContent"; model: string }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }> | null
          }
        | {
            __typename?: "BasicPropertyValue"
            valueType: string
            value?: any | null
          }
        | {
            __typename?: "BasicRichText"
            valueType: string
            richText?: string | null
          }
        | {
            __typename?: "BasicUnsupportedPropertyValue"
            message: string
            valueType: string
          }
        | {
            __typename?: "MintMediaPicker"
            valueType: string
            mediaItems: Array<{
              __typename?: "MintMediaPickerItem"
              id: number
              url: string
              altText?: string | null
            }>
          }
        | null
    } | null> | null
  } | null
}

type PropertyEditorsRoute_BasicBlockGridModel_Fragment = {
  __typename?: "BasicBlockGridModel"
  valueType: string
}

type PropertyEditorsRoute_BasicBlockListModel_Fragment = {
  __typename?: "BasicBlockListModel"
  valueType: string
}

type PropertyEditorsRoute_BasicContentPicker_Fragment = {
  __typename?: "BasicContentPicker"
  valueType: string
  contentList: Array<{
    __typename?: "BasicContentPickerItem"
    id: number
    absoluteUrl: string
    key: any
    name?: string | null
    url: string
    urlSegment?: string | null
  }>
}

type PropertyEditorsRoute_BasicDateTimePicker_Fragment = {
  __typename?: "BasicDateTimePicker"
  valueType: string
  dateTime?: any | null
}

type PropertyEditorsRoute_BasicLabel_Fragment = {
  __typename?: "BasicLabel"
  valueType: string
  label?: any | null
}

type PropertyEditorsRoute_BasicMediaPicker_Fragment = {
  __typename?: "BasicMediaPicker"
  valueType: string
}

type PropertyEditorsRoute_BasicMemberPicker_Fragment = {
  __typename?: "BasicMemberPicker"
  valueType: string
  members: Array<{
    __typename?: "BasicMemberPickerItem"
    id?: number | null
    name?: string | null
    properties: Array<{
      __typename?: "BasicProperty"
      alias?: string | null
      editorAlias?: string | null
      value?:
        | { __typename?: "BasicBlockGridModel"; model: string }
        | { __typename?: "BasicBlockListModel"; model: string }
        | {
            __typename?: "BasicContentPicker"
            model: string
            contentList: Array<{
              __typename?: "BasicContentPickerItem"
              id: number
              absoluteUrl: string
              key: any
              name?: string | null
              url: string
              urlSegment?: string | null
            }>
          }
        | {
            __typename?: "BasicDateTimePicker"
            model: string
            dateTime?: any | null
          }
        | { __typename?: "BasicLabel"; model: string; label?: any | null }
        | { __typename?: "BasicMediaPicker"; model: string }
        | {
            __typename?: "BasicMemberPicker"
            model: string
            members: Array<{
              __typename?: "BasicMemberPickerItem"
              id?: number | null
              name?: string | null
            }>
          }
        | {
            __typename?: "BasicMultiUrlPicker"
            model: string
            links: Array<{
              __typename?: "BasicMultiUrlPickerItem"
              name?: string | null
              target?: string | null
              type: LinkType
              url?: string | null
            }>
          }
        | {
            __typename?: "BasicNestedContent"
            model: string
            elements?: Array<{
              __typename?: "BasicNestedContentElement"
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | { __typename?: "BasicNestedContent"; model: string }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }> | null
          }
        | {
            __typename?: "BasicPropertyValue"
            model: string
            value?: any | null
          }
        | {
            __typename?: "BasicRichText"
            model: string
            richText?: string | null
          }
        | {
            __typename?: "BasicUnsupportedPropertyValue"
            model: string
            message: string
          }
        | {
            __typename?: "MintMediaPicker"
            model: string
            mediaItems: Array<{
              __typename?: "MintMediaPickerItem"
              id: number
              url: string
              altText?: string | null
            }>
          }
        | null
    } | null>
  }>
}

type PropertyEditorsRoute_BasicMultiUrlPicker_Fragment = {
  __typename?: "BasicMultiUrlPicker"
  valueType: string
  links: Array<{
    __typename?: "BasicMultiUrlPickerItem"
    name?: string | null
    target?: string | null
    type: LinkType
    url?: string | null
  }>
}

type PropertyEditorsRoute_BasicNestedContent_Fragment = {
  __typename?: "BasicNestedContent"
  valueType: string
  elements?: Array<{
    __typename?: "BasicNestedContentElement"
    properties: Array<{
      __typename?: "BasicProperty"
      alias?: string | null
      editorAlias?: string | null
      value?:
        | { __typename?: "BasicBlockGridModel"; model: string }
        | { __typename?: "BasicBlockListModel"; model: string }
        | {
            __typename?: "BasicContentPicker"
            model: string
            contentList: Array<{
              __typename?: "BasicContentPickerItem"
              id: number
              absoluteUrl: string
              key: any
              name?: string | null
              url: string
              urlSegment?: string | null
            }>
          }
        | {
            __typename?: "BasicDateTimePicker"
            model: string
            dateTime?: any | null
          }
        | { __typename?: "BasicLabel"; model: string; label?: any | null }
        | { __typename?: "BasicMediaPicker"; model: string }
        | {
            __typename?: "BasicMemberPicker"
            model: string
            members: Array<{
              __typename?: "BasicMemberPickerItem"
              id?: number | null
              name?: string | null
            }>
          }
        | {
            __typename?: "BasicMultiUrlPicker"
            model: string
            links: Array<{
              __typename?: "BasicMultiUrlPickerItem"
              name?: string | null
              target?: string | null
              type: LinkType
              url?: string | null
            }>
          }
        | { __typename?: "BasicNestedContent"; model: string }
        | {
            __typename?: "BasicPropertyValue"
            model: string
            value?: any | null
          }
        | {
            __typename?: "BasicRichText"
            model: string
            richText?: string | null
          }
        | {
            __typename?: "BasicUnsupportedPropertyValue"
            model: string
            message: string
          }
        | {
            __typename?: "MintMediaPicker"
            model: string
            mediaItems: Array<{
              __typename?: "MintMediaPickerItem"
              id: number
              url: string
              altText?: string | null
            }>
          }
        | null
    } | null>
  }> | null
}

type PropertyEditorsRoute_BasicPropertyValue_Fragment = {
  __typename?: "BasicPropertyValue"
  valueType: string
  value?: any | null
}

type PropertyEditorsRoute_BasicRichText_Fragment = {
  __typename?: "BasicRichText"
  valueType: string
  richText?: string | null
}

type PropertyEditorsRoute_BasicUnsupportedPropertyValue_Fragment = {
  __typename?: "BasicUnsupportedPropertyValue"
  message: string
  valueType: string
}

type PropertyEditorsRoute_MintMediaPicker_Fragment = {
  __typename?: "MintMediaPicker"
  valueType: string
  mediaItems: Array<{
    __typename?: "MintMediaPickerItem"
    id: number
    url: string
    altText?: string | null
  }>
}

export type PropertyEditorsRouteFragment =
  | PropertyEditorsRoute_BasicBlockGridModel_Fragment
  | PropertyEditorsRoute_BasicBlockListModel_Fragment
  | PropertyEditorsRoute_BasicContentPicker_Fragment
  | PropertyEditorsRoute_BasicDateTimePicker_Fragment
  | PropertyEditorsRoute_BasicLabel_Fragment
  | PropertyEditorsRoute_BasicMediaPicker_Fragment
  | PropertyEditorsRoute_BasicMemberPicker_Fragment
  | PropertyEditorsRoute_BasicMultiUrlPicker_Fragment
  | PropertyEditorsRoute_BasicNestedContent_Fragment
  | PropertyEditorsRoute_BasicPropertyValue_Fragment
  | PropertyEditorsRoute_BasicRichText_Fragment
  | PropertyEditorsRoute_BasicUnsupportedPropertyValue_Fragment
  | PropertyEditorsRoute_MintMediaPicker_Fragment

type MemberPickerRoute_BasicBlockGridModel_Fragment = {
  __typename?: "BasicBlockGridModel"
}

type MemberPickerRoute_BasicBlockListModel_Fragment = {
  __typename?: "BasicBlockListModel"
}

type MemberPickerRoute_BasicContentPicker_Fragment = {
  __typename?: "BasicContentPicker"
}

type MemberPickerRoute_BasicDateTimePicker_Fragment = {
  __typename?: "BasicDateTimePicker"
}

type MemberPickerRoute_BasicLabel_Fragment = { __typename?: "BasicLabel" }

type MemberPickerRoute_BasicMediaPicker_Fragment = {
  __typename?: "BasicMediaPicker"
}

type MemberPickerRoute_BasicMemberPicker_Fragment = {
  __typename?: "BasicMemberPicker"
  members: Array<{
    __typename?: "BasicMemberPickerItem"
    id?: number | null
    name?: string | null
    properties: Array<{
      __typename?: "BasicProperty"
      alias?: string | null
      editorAlias?: string | null
      value?:
        | { __typename?: "BasicBlockGridModel"; model: string }
        | { __typename?: "BasicBlockListModel"; model: string }
        | {
            __typename?: "BasicContentPicker"
            model: string
            contentList: Array<{
              __typename?: "BasicContentPickerItem"
              id: number
              absoluteUrl: string
              key: any
              name?: string | null
              url: string
              urlSegment?: string | null
            }>
          }
        | {
            __typename?: "BasicDateTimePicker"
            model: string
            dateTime?: any | null
          }
        | { __typename?: "BasicLabel"; model: string; label?: any | null }
        | { __typename?: "BasicMediaPicker"; model: string }
        | {
            __typename?: "BasicMemberPicker"
            model: string
            members: Array<{
              __typename?: "BasicMemberPickerItem"
              id?: number | null
              name?: string | null
            }>
          }
        | {
            __typename?: "BasicMultiUrlPicker"
            model: string
            links: Array<{
              __typename?: "BasicMultiUrlPickerItem"
              name?: string | null
              target?: string | null
              type: LinkType
              url?: string | null
            }>
          }
        | {
            __typename?: "BasicNestedContent"
            model: string
            elements?: Array<{
              __typename?: "BasicNestedContentElement"
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | { __typename?: "BasicNestedContent"; model: string }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }> | null
          }
        | {
            __typename?: "BasicPropertyValue"
            model: string
            value?: any | null
          }
        | {
            __typename?: "BasicRichText"
            model: string
            richText?: string | null
          }
        | {
            __typename?: "BasicUnsupportedPropertyValue"
            model: string
            message: string
          }
        | {
            __typename?: "MintMediaPicker"
            model: string
            mediaItems: Array<{
              __typename?: "MintMediaPickerItem"
              id: number
              url: string
              altText?: string | null
            }>
          }
        | null
    } | null>
  }>
}

type MemberPickerRoute_BasicMultiUrlPicker_Fragment = {
  __typename?: "BasicMultiUrlPicker"
}

type MemberPickerRoute_BasicNestedContent_Fragment = {
  __typename?: "BasicNestedContent"
}

type MemberPickerRoute_BasicPropertyValue_Fragment = {
  __typename?: "BasicPropertyValue"
}

type MemberPickerRoute_BasicRichText_Fragment = { __typename?: "BasicRichText" }

type MemberPickerRoute_BasicUnsupportedPropertyValue_Fragment = {
  __typename?: "BasicUnsupportedPropertyValue"
}

type MemberPickerRoute_MintMediaPicker_Fragment = {
  __typename?: "MintMediaPicker"
}

export type MemberPickerRouteFragment =
  | MemberPickerRoute_BasicBlockGridModel_Fragment
  | MemberPickerRoute_BasicBlockListModel_Fragment
  | MemberPickerRoute_BasicContentPicker_Fragment
  | MemberPickerRoute_BasicDateTimePicker_Fragment
  | MemberPickerRoute_BasicLabel_Fragment
  | MemberPickerRoute_BasicMediaPicker_Fragment
  | MemberPickerRoute_BasicMemberPicker_Fragment
  | MemberPickerRoute_BasicMultiUrlPicker_Fragment
  | MemberPickerRoute_BasicNestedContent_Fragment
  | MemberPickerRoute_BasicPropertyValue_Fragment
  | MemberPickerRoute_BasicRichText_Fragment
  | MemberPickerRoute_BasicUnsupportedPropertyValue_Fragment
  | MemberPickerRoute_MintMediaPicker_Fragment

type MemberPropertyEditorsRoute_BasicBlockGridModel_Fragment = {
  __typename?: "BasicBlockGridModel"
  model: string
}

type MemberPropertyEditorsRoute_BasicBlockListModel_Fragment = {
  __typename?: "BasicBlockListModel"
  model: string
}

type MemberPropertyEditorsRoute_BasicContentPicker_Fragment = {
  __typename?: "BasicContentPicker"
  model: string
  contentList: Array<{
    __typename?: "BasicContentPickerItem"
    id: number
    absoluteUrl: string
    key: any
    name?: string | null
    url: string
    urlSegment?: string | null
  }>
}

type MemberPropertyEditorsRoute_BasicDateTimePicker_Fragment = {
  __typename?: "BasicDateTimePicker"
  model: string
  dateTime?: any | null
}

type MemberPropertyEditorsRoute_BasicLabel_Fragment = {
  __typename?: "BasicLabel"
  model: string
  label?: any | null
}

type MemberPropertyEditorsRoute_BasicMediaPicker_Fragment = {
  __typename?: "BasicMediaPicker"
  model: string
}

type MemberPropertyEditorsRoute_BasicMemberPicker_Fragment = {
  __typename?: "BasicMemberPicker"
  model: string
  members: Array<{
    __typename?: "BasicMemberPickerItem"
    id?: number | null
    name?: string | null
  }>
}

type MemberPropertyEditorsRoute_BasicMultiUrlPicker_Fragment = {
  __typename?: "BasicMultiUrlPicker"
  model: string
  links: Array<{
    __typename?: "BasicMultiUrlPickerItem"
    name?: string | null
    target?: string | null
    type: LinkType
    url?: string | null
  }>
}

type MemberPropertyEditorsRoute_BasicNestedContent_Fragment = {
  __typename?: "BasicNestedContent"
  model: string
  elements?: Array<{
    __typename?: "BasicNestedContentElement"
    properties: Array<{
      __typename?: "BasicProperty"
      alias?: string | null
      editorAlias?: string | null
      value?:
        | { __typename?: "BasicBlockGridModel"; model: string }
        | { __typename?: "BasicBlockListModel"; model: string }
        | {
            __typename?: "BasicContentPicker"
            model: string
            contentList: Array<{
              __typename?: "BasicContentPickerItem"
              id: number
              absoluteUrl: string
              key: any
              name?: string | null
              url: string
              urlSegment?: string | null
            }>
          }
        | {
            __typename?: "BasicDateTimePicker"
            model: string
            dateTime?: any | null
          }
        | { __typename?: "BasicLabel"; model: string; label?: any | null }
        | { __typename?: "BasicMediaPicker"; model: string }
        | {
            __typename?: "BasicMemberPicker"
            model: string
            members: Array<{
              __typename?: "BasicMemberPickerItem"
              id?: number | null
              name?: string | null
            }>
          }
        | {
            __typename?: "BasicMultiUrlPicker"
            model: string
            links: Array<{
              __typename?: "BasicMultiUrlPickerItem"
              name?: string | null
              target?: string | null
              type: LinkType
              url?: string | null
            }>
          }
        | { __typename?: "BasicNestedContent"; model: string }
        | {
            __typename?: "BasicPropertyValue"
            model: string
            value?: any | null
          }
        | {
            __typename?: "BasicRichText"
            model: string
            richText?: string | null
          }
        | {
            __typename?: "BasicUnsupportedPropertyValue"
            model: string
            message: string
          }
        | {
            __typename?: "MintMediaPicker"
            model: string
            mediaItems: Array<{
              __typename?: "MintMediaPickerItem"
              id: number
              url: string
              altText?: string | null
            }>
          }
        | null
    } | null>
  }> | null
}

type MemberPropertyEditorsRoute_BasicPropertyValue_Fragment = {
  __typename?: "BasicPropertyValue"
  model: string
  value?: any | null
}

type MemberPropertyEditorsRoute_BasicRichText_Fragment = {
  __typename?: "BasicRichText"
  model: string
  richText?: string | null
}

type MemberPropertyEditorsRoute_BasicUnsupportedPropertyValue_Fragment = {
  __typename?: "BasicUnsupportedPropertyValue"
  model: string
  message: string
}

type MemberPropertyEditorsRoute_MintMediaPicker_Fragment = {
  __typename?: "MintMediaPicker"
  model: string
  mediaItems: Array<{
    __typename?: "MintMediaPickerItem"
    id: number
    url: string
    altText?: string | null
  }>
}

export type MemberPropertyEditorsRouteFragment =
  | MemberPropertyEditorsRoute_BasicBlockGridModel_Fragment
  | MemberPropertyEditorsRoute_BasicBlockListModel_Fragment
  | MemberPropertyEditorsRoute_BasicContentPicker_Fragment
  | MemberPropertyEditorsRoute_BasicDateTimePicker_Fragment
  | MemberPropertyEditorsRoute_BasicLabel_Fragment
  | MemberPropertyEditorsRoute_BasicMediaPicker_Fragment
  | MemberPropertyEditorsRoute_BasicMemberPicker_Fragment
  | MemberPropertyEditorsRoute_BasicMultiUrlPicker_Fragment
  | MemberPropertyEditorsRoute_BasicNestedContent_Fragment
  | MemberPropertyEditorsRoute_BasicPropertyValue_Fragment
  | MemberPropertyEditorsRoute_BasicRichText_Fragment
  | MemberPropertyEditorsRoute_BasicUnsupportedPropertyValue_Fragment
  | MemberPropertyEditorsRoute_MintMediaPicker_Fragment

type NestedContentRoute_BasicBlockGridModel_Fragment = {
  __typename?: "BasicBlockGridModel"
}

type NestedContentRoute_BasicBlockListModel_Fragment = {
  __typename?: "BasicBlockListModel"
}

type NestedContentRoute_BasicContentPicker_Fragment = {
  __typename?: "BasicContentPicker"
}

type NestedContentRoute_BasicDateTimePicker_Fragment = {
  __typename?: "BasicDateTimePicker"
}

type NestedContentRoute_BasicLabel_Fragment = { __typename?: "BasicLabel" }

type NestedContentRoute_BasicMediaPicker_Fragment = {
  __typename?: "BasicMediaPicker"
}

type NestedContentRoute_BasicMemberPicker_Fragment = {
  __typename?: "BasicMemberPicker"
}

type NestedContentRoute_BasicMultiUrlPicker_Fragment = {
  __typename?: "BasicMultiUrlPicker"
}

type NestedContentRoute_BasicNestedContent_Fragment = {
  __typename?: "BasicNestedContent"
  elements?: Array<{
    __typename?: "BasicNestedContentElement"
    properties: Array<{
      __typename?: "BasicProperty"
      alias?: string | null
      editorAlias?: string | null
      value?:
        | { __typename?: "BasicBlockGridModel"; model: string }
        | { __typename?: "BasicBlockListModel"; model: string }
        | {
            __typename?: "BasicContentPicker"
            model: string
            contentList: Array<{
              __typename?: "BasicContentPickerItem"
              id: number
              absoluteUrl: string
              key: any
              name?: string | null
              url: string
              urlSegment?: string | null
            }>
          }
        | {
            __typename?: "BasicDateTimePicker"
            model: string
            dateTime?: any | null
          }
        | { __typename?: "BasicLabel"; model: string; label?: any | null }
        | { __typename?: "BasicMediaPicker"; model: string }
        | {
            __typename?: "BasicMemberPicker"
            model: string
            members: Array<{
              __typename?: "BasicMemberPickerItem"
              id?: number | null
              name?: string | null
            }>
          }
        | {
            __typename?: "BasicMultiUrlPicker"
            model: string
            links: Array<{
              __typename?: "BasicMultiUrlPickerItem"
              name?: string | null
              target?: string | null
              type: LinkType
              url?: string | null
            }>
          }
        | { __typename?: "BasicNestedContent"; model: string }
        | {
            __typename?: "BasicPropertyValue"
            model: string
            value?: any | null
          }
        | {
            __typename?: "BasicRichText"
            model: string
            richText?: string | null
          }
        | {
            __typename?: "BasicUnsupportedPropertyValue"
            model: string
            message: string
          }
        | {
            __typename?: "MintMediaPicker"
            model: string
            mediaItems: Array<{
              __typename?: "MintMediaPickerItem"
              id: number
              url: string
              altText?: string | null
            }>
          }
        | null
    } | null>
  }> | null
}

type NestedContentRoute_BasicPropertyValue_Fragment = {
  __typename?: "BasicPropertyValue"
}

type NestedContentRoute_BasicRichText_Fragment = {
  __typename?: "BasicRichText"
}

type NestedContentRoute_BasicUnsupportedPropertyValue_Fragment = {
  __typename?: "BasicUnsupportedPropertyValue"
}

type NestedContentRoute_MintMediaPicker_Fragment = {
  __typename?: "MintMediaPicker"
}

export type NestedContentRouteFragment =
  | NestedContentRoute_BasicBlockGridModel_Fragment
  | NestedContentRoute_BasicBlockListModel_Fragment
  | NestedContentRoute_BasicContentPicker_Fragment
  | NestedContentRoute_BasicDateTimePicker_Fragment
  | NestedContentRoute_BasicLabel_Fragment
  | NestedContentRoute_BasicMediaPicker_Fragment
  | NestedContentRoute_BasicMemberPicker_Fragment
  | NestedContentRoute_BasicMultiUrlPicker_Fragment
  | NestedContentRoute_BasicNestedContent_Fragment
  | NestedContentRoute_BasicPropertyValue_Fragment
  | NestedContentRoute_BasicRichText_Fragment
  | NestedContentRoute_BasicUnsupportedPropertyValue_Fragment
  | NestedContentRoute_MintMediaPicker_Fragment

type BlockEditorRoute_BasicBlockGridModel_Fragment = {
  __typename?: "BasicBlockGridModel"
}

type BlockEditorRoute_BasicBlockListModel_Fragment = {
  __typename?: "BasicBlockListModel"
  blocks?: Array<{
    __typename?: "BasicBlockListItem"
    blockType?: string | null
    properties: Array<{
      __typename?: "BasicProperty"
      propertyName?: string | null
      propertyValue?:
        | { __typename?: "BasicBlockGridModel"; valueType: string }
        | {
            __typename?: "BasicBlockListModel"
            valueType: string
            blocks?: Array<{
              __typename?: "BasicBlockListItem"
              blockType?: string | null
              properties: Array<{
                __typename?: "BasicProperty"
                propertyName?: string | null
                propertyValue?:
                  | { __typename?: "BasicBlockGridModel"; valueType: string }
                  | {
                      __typename?: "BasicBlockListModel"
                      valueType: string
                      blocks?: Array<{
                        __typename?: "BasicBlockListItem"
                        blockType?: string | null
                        properties: Array<{
                          __typename?: "BasicProperty"
                          propertyName?: string | null
                          propertyValue?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                valueType: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                valueType: string
                                blocks?: Array<{
                                  __typename?: "BasicBlockListItem"
                                  blockType?: string | null
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    propertyName?: string | null
                                    propertyValue?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          valueType: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          valueType: string
                                          blocks?: Array<{
                                            __typename?: "BasicBlockListItem"
                                            blockType?: string | null
                                            properties: Array<{
                                              __typename?: "BasicProperty"
                                              propertyName?: string | null
                                              propertyValue?:
                                                | {
                                                    __typename?: "BasicBlockGridModel"
                                                    valueType: string
                                                  }
                                                | {
                                                    __typename?: "BasicBlockListModel"
                                                    valueType: string
                                                  }
                                                | {
                                                    __typename?: "BasicContentPicker"
                                                    valueType: string
                                                    contentList: Array<{
                                                      __typename?: "BasicContentPickerItem"
                                                      id: number
                                                      absoluteUrl: string
                                                      key: any
                                                      name?: string | null
                                                      url: string
                                                      urlSegment?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicDateTimePicker"
                                                    valueType: string
                                                    dateTime?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicLabel"
                                                    valueType: string
                                                    label?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicMediaPicker"
                                                    valueType: string
                                                  }
                                                | {
                                                    __typename?: "BasicMemberPicker"
                                                    valueType: string
                                                    members: Array<{
                                                      __typename?: "BasicMemberPickerItem"
                                                      id?: number | null
                                                      name?: string | null
                                                      properties: Array<{
                                                        __typename?: "BasicProperty"
                                                        alias?: string | null
                                                        editorAlias?:
                                                          | string
                                                          | null
                                                        value?:
                                                          | {
                                                              __typename?: "BasicBlockGridModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicBlockListModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicContentPicker"
                                                              model: string
                                                              contentList: Array<{
                                                                __typename?: "BasicContentPickerItem"
                                                                id: number
                                                                absoluteUrl: string
                                                                key: any
                                                                name?:
                                                                  | string
                                                                  | null
                                                                url: string
                                                                urlSegment?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicDateTimePicker"
                                                              model: string
                                                              dateTime?:
                                                                | any
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicLabel"
                                                              model: string
                                                              label?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicMediaPicker"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicMemberPicker"
                                                              model: string
                                                              members: Array<{
                                                                __typename?: "BasicMemberPickerItem"
                                                                id?:
                                                                  | number
                                                                  | null
                                                                name?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicMultiUrlPicker"
                                                              model: string
                                                              links: Array<{
                                                                __typename?: "BasicMultiUrlPickerItem"
                                                                name?:
                                                                  | string
                                                                  | null
                                                                target?:
                                                                  | string
                                                                  | null
                                                                type: LinkType
                                                                url?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicNestedContent"
                                                              model: string
                                                              elements?: Array<{
                                                                __typename?: "BasicNestedContentElement"
                                                                properties: Array<{
                                                                  __typename?: "BasicProperty"
                                                                  alias?:
                                                                    | string
                                                                    | null
                                                                  editorAlias?:
                                                                    | string
                                                                    | null
                                                                  value?:
                                                                    | {
                                                                        __typename?: "BasicBlockGridModel"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicBlockListModel"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicContentPicker"
                                                                        model: string
                                                                        contentList: Array<{
                                                                          __typename?: "BasicContentPickerItem"
                                                                          id: number
                                                                          absoluteUrl: string
                                                                          key: any
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                          url: string
                                                                          urlSegment?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicDateTimePicker"
                                                                        model: string
                                                                        dateTime?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicLabel"
                                                                        model: string
                                                                        label?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMediaPicker"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMemberPicker"
                                                                        model: string
                                                                        members: Array<{
                                                                          __typename?: "BasicMemberPickerItem"
                                                                          id?:
                                                                            | number
                                                                            | null
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMultiUrlPicker"
                                                                        model: string
                                                                        links: Array<{
                                                                          __typename?: "BasicMultiUrlPickerItem"
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                          target?:
                                                                            | string
                                                                            | null
                                                                          type: LinkType
                                                                          url?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicNestedContent"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicPropertyValue"
                                                                        model: string
                                                                        value?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicRichText"
                                                                        model: string
                                                                        richText?:
                                                                          | string
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicUnsupportedPropertyValue"
                                                                        model: string
                                                                        message: string
                                                                      }
                                                                    | {
                                                                        __typename?: "MintMediaPicker"
                                                                        model: string
                                                                        mediaItems: Array<{
                                                                          __typename?: "MintMediaPickerItem"
                                                                          id: number
                                                                          url: string
                                                                          altText?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | null
                                                                } | null>
                                                              }> | null
                                                            }
                                                          | {
                                                              __typename?: "BasicPropertyValue"
                                                              model: string
                                                              value?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicRichText"
                                                              model: string
                                                              richText?:
                                                                | string
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicUnsupportedPropertyValue"
                                                              model: string
                                                              message: string
                                                            }
                                                          | {
                                                              __typename?: "MintMediaPicker"
                                                              model: string
                                                              mediaItems: Array<{
                                                                __typename?: "MintMediaPickerItem"
                                                                id: number
                                                                url: string
                                                                altText?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | null
                                                      } | null>
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicMultiUrlPicker"
                                                    valueType: string
                                                    links: Array<{
                                                      __typename?: "BasicMultiUrlPickerItem"
                                                      name?: string | null
                                                      target?: string | null
                                                      type: LinkType
                                                      url?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicNestedContent"
                                                    valueType: string
                                                    elements?: Array<{
                                                      __typename?: "BasicNestedContentElement"
                                                      properties: Array<{
                                                        __typename?: "BasicProperty"
                                                        alias?: string | null
                                                        editorAlias?:
                                                          | string
                                                          | null
                                                        value?:
                                                          | {
                                                              __typename?: "BasicBlockGridModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicBlockListModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicContentPicker"
                                                              model: string
                                                              contentList: Array<{
                                                                __typename?: "BasicContentPickerItem"
                                                                id: number
                                                                absoluteUrl: string
                                                                key: any
                                                                name?:
                                                                  | string
                                                                  | null
                                                                url: string
                                                                urlSegment?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicDateTimePicker"
                                                              model: string
                                                              dateTime?:
                                                                | any
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicLabel"
                                                              model: string
                                                              label?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicMediaPicker"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicMemberPicker"
                                                              model: string
                                                              members: Array<{
                                                                __typename?: "BasicMemberPickerItem"
                                                                id?:
                                                                  | number
                                                                  | null
                                                                name?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicMultiUrlPicker"
                                                              model: string
                                                              links: Array<{
                                                                __typename?: "BasicMultiUrlPickerItem"
                                                                name?:
                                                                  | string
                                                                  | null
                                                                target?:
                                                                  | string
                                                                  | null
                                                                type: LinkType
                                                                url?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicNestedContent"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicPropertyValue"
                                                              model: string
                                                              value?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicRichText"
                                                              model: string
                                                              richText?:
                                                                | string
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicUnsupportedPropertyValue"
                                                              model: string
                                                              message: string
                                                            }
                                                          | {
                                                              __typename?: "MintMediaPicker"
                                                              model: string
                                                              mediaItems: Array<{
                                                                __typename?: "MintMediaPickerItem"
                                                                id: number
                                                                url: string
                                                                altText?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | null
                                                      } | null>
                                                    }> | null
                                                  }
                                                | {
                                                    __typename?: "BasicPropertyValue"
                                                    valueType: string
                                                    value?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicRichText"
                                                    valueType: string
                                                    richText?: string | null
                                                  }
                                                | {
                                                    __typename?: "BasicUnsupportedPropertyValue"
                                                    message: string
                                                    valueType: string
                                                  }
                                                | {
                                                    __typename?: "MintMediaPicker"
                                                    valueType: string
                                                    mediaItems: Array<{
                                                      __typename?: "MintMediaPickerItem"
                                                      id: number
                                                      url: string
                                                      altText?: string | null
                                                    }>
                                                  }
                                                | null
                                            } | null>
                                          }> | null
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          valueType: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          valueType: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          valueType: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          valueType: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          valueType: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                            properties: Array<{
                                              __typename?: "BasicProperty"
                                              alias?: string | null
                                              editorAlias?: string | null
                                              value?:
                                                | {
                                                    __typename?: "BasicBlockGridModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicBlockListModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicContentPicker"
                                                    model: string
                                                    contentList: Array<{
                                                      __typename?: "BasicContentPickerItem"
                                                      id: number
                                                      absoluteUrl: string
                                                      key: any
                                                      name?: string | null
                                                      url: string
                                                      urlSegment?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicDateTimePicker"
                                                    model: string
                                                    dateTime?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicLabel"
                                                    model: string
                                                    label?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicMediaPicker"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicMemberPicker"
                                                    model: string
                                                    members: Array<{
                                                      __typename?: "BasicMemberPickerItem"
                                                      id?: number | null
                                                      name?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicMultiUrlPicker"
                                                    model: string
                                                    links: Array<{
                                                      __typename?: "BasicMultiUrlPickerItem"
                                                      name?: string | null
                                                      target?: string | null
                                                      type: LinkType
                                                      url?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicNestedContent"
                                                    model: string
                                                    elements?: Array<{
                                                      __typename?: "BasicNestedContentElement"
                                                      properties: Array<{
                                                        __typename?: "BasicProperty"
                                                        alias?: string | null
                                                        editorAlias?:
                                                          | string
                                                          | null
                                                        value?:
                                                          | {
                                                              __typename?: "BasicBlockGridModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicBlockListModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicContentPicker"
                                                              model: string
                                                              contentList: Array<{
                                                                __typename?: "BasicContentPickerItem"
                                                                id: number
                                                                absoluteUrl: string
                                                                key: any
                                                                name?:
                                                                  | string
                                                                  | null
                                                                url: string
                                                                urlSegment?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicDateTimePicker"
                                                              model: string
                                                              dateTime?:
                                                                | any
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicLabel"
                                                              model: string
                                                              label?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicMediaPicker"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicMemberPicker"
                                                              model: string
                                                              members: Array<{
                                                                __typename?: "BasicMemberPickerItem"
                                                                id?:
                                                                  | number
                                                                  | null
                                                                name?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicMultiUrlPicker"
                                                              model: string
                                                              links: Array<{
                                                                __typename?: "BasicMultiUrlPickerItem"
                                                                name?:
                                                                  | string
                                                                  | null
                                                                target?:
                                                                  | string
                                                                  | null
                                                                type: LinkType
                                                                url?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicNestedContent"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicPropertyValue"
                                                              model: string
                                                              value?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicRichText"
                                                              model: string
                                                              richText?:
                                                                | string
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicUnsupportedPropertyValue"
                                                              model: string
                                                              message: string
                                                            }
                                                          | {
                                                              __typename?: "MintMediaPicker"
                                                              model: string
                                                              mediaItems: Array<{
                                                                __typename?: "MintMediaPickerItem"
                                                                id: number
                                                                url: string
                                                                altText?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | null
                                                      } | null>
                                                    }> | null
                                                  }
                                                | {
                                                    __typename?: "BasicPropertyValue"
                                                    model: string
                                                    value?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicRichText"
                                                    model: string
                                                    richText?: string | null
                                                  }
                                                | {
                                                    __typename?: "BasicUnsupportedPropertyValue"
                                                    model: string
                                                    message: string
                                                  }
                                                | {
                                                    __typename?: "MintMediaPicker"
                                                    model: string
                                                    mediaItems: Array<{
                                                      __typename?: "MintMediaPickerItem"
                                                      id: number
                                                      url: string
                                                      altText?: string | null
                                                    }>
                                                  }
                                                | null
                                            } | null>
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          valueType: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          valueType: string
                                          elements?: Array<{
                                            __typename?: "BasicNestedContentElement"
                                            properties: Array<{
                                              __typename?: "BasicProperty"
                                              alias?: string | null
                                              editorAlias?: string | null
                                              value?:
                                                | {
                                                    __typename?: "BasicBlockGridModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicBlockListModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicContentPicker"
                                                    model: string
                                                    contentList: Array<{
                                                      __typename?: "BasicContentPickerItem"
                                                      id: number
                                                      absoluteUrl: string
                                                      key: any
                                                      name?: string | null
                                                      url: string
                                                      urlSegment?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicDateTimePicker"
                                                    model: string
                                                    dateTime?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicLabel"
                                                    model: string
                                                    label?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicMediaPicker"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicMemberPicker"
                                                    model: string
                                                    members: Array<{
                                                      __typename?: "BasicMemberPickerItem"
                                                      id?: number | null
                                                      name?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicMultiUrlPicker"
                                                    model: string
                                                    links: Array<{
                                                      __typename?: "BasicMultiUrlPickerItem"
                                                      name?: string | null
                                                      target?: string | null
                                                      type: LinkType
                                                      url?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicNestedContent"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicPropertyValue"
                                                    model: string
                                                    value?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicRichText"
                                                    model: string
                                                    richText?: string | null
                                                  }
                                                | {
                                                    __typename?: "BasicUnsupportedPropertyValue"
                                                    model: string
                                                    message: string
                                                  }
                                                | {
                                                    __typename?: "MintMediaPicker"
                                                    model: string
                                                    mediaItems: Array<{
                                                      __typename?: "MintMediaPickerItem"
                                                      id: number
                                                      url: string
                                                      altText?: string | null
                                                    }>
                                                  }
                                                | null
                                            } | null>
                                          }> | null
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          valueType: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          valueType: string
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          message: string
                                          valueType: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          valueType: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }> | null
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                valueType: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                valueType: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                valueType: string
                                label?: any | null
                              }
                            | {
                                __typename?: "BasicMediaPicker"
                                valueType: string
                              }
                            | {
                                __typename?: "BasicMemberPicker"
                                valueType: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    alias?: string | null
                                    editorAlias?: string | null
                                    value?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          model: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          model: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          model: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          model: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          model: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          model: string
                                          elements?: Array<{
                                            __typename?: "BasicNestedContentElement"
                                            properties: Array<{
                                              __typename?: "BasicProperty"
                                              alias?: string | null
                                              editorAlias?: string | null
                                              value?:
                                                | {
                                                    __typename?: "BasicBlockGridModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicBlockListModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicContentPicker"
                                                    model: string
                                                    contentList: Array<{
                                                      __typename?: "BasicContentPickerItem"
                                                      id: number
                                                      absoluteUrl: string
                                                      key: any
                                                      name?: string | null
                                                      url: string
                                                      urlSegment?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicDateTimePicker"
                                                    model: string
                                                    dateTime?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicLabel"
                                                    model: string
                                                    label?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicMediaPicker"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicMemberPicker"
                                                    model: string
                                                    members: Array<{
                                                      __typename?: "BasicMemberPickerItem"
                                                      id?: number | null
                                                      name?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicMultiUrlPicker"
                                                    model: string
                                                    links: Array<{
                                                      __typename?: "BasicMultiUrlPickerItem"
                                                      name?: string | null
                                                      target?: string | null
                                                      type: LinkType
                                                      url?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicNestedContent"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicPropertyValue"
                                                    model: string
                                                    value?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicRichText"
                                                    model: string
                                                    richText?: string | null
                                                  }
                                                | {
                                                    __typename?: "BasicUnsupportedPropertyValue"
                                                    model: string
                                                    message: string
                                                  }
                                                | {
                                                    __typename?: "MintMediaPicker"
                                                    model: string
                                                    mediaItems: Array<{
                                                      __typename?: "MintMediaPickerItem"
                                                      id: number
                                                      url: string
                                                      altText?: string | null
                                                    }>
                                                  }
                                                | null
                                            } | null>
                                          }> | null
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          model: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          model: string
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          model: string
                                          message: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          model: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                valueType: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                valueType: string
                                elements?: Array<{
                                  __typename?: "BasicNestedContentElement"
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    alias?: string | null
                                    editorAlias?: string | null
                                    value?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          model: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          model: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          model: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          model: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          model: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          model: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          model: string
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          model: string
                                          message: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          model: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }> | null
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                valueType: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                valueType: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                message: string
                                valueType: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                valueType: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicContentPicker"
                      valueType: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      valueType: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      valueType: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; valueType: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      valueType: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                                elements?: Array<{
                                  __typename?: "BasicNestedContentElement"
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    alias?: string | null
                                    editorAlias?: string | null
                                    value?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          model: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          model: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          model: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          model: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          model: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          model: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          model: string
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          model: string
                                          message: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          model: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }> | null
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      valueType: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicNestedContent"
                      valueType: string
                      elements?: Array<{
                        __typename?: "BasicNestedContentElement"
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicPropertyValue"
                      valueType: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      valueType: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      message: string
                      valueType: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      valueType: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }> | null
          }
        | {
            __typename?: "BasicContentPicker"
            valueType: string
            contentList: Array<{
              __typename?: "BasicContentPickerItem"
              id: number
              absoluteUrl: string
              key: any
              name?: string | null
              url: string
              urlSegment?: string | null
            }>
          }
        | {
            __typename?: "BasicDateTimePicker"
            valueType: string
            dateTime?: any | null
          }
        | { __typename?: "BasicLabel"; valueType: string; label?: any | null }
        | { __typename?: "BasicMediaPicker"; valueType: string }
        | {
            __typename?: "BasicMemberPicker"
            valueType: string
            members: Array<{
              __typename?: "BasicMemberPickerItem"
              id?: number | null
              name?: string | null
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicNestedContent"
                      model: string
                      elements?: Array<{
                        __typename?: "BasicNestedContentElement"
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }>
          }
        | {
            __typename?: "BasicMultiUrlPicker"
            valueType: string
            links: Array<{
              __typename?: "BasicMultiUrlPickerItem"
              name?: string | null
              target?: string | null
              type: LinkType
              url?: string | null
            }>
          }
        | {
            __typename?: "BasicNestedContent"
            valueType: string
            elements?: Array<{
              __typename?: "BasicNestedContentElement"
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | { __typename?: "BasicNestedContent"; model: string }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }> | null
          }
        | {
            __typename?: "BasicPropertyValue"
            valueType: string
            value?: any | null
          }
        | {
            __typename?: "BasicRichText"
            valueType: string
            richText?: string | null
          }
        | {
            __typename?: "BasicUnsupportedPropertyValue"
            message: string
            valueType: string
          }
        | {
            __typename?: "MintMediaPicker"
            valueType: string
            mediaItems: Array<{
              __typename?: "MintMediaPickerItem"
              id: number
              url: string
              altText?: string | null
            }>
          }
        | null
    } | null>
  }> | null
}

type BlockEditorRoute_BasicContentPicker_Fragment = {
  __typename?: "BasicContentPicker"
}

type BlockEditorRoute_BasicDateTimePicker_Fragment = {
  __typename?: "BasicDateTimePicker"
}

type BlockEditorRoute_BasicLabel_Fragment = { __typename?: "BasicLabel" }

type BlockEditorRoute_BasicMediaPicker_Fragment = {
  __typename?: "BasicMediaPicker"
}

type BlockEditorRoute_BasicMemberPicker_Fragment = {
  __typename?: "BasicMemberPicker"
}

type BlockEditorRoute_BasicMultiUrlPicker_Fragment = {
  __typename?: "BasicMultiUrlPicker"
}

type BlockEditorRoute_BasicNestedContent_Fragment = {
  __typename?: "BasicNestedContent"
}

type BlockEditorRoute_BasicPropertyValue_Fragment = {
  __typename?: "BasicPropertyValue"
}

type BlockEditorRoute_BasicRichText_Fragment = { __typename?: "BasicRichText" }

type BlockEditorRoute_BasicUnsupportedPropertyValue_Fragment = {
  __typename?: "BasicUnsupportedPropertyValue"
}

type BlockEditorRoute_MintMediaPicker_Fragment = {
  __typename?: "MintMediaPicker"
}

export type BlockEditorRouteFragment =
  | BlockEditorRoute_BasicBlockGridModel_Fragment
  | BlockEditorRoute_BasicBlockListModel_Fragment
  | BlockEditorRoute_BasicContentPicker_Fragment
  | BlockEditorRoute_BasicDateTimePicker_Fragment
  | BlockEditorRoute_BasicLabel_Fragment
  | BlockEditorRoute_BasicMediaPicker_Fragment
  | BlockEditorRoute_BasicMemberPicker_Fragment
  | BlockEditorRoute_BasicMultiUrlPicker_Fragment
  | BlockEditorRoute_BasicNestedContent_Fragment
  | BlockEditorRoute_BasicPropertyValue_Fragment
  | BlockEditorRoute_BasicRichText_Fragment
  | BlockEditorRoute_BasicUnsupportedPropertyValue_Fragment
  | BlockEditorRoute_MintMediaPicker_Fragment

type BlockGridEditorRoute_BasicBlockGridModel_Fragment = {
  __typename?: "BasicBlockGridModel"
  gridColumns?: number | null
  blocks?: Array<{
    __typename?: "BasicBlockGridItem"
    columnSpan: number
    rowSpan: number
    contentProperties: Array<{
      __typename?: "BasicProperty"
      value?:
        | { __typename?: "BasicBlockGridModel"; valueType: string }
        | { __typename?: "BasicBlockListModel"; valueType: string }
        | {
            __typename?: "BasicContentPicker"
            valueType: string
            contentList: Array<{
              __typename?: "BasicContentPickerItem"
              id: number
              absoluteUrl: string
              key: any
              name?: string | null
              url: string
              urlSegment?: string | null
            }>
          }
        | {
            __typename?: "BasicDateTimePicker"
            valueType: string
            dateTime?: any | null
          }
        | { __typename?: "BasicLabel"; valueType: string; label?: any | null }
        | { __typename?: "BasicMediaPicker"; valueType: string }
        | {
            __typename?: "BasicMemberPicker"
            valueType: string
            members: Array<{
              __typename?: "BasicMemberPickerItem"
              id?: number | null
              name?: string | null
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicNestedContent"
                      model: string
                      elements?: Array<{
                        __typename?: "BasicNestedContentElement"
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }>
          }
        | {
            __typename?: "BasicMultiUrlPicker"
            valueType: string
            links: Array<{
              __typename?: "BasicMultiUrlPickerItem"
              name?: string | null
              target?: string | null
              type: LinkType
              url?: string | null
            }>
          }
        | {
            __typename?: "BasicNestedContent"
            valueType: string
            elements?: Array<{
              __typename?: "BasicNestedContentElement"
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | { __typename?: "BasicNestedContent"; model: string }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }> | null
          }
        | {
            __typename?: "BasicPropertyValue"
            valueType: string
            value?: any | null
          }
        | {
            __typename?: "BasicRichText"
            valueType: string
            richText?: string | null
          }
        | {
            __typename?: "BasicUnsupportedPropertyValue"
            message: string
            valueType: string
          }
        | {
            __typename?: "MintMediaPicker"
            valueType: string
            mediaItems: Array<{
              __typename?: "MintMediaPickerItem"
              id: number
              url: string
              altText?: string | null
            }>
          }
        | null
    } | null>
    settingsProperties: Array<{
      __typename?: "BasicProperty"
      value?:
        | { __typename?: "BasicBlockGridModel"; valueType: string }
        | { __typename?: "BasicBlockListModel"; valueType: string }
        | {
            __typename?: "BasicContentPicker"
            valueType: string
            contentList: Array<{
              __typename?: "BasicContentPickerItem"
              id: number
              absoluteUrl: string
              key: any
              name?: string | null
              url: string
              urlSegment?: string | null
            }>
          }
        | {
            __typename?: "BasicDateTimePicker"
            valueType: string
            dateTime?: any | null
          }
        | { __typename?: "BasicLabel"; valueType: string; label?: any | null }
        | { __typename?: "BasicMediaPicker"; valueType: string }
        | {
            __typename?: "BasicMemberPicker"
            valueType: string
            members: Array<{
              __typename?: "BasicMemberPickerItem"
              id?: number | null
              name?: string | null
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicNestedContent"
                      model: string
                      elements?: Array<{
                        __typename?: "BasicNestedContentElement"
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }>
          }
        | {
            __typename?: "BasicMultiUrlPicker"
            valueType: string
            links: Array<{
              __typename?: "BasicMultiUrlPickerItem"
              name?: string | null
              target?: string | null
              type: LinkType
              url?: string | null
            }>
          }
        | {
            __typename?: "BasicNestedContent"
            valueType: string
            elements?: Array<{
              __typename?: "BasicNestedContentElement"
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | { __typename?: "BasicNestedContent"; model: string }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }> | null
          }
        | {
            __typename?: "BasicPropertyValue"
            valueType: string
            value?: any | null
          }
        | {
            __typename?: "BasicRichText"
            valueType: string
            richText?: string | null
          }
        | {
            __typename?: "BasicUnsupportedPropertyValue"
            message: string
            valueType: string
          }
        | {
            __typename?: "MintMediaPicker"
            valueType: string
            mediaItems: Array<{
              __typename?: "MintMediaPickerItem"
              id: number
              url: string
              altText?: string | null
            }>
          }
        | null
    } | null>
    areas: Array<{
      __typename?: "BasicBlockGridArea"
      alias?: string | null
      rowSpan: number
      columnSpan: number
      blocks?: Array<{
        __typename?: "BasicBlockGridItem"
        columnSpan: number
        rowSpan: number
        contentProperties: Array<{
          __typename?: "BasicProperty"
          value?:
            | { __typename?: "BasicBlockGridModel"; valueType: string }
            | { __typename?: "BasicBlockListModel"; valueType: string }
            | {
                __typename?: "BasicContentPicker"
                valueType: string
                contentList: Array<{
                  __typename?: "BasicContentPickerItem"
                  id: number
                  absoluteUrl: string
                  key: any
                  name?: string | null
                  url: string
                  urlSegment?: string | null
                }>
              }
            | {
                __typename?: "BasicDateTimePicker"
                valueType: string
                dateTime?: any | null
              }
            | {
                __typename?: "BasicLabel"
                valueType: string
                label?: any | null
              }
            | { __typename?: "BasicMediaPicker"; valueType: string }
            | {
                __typename?: "BasicMemberPicker"
                valueType: string
                members: Array<{
                  __typename?: "BasicMemberPickerItem"
                  id?: number | null
                  name?: string | null
                  properties: Array<{
                    __typename?: "BasicProperty"
                    alias?: string | null
                    editorAlias?: string | null
                    value?:
                      | { __typename?: "BasicBlockGridModel"; model: string }
                      | { __typename?: "BasicBlockListModel"; model: string }
                      | {
                          __typename?: "BasicContentPicker"
                          model: string
                          contentList: Array<{
                            __typename?: "BasicContentPickerItem"
                            id: number
                            absoluteUrl: string
                            key: any
                            name?: string | null
                            url: string
                            urlSegment?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicDateTimePicker"
                          model: string
                          dateTime?: any | null
                        }
                      | {
                          __typename?: "BasicLabel"
                          model: string
                          label?: any | null
                        }
                      | { __typename?: "BasicMediaPicker"; model: string }
                      | {
                          __typename?: "BasicMemberPicker"
                          model: string
                          members: Array<{
                            __typename?: "BasicMemberPickerItem"
                            id?: number | null
                            name?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicMultiUrlPicker"
                          model: string
                          links: Array<{
                            __typename?: "BasicMultiUrlPickerItem"
                            name?: string | null
                            target?: string | null
                            type: LinkType
                            url?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicNestedContent"
                          model: string
                          elements?: Array<{
                            __typename?: "BasicNestedContentElement"
                            properties: Array<{
                              __typename?: "BasicProperty"
                              alias?: string | null
                              editorAlias?: string | null
                              value?:
                                | {
                                    __typename?: "BasicBlockGridModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicBlockListModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicContentPicker"
                                    model: string
                                    contentList: Array<{
                                      __typename?: "BasicContentPickerItem"
                                      id: number
                                      absoluteUrl: string
                                      key: any
                                      name?: string | null
                                      url: string
                                      urlSegment?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicDateTimePicker"
                                    model: string
                                    dateTime?: any | null
                                  }
                                | {
                                    __typename?: "BasicLabel"
                                    model: string
                                    label?: any | null
                                  }
                                | {
                                    __typename?: "BasicMediaPicker"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicMemberPicker"
                                    model: string
                                    members: Array<{
                                      __typename?: "BasicMemberPickerItem"
                                      id?: number | null
                                      name?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicMultiUrlPicker"
                                    model: string
                                    links: Array<{
                                      __typename?: "BasicMultiUrlPickerItem"
                                      name?: string | null
                                      target?: string | null
                                      type: LinkType
                                      url?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicNestedContent"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicPropertyValue"
                                    model: string
                                    value?: any | null
                                  }
                                | {
                                    __typename?: "BasicRichText"
                                    model: string
                                    richText?: string | null
                                  }
                                | {
                                    __typename?: "BasicUnsupportedPropertyValue"
                                    model: string
                                    message: string
                                  }
                                | {
                                    __typename?: "MintMediaPicker"
                                    model: string
                                    mediaItems: Array<{
                                      __typename?: "MintMediaPickerItem"
                                      id: number
                                      url: string
                                      altText?: string | null
                                    }>
                                  }
                                | null
                            } | null>
                          }> | null
                        }
                      | {
                          __typename?: "BasicPropertyValue"
                          model: string
                          value?: any | null
                        }
                      | {
                          __typename?: "BasicRichText"
                          model: string
                          richText?: string | null
                        }
                      | {
                          __typename?: "BasicUnsupportedPropertyValue"
                          model: string
                          message: string
                        }
                      | {
                          __typename?: "MintMediaPicker"
                          model: string
                          mediaItems: Array<{
                            __typename?: "MintMediaPickerItem"
                            id: number
                            url: string
                            altText?: string | null
                          }>
                        }
                      | null
                  } | null>
                }>
              }
            | {
                __typename?: "BasicMultiUrlPicker"
                valueType: string
                links: Array<{
                  __typename?: "BasicMultiUrlPickerItem"
                  name?: string | null
                  target?: string | null
                  type: LinkType
                  url?: string | null
                }>
              }
            | {
                __typename?: "BasicNestedContent"
                valueType: string
                elements?: Array<{
                  __typename?: "BasicNestedContentElement"
                  properties: Array<{
                    __typename?: "BasicProperty"
                    alias?: string | null
                    editorAlias?: string | null
                    value?:
                      | { __typename?: "BasicBlockGridModel"; model: string }
                      | { __typename?: "BasicBlockListModel"; model: string }
                      | {
                          __typename?: "BasicContentPicker"
                          model: string
                          contentList: Array<{
                            __typename?: "BasicContentPickerItem"
                            id: number
                            absoluteUrl: string
                            key: any
                            name?: string | null
                            url: string
                            urlSegment?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicDateTimePicker"
                          model: string
                          dateTime?: any | null
                        }
                      | {
                          __typename?: "BasicLabel"
                          model: string
                          label?: any | null
                        }
                      | { __typename?: "BasicMediaPicker"; model: string }
                      | {
                          __typename?: "BasicMemberPicker"
                          model: string
                          members: Array<{
                            __typename?: "BasicMemberPickerItem"
                            id?: number | null
                            name?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicMultiUrlPicker"
                          model: string
                          links: Array<{
                            __typename?: "BasicMultiUrlPickerItem"
                            name?: string | null
                            target?: string | null
                            type: LinkType
                            url?: string | null
                          }>
                        }
                      | { __typename?: "BasicNestedContent"; model: string }
                      | {
                          __typename?: "BasicPropertyValue"
                          model: string
                          value?: any | null
                        }
                      | {
                          __typename?: "BasicRichText"
                          model: string
                          richText?: string | null
                        }
                      | {
                          __typename?: "BasicUnsupportedPropertyValue"
                          model: string
                          message: string
                        }
                      | {
                          __typename?: "MintMediaPicker"
                          model: string
                          mediaItems: Array<{
                            __typename?: "MintMediaPickerItem"
                            id: number
                            url: string
                            altText?: string | null
                          }>
                        }
                      | null
                  } | null>
                }> | null
              }
            | {
                __typename?: "BasicPropertyValue"
                valueType: string
                value?: any | null
              }
            | {
                __typename?: "BasicRichText"
                valueType: string
                richText?: string | null
              }
            | {
                __typename?: "BasicUnsupportedPropertyValue"
                message: string
                valueType: string
              }
            | {
                __typename?: "MintMediaPicker"
                valueType: string
                mediaItems: Array<{
                  __typename?: "MintMediaPickerItem"
                  id: number
                  url: string
                  altText?: string | null
                }>
              }
            | null
        } | null>
        settingsProperties: Array<{
          __typename?: "BasicProperty"
          value?:
            | { __typename?: "BasicBlockGridModel"; valueType: string }
            | { __typename?: "BasicBlockListModel"; valueType: string }
            | {
                __typename?: "BasicContentPicker"
                valueType: string
                contentList: Array<{
                  __typename?: "BasicContentPickerItem"
                  id: number
                  absoluteUrl: string
                  key: any
                  name?: string | null
                  url: string
                  urlSegment?: string | null
                }>
              }
            | {
                __typename?: "BasicDateTimePicker"
                valueType: string
                dateTime?: any | null
              }
            | {
                __typename?: "BasicLabel"
                valueType: string
                label?: any | null
              }
            | { __typename?: "BasicMediaPicker"; valueType: string }
            | {
                __typename?: "BasicMemberPicker"
                valueType: string
                members: Array<{
                  __typename?: "BasicMemberPickerItem"
                  id?: number | null
                  name?: string | null
                  properties: Array<{
                    __typename?: "BasicProperty"
                    alias?: string | null
                    editorAlias?: string | null
                    value?:
                      | { __typename?: "BasicBlockGridModel"; model: string }
                      | { __typename?: "BasicBlockListModel"; model: string }
                      | {
                          __typename?: "BasicContentPicker"
                          model: string
                          contentList: Array<{
                            __typename?: "BasicContentPickerItem"
                            id: number
                            absoluteUrl: string
                            key: any
                            name?: string | null
                            url: string
                            urlSegment?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicDateTimePicker"
                          model: string
                          dateTime?: any | null
                        }
                      | {
                          __typename?: "BasicLabel"
                          model: string
                          label?: any | null
                        }
                      | { __typename?: "BasicMediaPicker"; model: string }
                      | {
                          __typename?: "BasicMemberPicker"
                          model: string
                          members: Array<{
                            __typename?: "BasicMemberPickerItem"
                            id?: number | null
                            name?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicMultiUrlPicker"
                          model: string
                          links: Array<{
                            __typename?: "BasicMultiUrlPickerItem"
                            name?: string | null
                            target?: string | null
                            type: LinkType
                            url?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicNestedContent"
                          model: string
                          elements?: Array<{
                            __typename?: "BasicNestedContentElement"
                            properties: Array<{
                              __typename?: "BasicProperty"
                              alias?: string | null
                              editorAlias?: string | null
                              value?:
                                | {
                                    __typename?: "BasicBlockGridModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicBlockListModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicContentPicker"
                                    model: string
                                    contentList: Array<{
                                      __typename?: "BasicContentPickerItem"
                                      id: number
                                      absoluteUrl: string
                                      key: any
                                      name?: string | null
                                      url: string
                                      urlSegment?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicDateTimePicker"
                                    model: string
                                    dateTime?: any | null
                                  }
                                | {
                                    __typename?: "BasicLabel"
                                    model: string
                                    label?: any | null
                                  }
                                | {
                                    __typename?: "BasicMediaPicker"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicMemberPicker"
                                    model: string
                                    members: Array<{
                                      __typename?: "BasicMemberPickerItem"
                                      id?: number | null
                                      name?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicMultiUrlPicker"
                                    model: string
                                    links: Array<{
                                      __typename?: "BasicMultiUrlPickerItem"
                                      name?: string | null
                                      target?: string | null
                                      type: LinkType
                                      url?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicNestedContent"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicPropertyValue"
                                    model: string
                                    value?: any | null
                                  }
                                | {
                                    __typename?: "BasicRichText"
                                    model: string
                                    richText?: string | null
                                  }
                                | {
                                    __typename?: "BasicUnsupportedPropertyValue"
                                    model: string
                                    message: string
                                  }
                                | {
                                    __typename?: "MintMediaPicker"
                                    model: string
                                    mediaItems: Array<{
                                      __typename?: "MintMediaPickerItem"
                                      id: number
                                      url: string
                                      altText?: string | null
                                    }>
                                  }
                                | null
                            } | null>
                          }> | null
                        }
                      | {
                          __typename?: "BasicPropertyValue"
                          model: string
                          value?: any | null
                        }
                      | {
                          __typename?: "BasicRichText"
                          model: string
                          richText?: string | null
                        }
                      | {
                          __typename?: "BasicUnsupportedPropertyValue"
                          model: string
                          message: string
                        }
                      | {
                          __typename?: "MintMediaPicker"
                          model: string
                          mediaItems: Array<{
                            __typename?: "MintMediaPickerItem"
                            id: number
                            url: string
                            altText?: string | null
                          }>
                        }
                      | null
                  } | null>
                }>
              }
            | {
                __typename?: "BasicMultiUrlPicker"
                valueType: string
                links: Array<{
                  __typename?: "BasicMultiUrlPickerItem"
                  name?: string | null
                  target?: string | null
                  type: LinkType
                  url?: string | null
                }>
              }
            | {
                __typename?: "BasicNestedContent"
                valueType: string
                elements?: Array<{
                  __typename?: "BasicNestedContentElement"
                  properties: Array<{
                    __typename?: "BasicProperty"
                    alias?: string | null
                    editorAlias?: string | null
                    value?:
                      | { __typename?: "BasicBlockGridModel"; model: string }
                      | { __typename?: "BasicBlockListModel"; model: string }
                      | {
                          __typename?: "BasicContentPicker"
                          model: string
                          contentList: Array<{
                            __typename?: "BasicContentPickerItem"
                            id: number
                            absoluteUrl: string
                            key: any
                            name?: string | null
                            url: string
                            urlSegment?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicDateTimePicker"
                          model: string
                          dateTime?: any | null
                        }
                      | {
                          __typename?: "BasicLabel"
                          model: string
                          label?: any | null
                        }
                      | { __typename?: "BasicMediaPicker"; model: string }
                      | {
                          __typename?: "BasicMemberPicker"
                          model: string
                          members: Array<{
                            __typename?: "BasicMemberPickerItem"
                            id?: number | null
                            name?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicMultiUrlPicker"
                          model: string
                          links: Array<{
                            __typename?: "BasicMultiUrlPickerItem"
                            name?: string | null
                            target?: string | null
                            type: LinkType
                            url?: string | null
                          }>
                        }
                      | { __typename?: "BasicNestedContent"; model: string }
                      | {
                          __typename?: "BasicPropertyValue"
                          model: string
                          value?: any | null
                        }
                      | {
                          __typename?: "BasicRichText"
                          model: string
                          richText?: string | null
                        }
                      | {
                          __typename?: "BasicUnsupportedPropertyValue"
                          model: string
                          message: string
                        }
                      | {
                          __typename?: "MintMediaPicker"
                          model: string
                          mediaItems: Array<{
                            __typename?: "MintMediaPickerItem"
                            id: number
                            url: string
                            altText?: string | null
                          }>
                        }
                      | null
                  } | null>
                }> | null
              }
            | {
                __typename?: "BasicPropertyValue"
                valueType: string
                value?: any | null
              }
            | {
                __typename?: "BasicRichText"
                valueType: string
                richText?: string | null
              }
            | {
                __typename?: "BasicUnsupportedPropertyValue"
                message: string
                valueType: string
              }
            | {
                __typename?: "MintMediaPicker"
                valueType: string
                mediaItems: Array<{
                  __typename?: "MintMediaPickerItem"
                  id: number
                  url: string
                  altText?: string | null
                }>
              }
            | null
        } | null>
        areas: Array<{
          __typename?: "BasicBlockGridArea"
          alias?: string | null
          rowSpan: number
          columnSpan: number
        } | null>
      }> | null
    } | null>
  }> | null
}

type BlockGridEditorRoute_BasicBlockListModel_Fragment = {
  __typename?: "BasicBlockListModel"
}

type BlockGridEditorRoute_BasicContentPicker_Fragment = {
  __typename?: "BasicContentPicker"
}

type BlockGridEditorRoute_BasicDateTimePicker_Fragment = {
  __typename?: "BasicDateTimePicker"
}

type BlockGridEditorRoute_BasicLabel_Fragment = { __typename?: "BasicLabel" }

type BlockGridEditorRoute_BasicMediaPicker_Fragment = {
  __typename?: "BasicMediaPicker"
}

type BlockGridEditorRoute_BasicMemberPicker_Fragment = {
  __typename?: "BasicMemberPicker"
}

type BlockGridEditorRoute_BasicMultiUrlPicker_Fragment = {
  __typename?: "BasicMultiUrlPicker"
}

type BlockGridEditorRoute_BasicNestedContent_Fragment = {
  __typename?: "BasicNestedContent"
}

type BlockGridEditorRoute_BasicPropertyValue_Fragment = {
  __typename?: "BasicPropertyValue"
}

type BlockGridEditorRoute_BasicRichText_Fragment = {
  __typename?: "BasicRichText"
}

type BlockGridEditorRoute_BasicUnsupportedPropertyValue_Fragment = {
  __typename?: "BasicUnsupportedPropertyValue"
}

type BlockGridEditorRoute_MintMediaPicker_Fragment = {
  __typename?: "MintMediaPicker"
}

export type BlockGridEditorRouteFragment =
  | BlockGridEditorRoute_BasicBlockGridModel_Fragment
  | BlockGridEditorRoute_BasicBlockListModel_Fragment
  | BlockGridEditorRoute_BasicContentPicker_Fragment
  | BlockGridEditorRoute_BasicDateTimePicker_Fragment
  | BlockGridEditorRoute_BasicLabel_Fragment
  | BlockGridEditorRoute_BasicMediaPicker_Fragment
  | BlockGridEditorRoute_BasicMemberPicker_Fragment
  | BlockGridEditorRoute_BasicMultiUrlPicker_Fragment
  | BlockGridEditorRoute_BasicNestedContent_Fragment
  | BlockGridEditorRoute_BasicPropertyValue_Fragment
  | BlockGridEditorRoute_BasicRichText_Fragment
  | BlockGridEditorRoute_BasicUnsupportedPropertyValue_Fragment
  | BlockGridEditorRoute_MintMediaPicker_Fragment

type PropertyValuesRoute_BasicBlockGridModel_Fragment = {
  __typename?: "BasicBlockGridModel"
  gridColumns?: number | null
  valueType: string
  blocks?: Array<{
    __typename?: "BasicBlockGridItem"
    columnSpan: number
    rowSpan: number
    contentProperties: Array<{
      __typename?: "BasicProperty"
      value?:
        | { __typename?: "BasicBlockGridModel"; valueType: string }
        | { __typename?: "BasicBlockListModel"; valueType: string }
        | {
            __typename?: "BasicContentPicker"
            valueType: string
            contentList: Array<{
              __typename?: "BasicContentPickerItem"
              id: number
              absoluteUrl: string
              key: any
              name?: string | null
              url: string
              urlSegment?: string | null
            }>
          }
        | {
            __typename?: "BasicDateTimePicker"
            valueType: string
            dateTime?: any | null
          }
        | { __typename?: "BasicLabel"; valueType: string; label?: any | null }
        | { __typename?: "BasicMediaPicker"; valueType: string }
        | {
            __typename?: "BasicMemberPicker"
            valueType: string
            members: Array<{
              __typename?: "BasicMemberPickerItem"
              id?: number | null
              name?: string | null
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicNestedContent"
                      model: string
                      elements?: Array<{
                        __typename?: "BasicNestedContentElement"
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }>
          }
        | {
            __typename?: "BasicMultiUrlPicker"
            valueType: string
            links: Array<{
              __typename?: "BasicMultiUrlPickerItem"
              name?: string | null
              target?: string | null
              type: LinkType
              url?: string | null
            }>
          }
        | {
            __typename?: "BasicNestedContent"
            valueType: string
            elements?: Array<{
              __typename?: "BasicNestedContentElement"
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | { __typename?: "BasicNestedContent"; model: string }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }> | null
          }
        | {
            __typename?: "BasicPropertyValue"
            valueType: string
            value?: any | null
          }
        | {
            __typename?: "BasicRichText"
            valueType: string
            richText?: string | null
          }
        | {
            __typename?: "BasicUnsupportedPropertyValue"
            message: string
            valueType: string
          }
        | {
            __typename?: "MintMediaPicker"
            valueType: string
            mediaItems: Array<{
              __typename?: "MintMediaPickerItem"
              id: number
              url: string
              altText?: string | null
            }>
          }
        | null
    } | null>
    settingsProperties: Array<{
      __typename?: "BasicProperty"
      value?:
        | { __typename?: "BasicBlockGridModel"; valueType: string }
        | { __typename?: "BasicBlockListModel"; valueType: string }
        | {
            __typename?: "BasicContentPicker"
            valueType: string
            contentList: Array<{
              __typename?: "BasicContentPickerItem"
              id: number
              absoluteUrl: string
              key: any
              name?: string | null
              url: string
              urlSegment?: string | null
            }>
          }
        | {
            __typename?: "BasicDateTimePicker"
            valueType: string
            dateTime?: any | null
          }
        | { __typename?: "BasicLabel"; valueType: string; label?: any | null }
        | { __typename?: "BasicMediaPicker"; valueType: string }
        | {
            __typename?: "BasicMemberPicker"
            valueType: string
            members: Array<{
              __typename?: "BasicMemberPickerItem"
              id?: number | null
              name?: string | null
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicNestedContent"
                      model: string
                      elements?: Array<{
                        __typename?: "BasicNestedContentElement"
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }>
          }
        | {
            __typename?: "BasicMultiUrlPicker"
            valueType: string
            links: Array<{
              __typename?: "BasicMultiUrlPickerItem"
              name?: string | null
              target?: string | null
              type: LinkType
              url?: string | null
            }>
          }
        | {
            __typename?: "BasicNestedContent"
            valueType: string
            elements?: Array<{
              __typename?: "BasicNestedContentElement"
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | { __typename?: "BasicNestedContent"; model: string }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }> | null
          }
        | {
            __typename?: "BasicPropertyValue"
            valueType: string
            value?: any | null
          }
        | {
            __typename?: "BasicRichText"
            valueType: string
            richText?: string | null
          }
        | {
            __typename?: "BasicUnsupportedPropertyValue"
            message: string
            valueType: string
          }
        | {
            __typename?: "MintMediaPicker"
            valueType: string
            mediaItems: Array<{
              __typename?: "MintMediaPickerItem"
              id: number
              url: string
              altText?: string | null
            }>
          }
        | null
    } | null>
    areas: Array<{
      __typename?: "BasicBlockGridArea"
      alias?: string | null
      rowSpan: number
      columnSpan: number
      blocks?: Array<{
        __typename?: "BasicBlockGridItem"
        columnSpan: number
        rowSpan: number
        contentProperties: Array<{
          __typename?: "BasicProperty"
          value?:
            | { __typename?: "BasicBlockGridModel"; valueType: string }
            | { __typename?: "BasicBlockListModel"; valueType: string }
            | {
                __typename?: "BasicContentPicker"
                valueType: string
                contentList: Array<{
                  __typename?: "BasicContentPickerItem"
                  id: number
                  absoluteUrl: string
                  key: any
                  name?: string | null
                  url: string
                  urlSegment?: string | null
                }>
              }
            | {
                __typename?: "BasicDateTimePicker"
                valueType: string
                dateTime?: any | null
              }
            | {
                __typename?: "BasicLabel"
                valueType: string
                label?: any | null
              }
            | { __typename?: "BasicMediaPicker"; valueType: string }
            | {
                __typename?: "BasicMemberPicker"
                valueType: string
                members: Array<{
                  __typename?: "BasicMemberPickerItem"
                  id?: number | null
                  name?: string | null
                  properties: Array<{
                    __typename?: "BasicProperty"
                    alias?: string | null
                    editorAlias?: string | null
                    value?:
                      | { __typename?: "BasicBlockGridModel"; model: string }
                      | { __typename?: "BasicBlockListModel"; model: string }
                      | {
                          __typename?: "BasicContentPicker"
                          model: string
                          contentList: Array<{
                            __typename?: "BasicContentPickerItem"
                            id: number
                            absoluteUrl: string
                            key: any
                            name?: string | null
                            url: string
                            urlSegment?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicDateTimePicker"
                          model: string
                          dateTime?: any | null
                        }
                      | {
                          __typename?: "BasicLabel"
                          model: string
                          label?: any | null
                        }
                      | { __typename?: "BasicMediaPicker"; model: string }
                      | {
                          __typename?: "BasicMemberPicker"
                          model: string
                          members: Array<{
                            __typename?: "BasicMemberPickerItem"
                            id?: number | null
                            name?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicMultiUrlPicker"
                          model: string
                          links: Array<{
                            __typename?: "BasicMultiUrlPickerItem"
                            name?: string | null
                            target?: string | null
                            type: LinkType
                            url?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicNestedContent"
                          model: string
                          elements?: Array<{
                            __typename?: "BasicNestedContentElement"
                            properties: Array<{
                              __typename?: "BasicProperty"
                              alias?: string | null
                              editorAlias?: string | null
                              value?:
                                | {
                                    __typename?: "BasicBlockGridModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicBlockListModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicContentPicker"
                                    model: string
                                    contentList: Array<{
                                      __typename?: "BasicContentPickerItem"
                                      id: number
                                      absoluteUrl: string
                                      key: any
                                      name?: string | null
                                      url: string
                                      urlSegment?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicDateTimePicker"
                                    model: string
                                    dateTime?: any | null
                                  }
                                | {
                                    __typename?: "BasicLabel"
                                    model: string
                                    label?: any | null
                                  }
                                | {
                                    __typename?: "BasicMediaPicker"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicMemberPicker"
                                    model: string
                                    members: Array<{
                                      __typename?: "BasicMemberPickerItem"
                                      id?: number | null
                                      name?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicMultiUrlPicker"
                                    model: string
                                    links: Array<{
                                      __typename?: "BasicMultiUrlPickerItem"
                                      name?: string | null
                                      target?: string | null
                                      type: LinkType
                                      url?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicNestedContent"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicPropertyValue"
                                    model: string
                                    value?: any | null
                                  }
                                | {
                                    __typename?: "BasicRichText"
                                    model: string
                                    richText?: string | null
                                  }
                                | {
                                    __typename?: "BasicUnsupportedPropertyValue"
                                    model: string
                                    message: string
                                  }
                                | {
                                    __typename?: "MintMediaPicker"
                                    model: string
                                    mediaItems: Array<{
                                      __typename?: "MintMediaPickerItem"
                                      id: number
                                      url: string
                                      altText?: string | null
                                    }>
                                  }
                                | null
                            } | null>
                          }> | null
                        }
                      | {
                          __typename?: "BasicPropertyValue"
                          model: string
                          value?: any | null
                        }
                      | {
                          __typename?: "BasicRichText"
                          model: string
                          richText?: string | null
                        }
                      | {
                          __typename?: "BasicUnsupportedPropertyValue"
                          model: string
                          message: string
                        }
                      | {
                          __typename?: "MintMediaPicker"
                          model: string
                          mediaItems: Array<{
                            __typename?: "MintMediaPickerItem"
                            id: number
                            url: string
                            altText?: string | null
                          }>
                        }
                      | null
                  } | null>
                }>
              }
            | {
                __typename?: "BasicMultiUrlPicker"
                valueType: string
                links: Array<{
                  __typename?: "BasicMultiUrlPickerItem"
                  name?: string | null
                  target?: string | null
                  type: LinkType
                  url?: string | null
                }>
              }
            | {
                __typename?: "BasicNestedContent"
                valueType: string
                elements?: Array<{
                  __typename?: "BasicNestedContentElement"
                  properties: Array<{
                    __typename?: "BasicProperty"
                    alias?: string | null
                    editorAlias?: string | null
                    value?:
                      | { __typename?: "BasicBlockGridModel"; model: string }
                      | { __typename?: "BasicBlockListModel"; model: string }
                      | {
                          __typename?: "BasicContentPicker"
                          model: string
                          contentList: Array<{
                            __typename?: "BasicContentPickerItem"
                            id: number
                            absoluteUrl: string
                            key: any
                            name?: string | null
                            url: string
                            urlSegment?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicDateTimePicker"
                          model: string
                          dateTime?: any | null
                        }
                      | {
                          __typename?: "BasicLabel"
                          model: string
                          label?: any | null
                        }
                      | { __typename?: "BasicMediaPicker"; model: string }
                      | {
                          __typename?: "BasicMemberPicker"
                          model: string
                          members: Array<{
                            __typename?: "BasicMemberPickerItem"
                            id?: number | null
                            name?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicMultiUrlPicker"
                          model: string
                          links: Array<{
                            __typename?: "BasicMultiUrlPickerItem"
                            name?: string | null
                            target?: string | null
                            type: LinkType
                            url?: string | null
                          }>
                        }
                      | { __typename?: "BasicNestedContent"; model: string }
                      | {
                          __typename?: "BasicPropertyValue"
                          model: string
                          value?: any | null
                        }
                      | {
                          __typename?: "BasicRichText"
                          model: string
                          richText?: string | null
                        }
                      | {
                          __typename?: "BasicUnsupportedPropertyValue"
                          model: string
                          message: string
                        }
                      | {
                          __typename?: "MintMediaPicker"
                          model: string
                          mediaItems: Array<{
                            __typename?: "MintMediaPickerItem"
                            id: number
                            url: string
                            altText?: string | null
                          }>
                        }
                      | null
                  } | null>
                }> | null
              }
            | {
                __typename?: "BasicPropertyValue"
                valueType: string
                value?: any | null
              }
            | {
                __typename?: "BasicRichText"
                valueType: string
                richText?: string | null
              }
            | {
                __typename?: "BasicUnsupportedPropertyValue"
                message: string
                valueType: string
              }
            | {
                __typename?: "MintMediaPicker"
                valueType: string
                mediaItems: Array<{
                  __typename?: "MintMediaPickerItem"
                  id: number
                  url: string
                  altText?: string | null
                }>
              }
            | null
        } | null>
        settingsProperties: Array<{
          __typename?: "BasicProperty"
          value?:
            | { __typename?: "BasicBlockGridModel"; valueType: string }
            | { __typename?: "BasicBlockListModel"; valueType: string }
            | {
                __typename?: "BasicContentPicker"
                valueType: string
                contentList: Array<{
                  __typename?: "BasicContentPickerItem"
                  id: number
                  absoluteUrl: string
                  key: any
                  name?: string | null
                  url: string
                  urlSegment?: string | null
                }>
              }
            | {
                __typename?: "BasicDateTimePicker"
                valueType: string
                dateTime?: any | null
              }
            | {
                __typename?: "BasicLabel"
                valueType: string
                label?: any | null
              }
            | { __typename?: "BasicMediaPicker"; valueType: string }
            | {
                __typename?: "BasicMemberPicker"
                valueType: string
                members: Array<{
                  __typename?: "BasicMemberPickerItem"
                  id?: number | null
                  name?: string | null
                  properties: Array<{
                    __typename?: "BasicProperty"
                    alias?: string | null
                    editorAlias?: string | null
                    value?:
                      | { __typename?: "BasicBlockGridModel"; model: string }
                      | { __typename?: "BasicBlockListModel"; model: string }
                      | {
                          __typename?: "BasicContentPicker"
                          model: string
                          contentList: Array<{
                            __typename?: "BasicContentPickerItem"
                            id: number
                            absoluteUrl: string
                            key: any
                            name?: string | null
                            url: string
                            urlSegment?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicDateTimePicker"
                          model: string
                          dateTime?: any | null
                        }
                      | {
                          __typename?: "BasicLabel"
                          model: string
                          label?: any | null
                        }
                      | { __typename?: "BasicMediaPicker"; model: string }
                      | {
                          __typename?: "BasicMemberPicker"
                          model: string
                          members: Array<{
                            __typename?: "BasicMemberPickerItem"
                            id?: number | null
                            name?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicMultiUrlPicker"
                          model: string
                          links: Array<{
                            __typename?: "BasicMultiUrlPickerItem"
                            name?: string | null
                            target?: string | null
                            type: LinkType
                            url?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicNestedContent"
                          model: string
                          elements?: Array<{
                            __typename?: "BasicNestedContentElement"
                            properties: Array<{
                              __typename?: "BasicProperty"
                              alias?: string | null
                              editorAlias?: string | null
                              value?:
                                | {
                                    __typename?: "BasicBlockGridModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicBlockListModel"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicContentPicker"
                                    model: string
                                    contentList: Array<{
                                      __typename?: "BasicContentPickerItem"
                                      id: number
                                      absoluteUrl: string
                                      key: any
                                      name?: string | null
                                      url: string
                                      urlSegment?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicDateTimePicker"
                                    model: string
                                    dateTime?: any | null
                                  }
                                | {
                                    __typename?: "BasicLabel"
                                    model: string
                                    label?: any | null
                                  }
                                | {
                                    __typename?: "BasicMediaPicker"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicMemberPicker"
                                    model: string
                                    members: Array<{
                                      __typename?: "BasicMemberPickerItem"
                                      id?: number | null
                                      name?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicMultiUrlPicker"
                                    model: string
                                    links: Array<{
                                      __typename?: "BasicMultiUrlPickerItem"
                                      name?: string | null
                                      target?: string | null
                                      type: LinkType
                                      url?: string | null
                                    }>
                                  }
                                | {
                                    __typename?: "BasicNestedContent"
                                    model: string
                                  }
                                | {
                                    __typename?: "BasicPropertyValue"
                                    model: string
                                    value?: any | null
                                  }
                                | {
                                    __typename?: "BasicRichText"
                                    model: string
                                    richText?: string | null
                                  }
                                | {
                                    __typename?: "BasicUnsupportedPropertyValue"
                                    model: string
                                    message: string
                                  }
                                | {
                                    __typename?: "MintMediaPicker"
                                    model: string
                                    mediaItems: Array<{
                                      __typename?: "MintMediaPickerItem"
                                      id: number
                                      url: string
                                      altText?: string | null
                                    }>
                                  }
                                | null
                            } | null>
                          }> | null
                        }
                      | {
                          __typename?: "BasicPropertyValue"
                          model: string
                          value?: any | null
                        }
                      | {
                          __typename?: "BasicRichText"
                          model: string
                          richText?: string | null
                        }
                      | {
                          __typename?: "BasicUnsupportedPropertyValue"
                          model: string
                          message: string
                        }
                      | {
                          __typename?: "MintMediaPicker"
                          model: string
                          mediaItems: Array<{
                            __typename?: "MintMediaPickerItem"
                            id: number
                            url: string
                            altText?: string | null
                          }>
                        }
                      | null
                  } | null>
                }>
              }
            | {
                __typename?: "BasicMultiUrlPicker"
                valueType: string
                links: Array<{
                  __typename?: "BasicMultiUrlPickerItem"
                  name?: string | null
                  target?: string | null
                  type: LinkType
                  url?: string | null
                }>
              }
            | {
                __typename?: "BasicNestedContent"
                valueType: string
                elements?: Array<{
                  __typename?: "BasicNestedContentElement"
                  properties: Array<{
                    __typename?: "BasicProperty"
                    alias?: string | null
                    editorAlias?: string | null
                    value?:
                      | { __typename?: "BasicBlockGridModel"; model: string }
                      | { __typename?: "BasicBlockListModel"; model: string }
                      | {
                          __typename?: "BasicContentPicker"
                          model: string
                          contentList: Array<{
                            __typename?: "BasicContentPickerItem"
                            id: number
                            absoluteUrl: string
                            key: any
                            name?: string | null
                            url: string
                            urlSegment?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicDateTimePicker"
                          model: string
                          dateTime?: any | null
                        }
                      | {
                          __typename?: "BasicLabel"
                          model: string
                          label?: any | null
                        }
                      | { __typename?: "BasicMediaPicker"; model: string }
                      | {
                          __typename?: "BasicMemberPicker"
                          model: string
                          members: Array<{
                            __typename?: "BasicMemberPickerItem"
                            id?: number | null
                            name?: string | null
                          }>
                        }
                      | {
                          __typename?: "BasicMultiUrlPicker"
                          model: string
                          links: Array<{
                            __typename?: "BasicMultiUrlPickerItem"
                            name?: string | null
                            target?: string | null
                            type: LinkType
                            url?: string | null
                          }>
                        }
                      | { __typename?: "BasicNestedContent"; model: string }
                      | {
                          __typename?: "BasicPropertyValue"
                          model: string
                          value?: any | null
                        }
                      | {
                          __typename?: "BasicRichText"
                          model: string
                          richText?: string | null
                        }
                      | {
                          __typename?: "BasicUnsupportedPropertyValue"
                          model: string
                          message: string
                        }
                      | {
                          __typename?: "MintMediaPicker"
                          model: string
                          mediaItems: Array<{
                            __typename?: "MintMediaPickerItem"
                            id: number
                            url: string
                            altText?: string | null
                          }>
                        }
                      | null
                  } | null>
                }> | null
              }
            | {
                __typename?: "BasicPropertyValue"
                valueType: string
                value?: any | null
              }
            | {
                __typename?: "BasicRichText"
                valueType: string
                richText?: string | null
              }
            | {
                __typename?: "BasicUnsupportedPropertyValue"
                message: string
                valueType: string
              }
            | {
                __typename?: "MintMediaPicker"
                valueType: string
                mediaItems: Array<{
                  __typename?: "MintMediaPickerItem"
                  id: number
                  url: string
                  altText?: string | null
                }>
              }
            | null
        } | null>
        areas: Array<{
          __typename?: "BasicBlockGridArea"
          alias?: string | null
          rowSpan: number
          columnSpan: number
        } | null>
      }> | null
    } | null>
  }> | null
}

type PropertyValuesRoute_BasicBlockListModel_Fragment = {
  __typename?: "BasicBlockListModel"
  valueType: string
  blocks?: Array<{
    __typename?: "BasicBlockListItem"
    blockType?: string | null
    properties: Array<{
      __typename?: "BasicProperty"
      propertyName?: string | null
      propertyValue?:
        | { __typename?: "BasicBlockGridModel"; valueType: string }
        | {
            __typename?: "BasicBlockListModel"
            valueType: string
            blocks?: Array<{
              __typename?: "BasicBlockListItem"
              blockType?: string | null
              properties: Array<{
                __typename?: "BasicProperty"
                propertyName?: string | null
                propertyValue?:
                  | { __typename?: "BasicBlockGridModel"; valueType: string }
                  | {
                      __typename?: "BasicBlockListModel"
                      valueType: string
                      blocks?: Array<{
                        __typename?: "BasicBlockListItem"
                        blockType?: string | null
                        properties: Array<{
                          __typename?: "BasicProperty"
                          propertyName?: string | null
                          propertyValue?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                valueType: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                valueType: string
                                blocks?: Array<{
                                  __typename?: "BasicBlockListItem"
                                  blockType?: string | null
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    propertyName?: string | null
                                    propertyValue?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          valueType: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          valueType: string
                                          blocks?: Array<{
                                            __typename?: "BasicBlockListItem"
                                            blockType?: string | null
                                            properties: Array<{
                                              __typename?: "BasicProperty"
                                              propertyName?: string | null
                                              propertyValue?:
                                                | {
                                                    __typename?: "BasicBlockGridModel"
                                                    valueType: string
                                                  }
                                                | {
                                                    __typename?: "BasicBlockListModel"
                                                    valueType: string
                                                  }
                                                | {
                                                    __typename?: "BasicContentPicker"
                                                    valueType: string
                                                    contentList: Array<{
                                                      __typename?: "BasicContentPickerItem"
                                                      id: number
                                                      absoluteUrl: string
                                                      key: any
                                                      name?: string | null
                                                      url: string
                                                      urlSegment?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicDateTimePicker"
                                                    valueType: string
                                                    dateTime?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicLabel"
                                                    valueType: string
                                                    label?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicMediaPicker"
                                                    valueType: string
                                                  }
                                                | {
                                                    __typename?: "BasicMemberPicker"
                                                    valueType: string
                                                    members: Array<{
                                                      __typename?: "BasicMemberPickerItem"
                                                      id?: number | null
                                                      name?: string | null
                                                      properties: Array<{
                                                        __typename?: "BasicProperty"
                                                        alias?: string | null
                                                        editorAlias?:
                                                          | string
                                                          | null
                                                        value?:
                                                          | {
                                                              __typename?: "BasicBlockGridModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicBlockListModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicContentPicker"
                                                              model: string
                                                              contentList: Array<{
                                                                __typename?: "BasicContentPickerItem"
                                                                id: number
                                                                absoluteUrl: string
                                                                key: any
                                                                name?:
                                                                  | string
                                                                  | null
                                                                url: string
                                                                urlSegment?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicDateTimePicker"
                                                              model: string
                                                              dateTime?:
                                                                | any
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicLabel"
                                                              model: string
                                                              label?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicMediaPicker"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicMemberPicker"
                                                              model: string
                                                              members: Array<{
                                                                __typename?: "BasicMemberPickerItem"
                                                                id?:
                                                                  | number
                                                                  | null
                                                                name?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicMultiUrlPicker"
                                                              model: string
                                                              links: Array<{
                                                                __typename?: "BasicMultiUrlPickerItem"
                                                                name?:
                                                                  | string
                                                                  | null
                                                                target?:
                                                                  | string
                                                                  | null
                                                                type: LinkType
                                                                url?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicNestedContent"
                                                              model: string
                                                              elements?: Array<{
                                                                __typename?: "BasicNestedContentElement"
                                                                properties: Array<{
                                                                  __typename?: "BasicProperty"
                                                                  alias?:
                                                                    | string
                                                                    | null
                                                                  editorAlias?:
                                                                    | string
                                                                    | null
                                                                  value?:
                                                                    | {
                                                                        __typename?: "BasicBlockGridModel"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicBlockListModel"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicContentPicker"
                                                                        model: string
                                                                        contentList: Array<{
                                                                          __typename?: "BasicContentPickerItem"
                                                                          id: number
                                                                          absoluteUrl: string
                                                                          key: any
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                          url: string
                                                                          urlSegment?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicDateTimePicker"
                                                                        model: string
                                                                        dateTime?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicLabel"
                                                                        model: string
                                                                        label?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMediaPicker"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMemberPicker"
                                                                        model: string
                                                                        members: Array<{
                                                                          __typename?: "BasicMemberPickerItem"
                                                                          id?:
                                                                            | number
                                                                            | null
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicMultiUrlPicker"
                                                                        model: string
                                                                        links: Array<{
                                                                          __typename?: "BasicMultiUrlPickerItem"
                                                                          name?:
                                                                            | string
                                                                            | null
                                                                          target?:
                                                                            | string
                                                                            | null
                                                                          type: LinkType
                                                                          url?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicNestedContent"
                                                                        model: string
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicPropertyValue"
                                                                        model: string
                                                                        value?:
                                                                          | any
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicRichText"
                                                                        model: string
                                                                        richText?:
                                                                          | string
                                                                          | null
                                                                      }
                                                                    | {
                                                                        __typename?: "BasicUnsupportedPropertyValue"
                                                                        model: string
                                                                        message: string
                                                                      }
                                                                    | {
                                                                        __typename?: "MintMediaPicker"
                                                                        model: string
                                                                        mediaItems: Array<{
                                                                          __typename?: "MintMediaPickerItem"
                                                                          id: number
                                                                          url: string
                                                                          altText?:
                                                                            | string
                                                                            | null
                                                                        }>
                                                                      }
                                                                    | null
                                                                } | null>
                                                              }> | null
                                                            }
                                                          | {
                                                              __typename?: "BasicPropertyValue"
                                                              model: string
                                                              value?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicRichText"
                                                              model: string
                                                              richText?:
                                                                | string
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicUnsupportedPropertyValue"
                                                              model: string
                                                              message: string
                                                            }
                                                          | {
                                                              __typename?: "MintMediaPicker"
                                                              model: string
                                                              mediaItems: Array<{
                                                                __typename?: "MintMediaPickerItem"
                                                                id: number
                                                                url: string
                                                                altText?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | null
                                                      } | null>
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicMultiUrlPicker"
                                                    valueType: string
                                                    links: Array<{
                                                      __typename?: "BasicMultiUrlPickerItem"
                                                      name?: string | null
                                                      target?: string | null
                                                      type: LinkType
                                                      url?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicNestedContent"
                                                    valueType: string
                                                    elements?: Array<{
                                                      __typename?: "BasicNestedContentElement"
                                                      properties: Array<{
                                                        __typename?: "BasicProperty"
                                                        alias?: string | null
                                                        editorAlias?:
                                                          | string
                                                          | null
                                                        value?:
                                                          | {
                                                              __typename?: "BasicBlockGridModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicBlockListModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicContentPicker"
                                                              model: string
                                                              contentList: Array<{
                                                                __typename?: "BasicContentPickerItem"
                                                                id: number
                                                                absoluteUrl: string
                                                                key: any
                                                                name?:
                                                                  | string
                                                                  | null
                                                                url: string
                                                                urlSegment?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicDateTimePicker"
                                                              model: string
                                                              dateTime?:
                                                                | any
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicLabel"
                                                              model: string
                                                              label?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicMediaPicker"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicMemberPicker"
                                                              model: string
                                                              members: Array<{
                                                                __typename?: "BasicMemberPickerItem"
                                                                id?:
                                                                  | number
                                                                  | null
                                                                name?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicMultiUrlPicker"
                                                              model: string
                                                              links: Array<{
                                                                __typename?: "BasicMultiUrlPickerItem"
                                                                name?:
                                                                  | string
                                                                  | null
                                                                target?:
                                                                  | string
                                                                  | null
                                                                type: LinkType
                                                                url?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicNestedContent"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicPropertyValue"
                                                              model: string
                                                              value?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicRichText"
                                                              model: string
                                                              richText?:
                                                                | string
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicUnsupportedPropertyValue"
                                                              model: string
                                                              message: string
                                                            }
                                                          | {
                                                              __typename?: "MintMediaPicker"
                                                              model: string
                                                              mediaItems: Array<{
                                                                __typename?: "MintMediaPickerItem"
                                                                id: number
                                                                url: string
                                                                altText?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | null
                                                      } | null>
                                                    }> | null
                                                  }
                                                | {
                                                    __typename?: "BasicPropertyValue"
                                                    valueType: string
                                                    value?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicRichText"
                                                    valueType: string
                                                    richText?: string | null
                                                  }
                                                | {
                                                    __typename?: "BasicUnsupportedPropertyValue"
                                                    message: string
                                                    valueType: string
                                                  }
                                                | {
                                                    __typename?: "MintMediaPicker"
                                                    valueType: string
                                                    mediaItems: Array<{
                                                      __typename?: "MintMediaPickerItem"
                                                      id: number
                                                      url: string
                                                      altText?: string | null
                                                    }>
                                                  }
                                                | null
                                            } | null>
                                          }> | null
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          valueType: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          valueType: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          valueType: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          valueType: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          valueType: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                            properties: Array<{
                                              __typename?: "BasicProperty"
                                              alias?: string | null
                                              editorAlias?: string | null
                                              value?:
                                                | {
                                                    __typename?: "BasicBlockGridModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicBlockListModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicContentPicker"
                                                    model: string
                                                    contentList: Array<{
                                                      __typename?: "BasicContentPickerItem"
                                                      id: number
                                                      absoluteUrl: string
                                                      key: any
                                                      name?: string | null
                                                      url: string
                                                      urlSegment?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicDateTimePicker"
                                                    model: string
                                                    dateTime?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicLabel"
                                                    model: string
                                                    label?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicMediaPicker"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicMemberPicker"
                                                    model: string
                                                    members: Array<{
                                                      __typename?: "BasicMemberPickerItem"
                                                      id?: number | null
                                                      name?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicMultiUrlPicker"
                                                    model: string
                                                    links: Array<{
                                                      __typename?: "BasicMultiUrlPickerItem"
                                                      name?: string | null
                                                      target?: string | null
                                                      type: LinkType
                                                      url?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicNestedContent"
                                                    model: string
                                                    elements?: Array<{
                                                      __typename?: "BasicNestedContentElement"
                                                      properties: Array<{
                                                        __typename?: "BasicProperty"
                                                        alias?: string | null
                                                        editorAlias?:
                                                          | string
                                                          | null
                                                        value?:
                                                          | {
                                                              __typename?: "BasicBlockGridModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicBlockListModel"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicContentPicker"
                                                              model: string
                                                              contentList: Array<{
                                                                __typename?: "BasicContentPickerItem"
                                                                id: number
                                                                absoluteUrl: string
                                                                key: any
                                                                name?:
                                                                  | string
                                                                  | null
                                                                url: string
                                                                urlSegment?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicDateTimePicker"
                                                              model: string
                                                              dateTime?:
                                                                | any
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicLabel"
                                                              model: string
                                                              label?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicMediaPicker"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicMemberPicker"
                                                              model: string
                                                              members: Array<{
                                                                __typename?: "BasicMemberPickerItem"
                                                                id?:
                                                                  | number
                                                                  | null
                                                                name?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicMultiUrlPicker"
                                                              model: string
                                                              links: Array<{
                                                                __typename?: "BasicMultiUrlPickerItem"
                                                                name?:
                                                                  | string
                                                                  | null
                                                                target?:
                                                                  | string
                                                                  | null
                                                                type: LinkType
                                                                url?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | {
                                                              __typename?: "BasicNestedContent"
                                                              model: string
                                                            }
                                                          | {
                                                              __typename?: "BasicPropertyValue"
                                                              model: string
                                                              value?: any | null
                                                            }
                                                          | {
                                                              __typename?: "BasicRichText"
                                                              model: string
                                                              richText?:
                                                                | string
                                                                | null
                                                            }
                                                          | {
                                                              __typename?: "BasicUnsupportedPropertyValue"
                                                              model: string
                                                              message: string
                                                            }
                                                          | {
                                                              __typename?: "MintMediaPicker"
                                                              model: string
                                                              mediaItems: Array<{
                                                                __typename?: "MintMediaPickerItem"
                                                                id: number
                                                                url: string
                                                                altText?:
                                                                  | string
                                                                  | null
                                                              }>
                                                            }
                                                          | null
                                                      } | null>
                                                    }> | null
                                                  }
                                                | {
                                                    __typename?: "BasicPropertyValue"
                                                    model: string
                                                    value?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicRichText"
                                                    model: string
                                                    richText?: string | null
                                                  }
                                                | {
                                                    __typename?: "BasicUnsupportedPropertyValue"
                                                    model: string
                                                    message: string
                                                  }
                                                | {
                                                    __typename?: "MintMediaPicker"
                                                    model: string
                                                    mediaItems: Array<{
                                                      __typename?: "MintMediaPickerItem"
                                                      id: number
                                                      url: string
                                                      altText?: string | null
                                                    }>
                                                  }
                                                | null
                                            } | null>
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          valueType: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          valueType: string
                                          elements?: Array<{
                                            __typename?: "BasicNestedContentElement"
                                            properties: Array<{
                                              __typename?: "BasicProperty"
                                              alias?: string | null
                                              editorAlias?: string | null
                                              value?:
                                                | {
                                                    __typename?: "BasicBlockGridModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicBlockListModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicContentPicker"
                                                    model: string
                                                    contentList: Array<{
                                                      __typename?: "BasicContentPickerItem"
                                                      id: number
                                                      absoluteUrl: string
                                                      key: any
                                                      name?: string | null
                                                      url: string
                                                      urlSegment?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicDateTimePicker"
                                                    model: string
                                                    dateTime?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicLabel"
                                                    model: string
                                                    label?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicMediaPicker"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicMemberPicker"
                                                    model: string
                                                    members: Array<{
                                                      __typename?: "BasicMemberPickerItem"
                                                      id?: number | null
                                                      name?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicMultiUrlPicker"
                                                    model: string
                                                    links: Array<{
                                                      __typename?: "BasicMultiUrlPickerItem"
                                                      name?: string | null
                                                      target?: string | null
                                                      type: LinkType
                                                      url?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicNestedContent"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicPropertyValue"
                                                    model: string
                                                    value?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicRichText"
                                                    model: string
                                                    richText?: string | null
                                                  }
                                                | {
                                                    __typename?: "BasicUnsupportedPropertyValue"
                                                    model: string
                                                    message: string
                                                  }
                                                | {
                                                    __typename?: "MintMediaPicker"
                                                    model: string
                                                    mediaItems: Array<{
                                                      __typename?: "MintMediaPickerItem"
                                                      id: number
                                                      url: string
                                                      altText?: string | null
                                                    }>
                                                  }
                                                | null
                                            } | null>
                                          }> | null
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          valueType: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          valueType: string
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          message: string
                                          valueType: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          valueType: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }> | null
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                valueType: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                valueType: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                valueType: string
                                label?: any | null
                              }
                            | {
                                __typename?: "BasicMediaPicker"
                                valueType: string
                              }
                            | {
                                __typename?: "BasicMemberPicker"
                                valueType: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    alias?: string | null
                                    editorAlias?: string | null
                                    value?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          model: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          model: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          model: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          model: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          model: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          model: string
                                          elements?: Array<{
                                            __typename?: "BasicNestedContentElement"
                                            properties: Array<{
                                              __typename?: "BasicProperty"
                                              alias?: string | null
                                              editorAlias?: string | null
                                              value?:
                                                | {
                                                    __typename?: "BasicBlockGridModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicBlockListModel"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicContentPicker"
                                                    model: string
                                                    contentList: Array<{
                                                      __typename?: "BasicContentPickerItem"
                                                      id: number
                                                      absoluteUrl: string
                                                      key: any
                                                      name?: string | null
                                                      url: string
                                                      urlSegment?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicDateTimePicker"
                                                    model: string
                                                    dateTime?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicLabel"
                                                    model: string
                                                    label?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicMediaPicker"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicMemberPicker"
                                                    model: string
                                                    members: Array<{
                                                      __typename?: "BasicMemberPickerItem"
                                                      id?: number | null
                                                      name?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicMultiUrlPicker"
                                                    model: string
                                                    links: Array<{
                                                      __typename?: "BasicMultiUrlPickerItem"
                                                      name?: string | null
                                                      target?: string | null
                                                      type: LinkType
                                                      url?: string | null
                                                    }>
                                                  }
                                                | {
                                                    __typename?: "BasicNestedContent"
                                                    model: string
                                                  }
                                                | {
                                                    __typename?: "BasicPropertyValue"
                                                    model: string
                                                    value?: any | null
                                                  }
                                                | {
                                                    __typename?: "BasicRichText"
                                                    model: string
                                                    richText?: string | null
                                                  }
                                                | {
                                                    __typename?: "BasicUnsupportedPropertyValue"
                                                    model: string
                                                    message: string
                                                  }
                                                | {
                                                    __typename?: "MintMediaPicker"
                                                    model: string
                                                    mediaItems: Array<{
                                                      __typename?: "MintMediaPickerItem"
                                                      id: number
                                                      url: string
                                                      altText?: string | null
                                                    }>
                                                  }
                                                | null
                                            } | null>
                                          }> | null
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          model: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          model: string
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          model: string
                                          message: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          model: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                valueType: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                valueType: string
                                elements?: Array<{
                                  __typename?: "BasicNestedContentElement"
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    alias?: string | null
                                    editorAlias?: string | null
                                    value?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          model: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          model: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          model: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          model: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          model: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          model: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          model: string
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          model: string
                                          message: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          model: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }> | null
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                valueType: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                valueType: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                message: string
                                valueType: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                valueType: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicContentPicker"
                      valueType: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      valueType: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      valueType: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; valueType: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      valueType: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                                elements?: Array<{
                                  __typename?: "BasicNestedContentElement"
                                  properties: Array<{
                                    __typename?: "BasicProperty"
                                    alias?: string | null
                                    editorAlias?: string | null
                                    value?:
                                      | {
                                          __typename?: "BasicBlockGridModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicBlockListModel"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicContentPicker"
                                          model: string
                                          contentList: Array<{
                                            __typename?: "BasicContentPickerItem"
                                            id: number
                                            absoluteUrl: string
                                            key: any
                                            name?: string | null
                                            url: string
                                            urlSegment?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicDateTimePicker"
                                          model: string
                                          dateTime?: any | null
                                        }
                                      | {
                                          __typename?: "BasicLabel"
                                          model: string
                                          label?: any | null
                                        }
                                      | {
                                          __typename?: "BasicMediaPicker"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicMemberPicker"
                                          model: string
                                          members: Array<{
                                            __typename?: "BasicMemberPickerItem"
                                            id?: number | null
                                            name?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicMultiUrlPicker"
                                          model: string
                                          links: Array<{
                                            __typename?: "BasicMultiUrlPickerItem"
                                            name?: string | null
                                            target?: string | null
                                            type: LinkType
                                            url?: string | null
                                          }>
                                        }
                                      | {
                                          __typename?: "BasicNestedContent"
                                          model: string
                                        }
                                      | {
                                          __typename?: "BasicPropertyValue"
                                          model: string
                                          value?: any | null
                                        }
                                      | {
                                          __typename?: "BasicRichText"
                                          model: string
                                          richText?: string | null
                                        }
                                      | {
                                          __typename?: "BasicUnsupportedPropertyValue"
                                          model: string
                                          message: string
                                        }
                                      | {
                                          __typename?: "MintMediaPicker"
                                          model: string
                                          mediaItems: Array<{
                                            __typename?: "MintMediaPickerItem"
                                            id: number
                                            url: string
                                            altText?: string | null
                                          }>
                                        }
                                      | null
                                  } | null>
                                }> | null
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      valueType: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicNestedContent"
                      valueType: string
                      elements?: Array<{
                        __typename?: "BasicNestedContentElement"
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicPropertyValue"
                      valueType: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      valueType: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      message: string
                      valueType: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      valueType: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }> | null
          }
        | {
            __typename?: "BasicContentPicker"
            valueType: string
            contentList: Array<{
              __typename?: "BasicContentPickerItem"
              id: number
              absoluteUrl: string
              key: any
              name?: string | null
              url: string
              urlSegment?: string | null
            }>
          }
        | {
            __typename?: "BasicDateTimePicker"
            valueType: string
            dateTime?: any | null
          }
        | { __typename?: "BasicLabel"; valueType: string; label?: any | null }
        | { __typename?: "BasicMediaPicker"; valueType: string }
        | {
            __typename?: "BasicMemberPicker"
            valueType: string
            members: Array<{
              __typename?: "BasicMemberPickerItem"
              id?: number | null
              name?: string | null
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicNestedContent"
                      model: string
                      elements?: Array<{
                        __typename?: "BasicNestedContentElement"
                        properties: Array<{
                          __typename?: "BasicProperty"
                          alias?: string | null
                          editorAlias?: string | null
                          value?:
                            | {
                                __typename?: "BasicBlockGridModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicBlockListModel"
                                model: string
                              }
                            | {
                                __typename?: "BasicContentPicker"
                                model: string
                                contentList: Array<{
                                  __typename?: "BasicContentPickerItem"
                                  id: number
                                  absoluteUrl: string
                                  key: any
                                  name?: string | null
                                  url: string
                                  urlSegment?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicDateTimePicker"
                                model: string
                                dateTime?: any | null
                              }
                            | {
                                __typename?: "BasicLabel"
                                model: string
                                label?: any | null
                              }
                            | { __typename?: "BasicMediaPicker"; model: string }
                            | {
                                __typename?: "BasicMemberPicker"
                                model: string
                                members: Array<{
                                  __typename?: "BasicMemberPickerItem"
                                  id?: number | null
                                  name?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicMultiUrlPicker"
                                model: string
                                links: Array<{
                                  __typename?: "BasicMultiUrlPickerItem"
                                  name?: string | null
                                  target?: string | null
                                  type: LinkType
                                  url?: string | null
                                }>
                              }
                            | {
                                __typename?: "BasicNestedContent"
                                model: string
                              }
                            | {
                                __typename?: "BasicPropertyValue"
                                model: string
                                value?: any | null
                              }
                            | {
                                __typename?: "BasicRichText"
                                model: string
                                richText?: string | null
                              }
                            | {
                                __typename?: "BasicUnsupportedPropertyValue"
                                model: string
                                message: string
                              }
                            | {
                                __typename?: "MintMediaPicker"
                                model: string
                                mediaItems: Array<{
                                  __typename?: "MintMediaPickerItem"
                                  id: number
                                  url: string
                                  altText?: string | null
                                }>
                              }
                            | null
                        } | null>
                      }> | null
                    }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }>
          }
        | {
            __typename?: "BasicMultiUrlPicker"
            valueType: string
            links: Array<{
              __typename?: "BasicMultiUrlPickerItem"
              name?: string | null
              target?: string | null
              type: LinkType
              url?: string | null
            }>
          }
        | {
            __typename?: "BasicNestedContent"
            valueType: string
            elements?: Array<{
              __typename?: "BasicNestedContentElement"
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | { __typename?: "BasicNestedContent"; model: string }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }> | null
          }
        | {
            __typename?: "BasicPropertyValue"
            valueType: string
            value?: any | null
          }
        | {
            __typename?: "BasicRichText"
            valueType: string
            richText?: string | null
          }
        | {
            __typename?: "BasicUnsupportedPropertyValue"
            message: string
            valueType: string
          }
        | {
            __typename?: "MintMediaPicker"
            valueType: string
            mediaItems: Array<{
              __typename?: "MintMediaPickerItem"
              id: number
              url: string
              altText?: string | null
            }>
          }
        | null
    } | null>
  }> | null
}

type PropertyValuesRoute_BasicContentPicker_Fragment = {
  __typename?: "BasicContentPicker"
  valueType: string
  contentList: Array<{
    __typename?: "BasicContentPickerItem"
    id: number
    absoluteUrl: string
    key: any
    name?: string | null
    url: string
    urlSegment?: string | null
  }>
}

type PropertyValuesRoute_BasicDateTimePicker_Fragment = {
  __typename?: "BasicDateTimePicker"
  valueType: string
  dateTime?: any | null
}

type PropertyValuesRoute_BasicLabel_Fragment = {
  __typename?: "BasicLabel"
  valueType: string
  label?: any | null
}

type PropertyValuesRoute_BasicMediaPicker_Fragment = {
  __typename?: "BasicMediaPicker"
  valueType: string
}

type PropertyValuesRoute_BasicMemberPicker_Fragment = {
  __typename?: "BasicMemberPicker"
  valueType: string
  members: Array<{
    __typename?: "BasicMemberPickerItem"
    id?: number | null
    name?: string | null
    properties: Array<{
      __typename?: "BasicProperty"
      alias?: string | null
      editorAlias?: string | null
      value?:
        | { __typename?: "BasicBlockGridModel"; model: string }
        | { __typename?: "BasicBlockListModel"; model: string }
        | {
            __typename?: "BasicContentPicker"
            model: string
            contentList: Array<{
              __typename?: "BasicContentPickerItem"
              id: number
              absoluteUrl: string
              key: any
              name?: string | null
              url: string
              urlSegment?: string | null
            }>
          }
        | {
            __typename?: "BasicDateTimePicker"
            model: string
            dateTime?: any | null
          }
        | { __typename?: "BasicLabel"; model: string; label?: any | null }
        | { __typename?: "BasicMediaPicker"; model: string }
        | {
            __typename?: "BasicMemberPicker"
            model: string
            members: Array<{
              __typename?: "BasicMemberPickerItem"
              id?: number | null
              name?: string | null
            }>
          }
        | {
            __typename?: "BasicMultiUrlPicker"
            model: string
            links: Array<{
              __typename?: "BasicMultiUrlPickerItem"
              name?: string | null
              target?: string | null
              type: LinkType
              url?: string | null
            }>
          }
        | {
            __typename?: "BasicNestedContent"
            model: string
            elements?: Array<{
              __typename?: "BasicNestedContentElement"
              properties: Array<{
                __typename?: "BasicProperty"
                alias?: string | null
                editorAlias?: string | null
                value?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | {
                      __typename?: "BasicContentPicker"
                      model: string
                      contentList: Array<{
                        __typename?: "BasicContentPickerItem"
                        id: number
                        absoluteUrl: string
                        key: any
                        name?: string | null
                        url: string
                        urlSegment?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicDateTimePicker"
                      model: string
                      dateTime?: any | null
                    }
                  | {
                      __typename?: "BasicLabel"
                      model: string
                      label?: any | null
                    }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | {
                      __typename?: "BasicMemberPicker"
                      model: string
                      members: Array<{
                        __typename?: "BasicMemberPickerItem"
                        id?: number | null
                        name?: string | null
                      }>
                    }
                  | {
                      __typename?: "BasicMultiUrlPicker"
                      model: string
                      links: Array<{
                        __typename?: "BasicMultiUrlPickerItem"
                        name?: string | null
                        target?: string | null
                        type: LinkType
                        url?: string | null
                      }>
                    }
                  | { __typename?: "BasicNestedContent"; model: string }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | {
                      __typename?: "BasicRichText"
                      model: string
                      richText?: string | null
                    }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                      message: string
                    }
                  | {
                      __typename?: "MintMediaPicker"
                      model: string
                      mediaItems: Array<{
                        __typename?: "MintMediaPickerItem"
                        id: number
                        url: string
                        altText?: string | null
                      }>
                    }
                  | null
              } | null>
            }> | null
          }
        | {
            __typename?: "BasicPropertyValue"
            model: string
            value?: any | null
          }
        | {
            __typename?: "BasicRichText"
            model: string
            richText?: string | null
          }
        | {
            __typename?: "BasicUnsupportedPropertyValue"
            model: string
            message: string
          }
        | {
            __typename?: "MintMediaPicker"
            model: string
            mediaItems: Array<{
              __typename?: "MintMediaPickerItem"
              id: number
              url: string
              altText?: string | null
            }>
          }
        | null
    } | null>
  }>
}

type PropertyValuesRoute_BasicMultiUrlPicker_Fragment = {
  __typename?: "BasicMultiUrlPicker"
  valueType: string
  links: Array<{
    __typename?: "BasicMultiUrlPickerItem"
    name?: string | null
    target?: string | null
    type: LinkType
    url?: string | null
  }>
}

type PropertyValuesRoute_BasicNestedContent_Fragment = {
  __typename?: "BasicNestedContent"
  valueType: string
  elements?: Array<{
    __typename?: "BasicNestedContentElement"
    properties: Array<{
      __typename?: "BasicProperty"
      alias?: string | null
      editorAlias?: string | null
      value?:
        | { __typename?: "BasicBlockGridModel"; model: string }
        | { __typename?: "BasicBlockListModel"; model: string }
        | {
            __typename?: "BasicContentPicker"
            model: string
            contentList: Array<{
              __typename?: "BasicContentPickerItem"
              id: number
              absoluteUrl: string
              key: any
              name?: string | null
              url: string
              urlSegment?: string | null
            }>
          }
        | {
            __typename?: "BasicDateTimePicker"
            model: string
            dateTime?: any | null
          }
        | { __typename?: "BasicLabel"; model: string; label?: any | null }
        | { __typename?: "BasicMediaPicker"; model: string }
        | {
            __typename?: "BasicMemberPicker"
            model: string
            members: Array<{
              __typename?: "BasicMemberPickerItem"
              id?: number | null
              name?: string | null
            }>
          }
        | {
            __typename?: "BasicMultiUrlPicker"
            model: string
            links: Array<{
              __typename?: "BasicMultiUrlPickerItem"
              name?: string | null
              target?: string | null
              type: LinkType
              url?: string | null
            }>
          }
        | { __typename?: "BasicNestedContent"; model: string }
        | {
            __typename?: "BasicPropertyValue"
            model: string
            value?: any | null
          }
        | {
            __typename?: "BasicRichText"
            model: string
            richText?: string | null
          }
        | {
            __typename?: "BasicUnsupportedPropertyValue"
            model: string
            message: string
          }
        | {
            __typename?: "MintMediaPicker"
            model: string
            mediaItems: Array<{
              __typename?: "MintMediaPickerItem"
              id: number
              url: string
              altText?: string | null
            }>
          }
        | null
    } | null>
  }> | null
}

type PropertyValuesRoute_BasicPropertyValue_Fragment = {
  __typename?: "BasicPropertyValue"
  valueType: string
  value?: any | null
}

type PropertyValuesRoute_BasicRichText_Fragment = {
  __typename?: "BasicRichText"
  valueType: string
  richText?: string | null
}

type PropertyValuesRoute_BasicUnsupportedPropertyValue_Fragment = {
  __typename?: "BasicUnsupportedPropertyValue"
  message: string
  valueType: string
}

type PropertyValuesRoute_MintMediaPicker_Fragment = {
  __typename?: "MintMediaPicker"
  valueType: string
  mediaItems: Array<{
    __typename?: "MintMediaPickerItem"
    id: number
    url: string
    altText?: string | null
  }>
}

export type PropertyValuesRouteFragment =
  | PropertyValuesRoute_BasicBlockGridModel_Fragment
  | PropertyValuesRoute_BasicBlockListModel_Fragment
  | PropertyValuesRoute_BasicContentPicker_Fragment
  | PropertyValuesRoute_BasicDateTimePicker_Fragment
  | PropertyValuesRoute_BasicLabel_Fragment
  | PropertyValuesRoute_BasicMediaPicker_Fragment
  | PropertyValuesRoute_BasicMemberPicker_Fragment
  | PropertyValuesRoute_BasicMultiUrlPicker_Fragment
  | PropertyValuesRoute_BasicNestedContent_Fragment
  | PropertyValuesRoute_BasicPropertyValue_Fragment
  | PropertyValuesRoute_BasicRichText_Fragment
  | PropertyValuesRoute_BasicUnsupportedPropertyValue_Fragment
  | PropertyValuesRoute_MintMediaPicker_Fragment

export type GetPageMetadataQueryVariables = Exact<{
  route: Scalars["String"]["input"]
  culture?: InputMaybe<Scalars["String"]["input"]>
}>

export type GetPageMetadataQuery = {
  __typename?: "Query"
  page?: {
    __typename?: "BasicContent"
    url?: string | null
    level?: number | null
    contentType?: {
      __typename?: "BasicContentType"
      alias?: string | null
    } | null
    properties?: Array<{
      __typename?: "BasicProperty"
      propertyName?: string | null
      propertyValue?:
        | { __typename?: "BasicBlockGridModel" }
        | { __typename?: "BasicBlockListModel" }
        | { __typename?: "BasicContentPicker" }
        | { __typename?: "BasicDateTimePicker" }
        | { __typename?: "BasicLabel" }
        | {
            __typename?: "BasicMediaPicker"
            mediaItems: Array<{
              __typename?: "BasicMediaPickerItem"
              id: number
              url: string
            }>
          }
        | { __typename?: "BasicMemberPicker" }
        | {
            __typename?: "BasicMultiUrlPicker"
            links: Array<{
              __typename?: "BasicMultiUrlPickerItem"
              name?: string | null
              target?: string | null
              type: LinkType
              url?: string | null
            }>
          }
        | { __typename?: "BasicNestedContent" }
        | { __typename?: "BasicPropertyValue"; value?: any | null }
        | { __typename?: "BasicRichText"; richText?: string | null }
        | { __typename?: "BasicUnsupportedPropertyValue" }
        | { __typename?: "MintMediaPicker" }
        | null
    } | null> | null
  } | null
}

export type GetSearchQueryVariables = Exact<{
  culture: Scalars["String"]["input"]
  route: Scalars["String"]["input"]
  ids: Array<Scalars["Int"]["input"]> | Scalars["Int"]["input"]
}>

export type GetSearchQuery = {
  __typename?: "Query"
  pages?: {
    __typename?: "ContentDescendantsByAbsoluteRouteConnection"
    nodes?: Array<{
      __typename?: "BasicContent"
      id?: number | null
      url?: string | null
      contentType?: {
        __typename?: "BasicContentType"
        alias?: string | null
      } | null
      namedProperties:
        | { __typename?: "AdynamicTitleAndContant" }
        | { __typename?: "AnchorMenu" }
        | { __typename?: "AnchorMenuItems" }
        | {
            __typename?: "Article"
            titleBreadcrumbs?: {
              __typename?: "BasicPropertyValue"
              value?: any | null
            } | null
          }
        | { __typename?: "ArticlesCategory" }
        | {
            __typename?: "ArticlesLobby"
            titleBreadcrumbs?: {
              __typename?: "BasicPropertyValue"
              value?: any | null
            } | null
          }
        | { __typename?: "BannerModule" }
        | { __typename?: "BasicBannerModule" }
        | { __typename?: "ButtonComponent" }
        | { __typename?: "ContactUs" }
        | { __typename?: "ContactUsBox" }
        | { __typename?: "ContactUsBoxItem" }
        | { __typename?: "ContactUsBoxWithText" }
        | { __typename?: "ContactUsDesktop" }
        | { __typename?: "ContactUsInfoItem" }
        | { __typename?: "ContactUsItem" }
        | { __typename?: "ContactUsMobile" }
        | { __typename?: "ContentMenuItem" }
        | {
            __typename?: "ContentPage"
            titleBreadcrumbs?: {
              __typename?: "BasicPropertyValue"
              value?: any | null
            } | null
          }
        | { __typename?: "CustomMenuItem" }
        | { __typename?: "DynamicBlockList" }
        | { __typename?: "EmployeeRecommendations" }
        | { __typename?: "EmployeeRecommendationsItem" }
        | { __typename?: "EmptyINamedContentProperties" }
        | { __typename?: "FAQ" }
        | { __typename?: "FAQItem" }
        | { __typename?: "FinePayment" }
        | { __typename?: "FinePaymentSteps" }
        | { __typename?: "Footer" }
        | { __typename?: "FooterCategories" }
        | {
            __typename?: "FreeContentPage"
            titleBreadcrumbs?: {
              __typename?: "BasicPropertyValue"
              value?: any | null
            } | null
          }
        | { __typename?: "HeaderCategories" }
        | { __typename?: "HeaderDesktop" }
        | { __typename?: "HeaderMobile" }
        | { __typename?: "HeroBanner" }
        | { __typename?: "HeroBannerHomePage" }
        | { __typename?: "HistoryItem" }
        | {
            __typename?: "HomePage"
            titleBreadcrumbs?: {
              __typename?: "BasicPropertyValue"
              value?: any | null
            } | null
          }
        | { __typename?: "Information" }
        | { __typename?: "InformationForPassangers" }
        | { __typename?: "InquiriesAndRequests" }
        | { __typename?: "LinesItem" }
        | { __typename?: "LinkItem" }
        | { __typename?: "LogoComponent" }
        | { __typename?: "MainTitleBlock" }
        | { __typename?: "MultyURLsTitleAndText" }
        | { __typename?: "NumericItem" }
        | { __typename?: "OpeningTimeItem" }
        | { __typename?: "OperatingHoursContactInfo" }
        | { __typename?: "OperatingHoursContactInfoItem" }
        | {
            __typename?: "PageInfoBlock"
            titleBreadcrumbs?: {
              __typename?: "BasicPropertyValue"
              value?: any | null
            } | null
          }
        | { __typename?: "PaymentMethod" }
        | { __typename?: "PaymentMethodItem" }
        | { __typename?: "PaymentMethodsInPublicTransport" }
        | { __typename?: "PowerNumbers" }
        | { __typename?: "PowerNumbersItem" }
        | { __typename?: "RavKavServiceStation" }
        | { __typename?: "RecommendationsBlock" }
        | { __typename?: "ServiceShortcuts" }
        | { __typename?: "ServiceShortcutsItem" }
        | { __typename?: "ServiceStationItem" }
        | { __typename?: "ServiceStationTabs" }
        | { __typename?: "SocialBlock" }
        | { __typename?: "SocialMedia" }
        | { __typename?: "Statistics" }
        | { __typename?: "StatisticsSectionItem" }
        | { __typename?: "StatusLost" }
        | { __typename?: "TabsContent" }
        | { __typename?: "TabsContent1" }
        | { __typename?: "TabsContentItem" }
        | { __typename?: "TabsContentItem1" }
        | { __typename?: "Team" }
        | { __typename?: "TeamCategory" }
        | { __typename?: "TeamItem" }
        | { __typename?: "Timeline" }
        | { __typename?: "TimelineItem" }
        | { __typename?: "TitleTextAndMediaBlock" }
        | {
            __typename?: "TrafficUpdatePage"
            titleBreadcrumbs?: {
              __typename?: "BasicPropertyValue"
              value?: any | null
            } | null
          }
        | { __typename?: "TrafficUpdates" }
        | { __typename?: "TrafficUpdatesItemsList" }
        | { __typename?: "UpdatesItem" }
        | { __typename?: "VisionTab" }
    } | null> | null
  } | null
}

export type GetSitemapQueryVariables = Exact<{
  route: Scalars["String"]["input"]
  culture: Scalars["String"]["input"]
}>

export type GetSitemapQuery = {
  __typename?: "Query"
  sitemap?: {
    __typename?: "ContentDescendantsByAbsoluteRouteConnection"
    nodes?: Array<{
      __typename?: "BasicContent"
      id?: number | null
      name?: string | null
      key?: any | null
      path?: string | null
      level?: number | null
      url?: string | null
      urlSegment?: string | null
      absoluteUrl?: string | null
      children?: Array<{
        __typename?: "BasicContent"
        id?: number | null
        name?: string | null
        key?: any | null
        path?: string | null
        level?: number | null
        url?: string | null
        urlSegment?: string | null
        absoluteUrl?: string | null
        children?: Array<{
          __typename?: "BasicContent"
          id?: number | null
          name?: string | null
          key?: any | null
          path?: string | null
          level?: number | null
          url?: string | null
          urlSegment?: string | null
          absoluteUrl?: string | null
          children?: Array<{
            __typename?: "BasicContent"
            id?: number | null
            name?: string | null
            key?: any | null
            path?: string | null
            level?: number | null
            url?: string | null
            urlSegment?: string | null
            absoluteUrl?: string | null
            children?: Array<{
              __typename?: "BasicContent"
              id?: number | null
              name?: string | null
              key?: any | null
              path?: string | null
              level?: number | null
              url?: string | null
              urlSegment?: string | null
              absoluteUrl?: string | null
              children?: Array<{
                __typename?: "BasicContent"
                id?: number | null
                name?: string | null
                key?: any | null
                path?: string | null
                level?: number | null
                url?: string | null
                urlSegment?: string | null
                absoluteUrl?: string | null
                children?: Array<{
                  __typename?: "BasicContent"
                  id?: number | null
                  name?: string | null
                  key?: any | null
                  path?: string | null
                  level?: number | null
                  url?: string | null
                  urlSegment?: string | null
                  absoluteUrl?: string | null
                  properties?: Array<{
                    __typename?: "BasicProperty"
                    editorAlias?: string | null
                    propertyName?: string | null
                    propertyValue?:
                      | { __typename?: "BasicBlockGridModel"; model: string }
                      | { __typename?: "BasicBlockListModel"; model: string }
                      | { __typename?: "BasicContentPicker"; model: string }
                      | { __typename?: "BasicDateTimePicker"; model: string }
                      | { __typename?: "BasicLabel"; model: string }
                      | { __typename?: "BasicMediaPicker"; model: string }
                      | { __typename?: "BasicMemberPicker"; model: string }
                      | { __typename?: "BasicMultiUrlPicker"; model: string }
                      | { __typename?: "BasicNestedContent"; model: string }
                      | {
                          __typename?: "BasicPropertyValue"
                          model: string
                          value?: any | null
                        }
                      | { __typename?: "BasicRichText"; model: string }
                      | {
                          __typename?: "BasicUnsupportedPropertyValue"
                          model: string
                        }
                      | { __typename?: "MintMediaPicker"; model: string }
                      | null
                  } | null> | null
                } | null> | null
                properties?: Array<{
                  __typename?: "BasicProperty"
                  editorAlias?: string | null
                  propertyName?: string | null
                  propertyValue?:
                    | { __typename?: "BasicBlockGridModel"; model: string }
                    | { __typename?: "BasicBlockListModel"; model: string }
                    | { __typename?: "BasicContentPicker"; model: string }
                    | { __typename?: "BasicDateTimePicker"; model: string }
                    | { __typename?: "BasicLabel"; model: string }
                    | { __typename?: "BasicMediaPicker"; model: string }
                    | { __typename?: "BasicMemberPicker"; model: string }
                    | { __typename?: "BasicMultiUrlPicker"; model: string }
                    | { __typename?: "BasicNestedContent"; model: string }
                    | {
                        __typename?: "BasicPropertyValue"
                        model: string
                        value?: any | null
                      }
                    | { __typename?: "BasicRichText"; model: string }
                    | {
                        __typename?: "BasicUnsupportedPropertyValue"
                        model: string
                      }
                    | { __typename?: "MintMediaPicker"; model: string }
                    | null
                } | null> | null
              } | null> | null
              properties?: Array<{
                __typename?: "BasicProperty"
                editorAlias?: string | null
                propertyName?: string | null
                propertyValue?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | { __typename?: "BasicContentPicker"; model: string }
                  | { __typename?: "BasicDateTimePicker"; model: string }
                  | { __typename?: "BasicLabel"; model: string }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | { __typename?: "BasicMemberPicker"; model: string }
                  | { __typename?: "BasicMultiUrlPicker"; model: string }
                  | { __typename?: "BasicNestedContent"; model: string }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | { __typename?: "BasicRichText"; model: string }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                    }
                  | { __typename?: "MintMediaPicker"; model: string }
                  | null
              } | null> | null
            } | null> | null
            properties?: Array<{
              __typename?: "BasicProperty"
              editorAlias?: string | null
              propertyName?: string | null
              propertyValue?:
                | { __typename?: "BasicBlockGridModel"; model: string }
                | { __typename?: "BasicBlockListModel"; model: string }
                | { __typename?: "BasicContentPicker"; model: string }
                | { __typename?: "BasicDateTimePicker"; model: string }
                | { __typename?: "BasicLabel"; model: string }
                | { __typename?: "BasicMediaPicker"; model: string }
                | { __typename?: "BasicMemberPicker"; model: string }
                | { __typename?: "BasicMultiUrlPicker"; model: string }
                | { __typename?: "BasicNestedContent"; model: string }
                | {
                    __typename?: "BasicPropertyValue"
                    model: string
                    value?: any | null
                  }
                | { __typename?: "BasicRichText"; model: string }
                | {
                    __typename?: "BasicUnsupportedPropertyValue"
                    model: string
                  }
                | { __typename?: "MintMediaPicker"; model: string }
                | null
            } | null> | null
          } | null> | null
          properties?: Array<{
            __typename?: "BasicProperty"
            editorAlias?: string | null
            propertyName?: string | null
            propertyValue?:
              | { __typename?: "BasicBlockGridModel"; model: string }
              | { __typename?: "BasicBlockListModel"; model: string }
              | { __typename?: "BasicContentPicker"; model: string }
              | { __typename?: "BasicDateTimePicker"; model: string }
              | { __typename?: "BasicLabel"; model: string }
              | { __typename?: "BasicMediaPicker"; model: string }
              | { __typename?: "BasicMemberPicker"; model: string }
              | { __typename?: "BasicMultiUrlPicker"; model: string }
              | { __typename?: "BasicNestedContent"; model: string }
              | {
                  __typename?: "BasicPropertyValue"
                  model: string
                  value?: any | null
                }
              | { __typename?: "BasicRichText"; model: string }
              | { __typename?: "BasicUnsupportedPropertyValue"; model: string }
              | { __typename?: "MintMediaPicker"; model: string }
              | null
          } | null> | null
        } | null> | null
        properties?: Array<{
          __typename?: "BasicProperty"
          editorAlias?: string | null
          propertyName?: string | null
          propertyValue?:
            | { __typename?: "BasicBlockGridModel"; model: string }
            | { __typename?: "BasicBlockListModel"; model: string }
            | { __typename?: "BasicContentPicker"; model: string }
            | { __typename?: "BasicDateTimePicker"; model: string }
            | { __typename?: "BasicLabel"; model: string }
            | { __typename?: "BasicMediaPicker"; model: string }
            | { __typename?: "BasicMemberPicker"; model: string }
            | { __typename?: "BasicMultiUrlPicker"; model: string }
            | { __typename?: "BasicNestedContent"; model: string }
            | {
                __typename?: "BasicPropertyValue"
                model: string
                value?: any | null
              }
            | { __typename?: "BasicRichText"; model: string }
            | { __typename?: "BasicUnsupportedPropertyValue"; model: string }
            | { __typename?: "MintMediaPicker"; model: string }
            | null
        } | null> | null
      } | null> | null
      properties?: Array<{
        __typename?: "BasicProperty"
        editorAlias?: string | null
        propertyName?: string | null
        propertyValue?:
          | { __typename?: "BasicBlockGridModel"; model: string }
          | { __typename?: "BasicBlockListModel"; model: string }
          | { __typename?: "BasicContentPicker"; model: string }
          | { __typename?: "BasicDateTimePicker"; model: string }
          | { __typename?: "BasicLabel"; model: string }
          | { __typename?: "BasicMediaPicker"; model: string }
          | { __typename?: "BasicMemberPicker"; model: string }
          | { __typename?: "BasicMultiUrlPicker"; model: string }
          | { __typename?: "BasicNestedContent"; model: string }
          | {
              __typename?: "BasicPropertyValue"
              model: string
              value?: any | null
            }
          | { __typename?: "BasicRichText"; model: string }
          | { __typename?: "BasicUnsupportedPropertyValue"; model: string }
          | { __typename?: "MintMediaPicker"; model: string }
          | null
      } | null> | null
    } | null> | null
  } | null
}

export type BasicContentNestedFragment = {
  __typename?: "BasicContent"
  id?: number | null
  name?: string | null
  key?: any | null
  path?: string | null
  level?: number | null
  url?: string | null
  urlSegment?: string | null
  absoluteUrl?: string | null
  children?: Array<{
    __typename?: "BasicContent"
    id?: number | null
    name?: string | null
    key?: any | null
    path?: string | null
    level?: number | null
    url?: string | null
    urlSegment?: string | null
    absoluteUrl?: string | null
    children?: Array<{
      __typename?: "BasicContent"
      id?: number | null
      name?: string | null
      key?: any | null
      path?: string | null
      level?: number | null
      url?: string | null
      urlSegment?: string | null
      absoluteUrl?: string | null
      children?: Array<{
        __typename?: "BasicContent"
        id?: number | null
        name?: string | null
        key?: any | null
        path?: string | null
        level?: number | null
        url?: string | null
        urlSegment?: string | null
        absoluteUrl?: string | null
        children?: Array<{
          __typename?: "BasicContent"
          id?: number | null
          name?: string | null
          key?: any | null
          path?: string | null
          level?: number | null
          url?: string | null
          urlSegment?: string | null
          absoluteUrl?: string | null
          children?: Array<{
            __typename?: "BasicContent"
            id?: number | null
            name?: string | null
            key?: any | null
            path?: string | null
            level?: number | null
            url?: string | null
            urlSegment?: string | null
            absoluteUrl?: string | null
            children?: Array<{
              __typename?: "BasicContent"
              id?: number | null
              name?: string | null
              key?: any | null
              path?: string | null
              level?: number | null
              url?: string | null
              urlSegment?: string | null
              absoluteUrl?: string | null
              properties?: Array<{
                __typename?: "BasicProperty"
                editorAlias?: string | null
                propertyName?: string | null
                propertyValue?:
                  | { __typename?: "BasicBlockGridModel"; model: string }
                  | { __typename?: "BasicBlockListModel"; model: string }
                  | { __typename?: "BasicContentPicker"; model: string }
                  | { __typename?: "BasicDateTimePicker"; model: string }
                  | { __typename?: "BasicLabel"; model: string }
                  | { __typename?: "BasicMediaPicker"; model: string }
                  | { __typename?: "BasicMemberPicker"; model: string }
                  | { __typename?: "BasicMultiUrlPicker"; model: string }
                  | { __typename?: "BasicNestedContent"; model: string }
                  | {
                      __typename?: "BasicPropertyValue"
                      model: string
                      value?: any | null
                    }
                  | { __typename?: "BasicRichText"; model: string }
                  | {
                      __typename?: "BasicUnsupportedPropertyValue"
                      model: string
                    }
                  | { __typename?: "MintMediaPicker"; model: string }
                  | null
              } | null> | null
            } | null> | null
            properties?: Array<{
              __typename?: "BasicProperty"
              editorAlias?: string | null
              propertyName?: string | null
              propertyValue?:
                | { __typename?: "BasicBlockGridModel"; model: string }
                | { __typename?: "BasicBlockListModel"; model: string }
                | { __typename?: "BasicContentPicker"; model: string }
                | { __typename?: "BasicDateTimePicker"; model: string }
                | { __typename?: "BasicLabel"; model: string }
                | { __typename?: "BasicMediaPicker"; model: string }
                | { __typename?: "BasicMemberPicker"; model: string }
                | { __typename?: "BasicMultiUrlPicker"; model: string }
                | { __typename?: "BasicNestedContent"; model: string }
                | {
                    __typename?: "BasicPropertyValue"
                    model: string
                    value?: any | null
                  }
                | { __typename?: "BasicRichText"; model: string }
                | {
                    __typename?: "BasicUnsupportedPropertyValue"
                    model: string
                  }
                | { __typename?: "MintMediaPicker"; model: string }
                | null
            } | null> | null
          } | null> | null
          properties?: Array<{
            __typename?: "BasicProperty"
            editorAlias?: string | null
            propertyName?: string | null
            propertyValue?:
              | { __typename?: "BasicBlockGridModel"; model: string }
              | { __typename?: "BasicBlockListModel"; model: string }
              | { __typename?: "BasicContentPicker"; model: string }
              | { __typename?: "BasicDateTimePicker"; model: string }
              | { __typename?: "BasicLabel"; model: string }
              | { __typename?: "BasicMediaPicker"; model: string }
              | { __typename?: "BasicMemberPicker"; model: string }
              | { __typename?: "BasicMultiUrlPicker"; model: string }
              | { __typename?: "BasicNestedContent"; model: string }
              | {
                  __typename?: "BasicPropertyValue"
                  model: string
                  value?: any | null
                }
              | { __typename?: "BasicRichText"; model: string }
              | { __typename?: "BasicUnsupportedPropertyValue"; model: string }
              | { __typename?: "MintMediaPicker"; model: string }
              | null
          } | null> | null
        } | null> | null
        properties?: Array<{
          __typename?: "BasicProperty"
          editorAlias?: string | null
          propertyName?: string | null
          propertyValue?:
            | { __typename?: "BasicBlockGridModel"; model: string }
            | { __typename?: "BasicBlockListModel"; model: string }
            | { __typename?: "BasicContentPicker"; model: string }
            | { __typename?: "BasicDateTimePicker"; model: string }
            | { __typename?: "BasicLabel"; model: string }
            | { __typename?: "BasicMediaPicker"; model: string }
            | { __typename?: "BasicMemberPicker"; model: string }
            | { __typename?: "BasicMultiUrlPicker"; model: string }
            | { __typename?: "BasicNestedContent"; model: string }
            | {
                __typename?: "BasicPropertyValue"
                model: string
                value?: any | null
              }
            | { __typename?: "BasicRichText"; model: string }
            | { __typename?: "BasicUnsupportedPropertyValue"; model: string }
            | { __typename?: "MintMediaPicker"; model: string }
            | null
        } | null> | null
      } | null> | null
      properties?: Array<{
        __typename?: "BasicProperty"
        editorAlias?: string | null
        propertyName?: string | null
        propertyValue?:
          | { __typename?: "BasicBlockGridModel"; model: string }
          | { __typename?: "BasicBlockListModel"; model: string }
          | { __typename?: "BasicContentPicker"; model: string }
          | { __typename?: "BasicDateTimePicker"; model: string }
          | { __typename?: "BasicLabel"; model: string }
          | { __typename?: "BasicMediaPicker"; model: string }
          | { __typename?: "BasicMemberPicker"; model: string }
          | { __typename?: "BasicMultiUrlPicker"; model: string }
          | { __typename?: "BasicNestedContent"; model: string }
          | {
              __typename?: "BasicPropertyValue"
              model: string
              value?: any | null
            }
          | { __typename?: "BasicRichText"; model: string }
          | { __typename?: "BasicUnsupportedPropertyValue"; model: string }
          | { __typename?: "MintMediaPicker"; model: string }
          | null
      } | null> | null
    } | null> | null
    properties?: Array<{
      __typename?: "BasicProperty"
      editorAlias?: string | null
      propertyName?: string | null
      propertyValue?:
        | { __typename?: "BasicBlockGridModel"; model: string }
        | { __typename?: "BasicBlockListModel"; model: string }
        | { __typename?: "BasicContentPicker"; model: string }
        | { __typename?: "BasicDateTimePicker"; model: string }
        | { __typename?: "BasicLabel"; model: string }
        | { __typename?: "BasicMediaPicker"; model: string }
        | { __typename?: "BasicMemberPicker"; model: string }
        | { __typename?: "BasicMultiUrlPicker"; model: string }
        | { __typename?: "BasicNestedContent"; model: string }
        | {
            __typename?: "BasicPropertyValue"
            model: string
            value?: any | null
          }
        | { __typename?: "BasicRichText"; model: string }
        | { __typename?: "BasicUnsupportedPropertyValue"; model: string }
        | { __typename?: "MintMediaPicker"; model: string }
        | null
    } | null> | null
  } | null> | null
  properties?: Array<{
    __typename?: "BasicProperty"
    editorAlias?: string | null
    propertyName?: string | null
    propertyValue?:
      | { __typename?: "BasicBlockGridModel"; model: string }
      | { __typename?: "BasicBlockListModel"; model: string }
      | { __typename?: "BasicContentPicker"; model: string }
      | { __typename?: "BasicDateTimePicker"; model: string }
      | { __typename?: "BasicLabel"; model: string }
      | { __typename?: "BasicMediaPicker"; model: string }
      | { __typename?: "BasicMemberPicker"; model: string }
      | { __typename?: "BasicMultiUrlPicker"; model: string }
      | { __typename?: "BasicNestedContent"; model: string }
      | { __typename?: "BasicPropertyValue"; model: string; value?: any | null }
      | { __typename?: "BasicRichText"; model: string }
      | { __typename?: "BasicUnsupportedPropertyValue"; model: string }
      | { __typename?: "MintMediaPicker"; model: string }
      | null
  } | null> | null
}

export type BasicContentFragment = {
  __typename?: "BasicContent"
  id?: number | null
  name?: string | null
  key?: any | null
  path?: string | null
  level?: number | null
  url?: string | null
  urlSegment?: string | null
  absoluteUrl?: string | null
  properties?: Array<{
    __typename?: "BasicProperty"
    editorAlias?: string | null
    propertyName?: string | null
    propertyValue?:
      | { __typename?: "BasicBlockGridModel"; model: string }
      | { __typename?: "BasicBlockListModel"; model: string }
      | { __typename?: "BasicContentPicker"; model: string }
      | { __typename?: "BasicDateTimePicker"; model: string }
      | { __typename?: "BasicLabel"; model: string }
      | { __typename?: "BasicMediaPicker"; model: string }
      | { __typename?: "BasicMemberPicker"; model: string }
      | { __typename?: "BasicMultiUrlPicker"; model: string }
      | { __typename?: "BasicNestedContent"; model: string }
      | { __typename?: "BasicPropertyValue"; model: string; value?: any | null }
      | { __typename?: "BasicRichText"; model: string }
      | { __typename?: "BasicUnsupportedPropertyValue"; model: string }
      | { __typename?: "MintMediaPicker"; model: string }
      | null
  } | null> | null
}
